import type { ModelConfig } from './generated_model_types';

export const modelConfigs: ModelConfig[] = [
  {
    id: "100200_yl",
    title: "野狼 角色立绘",
    assetKind: "character",
    categoryLabel: "角色",
    modelDir: "100200_yl",
    sourceModelDir: "100200_yl",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "localassets_win32",
    styleId: "",
    styleName: "野狼",
    stage: "角色立绘",
    hitAreaNames: ["HitAreaBody", "HitAreaHead", "HitAreaHandR", "HitAreaHandL", "HitAreaMoren"],
    followConfigs: [{"id": 1017, "prefab": "100200_yl", "activeName": "", "expressionName": "", "damping": 0.0, "parameters": [{"parameterId": "ParamAngleX", "axis": "X", "factor": 40.0, "sourceToken": "ParamAngleX#40*X"}, {"parameterId": "ParamAngleY", "axis": "Y", "factor": 30.0, "sourceToken": "ParamAngleY#30*Y"}, {"parameterId": "ParamEyeBallX", "axis": "X", "factor": 50.0, "sourceToken": "ParamEyeBallX#50*X"}, {"parameterId": "ParamEyeBallY", "axis": "Y", "factor": 50.0, "sourceToken": "ParamEyeBallY#50*Y"}, {"parameterId": "ParamBodyAngleX", "axis": "X", "factor": 50.0, "sourceToken": "ParamBodyAngleX#50*X"}, {"parameterId": "ParamBodyAngleY", "axis": "Y", "factor": 50.0, "sourceToken": "ParamBodyAngleY#50*Y"}]}],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 3.0 }
        ]
      },
      {
        label: "TapBody",
        actions: [
          { group: "TapBody", index: 0, actionId: "diantou", label: "diantou", duration: 3.0 },
          { group: "TapBody", index: 1, actionId: "houyang", label: "houyang", duration: 4.0 },
          { group: "TapBody", index: 2, actionId: "qianqing", label: "qianqing", duration: 4.333 },
          { group: "TapBody", index: 3, actionId: "qianqing_1", label: "qianqing_1", duration: 4.3 },
          { group: "TapBody", index: 4, actionId: "waitou", label: "waitou", duration: 3.667 },
          { group: "TapBody", index: 5, actionId: "waitou_1", label: "waitou_1", duration: 4.433 },
          { group: "TapBody", index: 6, actionId: "walk", label: "walk", duration: 2.0 },
          { group: "TapBody", index: 7, actionId: "woquan", label: "woquan", duration: 4.333 },
          { group: "TapBody", index: 8, actionId: "yaotou", label: "yaotou", duration: 3.0 }
        ]
      }
    ],
    clickShowActions: [
      {
        showId: 600101010,
        audioId: 60010004,
        audioName: "vo_6001_daiji_01",
        desc: "点击-通用1",
        group: "TapBody",
        index: 5,
        actionId: "waitou_1",
        label: "waitou_1",
        duration: 4.433,
        voices: {"cn": {"subtitle": "吵着要保护你的人是我，可是你不在，我连打架都不安心。也许，是你在保护我……", "sound": "sounds/vo_6001_daiji_01.wav"}, "en": {"subtitle": "吵着要保护你的人是我，可是你不在，我连打架都不安心。也许，是你在保护我……", "sound": "sounds/en_vo_6001_daiji_01.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 600101011,
        audioId: 60010005,
        audioName: "vo_6001_daiji_02",
        desc: "点击-通用2",
        group: "TapBody",
        index: 8,
        actionId: "yaotou",
        label: "yaotou",
        duration: 3.0,
        voices: {"cn": {"subtitle": "有人说我像BOSS的狗？哼，我乐意，狗可比有些人更懂得忠诚。", "sound": "sounds/vo_6001_daiji_02.wav"}, "en": {"subtitle": "有人说我像BOSS的狗？哼，我乐意，狗可比有些人更懂得忠诚。", "sound": "sounds/en_vo_6001_daiji_02.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 600101012,
        audioId: 60010010,
        audioName: "vo_6001_xianliao_01",
        desc: "点击-闲聊1",
        group: "Idle",
        index: 0,
        actionId: "idle",
        label: "默认",
        duration: 3.0,
        voices: {"cn": {"subtitle": "要饼干吗？随便吃，我包里还有一打——我讨厌饿肚子的滋味。", "sound": "sounds/vo_6001_xianliao_01.wav"}, "en": {"subtitle": "要饼干吗？随便吃，我包里还有一打——我讨厌饿肚子的滋味。", "sound": "sounds/en_vo_6001_xianliao_01.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 600101013,
        audioId: 60010011,
        audioName: "vo_6001_xianliao_02",
        desc: "点击-闲聊2",
        group: "Idle",
        index: 0,
        actionId: "idle",
        label: "默认",
        duration: 3.0,
        voices: {"cn": {"subtitle": "这堆破纸又是什么，挑刺的投诉信、要我命的悬赏令……嘁，都一样，我解决提出问题的人就行了。", "sound": "sounds/vo_6001_xianliao_02.wav"}, "en": {"subtitle": "这堆破纸又是什么，挑刺的投诉信、要我命的悬赏令……嘁，都一样，我解决提出问题的人就行了。", "sound": "sounds/en_vo_6001_xianliao_02.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 600101014,
        audioId: 60010012,
        audioName: "vo_6001_xianliao_03",
        desc: "点击-闲聊3",
        group: "TapBody",
        index: 8,
        actionId: "yaotou",
        label: "yaotou",
        duration: 3.0,
        voices: {"cn": {"subtitle": "没必要记挂我的左胳膊，它有时候可比肉体好用多了。你要不要见识一下？", "sound": "sounds/vo_6001_xianliao_03.wav"}, "en": {"subtitle": "没必要记挂我的左胳膊，它有时候可比肉体好用多了。你要不要见识一下？", "sound": "sounds/en_vo_6001_xianliao_03.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 600101015,
        audioId: 60010014,
        audioName: "vo_6001_zanyang",
        desc: "点击-赞扬1",
        group: "TapBody",
        index: 7,
        actionId: "woquan",
        label: "woquan",
        duration: 4.333,
        voices: {"cn": {"subtitle": "你一个眼神过来，我就能变成世上最强大的猛兽，没什么能挡住我。", "sound": "sounds/vo_6001_zanyang.wav"}, "en": {"subtitle": "你一个眼神过来，我就能变成世上最强大的猛兽，没什么能挡住我。", "sound": "sounds/en_vo_6001_zanyang.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 600101016,
        audioId: 60010006,
        audioName: "vo_6001_dianchu_tou",
        desc: "点击-头",
        group: "TapBody",
        index: 3,
        actionId: "qianqing_1",
        label: "qianqing_1",
        duration: 4.3,
        voices: {"cn": {"subtitle": "我的脑子搞不清那堆计谋，但我清楚，谁该死，谁该留。", "sound": "sounds/vo_6001_dianchu_tou.wav"}, "en": {"subtitle": "我的脑子搞不清那堆计谋，但我清楚，谁该死，谁该留。", "sound": "sounds/en_vo_6001_dianchu_tou.wav"}},
        hitAreaParam: "HitAreaHead",
        hitAreas: ["HitAreaHead"],
        sourceType2: 401,
        sourceWeight: 20,
        weight: 20
      },
      {
        showId: 600101017,
        audioId: 60010007,
        audioName: "vo_6001_dianchu_shou",
        desc: "点击-手",
        group: "TapBody",
        index: 7,
        actionId: "woquan",
        label: "woquan",
        duration: 4.333,
        voices: {"cn": {"subtitle": "我学不会什么优雅的握手礼，但我能用拳头让人永远闭嘴。", "sound": "sounds/vo_6001_dianchu_shou.wav"}, "en": {"subtitle": "我学不会什么优雅的握手礼，但我能用拳头让人永远闭嘴。", "sound": "sounds/en_vo_6001_dianchu_shou.wav"}},
        hitAreaParam: "HitAreaHandL#HitAreaHandR",
        hitAreas: ["HitAreaHandL", "HitAreaHandR"],
        sourceType2: 401,
        sourceWeight: 20,
        weight: 20
      },
      {
        showId: 600101018,
        audioId: 60010008,
        audioName: "vo_6001_dianchu_shen",
        desc: "点击-胸",
        group: "TapBody",
        index: 5,
        actionId: "waitou_1",
        label: "waitou_1",
        duration: 4.433,
        voices: {"cn": {"subtitle": "都说心脏最脆弱，可只要有你一句话，我连心都愿意掏出来。", "sound": "sounds/vo_6001_dianchu_shen.wav"}, "en": {"subtitle": "都说心脏最脆弱，可只要有你一句话，我连心都愿意掏出来。", "sound": "sounds/en_vo_6001_dianchu_shen.wav"}},
        hitAreaParam: "HitAreaBody",
        hitAreas: ["HitAreaBody"],
        sourceType2: 401,
        sourceWeight: 20,
        weight: 20
      }
    ]
  },
  {
    id: "100300_lw",
    title: "礼物 角色立绘",
    assetKind: "character",
    categoryLabel: "角色",
    modelDir: "100300_lw",
    sourceModelDir: "100300_lw",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "localassets_win32",
    styleId: "",
    styleName: "礼物",
    stage: "角色立绘",
    hitAreaNames: ["HitAreaMoren", "HitAreaHead", "HitAreaHandL2", "HitAreaHandL", "HitAreaHandR", "HitAreaBody"],
    followConfigs: [{"id": 1015, "prefab": "100300_lw", "activeName": "", "expressionName": "", "damping": 0.0, "parameters": [{"parameterId": "ParamEyeBallX", "axis": "X", "factor": 13.0, "sourceToken": "ParamEyeBallX#13*X"}, {"parameterId": "ParamEyeBallY", "axis": "Y", "factor": 30.0, "sourceToken": "ParamEyeBallY#30*Y"}, {"parameterId": "ParamAngleX", "axis": "X", "factor": 23.0, "sourceToken": "ParamAngleX#23*X"}, {"parameterId": "ParamAngleY", "axis": "Y", "factor": 40.0, "sourceToken": "ParamAngleY#40*Y"}, {"parameterId": "ParamBodyAngleX", "axis": "X", "factor": 4.0, "sourceToken": "ParamBodyAngleX#4*X"}, {"parameterId": "ParamBodyAngleY", "axis": "Y", "factor": 20.0, "sourceToken": "ParamBodyAngleY#20*Y"}, {"parameterId": "ParamBodyMae", "axis": "Y", "factor": -20.0, "sourceToken": "ParamBodyMae#-20*Y"}]}],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 5.967 }
        ]
      },
      {
        label: "TapBody",
        actions: [
          { group: "TapBody", index: 0, actionId: "diantou", label: "diantou", duration: 2.571 },
          { group: "TapBody", index: 1, actionId: "houyang", label: "houyang", duration: 2.571 },
          { group: "TapBody", index: 2, actionId: "qianqing", label: "qianqing", duration: 3.4 },
          { group: "TapBody", index: 3, actionId: "songjian", label: "songjian", duration: 2.812 },
          { group: "TapBody", index: 4, actionId: "songjian_1", label: "songjian_1", duration: 2.967 },
          { group: "TapBody", index: 5, actionId: "toufa", label: "toufa", duration: 6.3 },
          { group: "TapBody", index: 6, actionId: "waitou", label: "waitou", duration: 2.781 },
          { group: "TapBody", index: 7, actionId: "waitou_1", label: "waitou_1", duration: 3.833 },
          { group: "TapBody", index: 8, actionId: "walk", label: "walk", duration: 2.543 },
          { group: "TapBody", index: 9, actionId: "yaotou", label: "yaotou", duration: 2.543 }
        ]
      }
    ],
    clickShowActions: [
      {
        showId: 600901010,
        audioId: 60090004,
        audioName: "vo_6009_daiji_01",
        desc: "点击-通用1",
        group: "TapBody",
        index: 5,
        actionId: "toufa",
        label: "toufa",
        duration: 6.3,
        voices: {"cn": {"subtitle": "我又上头条了？呵，那些无名无趣的家伙拼了命的吸引目光，可人们宁愿看我吃路边摊的偷拍照片。", "sound": "sounds/vo_6009_daiji_01.wav"}, "en": {"subtitle": "我又上头条了？呵，那些无名无趣的家伙拼了命的吸引目光，可人们宁愿看我吃路边摊的偷拍照片。", "sound": "sounds/en_vo_6009_daiji_01.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 600901011,
        audioId: 60090005,
        audioName: "vo_6009_daiji_02",
        desc: "点击-通用2",
        group: "TapBody",
        index: 4,
        actionId: "songjian_1",
        label: "songjian_1",
        duration: 2.967,
        voices: {"cn": {"subtitle": "昨天的爆破戏炸早了一秒钟，我差点就成了真正的尸体。谁也不知道，意外和杀青哪个会先来。", "sound": "sounds/vo_6009_daiji_02.wav"}, "en": {"subtitle": "昨天的爆破戏炸早了一秒钟，我差点就成了真正的尸体。谁也不知道，意外和杀青哪个会先来。", "sound": "sounds/en_vo_6009_daiji_02.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 600901012,
        audioId: 60090010,
        audioName: "vo_6009_xianliao_01",
        desc: "点击-闲聊1",
        group: "TapBody",
        index: 5,
        actionId: "toufa",
        label: "toufa",
        duration: 6.3,
        voices: {"cn": {"subtitle": "从前有个一直在骚扰和跟拍我的狗仔，后来他因为一场意外失去了双臂，再也无法拿起相机了。我也不是很了解具体原因呢，希望他的新生活一切顺利吧。", "sound": "sounds/vo_6009_xianliao_01.wav"}, "en": {"subtitle": "从前有个一直在骚扰和跟拍我的狗仔，后来他因为一场意外失去了双臂，再也无法拿起相机了。我也不是很了解具体原因呢，希望他的新生活一切顺利吧。", "sound": "sounds/en_vo_6009_xianliao_01.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 600901013,
        audioId: 60090011,
        audioName: "vo_6009_xianliao_02",
        desc: "点击-闲聊2",
        group: "TapBody",
        index: 7,
        actionId: "waitou_1",
        label: "waitou_1",
        duration: 3.833,
        voices: {"cn": {"subtitle": "记者问我打戏为什么演得那么逼真，呵……我只是把送人上路的手感搬上了镜头。", "sound": "sounds/vo_6009_xianliao_02.wav"}, "en": {"subtitle": "记者问我打戏为什么演得那么逼真，呵……我只是把送人上路的手感搬上了镜头。", "sound": "sounds/en_vo_6009_xianliao_02.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 600901014,
        audioId: 60090012,
        audioName: "vo_6009_xianliao_03",
        desc: "点击-闲聊3",
        group: "TapBody",
        index: 0,
        actionId: "diantou",
        label: "diantou",
        duration: 2.571,
        voices: {"cn": {"subtitle": "有人说我做反派时的好演技是“相由心生”，嗯，不错的评价。", "sound": "sounds/vo_6009_xianliao_03.wav"}, "en": {"subtitle": "有人说我做反派时的好演技是“相由心生”，嗯，不错的评价。", "sound": "sounds/en_vo_6009_xianliao_03.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 600901015,
        audioId: 60090014,
        audioName: "vo_6009_zanyang",
        desc: "点击-赞扬1",
        group: "TapBody",
        index: 7,
        actionId: "waitou_1",
        label: "waitou_1",
        duration: 3.833,
        voices: {"cn": {"subtitle": "你是一个生活在无休止的血腥戏剧里的人，却又如此坦然与自信。或许，这会给我很多启示。", "sound": "sounds/vo_6009_zanyang.wav"}, "en": {"subtitle": "你是一个生活在无休止的血腥戏剧里的人，却又如此坦然与自信。或许，这会给我很多启示。", "sound": "sounds/en_vo_6009_zanyang.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 600901016,
        audioId: 60090006,
        audioName: "vo_6009_dianchu_tou",
        desc: "点击-头",
        group: "TapBody",
        index: 9,
        actionId: "yaotou",
        label: "yaotou",
        duration: 2.543,
        voices: {"cn": {"subtitle": "“只是靠美丽的脸获得一切”？哈……那些人这么忮忌我的成名之路，为什么不自己试试看呢？", "sound": "sounds/vo_6009_dianchu_tou.wav"}, "en": {"subtitle": "“只是靠美丽的脸获得一切”？哈……那些人这么忮忌我的成名之路，为什么不自己试试看呢？", "sound": "sounds/en_vo_6009_dianchu_tou.wav"}},
        hitAreaParam: "HitAreaHead",
        hitAreas: ["HitAreaHead"],
        sourceType2: 401,
        sourceWeight: 20,
        weight: 20
      },
      {
        showId: 600901017,
        audioId: 60090007,
        audioName: "vo_6009_dianchu_shou",
        desc: "点击-手",
        group: "TapBody",
        index: 0,
        actionId: "diantou",
        label: "diantou",
        duration: 2.571,
        voices: {"cn": {"subtitle": "从第一次演凶杀片开始，我就发现了自己使用冷兵器的天赋。那几乎是一种本能……我知道刀要怎么最漂亮地扎进别人的喉管里。", "sound": "sounds/vo_6009_dianchu_shou.wav"}, "en": {"subtitle": "从第一次演凶杀片开始，我就发现了自己使用冷兵器的天赋。那几乎是一种本能……我知道刀要怎么最漂亮地扎进别人的喉管里。", "sound": "sounds/en_vo_6009_dianchu_shou.wav"}},
        hitAreaParam: "HitAreaHandL1#HitAreaHandL2#HitAreaHandR",
        hitAreas: ["HitAreaHandL1", "HitAreaHandL2", "HitAreaHandR"],
        sourceType2: 401,
        sourceWeight: 20,
        weight: 20
      },
      {
        showId: 600901018,
        audioId: 60090008,
        audioName: "vo_6009_dianchu_shen",
        desc: "点击-胸",
        group: "TapBody",
        index: 4,
        actionId: "songjian_1",
        label: "songjian_1",
        duration: 2.967,
        voices: {"cn": {"subtitle": "很多人想要得到我的心，另一部分人则想亲手把它剜出来。可是你瞧，它还是保留在我的胸腔中，砰砰跳动着。", "sound": "sounds/vo_6009_dianchu_shen.wav"}, "en": {"subtitle": "很多人想要得到我的心，另一部分人则想亲手把它剜出来。可是你瞧，它还是保留在我的胸腔中，砰砰跳动着。", "sound": "sounds/en_vo_6009_dianchu_shen.wav"}},
        hitAreaParam: "HitAreaBody",
        hitAreas: ["HitAreaBody"],
        sourceType2: 401,
        sourceWeight: 20,
        weight: 20
      }
    ]
  },
  {
    id: "100400_yl",
    title: "幽灵 角色立绘",
    assetKind: "character",
    categoryLabel: "角色",
    modelDir: "100400_yl",
    sourceModelDir: "100400_yl",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "localassets_win32",
    styleId: "",
    styleName: "幽灵",
    stage: "角色立绘",
    hitAreaNames: ["HitAreaHead", "HitAreaMoren", "HitAreaBody", "HitAreaHandR", "HitAreaHandL"],
    followConfigs: [{"id": 1025, "prefab": "100400_yl", "activeName": "", "expressionName": "", "damping": 0.0, "parameters": [{"parameterId": "ParamAngleX", "axis": "X", "factor": 50.0, "sourceToken": "ParamAngleX#50*X"}, {"parameterId": "ParamAngleY", "axis": "Y", "factor": 50.0, "sourceToken": "ParamAngleY#50*Y"}, {"parameterId": "ParamEyeBallX", "axis": "X", "factor": 80.0, "sourceToken": "ParamEyeBallX#80*X"}, {"parameterId": "ParamEyeBallY", "axis": "Y", "factor": 80.0, "sourceToken": "ParamEyeBallY#80*Y"}, {"parameterId": "ParamBodyAngleX", "axis": "X", "factor": 30.0, "sourceToken": "ParamBodyAngleX#30*X"}, {"parameterId": "ParamBodyAngleY", "axis": "Y", "factor": 50.0, "sourceToken": "ParamBodyAngleY#50*Y"}]}],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 6.0 }
        ]
      },
      {
        label: "TapBody",
        actions: [
          { group: "TapBody", index: 0, actionId: "diantou", label: "diantou", duration: 3.0 },
          { group: "TapBody", index: 1, actionId: "ditou", label: "ditou", duration: 4.0 },
          { group: "TapBody", index: 2, actionId: "ditou_1", label: "ditou_1", duration: 4.0 },
          { group: "TapBody", index: 3, actionId: "fuxiong", label: "fuxiong", duration: 6.0 },
          { group: "TapBody", index: 4, actionId: "taishou", label: "taishou", duration: 4.0 },
          { group: "TapBody", index: 5, actionId: "waitou", label: "waitou", duration: 4.0 },
          { group: "TapBody", index: 6, actionId: "walk", label: "walk", duration: 2.0 },
          { group: "TapBody", index: 7, actionId: "yaotou", label: "yaotou", duration: 3.0 },
          { group: "TapBody", index: 8, actionId: "yaotou_1", label: "yaotou_1", duration: 3.0 }
        ]
      }
    ],
    clickShowActions: [
      {
        showId: 600701010,
        audioId: 60070004,
        audioName: "vo_6007_daiji_01",
        desc: "点击-通用1",
        group: "TapBody",
        index: 3,
        actionId: "fuxiong",
        label: "fuxiong",
        duration: 6.0,
        voices: {"cn": {"subtitle": "我会恰到好处地示弱，您负责心软；这正是我们的默契，不是吗？", "sound": "sounds/vo_6007_daiji_01.wav"}, "en": {"subtitle": "我会恰到好处地示弱，您负责心软；这正是我们的默契，不是吗？", "sound": "sounds/en_vo_6007_daiji_01.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 600701011,
        audioId: 60070005,
        audioName: "vo_6007_daiji_02",
        desc: "点击-通用2",
        group: "Idle",
        index: 0,
        actionId: "idle",
        label: "默认",
        duration: 6.0,
        voices: {"cn": {"subtitle": "即便不主动打听，秘密也会从人们口中自动涌现。所谓“八卦”真是件好事。", "sound": "sounds/vo_6007_daiji_02.wav"}, "en": {"subtitle": "即便不主动打听，秘密也会从人们口中自动涌现。所谓“八卦”真是件好事。", "sound": "sounds/en_vo_6007_daiji_02.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 600701012,
        audioId: 60070010,
        audioName: "vo_6007_xianliao_01",
        desc: "点击-闲聊1",
        group: "TapBody",
        index: 5,
        actionId: "waitou",
        label: "waitou",
        duration: 4.0,
        voices: {"cn": {"subtitle": "您觉得我是个温柔的人？原来您也有判断失误的时候。", "sound": "sounds/vo_6007_xianliao_01.wav"}, "en": {"subtitle": "您觉得我是个温柔的人？原来您也有判断失误的时候。", "sound": "sounds/en_vo_6007_xianliao_01.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 600701013,
        audioId: 60070011,
        audioName: "vo_6007_xianliao_02",
        desc: "点击-闲聊2",
        group: "TapBody",
        index: 2,
        actionId: "ditou_1",
        label: "ditou_1",
        duration: 4.0,
        voices: {"cn": {"subtitle": "您好奇我长大的地方？一座孤儿院，我在那里学会了很多。比如用厨师的把柄换面包，给幽会的仆人望风……诸如此类。", "sound": "sounds/vo_6007_xianliao_02.wav"}, "en": {"subtitle": "您好奇我长大的地方？一座孤儿院，我在那里学会了很多。比如用厨师的把柄换面包，给幽会的仆人望风……诸如此类。", "sound": "sounds/en_vo_6007_xianliao_02.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 600701014,
        audioId: 60070012,
        audioName: "vo_6007_xianliao_03",
        desc: "点击-闲聊3",
        group: "TapBody",
        index: 8,
        actionId: "yaotou_1",
        label: "yaotou_1",
        duration: 3.0,
        voices: {"cn": {"subtitle": "是结社那边传来的情报——似乎并非您想要的那条，不过，也许可以作为您喝茶时的消遣。", "sound": "sounds/vo_6007_xianliao_03.wav"}, "en": {"subtitle": "是结社那边传来的情报——似乎并非您想要的那条，不过，也许可以作为您喝茶时的消遣。", "sound": "sounds/en_vo_6007_xianliao_03.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 600701015,
        audioId: 60070014,
        audioName: "vo_6007_zanyang",
        desc: "点击-赞扬1",
        group: "TapBody",
        index: 2,
        actionId: "ditou_1",
        label: "ditou_1",
        duration: 4.0,
        voices: {"cn": {"subtitle": "在您身边久了，会让我忘记自己其实是擅长撒谎的骗子。", "sound": "sounds/vo_6007_zanyang.wav"}, "en": {"subtitle": "在您身边久了，会让我忘记自己其实是擅长撒谎的骗子。", "sound": "sounds/en_vo_6007_zanyang.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 600701016,
        audioId: 60070006,
        audioName: "vo_6007_dianchu_tou",
        desc: "点击-头",
        group: "TapBody",
        index: 2,
        actionId: "ditou_1",
        label: "ditou_1",
        duration: 4.0,
        voices: {"cn": {"subtitle": "如果哪天我不再抬头看您……或许是因为，我害怕自己的目光会泄露心里的秘密。", "sound": "sounds/vo_6007_dianchu_tou.wav"}, "en": {"subtitle": "如果哪天我不再抬头看您……或许是因为，我害怕自己的目光会泄露心里的秘密。", "sound": "sounds/en_vo_6007_dianchu_tou.wav"}},
        hitAreaParam: "HitAreaHead",
        hitAreas: ["HitAreaHead"],
        sourceType2: 401,
        sourceWeight: 20,
        weight: 20
      },
      {
        showId: 600701017,
        audioId: 60070007,
        audioName: "vo_6007_dianchu_shou",
        desc: "点击-手",
        group: "TapBody",
        index: 4,
        actionId: "taishou",
        label: "taishou",
        duration: 4.0,
        voices: {"cn": {"subtitle": "您握着我的手，是怕我会消失，还是怕我会把秘密带走？", "sound": "sounds/vo_6007_dianchu_shou.wav"}, "en": {"subtitle": "您握着我的手，是怕我会消失，还是怕我会把秘密带走？", "sound": "sounds/en_vo_6007_dianchu_shou.wav"}},
        hitAreaParam: "HitAreaHandL#HitAreaHandR",
        hitAreas: ["HitAreaHandL", "HitAreaHandR"],
        sourceType2: 401,
        sourceWeight: 20,
        weight: 20
      },
      {
        showId: 600701018,
        audioId: 60070008,
        audioName: "vo_6007_dianchu_shen",
        desc: "点击-胸",
        group: "TapBody",
        index: 3,
        actionId: "fuxiong",
        label: "fuxiong",
        duration: 6.0,
        voices: {"cn": {"subtitle": "心跳很平稳？这是基本功，即使下一秒要扣动扳机，也不能让它乱了节奏。", "sound": "sounds/vo_6007_dianchu_shen.wav"}, "en": {"subtitle": "心跳很平稳？这是基本功，即使下一秒要扣动扳机，也不能让它乱了节奏。", "sound": "sounds/en_vo_6007_dianchu_shen.wav"}},
        hitAreaParam: "HitAreaBody",
        hitAreas: ["HitAreaBody"],
        sourceType2: 401,
        sourceWeight: 20,
        weight: 20
      }
    ]
  },
  {
    id: "100400_yl_cg",
    title: "复仇童谣 二段",
    assetKind: "style",
    categoryLabel: "风格",
    modelDir: "100400_yl_cg",
    sourceModelDir: "100400_yl_cg",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "streamingassets",
    styleId: "13001025",
    styleName: "复仇童谣",
    stage: "二段",
    hitAreaNames: ["HitArea_quanshen", "HitArea_qita", "HitArea_shou2", "HitArea_qugan", "HitArea_lingdai", "HitArea_rujian", "HitArea_tou", "HitArea_shou1", "HitAreaMoren"],
    followConfigs: [{"id": 21004, "prefab": "100400_yl_cg", "activeName": "", "expressionName": "", "damping": 0.0, "parameters": [{"parameterId": "ParamAngleX", "axis": "X", "factor": 50.0, "sourceToken": "ParamAngleX#50*X"}, {"parameterId": "ParamAngleY", "axis": "Y", "factor": 10.0, "sourceToken": "ParamAngleY#10*Y"}, {"parameterId": "ParamEyeBallX", "axis": "X", "factor": 50.0, "sourceToken": "ParamEyeBallX#50*X"}, {"parameterId": "ParamEyeBallY", "axis": "Y", "factor": 10.0, "sourceToken": "ParamEyeBallY#10*Y"}, {"parameterId": "ParamBodyAngleX", "axis": "X", "factor": 40.0, "sourceToken": "ParamBodyAngleX#40*X"}, {"parameterId": "ParamBodyAngleY", "axis": "Y", "factor": 10.0, "sourceToken": "ParamBodyAngleY#10*Y"}]}],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [],
    storyTouchActions: [],
    unlockableMotions: [
      { group: "TapBody", index: 0, actionId: "dongzuo1", label: "亲近1", duration: 10.0 },
      { group: "TapBody", index: 1, actionId: "dongzuo2", label: "亲近2", duration: 10.0 },
      { group: "TapBody", index: 2, actionId: "dongzuo3", label: "亲近3", duration: 11.0 }
    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 10.0 },
          { group: "Idle", index: 1, actionId: "idle1", label: "注视1", duration: 4.733 },
          { group: "Idle", index: 2, actionId: "idle2", label: "注视2", duration: 6.8 }
        ]
      },
      {
        label: "TapBody",
        actions: [
          { group: "TapBody", index: 0, actionId: "dongzuo1", label: "亲近1", duration: 10.0 },
          { group: "TapBody", index: 1, actionId: "dongzuo2", label: "亲近2", duration: 10.0 },
          { group: "TapBody", index: 2, actionId: "dongzuo3", label: "亲近3", duration: 11.0 }
        ]
      },
      {
        label: "入场",
        actions: [
          { group: "Entry", index: 0, actionId: "ruchang", label: "入场", duration: 12.9 }
        ]
      }
    ],
    clickShowActions: [
      {
        showId: 61025055,
        audioId: 10250008,
        audioName: "vo_1025_erduanchahua_03",
        desc: "点击3",
        group: "TapBody",
        index: 0,
        actionId: "dongzuo1",
        label: "亲近1",
        duration: 10.0,
        voices: {"cn": {"subtitle": "您难道就不怕我会错意……", "sound": "sounds/vo_1025_erduanchahua_03.wav"}, "en": {"subtitle": "您难道就不怕我会错意……", "sound": "sounds/en_vo_1025_erduanchahua_03.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 20,
        weight: 20
      },
      {
        showId: 61025056,
        audioId: 10250009,
        audioName: "vo_1025_erduanchahua_04",
        desc: "点击4",
        group: "TapBody",
        index: 1,
        actionId: "dongzuo2",
        label: "亲近2",
        duration: 10.0,
        voices: {"cn": {"subtitle": "领饰……不是拿来做这种事的。", "sound": "sounds/vo_1025_erduanchahua_04.wav"}, "en": {"subtitle": "领饰……不是拿来做这种事的。", "sound": "sounds/en_vo_1025_erduanchahua_04.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 20,
        weight: 20
      },
      {
        showId: 61025057,
        audioId: 10250010,
        audioName: "vo_1025_erduanchahua_05",
        desc: "点击5",
        group: "TapBody",
        index: 2,
        actionId: "dongzuo3",
        label: "亲近3",
        duration: 11.0,
        voices: {"cn": {"subtitle": "我身上没有您想要的东西……", "sound": "sounds/vo_1025_erduanchahua_05.wav"}, "en": {"subtitle": "我身上没有您想要的东西……", "sound": "sounds/en_vo_1025_erduanchahua_05.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 20,
        weight: 20
      },
      {
        showId: 61025062,
        audioId: 10250006,
        audioName: "vo_1025_erduanchahua_01",
        desc: "点击1",
        group: "Idle",
        index: 1,
        actionId: "idle1",
        label: "注视1",
        duration: 4.733,
        voices: {"cn": {"subtitle": "您……靠得太近了。", "sound": "sounds/vo_1025_erduanchahua_01.wav"}, "en": {"subtitle": "您……靠得太近了。", "sound": "sounds/en_vo_1025_erduanchahua_01.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 10,
        weight: 10
      },
      {
        showId: 61025063,
        audioId: 10250007,
        audioName: "vo_1025_erduanchahua_02",
        desc: "点击2",
        group: "Idle",
        index: 2,
        actionId: "idle2",
        label: "注视2",
        duration: 6.8,
        voices: {"cn": {"subtitle": "您是想在这里休息吗？", "sound": "sounds/vo_1025_erduanchahua_02.wav"}, "en": {"subtitle": "您是想在这里休息吗？", "sound": "sounds/en_vo_1025_erduanchahua_02.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 10,
        weight: 10
      },
      {
        showId: 61025064,
        audioId: 60070004,
        audioName: "vo_6007_daiji_01",
        desc: "点击-通用1",
        group: "Idle",
        index: 2,
        actionId: "idle2",
        label: "注视2",
        duration: 6.8,
        voices: {"cn": {"subtitle": "我会恰到好处地示弱，您负责心软；这正是我们的默契，不是吗？", "sound": "sounds/vo_6007_daiji_01.wav"}, "en": {"subtitle": "我会恰到好处地示弱，您负责心软；这正是我们的默契，不是吗？", "sound": "sounds/en_vo_6007_daiji_01.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 61025065,
        audioId: 60070005,
        audioName: "vo_6007_daiji_02",
        desc: "点击-通用2",
        group: "Idle",
        index: 1,
        actionId: "idle1",
        label: "注视1",
        duration: 4.733,
        voices: {"cn": {"subtitle": "即便不主动打听，秘密也会从人们口中自动涌现。所谓“八卦”真是件好事。", "sound": "sounds/vo_6007_daiji_02.wav"}, "en": {"subtitle": "即便不主动打听，秘密也会从人们口中自动涌现。所谓“八卦”真是件好事。", "sound": "sounds/en_vo_6007_daiji_02.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 61025066,
        audioId: 60070010,
        audioName: "vo_6007_xianliao_01",
        desc: "点击-闲聊1",
        group: "Idle",
        index: 2,
        actionId: "idle2",
        label: "注视2",
        duration: 6.8,
        voices: {"cn": {"subtitle": "您觉得我是个温柔的人？原来您也有判断失误的时候。", "sound": "sounds/vo_6007_xianliao_01.wav"}, "en": {"subtitle": "您觉得我是个温柔的人？原来您也有判断失误的时候。", "sound": "sounds/en_vo_6007_xianliao_01.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 61025067,
        audioId: 60070014,
        audioName: "vo_6007_zanyang",
        desc: "点击-赞扬1",
        group: "Idle",
        index: 2,
        actionId: "idle2",
        label: "注视2",
        duration: 6.8,
        voices: {"cn": {"subtitle": "在您身边久了，会让我忘记自己其实是擅长撒谎的骗子。", "sound": "sounds/vo_6007_zanyang.wav"}, "en": {"subtitle": "在您身边久了，会让我忘记自己其实是擅长撒谎的骗子。", "sound": "sounds/en_vo_6007_zanyang.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      }
    ]
  },
  {
    id: "100500_ss",
    title: "将军 角色立绘",
    assetKind: "character",
    categoryLabel: "角色",
    modelDir: "100500_ss",
    sourceModelDir: "100500_ss",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "localassets_win32",
    styleId: "",
    styleName: "将军",
    stage: "角色立绘",
    hitAreaNames: ["HitAreaMoren", "HitAreaBody", "HitAreaHead", "HitAreaHandL", "HitAreaHandR"],
    followConfigs: [{"id": 1036, "prefab": "100500_ss", "activeName": "", "expressionName": "", "damping": 0.0, "parameters": [{"parameterId": "ParamAngleX", "axis": "X", "factor": 30.0, "sourceToken": "ParamAngleX#30*X"}, {"parameterId": "ParamAngleY", "axis": "Y", "factor": 50.0, "sourceToken": "ParamAngleY#50*Y"}, {"parameterId": "Param", "axis": "X", "factor": 25.0, "sourceToken": "Param#25*X"}, {"parameterId": "Param2", "axis": "Y", "factor": 50.0, "sourceToken": "Param2#50*Y"}, {"parameterId": "ParamBodyAngleX", "axis": "X", "factor": 14.0, "sourceToken": "ParamBodyAngleX#14*X"}, {"parameterId": "ParamBodyAngleY", "axis": "Y", "factor": 20.0, "sourceToken": "ParamBodyAngleY#20*Y"}]}],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 3.0 }
        ]
      },
      {
        label: "TapBody",
        actions: [
          { group: "TapBody", index: 0, actionId: "aoqi", label: "aoqi", duration: 4.0 },
          { group: "TapBody", index: 1, actionId: "aoqi_1", label: "aoqi_1", duration: 4.0 },
          { group: "TapBody", index: 2, actionId: "diantou", label: "diantou", duration: 3.0 },
          { group: "TapBody", index: 3, actionId: "sikao", label: "sikao", duration: 5.0 },
          { group: "TapBody", index: 4, actionId: "sikao_1", label: "sikao_1", duration: 4.967 },
          { group: "TapBody", index: 5, actionId: "waitou", label: "waitou", duration: 3.633 },
          { group: "TapBody", index: 6, actionId: "walk", label: "walk", duration: 1.967 },
          { group: "TapBody", index: 7, actionId: "yaotou", label: "yaotou", duration: 3.3 },
          { group: "TapBody", index: 8, actionId: "zhuanshouwan", label: "zhuanshouwan", duration: 8.233 }
        ]
      }
    ],
    clickShowActions: [
      {
        showId: 600801010,
        audioId: 60080004,
        audioName: "vo_6008_daiji_01",
        desc: "点击-通用1",
        group: "TapBody",
        index: 7,
        actionId: "yaotou",
        label: "yaotou",
        duration: 3.3,
        voices: {"cn": {"subtitle": "这些报告格式又乱了……说了多少次，军团不收涂鸦本。你还笑？也不知道帮我骂一骂他们。", "sound": "sounds/vo_6008_daiji_01.wav"}, "en": {"subtitle": "这些报告格式又乱了……说了多少次，军团不收涂鸦本。你还笑？也不知道帮我骂一骂他们。", "sound": "sounds/en_vo_6008_daiji_01.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 600801011,
        audioId: 60080005,
        audioName: "vo_6008_daiji_02",
        desc: "点击-通用2",
        group: "TapBody",
        index: 7,
        actionId: "yaotou",
        label: "yaotou",
        duration: 3.3,
        voices: {"cn": {"subtitle": "别一声不响地离开，我不怕你出事，你一定能应付。但我怕自己没法第一时间赶过去。", "sound": "sounds/vo_6008_daiji_02.wav"}, "en": {"subtitle": "别一声不响地离开，我不怕你出事，你一定能应付。但我怕自己没法第一时间赶过去。", "sound": "sounds/en_vo_6008_daiji_02.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 600801012,
        audioId: 60080010,
        audioName: "vo_6008_xianliao_01",
        desc: "点击-闲聊1",
        group: "TapBody",
        index: 8,
        actionId: "zhuanshouwan",
        label: "zhuanshouwan",
        duration: 8.233,
        voices: {"cn": {"subtitle": "要求士兵着装整洁不是为了好看。在战场上，一条松脱的皮带，也会变成拖死骑兵的绞索。", "sound": "sounds/vo_6008_xianliao_01.wav"}, "en": {"subtitle": "要求士兵着装整洁不是为了好看。在战场上，一条松脱的皮带，也会变成拖死骑兵的绞索。", "sound": "sounds/en_vo_6008_xianliao_01.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 600801013,
        audioId: 60080011,
        audioName: "vo_6008_xianliao_02",
        desc: "点击-闲聊2",
        group: "TapBody",
        index: 5,
        actionId: "waitou",
        label: "waitou",
        duration: 3.633,
        voices: {"cn": {"subtitle": "这里的气候比我故乡舒适。过多的雨水除外，它会让电极装置生锈。", "sound": "sounds/vo_6008_xianliao_02.wav"}, "en": {"subtitle": "这里的气候比我故乡舒适。过多的雨水除外，它会让电极装置生锈。", "sound": "sounds/en_vo_6008_xianliao_02.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 600801014,
        audioId: 60080012,
        audioName: "vo_6008_xianliao_03",
        desc: "点击-闲聊3",
        group: "TapBody",
        index: 8,
        actionId: "zhuanshouwan",
        label: "zhuanshouwan",
        duration: 8.233,
        voices: {"cn": {"subtitle": "只讲美德会遭人掠夺，而运用头脑和枪炮讲美德，你反而能收获鲜花和金子，甚至赢得一个国家。", "sound": "sounds/vo_6008_xianliao_03.wav"}, "en": {"subtitle": "只讲美德会遭人掠夺，而运用头脑和枪炮讲美德，你反而能收获鲜花和金子，甚至赢得一个国家。", "sound": "sounds/en_vo_6008_xianliao_03.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 600801015,
        audioId: 60080014,
        audioName: "vo_6008_zanyang",
        desc: "点击-赞扬1",
        group: "TapBody",
        index: 2,
        actionId: "diantou",
        label: "diantou",
        duration: 3.0,
        voices: {"cn": {"subtitle": "你的成长，比任何胜利都让我感到欣慰。", "sound": "sounds/vo_6008_zanyang.wav"}, "en": {"subtitle": "你的成长，比任何胜利都让我感到欣慰。", "sound": "sounds/en_vo_6008_zanyang.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 600801016,
        audioId: 60080006,
        audioName: "vo_6008_dianchu_tou",
        desc: "点击-头",
        group: "TapBody",
        index: 4,
        actionId: "sikao_1",
        label: "sikao_1",
        duration: 4.967,
        voices: {"cn": {"subtitle": "棕熊比政客好对付——至少它的杀意写在眼睛里。", "sound": "sounds/vo_6008_dianchu_tou.wav"}, "en": {"subtitle": "棕熊比政客好对付——至少它的杀意写在眼睛里。", "sound": "sounds/en_vo_6008_dianchu_tou.wav"}},
        hitAreaParam: "HitAreaHead",
        hitAreas: ["HitAreaHead"],
        sourceType2: 401,
        sourceWeight: 20,
        weight: 20
      },
      {
        showId: 600801017,
        audioId: 60080007,
        audioName: "vo_6008_dianchu_shou",
        desc: "点击-手",
        group: "TapBody",
        index: 8,
        actionId: "zhuanshouwan",
        label: "zhuanshouwan",
        duration: 8.233,
        voices: {"cn": {"subtitle": "手要稳，心要狠，上了战场，记住这两点能让你活命。", "sound": "sounds/vo_6008_dianchu_shou.wav"}, "en": {"subtitle": "手要稳，心要狠，上了战场，记住这两点能让你活命。", "sound": "sounds/en_vo_6008_dianchu_shou.wav"}},
        hitAreaParam: "HitAreaHandL#HitAreaHandR",
        hitAreas: ["HitAreaHandL", "HitAreaHandR"],
        sourceType2: 401,
        sourceWeight: 20,
        weight: 20
      },
      {
        showId: 600801018,
        audioId: 60080008,
        audioName: "vo_6008_dianchu_shen",
        desc: "点击-胸",
        group: "TapBody",
        index: 7,
        actionId: "yaotou",
        label: "yaotou",
        duration: 3.3,
        voices: {"cn": {"subtitle": "不用担心我，哪个军团士兵的制服下没有一身伤疤？", "sound": "sounds/vo_6008_dianchu_shen.wav"}, "en": {"subtitle": "不用担心我，哪个军团士兵的制服下没有一身伤疤？", "sound": "sounds/en_vo_6008_dianchu_shen.wav"}},
        hitAreaParam: "HitAreaBody",
        hitAreas: ["HitAreaBody"],
        sourceType2: 401,
        sourceWeight: 20,
        weight: 20
      }
    ]
  },
  {
    id: "100600_hst",
    title: "红手套 角色立绘",
    assetKind: "character",
    categoryLabel: "角色",
    modelDir: "100600_hst",
    sourceModelDir: "100600_hst",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "localassets_win32",
    styleId: "",
    styleName: "红手套",
    stage: "角色立绘",
    hitAreaNames: ["HitAreaHead", "HitAreaHandL", "HitAreaHandR", "HitAreaBody", "HitAreaMoren"],
    followConfigs: [{"id": 1020, "prefab": "100600_hst", "activeName": "", "expressionName": "", "damping": 0.0, "parameters": [{"parameterId": "ParamAngleX", "axis": "X", "factor": 20.0, "sourceToken": "ParamAngleX#20*X"}, {"parameterId": "ParamAngleY", "axis": "Y", "factor": 20.0, "sourceToken": "ParamAngleY#20*Y"}, {"parameterId": "ParamEyeBallX", "axis": "X", "factor": 60.0, "sourceToken": "ParamEyeBallX#60*X"}, {"parameterId": "ParamEyeBallY", "axis": "Y", "factor": 50.0, "sourceToken": "ParamEyeBallY#50*Y"}, {"parameterId": "ParamBodyAngleX", "axis": "X", "factor": 20.0, "sourceToken": "ParamBodyAngleX#20*X"}, {"parameterId": "ParamBodyMae", "axis": "Y", "factor": -10.0, "sourceToken": "ParamBodyMae#-10*Y"}]}],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 3.0 }
        ]
      },
      {
        label: "TapBody",
        actions: [
          { group: "TapBody", index: 0, actionId: "daxiao", label: "daxiao", duration: 3.333 },
          { group: "TapBody", index: 1, actionId: "daxiaoyanchang", label: "daxiaoyanchang", duration: 4.0 },
          { group: "TapBody", index: 2, actionId: "diantou", label: "diantou", duration: 3.0 },
          { group: "TapBody", index: 3, actionId: "taiyanjing", label: "taiyanjing", duration: 3.333 },
          { group: "TapBody", index: 4, actionId: "taiyanjing_1", label: "taiyanjing_1", duration: 3.5 },
          { group: "TapBody", index: 5, actionId: "tanshou", label: "tanshou", duration: 6.5 },
          { group: "TapBody", index: 6, actionId: "walk", label: "walk", duration: 2.0 }
        ]
      }
    ],
    clickShowActions: [
      {
        showId: 600601010,
        audioId: 60060004,
        audioName: "vo_6006_daiji_01",
        desc: "点击-通用1",
        group: "Idle",
        index: 0,
        actionId: "idle",
        label: "默认",
        duration: 3.0,
        voices: {"cn": {"subtitle": "太可惜了，不能把法庭听证席改成钢管舞台，少了一批视野绝佳的钢管座，噗哈哈哈！", "sound": "sounds/vo_6006_daiji_01.wav"}, "en": {"subtitle": "太可惜了，不能把法庭听证席改成钢管舞台，少了一批视野绝佳的钢管座，噗哈哈哈！", "sound": "sounds/en_vo_6006_daiji_01.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 600601011,
        audioId: 60060005,
        audioName: "vo_6006_daiji_02",
        desc: "点击-通用2",
        group: "TapBody",
        index: 5,
        actionId: "tanshou",
        label: "tanshou",
        duration: 6.5,
        voices: {"cn": {"subtitle": "今天的我没有案件、没有敌人、也没有乐子……该死，我是不是生病了？", "sound": "sounds/vo_6006_daiji_02.wav"}, "en": {"subtitle": "今天的我没有案件、没有敌人、也没有乐子……该死，我是不是生病了？", "sound": "sounds/en_vo_6006_daiji_02.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 600601012,
        audioId: 60060010,
        audioName: "vo_6006_xianliao_01",
        desc: "点击-闲聊1",
        group: "TapBody",
        index: 5,
        actionId: "tanshou",
        label: "tanshou",
        duration: 6.5,
        voices: {"cn": {"subtitle": "啊没错，我现在应该在法庭上，但我已经听了一周的陈词滥调。哪怕身处地狱，我也要捍卫自己休息的合法权利——", "sound": "sounds/vo_6006_xianliao_01.wav"}, "en": {"subtitle": "啊没错，我现在应该在法庭上，但我已经听了一周的陈词滥调。哪怕身处地狱，我也要捍卫自己休息的合法权利——", "sound": "sounds/en_vo_6006_xianliao_01.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 600601013,
        audioId: 60060011,
        audioName: "vo_6006_xianliao_02",
        desc: "点击-闲聊2",
        group: "Idle",
        index: 0,
        actionId: "idle",
        label: "默认",
        duration: 3.0,
        voices: {"cn": {"subtitle": "我听了个笑话——“正义不会缺席”！噗……正义可不是什么常驻法庭的吉祥物，你得主动去争取，最好再带上一把枪或斧头。", "sound": "sounds/vo_6006_xianliao_02.wav"}, "en": {"subtitle": "我听了个笑话——“正义不会缺席”！噗……正义可不是什么常驻法庭的吉祥物，你得主动去争取，最好再带上一把枪或斧头。", "sound": "sounds/en_vo_6006_xianliao_02.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 600601014,
        audioId: 60060012,
        audioName: "vo_6006_xianliao_03",
        desc: "点击-闲聊3",
        group: "TapBody",
        index: 4,
        actionId: "taiyanjing_1",
        label: "taiyanjing_1",
        duration: 3.5,
        voices: {"cn": {"subtitle": "“暗巷惊天凶案，受害者化整为零……”嗯哼，很吸睛的小报标题。为什么看我？我只是一个拎着公文包的普通律师，凑巧包里装了把斧头。", "sound": "sounds/vo_6006_xianliao_03.wav"}, "en": {"subtitle": "“暗巷惊天凶案，受害者化整为零……”嗯哼，很吸睛的小报标题。为什么看我？我只是一个拎着公文包的普通律师，凑巧包里装了把斧头。", "sound": "sounds/en_vo_6006_xianliao_03.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 600601015,
        audioId: 60060014,
        audioName: "vo_6006_zanyang",
        desc: "点击-赞扬1",
        group: "TapBody",
        index: 4,
        actionId: "taiyanjing_1",
        label: "taiyanjing_1",
        duration: 3.5,
        voices: {"cn": {"subtitle": "看看谁来了——是我最喜欢的委托人～你总能带来最多的刺激和混乱……哦，相信我，这绝对是夸奖。", "sound": "sounds/vo_6006_zanyang.wav"}, "en": {"subtitle": "看看谁来了——是我最喜欢的委托人～你总能带来最多的刺激和混乱……哦，相信我，这绝对是夸奖。", "sound": "sounds/en_vo_6006_zanyang.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 600601016,
        audioId: 60060006,
        audioName: "vo_6006_dianchu_tou",
        desc: "点击-头",
        group: "TapBody",
        index: 4,
        actionId: "taiyanjing_1",
        label: "taiyanjing_1",
        duration: 3.5,
        voices: {"cn": {"subtitle": "别那么看我，我的脑袋里装的可不是坏主意，是派对邀请函～", "sound": "sounds/vo_6006_dianchu_tou.wav"}, "en": {"subtitle": "别那么看我，我的脑袋里装的可不是坏主意，是派对邀请函～", "sound": "sounds/en_vo_6006_dianchu_tou.wav"}},
        hitAreaParam: "HitAreaHead",
        hitAreas: ["HitAreaHead"],
        sourceType2: 401,
        sourceWeight: 20,
        weight: 20
      },
      {
        showId: 600601017,
        audioId: 60060007,
        audioName: "vo_6006_dianchu_shou",
        desc: "点击-手",
        group: "TapBody",
        index: 5,
        actionId: "tanshou",
        label: "tanshou",
        duration: 6.5,
        voices: {"cn": {"subtitle": "这双红手套一亮相，谁还需要自我介绍？", "sound": "sounds/vo_6006_dianchu_shou.wav"}, "en": {"subtitle": "这双红手套一亮相，谁还需要自我介绍？", "sound": "sounds/en_vo_6006_dianchu_shou.wav"}},
        hitAreaParam: "HitAreaHandL#HitAreaHandR",
        hitAreas: ["HitAreaHandL", "HitAreaHandR"],
        sourceType2: 401,
        sourceWeight: 20,
        weight: 20
      },
      {
        showId: 600601018,
        audioId: 60060008,
        audioName: "vo_6006_dianchu_shen",
        desc: "点击-胸",
        group: "Idle",
        index: 0,
        actionId: "idle",
        label: "默认",
        duration: 3.0,
        voices: {"cn": {"subtitle": "我打过的官司里，不是原告缺胳膊，就是被告少条腿，或者两边都——砰！脑袋开花！", "sound": "sounds/vo_6006_dianchu_shen.wav"}, "en": {"subtitle": "我打过的官司里，不是原告缺胳膊，就是被告少条腿，或者两边都——砰！脑袋开花！", "sound": "sounds/en_vo_6006_dianchu_shen.wav"}},
        hitAreaParam: "HitAreaBody",
        hitAreas: ["HitAreaBody"],
        sourceType2: 401,
        sourceWeight: 20,
        weight: 20
      }
    ]
  },
  {
    id: "100600_hst_cg",
    title: "预埋风格CG 100600_hst_cg 风格候选",
    assetKind: "style",
    categoryLabel: "风格",
    modelDir: "100600_hst_cg",
    sourceModelDir: "100600_hst_cg",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "streamingassets",
    styleId: "",
    styleName: "预埋风格CG 100600_hst_cg",
    stage: "风格候选",
    hitAreaNames: ["HitAreaMoren"],
    followConfigs: [],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 0.033 },
          { group: "Idle", index: 1, actionId: "idle1", label: "注视1", duration: 13.333 }
        ]
      },
      {
        label: "入场",
        actions: [
          { group: "Entry", index: 0, actionId: "ruchang", label: "入场", duration: 11.633 }
        ]
      }
    ],
    clickShowActions: [

    ]
  },
  {
    id: "100700_mmr",
    title: "某某人 角色立绘",
    assetKind: "character",
    categoryLabel: "角色",
    modelDir: "100700_mmr",
    sourceModelDir: "100700_mmr",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "localassets_win32",
    styleId: "",
    styleName: "某某人",
    stage: "角色立绘",
    hitAreaNames: ["HitAreaHandL", "HitAreaMoren", "HitAreaBody", "HitAreaHead", "HitAreaHandR"],
    followConfigs: [{"id": 1001, "prefab": "100700_mmr", "activeName": "", "expressionName": "", "damping": 0.0, "parameters": [{"parameterId": "ParamAngleX", "axis": "X", "factor": 30.0, "sourceToken": "ParamAngleX#30*X"}, {"parameterId": "ParamAngleY", "axis": "Y", "factor": 50.0, "sourceToken": "ParamAngleY#50*Y"}, {"parameterId": "ParamEyeBallX", "axis": "X", "factor": 50.0, "sourceToken": "ParamEyeBallX#50*X"}, {"parameterId": "ParamEyeBallY", "axis": "Y", "factor": 50.0, "sourceToken": "ParamEyeBallY#50*Y"}, {"parameterId": "ParamBodyAngleX", "axis": "X", "factor": 30.0, "sourceToken": "ParamBodyAngleX#30*X"}, {"parameterId": "ParamBodyAngleY", "axis": "Y", "factor": 30.0, "sourceToken": "ParamBodyAngleY#30*Y"}]}],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 6.0 }
        ]
      },
      {
        label: "TapBody",
        actions: [
          { group: "TapBody", index: 0, actionId: "diantou", label: "diantou", duration: 3.0 },
          { group: "TapBody", index: 1, actionId: "houtui", label: "houtui", duration: 3.0 },
          { group: "TapBody", index: 2, actionId: "maozi", label: "maozi", duration: 4.4 },
          { group: "TapBody", index: 3, actionId: "qiaoqiang", label: "qiaoqiang", duration: 3.0 },
          { group: "TapBody", index: 4, actionId: "qiaoqiang_1", label: "qiaoqiang_1", duration: 3.0 },
          { group: "TapBody", index: 5, actionId: "walk", label: "walk", duration: 2.0 },
          { group: "TapBody", index: 6, actionId: "yaotou", label: "yaotou", duration: 2.571 }
        ]
      }
    ],
    clickShowActions: [
      {
        showId: 600201010,
        audioId: 60020004,
        audioName: "vo_6002_daiji_01",
        desc: "点击-通用1",
        group: "Idle",
        index: 0,
        actionId: "idle",
        label: "默认",
        duration: 6.0,
        voices: {"cn": {"subtitle": "沉默很有作用。它能杀掉一个人，也能保全一个家族。", "sound": "sounds/vo_6002_daiji_01.wav"}, "en": {"subtitle": "沉默很有作用。它能杀掉一个人，也能保全一个家族。", "sound": "sounds/en_vo_6002_daiji_01.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 600201011,
        audioId: 60020005,
        audioName: "vo_6002_daiji_02",
        desc: "点击-通用2",
        group: "TapBody",
        index: 2,
        actionId: "maozi",
        label: "maozi",
        duration: 4.4,
        voices: {"cn": {"subtitle": "每一杯酒都有它们的故事，就像每个人都有他们的秘密。", "sound": "sounds/vo_6002_daiji_02.wav"}, "en": {"subtitle": "每一杯酒都有它们的故事，就像每个人都有他们的秘密。", "sound": "sounds/en_vo_6002_daiji_02.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 600201012,
        audioId: 60020010,
        audioName: "vo_6002_xianliao_01",
        desc: "点击-闲聊1",
        group: "TapBody",
        index: 4,
        actionId: "qiaoqiang_1",
        label: "qiaoqiang_1",
        duration: 3.0,
        voices: {"cn": {"subtitle": "总有新手菜鸟以为，干这行只需要一把好枪。然后他们忘带的脑子，就彻底用不着了。", "sound": "sounds/vo_6002_xianliao_01.wav"}, "en": {"subtitle": "总有新手菜鸟以为，干这行只需要一把好枪。然后他们忘带的脑子，就彻底用不着了。", "sound": "sounds/en_vo_6002_xianliao_01.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 600201013,
        audioId: 60020011,
        audioName: "vo_6002_xianliao_02",
        desc: "点击-闲聊2",
        group: "Idle",
        index: 0,
        actionId: "idle",
        label: "默认",
        duration: 6.0,
        voices: {"cn": {"subtitle": "三月的雨水是丰收的前兆；但如果持续到五月，它会让葡萄结不出果实。无论做哪种生意，都要讲时机。", "sound": "sounds/vo_6002_xianliao_02.wav"}, "en": {"subtitle": "三月的雨水是丰收的前兆；但如果持续到五月，它会让葡萄结不出果实。无论做哪种生意，都要讲时机。", "sound": "sounds/en_vo_6002_xianliao_02.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 600201014,
        audioId: 60020012,
        audioName: "vo_6002_xianliao_03",
        desc: "点击-闲聊3",
        group: "TapBody",
        index: 0,
        actionId: "diantou",
        label: "diantou",
        duration: 3.0,
        voices: {"cn": {"subtitle": "公爵府今天很安静……或许那些吵闹的家伙也学会欣赏沉默的价值了。", "sound": "sounds/vo_6002_xianliao_03.wav"}, "en": {"subtitle": "公爵府今天很安静……或许那些吵闹的家伙也学会欣赏沉默的价值了。", "sound": "sounds/en_vo_6002_xianliao_03.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 600201015,
        audioId: 60020014,
        audioName: "vo_6002_zanyang",
        desc: "点击-赞扬1",
        group: "Idle",
        index: 0,
        actionId: "idle",
        label: "默认",
        duration: 6.0,
        voices: {"cn": {"subtitle": "很奇妙，你总能在关键时刻……让我莫名放松下来。", "sound": "sounds/vo_6002_zanyang.wav"}, "en": {"subtitle": "很奇妙，你总能在关键时刻……让我莫名放松下来。", "sound": "sounds/en_vo_6002_zanyang.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 600201016,
        audioId: 60020006,
        audioName: "vo_6002_dianchu_tou",
        desc: "点击-头",
        group: "Idle",
        index: 0,
        actionId: "idle",
        label: "默认",
        duration: 6.0,
        voices: {"cn": {"subtitle": "有些人喜欢直视对手的眼睛，我更喜欢让他们看不见我的。", "sound": "sounds/vo_6002_dianchu_tou.wav"}, "en": {"subtitle": "有些人喜欢直视对手的眼睛，我更喜欢让他们看不见我的。", "sound": "sounds/en_vo_6002_dianchu_tou.wav"}},
        hitAreaParam: "HitAreaHead",
        hitAreas: ["HitAreaHead"],
        sourceType2: 401,
        sourceWeight: 20,
        weight: 20
      },
      {
        showId: 600201017,
        audioId: 60020007,
        audioName: "vo_6002_dianchu_shou",
        desc: "点击-手",
        group: "TapBody",
        index: 0,
        actionId: "diantou",
        label: "diantou",
        duration: 3.0,
        voices: {"cn": {"subtitle": "如果你伸手，我一定会接住。这点小事，不需要靠契约履行。", "sound": "sounds/vo_6002_dianchu_shou.wav"}, "en": {"subtitle": "如果你伸手，我一定会接住。这点小事，不需要靠契约履行。", "sound": "sounds/en_vo_6002_dianchu_shou.wav"}},
        hitAreaParam: "HitAreaHandL#HitAreaHandR",
        hitAreas: ["HitAreaHandL", "HitAreaHandR"],
        sourceType2: 401,
        sourceWeight: 20,
        weight: 20
      },
      {
        showId: 600201018,
        audioId: 60020008,
        audioName: "vo_6002_dianchu_shen",
        desc: "点击-胸",
        group: "TapBody",
        index: 4,
        actionId: "qiaoqiang_1",
        label: "qiaoqiang_1",
        duration: 3.0,
        voices: {"cn": {"subtitle": "撑场面的活都可以让我的分身来，随叫随到。", "sound": "sounds/vo_6002_dianchu_shen.wav"}, "en": {"subtitle": "撑场面的活都可以让我的分身来，随叫随到。", "sound": "sounds/en_vo_6002_dianchu_shen.wav"}},
        hitAreaParam: "HitAreaBody",
        hitAreas: ["HitAreaBody"],
        sourceType2: 401,
        sourceWeight: 20,
        weight: 20
      }
    ]
  },
  {
    id: "100800_dd",
    title: "嘀嗒 角色立绘",
    assetKind: "character",
    categoryLabel: "角色",
    modelDir: "100800_dd",
    sourceModelDir: "100800_dd",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "localassets_win32",
    styleId: "",
    styleName: "嘀嗒",
    stage: "角色立绘",
    hitAreaNames: ["HitAreaMoren", "HitAreaHandL", "HitAreaHandR", "HitAreaHead", "HitAreaBody"],
    followConfigs: [{"id": 1001, "prefab": "100800_dd", "activeName": "", "expressionName": "", "damping": 0.0, "parameters": [{"parameterId": "ParamAngleX", "axis": "X", "factor": 30.0, "sourceToken": "ParamAngleX#30*X"}, {"parameterId": "ParamAngleY", "axis": "Y", "factor": 50.0, "sourceToken": "ParamAngleY#50*Y"}, {"parameterId": "ParamEyeBallX", "axis": "X", "factor": 50.0, "sourceToken": "ParamEyeBallX#50*X"}, {"parameterId": "ParamEyeBallY", "axis": "Y", "factor": 50.0, "sourceToken": "ParamEyeBallY#50*Y"}, {"parameterId": "ParamBodyAngleX", "axis": "X", "factor": 30.0, "sourceToken": "ParamBodyAngleX#30*X"}, {"parameterId": "ParamBodyAngleY", "axis": "Y", "factor": 30.0, "sourceToken": "ParamBodyAngleY#30*Y"}]}],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 6.0 }
        ]
      },
      {
        label: "TapBody",
        actions: [
          { group: "TapBody", index: 0, actionId: "diantou", label: "diantou", duration: 2.667 },
          { group: "TapBody", index: 1, actionId: "houtui", label: "houtui", duration: 2.667 },
          { group: "TapBody", index: 2, actionId: "houyang", label: "houyang", duration: 2.667 },
          { group: "TapBody", index: 3, actionId: "houyang_1", label: "houyang_1", duration: 2.667 },
          { group: "TapBody", index: 4, actionId: "maozi", label: "maozi", duration: 4.467 },
          { group: "TapBody", index: 5, actionId: "qianqing", label: "qianqing", duration: 3.433 },
          { group: "TapBody", index: 6, actionId: "qianqing_1", label: "qianqing_1", duration: 3.733 },
          { group: "TapBody", index: 7, actionId: "sikao", label: "sikao", duration: 4.467 },
          { group: "TapBody", index: 8, actionId: "songjian", label: "songjian", duration: 2.667 },
          { group: "TapBody", index: 9, actionId: "tibao", label: "tibao", duration: 2.667 },
          { group: "TapBody", index: 10, actionId: "tibao_1", label: "tibao_1", duration: 2.667 },
          { group: "TapBody", index: 11, actionId: "waitou", label: "waitou", duration: 3.0 },
          { group: "TapBody", index: 12, actionId: "walk", label: "walk", duration: 2.0 },
          { group: "TapBody", index: 13, actionId: "yaotou", label: "yaotou", duration: 2.0 }
        ]
      }
    ],
    clickShowActions: [
      {
        showId: 600301010,
        audioId: 60030004,
        audioName: "vo_6003_daiji_01",
        desc: "点击-通用1",
        group: "TapBody",
        index: 7,
        actionId: "sikao",
        label: "sikao",
        duration: 4.467,
        voices: {"cn": {"subtitle": "我总觉得自己该有个酷炫的出场方式，这样更能镇得住场子。比如甩一下外套，或者同时看三块怀表……？", "sound": "sounds/vo_6003_daiji_01.wav"}, "en": {"subtitle": "我总觉得自己该有个酷炫的出场方式，这样更能镇得住场子。比如甩一下外套，或者同时看三块怀表……？", "sound": "sounds/en_vo_6003_daiji_01.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 600301011,
        audioId: 60030005,
        audioName: "vo_6003_daiji_02",
        desc: "点击-通用2",
        group: "TapBody",
        index: 3,
        actionId: "houyang_1",
        label: "houyang_1",
        duration: 2.667,
        voices: {"cn": {"subtitle": "讲讲离奇的侦探故事？嗯……我曾经追踪一个可疑人物，最后被对方带着买了两斤苹果，还是特价的。", "sound": "sounds/vo_6003_daiji_02.wav"}, "en": {"subtitle": "讲讲离奇的侦探故事？嗯……我曾经追踪一个可疑人物，最后被对方带着买了两斤苹果，还是特价的。", "sound": "sounds/en_vo_6003_daiji_02.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 600301012,
        audioId: 60030010,
        audioName: "vo_6003_xianliao_01",
        desc: "点击-闲聊1",
        group: "Idle",
        index: 0,
        actionId: "idle",
        label: "默认",
        duration: 6.0,
        voices: {"cn": {"subtitle": "是不是我的问题太多了？总感觉……每当我拿着笔记本出现，周围的人都一下子消失了。", "sound": "sounds/vo_6003_xianliao_01.wav"}, "en": {"subtitle": "是不是我的问题太多了？总感觉……每当我拿着笔记本出现，周围的人都一下子消失了。", "sound": "sounds/en_vo_6003_xianliao_01.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 600301013,
        audioId: 60030011,
        audioName: "vo_6003_xianliao_02",
        desc: "点击-闲聊2",
        group: "TapBody",
        index: 7,
        actionId: "sikao",
        label: "sikao",
        duration: 4.467,
        voices: {"cn": {"subtitle": "时光倒流，人们回到过去弥补遗憾——啊，这是我刚读到的小说情节，要是它能成真就好了。", "sound": "sounds/vo_6003_xianliao_02.wav"}, "en": {"subtitle": "时光倒流，人们回到过去弥补遗憾——啊，这是我刚读到的小说情节，要是它能成真就好了。", "sound": "sounds/en_vo_6003_xianliao_02.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 600301014,
        audioId: 60030012,
        audioName: "vo_6003_xianliao_03",
        desc: "点击-闲聊3",
        group: "TapBody",
        index: 6,
        actionId: "qianqing_1",
        label: "qianqing_1",
        duration: 3.733,
        voices: {"cn": {"subtitle": "这个月我得了全勤奖？嘿嘿……太好了！我这人没什么优点，准时算一个。", "sound": "sounds/vo_6003_xianliao_03.wav"}, "en": {"subtitle": "这个月我得了全勤奖？嘿嘿……太好了！我这人没什么优点，准时算一个。", "sound": "sounds/en_vo_6003_xianliao_03.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 600301015,
        audioId: 60030014,
        audioName: "vo_6003_zanyang",
        desc: "点击-赞扬1",
        group: "TapBody",
        index: 6,
        actionId: "qianqing_1",
        label: "qianqing_1",
        duration: 3.733,
        voices: {"cn": {"subtitle": "在夜行者这行里，你可是了不起的大前辈！真希望我能跟得上你的脚步。", "sound": "sounds/vo_6003_zanyang.wav"}, "en": {"subtitle": "在夜行者这行里，你可是了不起的大前辈！真希望我能跟得上你的脚步。", "sound": "sounds/en_vo_6003_zanyang.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 600301016,
        audioId: 60030006,
        audioName: "vo_6003_dianchu_tou",
        desc: "点击-头",
        group: "TapBody",
        index: 13,
        actionId: "yaotou",
        label: "yaotou",
        duration: 2.0,
        voices: {"cn": {"subtitle": "昨天查资料熬夜了，现在脑袋像撞进了钟表店，里面回旋着滴滴答答的声音……呜呜。", "sound": "sounds/vo_6003_dianchu_tou.wav"}, "en": {"subtitle": "昨天查资料熬夜了，现在脑袋像撞进了钟表店，里面回旋着滴滴答答的声音……呜呜。", "sound": "sounds/en_vo_6003_dianchu_tou.wav"}},
        hitAreaParam: "HitAreaHead",
        hitAreas: ["HitAreaHead"],
        sourceType2: 401,
        sourceWeight: 20,
        weight: 20
      },
      {
        showId: 600301017,
        audioId: 60030007,
        audioName: "vo_6003_dianchu_shou",
        desc: "点击-手",
        group: "TapBody",
        index: 10,
        actionId: "tibao_1",
        label: "tibao_1",
        duration: 2.667,
        voices: {"cn": {"subtitle": "哦，手上的擦伤是在巷子里摔的，当时为了抓住敌人的眼线，我猛扑过去抱住了他的腿！这些擦伤是光荣的勋章！", "sound": "sounds/vo_6003_dianchu_shou.wav"}, "en": {"subtitle": "哦，手上的擦伤是在巷子里摔的，当时为了抓住敌人的眼线，我猛扑过去抱住了他的腿！这些擦伤是光荣的勋章！", "sound": "sounds/en_vo_6003_dianchu_shou.wav"}},
        hitAreaParam: "HitAreaHandL#HitAreaHandR",
        hitAreas: ["HitAreaHandL", "HitAreaHandR"],
        sourceType2: 401,
        sourceWeight: 20,
        weight: 20
      },
      {
        showId: 600301018,
        audioId: 60030008,
        audioName: "vo_6003_dianchu_shen",
        desc: "点击-胸",
        group: "Idle",
        index: 0,
        actionId: "idle",
        label: "默认",
        duration: 6.0,
        voices: {"cn": {"subtitle": "完成委托的时候，大家会笑着拍拍我的后背。每到这种时候，我心里就会充满了干劲！", "sound": "sounds/vo_6003_dianchu_shen.wav"}, "en": {"subtitle": "完成委托的时候，大家会笑着拍拍我的后背。每到这种时候，我心里就会充满了干劲！", "sound": "sounds/en_vo_6003_dianchu_shen.wav"}},
        hitAreaParam: "HitAreaBody",
        hitAreas: ["HitAreaBody"],
        sourceType2: 401,
        sourceWeight: 20,
        weight: 20
      }
    ]
  },
  {
    id: "100900_hst",
    title: "预埋角色 100900_hst 角色候选",
    assetKind: "character",
    categoryLabel: "角色",
    modelDir: "100900_hst",
    sourceModelDir: "100900_hst",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "streamingassets",
    styleId: "",
    styleName: "预埋角色 100900_hst",
    stage: "角色候选",
    hitAreaNames: ["HitAreaMoren", "HitAreaBody", "HitAreaHead", "HitAreaHand"],
    followConfigs: [{"id": 1021, "prefab": "100900_hst", "activeName": "", "expressionName": "", "damping": 0.0, "parameters": [{"parameterId": "ParamAngleX", "axis": "X", "factor": 30.0, "sourceToken": "ParamAngleX#30*X"}, {"parameterId": "ParamAngleY", "axis": "Y", "factor": 20.0, "sourceToken": "ParamAngleY#20*Y"}, {"parameterId": "ParamEyeBallX", "axis": "X", "factor": 80.0, "sourceToken": "ParamEyeBallX#80*X"}, {"parameterId": "ParamEyeBallY", "axis": "Y", "factor": 50.0, "sourceToken": "ParamEyeBallY#50*Y"}, {"parameterId": "ParamBodyAngleX", "axis": "X", "factor": 30.0, "sourceToken": "ParamBodyAngleX#30*X"}, {"parameterId": "ParamBodyAngleY", "axis": "Y", "factor": 50.0, "sourceToken": "ParamBodyAngleY#50*Y"}]}],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 3.0 }
        ]
      },
      {
        label: "TapBody",
        actions: [
          { group: "TapBody", index: 0, actionId: "diantou", label: "diantou", duration: 3.0 },
          { group: "TapBody", index: 1, actionId: "tiaoxin", label: "tiaoxin", duration: 3.333 },
          { group: "TapBody", index: 2, actionId: "waitou", label: "waitou", duration: 3.833 },
          { group: "TapBody", index: 3, actionId: "walk", label: "walk", duration: 2.0 },
          { group: "TapBody", index: 4, actionId: "yaotou", label: "yaotou", duration: 3.0 }
        ]
      }
    ],
    clickShowActions: [

    ]
  },
  {
    id: "100900_hst_cg",
    title: "深渊审判 二段",
    assetKind: "style",
    categoryLabel: "风格",
    modelDir: "100900_hst_cg",
    sourceModelDir: "100900_hst_cg",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "streamingassets",
    styleId: "13001009",
    styleName: "深渊审判",
    stage: "二段",
    hitAreaNames: ["HitAreamoren", "HitAreaquanbu", "HitAreateshu"],
    followConfigs: [{"id": 21003, "prefab": "100900_hst_cg", "activeName": "", "expressionName": "", "damping": 0.0, "parameters": [{"parameterId": "ParamAngleX", "axis": "X", "factor": 80.0, "sourceToken": "ParamAngleX#80*X"}, {"parameterId": "ParamAngleY", "axis": "Y", "factor": 80.0, "sourceToken": "ParamAngleY#80*Y"}, {"parameterId": "ParamAngleZ", "axis": "X", "factor": -5.0, "sourceToken": "ParamAngleZ#-5*X"}, {"parameterId": "ParamEyeBallX", "axis": "X", "factor": 30.0, "sourceToken": "ParamEyeBallX#30*X"}, {"parameterId": "ParamEyeBallY", "axis": "Y", "factor": 30.0, "sourceToken": "ParamEyeBallY#30*Y"}, {"parameterId": "ParamBodyAngleX", "axis": "X", "factor": 30.0, "sourceToken": "ParamBodyAngleX#30*X"}, {"parameterId": "ParamBodyAngleY", "axis": "Y", "factor": 30.0, "sourceToken": "ParamBodyAngleY#30*Y"}]}],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [],
    storyTouchActions: [],
    unlockableMotions: [
      { group: "TapBody", index: 0, actionId: "dongzuo1", label: "亲近1", duration: 12.0 },
      { group: "TapBody", index: 1, actionId: "dongzuo2", label: "亲近2", duration: 12.0 },
      { group: "TapBody", index: 2, actionId: "dongzuo3", label: "亲近3", duration: 12.667 }
    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 13.467 },
          { group: "Idle", index: 1, actionId: "idle1", label: "注视1", duration: 20.0 },
          { group: "Idle", index: 2, actionId: "idle2", label: "注视2", duration: 8.5 }
        ]
      },
      {
        label: "TapBody",
        actions: [
          { group: "TapBody", index: 0, actionId: "dongzuo1", label: "亲近1", duration: 12.0 },
          { group: "TapBody", index: 1, actionId: "dongzuo2", label: "亲近2", duration: 12.0 },
          { group: "TapBody", index: 2, actionId: "dongzuo3", label: "亲近3", duration: 12.667 }
        ]
      },
      {
        label: "入场",
        actions: [
          { group: "Entry", index: 0, actionId: "ruchang", label: "入场", duration: 17.5 }
        ]
      }
    ],
    clickShowActions: [
      {
        showId: 61009055,
        audioId: 10090008,
        audioName: "vo_1009_erduanchahua_03",
        desc: "点击3",
        group: "TapBody",
        index: 0,
        actionId: "dongzuo1",
        label: "亲近1",
        duration: 12.0,
        voices: {"cn": {"subtitle": "嘶哈……我都有点怀疑，你是不是在奖励我了。", "sound": "sounds/vo_1009_erduanchahua_03.wav"}, "en": {"subtitle": "嘶哈……我都有点怀疑，你是不是在奖励我了。", "sound": "sounds/en_vo_1009_erduanchahua_03.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 20,
        weight: 20
      },
      {
        showId: 61009056,
        audioId: 10090009,
        audioName: "vo_1009_erduanchahua_04",
        desc: "点击4",
        group: "TapBody",
        index: 1,
        actionId: "dongzuo2",
        label: "亲近2",
        duration: 12.0,
        voices: {"cn": {"subtitle": "噢……恰到好处的疼痛，对我胃口。", "sound": "sounds/vo_1009_erduanchahua_04.wav"}, "en": {"subtitle": "噢……恰到好处的疼痛，对我胃口。", "sound": "sounds/en_vo_1009_erduanchahua_04.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 20,
        weight: 20
      },
      {
        showId: 61009057,
        audioId: 10090010,
        audioName: "vo_1009_erduanchahua_05",
        desc: "点击5",
        group: "TapBody",
        index: 2,
        actionId: "dongzuo3",
        label: "亲近3",
        duration: 12.667,
        voices: {"cn": {"subtitle": "我的表情让你有兴致了？", "sound": "sounds/vo_1009_erduanchahua_05.wav"}, "en": {"subtitle": "我的表情让你有兴致了？", "sound": "sounds/en_vo_1009_erduanchahua_05.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 20,
        weight: 20
      },
      {
        showId: 61009061,
        audioId: 10090006,
        audioName: "vo_1009_erduanchahua_01",
        desc: "点击1",
        group: "Idle",
        index: 1,
        actionId: "idle1",
        label: "注视1",
        duration: 20.0,
        voices: {"cn": {"subtitle": "♪～", "sound": "sounds/vo_1009_erduanchahua_01.wav"}, "en": {"subtitle": "♪～", "sound": "sounds/en_vo_1009_erduanchahua_01.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 10,
        weight: 10
      },
      {
        showId: 61009062,
        audioId: 10090007,
        audioName: "vo_1009_erduanchahua_02",
        desc: "点击2",
        group: "Idle",
        index: 2,
        actionId: "idle2",
        label: "注视2",
        duration: 8.5,
        voices: {"cn": {"subtitle": "放心，你惩罚我的每一个动作，我都好好看在眼里。", "sound": "sounds/vo_1009_erduanchahua_02.wav"}, "en": {"subtitle": "放心，你惩罚我的每一个动作，我都好好看在眼里。", "sound": "sounds/en_vo_1009_erduanchahua_02.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 10,
        weight: 10
      },
      {
        showId: 61009063,
        audioId: 60060011,
        audioName: "vo_6006_xianliao_02",
        desc: "点击-闲聊2",
        group: "Idle",
        index: 2,
        actionId: "idle2",
        label: "注视2",
        duration: 8.5,
        voices: {"cn": {"subtitle": "我听了个笑话——“正义不会缺席”！噗……正义可不是什么常驻法庭的吉祥物，你得主动去争取，最好再带上一把枪或斧头。", "sound": "sounds/vo_6006_xianliao_02.wav"}, "en": {"subtitle": "我听了个笑话——“正义不会缺席”！噗……正义可不是什么常驻法庭的吉祥物，你得主动去争取，最好再带上一把枪或斧头。", "sound": "sounds/en_vo_6006_xianliao_02.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 61009064,
        audioId: 60060012,
        audioName: "vo_6006_xianliao_03",
        desc: "点击-闲聊3",
        group: "Idle",
        index: 1,
        actionId: "idle1",
        label: "注视1",
        duration: 20.0,
        voices: {"cn": {"subtitle": "“暗巷惊天凶案，受害者化整为零……”嗯哼，很吸睛的小报标题。为什么看我？我只是一个拎着公文包的普通律师，凑巧包里装了把斧头。", "sound": "sounds/vo_6006_xianliao_03.wav"}, "en": {"subtitle": "“暗巷惊天凶案，受害者化整为零……”嗯哼，很吸睛的小报标题。为什么看我？我只是一个拎着公文包的普通律师，凑巧包里装了把斧头。", "sound": "sounds/en_vo_6006_xianliao_03.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 61009065,
        audioId: 60060014,
        audioName: "vo_6006_zanyang",
        desc: "点击-赞扬1",
        group: "Idle",
        index: 2,
        actionId: "idle2",
        label: "注视2",
        duration: 8.5,
        voices: {"cn": {"subtitle": "看看谁来了——是我最喜欢的委托人～你总能带来最多的刺激和混乱……哦，相信我，这绝对是夸奖。", "sound": "sounds/vo_6006_zanyang.wav"}, "en": {"subtitle": "看看谁来了——是我最喜欢的委托人～你总能带来最多的刺激和混乱……哦，相信我，这绝对是夸奖。", "sound": "sounds/en_vo_6006_zanyang.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      }
    ]
  },
  {
    id: "100901_hst_cg",
    title: "深渊审判 一段",
    assetKind: "style",
    categoryLabel: "风格",
    modelDir: "100901_hst_cg",
    sourceModelDir: "100901_hst_cg",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "localassets_win32",
    styleId: "13001009",
    styleName: "深渊审判",
    stage: "一段",
    hitAreaNames: ["HitAreaquanbu"],
    followConfigs: [{"id": 21008, "prefab": "100901_hst_cg", "activeName": "", "expressionName": "", "damping": 0.0, "parameters": [{"parameterId": "Param104", "axis": "X", "factor": -12.0, "sourceToken": "Param104#-12*X"}, {"parameterId": "Param126", "axis": "Y", "factor": 60.0, "sourceToken": "Param126#60*Y"}, {"parameterId": "Param158", "axis": "Y", "factor": 100.0, "sourceToken": "Param158#100*Y"}, {"parameterId": "ParamAngleX", "axis": "X", "factor": 15.0, "sourceToken": "ParamAngleX#15*X"}, {"parameterId": "ParamAngleY", "axis": "Y", "factor": 74.0, "sourceToken": "ParamAngleY#74*Y"}, {"parameterId": "ParamAngleZ", "axis": "Y", "factor": -15.0, "sourceToken": "ParamAngleZ#-15*Y"}, {"parameterId": "ParamEyeLOpen", "axis": "Y", "factor": -20.0, "sourceToken": "ParamEyeLOpen#-20*Y"}, {"parameterId": "ParamEyeROpen", "axis": "Y", "factor": -20.0, "sourceToken": "ParamEyeROpen#-20*Y"}, {"parameterId": "ParamEyeBallY", "axis": "Y", "factor": -50.0, "sourceToken": "ParamEyeBallY#-50*Y"}, {"parameterId": "ParamBodyAngleX", "axis": "X", "factor": -2.0, "sourceToken": "ParamBodyAngleX#-2*X"}, {"parameterId": "Param100", "axis": "X", "factor": -1.0, "sourceToken": "Param100#-1*X"}, {"parameterId": "Param101", "axis": "Y", "factor": -2.0, "sourceToken": "Param101#-2*Y"}]}],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 20.233 },
          { group: "Idle", index: 1, actionId: "idle1", label: "注视1", duration: 10.633 },
          { group: "Idle", index: 2, actionId: "idle2", label: "注视2", duration: 9.37 }
        ]
      },
      {
        label: "入场",
        actions: [
          { group: "Entry", index: 0, actionId: "ruchang", label: "入场", duration: 22.6 }
        ]
      }
    ],
    clickShowActions: [
      {
        showId: 61009009,
        audioId: 10090002,
        audioName: "vo_1009_yiduanchahua_01",
        desc: "点击1",
        group: "Idle",
        index: 1,
        actionId: "idle1",
        label: "注视1",
        duration: 10.633,
        voices: {"cn": {"subtitle": "猜猜这颗樱桃粘过什么？毒药？谎言？还是……一点黏糊糊的真心？", "sound": "sounds/vo_1009_yiduanchahua_01.wav"}, "en": {"subtitle": "猜猜这颗樱桃粘过什么？毒药？谎言？还是……一点黏糊糊的真心？", "sound": "sounds/en_vo_1009_yiduanchahua_01.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 20,
        weight: 20
      },
      {
        showId: 61009010,
        audioId: 10090003,
        audioName: "vo_1009_yiduanchahua_02",
        desc: "点击2",
        group: "Idle",
        index: 2,
        actionId: "idle2",
        label: "注视2",
        duration: 9.37,
        voices: {"cn": {"subtitle": "看，它多像条缩小的绞索，尺寸正够把某根手指拖入婚姻的坟墓。", "sound": "sounds/vo_1009_yiduanchahua_02.wav"}, "en": {"subtitle": "看，它多像条缩小的绞索，尺寸正够把某根手指拖入婚姻的坟墓。", "sound": "sounds/en_vo_1009_yiduanchahua_02.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 20,
        weight: 20
      },
      {
        showId: 61009011,
        audioId: 60060004,
        audioName: "vo_6006_daiji_01",
        desc: "点击-通用1",
        group: "Idle",
        index: 2,
        actionId: "idle2",
        label: "注视2",
        duration: 9.37,
        voices: {"cn": {"subtitle": "太可惜了，不能把法庭听证席改成钢管舞台，少了一批视野绝佳的钢管座，噗哈哈哈！", "sound": "sounds/vo_6006_daiji_01.wav"}, "en": {"subtitle": "太可惜了，不能把法庭听证席改成钢管舞台，少了一批视野绝佳的钢管座，噗哈哈哈！", "sound": "sounds/en_vo_6006_daiji_01.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 10,
        weight: 10
      },
      {
        showId: 61009012,
        audioId: 60060005,
        audioName: "vo_6006_daiji_02",
        desc: "点击-通用2",
        group: "Idle",
        index: 1,
        actionId: "idle1",
        label: "注视1",
        duration: 10.633,
        voices: {"cn": {"subtitle": "今天的我没有案件、没有敌人、也没有乐子……该死，我是不是生病了？", "sound": "sounds/vo_6006_daiji_02.wav"}, "en": {"subtitle": "今天的我没有案件、没有敌人、也没有乐子……该死，我是不是生病了？", "sound": "sounds/en_vo_6006_daiji_02.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 10,
        weight: 10
      },
      {
        showId: 61009013,
        audioId: 60060010,
        audioName: "vo_6006_xianliao_01",
        desc: "点击-闲聊1",
        group: "Idle",
        index: 1,
        actionId: "idle1",
        label: "注视1",
        duration: 10.633,
        voices: {"cn": {"subtitle": "啊没错，我现在应该在法庭上，但我已经听了一周的陈词滥调。哪怕身处地狱，我也要捍卫自己休息的合法权利——", "sound": "sounds/vo_6006_xianliao_01.wav"}, "en": {"subtitle": "啊没错，我现在应该在法庭上，但我已经听了一周的陈词滥调。哪怕身处地狱，我也要捍卫自己休息的合法权利——", "sound": "sounds/en_vo_6006_xianliao_01.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 10,
        weight: 10
      },
      {
        showId: 61009014,
        audioId: 60060014,
        audioName: "vo_6006_zanyang",
        desc: "点击-赞扬1",
        group: "Idle",
        index: 2,
        actionId: "idle2",
        label: "注视2",
        duration: 9.37,
        voices: {"cn": {"subtitle": "看看谁来了——是我最喜欢的委托人～你总能带来最多的刺激和混乱……哦，相信我，这绝对是夸奖。", "sound": "sounds/vo_6006_zanyang.wav"}, "en": {"subtitle": "看看谁来了——是我最喜欢的委托人～你总能带来最多的刺激和混乱……哦，相信我，这绝对是夸奖。", "sound": "sounds/en_vo_6006_zanyang.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 10,
        weight: 10
      }
    ]
  },
  {
    id: "101000_yz",
    title: "愚者 角色立绘",
    assetKind: "character",
    categoryLabel: "角色",
    modelDir: "101000_yz",
    sourceModelDir: "101000_yz",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "localassets_win32",
    styleId: "",
    styleName: "愚者",
    stage: "角色立绘",
    hitAreaNames: ["HitAreaHandL1", "HitAreaMoren", "HitAreaHandR1", "HitAreaHandL2", "HitAreaHead", "HitAreaHandR2", "HitAreaBody"],
    followConfigs: [{"id": 1042, "prefab": "101000_yz", "activeName": "", "expressionName": "", "damping": 0.0, "parameters": [{"parameterId": "ParamAngleX", "axis": "X", "factor": 15.0, "sourceToken": "ParamAngleX#15*X"}, {"parameterId": "ParamAngleY", "axis": "Y", "factor": 25.0, "sourceToken": "ParamAngleY#25*Y"}, {"parameterId": "ParamEyeBallX", "axis": "X", "factor": 25.0, "sourceToken": "ParamEyeBallX#25*X"}, {"parameterId": "ParamEyeBallY", "axis": "Y", "factor": 30.0, "sourceToken": "ParamEyeBallY#30*Y"}, {"parameterId": "ParamBodyAngleX", "axis": "X", "factor": 15.0, "sourceToken": "ParamBodyAngleX#15*X"}, {"parameterId": "ParamBodyAngleY", "axis": "Y", "factor": 15.0, "sourceToken": "ParamBodyAngleY#15*Y"}]}],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 6.0 }
        ]
      },
      {
        label: "TapBody",
        actions: [
          { group: "TapBody", index: 0, actionId: "diantou", label: "diantou", duration: 3.0 },
          { group: "TapBody", index: 1, actionId: "lapai", label: "lapai", duration: 9.167 },
          { group: "TapBody", index: 2, actionId: "loop", label: "loop", duration: 6.0 },
          { group: "TapBody", index: 3, actionId: "moxiaba", label: "moxiaba", duration: 4.667 },
          { group: "TapBody", index: 4, actionId: "moxiaba_1", label: "moxiaba_1", duration: 4.667 },
          { group: "TapBody", index: 5, actionId: "waitou", label: "waitou", duration: 3.167 },
          { group: "TapBody", index: 6, actionId: "waitou_1", label: "waitou_1", duration: 3.333 },
          { group: "TapBody", index: 7, actionId: "walk", label: "walk", duration: 2.167 },
          { group: "TapBody", index: 8, actionId: "yaotou", label: "yaotou", duration: 3.0 },
          { group: "TapBody", index: 9, actionId: "zhanbu", label: "zhanbu", duration: 6.0 },
          { group: "TapBody", index: 10, actionId: "zhanbu_1", label: "zhanbu_1", duration: 6.0 }
        ]
      }
    ],
    clickShowActions: [
      {
        showId: 600401010,
        audioId: 60040004,
        audioName: "vo_6004_daiji_01",
        desc: "点击-通用1",
        group: "TapBody",
        index: 6,
        actionId: "waitou_1",
        label: "waitou_1",
        duration: 3.333,
        voices: {"cn": {"subtitle": "不觉得那些禁止的事项就是用来打破的吗？越是禁忌，破坏时就越迷人。", "sound": "sounds/vo_6004_daiji_01.wav"}, "en": {"subtitle": "不觉得那些禁止的事项就是用来打破的吗？越是禁忌，破坏时就越迷人。", "sound": "sounds/en_vo_6004_daiji_01.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 600401011,
        audioId: 60040005,
        audioName: "vo_6004_daiji_02",
        desc: "点击-通用2",
        group: "Idle",
        index: 0,
        actionId: "idle",
        label: "默认",
        duration: 6.0,
        voices: {"cn": {"subtitle": "我对本不该知道秘密的人告了密。你说，这点微不足道的差错，最后会不会演变成一场波及世界的灾难？", "sound": "sounds/vo_6004_daiji_02.wav"}, "en": {"subtitle": "我对本不该知道秘密的人告了密。你说，这点微不足道的差错，最后会不会演变成一场波及世界的灾难？", "sound": "sounds/en_vo_6004_daiji_02.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 600401012,
        audioId: 60040010,
        audioName: "vo_6004_xianliao_01",
        desc: "点击-闲聊1",
        group: "TapBody",
        index: 0,
        actionId: "diantou",
        label: "diantou",
        duration: 3.0,
        voices: {"cn": {"subtitle": "你收听了塔罗占卜深夜电台？哦，我相信电台主持叫愚者一定是命运的巧合，侧面说明我们的缘分无处不在。", "sound": "sounds/vo_6004_xianliao_01.wav"}, "en": {"subtitle": "你收听了塔罗占卜深夜电台？哦，我相信电台主持叫愚者一定是命运的巧合，侧面说明我们的缘分无处不在。", "sound": "sounds/en_vo_6004_xianliao_01.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 600401013,
        audioId: 60040011,
        audioName: "vo_6004_xianliao_02",
        desc: "点击-闲聊2",
        group: "TapBody",
        index: 1,
        actionId: "lapai",
        label: "lapai",
        duration: 9.167,
        voices: {"cn": {"subtitle": "光是打牌太无聊了，我们来点新玩法怎么样，我们互相押上自己的一次承诺……有点风险，但绝对值得。", "sound": "sounds/vo_6004_xianliao_02.wav"}, "en": {"subtitle": "光是打牌太无聊了，我们来点新玩法怎么样，我们互相押上自己的一次承诺……有点风险，但绝对值得。", "sound": "sounds/en_vo_6004_xianliao_02.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 600401014,
        audioId: 60040012,
        audioName: "vo_6004_xianliao_03",
        desc: "点击-闲聊3",
        group: "TapBody",
        index: 8,
        actionId: "yaotou",
        label: "yaotou",
        duration: 3.0,
        voices: {"cn": {"subtitle": "抱歉，我不能告诉你彩票中奖号码。一蹴而就有什么意思呢，人类的辉光就在于他们努力改变命运的瞬间～", "sound": "sounds/vo_6004_xianliao_03.wav"}, "en": {"subtitle": "抱歉，我不能告诉你彩票中奖号码。一蹴而就有什么意思呢，人类的辉光就在于他们努力改变命运的瞬间～", "sound": "sounds/en_vo_6004_xianliao_03.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 600401015,
        audioId: 60040014,
        audioName: "vo_6004_zanyang",
        desc: "点击-赞扬1",
        group: "Idle",
        index: 0,
        actionId: "idle",
        label: "默认",
        duration: 6.0,
        voices: {"cn": {"subtitle": "不得不承认，你打破规则的样子，格外迷人。", "sound": "sounds/vo_6004_zanyang.wav"}, "en": {"subtitle": "不得不承认，你打破规则的样子，格外迷人。", "sound": "sounds/en_vo_6004_zanyang.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 600401016,
        audioId: 60040006,
        audioName: "vo_6004_dianchu_tou",
        desc: "点击-头",
        group: "TapBody",
        index: 8,
        actionId: "yaotou",
        label: "yaotou",
        duration: 3.0,
        voices: {"cn": {"subtitle": "除了还没发生的无聊未来，我的脑子里，全是在想会怎么死在你手里……或者，如何讨要一个比死亡更危险的吻。", "sound": "sounds/vo_6004_dianchu_tou.wav"}, "en": {"subtitle": "除了还没发生的无聊未来，我的脑子里，全是在想会怎么死在你手里……或者，如何讨要一个比死亡更危险的吻。", "sound": "sounds/en_vo_6004_dianchu_tou.wav"}},
        hitAreaParam: "HitAreaHead",
        hitAreas: ["HitAreaHead"],
        sourceType2: 401,
        sourceWeight: 20,
        weight: 20
      },
      {
        showId: 600401017,
        audioId: 60040007,
        audioName: "vo_6004_dianchu_shou",
        desc: "点击-手",
        group: "TapBody",
        index: 10,
        actionId: "zhanbu_1",
        label: "zhanbu_1",
        duration: 6.0,
        voices: {"cn": {"subtitle": "抓住一个赌徒的手，可就没法轻易放开了。你是想看我手里有什么，还是想我顺势把你拉下水？", "sound": "sounds/vo_6004_dianchu_shou.wav"}, "en": {"subtitle": "抓住一个赌徒的手，可就没法轻易放开了。你是想看我手里有什么，还是想我顺势把你拉下水？", "sound": "sounds/en_vo_6004_dianchu_shou.wav"}},
        hitAreaParam: "HitAreaHandL1#HitAreaHandL2#HitAreaHandR1#HitAreaHandR2",
        hitAreas: ["HitAreaHandL1", "HitAreaHandL2", "HitAreaHandR1", "HitAreaHandR2"],
        sourceType2: 401,
        sourceWeight: 20,
        weight: 20
      },
      {
        showId: 600401018,
        audioId: 60040008,
        audioName: "vo_6004_dianchu_shen",
        desc: "点击-胸",
        group: "Idle",
        index: 0,
        actionId: "idle",
        label: "默认",
        duration: 6.0,
        voices: {"cn": {"subtitle": "我还在想该怎么礼貌地越界，谢谢你给了我一个借口。既然这是你的邀请，那我就不克制了。", "sound": "sounds/vo_6004_dianchu_shen.wav"}, "en": {"subtitle": "我还在想该怎么礼貌地越界，谢谢你给了我一个借口。既然这是你的邀请，那我就不克制了。", "sound": "sounds/en_vo_6004_dianchu_shen.wav"}},
        hitAreaParam: "HitAreaBody",
        hitAreas: ["HitAreaBody"],
        sourceType2: 401,
        sourceWeight: 20,
        weight: 20
      }
    ]
  },
  {
    id: "101000_yz_cg",
    title: "牌局先知 一段",
    assetKind: "style",
    categoryLabel: "风格",
    modelDir: "101000_yz_cg",
    sourceModelDir: "101000_yz_cg",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "localassets_win32",
    styleId: "13001010",
    styleName: "牌局先知",
    stage: "一段",
    hitAreaNames: ["HitAreaquanbu", "HitAreagensui"],
    followConfigs: [{"id": 21017, "prefab": "101000_yz_cg", "activeName": "HitAreagensui", "expressionName": "", "damping": 0.0, "parameters": [{"parameterId": "ParamBodyAngleX3", "axis": "X", "factor": 2.0, "sourceToken": "ParamBodyAngleX3#2*X"}, {"parameterId": "ParamBodyAngleZ2", "axis": "X", "factor": 7.0, "sourceToken": "ParamBodyAngleZ2#7*X"}, {"parameterId": "Param103", "axis": "X", "factor": 20.0, "sourceToken": "Param103#20*X"}, {"parameterId": "Param105", "axis": "Y", "factor": 20.0, "sourceToken": "Param105#20*Y"}, {"parameterId": "ParamEyeBallX", "axis": "X", "factor": -8.0, "sourceToken": "ParamEyeBallX#-8*X"}, {"parameterId": "ParamEyeBallY", "axis": "Y", "factor": 70.0, "sourceToken": "ParamEyeBallY#70*Y"}, {"parameterId": "ParamAngleX", "axis": "X", "factor": 8.0, "sourceToken": "ParamAngleX#8*X"}, {"parameterId": "ParamAngleY", "axis": "Y", "factor": 20.0, "sourceToken": "ParamAngleY#20*Y"}, {"parameterId": "ParamAngleZ", "axis": "Y", "factor": -2.0, "sourceToken": "ParamAngleZ#-2*Y"}, {"parameterId": "ParamBodyAngleY", "axis": "X", "factor": -2.0, "sourceToken": "ParamBodyAngleY#-2*X"}]}],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 6.633 },
          { group: "Idle", index: 1, actionId: "idle1", label: "注视1", duration: 10.9 },
          { group: "Idle", index: 2, actionId: "idle2", label: "注视2", duration: 12.8 }
        ]
      },
      {
        label: "入场",
        actions: [
          { group: "Entry", index: 0, actionId: "ruchang", label: "入场", duration: 14.6 }
        ]
      }
    ],
    clickShowActions: [
      {
        showId: 61010008,
        audioId: 10100002,
        audioName: "vo_1010_yiduanchahua_01",
        desc: "点击1",
        group: "Idle",
        index: 1,
        actionId: "idle1",
        label: "注视1",
        duration: 10.9,
        voices: {"cn": {"subtitle": "你好像对我的占有欲没有概念，没关系……我会用行动告诉你。", "sound": "sounds/vo_1010_yiduanchahua_01.wav"}, "en": {"subtitle": "你好像对我的占有欲没有概念，没关系……我会用行动告诉你。", "sound": "sounds/en_vo_1010_yiduanchahua_01.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 20,
        weight: 20
      },
      {
        showId: 61010009,
        audioId: 10100003,
        audioName: "vo_1010_yiduanchahua_02",
        desc: "点击2",
        group: "Idle",
        index: 2,
        actionId: "idle2",
        label: "注视2",
        duration: 12.8,
        voices: {"cn": {"subtitle": "把欲望的果实交给我，或者自己品尝这禁忌的滋味？选择，总在你手里。", "sound": "sounds/vo_1010_yiduanchahua_02.wav"}, "en": {"subtitle": "把欲望的果实交给我，或者自己品尝这禁忌的滋味？选择，总在你手里。", "sound": "sounds/en_vo_1010_yiduanchahua_02.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 20,
        weight: 20
      },
      {
        showId: 61010010,
        audioId: 60040004,
        audioName: "vo_6004_daiji_01",
        desc: "点击-通用1",
        group: "Idle",
        index: 2,
        actionId: "idle2",
        label: "注视2",
        duration: 12.8,
        voices: {"cn": {"subtitle": "不觉得那些禁止的事项就是用来打破的吗？越是禁忌，破坏时就越迷人。", "sound": "sounds/vo_6004_daiji_01.wav"}, "en": {"subtitle": "不觉得那些禁止的事项就是用来打破的吗？越是禁忌，破坏时就越迷人。", "sound": "sounds/en_vo_6004_daiji_01.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 10,
        weight: 10
      },
      {
        showId: 61010011,
        audioId: 60040005,
        audioName: "vo_6004_daiji_02",
        desc: "点击-通用2",
        group: "Idle",
        index: 1,
        actionId: "idle1",
        label: "注视1",
        duration: 10.9,
        voices: {"cn": {"subtitle": "我对本不该知道秘密的人告了密。你说，这点微不足道的差错，最后会不会演变成一场波及世界的灾难？", "sound": "sounds/vo_6004_daiji_02.wav"}, "en": {"subtitle": "我对本不该知道秘密的人告了密。你说，这点微不足道的差错，最后会不会演变成一场波及世界的灾难？", "sound": "sounds/en_vo_6004_daiji_02.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 10,
        weight: 10
      },
      {
        showId: 61010012,
        audioId: 60040014,
        audioName: "vo_6004_zanyang",
        desc: "点击-赞扬1",
        group: "Idle",
        index: 2,
        actionId: "idle2",
        label: "注视2",
        duration: 12.8,
        voices: {"cn": {"subtitle": "不得不承认，你打破规则的样子，格外迷人。", "sound": "sounds/vo_6004_zanyang.wav"}, "en": {"subtitle": "不得不承认，你打破规则的样子，格外迷人。", "sound": "sounds/en_vo_6004_zanyang.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 10,
        weight: 10
      }
    ]
  },
  {
    id: "101001_yz_cg",
    title: "牌局先知 二段",
    assetKind: "style",
    categoryLabel: "风格",
    modelDir: "101001_yz_cg",
    sourceModelDir: "101001_yz_cg",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "localassets_win32",
    styleId: "13001010",
    styleName: "牌局先知",
    stage: "二段",
    hitAreaNames: ["HitAreaMoren", "HitAreagensui"],
    followConfigs: [{"id": 21007, "prefab": "101001_yz_cg", "activeName": "HitAreagensui", "expressionName": "", "damping": 0.0, "parameters": [{"parameterId": "Param6", "axis": "X", "factor": -4.0, "sourceToken": "Param6#-4*X"}, {"parameterId": "Param3", "axis": "X", "factor": 8.0, "sourceToken": "Param3#8*X"}, {"parameterId": "Param4", "axis": "X", "factor": -19.0, "sourceToken": "Param4#-19*X"}, {"parameterId": "Param5", "axis": "X", "factor": 19.0, "sourceToken": "Param5#19*X"}, {"parameterId": "Param29", "axis": "X", "factor": 19.0, "sourceToken": "Param29#19*X"}, {"parameterId": "Param7", "axis": "X", "factor": 8.0, "sourceToken": "Param7#8*X"}, {"parameterId": "ParamarmL2", "axis": "X", "factor": 8.0, "sourceToken": "ParamarmL2#8*X"}, {"parameterId": "ParamarmL", "axis": "X", "factor": -8.0, "sourceToken": "ParamarmL#-8*X"}]}],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [],
    storyTouchActions: [],
    unlockableMotions: [
      { group: "TapBody", index: 0, actionId: "dongzuo1", label: "亲近1", duration: 12.467 },
      { group: "TapBody", index: 1, actionId: "dongzuo2", label: "亲近2", duration: 11.967 },
      { group: "TapBody", index: 2, actionId: "dongzuo3", label: "亲近3", duration: 11.467 }
    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 9.967 },
          { group: "Idle", index: 1, actionId: "idle1", label: "注视1", duration: 6.967 },
          { group: "Idle", index: 2, actionId: "idle2", label: "注视2", duration: 9.967 }
        ]
      },
      {
        label: "TapBody",
        actions: [
          { group: "TapBody", index: 0, actionId: "dongzuo1", label: "亲近1", duration: 12.467 },
          { group: "TapBody", index: 1, actionId: "dongzuo2", label: "亲近2", duration: 11.967 },
          { group: "TapBody", index: 2, actionId: "dongzuo3", label: "亲近3", duration: 11.467 },
          { group: "TapBody", index: 3, actionId: "loop", label: "loop", duration: 9.967 }
        ]
      },
      {
        label: "入场",
        actions: [
          { group: "Entry", index: 0, actionId: "ruchang", label: "入场", duration: 13.367 }
        ]
      }
    ],
    clickShowActions: [
      {
        showId: 61010055,
        audioId: 10100006,
        audioName: "vo_1010_erduanchahua_01",
        desc: "点击3",
        group: "TapBody",
        index: 0,
        actionId: "dongzuo1",
        label: "亲近1",
        duration: 12.467,
        voices: {"cn": {"subtitle": "你喜欢这种玩法吗？我也喜欢，看来我们对情趣的理解也同样合拍。", "sound": "sounds/vo_1010_erduanchahua_01.wav"}, "en": {"subtitle": "你喜欢这种玩法吗？我也喜欢，看来我们对情趣的理解也同样合拍。", "sound": "sounds/en_vo_1010_erduanchahua_01.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 20,
        weight: 20
      },
      {
        showId: 61010056,
        audioId: 10100007,
        audioName: "vo_1010_erduanchahua_02",
        desc: "点击4",
        group: "TapBody",
        index: 1,
        actionId: "dongzuo2",
        label: "亲近2",
        duration: 11.967,
        voices: {"cn": {"subtitle": "真是意想不到……这种拙劣的圈套，我竟然也舍不得拆穿。", "sound": "sounds/vo_1010_erduanchahua_02.wav"}, "en": {"subtitle": "真是意想不到……这种拙劣的圈套，我竟然也舍不得拆穿。", "sound": "sounds/en_vo_1010_erduanchahua_02.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 20,
        weight: 20
      },
      {
        showId: 61010057,
        audioId: 10100008,
        audioName: "vo_1010_erduanchahua_03",
        desc: "点击5",
        group: "TapBody",
        index: 2,
        actionId: "dongzuo3",
        label: "亲近3",
        duration: 11.467,
        voices: {"cn": {"subtitle": "这种意外发生的概率只有0.1%……看来为了让我们贴得更近，连命运都忍不住下场了。", "sound": "sounds/vo_1010_erduanchahua_03.wav"}, "en": {"subtitle": "这种意外发生的概率只有0.1%……看来为了让我们贴得更近，连命运都忍不住下场了。", "sound": "sounds/en_vo_1010_erduanchahua_03.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 20,
        weight: 20
      },
      {
        showId: 61010061,
        audioId: 10100009,
        audioName: "vo_1010_erduanchahua_04",
        desc: "点击1",
        group: "Idle",
        index: 1,
        actionId: "idle1",
        label: "注视1",
        duration: 6.967,
        voices: {"cn": {"subtitle": "真希望我们的心也能靠得这么近……这样我的死亡之日就可以快点到来了。你也很期待，不是吗？", "sound": "sounds/vo_1010_erduanchahua_04.wav"}, "en": {"subtitle": "真希望我们的心也能靠得这么近……这样我的死亡之日就可以快点到来了。你也很期待，不是吗？", "sound": "sounds/en_vo_1010_erduanchahua_04.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 10,
        weight: 10
      },
      {
        showId: 61010062,
        audioId: 10100010,
        audioName: "vo_1010_erduanchahua_05",
        desc: "点击2",
        group: "Idle",
        index: 2,
        actionId: "idle2",
        label: "注视2",
        duration: 9.967,
        voices: {"cn": {"subtitle": "你又要离开了吗？那我只好抓住你了。哦……你在笑，看来是你抓住我了。", "sound": "sounds/vo_1010_erduanchahua_05.wav"}, "en": {"subtitle": "你又要离开了吗？那我只好抓住你了。哦……你在笑，看来是你抓住我了。", "sound": "sounds/en_vo_1010_erduanchahua_05.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 10,
        weight: 10
      },
      {
        showId: 61010063,
        audioId: 60040004,
        audioName: "vo_6004_daiji_01",
        desc: "点击-通用1",
        group: "Idle",
        index: 1,
        actionId: "idle1",
        label: "注视1",
        duration: 6.967,
        voices: {"cn": {"subtitle": "不觉得那些禁止的事项就是用来打破的吗？越是禁忌，破坏时就越迷人。", "sound": "sounds/vo_6004_daiji_01.wav"}, "en": {"subtitle": "不觉得那些禁止的事项就是用来打破的吗？越是禁忌，破坏时就越迷人。", "sound": "sounds/en_vo_6004_daiji_01.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 61010064,
        audioId: 60040005,
        audioName: "vo_6004_daiji_02",
        desc: "点击-通用2",
        group: "Idle",
        index: 2,
        actionId: "idle2",
        label: "注视2",
        duration: 9.967,
        voices: {"cn": {"subtitle": "我对本不该知道秘密的人告了密。你说，这点微不足道的差错，最后会不会演变成一场波及世界的灾难？", "sound": "sounds/vo_6004_daiji_02.wav"}, "en": {"subtitle": "我对本不该知道秘密的人告了密。你说，这点微不足道的差错，最后会不会演变成一场波及世界的灾难？", "sound": "sounds/en_vo_6004_daiji_02.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 61010065,
        audioId: 60040014,
        audioName: "vo_6004_zanyang",
        desc: "点击-赞扬1",
        group: "Idle",
        index: 2,
        actionId: "idle2",
        label: "注视2",
        duration: 9.967,
        voices: {"cn": {"subtitle": "不得不承认，你打破规则的样子，格外迷人。", "sound": "sounds/vo_6004_zanyang.wav"}, "en": {"subtitle": "不得不承认，你打破规则的样子，格外迷人。", "sound": "sounds/en_vo_6004_zanyang.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      }
    ]
  },
  {
    id: "101001_yz_cg__streamingassets",
    title: "牌局先知 二段",
    assetKind: "style",
    categoryLabel: "风格",
    modelDir: "101001_yz_cg__streamingassets",
    sourceModelDir: "101001_yz_cg",
    variantKey: "streamingassets",
    variantLabel: "旧版 streamingassets",
    variantSourceLayer: "streamingassets",
    styleId: "13001010",
    styleName: "牌局先知",
    stage: "二段",
    hitAreaNames: ["HitAreagensui", "HitAreaquanbu"],
    followConfigs: [{"id": 21007, "prefab": "101001_yz_cg", "activeName": "HitAreagensui", "expressionName": "", "damping": 0.0, "parameters": [{"parameterId": "Param6", "axis": "X", "factor": -4.0, "sourceToken": "Param6#-4*X"}, {"parameterId": "Param3", "axis": "X", "factor": 8.0, "sourceToken": "Param3#8*X"}, {"parameterId": "Param4", "axis": "X", "factor": -19.0, "sourceToken": "Param4#-19*X"}, {"parameterId": "Param5", "axis": "X", "factor": 19.0, "sourceToken": "Param5#19*X"}, {"parameterId": "Param29", "axis": "X", "factor": 19.0, "sourceToken": "Param29#19*X"}, {"parameterId": "Param7", "axis": "X", "factor": 8.0, "sourceToken": "Param7#8*X"}, {"parameterId": "ParamarmL2", "axis": "X", "factor": 8.0, "sourceToken": "ParamarmL2#8*X"}, {"parameterId": "ParamarmL", "axis": "X", "factor": -8.0, "sourceToken": "ParamarmL#-8*X"}]}],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [],
    storyTouchActions: [],
    unlockableMotions: [
      { group: "TapBody", index: 0, actionId: "dongzuo1", label: "亲近1", duration: 9.7 },
      { group: "TapBody", index: 1, actionId: "dongzuo2", label: "亲近2", duration: 10.633 },
      { group: "TapBody", index: 2, actionId: "dongzuo3", label: "亲近3", duration: 14.9 }
    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 6.633 },
          { group: "Idle", index: 1, actionId: "idle1", label: "注视1", duration: 8.0 },
          { group: "Idle", index: 2, actionId: "idle2", label: "注视2", duration: 13.333 }
        ]
      },
      {
        label: "TapBody",
        actions: [
          { group: "TapBody", index: 0, actionId: "dongzuo1", label: "亲近1", duration: 9.7 },
          { group: "TapBody", index: 1, actionId: "dongzuo2", label: "亲近2", duration: 10.633 },
          { group: "TapBody", index: 2, actionId: "dongzuo3", label: "亲近3", duration: 14.9 }
        ]
      },
      {
        label: "入场",
        actions: [
          { group: "Entry", index: 0, actionId: "ruchang", label: "入场", duration: 16.4 }
        ]
      }
    ],
    clickShowActions: [
      {
        showId: 61010055,
        audioId: 10100006,
        audioName: "vo_1010_erduanchahua_01",
        desc: "点击3",
        group: "TapBody",
        index: 0,
        actionId: "dongzuo1",
        label: "亲近1",
        duration: 9.7,
        voices: {"cn": {"subtitle": "你喜欢这种玩法吗？我也喜欢，看来我们对情趣的理解也同样合拍。", "sound": "sounds/vo_1010_erduanchahua_01.wav"}, "en": {"subtitle": "你喜欢这种玩法吗？我也喜欢，看来我们对情趣的理解也同样合拍。", "sound": "sounds/en_vo_1010_erduanchahua_01.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 20,
        weight: 20
      },
      {
        showId: 61010056,
        audioId: 10100007,
        audioName: "vo_1010_erduanchahua_02",
        desc: "点击4",
        group: "TapBody",
        index: 1,
        actionId: "dongzuo2",
        label: "亲近2",
        duration: 10.633,
        voices: {"cn": {"subtitle": "真是意想不到……这种拙劣的圈套，我竟然也舍不得拆穿。", "sound": "sounds/vo_1010_erduanchahua_02.wav"}, "en": {"subtitle": "真是意想不到……这种拙劣的圈套，我竟然也舍不得拆穿。", "sound": "sounds/en_vo_1010_erduanchahua_02.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 20,
        weight: 20
      },
      {
        showId: 61010057,
        audioId: 10100008,
        audioName: "vo_1010_erduanchahua_03",
        desc: "点击5",
        group: "TapBody",
        index: 2,
        actionId: "dongzuo3",
        label: "亲近3",
        duration: 14.9,
        voices: {"cn": {"subtitle": "这种意外发生的概率只有0.1%……看来为了让我们贴得更近，连命运都忍不住下场了。", "sound": "sounds/vo_1010_erduanchahua_03.wav"}, "en": {"subtitle": "这种意外发生的概率只有0.1%……看来为了让我们贴得更近，连命运都忍不住下场了。", "sound": "sounds/en_vo_1010_erduanchahua_03.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 20,
        weight: 20
      },
      {
        showId: 61010061,
        audioId: 10100009,
        audioName: "vo_1010_erduanchahua_04",
        desc: "点击1",
        group: "Idle",
        index: 1,
        actionId: "idle1",
        label: "注视1",
        duration: 8.0,
        voices: {"cn": {"subtitle": "真希望我们的心也能靠得这么近……这样我的死亡之日就可以快点到来了。你也很期待，不是吗？", "sound": "sounds/vo_1010_erduanchahua_04.wav"}, "en": {"subtitle": "真希望我们的心也能靠得这么近……这样我的死亡之日就可以快点到来了。你也很期待，不是吗？", "sound": "sounds/en_vo_1010_erduanchahua_04.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 10,
        weight: 10
      },
      {
        showId: 61010062,
        audioId: 10100010,
        audioName: "vo_1010_erduanchahua_05",
        desc: "点击2",
        group: "Idle",
        index: 2,
        actionId: "idle2",
        label: "注视2",
        duration: 13.333,
        voices: {"cn": {"subtitle": "你又要离开了吗？那我只好抓住你了。哦……你在笑，看来是你抓住我了。", "sound": "sounds/vo_1010_erduanchahua_05.wav"}, "en": {"subtitle": "你又要离开了吗？那我只好抓住你了。哦……你在笑，看来是你抓住我了。", "sound": "sounds/en_vo_1010_erduanchahua_05.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 10,
        weight: 10
      },
      {
        showId: 61010063,
        audioId: 60040004,
        audioName: "vo_6004_daiji_01",
        desc: "点击-通用1",
        group: "Idle",
        index: 1,
        actionId: "idle1",
        label: "注视1",
        duration: 8.0,
        voices: {"cn": {"subtitle": "不觉得那些禁止的事项就是用来打破的吗？越是禁忌，破坏时就越迷人。", "sound": "sounds/vo_6004_daiji_01.wav"}, "en": {"subtitle": "不觉得那些禁止的事项就是用来打破的吗？越是禁忌，破坏时就越迷人。", "sound": "sounds/en_vo_6004_daiji_01.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 61010064,
        audioId: 60040005,
        audioName: "vo_6004_daiji_02",
        desc: "点击-通用2",
        group: "Idle",
        index: 2,
        actionId: "idle2",
        label: "注视2",
        duration: 13.333,
        voices: {"cn": {"subtitle": "我对本不该知道秘密的人告了密。你说，这点微不足道的差错，最后会不会演变成一场波及世界的灾难？", "sound": "sounds/vo_6004_daiji_02.wav"}, "en": {"subtitle": "我对本不该知道秘密的人告了密。你说，这点微不足道的差错，最后会不会演变成一场波及世界的灾难？", "sound": "sounds/en_vo_6004_daiji_02.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 61010065,
        audioId: 60040014,
        audioName: "vo_6004_zanyang",
        desc: "点击-赞扬1",
        group: "Idle",
        index: 2,
        actionId: "idle2",
        label: "注视2",
        duration: 13.333,
        voices: {"cn": {"subtitle": "不得不承认，你打破规则的样子，格外迷人。", "sound": "sounds/vo_6004_zanyang.wav"}, "en": {"subtitle": "不得不承认，你打破规则的样子，格外迷人。", "sound": "sounds/en_vo_6004_zanyang.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      }
    ]
  },
  {
    id: "101100_xdr",
    title: "小大人 角色立绘",
    assetKind: "character",
    categoryLabel: "角色",
    modelDir: "101100_xdr",
    sourceModelDir: "101100_xdr",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "localassets_win32",
    styleId: "",
    styleName: "小大人",
    stage: "角色立绘",
    hitAreaNames: ["HitAreaMoren", "HitAreaBody", "HitAreaHandL", "HitAreaHandR", "HitAreaHead"],
    followConfigs: [{"id": 1003, "prefab": "101100_xdr", "activeName": "", "expressionName": "", "damping": 0.0, "parameters": [{"parameterId": "ParamAngleX", "axis": "X", "factor": 50.0, "sourceToken": "ParamAngleX#50*X"}, {"parameterId": "ParamAngleY", "axis": "Y", "factor": 70.0, "sourceToken": "ParamAngleY#70*Y"}, {"parameterId": "ParamEyeBallX", "axis": "X", "factor": 30.0, "sourceToken": "ParamEyeBallX#30*X"}, {"parameterId": "ParamEyeBallY", "axis": "Y", "factor": 30.0, "sourceToken": "ParamEyeBallY#30*Y"}, {"parameterId": "ParamBodyAngleX", "axis": "X", "factor": 30.0, "sourceToken": "ParamBodyAngleX#30*X"}, {"parameterId": "ParamBodyMae", "axis": "Y", "factor": -20.0, "sourceToken": "ParamBodyMae#-20*Y"}]}],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 6.0 }
        ]
      },
      {
        label: "TapBody",
        actions: [
          { group: "TapBody", index: 0, actionId: "chayao", label: "chayao", duration: 4.0 },
          { group: "TapBody", index: 1, actionId: "diantou", label: "diantou", duration: 2.571 },
          { group: "TapBody", index: 2, actionId: "dingmaozi", label: "dingmaozi", duration: 2.812 },
          { group: "TapBody", index: 3, actionId: "houyang", label: "houyang", duration: 2.571 },
          { group: "TapBody", index: 4, actionId: "kaixin", label: "kaixin", duration: 3.0 },
          { group: "TapBody", index: 5, actionId: "kuqi", label: "kuqi", duration: 7.0 },
          { group: "TapBody", index: 6, actionId: "qianqing", label: "qianqing", duration: 3.429 },
          { group: "TapBody", index: 7, actionId: "qianqing_1", label: "qianqing_1", duration: 3.429 },
          { group: "TapBody", index: 8, actionId: "waitou", label: "waitou", duration: 2.812 },
          { group: "TapBody", index: 9, actionId: "walk", label: "walk", duration: 1.714 },
          { group: "TapBody", index: 10, actionId: "yaotou", label: "yaotou", duration: 2.0 }
        ]
      }
    ],
    clickShowActions: [
      {
        showId: 601001010,
        audioId: 60100004,
        audioName: "vo_6010_daiji_01",
        desc: "点击-通用1",
        group: "TapBody",
        index: 0,
        actionId: "chayao",
        label: "chayao",
        duration: 4.0,
        voices: {"cn": {"subtitle": "邻居家的大狗冲着我叫，我挺起胸膛一瞪眼，它就缩回去了，这就是大人的气场！", "sound": "sounds/vo_6010_daiji_01.wav"}, "en": {"subtitle": "邻居家的大狗冲着我叫，我挺起胸膛一瞪眼，它就缩回去了，这就是大人的气场！", "sound": "sounds/en_vo_6010_daiji_01.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 601001011,
        audioId: 60100005,
        audioName: "vo_6010_daiji_02",
        desc: "点击-通用2",
        group: "TapBody",
        index: 2,
        actionId: "dingmaozi",
        label: "dingmaozi",
        duration: 2.812,
        voices: {"cn": {"subtitle": "人家都说梦见牙齿掉了会长大，可我梦见的是西装扣子掉了，这算什么预兆啊？", "sound": "sounds/vo_6010_daiji_02.wav"}, "en": {"subtitle": "人家都说梦见牙齿掉了会长大，可我梦见的是西装扣子掉了，这算什么预兆啊？", "sound": "sounds/en_vo_6010_daiji_02.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 601001012,
        audioId: 60100010,
        audioName: "vo_6010_xianliao_01",
        desc: "点击-闲聊1",
        group: "TapBody",
        index: 0,
        actionId: "chayao",
        label: "chayao",
        duration: 4.0,
        voices: {"cn": {"subtitle": "你要自己出门？等等我，作为成熟的大人，我得拿上水枪保护你。", "sound": "sounds/vo_6010_xianliao_01.wav"}, "en": {"subtitle": "你要自己出门？等等我，作为成熟的大人，我得拿上水枪保护你。", "sound": "sounds/en_vo_6010_xianliao_01.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 601001013,
        audioId: 60100011,
        audioName: "vo_6010_xianliao_02",
        desc: "点击-闲聊2",
        group: "TapBody",
        index: 7,
        actionId: "qianqing_1",
        label: "qianqing_1",
        duration: 3.429,
        voices: {"cn": {"subtitle": "BOSS快看，这次家族考试我进步了五名！等家族成员知道了我的厉害，就不会再喊我“小朋友”，而是叫我“先生”了。", "sound": "sounds/vo_6010_xianliao_02.wav"}, "en": {"subtitle": "BOSS快看，这次家族考试我进步了五名！等家族成员知道了我的厉害，就不会再喊我“小朋友”，而是叫我“先生”了。", "sound": "sounds/en_vo_6010_xianliao_02.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 601001014,
        audioId: 60100012,
        audioName: "vo_6010_xianliao_03",
        desc: "点击-闲聊3",
        group: "TapBody",
        index: 2,
        actionId: "dingmaozi",
        label: "dingmaozi",
        duration: 2.812,
        voices: {"cn": {"subtitle": "某某人好像是这样压帽子的，看起来会更酷？唔……！BOSS你什么都没看到。", "sound": "sounds/vo_6010_xianliao_03.wav"}, "en": {"subtitle": "某某人好像是这样压帽子的，看起来会更酷？唔……！BOSS你什么都没看到。", "sound": "sounds/en_vo_6010_xianliao_03.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 601001015,
        audioId: 60100014,
        audioName: "vo_6010_zanyang",
        desc: "点击-赞扬1",
        group: "TapBody",
        index: 1,
        actionId: "diantou",
        label: "diantou",
        duration: 2.571,
        voices: {"cn": {"subtitle": "BOSS为了家族那么努力，我也不会输！我可是值得信赖的大人。", "sound": "sounds/vo_6010_zanyang.wav"}, "en": {"subtitle": "BOSS为了家族那么努力，我也不会输！我可是值得信赖的大人。", "sound": "sounds/en_vo_6010_zanyang.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 601001016,
        audioId: 60100006,
        audioName: "vo_6010_dianchu_tou",
        desc: "点击-头",
        group: "TapBody",
        index: 0,
        actionId: "chayao",
        label: "chayao",
        duration: 4.0,
        voices: {"cn": {"subtitle": "我在练习“锐利的眼神”，唔——怎么样？是不是很吓人！", "sound": "sounds/vo_6010_dianchu_tou.wav"}, "en": {"subtitle": "我在练习“锐利的眼神”，唔——怎么样？是不是很吓人！", "sound": "sounds/en_vo_6010_dianchu_tou.wav"}},
        hitAreaParam: "HitAreaHead",
        hitAreas: ["HitAreaHead"],
        sourceType2: 401,
        sourceWeight: 20,
        weight: 20
      },
      {
        showId: 601001017,
        audioId: 60100007,
        audioName: "vo_6010_dianchu_shou",
        desc: "点击-手",
        group: "TapBody",
        index: 7,
        actionId: "qianqing_1",
        label: "qianqing_1",
        duration: 3.429,
        voices: {"cn": {"subtitle": "你的手比我大这么多啊……不过没关系，将来我一定会长大到能握住你的手！", "sound": "sounds/vo_6010_dianchu_shou.wav"}, "en": {"subtitle": "你的手比我大这么多啊……不过没关系，将来我一定会长大到能握住你的手！", "sound": "sounds/en_vo_6010_dianchu_shou.wav"}},
        hitAreaParam: "HitAreaHandL#HitAreaHandR",
        hitAreas: ["HitAreaHandL", "HitAreaHandR"],
        sourceType2: 401,
        sourceWeight: 20,
        weight: 20
      },
      {
        showId: 601001018,
        audioId: 60100008,
        audioName: "vo_6010_dianchu_shen",
        desc: "点击-胸",
        group: "Idle",
        index: 0,
        actionId: "idle",
        label: "默认",
        duration: 6.0,
        voices: {"cn": {"subtitle": "你说我这样双手抱胸站着，是不是很有威严？啊……看起来像生闷气？", "sound": "sounds/vo_6010_dianchu_shen.wav"}, "en": {"subtitle": "你说我这样双手抱胸站着，是不是很有威严？啊……看起来像生闷气？", "sound": "sounds/en_vo_6010_dianchu_shen.wav"}},
        hitAreaParam: "HitAreaBody",
        hitAreas: ["HitAreaBody"],
        sourceType2: 401,
        sourceWeight: 20,
        weight: 20
      }
    ]
  },
  {
    id: "101200_bj",
    title: "暴君 角色立绘",
    assetKind: "character",
    categoryLabel: "角色",
    modelDir: "101200_bj",
    sourceModelDir: "101200_bj",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "localassets_win32",
    styleId: "",
    styleName: "暴君",
    stage: "角色立绘",
    hitAreaNames: ["HitAreaBody", "HitAreaMoren", "HitAreaHandL", "HitAreaHead", "HitAreaHandR"],
    followConfigs: [{"id": 1018, "prefab": "101200_bj", "activeName": "", "expressionName": "", "damping": 0.0, "parameters": [{"parameterId": "ParamAngleX", "axis": "X", "factor": 30.0, "sourceToken": "ParamAngleX#30*X"}, {"parameterId": "ParamAngleY", "axis": "Y", "factor": 30.0, "sourceToken": "ParamAngleY#30*Y"}, {"parameterId": "ParamEyeBallX", "axis": "X", "factor": 70.0, "sourceToken": "ParamEyeBallX#70*X"}, {"parameterId": "ParamEyeBallY", "axis": "Y", "factor": 30.0, "sourceToken": "ParamEyeBallY#30*Y"}, {"parameterId": "ParamBodyAngleX", "axis": "X", "factor": 30.0, "sourceToken": "ParamBodyAngleX#30*X"}, {"parameterId": "ParamBodyMae", "axis": "Y", "factor": -10.0, "sourceToken": "ParamBodyMae#-10*Y"}]}],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 6.0 }
        ]
      },
      {
        label: "TapBody",
        actions: [
          { group: "TapBody", index: 0, actionId: "diantou", label: "diantou", duration: 3.0 },
          { group: "TapBody", index: 1, actionId: "houyang", label: "houyang", duration: 3.0 },
          { group: "TapBody", index: 2, actionId: "qianqing", label: "qianqing", duration: 4.0 },
          { group: "TapBody", index: 3, actionId: "qianqing_1", label: "qianqing_1", duration: 4.0 },
          { group: "TapBody", index: 4, actionId: "songjian", label: "songjian", duration: 3.0 },
          { group: "TapBody", index: 5, actionId: "waitou", label: "waitou", duration: 4.0 },
          { group: "TapBody", index: 6, actionId: "waitou_1", label: "waitou_1", duration: 4.0 },
          { group: "TapBody", index: 7, actionId: "walk", label: "walk", duration: 2.0 },
          { group: "TapBody", index: 8, actionId: "yaotou", label: "yaotou", duration: 3.0 },
          { group: "TapBody", index: 9, actionId: "zidan", label: "zidan", duration: 6.0 }
        ]
      }
    ],
    clickShowActions: [
      {
        showId: 601301010,
        audioId: 60130004,
        audioName: "vo_6013_daiji_01",
        desc: "点击-通用1",
        group: "TapBody",
        index: 3,
        actionId: "qianqing_1",
        label: "qianqing_1",
        duration: 4.0,
        voices: {"cn": {"subtitle": "我心情好是因为灭了一个敌方据点？原来在你印象中我是这种人。", "sound": "sounds/vo_6013_daiji_01.wav"}, "en": {"subtitle": "我心情好是因为灭了一个敌方据点？原来在你印象中我是这种人。", "sound": "sounds/en_vo_6013_daiji_01.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 601301011,
        audioId: 60130005,
        audioName: "vo_6013_daiji_02",
        desc: "点击-通用2",
        group: "TapBody",
        index: 9,
        actionId: "zidan",
        label: "zidan",
        duration: 6.0,
        voices: {"cn": {"subtitle": "今天风向变了，有些不安分的势力可能又想闹事。我等着他们犯错。", "sound": "sounds/vo_6013_daiji_02.wav"}, "en": {"subtitle": "今天风向变了，有些不安分的势力可能又想闹事。我等着他们犯错。", "sound": "sounds/en_vo_6013_daiji_02.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 601301012,
        audioId: 60130010,
        audioName: "vo_6013_xianliao_01",
        desc: "点击-闲聊1",
        group: "TapBody",
        index: 4,
        actionId: "songjian",
        label: "songjian",
        duration: 3.0,
        voices: {"cn": {"subtitle": "我知道外面的人是怎么说泰拉的。人们忌惮它、回避它，这意味着他们不敢轻易伤害它。这样最好。", "sound": "sounds/vo_6013_xianliao_01.wav"}, "en": {"subtitle": "我知道外面的人是怎么说泰拉的。人们忌惮它、回避它，这意味着他们不敢轻易伤害它。这样最好。", "sound": "sounds/en_vo_6013_xianliao_01.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 601301013,
        audioId: 60130011,
        audioName: "vo_6013_xianliao_02",
        desc: "点击-闲聊2",
        group: "TapBody",
        index: 6,
        actionId: "waitou_1",
        label: "waitou_1",
        duration: 4.0,
        voices: {"cn": {"subtitle": "一起去上城区？不给我个兜帽吗，如果你想传出德弗兰公爵和泰拉首领勾结的大新闻，我无所谓。", "sound": "sounds/vo_6013_xianliao_02.wav"}, "en": {"subtitle": "一起去上城区？不给我个兜帽吗，如果你想传出德弗兰公爵和泰拉首领勾结的大新闻，我无所谓。", "sound": "sounds/en_vo_6013_xianliao_02.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 601301014,
        audioId: 60130012,
        audioName: "vo_6013_xianliao_03",
        desc: "点击-闲聊3",
        group: "Idle",
        index: 0,
        actionId: "idle",
        label: "默认",
        duration: 6.0,
        voices: {"cn": {"subtitle": "下城区有自己的热闹，也有很多值得一试的东西。我知道有个小摊的炖菜不错，一起？", "sound": "sounds/vo_6013_xianliao_03.wav"}, "en": {"subtitle": "下城区有自己的热闹，也有很多值得一试的东西。我知道有个小摊的炖菜不错，一起？", "sound": "sounds/en_vo_6013_xianliao_03.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 601301015,
        audioId: 60130014,
        audioName: "vo_6013_zanyang",
        desc: "点击-赞扬1",
        group: "TapBody",
        index: 6,
        actionId: "waitou_1",
        label: "waitou_1",
        duration: 4.0,
        voices: {"cn": {"subtitle": "你比我想象中更适合当统治者。你若生在地下城，倒是能博一个和“暴君”并肩的名号。", "sound": "sounds/vo_6013_zanyang.wav"}, "en": {"subtitle": "你比我想象中更适合当统治者。你若生在地下城，倒是能博一个和“暴君”并肩的名号。", "sound": "sounds/en_vo_6013_zanyang.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 601301016,
        audioId: 60130006,
        audioName: "vo_6013_dianchu_tou",
        desc: "点击-头",
        group: "TapBody",
        index: 9,
        actionId: "zidan",
        label: "zidan",
        duration: 6.0,
        voices: {"cn": {"subtitle": "很多人想买我的头，可惜没人付得起那个价。", "sound": "sounds/vo_6013_dianchu_tou.wav"}, "en": {"subtitle": "很多人想买我的头，可惜没人付得起那个价。", "sound": "sounds/en_vo_6013_dianchu_tou.wav"}},
        hitAreaParam: "HitAreaHead",
        hitAreas: ["HitAreaHead"],
        sourceType2: 401,
        sourceWeight: 20,
        weight: 20
      },
      {
        showId: 601301017,
        audioId: 60130007,
        audioName: "vo_6013_dianchu_shou",
        desc: "点击-手",
        group: "Idle",
        index: 0,
        actionId: "idle",
        label: "默认",
        duration: 6.0,
        voices: {"cn": {"subtitle": "伸手做什么？你要的东西，我可不会免费给。除非……", "sound": "sounds/vo_6013_dianchu_shou.wav"}, "en": {"subtitle": "伸手做什么？你要的东西，我可不会免费给。除非……", "sound": "sounds/en_vo_6013_dianchu_shou.wav"}},
        hitAreaParam: "HitAreaHandL#HitAreaHandR",
        hitAreas: ["HitAreaHandL", "HitAreaHandR"],
        sourceType2: 401,
        sourceWeight: 20,
        weight: 20
      },
      {
        showId: 601301018,
        audioId: 60130008,
        audioName: "vo_6013_dianchu_shen",
        desc: "点击-胸",
        group: "TapBody",
        index: 3,
        actionId: "qianqing_1",
        label: "qianqing_1",
        duration: 4.0,
        voices: {"cn": {"subtitle": "偷袭？被我抓到了，可没有好果子吃。", "sound": "sounds/vo_6013_dianchu_shen.wav"}, "en": {"subtitle": "偷袭？被我抓到了，可没有好果子吃。", "sound": "sounds/en_vo_6013_dianchu_shen.wav"}},
        hitAreaParam: "HitAreaBody",
        hitAreas: ["HitAreaBody"],
        sourceType2: 401,
        sourceWeight: 20,
        weight: 20
      }
    ]
  },
  {
    id: "101200_bj_cg",
    title: "泰拉之主 一段",
    assetKind: "style",
    categoryLabel: "风格",
    modelDir: "101200_bj_cg",
    sourceModelDir: "101200_bj_cg",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "streamingassets",
    styleId: "13001012",
    styleName: "泰拉之主",
    stage: "一段",
    hitAreaNames: ["HitAreaMoren"],
    followConfigs: [{"id": 21013, "prefab": "101200_bj_cg", "activeName": "", "expressionName": "", "damping": 0.0, "parameters": [{"parameterId": "ParamAngleX", "axis": "X", "factor": 30.0, "sourceToken": "ParamAngleX#30*X"}, {"parameterId": "ParamAngleY", "axis": "Y", "factor": 40.0, "sourceToken": "ParamAngleY#40*Y"}, {"parameterId": "ParamAngleZ", "axis": "X", "factor": 15.0, "sourceToken": "ParamAngleZ#15*X"}, {"parameterId": "ParamEyeBallX", "axis": "X", "factor": 30.0, "sourceToken": "ParamEyeBallX#30*X"}, {"parameterId": "ParamEyeBallY", "axis": "Y", "factor": 60.0, "sourceToken": "ParamEyeBallY#60*Y"}, {"parameterId": "ParamBodyAngleX", "axis": "X", "factor": 2.0, "sourceToken": "ParamBodyAngleX#2*X"}, {"parameterId": "ParamBodyAngleY", "axis": "Y", "factor": 25.0, "sourceToken": "ParamBodyAngleY#25*Y"}, {"parameterId": "ParamBodyAngleZ", "axis": "X", "factor": 5.0, "sourceToken": "ParamBodyAngleZ#5*X"}, {"parameterId": "ParamArmR2", "axis": "X", "factor": -2.0, "sourceToken": "ParamArmR2#-2*X"}, {"parameterId": "ParamArmR3", "axis": "X", "factor": 2.0, "sourceToken": "ParamArmR3#2*X"}]}],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 18.0 },
          { group: "Idle", index: 1, actionId: "idle1", label: "注视1", duration: 9.0 },
          { group: "Idle", index: 2, actionId: "idle2", label: "注视2", duration: 6.0 }
        ]
      },
      {
        label: "入场",
        actions: [
          { group: "Entry", index: 0, actionId: "ruchang", label: "入场", duration: 13.0 }
        ]
      }
    ],
    clickShowActions: [
      {
        showId: 61012009,
        audioId: 10120002,
        audioName: "vo_1012_yiduanchahua_01",
        desc: "点击1",
        group: "Idle",
        index: 1,
        actionId: "idle1",
        label: "注视1",
        duration: 9.0,
        voices: {"cn": {"subtitle": "装害怕让我放松警惕？虽然是无用的小把戏，但我喜欢看你演戏。", "sound": "sounds/vo_1012_yiduanchahua_01.wav"}, "en": {"subtitle": "装害怕让我放松警惕？虽然是无用的小把戏，但我喜欢看你演戏。", "sound": "sounds/en_vo_1012_yiduanchahua_01.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 20,
        weight: 20
      },
      {
        showId: 61012010,
        audioId: 10120003,
        audioName: "vo_1012_yiduanchahua_02",
        desc: "点击2",
        group: "Idle",
        index: 2,
        actionId: "idle2",
        label: "注视2",
        duration: 6.0,
        voices: {"cn": {"subtitle": "你看，刀很听我的话……你呢？", "sound": "sounds/vo_1012_yiduanchahua_02.wav"}, "en": {"subtitle": "你看，刀很听我的话……你呢？", "sound": "sounds/en_vo_1012_yiduanchahua_02.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 20,
        weight: 20
      },
      {
        showId: 61012011,
        audioId: 60130004,
        audioName: "vo_6013_daiji_01",
        desc: "点击-通用1",
        group: "Idle",
        index: 2,
        actionId: "idle2",
        label: "注视2",
        duration: 6.0,
        voices: {"cn": {"subtitle": "我心情好是因为灭了一个敌方据点？原来在你印象中我是这种人。", "sound": "sounds/vo_6013_daiji_01.wav"}, "en": {"subtitle": "我心情好是因为灭了一个敌方据点？原来在你印象中我是这种人。", "sound": "sounds/en_vo_6013_daiji_01.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 10,
        weight: 10
      },
      {
        showId: 61012012,
        audioId: 60130005,
        audioName: "vo_6013_daiji_02",
        desc: "点击-通用2",
        group: "Idle",
        index: 1,
        actionId: "idle1",
        label: "注视1",
        duration: 9.0,
        voices: {"cn": {"subtitle": "今天风向变了，有些不安分的势力可能又想闹事。我等着他们犯错。", "sound": "sounds/vo_6013_daiji_02.wav"}, "en": {"subtitle": "今天风向变了，有些不安分的势力可能又想闹事。我等着他们犯错。", "sound": "sounds/en_vo_6013_daiji_02.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 10,
        weight: 10
      },
      {
        showId: 61012013,
        audioId: 60130010,
        audioName: "vo_6013_xianliao_01",
        desc: "点击-闲聊1",
        group: "Idle",
        index: 1,
        actionId: "idle1",
        label: "注视1",
        duration: 9.0,
        voices: {"cn": {"subtitle": "我知道外面的人是怎么说泰拉的。人们忌惮它、回避它，这意味着他们不敢轻易伤害它。这样最好。", "sound": "sounds/vo_6013_xianliao_01.wav"}, "en": {"subtitle": "我知道外面的人是怎么说泰拉的。人们忌惮它、回避它，这意味着他们不敢轻易伤害它。这样最好。", "sound": "sounds/en_vo_6013_xianliao_01.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 10,
        weight: 10
      },
      {
        showId: 61012014,
        audioId: 60130014,
        audioName: "vo_6013_zanyang",
        desc: "点击-赞扬1",
        group: "Idle",
        index: 2,
        actionId: "idle2",
        label: "注视2",
        duration: 6.0,
        voices: {"cn": {"subtitle": "你比我想象中更适合当统治者。你若生在地下城，倒是能博一个和“暴君”并肩的名号。", "sound": "sounds/vo_6013_zanyang.wav"}, "en": {"subtitle": "你比我想象中更适合当统治者。你若生在地下城，倒是能博一个和“暴君”并肩的名号。", "sound": "sounds/en_vo_6013_zanyang.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 10,
        weight: 10
      }
    ]
  },
  {
    id: "101201_bj_cg",
    title: "泰拉之主 二段",
    assetKind: "style",
    categoryLabel: "风格",
    modelDir: "101201_bj_cg",
    sourceModelDir: "101201_bj_cg",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "localassets_win32",
    styleId: "13001012",
    styleName: "泰拉之主",
    stage: "二段",
    hitAreaNames: ["HitAreagensui", "HitAreaquanbu"],
    followConfigs: [{"id": 21011, "prefab": "101201_bj_cg", "activeName": "HitAreagensui", "expressionName": "", "damping": 0.8, "parameters": [{"parameterId": "ParamBLarmZ27", "axis": "Y", "factor": -10.0, "sourceToken": "ParamBLarmZ27#-10*Y"}, {"parameterId": "ParamBLarmZ13", "axis": "Y", "factor": 10.0, "sourceToken": "ParamBLarmZ13#10*Y"}, {"parameterId": "ParamBLarmZ15", "axis": "Y", "factor": -20.0, "sourceToken": "ParamBLarmZ15#-20*Y"}, {"parameterId": "ParamBLarmZ28", "axis": "Y", "factor": -20.0, "sourceToken": "ParamBLarmZ28#-20*Y"}, {"parameterId": "ParamBLarmZ19", "axis": "Y", "factor": 20.0, "sourceToken": "ParamBLarmZ19#20*Y"}, {"parameterId": "ParamBLarmZ20", "axis": "Y", "factor": 20.0, "sourceToken": "ParamBLarmZ20#20*Y"}, {"parameterId": "ParamBLarmZ34", "axis": "Y", "factor": 5.0, "sourceToken": "ParamBLarmZ34#5*Y"}, {"parameterId": "ParamBLarmZ33", "axis": "Y", "factor": -10.0, "sourceToken": "ParamBLarmZ33#-10*Y"}]}],
    hideGroups: [{"id": "protagonist", "label": "主控", "matchPrefixes": ["N_"], "partIds": ["N_Body", "N_Body1", "N_Body10", "N_Body2", "N_Body3", "N_Body4", "N_Body5", "N_Body6", "N_Body7", "N_Body8", "N_Face", "N_Hat", "N_Hat1", "N_Hat10", "N_Hat2", "N_Hat3", "N_Hat4", "N_Hat5", "N_Hat6", "N_Hat7", "N_Hat8", "N_Hat9", "N_Head", "N_LBH", "N_LBH1", "N_LBH2", "N_LBH3", "N_LBH4", "N_LBH5", "N_LBH6", "N_LH1", "N_LH2", "N_Mouth1", "N_Mouth2", "N_Neck", "N_RBH", "N_RBH1", "N_RBH2", "N_RBH3", "N_RBH4", "N_RBH5", "N_RBH6", "N_RBH7", "N_arm1yf2", "N_arm1yf3", "N_arm3", "N_arm4", "N_hand3", "N_hand4"], "drawableIds": ["N_Body", "N_Body1", "N_Body10", "N_Body2", "N_Body3", "N_Body4", "N_Body5", "N_Body6", "N_Body7", "N_Body8", "N_Face", "N_Hat", "N_Hat1", "N_Hat10", "N_Hat2", "N_Hat3", "N_Hat4", "N_Hat5", "N_Hat6", "N_Hat7", "N_Hat8", "N_Hat9", "N_Head", "N_LBH", "N_LBH1", "N_LBH2", "N_LBH3", "N_LBH4", "N_LBH5", "N_LBH6", "N_LH1", "N_LH2", "N_Mouth1", "N_Mouth2", "N_Neck", "N_RBH", "N_RBH1", "N_RBH2", "N_RBH3", "N_RBH4", "N_RBH5", "N_RBH6", "N_RBH7", "N_arm1yf2", "N_arm1yf3", "N_arm3", "N_arm4", "N_hand3", "N_hand4"], "confidence": "auto:n_prefix_body_parts", "candidateCount": 59, "semanticCandidateCount": 49}],
    ambientMotion: undefined,
    storySegments: [],
    storyTouchActions: [],
    unlockableMotions: [
      { group: "TapBody", index: 0, actionId: "dongzuo1", label: "亲近1", duration: 9.0 },
      { group: "TapBody", index: 1, actionId: "dongzuo2", label: "亲近2", duration: 10.0 },
      { group: "TapBody", index: 2, actionId: "dongzuo3", label: "亲近3", duration: 12.0 }
    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 12.0 },
          { group: "Idle", index: 1, actionId: "idle1", label: "注视1", duration: 10.0 },
          { group: "Idle", index: 2, actionId: "idle2", label: "注视2", duration: 10.0 }
        ]
      },
      {
        label: "TapBody",
        actions: [
          { group: "TapBody", index: 0, actionId: "dongzuo1", label: "亲近1", duration: 9.0 },
          { group: "TapBody", index: 1, actionId: "dongzuo2", label: "亲近2", duration: 10.0 },
          { group: "TapBody", index: 2, actionId: "dongzuo3", label: "亲近3", duration: 12.0 }
        ]
      },
      {
        label: "入场",
        actions: [
          { group: "Entry", index: 0, actionId: "ruchang", label: "入场", duration: 10.5 }
        ]
      }
    ],
    clickShowActions: [
      {
        showId: 61012055,
        audioId: 10120008,
        audioName: "vo_1012_erduanchahua_03",
        desc: "点击3",
        group: "TapBody",
        index: 0,
        actionId: "dongzuo1",
        label: "亲近1",
        duration: 9.0,
        voices: {"cn": {"subtitle": "泰拉不讲究你们那套规矩，只要你有这个胆量，可以来试着征服我。", "sound": "sounds/vo_1012_erduanchahua_03.wav"}, "en": {"subtitle": "泰拉不讲究你们那套规矩，只要你有这个胆量，可以来试着征服我。", "sound": "sounds/en_vo_1012_erduanchahua_03.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 20,
        weight: 20
      },
      {
        showId: 61012056,
        audioId: 10120009,
        audioName: "vo_1012_erduanchahua_04",
        desc: "点击4",
        group: "TapBody",
        index: 1,
        actionId: "dongzuo2",
        label: "亲近2",
        duration: 10.0,
        voices: {"cn": {"subtitle": "你不服输的眼神，让我更想挑战你了……", "sound": "sounds/vo_1012_erduanchahua_04.wav"}, "en": {"subtitle": "你不服输的眼神，让我更想挑战你了……", "sound": "sounds/en_vo_1012_erduanchahua_04.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 20,
        weight: 20
      },
      {
        showId: 61012057,
        audioId: 10120010,
        audioName: "vo_1012_erduanchahua_05",
        desc: "点击5",
        group: "TapBody",
        index: 2,
        actionId: "dongzuo3",
        label: "亲近3",
        duration: 12.0,
        voices: {"cn": {"subtitle": "身份阶级不是泰拉的通行证，这里没人认得出你是谁，你大可以脱下你的伪装。", "sound": "sounds/vo_1012_erduanchahua_05.wav"}, "en": {"subtitle": "身份阶级不是泰拉的通行证，这里没人认得出你是谁，你大可以脱下你的伪装。", "sound": "sounds/en_vo_1012_erduanchahua_05.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 20,
        weight: 20
      },
      {
        showId: 61012062,
        audioId: 10120006,
        audioName: "vo_1012_erduanchahua_01",
        desc: "点击1",
        group: "Idle",
        index: 1,
        actionId: "idle1",
        label: "注视1",
        duration: 10.0,
        voices: {"cn": {"subtitle": "故意的？你再动一下，我就不忍了……", "sound": "sounds/vo_1012_erduanchahua_01.wav"}, "en": {"subtitle": "故意的？你再动一下，我就不忍了……", "sound": "sounds/en_vo_1012_erduanchahua_01.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 10,
        weight: 10
      },
      {
        showId: 61012063,
        audioId: 10120007,
        audioName: "vo_1012_erduanchahua_02",
        desc: "点击2",
        group: "Idle",
        index: 2,
        actionId: "idle2",
        label: "注视2",
        duration: 10.0,
        voices: {"cn": {"subtitle": "要再赌一把吗？输赢条件你定，但赌注……由我来选。", "sound": "sounds/vo_1012_erduanchahua_02.wav"}, "en": {"subtitle": "要再赌一把吗？输赢条件你定，但赌注……由我来选。", "sound": "sounds/en_vo_1012_erduanchahua_02.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 10,
        weight: 10
      },
      {
        showId: 61012064,
        audioId: 60130004,
        audioName: "vo_6013_daiji_01",
        desc: "点击-通用1",
        group: "Idle",
        index: 1,
        actionId: "idle1",
        label: "注视1",
        duration: 10.0,
        voices: {"cn": {"subtitle": "我心情好是因为灭了一个敌方据点？原来在你印象中我是这种人。", "sound": "sounds/vo_6013_daiji_01.wav"}, "en": {"subtitle": "我心情好是因为灭了一个敌方据点？原来在你印象中我是这种人。", "sound": "sounds/en_vo_6013_daiji_01.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 61012065,
        audioId: 60130005,
        audioName: "vo_6013_daiji_02",
        desc: "点击-通用2",
        group: "Idle",
        index: 2,
        actionId: "idle2",
        label: "注视2",
        duration: 10.0,
        voices: {"cn": {"subtitle": "今天风向变了，有些不安分的势力可能又想闹事。我等着他们犯错。", "sound": "sounds/vo_6013_daiji_02.wav"}, "en": {"subtitle": "今天风向变了，有些不安分的势力可能又想闹事。我等着他们犯错。", "sound": "sounds/en_vo_6013_daiji_02.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 61012066,
        audioId: 60130012,
        audioName: "vo_6013_xianliao_03",
        desc: "点击-闲聊3",
        group: "Idle",
        index: 1,
        actionId: "idle1",
        label: "注视1",
        duration: 10.0,
        voices: {"cn": {"subtitle": "下城区有自己的热闹，也有很多值得一试的东西。我知道有个小摊的炖菜不错，一起？", "sound": "sounds/vo_6013_xianliao_03.wav"}, "en": {"subtitle": "下城区有自己的热闹，也有很多值得一试的东西。我知道有个小摊的炖菜不错，一起？", "sound": "sounds/en_vo_6013_xianliao_03.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 61012067,
        audioId: 60130014,
        audioName: "vo_6013_zanyang",
        desc: "点击-赞扬1",
        group: "Idle",
        index: 2,
        actionId: "idle2",
        label: "注视2",
        duration: 10.0,
        voices: {"cn": {"subtitle": "你比我想象中更适合当统治者。你若生在地下城，倒是能博一个和“暴君”并肩的名号。", "sound": "sounds/vo_6013_zanyang.wav"}, "en": {"subtitle": "你比我想象中更适合当统治者。你若生在地下城，倒是能博一个和“暴君”并肩的名号。", "sound": "sounds/en_vo_6013_zanyang.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      }
    ]
  },
  {
    id: "101300_yd",
    title: "园丁 角色立绘",
    assetKind: "character",
    categoryLabel: "角色",
    modelDir: "101300_yd",
    sourceModelDir: "101300_yd",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "localassets_win32",
    styleId: "",
    styleName: "园丁",
    stage: "角色立绘",
    hitAreaNames: ["HitAreaBody", "HitAreaHead", "HitAreaHandL2", "HitAreaMoren", "HitAreaHandR2", "HitAreaHandL1", "HitAreaHandR1"],
    followConfigs: [{"id": 1004, "prefab": "101300_yd", "activeName": "", "expressionName": "", "damping": 0.0, "parameters": [{"parameterId": "ParamAngleX", "axis": "X", "factor": 30.0, "sourceToken": "ParamAngleX#30*X"}, {"parameterId": "ParamAngleY", "axis": "Y", "factor": 50.0, "sourceToken": "ParamAngleY#50*Y"}, {"parameterId": "ParamEyeBallX", "axis": "X", "factor": 85.0, "sourceToken": "ParamEyeBallX#85*X"}, {"parameterId": "ParamEyeBallY", "axis": "Y", "factor": 50.0, "sourceToken": "ParamEyeBallY#50*Y"}, {"parameterId": "ParamBodyAngleX", "axis": "X", "factor": 20.0, "sourceToken": "ParamBodyAngleX#20*X"}, {"parameterId": "ParamBodyAngleY", "axis": "Y", "factor": 10.0, "sourceToken": "ParamBodyAngleY#10*Y"}]}],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 5.967 }
        ]
      },
      {
        label: "TapBody",
        actions: [
          { group: "TapBody", index: 0, actionId: "diantou", label: "diantou", duration: 3.0 },
          { group: "TapBody", index: 1, actionId: "duishouzhi", label: "duishouzhi", duration: 3.0 },
          { group: "TapBody", index: 2, actionId: "houyang", label: "houyang", duration: 4.0 },
          { group: "TapBody", index: 3, actionId: "nahua", label: "nahua", duration: 10.633 },
          { group: "TapBody", index: 4, actionId: "waitou", label: "waitou", duration: 3.667 },
          { group: "TapBody", index: 5, actionId: "waitou_1", label: "waitou_1", duration: 4.0 },
          { group: "TapBody", index: 6, actionId: "walk", label: "walk", duration: 2.0 },
          { group: "TapBody", index: 7, actionId: "yaotou", label: "yaotou", duration: 3.0 }
        ]
      }
    ],
    clickShowActions: [
      {
        showId: 601101010,
        audioId: 60110004,
        audioName: "vo_6011_daiji_01",
        desc: "点击-通用1",
        group: "TapBody",
        index: 3,
        actionId: "nahua",
        label: "nahua",
        duration: 10.633,
        voices: {"cn": {"subtitle": "摘下来的……小花，你要吗？放在口袋里……一直带着，心情会变好。", "sound": "sounds/vo_6011_daiji_01.wav"}, "en": {"subtitle": "摘下来的……小花，你要吗？放在口袋里……一直带着，心情会变好。", "sound": "sounds/en_vo_6011_daiji_01.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 601101011,
        audioId: 60110005,
        audioName: "vo_6011_daiji_02",
        desc: "点击-通用2",
        group: "TapBody",
        index: 5,
        actionId: "waitou_1",
        label: "waitou_1",
        duration: 4.0,
        voices: {"cn": {"subtitle": "被打……不是很痛。倒地睡一觉，醒来……就好了。", "sound": "sounds/vo_6011_daiji_02.wav"}, "en": {"subtitle": "被打……不是很痛。倒地睡一觉，醒来……就好了。", "sound": "sounds/en_vo_6011_daiji_02.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 601101012,
        audioId: 60110010,
        audioName: "vo_6011_xianliao_01",
        desc: "点击-闲聊1",
        group: "TapBody",
        index: 2,
        actionId: "houyang",
        label: "houyang",
        duration: 4.0,
        voices: {"cn": {"subtitle": "你很干净，我都是土，不要碰。", "sound": "sounds/vo_6011_xianliao_01.wav"}, "en": {"subtitle": "你很干净，我都是土，不要碰。", "sound": "sounds/en_vo_6011_xianliao_01.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 601101013,
        audioId: 60110011,
        audioName: "vo_6011_xianliao_02",
        desc: "点击-闲聊2",
        group: "TapBody",
        index: 1,
        actionId: "duishouzhi",
        label: "duishouzhi",
        duration: 3.0,
        voices: {"cn": {"subtitle": "天气热的话……铁桶很烫。我只好……往头上浇水。", "sound": "sounds/vo_6011_xianliao_02.wav"}, "en": {"subtitle": "天气热的话……铁桶很烫。我只好……往头上浇水。", "sound": "sounds/en_vo_6011_xianliao_02.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 601101014,
        audioId: 60110012,
        audioName: "vo_6011_xianliao_03",
        desc: "点击-闲聊3",
        group: "TapBody",
        index: 1,
        actionId: "duishouzhi",
        label: "duishouzhi",
        duration: 3.0,
        voices: {"cn": {"subtitle": "你说话，我没听见……你就，敲敲铁桶。", "sound": "sounds/vo_6011_xianliao_03.wav"}, "en": {"subtitle": "你说话，我没听见……你就，敲敲铁桶。", "sound": "sounds/en_vo_6011_xianliao_03.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 601101015,
        audioId: 60110014,
        audioName: "vo_6011_zanyang",
        desc: "点击-赞扬1",
        group: "TapBody",
        index: 5,
        actionId: "waitou_1",
        label: "waitou_1",
        duration: 4.0,
        voices: {"cn": {"subtitle": "你像……向日葵，看着很暖和。", "sound": "sounds/vo_6011_zanyang.wav"}, "en": {"subtitle": "你像……向日葵，看着很暖和。", "sound": "sounds/en_vo_6011_zanyang.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 601101016,
        audioId: 60110006,
        audioName: "vo_6011_dianchu_tou",
        desc: "点击-头",
        group: "Idle",
        index: 0,
        actionId: "idle",
        label: "默认",
        duration: 5.967,
        voices: {"cn": {"subtitle": "铁桶里，能听到……回声。你想听？唔，我去拿别的桶……", "sound": "sounds/vo_6011_dianchu_tou.wav"}, "en": {"subtitle": "铁桶里，能听到……回声。你想听？唔，我去拿别的桶……", "sound": "sounds/en_vo_6011_dianchu_tou.wav"}},
        hitAreaParam: "HitAreaHead",
        hitAreas: ["HitAreaHead"],
        sourceType2: 401,
        sourceWeight: 20,
        weight: 20
      },
      {
        showId: 601101017,
        audioId: 60110007,
        audioName: "vo_6011_dianchu_shou",
        desc: "点击-手",
        group: "TapBody",
        index: 1,
        actionId: "duishouzhi",
        label: "duishouzhi",
        duration: 3.0,
        voices: {"cn": {"subtitle": "你对我笑的时候……我，嗯……不知道手要放哪。", "sound": "sounds/vo_6011_dianchu_shou.wav"}, "en": {"subtitle": "你对我笑的时候……我，嗯……不知道手要放哪。", "sound": "sounds/en_vo_6011_dianchu_shou.wav"}},
        hitAreaParam: "HitAreaHandL1#HitAreaHandL2#HitAreaHandR1#HitAreaHandR2",
        hitAreas: ["HitAreaHandL1", "HitAreaHandL2", "HitAreaHandR1", "HitAreaHandR2"],
        sourceType2: 401,
        sourceWeight: 20,
        weight: 20
      },
      {
        showId: 601101018,
        audioId: 60110008,
        audioName: "vo_6011_dianchu_shen",
        desc: "点击-胸",
        group: "Idle",
        index: 0,
        actionId: "idle",
        label: "默认",
        duration: 5.967,
        voices: {"cn": {"subtitle": "衣服……我不挑，反正……总是会脏。", "sound": "sounds/vo_6011_dianchu_shen.wav"}, "en": {"subtitle": "衣服……我不挑，反正……总是会脏。", "sound": "sounds/en_vo_6011_dianchu_shen.wav"}},
        hitAreaParam: "HitAreaBody",
        hitAreas: ["HitAreaBody"],
        sourceType2: 401,
        sourceWeight: 20,
        weight: 20
      }
    ]
  },
  {
    id: "101500_djs",
    title: "点金手 角色立绘",
    assetKind: "character",
    categoryLabel: "角色",
    modelDir: "101500_djs",
    sourceModelDir: "101500_djs",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "localassets_win32",
    styleId: "",
    styleName: "点金手",
    stage: "角色立绘",
    hitAreaNames: ["HitAreaHead", "HitAreaHandL1", "HitAreaHandR", "HitAreaHandL2", "HitAreaBody", "HitAreaMoren"],
    followConfigs: [{"id": 1029, "prefab": "101500_djs", "activeName": "", "expressionName": "", "damping": 0.0, "parameters": [{"parameterId": "ParamAngleX", "axis": "X", "factor": 20.0, "sourceToken": "ParamAngleX#20*X"}, {"parameterId": "ParamAngleY", "axis": "Y", "factor": 30.0, "sourceToken": "ParamAngleY#30*Y"}, {"parameterId": "ParamEyeBallX", "axis": "X", "factor": 50.0, "sourceToken": "ParamEyeBallX#50*X"}, {"parameterId": "ParamEyeBallY", "axis": "Y", "factor": 50.0, "sourceToken": "ParamEyeBallY#50*Y"}, {"parameterId": "ParamBodyAngleX", "axis": "X", "factor": 10.0, "sourceToken": "ParamBodyAngleX#10*X"}, {"parameterId": "ParamBodyMae", "axis": "Y", "factor": 10.0, "sourceToken": "ParamBodyMae#10*Y"}]}],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 6.0 }
        ]
      },
      {
        label: "TapBody",
        actions: [
          { group: "TapBody", index: 0, actionId: "diantou", label: "diantou", duration: 3.0 },
          { group: "TapBody", index: 1, actionId: "houyang", label: "houyang", duration: 4.0 },
          { group: "TapBody", index: 2, actionId: "qianqing", label: "qianqing", duration: 4.667 },
          { group: "TapBody", index: 3, actionId: "shenshou", label: "shenshou", duration: 6.0 },
          { group: "TapBody", index: 4, actionId: "shenshou_1", label: "shenshou_1", duration: 6.0 },
          { group: "TapBody", index: 5, actionId: "suanzhang", label: "suanzhang", duration: 9.0 },
          { group: "TapBody", index: 6, actionId: "waitou", label: "waitou", duration: 3.667 },
          { group: "TapBody", index: 7, actionId: "walk", label: "walk", duration: 2.0 },
          { group: "TapBody", index: 8, actionId: "yaotou", label: "yaotou", duration: 3.0 }
        ]
      }
    ],
    clickShowActions: [
      {
        showId: 601401010,
        audioId: 60140004,
        audioName: "vo_6014_daiji_01",
        desc: "点击-通用1",
        group: "TapBody",
        index: 6,
        actionId: "waitou",
        label: "waitou",
        duration: 3.667,
        voices: {"cn": {"subtitle": "我的慷慨只给两种人——死人，和将来能让我赚更多钱的人。", "sound": "sounds/vo_6014_daiji_01.wav"}, "en": {"subtitle": "我的慷慨只给两种人——死人，和将来能让我赚更多钱的人。", "sound": "sounds/en_vo_6014_daiji_01.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 601401011,
        audioId: 60140005,
        audioName: "vo_6014_daiji_02",
        desc: "点击-通用2",
        group: "TapBody",
        index: 5,
        actionId: "suanzhang",
        label: "suanzhang",
        duration: 9.0,
        voices: {"cn": {"subtitle": "无论是金钱债还是人情债，人与人之间的关系本就靠债务维系。", "sound": "sounds/vo_6014_daiji_02.wav"}, "en": {"subtitle": "无论是金钱债还是人情债，人与人之间的关系本就靠债务维系。", "sound": "sounds/en_vo_6014_daiji_02.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 601401012,
        audioId: 60140010,
        audioName: "vo_6014_xianliao_01",
        desc: "点击-闲聊1",
        group: "TapBody",
        index: 6,
        actionId: "waitou",
        label: "waitou",
        duration: 3.667,
        voices: {"cn": {"subtitle": "有人说我的慈善捐款是“鳄鱼的流泪”，呵呵，闲得无聊的“绅士”只会捐空话，要他们捐钱，那是一分也不会掏。", "sound": "sounds/vo_6014_xianliao_01.wav"}, "en": {"subtitle": "有人说我的慈善捐款是“鳄鱼的流泪”，呵呵，闲得无聊的“绅士”只会捐空话，要他们捐钱，那是一分也不会掏。", "sound": "sounds/en_vo_6014_xianliao_01.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 601401013,
        audioId: 60140011,
        audioName: "vo_6014_xianliao_02",
        desc: "点击-闲聊2",
        group: "Idle",
        index: 0,
        actionId: "idle",
        label: "默认",
        duration: 6.0,
        voices: {"cn": {"subtitle": "很多人都乐于出卖自己的尊严、肉体或是灵魂，换取金钱和片刻愉悦，可他们往往没想到怎么赎回来——我的职责是提醒他们。", "sound": "sounds/vo_6014_xianliao_02.wav"}, "en": {"subtitle": "很多人都乐于出卖自己的尊严、肉体或是灵魂，换取金钱和片刻愉悦，可他们往往没想到怎么赎回来——我的职责是提醒他们。", "sound": "sounds/en_vo_6014_xianliao_02.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 601401014,
        audioId: 60140012,
        audioName: "vo_6014_xianliao_03",
        desc: "点击-闲聊3",
        group: "TapBody",
        index: 4,
        actionId: "shenshou_1",
        label: "shenshou_1",
        duration: 6.0,
        voices: {"cn": {"subtitle": "我的手指时刻在提醒我，有些回报不会等价，有些付出的事物永远不会回来。", "sound": "sounds/vo_6014_xianliao_03.wav"}, "en": {"subtitle": "我的手指时刻在提醒我，有些回报不会等价，有些付出的事物永远不会回来。", "sound": "sounds/en_vo_6014_xianliao_03.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 601401015,
        audioId: 60140014,
        audioName: "vo_6014_zanyang",
        desc: "点击-赞扬1",
        group: "TapBody",
        index: 5,
        actionId: "suanzhang",
        label: "suanzhang",
        duration: 9.0,
        voices: {"cn": {"subtitle": "你比我想象的还要身家干净。还是说，你的手段比我想象的高明？", "sound": "sounds/vo_6014_zanyang.wav"}, "en": {"subtitle": "你比我想象的还要身家干净。还是说，你的手段比我想象的高明？", "sound": "sounds/en_vo_6014_zanyang.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 601401016,
        audioId: 60140006,
        audioName: "vo_6014_dianchu_tou",
        desc: "点击-头",
        group: "Idle",
        index: 0,
        actionId: "idle",
        label: "默认",
        duration: 6.0,
        voices: {"cn": {"subtitle": "有人说我眼神像在估价。没错，我确实在算——算人的恐惧值多少，忠诚又值多少。", "sound": "sounds/vo_6014_dianchu_tou.wav"}, "en": {"subtitle": "有人说我眼神像在估价。没错，我确实在算——算人的恐惧值多少，忠诚又值多少。", "sound": "sounds/en_vo_6014_dianchu_tou.wav"}},
        hitAreaParam: "HitAreaHead",
        hitAreas: ["HitAreaHead"],
        sourceType2: 401,
        sourceWeight: 20,
        weight: 20
      },
      {
        showId: 601401017,
        audioId: 60140007,
        audioName: "vo_6014_dianchu_shou",
        desc: "点击-手",
        group: "TapBody",
        index: 4,
        actionId: "shenshou_1",
        label: "shenshou_1",
        duration: 6.0,
        voices: {"cn": {"subtitle": "伸手要钱的时候，可得算好利息啊。", "sound": "sounds/vo_6014_dianchu_shou.wav"}, "en": {"subtitle": "伸手要钱的时候，可得算好利息啊。", "sound": "sounds/en_vo_6014_dianchu_shou.wav"}},
        hitAreaParam: "HitAreaHandL1#HitAreaHandL2#HitAreaHandR",
        hitAreas: ["HitAreaHandL1", "HitAreaHandL2", "HitAreaHandR"],
        sourceType2: 401,
        sourceWeight: 20,
        weight: 20
      },
      {
        showId: 601401018,
        audioId: 60140008,
        audioName: "vo_6014_dianchu_shen",
        desc: "点击-胸",
        group: "TapBody",
        index: 6,
        actionId: "waitou",
        label: "waitou",
        duration: 3.667,
        voices: {"cn": {"subtitle": "想知道这里面装的是什么？良心？早就典当了，里面只剩下叮当响的金币。", "sound": "sounds/vo_6014_dianchu_shen.wav"}, "en": {"subtitle": "想知道这里面装的是什么？良心？早就典当了，里面只剩下叮当响的金币。", "sound": "sounds/en_vo_6014_dianchu_shen.wav"}},
        hitAreaParam: "HitAreaBody",
        hitAreas: ["HitAreaBody"],
        sourceType2: 401,
        sourceWeight: 20,
        weight: 20
      }
    ]
  },
  {
    id: "101600_zc",
    title: "预埋角色 101600_zc 角色候选",
    assetKind: "character",
    categoryLabel: "角色",
    modelDir: "101600_zc",
    sourceModelDir: "101600_zc",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "streamingassets",
    styleId: "",
    styleName: "预埋角色 101600_zc",
    stage: "角色候选",
    hitAreaNames: ["HitAreaBody", "HitAreaMoren", "HitAreaHandL", "HitAreaHead"],
    followConfigs: [{"id": 1008, "prefab": "101600_zc", "activeName": "", "expressionName": "", "damping": 0.0, "parameters": [{"parameterId": "ParamAngleX", "axis": "X", "factor": 30.0, "sourceToken": "ParamAngleX#30*X"}, {"parameterId": "ParamAngleY", "axis": "Y", "factor": 15.0, "sourceToken": "ParamAngleY#15*Y"}, {"parameterId": "ParamEyeBallX", "axis": "X", "factor": 85.0, "sourceToken": "ParamEyeBallX#85*X"}, {"parameterId": "ParamEyeBallY", "axis": "Y", "factor": 50.0, "sourceToken": "ParamEyeBallY#50*Y"}, {"parameterId": "ParamBodyAngleX", "axis": "X", "factor": 30.0, "sourceToken": "ParamBodyAngleX#30*X"}, {"parameterId": "ParamBodyAngleY", "axis": "Y", "factor": 30.0, "sourceToken": "ParamBodyAngleY#30*Y"}]}],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 6.0 }
        ]
      },
      {
        label: "TapBody",
        actions: [
          { group: "TapBody", index: 0, actionId: "cangdao", label: "cangdao", duration: 3.5 },
          { group: "TapBody", index: 1, actionId: "diantou", label: "diantou", duration: 3.333 },
          { group: "TapBody", index: 2, actionId: "houyang", label: "houyang", duration: 3.5 },
          { group: "TapBody", index: 3, actionId: "qianqing", label: "qianqing", duration: 4.5 },
          { group: "TapBody", index: 4, actionId: "waitou", label: "waitou", duration: 3.5 },
          { group: "TapBody", index: 5, actionId: "waitou_1", label: "waitou_1", duration: 3.5 },
          { group: "TapBody", index: 6, actionId: "walk", label: "walk", duration: 2.0 },
          { group: "TapBody", index: 7, actionId: "yaotou", label: "yaotou", duration: 3.0 }
        ]
      }
    ],
    clickShowActions: [

    ]
  },
  {
    id: "101601_zc",
    title: "主厨 角色立绘",
    assetKind: "character",
    categoryLabel: "角色",
    modelDir: "101601_zc",
    sourceModelDir: "101601_zc",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "localassets_win32",
    styleId: "",
    styleName: "主厨",
    stage: "角色立绘",
    hitAreaNames: ["HitAreaHandR", "HitAreaHead", "HitAreaHandL", "HitAreaBody", "HitAreaMoren"],
    followConfigs: [{"id": 1008, "prefab": "101601_zc", "activeName": "", "expressionName": "", "damping": 0.0, "parameters": [{"parameterId": "ParamAngleX", "axis": "X", "factor": 30.0, "sourceToken": "ParamAngleX#30*X"}, {"parameterId": "ParamAngleY", "axis": "Y", "factor": 15.0, "sourceToken": "ParamAngleY#15*Y"}, {"parameterId": "ParamEyeBallX", "axis": "X", "factor": 85.0, "sourceToken": "ParamEyeBallX#85*X"}, {"parameterId": "ParamEyeBallY", "axis": "Y", "factor": 50.0, "sourceToken": "ParamEyeBallY#50*Y"}, {"parameterId": "ParamBodyAngleX", "axis": "X", "factor": 30.0, "sourceToken": "ParamBodyAngleX#30*X"}, {"parameterId": "ParamBodyAngleY", "axis": "Y", "factor": 30.0, "sourceToken": "ParamBodyAngleY#30*Y"}]}],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 6.0 }
        ]
      },
      {
        label: "TapBody",
        actions: [
          { group: "TapBody", index: 0, actionId: "cangdao", label: "cangdao", duration: 3.5 },
          { group: "TapBody", index: 1, actionId: "diantou", label: "diantou", duration: 3.333 },
          { group: "TapBody", index: 2, actionId: "houyang", label: "houyang", duration: 3.5 },
          { group: "TapBody", index: 3, actionId: "qianqing", label: "qianqing", duration: 4.5 },
          { group: "TapBody", index: 4, actionId: "taidao", label: "taidao", duration: 5.9 },
          { group: "TapBody", index: 5, actionId: "waitou", label: "waitou", duration: 3.5 },
          { group: "TapBody", index: 6, actionId: "waitou_1", label: "waitou_1", duration: 3.5 },
          { group: "TapBody", index: 7, actionId: "walk", label: "walk", duration: 2.0 },
          { group: "TapBody", index: 8, actionId: "yaotou", label: "yaotou", duration: 3.0 }
        ]
      }
    ],
    clickShowActions: [
      {
        showId: 601501010,
        audioId: 60150004,
        audioName: "vo_6015_daiji_01",
        desc: "点击-通用1",
        group: "TapBody",
        index: 4,
        actionId: "taidao",
        label: "taidao",
        duration: 5.9,
        voices: {"cn": {"subtitle": "有些仇人不需要我动刀，我只需请他吃顿我亲手做的饭。", "sound": "sounds/vo_6015_daiji_01.wav"}, "en": {"subtitle": "有些仇人不需要我动刀，我只需请他吃顿我亲手做的饭。", "sound": "sounds/en_vo_6015_daiji_01.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 601501011,
        audioId: 60150005,
        audioName: "vo_6015_daiji_02",
        desc: "点击-通用2",
        group: "TapBody",
        index: 3,
        actionId: "qianqing",
        label: "qianqing",
        duration: 4.5,
        voices: {"cn": {"subtitle": "刚才看你随便吃两口就来办公室了，这是加餐，至少别饿倒在我面前。", "sound": "sounds/vo_6015_daiji_02.wav"}, "en": {"subtitle": "刚才看你随便吃两口就来办公室了，这是加餐，至少别饿倒在我面前。", "sound": "sounds/en_vo_6015_daiji_02.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 601501012,
        audioId: 60150010,
        audioName: "vo_6015_xianliao_01",
        desc: "点击-闲聊1",
        group: "TapBody",
        index: 4,
        actionId: "taidao",
        label: "taidao",
        duration: 5.9,
        voices: {"cn": {"subtitle": "每个米兰王国的人都应该知道怎么做一份完美的披萨——上面绝对没有水果。", "sound": "sounds/vo_6015_xianliao_01.wav"}, "en": {"subtitle": "每个米兰王国的人都应该知道怎么做一份完美的披萨——上面绝对没有水果。", "sound": "sounds/en_vo_6015_xianliao_01.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 601501013,
        audioId: 60150011,
        audioName: "vo_6015_xianliao_02",
        desc: "点击-闲聊2",
        group: "TapBody",
        index: 3,
        actionId: "qianqing",
        label: "qianqing",
        duration: 4.5,
        voices: {"cn": {"subtitle": "别怪我没有提醒你，挑食会让你的身体营养不均衡，别以为夜行者就可以对自己的身体为所欲为。", "sound": "sounds/vo_6015_xianliao_02.wav"}, "en": {"subtitle": "别怪我没有提醒你，挑食会让你的身体营养不均衡，别以为夜行者就可以对自己的身体为所欲为。", "sound": "sounds/en_vo_6015_xianliao_02.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 601501014,
        audioId: 60150012,
        audioName: "vo_6015_xianliao_03",
        desc: "点击-闲聊3",
        group: "Idle",
        index: 0,
        actionId: "idle",
        label: "默认",
        duration: 6.0,
        voices: {"cn": {"subtitle": "每个家庭餐馆都有自己传承的秘方，那都是带着回忆的、独一无二的味道。", "sound": "sounds/vo_6015_xianliao_03.wav"}, "en": {"subtitle": "每个家庭餐馆都有自己传承的秘方，那都是带着回忆的、独一无二的味道。", "sound": "sounds/en_vo_6015_xianliao_03.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 601501015,
        audioId: 60150014,
        audioName: "vo_6015_zanyang",
        desc: "点击-赞扬1",
        group: "TapBody",
        index: 6,
        actionId: "waitou_1",
        label: "waitou_1",
        duration: 3.5,
        voices: {"cn": {"subtitle": "看到你今天也有按时吃饱饭，我就放心了。", "sound": "sounds/vo_6015_zanyang.wav"}, "en": {"subtitle": "看到你今天也有按时吃饱饭，我就放心了。", "sound": "sounds/en_vo_6015_zanyang.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 601501016,
        audioId: 60150006,
        audioName: "vo_6015_dianchu_tou",
        desc: "点击-头",
        group: "TapBody",
        index: 6,
        actionId: "waitou_1",
        label: "waitou_1",
        duration: 3.5,
        voices: {"cn": {"subtitle": "揭开餐盘盖之前，食客不会知道里面是烤猪头，还是敌人的脑袋。", "sound": "sounds/vo_6015_dianchu_tou.wav"}, "en": {"subtitle": "揭开餐盘盖之前，食客不会知道里面是烤猪头，还是敌人的脑袋。", "sound": "sounds/en_vo_6015_dianchu_tou.wav"}},
        hitAreaParam: "HitAreaHead",
        hitAreas: ["HitAreaHead"],
        sourceType2: 401,
        sourceWeight: 20,
        weight: 20
      },
      {
        showId: 601501017,
        audioId: 60150007,
        audioName: "vo_6015_dianchu_shou",
        desc: "点击-手",
        group: "TapBody",
        index: 4,
        actionId: "taidao",
        label: "taidao",
        duration: 5.9,
        voices: {"cn": {"subtitle": "我的手是糙了点，但这些握刀磨出的茧，让我一拿刀就能唤起烹饪的肌肉记忆。", "sound": "sounds/vo_6015_dianchu_shou.wav"}, "en": {"subtitle": "我的手是糙了点，但这些握刀磨出的茧，让我一拿刀就能唤起烹饪的肌肉记忆。", "sound": "sounds/en_vo_6015_dianchu_shou.wav"}},
        hitAreaParam: "HitAreaHandL#HitAreaHandR",
        hitAreas: ["HitAreaHandL", "HitAreaHandR"],
        sourceType2: 401,
        sourceWeight: 20,
        weight: 20
      },
      {
        showId: 601501018,
        audioId: 60150008,
        audioName: "vo_6015_dianchu_shen",
        desc: "点击-胸",
        group: "Idle",
        index: 0,
        actionId: "idle",
        label: "默认",
        duration: 6.0,
        voices: {"cn": {"subtitle": "摸透牲畜每寸筋骨是厨子的本分，恰好人的身体我也很熟。", "sound": "sounds/vo_6015_dianchu_shen.wav"}, "en": {"subtitle": "摸透牲畜每寸筋骨是厨子的本分，恰好人的身体我也很熟。", "sound": "sounds/en_vo_6015_dianchu_shen.wav"}},
        hitAreaParam: "HitAreaBody",
        hitAreas: ["HitAreaBody"],
        sourceType2: 401,
        sourceWeight: 20,
        weight: 20
      }
    ]
  },
  {
    id: "101700_yl",
    title: "预埋角色 101700_yl 角色候选",
    assetKind: "character",
    categoryLabel: "角色",
    modelDir: "101700_yl",
    sourceModelDir: "101700_yl",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "localassets_win32",
    styleId: "",
    styleName: "预埋角色 101700_yl",
    stage: "角色候选",
    hitAreaNames: ["HitAreaHead", "HitAreaHandL", "HitAreaHandR", "HitAreaBody", "HitAreaMoren"],
    followConfigs: [{"id": 1022, "prefab": "101700_yl", "activeName": "", "expressionName": "", "damping": 0.0, "parameters": [{"parameterId": "ParamAngleX", "axis": "X", "factor": 50.0, "sourceToken": "ParamAngleX#50*X"}, {"parameterId": "ParamAngleY", "axis": "Y", "factor": 30.0, "sourceToken": "ParamAngleY#30*Y"}, {"parameterId": "ParamEyeBallX", "axis": "X", "factor": 70.0, "sourceToken": "ParamEyeBallX#70*X"}, {"parameterId": "ParamEyeBallY", "axis": "Y", "factor": 50.0, "sourceToken": "ParamEyeBallY#50*Y"}, {"parameterId": "ParamBodyAngleX", "axis": "X", "factor": 30.0, "sourceToken": "ParamBodyAngleX#30*X"}, {"parameterId": "ParamBodyMae", "axis": "Y", "factor": -5.0, "sourceToken": "ParamBodyMae#-5*Y"}]}],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 6.0 }
        ]
      },
      {
        label: "TapBody",
        actions: [
          { group: "TapBody", index: 0, actionId: "deyi", label: "deyi", duration: 2.812 },
          { group: "TapBody", index: 1, actionId: "diantou", label: "diantou", duration: 2.571 },
          { group: "TapBody", index: 2, actionId: "houyang", label: "houyang", duration: 2.571 },
          { group: "TapBody", index: 3, actionId: "naotou", label: "naotou", duration: 2.812 },
          { group: "TapBody", index: 4, actionId: "qianqing", label: "qianqing", duration: 3.429 },
          { group: "TapBody", index: 5, actionId: "waitou", label: "waitou", duration: 2.812 },
          { group: "TapBody", index: 6, actionId: "walk", label: "walk", duration: 1.714 },
          { group: "TapBody", index: 7, actionId: "yaotou", label: "yaotou", duration: 2.571 }
        ]
      }
    ],
    clickShowActions: [

    ]
  },
  {
    id: "101700_yl_cg",
    title: "巡游护卫 二段",
    assetKind: "style",
    categoryLabel: "风格",
    modelDir: "101700_yl_cg",
    sourceModelDir: "101700_yl_cg",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "localassets_win32",
    styleId: "13001017",
    styleName: "巡游护卫",
    stage: "二段",
    hitAreaNames: ["HitAreaMoren", "HitAreaTeShu", "HitAreaquanbu"],
    followConfigs: [{"id": 21002, "prefab": "101700_yl_cg", "activeName": "", "expressionName": "", "damping": 0.0, "parameters": [{"parameterId": "ParamAngleX", "axis": "X", "factor": 20.0, "sourceToken": "ParamAngleX#20*X"}, {"parameterId": "ParamAngleY", "axis": "Y", "factor": 100.0, "sourceToken": "ParamAngleY#100*Y"}, {"parameterId": "ParamAngleZ", "axis": "Y", "factor": 30.0, "sourceToken": "ParamAngleZ#30*Y"}, {"parameterId": "ParamBoZi_X", "axis": "X", "factor": 70.0, "sourceToken": "ParamBoZi_X#70*X"}, {"parameterId": "ParamBoZi_Y", "axis": "Y", "factor": 100.0, "sourceToken": "ParamBoZi_Y#100*Y"}, {"parameterId": "ParamEyeBallX", "axis": "X", "factor": 20.0, "sourceToken": "ParamEyeBallX#20*X"}, {"parameterId": "ParamEyeBallY", "axis": "Y", "factor": -45.0, "sourceToken": "ParamEyeBallY#-45*Y"}, {"parameterId": "ParamBodyAngleY", "axis": "Y", "factor": 20.0, "sourceToken": "ParamBodyAngleY#20*Y"}, {"parameterId": "ParamBody_X_Move", "axis": "X", "factor": 1.0, "sourceToken": "ParamBody_X_Move#1*X"}, {"parameterId": "ParamBody_Y_Move", "axis": "Y", "factor": 1.0, "sourceToken": "ParamBody_Y_Move#1*Y"}, {"parameterId": "Param20", "axis": "X", "factor": -10.0, "sourceToken": "Param20#-10*X"}, {"parameterId": "Param108", "axis": "Y", "factor": -10.0, "sourceToken": "Param108#-10*Y"}, {"parameterId": "Param53", "axis": "X", "factor": -5.0, "sourceToken": "Param53#-5*X"}, {"parameterId": "Param52", "axis": "Y", "factor": -10.0, "sourceToken": "Param52#-10*Y"}]}],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [],
    storyTouchActions: [],
    unlockableMotions: [
      { group: "TapBody", index: 0, actionId: "dongzuo1", label: "亲近1", duration: 11.3 },
      { group: "TapBody", index: 1, actionId: "dongzuo2", label: "亲近2", duration: 18.47 },
      { group: "TapBody", index: 2, actionId: "dongzuo3", label: "亲近3", duration: 11.07 }
    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 6.67 },
          { group: "Idle", index: 1, actionId: "idle1", label: "注视1", duration: 8.333 },
          { group: "Idle", index: 2, actionId: "idle2", label: "注视2", duration: 16.1 }
        ]
      },
      {
        label: "TapBody",
        actions: [
          { group: "TapBody", index: 0, actionId: "dongzuo1", label: "亲近1", duration: 11.3 },
          { group: "TapBody", index: 1, actionId: "dongzuo2", label: "亲近2", duration: 18.47 },
          { group: "TapBody", index: 2, actionId: "dongzuo3", label: "亲近3", duration: 11.07 }
        ]
      },
      {
        label: "入场",
        actions: [
          { group: "Entry", index: 0, actionId: "ruchang", label: "入场", duration: 15.17 }
        ]
      }
    ],
    clickShowActions: [
      {
        showId: 61017055,
        audioId: 10170008,
        audioName: "vo_1017_erduanchahua_03",
        desc: "点击3",
        group: "TapBody",
        index: 0,
        actionId: "dongzuo1",
        label: "亲近1",
        duration: 11.3,
        voices: {"cn": {"subtitle": "你的每一寸皮肤都散发着诱人的味道……", "sound": "sounds/vo_1017_erduanchahua_03.wav"}, "en": {"subtitle": "你的每一寸皮肤都散发着诱人的味道……", "sound": "sounds/en_vo_1017_erduanchahua_03.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 20,
        weight: 20
      },
      {
        showId: 61017056,
        audioId: 10170010,
        audioName: "vo_1017_erduanchahua_05",
        desc: "点击4",
        group: "TapBody",
        index: 1,
        actionId: "dongzuo2",
        label: "亲近2",
        duration: 18.47,
        voices: {"cn": {"subtitle": "不许动，这是……我应得的奖赏。", "sound": "sounds/vo_1017_erduanchahua_05.wav"}, "en": {"subtitle": "不许动，这是……我应得的奖赏。", "sound": "sounds/en_vo_1017_erduanchahua_05.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 20,
        weight: 20
      },
      {
        showId: 61017057,
        audioId: 10170009,
        audioName: "vo_1017_erduanchahua_04",
        desc: "点击5",
        group: "TapBody",
        index: 2,
        actionId: "dongzuo3",
        label: "亲近3",
        duration: 11.07,
        voices: {"cn": {"subtitle": "感受到我的心跳了吗……你让一只野兽为你发狂。", "sound": "sounds/vo_1017_erduanchahua_04.wav"}, "en": {"subtitle": "感受到我的心跳了吗……你让一只野兽为你发狂。", "sound": "sounds/en_vo_1017_erduanchahua_04.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 20,
        weight: 20
      },
      {
        showId: 61017062,
        audioId: 10170006,
        audioName: "vo_1017_erduanchahua_01",
        desc: "点击1",
        group: "Idle",
        index: 1,
        actionId: "idle1",
        label: "注视1",
        duration: 8.333,
        voices: {"cn": {"subtitle": "你这样毫无防备，小心被狼反咬一口……", "sound": "sounds/vo_1017_erduanchahua_01.wav"}, "en": {"subtitle": "你这样毫无防备，小心被狼反咬一口……", "sound": "sounds/en_vo_1017_erduanchahua_01.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 10,
        weight: 10
      },
      {
        showId: 61017063,
        audioId: 10170007,
        audioName: "vo_1017_erduanchahua_02",
        desc: "点击2",
        group: "Idle",
        index: 2,
        actionId: "idle2",
        label: "注视2",
        duration: 16.1,
        voices: {"cn": {"subtitle": "……", "sound": "sounds/vo_1017_erduanchahua_02.wav"}, "en": {"subtitle": "……", "sound": "sounds/en_vo_1017_erduanchahua_02.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 10,
        weight: 10
      },
      {
        showId: 61017064,
        audioId: 60010004,
        audioName: "vo_6001_daiji_01",
        desc: "点击-通用1",
        group: "Idle",
        index: 2,
        actionId: "idle2",
        label: "注视2",
        duration: 16.1,
        voices: {"cn": {"subtitle": "吵着要保护你的人是我，可是你不在，我连打架都不安心。也许，是你在保护我……", "sound": "sounds/vo_6001_daiji_01.wav"}, "en": {"subtitle": "吵着要保护你的人是我，可是你不在，我连打架都不安心。也许，是你在保护我……", "sound": "sounds/en_vo_6001_daiji_01.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 61017065,
        audioId: 60010005,
        audioName: "vo_6001_daiji_02",
        desc: "点击-通用2",
        group: "Idle",
        index: 1,
        actionId: "idle1",
        label: "注视1",
        duration: 8.333,
        voices: {"cn": {"subtitle": "有人说我像BOSS的狗？哼，我乐意，狗可比有些人更懂得忠诚。", "sound": "sounds/vo_6001_daiji_02.wav"}, "en": {"subtitle": "有人说我像BOSS的狗？哼，我乐意，狗可比有些人更懂得忠诚。", "sound": "sounds/en_vo_6001_daiji_02.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 61017066,
        audioId: 60010012,
        audioName: "vo_6001_xianliao_03",
        desc: "点击-闲聊3",
        group: "Idle",
        index: 1,
        actionId: "idle1",
        label: "注视1",
        duration: 8.333,
        voices: {"cn": {"subtitle": "没必要记挂我的左胳膊，它有时候可比肉体好用多了。你要不要见识一下？", "sound": "sounds/vo_6001_xianliao_03.wav"}, "en": {"subtitle": "没必要记挂我的左胳膊，它有时候可比肉体好用多了。你要不要见识一下？", "sound": "sounds/en_vo_6001_xianliao_03.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 61017067,
        audioId: 60010014,
        audioName: "vo_6001_zanyang",
        desc: "点击-赞扬1",
        group: "Idle",
        index: 2,
        actionId: "idle2",
        label: "注视2",
        duration: 16.1,
        voices: {"cn": {"subtitle": "你一个眼神过来，我就能变成世上最强大的猛兽，没什么能挡住我。", "sound": "sounds/vo_6001_zanyang.wav"}, "en": {"subtitle": "你一个眼神过来，我就能变成世上最强大的猛兽，没什么能挡住我。", "sound": "sounds/en_vo_6001_zanyang.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      }
    ]
  },
  {
    id: "101701_yl_cg",
    title: "巡游护卫 一段",
    assetKind: "style",
    categoryLabel: "风格",
    modelDir: "101701_yl_cg",
    sourceModelDir: "101701_yl_cg",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "streamingassets",
    styleId: "13001017",
    styleName: "巡游护卫",
    stage: "一段",
    hitAreaNames: ["HitAreaquanbu"],
    followConfigs: [{"id": 21009, "prefab": "101701_yl_cg", "activeName": "", "expressionName": "", "damping": 0.0, "parameters": [{"parameterId": "Param300", "axis": "X", "factor": 20.0, "sourceToken": "Param300#20*X"}, {"parameterId": "Param301", "axis": "Y", "factor": 20.0, "sourceToken": "Param301#20*Y"}, {"parameterId": "ParamAngleX", "axis": "X", "factor": 25.0, "sourceToken": "ParamAngleX#25*X"}, {"parameterId": "ParamAngleY", "axis": "Y", "factor": 40.0, "sourceToken": "ParamAngleY#40*Y"}, {"parameterId": "ParamAngleZ", "axis": "X", "factor": 10.0, "sourceToken": "ParamAngleZ#10*X"}, {"parameterId": "Param278", "axis": "X", "factor": 11.0, "sourceToken": "Param278#11*X"}, {"parameterId": "ParamBodyAngleZ", "axis": "X", "factor": 6.0, "sourceToken": "ParamBodyAngleZ#6*X"}, {"parameterId": "ParamBodyAngleY", "axis": "Y", "factor": -15.0, "sourceToken": "ParamBodyAngleY#-15*Y"}, {"parameterId": "Param103", "axis": "Y", "factor": 5.0, "sourceToken": "Param103#5*Y"}, {"parameterId": "Param106", "axis": "X", "factor": 1.0, "sourceToken": "Param106#1*X"}, {"parameterId": "Param192", "axis": "X", "factor": 2.0, "sourceToken": "Param192#2*X"}, {"parameterId": "Param193", "axis": "Y", "factor": 2.0, "sourceToken": "Param193#2*Y"}, {"parameterId": "Param19", "axis": "Y", "factor": 20.0, "sourceToken": "Param19#20*Y"}]}],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 13.3 },
          { group: "Idle", index: 1, actionId: "idle1", label: "注视1", duration: 7.47 },
          { group: "Idle", index: 2, actionId: "idle2", label: "注视2", duration: 11.9 }
        ]
      },
      {
        label: "入场",
        actions: [
          { group: "Entry", index: 0, actionId: "ruchang", label: "入场", duration: 15.133 }
        ]
      }
    ],
    clickShowActions: [
      {
        showId: 61017009,
        audioId: 10170002,
        audioName: "vo_1017_yiduanchahua_01",
        desc: "点击1",
        group: "Idle",
        index: 1,
        actionId: "idle1",
        label: "注视1",
        duration: 7.47,
        voices: {"cn": {"subtitle": "用手吃更快。看中的食物只要这样一下、两下，就完全属于我了。", "sound": "sounds/vo_1017_yiduanchahua_01.wav"}, "en": {"subtitle": "用手吃更快。看中的食物只要这样一下、两下，就完全属于我了。", "sound": "sounds/en_vo_1017_yiduanchahua_01.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 20,
        weight: 20
      },
      {
        showId: 61017010,
        audioId: 10170003,
        audioName: "vo_1017_yiduanchahua_02",
        desc: "点击2",
        group: "Idle",
        index: 2,
        actionId: "idle2",
        label: "注视2",
        duration: 11.9,
        voices: {"cn": {"subtitle": "你是不是故意的？故意露出这种笑容，让我分心……", "sound": "sounds/vo_1017_yiduanchahua_02.wav"}, "en": {"subtitle": "你是不是故意的？故意露出这种笑容，让我分心……", "sound": "sounds/en_vo_1017_yiduanchahua_02.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 20,
        weight: 20
      },
      {
        showId: 61017011,
        audioId: 60010004,
        audioName: "vo_6001_daiji_01",
        desc: "点击-通用1",
        group: "Idle",
        index: 2,
        actionId: "idle2",
        label: "注视2",
        duration: 11.9,
        voices: {"cn": {"subtitle": "吵着要保护你的人是我，可是你不在，我连打架都不安心。也许，是你在保护我……", "sound": "sounds/vo_6001_daiji_01.wav"}, "en": {"subtitle": "吵着要保护你的人是我，可是你不在，我连打架都不安心。也许，是你在保护我……", "sound": "sounds/en_vo_6001_daiji_01.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 10,
        weight: 10
      },
      {
        showId: 61017012,
        audioId: 60010005,
        audioName: "vo_6001_daiji_02",
        desc: "点击-通用2",
        group: "Idle",
        index: 1,
        actionId: "idle1",
        label: "注视1",
        duration: 7.47,
        voices: {"cn": {"subtitle": "有人说我像BOSS的狗？哼，我乐意，狗可比有些人更懂得忠诚。", "sound": "sounds/vo_6001_daiji_02.wav"}, "en": {"subtitle": "有人说我像BOSS的狗？哼，我乐意，狗可比有些人更懂得忠诚。", "sound": "sounds/en_vo_6001_daiji_02.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 10,
        weight: 10
      },
      {
        showId: 61017013,
        audioId: 60010012,
        audioName: "vo_6001_xianliao_03",
        desc: "点击-闲聊3",
        group: "Idle",
        index: 1,
        actionId: "idle1",
        label: "注视1",
        duration: 7.47,
        voices: {"cn": {"subtitle": "没必要记挂我的左胳膊，它有时候可比肉体好用多了。你要不要见识一下？", "sound": "sounds/vo_6001_xianliao_03.wav"}, "en": {"subtitle": "没必要记挂我的左胳膊，它有时候可比肉体好用多了。你要不要见识一下？", "sound": "sounds/en_vo_6001_xianliao_03.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 10,
        weight: 10
      },
      {
        showId: 61017014,
        audioId: 60010014,
        audioName: "vo_6001_zanyang",
        desc: "点击-赞扬1",
        group: "Idle",
        index: 2,
        actionId: "idle2",
        label: "注视2",
        duration: 11.9,
        voices: {"cn": {"subtitle": "你一个眼神过来，我就能变成世上最强大的猛兽，没什么能挡住我。", "sound": "sounds/vo_6001_zanyang.wav"}, "en": {"subtitle": "你一个眼神过来，我就能变成世上最强大的猛兽，没什么能挡住我。", "sound": "sounds/en_vo_6001_zanyang.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 10,
        weight: 10
      }
    ]
  },
  {
    id: "102000_mmr",
    title: "预埋角色 102000_mmr 角色候选",
    assetKind: "character",
    categoryLabel: "角色",
    modelDir: "102000_mmr",
    sourceModelDir: "102000_mmr",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "localassets_win32",
    styleId: "",
    styleName: "预埋角色 102000_mmr",
    stage: "角色候选",
    hitAreaNames: ["HitAreaHand", "HitAreaMoren", "HitAreaHead", "HitAreaBody"],
    followConfigs: [{"id": 1023, "prefab": "102000_mmr", "activeName": "", "expressionName": "", "damping": 0.0, "parameters": [{"parameterId": "ParamAngleX", "axis": "X", "factor": 40.0, "sourceToken": "ParamAngleX#40*X"}, {"parameterId": "ParamAngleY", "axis": "Y", "factor": 30.0, "sourceToken": "ParamAngleY#30*Y"}, {"parameterId": "ParamEyeBallX", "axis": "X", "factor": 30.0, "sourceToken": "ParamEyeBallX#30*X"}, {"parameterId": "ParamEyeBallY", "axis": "Y", "factor": 20.0, "sourceToken": "ParamEyeBallY#20*Y"}, {"parameterId": "ParamBodyAngleX", "axis": "X", "factor": 20.0, "sourceToken": "ParamBodyAngleX#20*X"}, {"parameterId": "ParamBodyMae", "axis": "Y", "factor": 10.0, "sourceToken": "ParamBodyMae#10*Y"}]}],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 6.0 }
        ]
      },
      {
        label: "TapBody",
        actions: [
          { group: "TapBody", index: 0, actionId: "diantou", label: "diantou", duration: 2.967 },
          { group: "TapBody", index: 1, actionId: "houyang", label: "houyang", duration: 4.0 },
          { group: "TapBody", index: 2, actionId: "qianqing", label: "qianqing", duration: 4.667 },
          { group: "TapBody", index: 3, actionId: "waitou", label: "waitou", duration: 3.667 },
          { group: "TapBody", index: 4, actionId: "walk", label: "walk", duration: 2.0 },
          { group: "TapBody", index: 5, actionId: "yaotou", label: "yaotou", duration: 3.0 }
        ]
      }
    ],
    clickShowActions: [

    ]
  },
  {
    id: "102100_yx",
    title: "雨仙 角色立绘",
    assetKind: "character",
    categoryLabel: "角色",
    modelDir: "102100_yx",
    sourceModelDir: "102100_yx",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "localassets_win32",
    styleId: "",
    styleName: "雨仙",
    stage: "角色立绘",
    hitAreaNames: ["HitAreaHandL", "HitAreaBody", "HitAreaHandR", "HitAreaChange_ParamDiyYanZhao", "HitAreaMoren", "HitAreaHead"],
    followConfigs: [{"id": 1047, "prefab": "102100_yx", "activeName": "", "expressionName": "", "damping": 0.0, "parameters": [{"parameterId": "ParamEyeBallX", "axis": "X", "factor": 30.0, "sourceToken": "ParamEyeBallX#30*X"}, {"parameterId": "ParamEyeBallY", "axis": "Y", "factor": 50.0, "sourceToken": "ParamEyeBallY#50*Y"}, {"parameterId": "ParamAngleX", "axis": "X", "factor": 8.0, "sourceToken": "ParamAngleX#8*X"}, {"parameterId": "ParamAngleY", "axis": "Y", "factor": 40.0, "sourceToken": "ParamAngleY#40*Y"}, {"parameterId": "ParamBodyAngleX", "axis": "X", "factor": 9.0, "sourceToken": "ParamBodyAngleX#9*X"}, {"parameterId": "ParamBodyMae", "axis": "Y", "factor": -10.0, "sourceToken": "ParamBodyMae#-10*Y"}]}],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 6.0 }
        ]
      },
      {
        label: "TapBody",
        actions: [
          { group: "TapBody", index: 0, actionId: "diantou", label: "diantou", duration: 2.571 },
          { group: "TapBody", index: 1, actionId: "houyang", label: "houyang", duration: 2.914 },
          { group: "TapBody", index: 2, actionId: "jingshu", label: "jingshu", duration: 6.0 },
          { group: "TapBody", index: 3, actionId: "qiancheng", label: "qiancheng", duration: 6.0 },
          { group: "TapBody", index: 4, actionId: "qianqing", label: "qianqing", duration: 3.429 },
          { group: "TapBody", index: 5, actionId: "waitou", label: "waitou", duration: 3.75 },
          { group: "TapBody", index: 6, actionId: "walk", label: "walk", duration: 2.286 },
          { group: "TapBody", index: 7, actionId: "yaoqing", label: "yaoqing", duration: 6.5 },
          { group: "TapBody", index: 8, actionId: "yaotou", label: "yaotou", duration: 2.571 }
        ]
      }
    ],
    clickShowActions: [
      {
        showId: 601601010,
        audioId: 60160004,
        audioName: "vo_6016_daiji_01",
        desc: "点击-通用1",
        group: "Idle",
        index: 0,
        actionId: "idle",
        label: "默认",
        duration: 6.0,
        voices: {"cn": {"subtitle": "有人问过我，太阳最大时雨神在哪。世人只能看到表象，但神明的目光不会被任何存在遮挡，正如人的罪，也不会被衣冠钱财掩盖。", "sound": "sounds/vo_6016_daiji_01.wav"}, "en": {"subtitle": "有人问过我，太阳最大时雨神在哪。世人只能看到表象，但神明的目光不会被任何存在遮挡，正如人的罪，也不会被衣冠钱财掩盖。", "sound": "sounds/en_vo_6016_daiji_01.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 601601011,
        audioId: 60160005,
        audioName: "vo_6016_daiji_02",
        desc: "点击-通用2",
        group: "TapBody",
        index: 5,
        actionId: "waitou",
        label: "waitou",
        duration: 3.75,
        voices: {"cn": {"subtitle": "外面世界的人下班后都在做什么？执事告诉我很多人会去一个叫“酒馆”的地方。它和圣堂的告解室功能是一样的吗？", "sound": "sounds/vo_6016_daiji_02.wav"}, "en": {"subtitle": "外面世界的人下班后都在做什么？执事告诉我很多人会去一个叫“酒馆”的地方。它和圣堂的告解室功能是一样的吗？", "sound": "sounds/en_vo_6016_daiji_02.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 601601012,
        audioId: 60160010,
        audioName: "vo_6016_xianliao_01",
        desc: "点击-闲聊1",
        group: "TapBody",
        index: 8,
        actionId: "yaotou",
        label: "yaotou",
        duration: 2.571,
        voices: {"cn": {"subtitle": "规则，教义，信仰……不过是些精致的锁链。只要轻轻拨动其中的一环，所有人都会像提线木偶一样起舞。", "sound": "sounds/vo_6016_xianliao_01.wav"}, "en": {"subtitle": "规则，教义，信仰……不过是些精致的锁链。只要轻轻拨动其中的一环，所有人都会像提线木偶一样起舞。", "sound": "sounds/en_vo_6016_xianliao_01.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 601601013,
        audioId: 60160011,
        audioName: "vo_6016_xianliao_02",
        desc: "点击-闲聊2",
        group: "Idle",
        index: 0,
        actionId: "idle",
        label: "默认",
        duration: 6.0,
        voices: {"cn": {"subtitle": "净雨之庭的饭菜大多淡而无味，你提过的“可乐”，据说喝起来像舌尖在下暴雨，我很好奇那种感觉。", "sound": "sounds/vo_6016_xianliao_02.wav"}, "en": {"subtitle": "净雨之庭的饭菜大多淡而无味，你提过的“可乐”，据说喝起来像舌尖在下暴雨，我很好奇那种感觉。", "sound": "sounds/en_vo_6016_xianliao_02.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 601601014,
        audioId: 60160012,
        audioName: "vo_6016_xianliao_03",
        desc: "点击-闲聊3",
        group: "TapBody",
        index: 2,
        actionId: "jingshu",
        label: "jingshu",
        duration: 6.0,
        voices: {"cn": {"subtitle": "雨滴落下的轨迹，就像凡人被写好的命运。看似自由，实则早已注定。", "sound": "sounds/vo_6016_xianliao_03.wav"}, "en": {"subtitle": "雨滴落下的轨迹，就像凡人被写好的命运。看似自由，实则早已注定。", "sound": "sounds/en_vo_6016_xianliao_03.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 601601015,
        audioId: 60160014,
        audioName: "vo_6016_zanyang",
        desc: "点击-赞扬1",
        group: "TapBody",
        index: 5,
        actionId: "waitou",
        label: "waitou",
        duration: 3.75,
        voices: {"cn": {"subtitle": "你从不祈求神明，因为你只相信你自己。这份傲慢，让我无比着迷。", "sound": "sounds/vo_6016_zanyang.wav"}, "en": {"subtitle": "你从不祈求神明，因为你只相信你自己。这份傲慢，让我无比着迷。", "sound": "sounds/en_vo_6016_zanyang.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 601601016,
        audioId: 60160006,
        audioName: "vo_6016_dianchu_tou",
        desc: "点击-头",
        group: "TapBody",
        index: 1,
        actionId: "houyang",
        label: "houyang",
        duration: 2.914,
        voices: {"cn": {"subtitle": "你这是……圣子之间可不是靠摸头来传递神谕的。", "sound": "sounds/vo_6016_dianchu_tou.wav"}, "en": {"subtitle": "你这是……圣子之间可不是靠摸头来传递神谕的。", "sound": "sounds/en_vo_6016_dianchu_tou.wav"}},
        hitAreaParam: "HitAreaHead",
        hitAreas: ["HitAreaHead"],
        sourceType2: 401,
        sourceWeight: 20,
        weight: 20
      },
      {
        showId: 601601017,
        audioId: 60160007,
        audioName: "vo_6016_dianchu_shou",
        desc: "点击-手",
        group: "TapBody",
        index: 7,
        actionId: "yaoqing",
        label: "yaoqing",
        duration: 6.5,
        voices: {"cn": {"subtitle": "信众亲吻这双手，将我的一举一动视作神明意志的延伸，你呢？", "sound": "sounds/vo_6016_dianchu_shou.wav"}, "en": {"subtitle": "信众亲吻这双手，将我的一举一动视作神明意志的延伸，你呢？", "sound": "sounds/en_vo_6016_dianchu_shou.wav"}},
        hitAreaParam: "HitAreaHandL#HitAreaHandR",
        hitAreas: ["HitAreaHandL", "HitAreaHandR"],
        sourceType2: 401,
        sourceWeight: 20,
        weight: 20
      },
      {
        showId: 601601018,
        audioId: 60160008,
        audioName: "vo_6016_dianchu_shen",
        desc: "点击-胸",
        group: "TapBody",
        index: 3,
        actionId: "qiancheng",
        label: "qiancheng",
        duration: 6.0,
        voices: {"cn": {"subtitle": "有时我要斋戒，为了让身体空一些，好装下别的东西，比如一个新的决定，或者一场新雨。", "sound": "sounds/vo_6016_dianchu_shen.wav"}, "en": {"subtitle": "有时我要斋戒，为了让身体空一些，好装下别的东西，比如一个新的决定，或者一场新雨。", "sound": "sounds/en_vo_6016_dianchu_shen.wav"}},
        hitAreaParam: "HitAreaBody",
        hitAreas: ["HitAreaBody"],
        sourceType2: 401,
        sourceWeight: 20,
        weight: 20
      }
    ]
  },
  {
    id: "102100_yx_cg",
    title: "净世雨 一段",
    assetKind: "style",
    categoryLabel: "风格",
    modelDir: "102100_yx_cg",
    sourceModelDir: "102100_yx_cg",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "localassets_win32",
    styleId: "13001021",
    styleName: "净世雨",
    stage: "一段",
    hitAreaNames: ["HitAreagensui", "HitAreaquanbu"],
    followConfigs: [{"id": 21021, "prefab": "102100_yx_cg", "activeName": "HitAreagensui", "expressionName": "", "damping": 0.0, "parameters": [{"parameterId": "Param8", "axis": "Y", "factor": 50.0, "sourceToken": "Param8#50*Y"}, {"parameterId": "Param11", "axis": "Y", "factor": 50.0, "sourceToken": "Param11#50*Y"}, {"parameterId": "Param16", "axis": "X", "factor": 25.0, "sourceToken": "Param16#25*X"}, {"parameterId": "Param20", "axis": "Y", "factor": 25.0, "sourceToken": "Param20#25*Y"}, {"parameterId": "Param150", "axis": "X", "factor": 25.0, "sourceToken": "Param150#25*X"}, {"parameterId": "Param148", "axis": "Y", "factor": 50.0, "sourceToken": "Param148#50*Y"}, {"parameterId": "Param66", "axis": "X", "factor": 10.0, "sourceToken": "Param66#10*X"}, {"parameterId": "ParamEyeBallX", "axis": "X", "factor": 20.0, "sourceToken": "ParamEyeBallX#20*X"}, {"parameterId": "ParamEyeBallY", "axis": "Y", "factor": 50.0, "sourceToken": "ParamEyeBallY#50*Y"}, {"parameterId": "ParamAngleX", "axis": "X", "factor": 15.0, "sourceToken": "ParamAngleX#15*X"}, {"parameterId": "ParamAngleY", "axis": "Y", "factor": 50.0, "sourceToken": "ParamAngleY#50*Y"}, {"parameterId": "ParamAngleX", "axis": "X", "factor": 10.0, "sourceToken": "ParamAngleX#10*X"}, {"parameterId": "ParamAngleY", "axis": "Y", "factor": 5.0, "sourceToken": "ParamAngleY#5*Y"}]}, {"id": 21026, "prefab": "102100_yx_cg", "activeName": "", "expressionName": "", "damping": 0.0, "parameters": [{"parameterId": "ParamEyeBallX", "axis": "X", "factor": 35.0, "sourceToken": "ParamEyeBallX#35*X"}, {"parameterId": "ParamEyeBallY", "axis": "Y", "factor": 50.0, "sourceToken": "ParamEyeBallY#50*Y"}, {"parameterId": "ParamAngleX", "axis": "X", "factor": 50.0, "sourceToken": "ParamAngleX#50*X"}, {"parameterId": "ParamAngleY", "axis": "Y", "factor": 50.0, "sourceToken": "ParamAngleY#50*Y"}]}],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 7.0 },
          { group: "Idle", index: 1, actionId: "idle1", label: "注视1", duration: 9.267 },
          { group: "Idle", index: 2, actionId: "idle2", label: "注视2", duration: 8.4 }
        ]
      },
      {
        label: "入场",
        actions: [
          { group: "Entry", index: 0, actionId: "ruchang", label: "入场", duration: 11.2 }
        ]
      }
    ],
    clickShowActions: [
      {
        showId: 61021007,
        audioId: 10210002,
        audioName: "vo_1021_yiduanchahua_01",
        desc: "点击1",
        group: "Idle",
        index: 1,
        actionId: "idle1",
        label: "注视1",
        duration: 9.267,
        voices: {"cn": {"subtitle": "人们在外面等我念下一段祷文。而你在这里，在圣坛前，逼我把心跳交出来作为呈堂证供。", "sound": "sounds/vo_1021_yiduanchahua_01.wav"}, "en": {"subtitle": "人们在外面等我念下一段祷文。而你在这里，在圣坛前，逼我把心跳交出来作为呈堂证供。", "sound": "sounds/en_vo_1021_yiduanchahua_01.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 20,
        weight: 20
      },
      {
        showId: 61021008,
        audioId: 10210003,
        audioName: "vo_1021_yiduanchahua_02",
        desc: "点击2",
        group: "Idle",
        index: 2,
        actionId: "idle2",
        label: "注视2",
        duration: 8.4,
        voices: {"cn": {"subtitle": "神爱世人，所以我不偏帮任何一方。但如果……你是在向“卡塔西斯”索要特权，你打算拿什么来换？", "sound": "sounds/vo_1021_yiduanchahua_02.wav"}, "en": {"subtitle": "神爱世人，所以我不偏帮任何一方。但如果……你是在向“卡塔西斯”索要特权，你打算拿什么来换？", "sound": "sounds/en_vo_1021_yiduanchahua_02.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 20,
        weight: 20
      },
      {
        showId: 61021009,
        audioId: 60160004,
        audioName: "vo_6016_daiji_01",
        desc: "点击-通用1",
        group: "Idle",
        index: 2,
        actionId: "idle2",
        label: "注视2",
        duration: 8.4,
        voices: {"cn": {"subtitle": "有人问过我，太阳最大时雨神在哪。世人只能看到表象，但神明的目光不会被任何存在遮挡，正如人的罪，也不会被衣冠钱财掩盖。", "sound": "sounds/vo_6016_daiji_01.wav"}, "en": {"subtitle": "有人问过我，太阳最大时雨神在哪。世人只能看到表象，但神明的目光不会被任何存在遮挡，正如人的罪，也不会被衣冠钱财掩盖。", "sound": "sounds/en_vo_6016_daiji_01.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 10,
        weight: 10
      },
      {
        showId: 61021010,
        audioId: 60160005,
        audioName: "vo_6016_daiji_02",
        desc: "点击-通用2",
        group: "Idle",
        index: 1,
        actionId: "idle1",
        label: "注视1",
        duration: 9.267,
        voices: {"cn": {"subtitle": "外面世界的人下班后都在做什么？执事告诉我很多人会去一个叫“酒馆”的地方。它和圣堂的告解室功能是一样的吗？", "sound": "sounds/vo_6016_daiji_02.wav"}, "en": {"subtitle": "外面世界的人下班后都在做什么？执事告诉我很多人会去一个叫“酒馆”的地方。它和圣堂的告解室功能是一样的吗？", "sound": "sounds/en_vo_6016_daiji_02.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 10,
        weight: 10
      }
    ]
  },
  {
    id: "102101_yx",
    title: "预埋角色 102101_yx 角色候选",
    assetKind: "character",
    categoryLabel: "角色",
    modelDir: "102101_yx",
    sourceModelDir: "102101_yx",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "streamingassets",
    styleId: "",
    styleName: "预埋角色 102101_yx",
    stage: "角色候选",
    hitAreaNames: ["HitAreaHandL", "HitAreaBody", "HitAreaMoren", "HitAreaHead", "HitAreaHandR"],
    followConfigs: [],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 5.97 }
        ]
      },
      {
        label: "TapBody",
        actions: [
          { group: "TapBody", index: 0, actionId: "diantou", label: "diantou", duration: 2.571 },
          { group: "TapBody", index: 1, actionId: "houyang", label: "houyang", duration: 2.914 },
          { group: "TapBody", index: 2, actionId: "qiancheng", label: "qiancheng", duration: 6.0 },
          { group: "TapBody", index: 3, actionId: "qianqing", label: "qianqing", duration: 3.43 },
          { group: "TapBody", index: 4, actionId: "waitou", label: "waitou", duration: 3.75 },
          { group: "TapBody", index: 5, actionId: "walk", label: "walk", duration: 2.29 },
          { group: "TapBody", index: 6, actionId: "yaoqing", label: "yaoqing", duration: 6.5 },
          { group: "TapBody", index: 7, actionId: "yaotou", label: "yaotou", duration: 2.571 }
        ]
      }
    ],
    clickShowActions: [

    ]
  },
  {
    id: "102101_yx_cg",
    title: "净世雨 二段",
    assetKind: "style",
    categoryLabel: "风格",
    modelDir: "102101_yx_cg",
    sourceModelDir: "102101_yx_cg",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "localassets_win32",
    styleId: "13001021",
    styleName: "净世雨",
    stage: "二段",
    hitAreaNames: ["HitAreagensui", "HitAreaMoren"],
    followConfigs: [{"id": 21029, "prefab": "102101_yx_cg", "activeName": "HitAreagensui", "expressionName": "gensui01", "damping": 0.4, "parameters": [{"parameterId": "Param94", "axis": "Y", "factor": 6.0, "sourceToken": "Param94#6*Y"}, {"parameterId": "Param115", "axis": "Y", "factor": 25.0, "sourceToken": "Param115#25*Y"}, {"parameterId": "Param26", "axis": "Y", "factor": 2.0, "sourceToken": "Param26#2*Y"}, {"parameterId": "Param27", "axis": "Y", "factor": 4.0, "sourceToken": "Param27#4*Y"}, {"parameterId": "ParamAngleX", "axis": "Y", "factor": 5.0, "sourceToken": "ParamAngleX#5*Y"}, {"parameterId": "ParamAngleZ", "axis": "Y", "factor": -12.0, "sourceToken": "ParamAngleZ#-12*Y"}, {"parameterId": "ParamEyeBallY", "axis": "Y", "factor": 50.0, "sourceToken": "ParamEyeBallY#50*Y"}, {"parameterId": "ParamLArm2z", "axis": "Y", "factor": -2.0, "sourceToken": "ParamLArm2z#-2*Y"}, {"parameterId": "ParamLhandz", "axis": "Y", "factor": 8.0, "sourceToken": "ParamLhandz#8*Y"}, {"parameterId": "ParamLhandx", "axis": "Y", "factor": -15.0, "sourceToken": "ParamLhandx#-15*Y"}, {"parameterId": "ParamLshd", "axis": "Y", "factor": 10.0, "sourceToken": "ParamLshd#10*Y"}]}],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [],
    storyTouchActions: [],
    unlockableMotions: [
      { group: "TapBody", index: 0, actionId: "dongzuo1", label: "亲近1", duration: 16.0 },
      { group: "TapBody", index: 1, actionId: "dongzuo2", label: "亲近2", duration: 19.333 },
      { group: "TapBody", index: 2, actionId: "dongzuo3", label: "亲近3", duration: 14.667 }
    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 11.967 },
          { group: "Idle", index: 1, actionId: "idle1", label: "注视1", duration: 16.0 },
          { group: "Idle", index: 2, actionId: "idle2", label: "注视2", duration: 13.133 }
        ]
      },
      {
        label: "TapBody",
        actions: [
          { group: "TapBody", index: 0, actionId: "dongzuo1", label: "亲近1", duration: 16.0 },
          { group: "TapBody", index: 1, actionId: "dongzuo2", label: "亲近2", duration: 19.333 },
          { group: "TapBody", index: 2, actionId: "dongzuo3", label: "亲近3", duration: 14.667 },
          { group: "TapBody", index: 3, actionId: "loop", label: "loop", duration: 11.967 }
        ]
      },
      {
        label: "入场",
        actions: [
          { group: "Entry", index: 0, actionId: "ruchang", label: "入场", duration: 23.833 }
        ]
      }
    ],
    clickShowActions: [
      {
        showId: 61021055,
        audioId: 10210008,
        audioName: "vo_1021_erduanchahua_03",
        desc: "点击3",
        group: "TapBody",
        index: 0,
        actionId: "dongzuo1",
        label: "亲近1",
        duration: 16.0,
        voices: {"cn": {"subtitle": "如若你不肯接受光明，那就和我一起，在雨夜的蒙昧里沉沦吧。", "sound": "sounds/vo_1021_erduanchahua_03.wav"}, "en": {"subtitle": "如若你不肯接受光明，那就和我一起，在雨夜的蒙昧里沉沦吧。", "sound": "sounds/en_vo_1021_erduanchahua_03.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 20,
        weight: 20
      },
      {
        showId: 61021056,
        audioId: 10210009,
        audioName: "vo_1021_erduanchahua_04",
        desc: "点击4",
        group: "TapBody",
        index: 1,
        actionId: "dongzuo2",
        label: "亲近2",
        duration: 19.333,
        voices: {"cn": {"subtitle": "多美丽的色泽。等它完全被我的雨水浸透，你就会彻底属于我了。", "sound": "sounds/vo_1021_erduanchahua_04.wav"}, "en": {"subtitle": "多美丽的色泽。等它完全被我的雨水浸透，你就会彻底属于我了。", "sound": "sounds/en_vo_1021_erduanchahua_04.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 20,
        weight: 20
      },
      {
        showId: 61021057,
        audioId: 10210010,
        audioName: "vo_1021_erduanchahua_05",
        desc: "点击5",
        group: "TapBody",
        index: 2,
        actionId: "dongzuo3",
        label: "亲近3",
        duration: 14.667,
        voices: {"cn": {"subtitle": "好了，仪式完成。接下来这个吻，不在任何经文上。是属于我的。", "sound": "sounds/vo_1021_erduanchahua_05.wav"}, "en": {"subtitle": "好了，仪式完成。接下来这个吻，不在任何经文上。是属于我的。", "sound": "sounds/en_vo_1021_erduanchahua_05.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 20,
        weight: 20
      },
      {
        showId: 61021059,
        audioId: 10210006,
        audioName: "vo_1021_erduanchahua_01",
        desc: "点击1",
        group: "Idle",
        index: 1,
        actionId: "idle1",
        label: "注视1",
        duration: 16.0,
        voices: {"cn": {"subtitle": "洗净她，用冰冷的雨冲刷她的意志……让她忘记执念，只念诵神名和我名……", "sound": "sounds/vo_1021_erduanchahua_01.wav"}, "en": {"subtitle": "洗净她，用冰冷的雨冲刷她的意志……让她忘记执念，只念诵神名和我名……", "sound": "sounds/en_vo_1021_erduanchahua_01.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 10,
        weight: 10
      },
      {
        showId: 61021060,
        audioId: 10210007,
        audioName: "vo_1021_erduanchahua_02",
        desc: "点击2",
        group: "Idle",
        index: 2,
        actionId: "idle2",
        label: "注视2",
        duration: 13.133,
        voices: {"cn": {"subtitle": "偏过头来。既然不愿看高高在上的神像，那就好好聆听我的祷告。", "sound": "sounds/vo_1021_erduanchahua_02.wav"}, "en": {"subtitle": "偏过头来。既然不愿看高高在上的神像，那就好好聆听我的祷告。", "sound": "sounds/en_vo_1021_erduanchahua_02.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 10,
        weight: 10
      },
      {
        showId: 61021061,
        audioId: 60160004,
        audioName: "vo_6016_daiji_01",
        desc: "点击-通用1",
        group: "Idle",
        index: 1,
        actionId: "idle1",
        label: "注视1",
        duration: 16.0,
        voices: {"cn": {"subtitle": "有人问过我，太阳最大时雨神在哪。世人只能看到表象，但神明的目光不会被任何存在遮挡，正如人的罪，也不会被衣冠钱财掩盖。", "sound": "sounds/vo_6016_daiji_01.wav"}, "en": {"subtitle": "有人问过我，太阳最大时雨神在哪。世人只能看到表象，但神明的目光不会被任何存在遮挡，正如人的罪，也不会被衣冠钱财掩盖。", "sound": "sounds/en_vo_6016_daiji_01.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      }
    ]
  },
  {
    id: "102500_yl",
    title: "预埋角色 102500_yl 角色候选",
    assetKind: "character",
    categoryLabel: "角色",
    modelDir: "102500_yl",
    sourceModelDir: "102500_yl",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "streamingassets",
    styleId: "",
    styleName: "预埋角色 102500_yl",
    stage: "角色候选",
    hitAreaNames: ["HitAreaHead", "HitAreaBody", "HitAreaHandR", "HitAreaHandL", "HitAreaMoren"],
    followConfigs: [{"id": 1022, "prefab": "102500_yl", "activeName": "", "expressionName": "", "damping": 0.0, "parameters": [{"parameterId": "ParamAngleX", "axis": "X", "factor": 50.0, "sourceToken": "ParamAngleX#50*X"}, {"parameterId": "ParamAngleY", "axis": "Y", "factor": 30.0, "sourceToken": "ParamAngleY#30*Y"}, {"parameterId": "ParamEyeBallX", "axis": "X", "factor": 70.0, "sourceToken": "ParamEyeBallX#70*X"}, {"parameterId": "ParamEyeBallY", "axis": "Y", "factor": 50.0, "sourceToken": "ParamEyeBallY#50*Y"}, {"parameterId": "ParamBodyAngleX", "axis": "X", "factor": 30.0, "sourceToken": "ParamBodyAngleX#30*X"}, {"parameterId": "ParamBodyMae", "axis": "Y", "factor": -5.0, "sourceToken": "ParamBodyMae#-5*Y"}]}],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 6.0 }
        ]
      },
      {
        label: "TapBody",
        actions: [
          { group: "TapBody", index: 0, actionId: "diantou", label: "diantou", duration: 3.0 },
          { group: "TapBody", index: 1, actionId: "piaofu", label: "piaofu", duration: 6.0 },
          { group: "TapBody", index: 2, actionId: "shifa", label: "shifa", duration: 4.0 },
          { group: "TapBody", index: 3, actionId: "waitou", label: "waitou", duration: 4.0 },
          { group: "TapBody", index: 4, actionId: "yaotou", label: "yaotou", duration: 3.0 }
        ]
      }
    ],
    clickShowActions: [

    ]
  },
  {
    id: "102500_yl_cg",
    title: "复仇童谣 一段",
    assetKind: "style",
    categoryLabel: "风格",
    modelDir: "102500_yl_cg",
    sourceModelDir: "102500_yl_cg",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "localassets_win32",
    styleId: "13001025",
    styleName: "复仇童谣",
    stage: "一段",
    hitAreaNames: ["HitAreagensui", "HitAreaquanbu"],
    followConfigs: [{"id": 21005, "prefab": "102500_yl_cg", "activeName": "HitAreagensui", "expressionName": "gensui01", "damping": 0.0, "parameters": [{"parameterId": "ParamAngleX", "axis": "X", "factor": 20.0, "sourceToken": "ParamAngleX#20*X"}, {"parameterId": "ParamAngleY", "axis": "Y", "factor": 10.0, "sourceToken": "ParamAngleY#10*Y"}, {"parameterId": "ParamEyeBallX", "axis": "X", "factor": 5.0, "sourceToken": "ParamEyeBallX#5*X"}, {"parameterId": "ParamEyeBallY", "axis": "Y", "factor": 5.0, "sourceToken": "ParamEyeBallY#5*Y"}, {"parameterId": "ParamBodyAngleX", "axis": "X", "factor": 20.0, "sourceToken": "ParamBodyAngleX#20*X"}, {"parameterId": "ParamBodyAngleY", "axis": "Y", "factor": 5.0, "sourceToken": "ParamBodyAngleY#5*Y"}, {"parameterId": "Param117", "axis": "Y", "factor": 20.0, "sourceToken": "Param117#20*20Y"}, {"parameterId": "Param118", "axis": "X", "factor": 2.0, "sourceToken": "Param118#2*X"}, {"parameterId": "Param119", "axis": "Y", "factor": 3.0, "sourceToken": "Param119#3*Y"}, {"parameterId": "Param73", "axis": "X", "factor": 15.0, "sourceToken": "Param73#15*X"}, {"parameterId": "Param74", "axis": "Y", "factor": 13.0, "sourceToken": "Param74#13*Y"}, {"parameterId": "Param77", "axis": "X", "factor": 50.0, "sourceToken": "Param77#50*X"}, {"parameterId": "Param101", "axis": "Y", "factor": 50.0, "sourceToken": "Param101#50*Y"}, {"parameterId": "Param70", "axis": "X", "factor": 7.0, "sourceToken": "Param70#7*X"}, {"parameterId": "Param56", "axis": "Y", "factor": 7.0, "sourceToken": "Param56#7*Y"}, {"parameterId": "Param62", "axis": "Y", "factor": -10.0, "sourceToken": "Param62#-10*Y"}]}],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 12.0 },
          { group: "Idle", index: 1, actionId: "idle1", label: "注视1", duration: 7.5 },
          { group: "Idle", index: 2, actionId: "idle2", label: "注视2", duration: 8.233 }
        ]
      },
      {
        label: "入场",
        actions: [
          { group: "Entry", index: 0, actionId: "ruchang", label: "入场", duration: 15.067 }
        ]
      }
    ],
    clickShowActions: [
      {
        showId: 61025009,
        audioId: 10250002,
        audioName: "vo_1025_yiduanchahua_01",
        desc: "点击1",
        group: "Idle",
        index: 1,
        actionId: "idle1",
        label: "注视1",
        duration: 7.5,
        voices: {"cn": {"subtitle": "如果我告诉您，刚才是本能反应，您会笑话我吗？", "sound": "sounds/vo_1025_yiduanchahua_01.wav"}, "en": {"subtitle": "如果我告诉您，刚才是本能反应，您会笑话我吗？", "sound": "sounds/en_vo_1025_yiduanchahua_01.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 20,
        weight: 20
      },
      {
        showId: 61025010,
        audioId: 10250003,
        audioName: "vo_1025_yiduanchahua_02",
        desc: "点击2",
        group: "Idle",
        index: 2,
        actionId: "idle2",
        label: "注视2",
        duration: 8.233,
        voices: {"cn": {"subtitle": "您是不是已经看穿了我的小把戏呢？却还一直纵容我……", "sound": "sounds/vo_1025_yiduanchahua_02.wav"}, "en": {"subtitle": "您是不是已经看穿了我的小把戏呢？却还一直纵容我……", "sound": "sounds/en_vo_1025_yiduanchahua_02.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 20,
        weight: 20
      },
      {
        showId: 61025011,
        audioId: 60070004,
        audioName: "vo_6007_daiji_01",
        desc: "点击-通用1",
        group: "Idle",
        index: 2,
        actionId: "idle2",
        label: "注视2",
        duration: 8.233,
        voices: {"cn": {"subtitle": "我会恰到好处地示弱，您负责心软；这正是我们的默契，不是吗？", "sound": "sounds/vo_6007_daiji_01.wav"}, "en": {"subtitle": "我会恰到好处地示弱，您负责心软；这正是我们的默契，不是吗？", "sound": "sounds/en_vo_6007_daiji_01.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 10,
        weight: 10
      },
      {
        showId: 61025012,
        audioId: 60070010,
        audioName: "vo_6007_xianliao_01",
        desc: "点击-闲聊1",
        group: "Idle",
        index: 2,
        actionId: "idle2",
        label: "注视2",
        duration: 8.233,
        voices: {"cn": {"subtitle": "您觉得我是个温柔的人？原来您也有判断失误的时候。", "sound": "sounds/vo_6007_xianliao_01.wav"}, "en": {"subtitle": "您觉得我是个温柔的人？原来您也有判断失误的时候。", "sound": "sounds/en_vo_6007_xianliao_01.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 10,
        weight: 10
      },
      {
        showId: 61025013,
        audioId: 60070011,
        audioName: "vo_6007_xianliao_02",
        desc: "点击-闲聊2",
        group: "Idle",
        index: 1,
        actionId: "idle1",
        label: "注视1",
        duration: 7.5,
        voices: {"cn": {"subtitle": "您好奇我长大的地方？一座孤儿院，我在那里学会了很多。比如用厨师的把柄换面包，给幽会的仆人望风……诸如此类。", "sound": "sounds/vo_6007_xianliao_02.wav"}, "en": {"subtitle": "您好奇我长大的地方？一座孤儿院，我在那里学会了很多。比如用厨师的把柄换面包，给幽会的仆人望风……诸如此类。", "sound": "sounds/en_vo_6007_xianliao_02.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 10,
        weight: 10
      },
      {
        showId: 61025014,
        audioId: 60070014,
        audioName: "vo_6007_zanyang",
        desc: "点击-赞扬1",
        group: "Idle",
        index: 2,
        actionId: "idle2",
        label: "注视2",
        duration: 8.233,
        voices: {"cn": {"subtitle": "在您身边久了，会让我忘记自己其实是擅长撒谎的骗子。", "sound": "sounds/vo_6007_zanyang.wav"}, "en": {"subtitle": "在您身边久了，会让我忘记自己其实是擅长撒谎的骗子。", "sound": "sounds/en_vo_6007_zanyang.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 10,
        weight: 10
      }
    ]
  },
  {
    id: "102600_zc",
    title: "预埋角色 102600_zc 角色候选",
    assetKind: "character",
    categoryLabel: "角色",
    modelDir: "102600_zc",
    sourceModelDir: "102600_zc",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "streamingassets",
    styleId: "",
    styleName: "预埋角色 102600_zc",
    stage: "角色候选",
    hitAreaNames: ["HitAreaHead", "HitAreaHandR", "HitAreaMoren", "HitAreaBody", "HitAreaHandL"],
    followConfigs: [{"id": 1027, "prefab": "102600_zc", "activeName": "", "expressionName": "", "damping": 0.0, "parameters": [{"parameterId": "ParamAngleX", "axis": "X", "factor": 20.0, "sourceToken": "ParamAngleX#20*X"}, {"parameterId": "ParamAngleY", "axis": "Y", "factor": 20.0, "sourceToken": "ParamAngleY#20*Y"}, {"parameterId": "ParamEyeBallX", "axis": "X", "factor": 60.0, "sourceToken": "ParamEyeBallX#60*X"}, {"parameterId": "ParamEyeBallY", "axis": "Y", "factor": 40.0, "sourceToken": "ParamEyeBallY#40*Y"}, {"parameterId": "ParamBodyAngleX", "axis": "X", "factor": 30.0, "sourceToken": "ParamBodyAngleX#30*X"}, {"parameterId": "ParamBodyAngleY", "axis": "Y", "factor": 50.0, "sourceToken": "ParamBodyAngleY#50*Y"}]}],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 6.0 }
        ]
      },
      {
        label: "TapBody",
        actions: [
          { group: "TapBody", index: 0, actionId: "diantou", label: "diantou", duration: 2.571 },
          { group: "TapBody", index: 1, actionId: "waitou", label: "waitou", duration: 2.812 },
          { group: "TapBody", index: 2, actionId: "walk", label: "walk", duration: 1.714 },
          { group: "TapBody", index: 3, actionId: "woquan", label: "woquan", duration: 3.0 },
          { group: "TapBody", index: 4, actionId: "yaotou", label: "yaotou", duration: 2.571 }
        ]
      }
    ],
    clickShowActions: [

    ]
  },
  {
    id: "102700_jj",
    title: "预埋角色 102700_jj 角色候选",
    assetKind: "character",
    categoryLabel: "角色",
    modelDir: "102700_jj",
    sourceModelDir: "102700_jj",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "localassets_win32",
    styleId: "",
    styleName: "预埋角色 102700_jj",
    stage: "角色候选",
    hitAreaNames: ["HitAreaBody", "HitAreaHead", "HitAreaHandR", "HitAreaHandL", "HitAreaMoren"],
    followConfigs: [{"id": 1022, "prefab": "102700_jj", "activeName": "", "expressionName": "", "damping": 0.0, "parameters": [{"parameterId": "ParamAngleX", "axis": "X", "factor": 50.0, "sourceToken": "ParamAngleX#50*X"}, {"parameterId": "ParamAngleY", "axis": "Y", "factor": 30.0, "sourceToken": "ParamAngleY#30*Y"}, {"parameterId": "ParamEyeBallX", "axis": "X", "factor": 70.0, "sourceToken": "ParamEyeBallX#70*X"}, {"parameterId": "ParamEyeBallY", "axis": "Y", "factor": 50.0, "sourceToken": "ParamEyeBallY#50*Y"}, {"parameterId": "ParamBodyAngleX", "axis": "X", "factor": 30.0, "sourceToken": "ParamBodyAngleX#30*X"}, {"parameterId": "ParamBodyMae", "axis": "Y", "factor": -5.0, "sourceToken": "ParamBodyMae#-5*Y"}]}],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 5.967 }
        ]
      },
      {
        label: "TapBody",
        actions: [
          { group: "TapBody", index: 0, actionId: "diantou", label: "diantou", duration: 2.967 },
          { group: "TapBody", index: 1, actionId: "houyang", label: "houyang", duration: 2.967 },
          { group: "TapBody", index: 2, actionId: "qianqing", label: "qianqing", duration: 4.0 },
          { group: "TapBody", index: 3, actionId: "shuaipifeng", label: "shuaipifeng", duration: 5.033 },
          { group: "TapBody", index: 4, actionId: "waitou", label: "waitou", duration: 2.967 },
          { group: "TapBody", index: 5, actionId: "walk", label: "walk", duration: 2.0 },
          { group: "TapBody", index: 6, actionId: "walk_1", label: "walk_1", duration: 1.967 },
          { group: "TapBody", index: 7, actionId: "yaotou", label: "yaotou", duration: 3.0 },
          { group: "TapBody", index: 8, actionId: "zhenshe", label: "zhenshe", duration: 2.967 },
          { group: "TapBody", index: 9, actionId: "zhenshe_1", label: "zhenshe_1", duration: 3.4 }
        ]
      }
    ],
    clickShowActions: [

    ]
  },
  {
    id: "102700_jj_cg",
    title: "雷霆统帅 一段",
    assetKind: "style",
    categoryLabel: "风格",
    modelDir: "102700_jj_cg",
    sourceModelDir: "102700_jj_cg",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "streamingassets",
    styleId: "13001027",
    styleName: "雷霆统帅",
    stage: "一段",
    hitAreaNames: ["HitAreaMoren"],
    followConfigs: [{"id": 21012, "prefab": "102700_jj_cg", "activeName": "", "expressionName": "", "damping": 0.0, "parameters": [{"parameterId": "ParamAngleX", "axis": "X", "factor": 15.0, "sourceToken": "ParamAngleX#15*X"}, {"parameterId": "ParamAngleY", "axis": "Y", "factor": 30.0, "sourceToken": "ParamAngleY#30*Y"}, {"parameterId": "ParamAngleZ", "axis": "X", "factor": 12.0, "sourceToken": "ParamAngleZ#12*X"}, {"parameterId": "ParamAngleZ2", "axis": "Y", "factor": 25.0, "sourceToken": "ParamAngleZ2#25*Y"}, {"parameterId": "ParamEyeLOpen", "axis": "X", "factor": -10.0, "sourceToken": "ParamEyeLOpen#-10*X"}, {"parameterId": "ParamEyeROpen", "axis": "X", "factor": -10.0, "sourceToken": "ParamEyeROpen#-10*X"}, {"parameterId": "ParamEyeBallX", "axis": "X", "factor": -25.0, "sourceToken": "ParamEyeBallX#-25*X"}, {"parameterId": "ParamEyeBallY", "axis": "Y", "factor": -60.0, "sourceToken": "ParamEyeBallY#-60*Y"}, {"parameterId": "ParamBodyAngleX", "axis": "X", "factor": 3.0, "sourceToken": "ParamBodyAngleX#3*X"}, {"parameterId": "ParamBodyAngleY", "axis": "Y", "factor": 6.0, "sourceToken": "ParamBodyAngleY#6*Y"}, {"parameterId": "ParamBodyAngleZ", "axis": "X", "factor": 4.0, "sourceToken": "ParamBodyAngleZ#4*X"}, {"parameterId": "ParamKataL", "axis": "X", "factor": -35.0, "sourceToken": "ParamKataL#-35*X"}, {"parameterId": "ParamArmL2", "axis": "X", "factor": -15.0, "sourceToken": "ParamArmL2#-15*X"}, {"parameterId": "ParamArmL3", "axis": "X", "factor": 17.0, "sourceToken": "ParamArmL3#17*X"}, {"parameterId": "ParamArmL4", "axis": "X", "factor": 50.0, "sourceToken": "ParamArmL4#50*X"}, {"parameterId": "ParamBengdai", "axis": "X", "factor": 25.0, "sourceToken": "ParamBengdai#25*X"}, {"parameterId": "ParamArmL6", "axis": "X", "factor": 40.0, "sourceToken": "ParamArmL6#40*X"}, {"parameterId": "ParamBody", "axis": "X", "factor": 40.0, "sourceToken": "ParamBody#40*X"}, {"parameterId": "ParamArmR", "axis": "X", "factor": -1.0, "sourceToken": "ParamArmR#-1*X"}]}],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 6.0 },
          { group: "Idle", index: 1, actionId: "idle1", label: "注视1", duration: 9.0 },
          { group: "Idle", index: 2, actionId: "idle2", label: "注视2", duration: 9.0 }
        ]
      },
      {
        label: "入场",
        actions: [
          { group: "Entry", index: 0, actionId: "ruchang", label: "入场", duration: 12.167 }
        ]
      }
    ],
    clickShowActions: [
      {
        showId: 61027008,
        audioId: 10270002,
        audioName: "vo_1027_yiduanchahua_01",
        desc: "点击1",
        group: "Idle",
        index: 1,
        actionId: "idle1",
        label: "注视1",
        duration: 9.0,
        voices: {"cn": {"subtitle": "我还记得第一次帮我处理伤口时，你紧张得手都在抖的模样。时间转眼就过去了……", "sound": "sounds/vo_1027_yiduanchahua_01.wav"}, "en": {"subtitle": "我还记得第一次帮我处理伤口时，你紧张得手都在抖的模样。时间转眼就过去了……", "sound": "sounds/en_vo_1027_yiduanchahua_01.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 20,
        weight: 20
      },
      {
        showId: 61027009,
        audioId: 10270003,
        audioName: "vo_1027_yiduanchahua_02",
        desc: "点击2",
        group: "Idle",
        index: 2,
        actionId: "idle2",
        label: "注视2",
        duration: 9.0,
        voices: {"cn": {"subtitle": "好好看着，下次我昏迷时，你得自己动手。", "sound": "sounds/vo_1027_yiduanchahua_02.wav"}, "en": {"subtitle": "好好看着，下次我昏迷时，你得自己动手。", "sound": "sounds/en_vo_1027_yiduanchahua_02.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 20,
        weight: 20
      },
      {
        showId: 61027010,
        audioId: 60080005,
        audioName: "vo_6008_daiji_02",
        desc: "点击-通用2",
        group: "Idle",
        index: 1,
        actionId: "idle1",
        label: "注视1",
        duration: 9.0,
        voices: {"cn": {"subtitle": "别一声不响地离开，我不怕你出事，你一定能应付。但我怕自己没法第一时间赶过去。", "sound": "sounds/vo_6008_daiji_02.wav"}, "en": {"subtitle": "别一声不响地离开，我不怕你出事，你一定能应付。但我怕自己没法第一时间赶过去。", "sound": "sounds/en_vo_6008_daiji_02.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 10,
        weight: 10
      },
      {
        showId: 61027011,
        audioId: 60080010,
        audioName: "vo_6008_xianliao_01",
        desc: "点击-闲聊1",
        group: "Idle",
        index: 2,
        actionId: "idle2",
        label: "注视2",
        duration: 9.0,
        voices: {"cn": {"subtitle": "要求士兵着装整洁不是为了好看。在战场上，一条松脱的皮带，也会变成拖死骑兵的绞索。", "sound": "sounds/vo_6008_xianliao_01.wav"}, "en": {"subtitle": "要求士兵着装整洁不是为了好看。在战场上，一条松脱的皮带，也会变成拖死骑兵的绞索。", "sound": "sounds/en_vo_6008_xianliao_01.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 10,
        weight: 10
      },
      {
        showId: 61027012,
        audioId: 60080011,
        audioName: "vo_6008_xianliao_02",
        desc: "点击-闲聊2",
        group: "Idle",
        index: 1,
        actionId: "idle1",
        label: "注视1",
        duration: 9.0,
        voices: {"cn": {"subtitle": "这里的气候比我故乡舒适。过多的雨水除外，它会让电极装置生锈。", "sound": "sounds/vo_6008_xianliao_02.wav"}, "en": {"subtitle": "这里的气候比我故乡舒适。过多的雨水除外，它会让电极装置生锈。", "sound": "sounds/en_vo_6008_xianliao_02.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 10,
        weight: 10
      }
    ]
  },
  {
    id: "102701_jj_cg",
    title: "雷霆统帅 二段",
    assetKind: "style",
    categoryLabel: "风格",
    modelDir: "102701_jj_cg",
    sourceModelDir: "102701_jj_cg",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "localassets_win32",
    styleId: "13001027",
    styleName: "雷霆统帅",
    stage: "二段",
    hitAreaNames: ["HitAreagensui", "HitAreaquanbu", "HitAreamoren"],
    followConfigs: [{"id": 21014, "prefab": "102701_jj_cg", "activeName": "HitAreagensui", "expressionName": "gensui01", "damping": 0.4, "parameters": [{"parameterId": "ParamAngleY", "axis": "X", "factor": 8.0, "sourceToken": "ParamAngleY#8*X"}, {"parameterId": "ParamAngleZ2", "axis": "X", "factor": 5.0, "sourceToken": "ParamAngleZ2#5*X"}, {"parameterId": "ParamBodyAngleX", "axis": "X", "factor": 2.0, "sourceToken": "ParamBodyAngleX#2*X"}, {"parameterId": "ParamBodyAngleY", "axis": "Y", "factor": 5.0, "sourceToken": "ParamBodyAngleY#5*Y"}, {"parameterId": "ParamBodyAngleY2", "axis": "Y", "factor": 60.0, "sourceToken": "ParamBodyAngleY2#60*Y"}, {"parameterId": "ParamNBodyAngleX", "axis": "Y", "factor": 15.0, "sourceToken": "ParamNBodyAngleX#15*Y"}, {"parameterId": "ParamNBodyAngleY", "axis": "Y", "factor": 10.0, "sourceToken": "ParamNBodyAngleY#10*Y"}, {"parameterId": "ParamNBodyAngleZ2", "axis": "Y", "factor": 2.0, "sourceToken": "ParamNBodyAngleZ2#2*Y"}, {"parameterId": "ParamNshd", "axis": "Y", "factor": 30.0, "sourceToken": "ParamNshd#30*Y"}, {"parameterId": "ParamNRarm1z", "axis": "Y", "factor": 6.0, "sourceToken": "ParamNRarm1z#6*Y"}, {"parameterId": "ParamNRarm2z", "axis": "Y", "factor": -8.0, "sourceToken": "ParamNRarm2z#-8*Y"}, {"parameterId": "ParamNRarm2s", "axis": "Y", "factor": 15.0, "sourceToken": "ParamNRarm2s#15*Y"}, {"parameterId": "ParamNRarm2l", "axis": "Y", "factor": 30.0, "sourceToken": "ParamNRarm2l#30*Y"}, {"parameterId": "ParamRhandz2", "axis": "Y", "factor": 15.0, "sourceToken": "ParamRhandz2#15*Y"}, {"parameterId": "ParamRhandz3", "axis": "Y", "factor": -5.0, "sourceToken": "ParamRhandz3#-5*Y"}, {"parameterId": "ParamRnfg1z1", "axis": "Y", "factor": 10.0, "sourceToken": "ParamRnfg1z1#10*Y"}, {"parameterId": "ParamRfg2z1", "axis": "Y", "factor": 5.0, "sourceToken": "ParamRfg2z1#5*Y"}, {"parameterId": "ParamRfg2z2", "axis": "Y", "factor": 10.0, "sourceToken": "ParamRfg2z2#10*Y"}, {"parameterId": "ParamRfg3z1", "axis": "Y", "factor": 5.0, "sourceToken": "ParamRfg3z1#5*Y"}, {"parameterId": "ParamRfg3z2", "axis": "Y", "factor": 10.0, "sourceToken": "ParamRfg3z2#10*Y"}, {"parameterId": "ParamRfg4z1", "axis": "Y", "factor": 5.0, "sourceToken": "ParamRfg4z1#5*Y"}, {"parameterId": "ParamRfg4z2", "axis": "Y", "factor": 10.0, "sourceToken": "ParamRfg4z2#10*Y"}, {"parameterId": "ParamRfg5z1", "axis": "Y", "factor": 5.0, "sourceToken": "ParamRfg5z1#5*Y"}, {"parameterId": "ParamRfg5z2", "axis": "Y", "factor": 10.0, "sourceToken": "ParamRfg5z2#10*Y"}]}],
    hideGroups: [{"id": "protagonist", "label": "主控", "matchPrefixes": ["N_"], "partIds": ["N_BH", "N_BH1", "N_BH10", "N_BH11", "N_BH12", "N_BH13", "N_BH14", "N_BH2", "N_BH3", "N_BH4", "N_BH5", "N_BH6", "N_BH7", "N_BH8", "N_BH9", "N_Body", "N_Head", "N_Head1", "N_Head11", "N_Head2", "N_Head3", "N_Head4", "N_Leg1", "N_Leg2", "N_Pifeng", "N_Pifeng1", "N_Pifeng2", "N_Pifeng2hl", "N_Pifeng3", "N_Pifeng3hl", "N_Pifeng4", "N_Pifeng5", "N_Pifeng6", "N_Pifeng7", "N_Pifeng8", "N_PifengB", "N_arm", "N_arm1", "N_arm1yy", "N_arm2", "N_armhair", "N_hand"], "drawableIds": ["N_BH", "N_BH1", "N_BH10", "N_BH11", "N_BH12", "N_BH13", "N_BH14", "N_BH2", "N_BH3", "N_BH4", "N_BH5", "N_BH6", "N_BH7", "N_BH8", "N_BH9", "N_Body", "N_Head", "N_Head1", "N_Head11", "N_Head2", "N_Head3", "N_Head4", "N_Leg1", "N_Leg2", "N_Pifeng", "N_Pifeng1", "N_Pifeng2", "N_Pifeng2hl", "N_Pifeng3", "N_Pifeng3hl", "N_Pifeng4", "N_Pifeng5", "N_Pifeng6", "N_Pifeng7", "N_Pifeng8", "N_PifengB", "N_arm", "N_arm1", "N_arm1yy", "N_arm2", "N_armhair", "N_hand"], "confidence": "auto:n_prefix_body_parts", "candidateCount": 52, "semanticCandidateCount": 42}],
    ambientMotion: undefined,
    storySegments: [],
    storyTouchActions: [],
    unlockableMotions: [
      { group: "TapBody", index: 0, actionId: "dongzuo1", label: "亲近1", duration: 12.0 },
      { group: "TapBody", index: 1, actionId: "dongzuo2", label: "亲近2", duration: 14.5 },
      { group: "TapBody", index: 2, actionId: "dongzuo3", label: "亲近3", duration: 16.0 }
    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 12.0 },
          { group: "Idle", index: 1, actionId: "idle1", label: "注视1", duration: 6.5 },
          { group: "Idle", index: 2, actionId: "idle2", label: "注视2", duration: 12.0 }
        ]
      },
      {
        label: "TapBody",
        actions: [
          { group: "TapBody", index: 0, actionId: "dongzuo1", label: "亲近1", duration: 12.0 },
          { group: "TapBody", index: 1, actionId: "dongzuo2", label: "亲近2", duration: 14.5 },
          { group: "TapBody", index: 2, actionId: "dongzuo3", label: "亲近3", duration: 16.0 }
        ]
      },
      {
        label: "入场",
        actions: [
          { group: "Entry", index: 0, actionId: "ruchang", label: "入场", duration: 13.5 }
        ]
      }
    ],
    clickShowActions: [
      {
        showId: 61027055,
        audioId: 10270008,
        audioName: "vo_1027_erduanchahua_03",
        desc: "点击3",
        group: "TapBody",
        index: 0,
        actionId: "dongzuo1",
        label: "亲近1",
        duration: 12.0,
        voices: {"cn": {"subtitle": "嘘……我就在这里，哪儿也不去。", "sound": "sounds/vo_1027_erduanchahua_03.wav"}, "en": {"subtitle": "嘘……我就在这里，哪儿也不去。", "sound": "sounds/en_vo_1027_erduanchahua_03.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 20,
        weight: 20
      },
      {
        showId: 61027056,
        audioId: 10270009,
        audioName: "vo_1027_erduanchahua_04",
        desc: "点击4",
        group: "TapBody",
        index: 1,
        actionId: "dongzuo2",
        label: "亲近2",
        duration: 14.5,
        voices: {"cn": {"subtitle": "我刚才想做什么？真是疯了。", "sound": "sounds/vo_1027_erduanchahua_04.wav"}, "en": {"subtitle": "我刚才想做什么？真是疯了。", "sound": "sounds/en_vo_1027_erduanchahua_04.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 20,
        weight: 20
      },
      {
        showId: 61027057,
        audioId: 10270010,
        audioName: "vo_1027_erduanchahua_05",
        desc: "点击5",
        group: "TapBody",
        index: 2,
        actionId: "dongzuo3",
        label: "亲近3",
        duration: 16.0,
        voices: {"cn": {"subtitle": "败给你了……", "sound": "sounds/vo_1027_erduanchahua_05.wav"}, "en": {"subtitle": "败给你了……", "sound": "sounds/en_vo_1027_erduanchahua_05.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 20,
        weight: 20
      },
      {
        showId: 61027061,
        audioId: 10270006,
        audioName: "vo_1027_erduanchahua_01",
        desc: "点击1",
        group: "Idle",
        index: 1,
        actionId: "idle1",
        label: "注视1",
        duration: 6.5,
        voices: {"cn": {"subtitle": "唔……！", "sound": "sounds/vo_1027_erduanchahua_01.wav"}, "en": {"subtitle": "唔……！", "sound": "sounds/en_vo_1027_erduanchahua_01.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 10,
        weight: 10
      },
      {
        showId: 61027062,
        audioId: 10270007,
        audioName: "vo_1027_erduanchahua_02",
        desc: "点击2",
        group: "Idle",
        index: 2,
        actionId: "idle2",
        label: "注视2",
        duration: 12.0,
        voices: {"cn": {"subtitle": "糟了，居然睡过去了……还好，她没事。", "sound": "sounds/vo_1027_erduanchahua_02.wav"}, "en": {"subtitle": "糟了，居然睡过去了……还好，她没事。", "sound": "sounds/en_vo_1027_erduanchahua_02.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 10,
        weight: 10
      },
      {
        showId: 61027063,
        audioId: 60080005,
        audioName: "vo_6008_daiji_02",
        desc: "点击-通用2",
        group: "Idle",
        index: 2,
        actionId: "idle2",
        label: "注视2",
        duration: 12.0,
        voices: {"cn": {"subtitle": "别一声不响地离开，我不怕你出事，你一定能应付。但我怕自己没法第一时间赶过去。", "sound": "sounds/vo_6008_daiji_02.wav"}, "en": {"subtitle": "别一声不响地离开，我不怕你出事，你一定能应付。但我怕自己没法第一时间赶过去。", "sound": "sounds/en_vo_6008_daiji_02.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 61027064,
        audioId: 60080011,
        audioName: "vo_6008_xianliao_02",
        desc: "点击-闲聊2",
        group: "Idle",
        index: 1,
        actionId: "idle1",
        label: "注视1",
        duration: 6.5,
        voices: {"cn": {"subtitle": "这里的气候比我故乡舒适。过多的雨水除外，它会让电极装置生锈。", "sound": "sounds/vo_6008_xianliao_02.wav"}, "en": {"subtitle": "这里的气候比我故乡舒适。过多的雨水除外，它会让电极装置生锈。", "sound": "sounds/en_vo_6008_xianliao_02.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 61027065,
        audioId: 60080014,
        audioName: "vo_6008_zanyang",
        desc: "点击-赞扬1",
        group: "Idle",
        index: 1,
        actionId: "idle1",
        label: "注视1",
        duration: 6.5,
        voices: {"cn": {"subtitle": "你的成长，比任何胜利都让我感到欣慰。", "sound": "sounds/vo_6008_zanyang.wav"}, "en": {"subtitle": "你的成长，比任何胜利都让我感到欣慰。", "sound": "sounds/en_vo_6008_zanyang.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      }
    ]
  },
  {
    id: "103000_df",
    title: "刀锋 角色立绘",
    assetKind: "character",
    categoryLabel: "角色",
    modelDir: "103000_df",
    sourceModelDir: "103000_df",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "localassets_win32",
    styleId: "",
    styleName: "刀锋",
    stage: "角色立绘",
    hitAreaNames: ["HitAreaBody", "HitAreaHead", "HitAreaMoren", "HitAreaHandR", "HitAreaHandL"],
    followConfigs: [{"id": 1002, "prefab": "103000_df", "activeName": "", "expressionName": "", "damping": 0.0, "parameters": [{"parameterId": "ParamAngleX", "axis": "X", "factor": 20.0, "sourceToken": "ParamAngleX#20*X"}, {"parameterId": "ParamAngleY", "axis": "Y", "factor": 40.0, "sourceToken": "ParamAngleY#40*Y"}, {"parameterId": "ParamEyeBallX", "axis": "X", "factor": 50.0, "sourceToken": "ParamEyeBallX#50*X"}, {"parameterId": "ParamEyeBallY", "axis": "Y", "factor": 50.0, "sourceToken": "ParamEyeBallY#50*Y"}, {"parameterId": "ParamBodyAngleX", "axis": "X", "factor": 20.0, "sourceToken": "ParamBodyAngleX#20*X"}, {"parameterId": "ParamBodyMae", "axis": "Y", "factor": 20.0, "sourceToken": "ParamBodyMae#20*Y"}]}],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 5.967 }
        ]
      },
      {
        label: "TapBody",
        actions: [
          { group: "TapBody", index: 0, actionId: "diantou", label: "diantou", duration: 3.0 },
          { group: "TapBody", index: 1, actionId: "fudao", label: "fudao", duration: 8.3 },
          { group: "TapBody", index: 2, actionId: "judao", label: "judao", duration: 6.0 },
          { group: "TapBody", index: 3, actionId: "judao_1", label: "judao_1", duration: 3.0 },
          { group: "TapBody", index: 4, actionId: "paodao", label: "paodao", duration: 5.433 },
          { group: "TapBody", index: 5, actionId: "qianqing", label: "qianqing", duration: 4.333 },
          { group: "TapBody", index: 6, actionId: "songjian", label: "songjian", duration: 3.0 },
          { group: "TapBody", index: 7, actionId: "walk", label: "walk", duration: 2.0 },
          { group: "TapBody", index: 8, actionId: "yaotou", label: "yaotou", duration: 3.0 }
        ]
      }
    ],
    clickShowActions: [
      {
        showId: 601901010,
        audioId: 60190004,
        audioName: "vo_6019_daiji_01",
        desc: "点击-通用1",
        group: "TapBody",
        index: 4,
        actionId: "paodao",
        label: "paodao",
        duration: 5.433,
        voices: {"cn": {"subtitle": "刀放久了会生锈，人也是。闲太久的话，我反而会不自在。", "sound": "sounds/vo_6019_daiji_01.wav"}, "en": {"subtitle": "刀放久了会生锈，人也是。闲太久的话，我反而会不自在。", "sound": "sounds/en_vo_6019_daiji_01.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 601901011,
        audioId: 60190005,
        audioName: "vo_6019_daiji_02",
        desc: "点击-通用2",
        group: "Idle",
        index: 0,
        actionId: "idle",
        label: "默认",
        duration: 5.967,
        voices: {"cn": {"subtitle": "有只流浪狗一直跟着我，是想被收养吗？可惜我只擅长夺走性命，不知如何……养育一个生命。", "sound": "sounds/vo_6019_daiji_02.wav"}, "en": {"subtitle": "有只流浪狗一直跟着我，是想被收养吗？可惜我只擅长夺走性命，不知如何……养育一个生命。", "sound": "sounds/en_vo_6019_daiji_02.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 601901012,
        audioId: 60190010,
        audioName: "vo_6019_xianliao_01",
        desc: "点击-闲聊1",
        group: "Idle",
        index: 0,
        actionId: "idle",
        label: "默认",
        duration: 5.967,
        voices: {"cn": {"subtitle": "泰拉的楼缝里，有时能看到远处的灯火。看着那幅画面，心里突然就静下来了。", "sound": "sounds/vo_6019_xianliao_01.wav"}, "en": {"subtitle": "泰拉的楼缝里，有时能看到远处的灯火。看着那幅画面，心里突然就静下来了。", "sound": "sounds/en_vo_6019_xianliao_01.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 601901013,
        audioId: 60190011,
        audioName: "vo_6019_xianliao_02",
        desc: "点击-闲聊2",
        group: "TapBody",
        index: 6,
        actionId: "songjian",
        label: "songjian",
        duration: 3.0,
        voices: {"cn": {"subtitle": "第一次看见烟花，我以为哪里打起来了。后来才知道，有些爆炸不会伤人，而是会让人开心。", "sound": "sounds/vo_6019_xianliao_02.wav"}, "en": {"subtitle": "第一次看见烟花，我以为哪里打起来了。后来才知道，有些爆炸不会伤人，而是会让人开心。", "sound": "sounds/en_vo_6019_xianliao_02.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 601901014,
        audioId: 60190012,
        audioName: "vo_6019_xianliao_03",
        desc: "点击-闲聊3",
        group: "TapBody",
        index: 6,
        actionId: "songjian",
        label: "songjian",
        duration: 3.0,
        voices: {"cn": {"subtitle": "有人笑我不懂欣赏食物，可能因为我在战壕里啃干粮啃惯了。只要不是那东西，对我来说就是美食。", "sound": "sounds/vo_6019_xianliao_03.wav"}, "en": {"subtitle": "有人笑我不懂欣赏食物，可能因为我在战壕里啃干粮啃惯了。只要不是那东西，对我来说就是美食。", "sound": "sounds/en_vo_6019_xianliao_03.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 601901015,
        audioId: 60190014,
        audioName: "vo_6019_zanyang",
        desc: "点击-赞扬1",
        group: "TapBody",
        index: 0,
        actionId: "diantou",
        label: "diantou",
        duration: 3.0,
        voices: {"cn": {"subtitle": "你的脚步声很轻，是有人特地教过你吗？抱歉，因为这个步法很专业，我有点好奇。", "sound": "sounds/vo_6019_zanyang.wav"}, "en": {"subtitle": "你的脚步声很轻，是有人特地教过你吗？抱歉，因为这个步法很专业，我有点好奇。", "sound": "sounds/en_vo_6019_zanyang.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 601901016,
        audioId: 60190006,
        audioName: "vo_6019_dianchu_tou",
        desc: "点击-头",
        group: "TapBody",
        index: 4,
        actionId: "paodao",
        label: "paodao",
        duration: 5.433,
        voices: {"cn": {"subtitle": "我脑子里在想什么？路线、敌人、时机。就这些。", "sound": "sounds/vo_6019_dianchu_tou.wav"}, "en": {"subtitle": "我脑子里在想什么？路线、敌人、时机。就这些。", "sound": "sounds/en_vo_6019_dianchu_tou.wav"}},
        hitAreaParam: "HitAreaHead",
        hitAreas: ["HitAreaHead"],
        sourceType2: 401,
        sourceWeight: 20,
        weight: 20
      },
      {
        showId: 601901017,
        audioId: 60190007,
        audioName: "vo_6019_dianchu_shou",
        desc: "点击-手",
        group: "Idle",
        index: 0,
        actionId: "idle",
        label: "默认",
        duration: 5.967,
        voices: {"cn": {"subtitle": "灵活的手，才能让刀和枪听话。我平时会做手部放松，你想试试吗？", "sound": "sounds/vo_6019_dianchu_shou.wav"}, "en": {"subtitle": "灵活的手，才能让刀和枪听话。我平时会做手部放松，你想试试吗？", "sound": "sounds/en_vo_6019_dianchu_shou.wav"}},
        hitAreaParam: "HitAreaHandL#HitAreaHandR",
        hitAreas: ["HitAreaHandL", "HitAreaHandR"],
        sourceType2: 401,
        sourceWeight: 20,
        weight: 20
      },
      {
        showId: 601901018,
        audioId: 60190008,
        audioName: "vo_6019_dianchu_shen",
        desc: "点击-胸",
        group: "TapBody",
        index: 5,
        actionId: "qianqing",
        label: "qianqing",
        duration: 4.333,
        voices: {"cn": {"subtitle": "胸口的伤，让我记住了呼吸是一种奢侈的事。", "sound": "sounds/vo_6019_dianchu_shen.wav"}, "en": {"subtitle": "胸口的伤，让我记住了呼吸是一种奢侈的事。", "sound": "sounds/en_vo_6019_dianchu_shen.wav"}},
        hitAreaParam: "HitAreaBody",
        hitAreas: ["HitAreaBody"],
        sourceType2: 401,
        sourceWeight: 20,
        weight: 20
      }
    ]
  },
  {
    id: "103400_dd",
    title: "预埋角色 103400_dd 角色候选",
    assetKind: "character",
    categoryLabel: "角色",
    modelDir: "103400_dd",
    sourceModelDir: "103400_dd",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "localassets_win32",
    styleId: "",
    styleName: "预埋角色 103400_dd",
    stage: "角色候选",
    hitAreaNames: ["HitAreaMoren", "HitAreaHandL", "HitAreaHead", "HitAreaHandR", "HitAreaBody"],
    followConfigs: [{"id": 1019, "prefab": "103400_dd", "activeName": "", "expressionName": "", "damping": 0.0, "parameters": [{"parameterId": "ParamAngleX", "axis": "X", "factor": 50.0, "sourceToken": "ParamAngleX#50*X"}, {"parameterId": "ParamAngleY", "axis": "Y", "factor": 50.0, "sourceToken": "ParamAngleY#50*Y"}, {"parameterId": "ParamEyeBallX", "axis": "X", "factor": 80.0, "sourceToken": "ParamEyeBallX#80*X"}, {"parameterId": "ParamEyeBallY", "axis": "Y", "factor": 30.0, "sourceToken": "ParamEyeBallY#30*Y"}, {"parameterId": "ParamBodyAngleX", "axis": "X", "factor": 20.0, "sourceToken": "ParamBodyAngleX#20*X"}, {"parameterId": "ParamBodyAngleY", "axis": "Y", "factor": -20.0, "sourceToken": "ParamBodyAngleY#-20*Y"}]}],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 3.0 }
        ]
      },
      {
        label: "TapBody",
        actions: [
          { group: "TapBody", index: 0, actionId: "diantou", label: "diantou", duration: 3.0 },
          { group: "TapBody", index: 1, actionId: "houyang", label: "houyang", duration: 3.5 },
          { group: "TapBody", index: 2, actionId: "linqi", label: "linqi", duration: 6.833 },
          { group: "TapBody", index: 3, actionId: "qianqing", label: "qianqing", duration: 4.0 },
          { group: "TapBody", index: 4, actionId: "waitou", label: "waitou", duration: 6.0 },
          { group: "TapBody", index: 5, actionId: "walk", label: "walk", duration: 3.0 },
          { group: "TapBody", index: 6, actionId: "yaotou", label: "yaotou", duration: 3.0 },
          { group: "TapBody", index: 7, actionId: "zuanjin", label: "zuanjin", duration: 3.333 }
        ]
      }
    ],
    clickShowActions: [

    ]
  },
  {
    id: "103500_txr",
    title: "提线人 角色立绘",
    assetKind: "character",
    categoryLabel: "角色",
    modelDir: "103500_txr",
    sourceModelDir: "103500_txr",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "localassets_win32",
    styleId: "",
    styleName: "提线人",
    stage: "角色立绘",
    hitAreaNames: ["HitAreaHandL1", "HitAreaBody", "HitAreaHead", "HitAreaHandR1", "HitAreaHandR2", "HitAreaMoren", "HitAreaHandL2"],
    followConfigs: [{"id": 1024, "prefab": "103500_txr", "activeName": "", "expressionName": "", "damping": 0.0, "parameters": [{"parameterId": "ParamAngleX", "axis": "X", "factor": 30.0, "sourceToken": "ParamAngleX#30*X"}, {"parameterId": "ParamAngleY", "axis": "Y", "factor": 30.0, "sourceToken": "ParamAngleY#30*Y"}, {"parameterId": "ParamEyeBallX", "axis": "X", "factor": 70.0, "sourceToken": "ParamEyeBallX#70*X"}, {"parameterId": "ParamEyeBallY", "axis": "Y", "factor": 50.0, "sourceToken": "ParamEyeBallY#50*Y"}, {"parameterId": "ParamBodyAngleX", "axis": "X", "factor": 10.0, "sourceToken": "ParamBodyAngleX#10*X"}, {"parameterId": "ParamBodyAngleY", "axis": "Y", "factor": 50.0, "sourceToken": "ParamBodyAngleY#50*Y"}]}],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 5.967 }
        ]
      },
      {
        label: "TapBody",
        actions: [
          { group: "TapBody", index: 0, actionId: "baogao", label: "baogao", duration: 7.367 },
          { group: "TapBody", index: 1, actionId: "biyan", label: "biyan", duration: 8.967 },
          { group: "TapBody", index: 2, actionId: "caozong", label: "caozong", duration: 5.967 },
          { group: "TapBody", index: 3, actionId: "caozong_1", label: "caozong_1", duration: 5.967 },
          { group: "TapBody", index: 4, actionId: "diantou", label: "diantou", duration: 2.967 },
          { group: "TapBody", index: 5, actionId: "waitou", label: "waitou", duration: 2.967 },
          { group: "TapBody", index: 6, actionId: "waitou_1", label: "waitou_1", duration: 3.7 },
          { group: "TapBody", index: 7, actionId: "yaotou", label: "yaotou", duration: 2.967 }
        ]
      }
    ],
    clickShowActions: [
      {
        showId: 602001010,
        audioId: 60200004,
        audioName: "vo_6020_daiji_01",
        desc: "点击-通用1",
        group: "Idle",
        index: 0,
        actionId: "idle",
        label: "默认",
        duration: 5.967,
        voices: {"cn": {"subtitle": "今天的研究工作本来很顺利，直到咖啡机决定背叛我。", "sound": "sounds/vo_6020_daiji_01.wav"}, "en": {"subtitle": "今天的研究工作本来很顺利，直到咖啡机决定背叛我。", "sound": "sounds/en_vo_6020_daiji_01.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 602001011,
        audioId: 60200005,
        audioName: "vo_6020_daiji_02",
        desc: "点击-通用2",
        group: "TapBody",
        index: 0,
        actionId: "baogao",
        label: "baogao",
        duration: 7.367,
        voices: {"cn": {"subtitle": "读到了一篇旧论文，里面的错误真是精彩，值得收藏并当作笑话集。", "sound": "sounds/vo_6020_daiji_02.wav"}, "en": {"subtitle": "读到了一篇旧论文，里面的错误真是精彩，值得收藏并当作笑话集。", "sound": "sounds/en_vo_6020_daiji_02.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 602001012,
        audioId: 60200010,
        audioName: "vo_6020_xianliao_01",
        desc: "点击-闲聊1",
        group: "TapBody",
        index: 7,
        actionId: "yaotou",
        label: "yaotou",
        duration: 2.967,
        voices: {"cn": {"subtitle": "你家厨房也太不经用了，泡杯咖啡就能让它四分五裂……感谢我吧，我可以为你免费升级厨房。", "sound": "sounds/vo_6020_xianliao_01.wav"}, "en": {"subtitle": "你家厨房也太不经用了，泡杯咖啡就能让它四分五裂……感谢我吧，我可以为你免费升级厨房。", "sound": "sounds/en_vo_6020_xianliao_01.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 602001013,
        audioId: 60200011,
        audioName: "vo_6020_xianliao_02",
        desc: "点击-闲聊2",
        group: "TapBody",
        index: 6,
        actionId: "waitou_1",
        label: "waitou_1",
        duration: 3.7,
        voices: {"cn": {"subtitle": "拜托我泡茶？抱歉，我对烧开水的研究还停留在理论阶段。", "sound": "sounds/vo_6020_xianliao_02.wav"}, "en": {"subtitle": "拜托我泡茶？抱歉，我对烧开水的研究还停留在理论阶段。", "sound": "sounds/en_vo_6020_xianliao_02.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 602001014,
        audioId: 60200012,
        audioName: "vo_6020_xianliao_03",
        desc: "点击-闲聊3",
        group: "TapBody",
        index: 0,
        actionId: "baogao",
        label: "baogao",
        duration: 7.367,
        voices: {"cn": {"subtitle": "“在吗”这种低效社交词汇，就应该从人类词库里删除。为什么有些人不能有事直说？是因为没学会其他单词吗？", "sound": "sounds/vo_6020_xianliao_03.wav"}, "en": {"subtitle": "“在吗”这种低效社交词汇，就应该从人类词库里删除。为什么有些人不能有事直说？是因为没学会其他单词吗？", "sound": "sounds/en_vo_6020_xianliao_03.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 602001015,
        audioId: 60200014,
        audioName: "vo_6020_zanyang",
        desc: "点击-赞扬1",
        group: "TapBody",
        index: 6,
        actionId: "waitou_1",
        label: "waitou_1",
        duration: 3.7,
        voices: {"cn": {"subtitle": "和你聊天让我效率下降了28%，但心情好像提升了32%，有趣的平衡。", "sound": "sounds/vo_6020_zanyang.wav"}, "en": {"subtitle": "和你聊天让我效率下降了28%，但心情好像提升了32%，有趣的平衡。", "sound": "sounds/en_vo_6020_zanyang.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 602001016,
        audioId: 60200006,
        audioName: "vo_6020_dianchu_tou",
        desc: "点击-头",
        group: "TapBody",
        index: 0,
        actionId: "baogao",
        label: "baogao",
        duration: 7.367,
        voices: {"cn": {"subtitle": "我的头脑从不休息，连做梦都在推演公式……倒是你，整天在想什么奇怪念头？", "sound": "sounds/vo_6020_dianchu_tou.wav"}, "en": {"subtitle": "我的头脑从不休息，连做梦都在推演公式……倒是你，整天在想什么奇怪念头？", "sound": "sounds/en_vo_6020_dianchu_tou.wav"}},
        hitAreaParam: "HitAreaHead",
        hitAreas: ["HitAreaHead"],
        sourceType2: 401,
        sourceWeight: 20,
        weight: 20
      },
      {
        showId: 602001017,
        audioId: 60200007,
        audioName: "vo_6020_dianchu_shou",
        desc: "点击-手",
        group: "TapBody",
        index: 3,
        actionId: "caozong_1",
        label: "caozong_1",
        duration: 5.967,
        voices: {"cn": {"subtitle": "你手心的温度比昨天低了1℃﻿……没事就去喝杯热茶。", "sound": "sounds/vo_6020_dianchu_shou.wav"}, "en": {"subtitle": "你手心的温度比昨天低了1℃﻿……没事就去喝杯热茶。", "sound": "sounds/en_vo_6020_dianchu_shou.wav"}},
        hitAreaParam: "HitAreaHandL1#HitAreaHandL2#HitAreaHandR1#HitAreaHandR2",
        hitAreas: ["HitAreaHandL1", "HitAreaHandL2", "HitAreaHandR1", "HitAreaHandR2"],
        sourceType2: 401,
        sourceWeight: 20,
        weight: 20
      },
      {
        showId: 602001018,
        audioId: 60200008,
        audioName: "vo_6020_dianchu_shen",
        desc: "点击-胸",
        group: "Idle",
        index: 0,
        actionId: "idle",
        label: "默认",
        duration: 5.967,
        voices: {"cn": {"subtitle": "身体有时会背叛理智，尤其是在你面前。那些不合逻辑的反应我也很讨厌。", "sound": "sounds/vo_6020_dianchu_shen.wav"}, "en": {"subtitle": "身体有时会背叛理智，尤其是在你面前。那些不合逻辑的反应我也很讨厌。", "sound": "sounds/en_vo_6020_dianchu_shen.wav"}},
        hitAreaParam: "HitAreaBody",
        hitAreas: ["HitAreaBody"],
        sourceType2: 401,
        sourceWeight: 20,
        weight: 20
      }
    ]
  },
  {
    id: "103500_txr_cg",
    title: "科技部长 一段",
    assetKind: "style",
    categoryLabel: "风格",
    modelDir: "103500_txr_cg",
    sourceModelDir: "103500_txr_cg",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "streamingassets",
    styleId: "13001035",
    styleName: "科技部长",
    stage: "一段",
    hitAreaNames: ["HitAreaMoren"],
    followConfigs: [{"id": 21006, "prefab": "103500_txr_cg", "activeName": "", "expressionName": "", "damping": 0.0, "parameters": [{"parameterId": "ParamAngleX", "axis": "X", "factor": 80.0, "sourceToken": "ParamAngleX#80*X"}, {"parameterId": "ParamAngleY", "axis": "Y", "factor": 30.0, "sourceToken": "ParamAngleY#30*Y"}, {"parameterId": "ParamEyeBallX", "axis": "X", "factor": 30.0, "sourceToken": "ParamEyeBallX#30*X"}, {"parameterId": "ParamEyeBallY", "axis": "Y", "factor": 30.0, "sourceToken": "ParamEyeBallY#30*Y"}, {"parameterId": "ParamBodyAngleX", "axis": "X", "factor": 50.0, "sourceToken": "ParamBodyAngleX#50*X"}, {"parameterId": "ParamBodyAngleY", "axis": "Y", "factor": 50.0, "sourceToken": "ParamBodyAngleY#50*Y"}, {"parameterId": "ParamEyeLOpen", "axis": "Y", "factor": 10.0, "sourceToken": "ParamEyeLOpen#10*Y"}, {"parameterId": "ParamBrowLForm", "axis": "Y", "factor": 10.0, "sourceToken": "ParamBrowLForm#10*Y"}, {"parameterId": "ParamBrowRForm", "axis": "Y", "factor": 10.0, "sourceToken": "ParamBrowRForm#10*Y"}, {"parameterId": "ParamKataR", "axis": "X", "factor": 10.0, "sourceToken": "ParamKataR#10*X"}, {"parameterId": "ParamArmR1", "axis": "X", "factor": -5.0, "sourceToken": "ParamArmR1#-5*X"}]}],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 9.0 },
          { group: "Idle", index: 1, actionId: "idle1", label: "注视1", duration: 9.0 },
          { group: "Idle", index: 2, actionId: "idle2", label: "注视2", duration: 9.0 }
        ]
      },
      {
        label: "入场",
        actions: [
          { group: "Entry", index: 0, actionId: "ruchang", label: "入场", duration: 12.5 }
        ]
      }
    ],
    clickShowActions: [
      {
        showId: 61035008,
        audioId: 10350002,
        audioName: "vo_1035_yiduanchahua_01",
        desc: "点击1",
        group: "Idle",
        index: 1,
        actionId: "idle1",
        label: "注视1",
        duration: 9.0,
        voices: {"cn": {"subtitle": "你在同情我？上一个这样想的人已经败在我手里了，他现在能做的只有日夜诅咒我早点去死。", "sound": "sounds/vo_1035_yiduanchahua_01.wav"}, "en": {"subtitle": "你在同情我？上一个这样想的人已经败在我手里了，他现在能做的只有日夜诅咒我早点去死。", "sound": "sounds/en_vo_1035_yiduanchahua_01.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 20,
        weight: 20
      },
      {
        showId: 61035009,
        audioId: 10350003,
        audioName: "vo_1035_yiduanchahua_02",
        desc: "点击2",
        group: "Idle",
        index: 2,
        actionId: "idle2",
        label: "注视2",
        duration: 9.0,
        voices: {"cn": {"subtitle": "喜欢看我狼狈的样子？你比我想象的还要恶趣味。", "sound": "sounds/vo_1035_yiduanchahua_02.wav"}, "en": {"subtitle": "喜欢看我狼狈的样子？你比我想象的还要恶趣味。", "sound": "sounds/en_vo_1035_yiduanchahua_02.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 20,
        weight: 20
      },
      {
        showId: 61035010,
        audioId: 60200004,
        audioName: "vo_6020_daiji_01",
        desc: "点击-通用1",
        group: "Idle",
        index: 2,
        actionId: "idle2",
        label: "注视2",
        duration: 9.0,
        voices: {"cn": {"subtitle": "今天的研究工作本来很顺利，直到咖啡机决定背叛我。", "sound": "sounds/vo_6020_daiji_01.wav"}, "en": {"subtitle": "今天的研究工作本来很顺利，直到咖啡机决定背叛我。", "sound": "sounds/en_vo_6020_daiji_01.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 10,
        weight: 10
      },
      {
        showId: 61035011,
        audioId: 60200010,
        audioName: "vo_6020_xianliao_01",
        desc: "点击-闲聊1",
        group: "Idle",
        index: 1,
        actionId: "idle1",
        label: "注视1",
        duration: 9.0,
        voices: {"cn": {"subtitle": "你家厨房也太不经用了，泡杯咖啡就能让它四分五裂……感谢我吧，我可以为你免费升级厨房。", "sound": "sounds/vo_6020_xianliao_01.wav"}, "en": {"subtitle": "你家厨房也太不经用了，泡杯咖啡就能让它四分五裂……感谢我吧，我可以为你免费升级厨房。", "sound": "sounds/en_vo_6020_xianliao_01.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 10,
        weight: 10
      },
      {
        showId: 61035012,
        audioId: 60200011,
        audioName: "vo_6020_xianliao_02",
        desc: "点击-闲聊2",
        group: "Idle",
        index: 2,
        actionId: "idle2",
        label: "注视2",
        duration: 9.0,
        voices: {"cn": {"subtitle": "拜托我泡茶？抱歉，我对烧开水的研究还停留在理论阶段。", "sound": "sounds/vo_6020_xianliao_02.wav"}, "en": {"subtitle": "拜托我泡茶？抱歉，我对烧开水的研究还停留在理论阶段。", "sound": "sounds/en_vo_6020_xianliao_02.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 10,
        weight: 10
      }
    ]
  },
  {
    id: "103501_txr_cg",
    title: "科技部长 二段",
    assetKind: "style",
    categoryLabel: "风格",
    modelDir: "103501_txr_cg",
    sourceModelDir: "103501_txr_cg",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "streamingassets",
    styleId: "13001035",
    styleName: "科技部长",
    stage: "二段",
    hitAreaNames: ["HitAreagensui", "HitAreaquanbu"],
    followConfigs: [{"id": 21010, "prefab": "103501_txr_cg", "activeName": "HitAreagensui", "expressionName": "gensui01", "damping": 0.0, "parameters": [{"parameterId": "Param253", "axis": "X", "factor": 20.0, "sourceToken": "Param253#20*X"}, {"parameterId": "Param156", "axis": "X", "factor": 25.0, "sourceToken": "Param156#25*X"}, {"parameterId": "Param157", "axis": "Y", "factor": 50.0, "sourceToken": "Param157#50*Y"}, {"parameterId": "Param267", "axis": "Y", "factor": 10.0, "sourceToken": "Param267#10*Y"}, {"parameterId": "Param240", "axis": "X", "factor": 5.0, "sourceToken": "Param240#5*X"}, {"parameterId": "ParamAngleX", "axis": "X", "factor": -5.0, "sourceToken": "ParamAngleX#-5*X"}, {"parameterId": "ParamAngleY", "axis": "Y", "factor": 10.0, "sourceToken": "ParamAngleY#10*Y"}, {"parameterId": "ParamAngleZ", "axis": "X", "factor": -2.0, "sourceToken": "ParamAngleZ#-2*X"}, {"parameterId": "ParamEyeBallX", "axis": "X", "factor": -5.0, "sourceToken": "ParamEyeBallX#-5*X"}, {"parameterId": "ParamEyeBallY", "axis": "Y", "factor": 30.0, "sourceToken": "ParamEyeBallY#30*Y"}, {"parameterId": "ParamBodyAngleY", "axis": "Y", "factor": 5.0, "sourceToken": "ParamBodyAngleY#5*Y"}]}],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [],
    storyTouchActions: [],
    unlockableMotions: [
      { group: "TapBody", index: 0, actionId: "dongzuo1", label: "亲近1", duration: 14.033 },
      { group: "TapBody", index: 1, actionId: "dongzuo2", label: "亲近2", duration: 14.47 },
      { group: "TapBody", index: 2, actionId: "dongzuo3", label: "亲近3", duration: 15.07 }
    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 6.633 },
          { group: "Idle", index: 1, actionId: "idle1", label: "注视1", duration: 13.333 },
          { group: "Idle", index: 2, actionId: "idle2", label: "注视2", duration: 9.333 }
        ]
      },
      {
        label: "TapBody",
        actions: [
          { group: "TapBody", index: 0, actionId: "dongzuo1", label: "亲近1", duration: 14.033 },
          { group: "TapBody", index: 1, actionId: "dongzuo2", label: "亲近2", duration: 14.47 },
          { group: "TapBody", index: 2, actionId: "dongzuo3", label: "亲近3", duration: 15.07 }
        ]
      },
      {
        label: "入场",
        actions: [
          { group: "Entry", index: 0, actionId: "ruchang", label: "入场", duration: 16.4 }
        ]
      }
    ],
    clickShowActions: [
      {
        showId: 61035055,
        audioId: 10350008,
        audioName: "vo_1035_erduanchahua_03",
        desc: "点击3",
        group: "TapBody",
        index: 0,
        actionId: "dongzuo1",
        label: "亲近1",
        duration: 14.033,
        voices: {"cn": {"subtitle": "别误会，我脸红只是因为实验室的温度略高。", "sound": "sounds/vo_1035_erduanchahua_03.wav"}, "en": {"subtitle": "别误会，我脸红只是因为实验室的温度略高。", "sound": "sounds/en_vo_1035_erduanchahua_03.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 20,
        weight: 20
      },
      {
        showId: 61035056,
        audioId: 10350009,
        audioName: "vo_1035_erduanchahua_04",
        desc: "点击4",
        group: "TapBody",
        index: 1,
        actionId: "dongzuo2",
        label: "亲近2",
        duration: 14.47,
        voices: {"cn": {"subtitle": "你不像在检测知觉，而像是考验我的忍耐力。", "sound": "sounds/vo_1035_erduanchahua_04.wav"}, "en": {"subtitle": "你不像在检测知觉，而像是考验我的忍耐力。", "sound": "sounds/en_vo_1035_erduanchahua_04.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 20,
        weight: 20
      },
      {
        showId: 61035057,
        audioId: 10350010,
        audioName: "vo_1035_erduanchahua_05",
        desc: "点击5",
        group: "TapBody",
        index: 2,
        actionId: "dongzuo3",
        label: "亲近3",
        duration: 15.07,
        voices: {"cn": {"subtitle": "怎么不擦了？还没清理干净呢。", "sound": "sounds/vo_1035_erduanchahua_05.wav"}, "en": {"subtitle": "怎么不擦了？还没清理干净呢。", "sound": "sounds/en_vo_1035_erduanchahua_05.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 20,
        weight: 20
      },
      {
        showId: 61035059,
        audioId: 10350006,
        audioName: "vo_1035_erduanchahua_01",
        desc: "点击1",
        group: "Idle",
        index: 1,
        actionId: "idle1",
        label: "注视1",
        duration: 13.333,
        voices: {"cn": {"subtitle": "不是我控制的它……！该死，这破玩意该升级了……！", "sound": "sounds/vo_1035_erduanchahua_01.wav"}, "en": {"subtitle": "不是我控制的它……！该死，这破玩意该升级了……！", "sound": "sounds/en_vo_1035_erduanchahua_01.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 10,
        weight: 10
      },
      {
        showId: 61035060,
        audioId: 10350007,
        audioName: "vo_1035_erduanchahua_02",
        desc: "点击2",
        group: "Idle",
        index: 2,
        actionId: "idle2",
        label: "注视2",
        duration: 9.333,
        voices: {"cn": {"subtitle": "我到底在期待什么……", "sound": "sounds/vo_1035_erduanchahua_02.wav"}, "en": {"subtitle": "我到底在期待什么……", "sound": "sounds/en_vo_1035_erduanchahua_02.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 10,
        weight: 10
      },
      {
        showId: 61035061,
        audioId: 60200014,
        audioName: "vo_6020_zanyang",
        desc: "点击-赞扬1",
        group: "Idle",
        index: 2,
        actionId: "idle2",
        label: "注视2",
        duration: 9.333,
        voices: {"cn": {"subtitle": "和你聊天让我效率下降了28%，但心情好像提升了32%，有趣的平衡。", "sound": "sounds/vo_6020_zanyang.wav"}, "en": {"subtitle": "和你聊天让我效率下降了28%，但心情好像提升了32%，有趣的平衡。", "sound": "sounds/en_vo_6020_zanyang.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      }
    ]
  },
  {
    id: "103600_dnxb",
    title: "东南西北 角色立绘",
    assetKind: "character",
    categoryLabel: "角色",
    modelDir: "103600_dnxb",
    sourceModelDir: "103600_dnxb",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "localassets_win32",
    styleId: "",
    styleName: "东南西北",
    stage: "角色立绘",
    hitAreaNames: ["HitAreaHandL1", "HitAreaHead", "HitAreaHandL2", "HitAreaMoren", "HitAreaHandR", "HitAreaBody"],
    followConfigs: [{"id": 1041, "prefab": "103600_dnxb", "activeName": "", "expressionName": "", "damping": 0.0, "parameters": [{"parameterId": "ParamAngleX", "axis": "X", "factor": 15.0, "sourceToken": "ParamAngleX#15*X"}, {"parameterId": "ParamAngleY", "axis": "Y", "factor": 25.0, "sourceToken": "ParamAngleY#25*Y"}, {"parameterId": "ParamEyeBallX", "axis": "X", "factor": 25.0, "sourceToken": "ParamEyeBallX#25*X"}, {"parameterId": "ParamEyeBallY", "axis": "Y", "factor": 30.0, "sourceToken": "ParamEyeBallY#30*Y"}, {"parameterId": "ParamBodyAngleX", "axis": "X", "factor": 15.0, "sourceToken": "ParamBodyAngleX#15*X"}, {"parameterId": "ParamBodyAngleY", "axis": "Y", "factor": 15.0, "sourceToken": "ParamBodyAngleY#15*Y"}]}],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 6.0 }
        ]
      },
      {
        label: "TapBody",
        actions: [
          { group: "TapBody", index: 0, actionId: "bawan", label: "bawan", duration: 5.667 },
          { group: "TapBody", index: 1, actionId: "dianliang", label: "dianliang", duration: 3.167 },
          { group: "TapBody", index: 2, actionId: "dianliang_1", label: "dianliang_1", duration: 3.167 },
          { group: "TapBody", index: 3, actionId: "diantou", label: "diantou", duration: 3.167 },
          { group: "TapBody", index: 4, actionId: "shenshou", label: "shenshou", duration: 5.5 },
          { group: "TapBody", index: 5, actionId: "waitou", label: "waitou", duration: 3.167 },
          { group: "TapBody", index: 6, actionId: "walk", label: "walk", duration: 2.0 },
          { group: "TapBody", index: 7, actionId: "yaotou", label: "yaotou", duration: 3.333 },
          { group: "TapBody", index: 8, actionId: "yezi", label: "yezi", duration: 9.167 }
        ]
      }
    ],
    clickShowActions: [
      {
        showId: 602101010,
        audioId: 60210004,
        audioName: "vo_6021_daiji_01",
        desc: "点击-通用1",
        group: "TapBody",
        index: 2,
        actionId: "dianliang_1",
        label: "dianliang_1",
        duration: 3.167,
        voices: {"cn": {"subtitle": "茶叶要存年份，酒要见火候，人呢？得经得起世道打磨。", "sound": "sounds/vo_6021_daiji_01.wav"}, "en": {"subtitle": "茶叶要存年份，酒要见火候，人呢？得经得起世道打磨。", "sound": "sounds/en_vo_6021_daiji_01.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 602101011,
        audioId: 60210005,
        audioName: "vo_6021_daiji_02",
        desc: "点击-通用2",
        group: "TapBody",
        index: 0,
        actionId: "bawan",
        label: "bawan",
        duration: 5.667,
        voices: {"cn": {"subtitle": "即便我们是老熟人了，但在商言商，我帮你，又能换得怎样的好处呢？", "sound": "sounds/vo_6021_daiji_02.wav"}, "en": {"subtitle": "即便我们是老熟人了，但在商言商，我帮你，又能换得怎样的好处呢？", "sound": "sounds/en_vo_6021_daiji_02.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 602101012,
        audioId: 60210010,
        audioName: "vo_6021_xianliao_01",
        desc: "点击-闲聊1",
        group: "TapBody",
        index: 8,
        actionId: "yezi",
        label: "yezi",
        duration: 9.167,
        voices: {"cn": {"subtitle": "风往哪里吹，舵就该往哪里转，这是生意之道。", "sound": "sounds/vo_6021_xianliao_01.wav"}, "en": {"subtitle": "风往哪里吹，舵就该往哪里转，这是生意之道。", "sound": "sounds/en_vo_6021_xianliao_01.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 602101013,
        audioId: 60210011,
        audioName: "vo_6021_xianliao_02",
        desc: "点击-闲聊2",
        group: "Idle",
        index: 0,
        actionId: "idle",
        label: "默认",
        duration: 6.0,
        voices: {"cn": {"subtitle": "在风篁人眼中，无论何时何地，说点吉祥话总是没错的。哪怕是濒死之人，也会想听到“早登极乐”。", "sound": "sounds/vo_6021_xianliao_02.wav"}, "en": {"subtitle": "在风篁人眼中，无论何时何地，说点吉祥话总是没错的。哪怕是濒死之人，也会想听到“早登极乐”。", "sound": "sounds/en_vo_6021_xianliao_02.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 602101014,
        audioId: 60210012,
        audioName: "vo_6021_xianliao_03",
        desc: "点击-闲聊3",
        group: "TapBody",
        index: 8,
        actionId: "yezi",
        label: "yezi",
        duration: 9.167,
        voices: {"cn": {"subtitle": "风篁人总是眷恋故土，但故土有时却只在梦中。嗯，至少今夜东风犹在。", "sound": "sounds/vo_6021_xianliao_03.wav"}, "en": {"subtitle": "风篁人总是眷恋故土，但故土有时却只在梦中。嗯，至少今夜东风犹在。", "sound": "sounds/en_vo_6021_xianliao_03.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 602101015,
        audioId: 60210014,
        audioName: "vo_6021_zanyang",
        desc: "点击-赞扬1",
        group: "TapBody",
        index: 0,
        actionId: "bawan",
        label: "bawan",
        duration: 5.667,
        voices: {"cn": {"subtitle": "你有着生意人的狡诈，却没有生意人的虚伪——这当然是夸奖，不然呢？", "sound": "sounds/vo_6021_zanyang.wav"}, "en": {"subtitle": "你有着生意人的狡诈，却没有生意人的虚伪——这当然是夸奖，不然呢？", "sound": "sounds/en_vo_6021_zanyang.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 602101016,
        audioId: 60210006,
        audioName: "vo_6021_dianchu_tou",
        desc: "点击-头",
        group: "TapBody",
        index: 5,
        actionId: "waitou",
        label: "waitou",
        duration: 3.167,
        voices: {"cn": {"subtitle": "要是把我头上的财运摸走了，可怎么好？你得负责啊。", "sound": "sounds/vo_6021_dianchu_tou.wav"}, "en": {"subtitle": "要是把我头上的财运摸走了，可怎么好？你得负责啊。", "sound": "sounds/en_vo_6021_dianchu_tou.wav"}},
        hitAreaParam: "HitAreaHead",
        hitAreas: ["HitAreaHead"],
        sourceType2: 401,
        sourceWeight: 20,
        weight: 20
      },
      {
        showId: 602101017,
        audioId: 60210007,
        audioName: "vo_6021_dianchu_shou",
        desc: "点击-手",
        group: "TapBody",
        index: 0,
        actionId: "bawan",
        label: "bawan",
        duration: 5.667,
        voices: {"cn": {"subtitle": "貔貅招财聚宝，多盘一盘，讨个好意头。至于我信不信这套玄学……不重要，别人信就好。", "sound": "sounds/vo_6021_dianchu_shou.wav"}, "en": {"subtitle": "貔貅招财聚宝，多盘一盘，讨个好意头。至于我信不信这套玄学……不重要，别人信就好。", "sound": "sounds/en_vo_6021_dianchu_shou.wav"}},
        hitAreaParam: "HitAreaHandL1#HitAreaHandL2#HitAreaHandR",
        hitAreas: ["HitAreaHandL1", "HitAreaHandL2", "HitAreaHandR"],
        sourceType2: 401,
        sourceWeight: 20,
        weight: 20
      },
      {
        showId: 602101018,
        audioId: 60210008,
        audioName: "vo_6021_dianchu_shen",
        desc: "点击-胸",
        group: "TapBody",
        index: 4,
        actionId: "shenshou",
        label: "shenshou",
        duration: 5.5,
        voices: {"cn": {"subtitle": "想借我的怀抱，可以。让我讨点利息不过分吧。", "sound": "sounds/vo_6021_dianchu_shen.wav"}, "en": {"subtitle": "想借我的怀抱，可以。让我讨点利息不过分吧。", "sound": "sounds/en_vo_6021_dianchu_shen.wav"}},
        hitAreaParam: "HitAreaBody",
        hitAreas: ["HitAreaBody"],
        sourceType2: 401,
        sourceWeight: 20,
        weight: 20
      }
    ]
  },
  {
    id: "103600_dnxb_cg",
    title: "爱财君子 一段",
    assetKind: "style",
    categoryLabel: "风格",
    modelDir: "103600_dnxb_cg",
    sourceModelDir: "103600_dnxb_cg",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "streamingassets",
    styleId: "13001036",
    styleName: "爱财君子",
    stage: "一段",
    hitAreaNames: ["HitAreagensui", "HitAreamoren", "HitAreaquanbu"],
    followConfigs: [{"id": 21015, "prefab": "103600_dnxb_cg", "activeName": "HitAreagensui", "expressionName": "gensui01", "damping": 0.3, "parameters": [{"parameterId": "ParamAngleZ2", "axis": "Y", "factor": 3.0, "sourceToken": "ParamAngleZ2#3*Y"}, {"parameterId": "ParamBodyAngleX", "axis": "X", "factor": 2.0, "sourceToken": "ParamBodyAngleX#2*X"}, {"parameterId": "ParamBodyAngleY", "axis": "Y", "factor": -1.0, "sourceToken": "ParamBodyAngleY#-1*Y"}, {"parameterId": "Paramktgz", "axis": "Y", "factor": 100.0, "sourceToken": "Paramktgz#100*Y"}, {"parameterId": "Param15", "axis": "Y", "factor": 10.0, "sourceToken": "Param15#10*Y"}]}],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 12.0 },
          { group: "Idle", index: 1, actionId: "idle1", label: "注视1", duration: 12.0 },
          { group: "Idle", index: 2, actionId: "idle2", label: "注视2", duration: 12.333 }
        ]
      },
      {
        label: "入场",
        actions: [
          { group: "Entry", index: 0, actionId: "ruchang", label: "入场", duration: 17.5 }
        ]
      }
    ],
    clickShowActions: [
      {
        showId: 61036008,
        audioId: 10360002,
        audioName: "vo_1036_yiduanchahua_01",
        desc: "点击1",
        group: "Idle",
        index: 1,
        actionId: "idle1",
        label: "注视1",
        duration: 12.0,
        voices: {"cn": {"subtitle": "最近人人都在传云老板多了个久别重逢的旧情人……如何，要把传言坐实吗？", "sound": "sounds/vo_1036_yiduanchahua_01.wav"}, "en": {"subtitle": "最近人人都在传云老板多了个久别重逢的旧情人……如何，要把传言坐实吗？", "sound": "sounds/en_vo_1036_yiduanchahua_01.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 20,
        weight: 20
      },
      {
        showId: 61036009,
        audioId: 10360003,
        audioName: "vo_1036_yiduanchahua_02",
        desc: "点击2",
        group: "Idle",
        index: 2,
        actionId: "idle2",
        label: "注视2",
        duration: 12.333,
        voices: {"cn": {"subtitle": "我不是那种迂腐的伪君子，我喜欢你的计划——当然也包括那些耳鬓厮磨的细节。", "sound": "sounds/vo_1036_yiduanchahua_02.wav"}, "en": {"subtitle": "我不是那种迂腐的伪君子，我喜欢你的计划——当然也包括那些耳鬓厮磨的细节。", "sound": "sounds/en_vo_1036_yiduanchahua_02.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 20,
        weight: 20
      },
      {
        showId: 61036010,
        audioId: 60210005,
        audioName: "vo_6021_daiji_02",
        desc: "点击-通用2",
        group: "Idle",
        index: 1,
        actionId: "idle1",
        label: "注视1",
        duration: 12.0,
        voices: {"cn": {"subtitle": "即便我们是老熟人了，但在商言商，我帮你，又能换得怎样的好处呢？", "sound": "sounds/vo_6021_daiji_02.wav"}, "en": {"subtitle": "即便我们是老熟人了，但在商言商，我帮你，又能换得怎样的好处呢？", "sound": "sounds/en_vo_6021_daiji_02.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 10,
        weight: 10
      },
      {
        showId: 61036011,
        audioId: 60210010,
        audioName: "vo_6021_xianliao_01",
        desc: "点击-闲聊1",
        group: "Idle",
        index: 1,
        actionId: "idle1",
        label: "注视1",
        duration: 12.0,
        voices: {"cn": {"subtitle": "风往哪里吹，舵就该往哪里转，这是生意之道。", "sound": "sounds/vo_6021_xianliao_01.wav"}, "en": {"subtitle": "风往哪里吹，舵就该往哪里转，这是生意之道。", "sound": "sounds/en_vo_6021_xianliao_01.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 10,
        weight: 10
      },
      {
        showId: 61036012,
        audioId: 60210014,
        audioName: "vo_6021_zanyang",
        desc: "点击-赞扬1",
        group: "Idle",
        index: 2,
        actionId: "idle2",
        label: "注视2",
        duration: 12.333,
        voices: {"cn": {"subtitle": "你有着生意人的狡诈，却没有生意人的虚伪——这当然是夸奖，不然呢？", "sound": "sounds/vo_6021_zanyang.wav"}, "en": {"subtitle": "你有着生意人的狡诈，却没有生意人的虚伪——这当然是夸奖，不然呢？", "sound": "sounds/en_vo_6021_zanyang.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 10,
        weight: 10
      }
    ]
  },
  {
    id: "103601_dnxb_cg",
    title: "爱财君子 二段",
    assetKind: "style",
    categoryLabel: "风格",
    modelDir: "103601_dnxb_cg",
    sourceModelDir: "103601_dnxb_cg",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "localassets_win32",
    styleId: "13001036",
    styleName: "爱财君子",
    stage: "二段",
    hitAreaNames: ["HitAreamoren", "HitAreagensui", "HitAreaquanbu"],
    followConfigs: [{"id": 21016, "prefab": "103601_dnxb_cg", "activeName": "HitAreagensui", "expressionName": "gensui01", "damping": 0.2, "parameters": [{"parameterId": "ParamAngleX", "axis": "X", "factor": 15.0, "sourceToken": "ParamAngleX#15*X"}, {"parameterId": "ParamAngleY", "axis": "Y", "factor": 30.0, "sourceToken": "ParamAngleY#30*Y"}, {"parameterId": "ParamNRshd9", "axis": "Y", "factor": 40.0, "sourceToken": "ParamNRshd9#40*Y"}, {"parameterId": "ParamAngleZ", "axis": "X", "factor": -2.0, "sourceToken": "ParamAngleZ#-2*X"}, {"parameterId": "ParamNeckZ2", "axis": "Y", "factor": -5.0, "sourceToken": "ParamNeckZ2#-5*Y"}, {"parameterId": "ParamEyeBallX", "axis": "X", "factor": -25.0, "sourceToken": "ParamEyeBallX#-25*X"}, {"parameterId": "ParamEyeBallY", "axis": "Y", "factor": -30.0, "sourceToken": "ParamEyeBallY#-30*Y"}, {"parameterId": "ParamRArm2z", "axis": "Y", "factor": 1.0, "sourceToken": "ParamRArm2z#1*Y"}, {"parameterId": "ParamNAngleZ", "axis": "Y", "factor": 3.0, "sourceToken": "ParamNAngleZ#3*Y"}, {"parameterId": "ParamNBodyY", "axis": "Y", "factor": 5.0, "sourceToken": "ParamNBodyY#5*Y"}, {"parameterId": "ParamNRArm2z", "axis": "X", "factor": 3.0, "sourceToken": "ParamNRArm2z#3*X"}, {"parameterId": "ParamNRhandz", "axis": "Y", "factor": -10.0, "sourceToken": "ParamNRhandz#-10*Y"}, {"parameterId": "ParamNRhandx", "axis": "Y", "factor": 50.0, "sourceToken": "ParamNRhandx#50*Y"}, {"parameterId": "ParamNLfg2z", "axis": "X", "factor": 5.0, "sourceToken": "ParamNLfg2z#5*X"}, {"parameterId": "ParamNLfg2d2", "axis": "Y", "factor": 10.0, "sourceToken": "ParamNLfg2d2#10*Y"}, {"parameterId": "ParamNLfg345d", "axis": "Y", "factor": 10.0, "sourceToken": "ParamNLfg345d#10*Y"}, {"parameterId": "ParamNLfg345d2", "axis": "Y", "factor": 10.0, "sourceToken": "ParamNLfg345d2#10*Y"}]}],
    hideGroups: [{"id": "protagonist", "label": "主控", "matchPrefixes": ["N_"], "partIds": ["N_BH1", "N_BH10", "N_BH11", "N_BH111", "N_BH112", "N_BH12", "N_BH121", "N_BH122", "N_BH123", "N_BH13", "N_BH131", "N_BH14", "N_BH15", "N_BH16", "N_BH17", "N_BH2", "N_BH3", "N_BH4", "N_BH6", "N_BH63", "N_BH7", "N_BH8", "N_BH9", "N_Body", "N_Body1", "N_Body2", "N_Larm1", "N_Larm3", "N_Larm4", "N_Lhand3", "N_Lhand4", "N_Rarm", "N_Rarm2", "N_Rfg1", "N_Rfg2", "N_Rfg21", "N_Rfg22", "N_Rfg23", "N_Rfg24", "N_Rfg31", "N_Rfg32", "N_Rfg33", "N_Rfg41", "N_Rfg42", "N_Rfg43", "N_Rfg51", "N_Rfg52", "N_Rhand", "N_Rhand2", "N_Rhandzz", "N_body", "N_bu", "N_earring", "N_face", "N_head"], "drawableIds": ["N_BH1", "N_BH10", "N_BH11", "N_BH111", "N_BH112", "N_BH12", "N_BH121", "N_BH122", "N_BH123", "N_BH13", "N_BH131", "N_BH14", "N_BH15", "N_BH16", "N_BH17", "N_BH2", "N_BH3", "N_BH4", "N_BH6", "N_BH63", "N_BH7", "N_BH8", "N_BH9", "N_Body", "N_Body1", "N_Body2", "N_Larm1", "N_Larm3", "N_Larm4", "N_Lhand3", "N_Lhand4", "N_Rarm", "N_Rarm2", "N_Rfg1", "N_Rfg2", "N_Rfg21", "N_Rfg22", "N_Rfg23", "N_Rfg24", "N_Rfg31", "N_Rfg32", "N_Rfg33", "N_Rfg41", "N_Rfg42", "N_Rfg43", "N_Rfg51", "N_Rfg52", "N_Rhand", "N_Rhand2", "N_Rhandzz", "N_body", "N_bu", "N_earring", "N_face", "N_head"], "confidence": "auto:n_prefix_body_parts", "candidateCount": 75, "semanticCandidateCount": 55}],
    ambientMotion: undefined,
    storySegments: [],
    storyTouchActions: [],
    unlockableMotions: [
      { group: "TapBody", index: 0, actionId: "dongzuo1", label: "亲近1", duration: 10.667 },
      { group: "TapBody", index: 1, actionId: "dongzuo2", label: "亲近2", duration: 14.0 },
      { group: "TapBody", index: 3, actionId: "dongzuo3", label: "亲近3", duration: 12.333 }
    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 8.0 },
          { group: "Idle", index: 1, actionId: "idle1", label: "注视1", duration: 8.0 },
          { group: "Idle", index: 2, actionId: "idle2", label: "注视2", duration: 12.0 }
        ]
      },
      {
        label: "TapBody",
        actions: [
          { group: "TapBody", index: 0, actionId: "dongzuo1", label: "亲近1", duration: 10.667 },
          { group: "TapBody", index: 1, actionId: "dongzuo2", label: "亲近2", duration: 14.0 },
          { group: "TapBody", index: 2, actionId: "dongzuo2_1", label: "dongzuo2_1", duration: 16.833 },
          { group: "TapBody", index: 3, actionId: "dongzuo3", label: "亲近3", duration: 12.333 }
        ]
      },
      {
        label: "入场",
        actions: [
          { group: "Entry", index: 0, actionId: "ruchang", label: "入场", duration: 16.0 },
          { group: "Entry", index: 1, actionId: "ruchang_1", label: "入场 1", duration: 17.333 }
        ]
      }
    ],
    clickShowActions: [
      {
        showId: 61036055,
        audioId: 10360008,
        audioName: "vo_1036_erduanchahua_03",
        desc: "点击3",
        group: "TapBody",
        index: 0,
        actionId: "dongzuo1",
        label: "亲近1",
        duration: 10.667,
        voices: {"cn": {"subtitle": "你的意思，是做戏要做全套？可你如此急切，我怎知你不是假戏真做？", "sound": "sounds/vo_1036_erduanchahua_03.wav"}, "en": {"subtitle": "你的意思，是做戏要做全套？可你如此急切，我怎知你不是假戏真做？", "sound": "sounds/en_vo_1036_erduanchahua_03.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 20,
        weight: 20
      },
      {
        showId: 61036056,
        audioId: 10360009,
        audioName: "vo_1036_erduanchahua_04",
        desc: "点击4",
        group: "TapBody",
        index: 1,
        actionId: "dongzuo2",
        label: "亲近2",
        duration: 14.0,
        voices: {"cn": {"subtitle": "即使我们肌肤相亲，你仍藏着很多秘密。要靠得多近，你才愿意讲给我听呢？", "sound": "sounds/vo_1036_erduanchahua_04.wav"}, "en": {"subtitle": "即使我们肌肤相亲，你仍藏着很多秘密。要靠得多近，你才愿意讲给我听呢？", "sound": "sounds/en_vo_1036_erduanchahua_04.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 20,
        weight: 20
      },
      {
        showId: 61036057,
        audioId: 10360010,
        audioName: "vo_1036_erduanchahua_05",
        desc: "点击5",
        group: "TapBody",
        index: 3,
        actionId: "dongzuo3",
        label: "亲近3",
        duration: 12.333,
        voices: {"cn": {"subtitle": "你依赖我的样子很可爱，即便我知道这是装出来的，且今夜过后你就会翻脸不认人。", "sound": "sounds/vo_1036_erduanchahua_05.wav"}, "en": {"subtitle": "你依赖我的样子很可爱，即便我知道这是装出来的，且今夜过后你就会翻脸不认人。", "sound": "sounds/en_vo_1036_erduanchahua_05.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 20,
        weight: 20
      },
      {
        showId: 61036060,
        audioId: 10360006,
        audioName: "vo_1036_erduanchahua_01",
        desc: "点击1",
        group: "Idle",
        index: 1,
        actionId: "idle1",
        label: "注视1",
        duration: 8.0,
        voices: {"cn": {"subtitle": "我不介意你心怀鬼胎，反正你我心知肚明，我们都不清白。", "sound": "sounds/vo_1036_erduanchahua_01.wav"}, "en": {"subtitle": "我不介意你心怀鬼胎，反正你我心知肚明，我们都不清白。", "sound": "sounds/en_vo_1036_erduanchahua_01.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 10,
        weight: 10
      },
      {
        showId: 61036061,
        audioId: 10360007,
        audioName: "vo_1036_erduanchahua_02",
        desc: "点击2",
        group: "Idle",
        index: 2,
        actionId: "idle2",
        label: "注视2",
        duration: 12.0,
        voices: {"cn": {"subtitle": "你的心跳声这么大，我都快听不清敌人的动静了。", "sound": "sounds/vo_1036_erduanchahua_02.wav"}, "en": {"subtitle": "你的心跳声这么大，我都快听不清敌人的动静了。", "sound": "sounds/en_vo_1036_erduanchahua_02.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 10,
        weight: 10
      },
      {
        showId: 61036062,
        audioId: 60210005,
        audioName: "vo_6021_daiji_02",
        desc: "点击-通用2",
        group: "Idle",
        index: 2,
        actionId: "idle2",
        label: "注视2",
        duration: 12.0,
        voices: {"cn": {"subtitle": "即便我们是老熟人了，但在商言商，我帮你，又能换得怎样的好处呢？", "sound": "sounds/vo_6021_daiji_02.wav"}, "en": {"subtitle": "即便我们是老熟人了，但在商言商，我帮你，又能换得怎样的好处呢？", "sound": "sounds/en_vo_6021_daiji_02.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 61036063,
        audioId: 60210014,
        audioName: "vo_6021_zanyang",
        desc: "点击-赞扬1",
        group: "Idle",
        index: 1,
        actionId: "idle1",
        label: "注视1",
        duration: 8.0,
        voices: {"cn": {"subtitle": "你有着生意人的狡诈，却没有生意人的虚伪——这当然是夸奖，不然呢？", "sound": "sounds/vo_6021_zanyang.wav"}, "en": {"subtitle": "你有着生意人的狡诈，却没有生意人的虚伪——这当然是夸奖，不然呢？", "sound": "sounds/en_vo_6021_zanyang.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      }
    ]
  },
  {
    id: "103800_tzy",
    title: "替罪羊 角色立绘",
    assetKind: "character",
    categoryLabel: "角色",
    modelDir: "103800_tzy",
    sourceModelDir: "103800_tzy",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "localassets_win32",
    styleId: "",
    styleName: "替罪羊",
    stage: "角色立绘",
    hitAreaNames: ["HitAreaMoren", "HitAreaHead", "HitAreaBody", "HitAreaHandR", "HitAreaHandL"],
    followConfigs: [{"id": 1004, "prefab": "103800_tzy", "activeName": "", "expressionName": "", "damping": 0.0, "parameters": [{"parameterId": "ParamAngleX", "axis": "X", "factor": 30.0, "sourceToken": "ParamAngleX#30*X"}, {"parameterId": "ParamAngleY", "axis": "Y", "factor": 50.0, "sourceToken": "ParamAngleY#50*Y"}, {"parameterId": "ParamEyeBallX", "axis": "X", "factor": 85.0, "sourceToken": "ParamEyeBallX#85*X"}, {"parameterId": "ParamEyeBallY", "axis": "Y", "factor": 50.0, "sourceToken": "ParamEyeBallY#50*Y"}, {"parameterId": "ParamBodyAngleX", "axis": "X", "factor": 20.0, "sourceToken": "ParamBodyAngleX#20*X"}, {"parameterId": "ParamBodyAngleY", "axis": "Y", "factor": 10.0, "sourceToken": "ParamBodyAngleY#10*Y"}]}],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 5.967 }
        ]
      },
      {
        label: "TapBody",
        actions: [
          { group: "TapBody", index: 0, actionId: "diantou", label: "diantou", duration: 2.543 },
          { group: "TapBody", index: 1, actionId: "houyang", label: "houyang", duration: 2.543 },
          { group: "TapBody", index: 2, actionId: "qianqing", label: "qianqing", duration: 3.4 },
          { group: "TapBody", index: 3, actionId: "songjian", label: "songjian", duration: 3.967 },
          { group: "TapBody", index: 4, actionId: "songjian_1", label: "songjian_1", duration: 3.3 },
          { group: "TapBody", index: 5, actionId: "waitou", label: "waitou", duration: 2.781 },
          { group: "TapBody", index: 6, actionId: "waitou_1", label: "waitou_1", duration: 3.3 },
          { group: "TapBody", index: 7, actionId: "walk", label: "walk", duration: 1.69 },
          { group: "TapBody", index: 8, actionId: "yaotou", label: "yaotou", duration: 2.543 },
          { group: "TapBody", index: 9, actionId: "zhuanyaoshi", label: "zhuanyaoshi", duration: 5.967 }
        ]
      }
    ],
    clickShowActions: [
      {
        showId: 602301010,
        audioId: 60230004,
        audioName: "vo_6023_daiji_01",
        desc: "点击-通用1",
        group: "TapBody",
        index: 9,
        actionId: "zhuanyaoshi",
        label: "zhuanyaoshi",
        duration: 5.967,
        voices: {"cn": {"subtitle": "昨天越狱时顺了监狱长的咖啡豆，要尝尝“铁窗风味拿铁”吗？", "sound": "sounds/vo_6023_daiji_01.wav"}, "en": {"subtitle": "昨天越狱时顺了监狱长的咖啡豆，要尝尝“铁窗风味拿铁”吗？", "sound": "sounds/en_vo_6023_daiji_01.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 602301011,
        audioId: 60230005,
        audioName: "vo_6023_daiji_02",
        desc: "点击-通用2",
        group: "TapBody",
        index: 2,
        actionId: "qianqing",
        label: "qianqing",
        duration: 3.4,
        voices: {"cn": {"subtitle": "你猜监狱长们最怕什么？不是暴动，是发现我替他们写了年终述职报告～", "sound": "sounds/vo_6023_daiji_02.wav"}, "en": {"subtitle": "你猜监狱长们最怕什么？不是暴动，是发现我替他们写了年终述职报告～", "sound": "sounds/en_vo_6023_daiji_02.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 602301012,
        audioId: 60230010,
        audioName: "vo_6023_xianliao_01",
        desc: "点击-闲聊1",
        group: "TapBody",
        index: 6,
        actionId: "waitou_1",
        label: "waitou_1",
        duration: 3.3,
        voices: {"cn": {"subtitle": "分享一个小经验——绞刑架和秋千的玩法其实差不多，都需要荡到最高点才有趣呢。", "sound": "sounds/vo_6023_xianliao_01.wav"}, "en": {"subtitle": "分享一个小经验——绞刑架和秋千的玩法其实差不多，都需要荡到最高点才有趣呢。", "sound": "sounds/en_vo_6023_xianliao_01.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 602301013,
        audioId: 60230011,
        audioName: "vo_6023_xianliao_02",
        desc: "点击-闲聊2",
        group: "TapBody",
        index: 9,
        actionId: "zhuanyaoshi",
        label: "zhuanyaoshi",
        duration: 5.967,
        voices: {"cn": {"subtitle": "水牢逃脱、手铐逃脱……说不定我更适合当魔术师？越狱就是面向狱警与囚犯的魔术嘛。", "sound": "sounds/vo_6023_xianliao_02.wav"}, "en": {"subtitle": "水牢逃脱、手铐逃脱……说不定我更适合当魔术师？越狱就是面向狱警与囚犯的魔术嘛。", "sound": "sounds/en_vo_6023_xianliao_02.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 602301014,
        audioId: 60230012,
        audioName: "vo_6023_xianliao_03",
        desc: "点击-闲聊3",
        group: "Idle",
        index: 0,
        actionId: "idle",
        label: "默认",
        duration: 5.967,
        voices: {"cn": {"subtitle": "“当越狱犯成为一种职业时，世界就快完蛋了。”——这是谁的点评？真不了解市场啊，有需才有供，早点面对现实吧。", "sound": "sounds/vo_6023_xianliao_03.wav"}, "en": {"subtitle": "“当越狱犯成为一种职业时，世界就快完蛋了。”——这是谁的点评？真不了解市场啊，有需才有供，早点面对现实吧。", "sound": "sounds/en_vo_6023_xianliao_03.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 602301015,
        audioId: 60230014,
        audioName: "vo_6023_zanyang",
        desc: "点击-赞扬1",
        group: "TapBody",
        index: 6,
        actionId: "waitou_1",
        label: "waitou_1",
        duration: 3.3,
        voices: {"cn": {"subtitle": "你在做坏事方面真是出类拔萃～教教我吧？", "sound": "sounds/vo_6023_zanyang.wav"}, "en": {"subtitle": "你在做坏事方面真是出类拔萃～教教我吧？", "sound": "sounds/en_vo_6023_zanyang.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 602301016,
        audioId: 60230006,
        audioName: "vo_6023_dianchu_tou",
        desc: "点击-头",
        group: "TapBody",
        index: 4,
        actionId: "songjian_1",
        label: "songjian_1",
        duration: 3.3,
        voices: {"cn": {"subtitle": "拍入狱照时，摄影师也叫我把眼睛睁大点，你们真会为难人。", "sound": "sounds/vo_6023_dianchu_tou.wav"}, "en": {"subtitle": "拍入狱照时，摄影师也叫我把眼睛睁大点，你们真会为难人。", "sound": "sounds/en_vo_6023_dianchu_tou.wav"}},
        hitAreaParam: "HitAreaHead",
        hitAreas: ["HitAreaHead"],
        sourceType2: 401,
        sourceWeight: 20,
        weight: 20
      },
      {
        showId: 602301017,
        audioId: 60230007,
        audioName: "vo_6023_dianchu_shou",
        desc: "点击-手",
        group: "TapBody",
        index: 2,
        actionId: "qianqing",
        label: "qianqing",
        duration: 3.4,
        voices: {"cn": {"subtitle": "手铐也是一种首饰呀，怎么就没人懂得鉴赏呢。", "sound": "sounds/vo_6023_dianchu_shou.wav"}, "en": {"subtitle": "手铐也是一种首饰呀，怎么就没人懂得鉴赏呢。", "sound": "sounds/en_vo_6023_dianchu_shou.wav"}},
        hitAreaParam: "HitAreaHandL#HitAreaHandR",
        hitAreas: ["HitAreaHandL", "HitAreaHandR"],
        sourceType2: 401,
        sourceWeight: 20,
        weight: 20
      },
      {
        showId: 602301018,
        audioId: 60230008,
        audioName: "vo_6023_dianchu_shen",
        desc: "点击-胸",
        group: "TapBody",
        index: 1,
        actionId: "houyang",
        label: "houyang",
        duration: 2.543,
        voices: {"cn": {"subtitle": "长官，还要检查到什么时候？我这个地方可藏不了什么东西。", "sound": "sounds/vo_6023_dianchu_shen.wav"}, "en": {"subtitle": "长官，还要检查到什么时候？我这个地方可藏不了什么东西。", "sound": "sounds/en_vo_6023_dianchu_shen.wav"}},
        hitAreaParam: "HitAreaBody",
        hitAreas: ["HitAreaBody"],
        sourceType2: 401,
        sourceWeight: 20,
        weight: 20
      }
    ]
  },
  {
    id: "103900_xs",
    title: "星闪 角色立绘",
    assetKind: "character",
    categoryLabel: "角色",
    modelDir: "103900_xs",
    sourceModelDir: "103900_xs",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "localassets_win32",
    styleId: "",
    styleName: "星闪",
    stage: "角色立绘",
    hitAreaNames: ["HitAreaBody", "HitAreaHandR1", "HitAreaHandR2", "HitAreaHandL", "HitAreaHead", "HitAreaMoren"],
    followConfigs: [{"id": 1012, "prefab": "103900_xs", "activeName": "", "expressionName": "", "damping": 0.0, "parameters": [{"parameterId": "ParamAngleX", "axis": "X", "factor": 50.0, "sourceToken": "ParamAngleX#50*X"}, {"parameterId": "ParamAngleY", "axis": "Y", "factor": 50.0, "sourceToken": "ParamAngleY#50*Y"}, {"parameterId": "ParamEyeBallX", "axis": "X", "factor": 70.0, "sourceToken": "ParamEyeBallX#70*X"}, {"parameterId": "ParamEyeBallY", "axis": "Y", "factor": 70.0, "sourceToken": "ParamEyeBallY#70*Y"}, {"parameterId": "ParamBodyAngleX", "axis": "X", "factor": 50.0, "sourceToken": "ParamBodyAngleX#50*X"}, {"parameterId": "ParamBodyAngleY", "axis": "Y", "factor": 50.0, "sourceToken": "ParamBodyAngleY#50*Y"}]}],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 6.0 }
        ]
      },
      {
        label: "TapBody",
        actions: [
          { group: "TapBody", index: 0, actionId: "daxiao", label: "daxiao", duration: 3.0 },
          { group: "TapBody", index: 1, actionId: "diantou", label: "diantou", duration: 3.0 },
          { group: "TapBody", index: 2, actionId: "houyang", label: "houyang", duration: 4.5 },
          { group: "TapBody", index: 3, actionId: "mopachong", label: "mopachong", duration: 4.9 },
          { group: "TapBody", index: 4, actionId: "mopachong_1", label: "mopachong_1", duration: 4.9 },
          { group: "TapBody", index: 5, actionId: "moxiaba", label: "moxiaba", duration: 4.5 },
          { group: "TapBody", index: 6, actionId: "moxiaba_1", label: "moxiaba_1", duration: 4.5 },
          { group: "TapBody", index: 7, actionId: "qianqing", label: "qianqing", duration: 4.5 },
          { group: "TapBody", index: 8, actionId: "tanshou", label: "tanshou", duration: 5.333 },
          { group: "TapBody", index: 9, actionId: "walk", label: "walk", duration: 2.0 },
          { group: "TapBody", index: 10, actionId: "yaotou", label: "yaotou", duration: 3.0 }
        ]
      }
    ],
    clickShowActions: [
      {
        showId: 602401010,
        audioId: 60240004,
        audioName: "vo_6024_daiji_01",
        desc: "点击-通用1",
        group: "TapBody",
        index: 6,
        actionId: "moxiaba_1",
        label: "moxiaba_1",
        duration: 4.5,
        voices: {"cn": {"subtitle": "我有几处“避风港”，那里藏了点好酒，还有……想知道？得看你愿意出什么价。", "sound": "sounds/vo_6024_daiji_01.wav"}, "en": {"subtitle": "我有几处“避风港”，那里藏了点好酒，还有……想知道？得看你愿意出什么价。", "sound": "sounds/en_vo_6024_daiji_01.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 602401011,
        audioId: 60240005,
        audioName: "vo_6024_daiji_02",
        desc: "点击-通用2",
        group: "TapBody",
        index: 4,
        actionId: "mopachong_1",
        label: "mopachong_1",
        duration: 4.9,
        voices: {"cn": {"subtitle": "今天没出海，我们休假。你以为海盗不讲排班？我们也有人事调度的好吧。", "sound": "sounds/vo_6024_daiji_02.wav"}, "en": {"subtitle": "今天没出海，我们休假。你以为海盗不讲排班？我们也有人事调度的好吧。", "sound": "sounds/en_vo_6024_daiji_02.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 602401012,
        audioId: 60240010,
        audioName: "vo_6024_xianliao_01",
        desc: "点击-闲聊1",
        group: "TapBody",
        index: 6,
        actionId: "moxiaba_1",
        label: "moxiaba_1",
        duration: 4.5,
        voices: {"cn": {"subtitle": "我的故事？没什么特别，就是海盗，宝藏，风暴，和一艘不肯停泊的船。", "sound": "sounds/vo_6024_xianliao_01.wav"}, "en": {"subtitle": "我的故事？没什么特别，就是海盗，宝藏，风暴，和一艘不肯停泊的船。", "sound": "sounds/en_vo_6024_xianliao_01.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 602401013,
        audioId: 60240011,
        audioName: "vo_6024_xianliao_02",
        desc: "点击-闲聊2",
        group: "TapBody",
        index: 8,
        actionId: "tanshou",
        label: "tanshou",
        duration: 5.333,
        voices: {"cn": {"subtitle": "光靠海上寻宝是要喝西北风的，只有扩展更多业务，比如打捞，捕鱼，再时不时请“贵客”上船喝杯酒……日子才过得下去～", "sound": "sounds/vo_6024_xianliao_02.wav"}, "en": {"subtitle": "光靠海上寻宝是要喝西北风的，只有扩展更多业务，比如打捞，捕鱼，再时不时请“贵客”上船喝杯酒……日子才过得下去～", "sound": "sounds/en_vo_6024_xianliao_02.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 602401014,
        audioId: 60240012,
        audioName: "vo_6024_xianliao_03",
        desc: "点击-闲聊3",
        group: "TapBody",
        index: 10,
        actionId: "yaotou",
        label: "yaotou",
        duration: 3.0,
        voices: {"cn": {"subtitle": "海盗是不会有乡愁的，我们在哪儿都能活下去……五湖四海，整个世界，都等着我们去抢夺。", "sound": "sounds/vo_6024_xianliao_03.wav"}, "en": {"subtitle": "海盗是不会有乡愁的，我们在哪儿都能活下去……五湖四海，整个世界，都等着我们去抢夺。", "sound": "sounds/en_vo_6024_xianliao_03.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 602401015,
        audioId: 60240014,
        audioName: "vo_6024_zanyang",
        desc: "点击-赞扬1",
        group: "TapBody",
        index: 7,
        actionId: "qianqing",
        label: "qianqing",
        duration: 4.5,
        voices: {"cn": {"subtitle": "你身上那股狠劲比海盗更像海盗，去厮杀、去掠夺，别浪费你的野心和本事。", "sound": "sounds/vo_6024_zanyang.wav"}, "en": {"subtitle": "你身上那股狠劲比海盗更像海盗，去厮杀、去掠夺，别浪费你的野心和本事。", "sound": "sounds/en_vo_6024_zanyang.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 602401016,
        audioId: 60240006,
        audioName: "vo_6024_dianchu_tou",
        desc: "点击-头",
        group: "TapBody",
        index: 8,
        actionId: "tanshou",
        label: "tanshou",
        duration: 5.333,
        voices: {"cn": {"subtitle": "喜欢我的脑袋吗？伊斯班尼的海盗悬赏榜上，它排第一，可值钱了。", "sound": "sounds/vo_6024_dianchu_tou.wav"}, "en": {"subtitle": "喜欢我的脑袋吗？伊斯班尼的海盗悬赏榜上，它排第一，可值钱了。", "sound": "sounds/en_vo_6024_dianchu_tou.wav"}},
        hitAreaParam: "HitAreaHead",
        hitAreas: ["HitAreaHead"],
        sourceType2: 401,
        sourceWeight: 20,
        weight: 20
      },
      {
        showId: 602401017,
        audioId: 60240007,
        audioName: "vo_6024_dianchu_shou",
        desc: "点击-手",
        group: "TapBody",
        index: 6,
        actionId: "moxiaba_1",
        label: "moxiaba_1",
        duration: 4.5,
        voices: {"cn": {"subtitle": "你也喜欢这些亮晶晶的珠宝？就是嘛，豁出性命抢来的财宝，当然要明晃晃地挂在身上，让别人眼红才行。", "sound": "sounds/vo_6024_dianchu_shou.wav"}, "en": {"subtitle": "你也喜欢这些亮晶晶的珠宝？就是嘛，豁出性命抢来的财宝，当然要明晃晃地挂在身上，让别人眼红才行。", "sound": "sounds/en_vo_6024_dianchu_shou.wav"}},
        hitAreaParam: "HitAreaHandL#HitAreaHandR1#HitAreaHandR2",
        hitAreas: ["HitAreaHandL", "HitAreaHandR1", "HitAreaHandR2"],
        sourceType2: 401,
        sourceWeight: 20,
        weight: 20
      },
      {
        showId: 602401018,
        audioId: 60240008,
        audioName: "vo_6024_dianchu_shen",
        desc: "点击-胸",
        group: "TapBody",
        index: 2,
        actionId: "houyang",
        label: "houyang",
        duration: 4.5,
        voices: {"cn": {"subtitle": "这么心安理得地摸上来？你比我还像个强盗。", "sound": "sounds/vo_6024_dianchu_shen.wav"}, "en": {"subtitle": "这么心安理得地摸上来？你比我还像个强盗。", "sound": "sounds/en_vo_6024_dianchu_shen.wav"}},
        hitAreaParam: "HitAreaBody",
        hitAreas: ["HitAreaBody"],
        sourceType2: 401,
        sourceWeight: 20,
        weight: 20
      }
    ]
  },
  {
    id: "103900_xs_cg",
    title: "海上浪子 一段",
    assetKind: "style",
    categoryLabel: "风格",
    modelDir: "103900_xs_cg",
    sourceModelDir: "103900_xs_cg",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "streamingassets",
    styleId: "13001039",
    styleName: "海上浪子",
    stage: "一段",
    hitAreaNames: ["HitAreaquanbu"],
    followConfigs: [{"id": 21018, "prefab": "103900_xs_cg", "activeName": "", "expressionName": "", "damping": 0.0, "parameters": [{"parameterId": "ParamAngleX", "axis": "X", "factor": 50.0, "sourceToken": "ParamAngleX#50*X"}, {"parameterId": "ParamAngleY", "axis": "Y", "factor": 50.0, "sourceToken": "ParamAngleY#50*Y"}, {"parameterId": "ParamEyeBallX", "axis": "X", "factor": 50.0, "sourceToken": "ParamEyeBallX#50*X"}, {"parameterId": "ParamEyeBallY", "axis": "Y", "factor": 50.0, "sourceToken": "ParamEyeBallY#50*Y"}, {"parameterId": "ParamBodyAngleX", "axis": "X", "factor": 30.0, "sourceToken": "ParamBodyAngleX#30*X"}, {"parameterId": "ParamBodyMae", "axis": "Y", "factor": 20.0, "sourceToken": "ParamBodyMae#20*Y"}]}],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 12.0 },
          { group: "Idle", index: 1, actionId: "idle1", label: "注视1", duration: 9.0 },
          { group: "Idle", index: 2, actionId: "idle2", label: "注视2", duration: 9.0 }
        ]
      },
      {
        label: "入场",
        actions: [
          { group: "Entry", index: 0, actionId: "ruchang", label: "入场", duration: 12.0 }
        ]
      }
    ],
    clickShowActions: [
      {
        showId: 61039009,
        audioId: 10390002,
        audioName: "vo_1039_yiduanchahua_01",
        desc: "点击1",
        group: "Idle",
        index: 1,
        actionId: "idle1",
        label: "注视1",
        duration: 9.0,
        voices: {"cn": {"subtitle": "风暴来临前，适合跟一个最特别的人，喝一杯最烈的酒。", "sound": "sounds/vo_1039_yiduanchahua_01.wav"}, "en": {"subtitle": "风暴来临前，适合跟一个最特别的人，喝一杯最烈的酒。", "sound": "sounds/en_vo_1039_yiduanchahua_01.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 20,
        weight: 20
      },
      {
        showId: 61039010,
        audioId: 10390003,
        audioName: "vo_1039_yiduanchahua_02",
        desc: "点击2",
        group: "Idle",
        index: 2,
        actionId: "idle2",
        label: "注视2",
        duration: 9.0,
        voices: {"cn": {"subtitle": "我的衣服湿成这样，什么也藏不住，算得上向你“坦诚相见”了，很有合作诚意吧。", "sound": "sounds/vo_1039_yiduanchahua_02.wav"}, "en": {"subtitle": "我的衣服湿成这样，什么也藏不住，算得上向你“坦诚相见”了，很有合作诚意吧。", "sound": "sounds/en_vo_1039_yiduanchahua_02.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 20,
        weight: 20
      },
      {
        showId: 61039011,
        audioId: 60240004,
        audioName: "vo_6024_daiji_01",
        desc: "点击-通用1",
        group: "Idle",
        index: 1,
        actionId: "idle1",
        label: "注视1",
        duration: 9.0,
        voices: {"cn": {"subtitle": "我有几处“避风港”，那里藏了点好酒，还有……想知道？得看你愿意出什么价。", "sound": "sounds/vo_6024_daiji_01.wav"}, "en": {"subtitle": "我有几处“避风港”，那里藏了点好酒，还有……想知道？得看你愿意出什么价。", "sound": "sounds/en_vo_6024_daiji_01.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 10,
        weight: 10
      },
      {
        showId: 61039012,
        audioId: 60240010,
        audioName: "vo_6024_xianliao_01",
        desc: "点击-闲聊1",
        group: "Idle",
        index: 1,
        actionId: "idle1",
        label: "注视1",
        duration: 9.0,
        voices: {"cn": {"subtitle": "我的故事？没什么特别，就是海盗，宝藏，风暴，和一艘不肯停泊的船。", "sound": "sounds/vo_6024_xianliao_01.wav"}, "en": {"subtitle": "我的故事？没什么特别，就是海盗，宝藏，风暴，和一艘不肯停泊的船。", "sound": "sounds/en_vo_6024_xianliao_01.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 10,
        weight: 10
      },
      {
        showId: 61039013,
        audioId: 60240012,
        audioName: "vo_6024_xianliao_03",
        desc: "点击-闲聊3",
        group: "Idle",
        index: 1,
        actionId: "idle1",
        label: "注视1",
        duration: 9.0,
        voices: {"cn": {"subtitle": "海盗是不会有乡愁的，我们在哪儿都能活下去……五湖四海，整个世界，都等着我们去抢夺。", "sound": "sounds/vo_6024_xianliao_03.wav"}, "en": {"subtitle": "海盗是不会有乡愁的，我们在哪儿都能活下去……五湖四海，整个世界，都等着我们去抢夺。", "sound": "sounds/en_vo_6024_xianliao_03.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 10,
        weight: 10
      },
      {
        showId: 61039014,
        audioId: 60240014,
        audioName: "vo_6024_zanyang",
        desc: "点击-赞扬1",
        group: "Idle",
        index: 2,
        actionId: "idle2",
        label: "注视2",
        duration: 9.0,
        voices: {"cn": {"subtitle": "你身上那股狠劲比海盗更像海盗，去厮杀、去掠夺，别浪费你的野心和本事。", "sound": "sounds/vo_6024_zanyang.wav"}, "en": {"subtitle": "你身上那股狠劲比海盗更像海盗，去厮杀、去掠夺，别浪费你的野心和本事。", "sound": "sounds/en_vo_6024_zanyang.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 10,
        weight: 10
      }
    ]
  },
  {
    id: "103901_xs",
    title: "预埋角色 103901_xs 角色候选",
    assetKind: "character",
    categoryLabel: "角色",
    modelDir: "103901_xs",
    sourceModelDir: "103901_xs",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "streamingassets",
    styleId: "",
    styleName: "预埋角色 103901_xs",
    stage: "角色候选",
    hitAreaNames: ["HitAreaMoren", "HitAreaBody", "HitAreaHandR", "HitAreaHead", "HitAreaHandL"],
    followConfigs: [],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 6.0 }
        ]
      },
      {
        label: "TapBody",
        actions: [
          { group: "TapBody", index: 0, actionId: "diantou", label: "diantou", duration: 3.0 },
          { group: "TapBody", index: 1, actionId: "houyang", label: "houyang", duration: 3.0 },
          { group: "TapBody", index: 2, actionId: "qianqing", label: "qianqing", duration: 3.5 },
          { group: "TapBody", index: 3, actionId: "waitou", label: "waitou", duration: 4.0 },
          { group: "TapBody", index: 4, actionId: "walk", label: "walk", duration: 2.0 },
          { group: "TapBody", index: 5, actionId: "yaotou", label: "yaotou", duration: 3.0 }
        ]
      }
    ],
    clickShowActions: [

    ]
  },
  {
    id: "103901_xs_cg",
    title: "海上浪子 二段",
    assetKind: "style",
    categoryLabel: "风格",
    modelDir: "103901_xs_cg",
    sourceModelDir: "103901_xs_cg",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "streamingassets",
    styleId: "13001039",
    styleName: "海上浪子",
    stage: "二段",
    hitAreaNames: ["HitAreagensui", "HitAreaquanbu"],
    followConfigs: [{"id": 21022, "prefab": "103901_xs_cg", "activeName": "HitAreagensui", "expressionName": "gensui01", "damping": 0.2, "parameters": [{"parameterId": "Paramgensui", "axis": "Y", "factor": 60.0, "sourceToken": "Paramgensui#60*Y"}, {"parameterId": "ParamAngleZ2", "axis": "Y", "factor": 10.0, "sourceToken": "ParamAngleZ2#10*Y"}, {"parameterId": "ParamRHandX2", "axis": "Y", "factor": 40.0, "sourceToken": "ParamRHandX2#40*Y"}, {"parameterId": "ParamNBodyX", "axis": "Y", "factor": 30.0, "sourceToken": "ParamNBodyX#30*Y"}, {"parameterId": "ParamLarm2Z7", "axis": "Y", "factor": 3.0, "sourceToken": "ParamLarm2Z7#3*Y"}, {"parameterId": "ParamLHandY2", "axis": "Y", "factor": 5.0, "sourceToken": "ParamLHandY2#5*Y"}, {"parameterId": "ParamLHandD2", "axis": "Y", "factor": 10.0, "sourceToken": "ParamLHandD2#10*Y"}]}],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [],
    storyTouchActions: [],
    unlockableMotions: [
      { group: "TapBody", index: 0, actionId: "dongzuo1", label: "亲近1", duration: 12.0 },
      { group: "TapBody", index: 1, actionId: "dongzuo2", label: "亲近2", duration: 15.0 },
      { group: "TapBody", index: 2, actionId: "dongzuo3", label: "亲近3", duration: 14.0 }
    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 12.0 },
          { group: "Idle", index: 1, actionId: "idle1", label: "注视1", duration: 8.0 },
          { group: "Idle", index: 2, actionId: "idle2", label: "注视2", duration: 8.0 }
        ]
      },
      {
        label: "TapBody",
        actions: [
          { group: "TapBody", index: 0, actionId: "dongzuo1", label: "亲近1", duration: 12.0 },
          { group: "TapBody", index: 1, actionId: "dongzuo2", label: "亲近2", duration: 15.0 },
          { group: "TapBody", index: 2, actionId: "dongzuo3", label: "亲近3", duration: 14.0 }
        ]
      },
      {
        label: "入场",
        actions: [
          { group: "Entry", index: 0, actionId: "ruchang", label: "入场", duration: 12.5 }
        ]
      }
    ],
    clickShowActions: [
      {
        showId: 61039055,
        audioId: 10390008,
        audioName: "vo_1039_erduanchahua_03",
        desc: "点击3",
        group: "TapBody",
        index: 0,
        actionId: "dongzuo1",
        label: "亲近1",
        duration: 12.0,
        voices: {"cn": {"subtitle": "刚才还对我下狠手，现在倒学会疼人了？你的手比你的嘴要有情得多了。", "sound": "sounds/vo_1039_erduanchahua_03.wav"}, "en": {"subtitle": "刚才还对我下狠手，现在倒学会疼人了？你的手比你的嘴要有情得多了。", "sound": "sounds/en_vo_1039_erduanchahua_03.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 20,
        weight: 20
      },
      {
        showId: 61039056,
        audioId: 10390009,
        audioName: "vo_1039_erduanchahua_04",
        desc: "点击4",
        group: "TapBody",
        index: 1,
        actionId: "dongzuo2",
        label: "亲近2",
        duration: 15.0,
        voices: {"cn": {"subtitle": "老水手说的没错，女人的心就像海上的雾，时浓时淡，忽远忽近，谁也琢磨不透，可偏偏我就吃你这一套。", "sound": "sounds/vo_1039_erduanchahua_04.wav"}, "en": {"subtitle": "老水手说的没错，女人的心就像海上的雾，时浓时淡，忽远忽近，谁也琢磨不透，可偏偏我就吃你这一套。", "sound": "sounds/en_vo_1039_erduanchahua_04.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 20,
        weight: 20
      },
      {
        showId: 61039057,
        audioId: 10390010,
        audioName: "vo_1039_erduanchahua_05",
        desc: "点击5",
        group: "TapBody",
        index: 2,
        actionId: "dongzuo3",
        label: "亲近3",
        duration: 14.0,
        voices: {"cn": {"subtitle": "怎么专挑别人脆弱的部位下脚……知道我的弱点后，你还会对我做什么吗？", "sound": "sounds/vo_1039_erduanchahua_05.wav"}, "en": {"subtitle": "怎么专挑别人脆弱的部位下脚……知道我的弱点后，你还会对我做什么吗？", "sound": "sounds/en_vo_1039_erduanchahua_05.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 20,
        weight: 20
      },
      {
        showId: 61039061,
        audioId: 10390006,
        audioName: "vo_1039_erduanchahua_01",
        desc: "点击1",
        group: "Idle",
        index: 1,
        actionId: "idle1",
        label: "注视1",
        duration: 8.0,
        voices: {"cn": {"subtitle": "我可以交代在你手里，但也得讨点彩头……不如，给我个吻吧？", "sound": "sounds/vo_1039_erduanchahua_01.wav"}, "en": {"subtitle": "我可以交代在你手里，但也得讨点彩头……不如，给我个吻吧？", "sound": "sounds/en_vo_1039_erduanchahua_01.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 10,
        weight: 10
      },
      {
        showId: 61039062,
        audioId: 10390007,
        audioName: "vo_1039_erduanchahua_02",
        desc: "点击2",
        group: "Idle",
        index: 2,
        actionId: "idle2",
        label: "注视2",
        duration: 8.0,
        voices: {"cn": {"subtitle": "别忘了，我是海盗，在水下，谁被谁捕获，还不一定呢。", "sound": "sounds/vo_1039_erduanchahua_02.wav"}, "en": {"subtitle": "别忘了，我是海盗，在水下，谁被谁捕获，还不一定呢。", "sound": "sounds/en_vo_1039_erduanchahua_02.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 10,
        weight: 10
      },
      {
        showId: 61039063,
        audioId: 60240004,
        audioName: "vo_6024_daiji_01",
        desc: "点击-通用1",
        group: "Idle",
        index: 1,
        actionId: "idle1",
        label: "注视1",
        duration: 8.0,
        voices: {"cn": {"subtitle": "我有几处“避风港”，那里藏了点好酒，还有……想知道？得看你愿意出什么价。", "sound": "sounds/vo_6024_daiji_01.wav"}, "en": {"subtitle": "我有几处“避风港”，那里藏了点好酒，还有……想知道？得看你愿意出什么价。", "sound": "sounds/en_vo_6024_daiji_01.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 61039064,
        audioId: 60240010,
        audioName: "vo_6024_xianliao_01",
        desc: "点击-闲聊1",
        group: "Idle",
        index: 1,
        actionId: "idle1",
        label: "注视1",
        duration: 8.0,
        voices: {"cn": {"subtitle": "我的故事？没什么特别，就是海盗，宝藏，风暴，和一艘不肯停泊的船。", "sound": "sounds/vo_6024_xianliao_01.wav"}, "en": {"subtitle": "我的故事？没什么特别，就是海盗，宝藏，风暴，和一艘不肯停泊的船。", "sound": "sounds/en_vo_6024_xianliao_01.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 61039065,
        audioId: 60240014,
        audioName: "vo_6024_zanyang",
        desc: "点击-赞扬1",
        group: "Idle",
        index: 2,
        actionId: "idle2",
        label: "注视2",
        duration: 8.0,
        voices: {"cn": {"subtitle": "你身上那股狠劲比海盗更像海盗，去厮杀、去掠夺，别浪费你的野心和本事。", "sound": "sounds/vo_6024_zanyang.wav"}, "en": {"subtitle": "你身上那股狠劲比海盗更像海盗，去厮杀、去掠夺，别浪费你的野心和本事。", "sound": "sounds/en_vo_6024_zanyang.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      }
    ]
  },
  {
    id: "104100_yjs",
    title: "银爵士 角色立绘",
    assetKind: "character",
    categoryLabel: "角色",
    modelDir: "104100_yjs",
    sourceModelDir: "104100_yjs",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "localassets_win32",
    styleId: "",
    styleName: "银爵士",
    stage: "角色立绘",
    hitAreaNames: ["HitAreaMoren", "HitAreaHandR1", "HitAreaHandL", "HitAreaBody", "HitAreaHead", "HitAreaHandR2"],
    followConfigs: [{"id": 1013, "prefab": "104100_yjs", "activeName": "", "expressionName": "", "damping": 0.0, "parameters": [{"parameterId": "ParamAngleX", "axis": "X", "factor": 30.0, "sourceToken": "ParamAngleX#30*X"}, {"parameterId": "ParamAngleY", "axis": "Y", "factor": 30.0, "sourceToken": "ParamAngleY#30*Y"}, {"parameterId": "ParamEyeBallX", "axis": "X", "factor": 50.0, "sourceToken": "ParamEyeBallX#50*X"}, {"parameterId": "ParamEyeBallY", "axis": "Y", "factor": 40.0, "sourceToken": "ParamEyeBallY#40*Y"}, {"parameterId": "ParamBodyAngleX", "axis": "X", "factor": 30.0, "sourceToken": "ParamBodyAngleX#30*X"}, {"parameterId": "ParamBodyAngleY", "axis": "Y", "factor": 50.0, "sourceToken": "ParamBodyAngleY#50*Y"}]}],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 6.0 }
        ]
      },
      {
        label: "TapBody",
        actions: [
          { group: "TapBody", index: 0, actionId: "diantou", label: "diantou", duration: 3.0 },
          { group: "TapBody", index: 1, actionId: "houyang", label: "houyang", duration: 4.5 },
          { group: "TapBody", index: 2, actionId: "qianqing", label: "qianqing", duration: 4.5 },
          { group: "TapBody", index: 3, actionId: "taiqi", label: "taiqi", duration: 3.633 },
          { group: "TapBody", index: 4, actionId: "taiqi_1", label: "taiqi_1", duration: 3.6 },
          { group: "TapBody", index: 5, actionId: "waitou", label: "waitou", duration: 3.433 },
          { group: "TapBody", index: 6, actionId: "walk", label: "walk", duration: 2.0 },
          { group: "TapBody", index: 7, actionId: "xingli", label: "xingli", duration: 4.3 },
          { group: "TapBody", index: 8, actionId: "yaotou", label: "yaotou", duration: 3.0 }
        ]
      }
    ],
    clickShowActions: [
      {
        showId: 602601010,
        audioId: 60260004,
        audioName: "vo_6026_daiji_01",
        desc: "点击-通用1",
        group: "TapBody",
        index: 4,
        actionId: "taiqi_1",
        label: "taiqi_1",
        duration: 3.6,
        voices: {"cn": {"subtitle": "下午茶已备妥，有客人钟爱的茉莉红茶，加了两勺半糖。我从哪了解到客人的喜好？抱歉，这是管家的职业秘密。", "sound": "sounds/vo_6026_daiji_01.wav"}, "en": {"subtitle": "下午茶已备妥，有客人钟爱的茉莉红茶，加了两勺半糖。我从哪了解到客人的喜好？抱歉，这是管家的职业秘密。", "sound": "sounds/en_vo_6026_daiji_01.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 602601011,
        audioId: 60260005,
        audioName: "vo_6026_daiji_02",
        desc: "点击-通用2",
        group: "TapBody",
        index: 8,
        actionId: "yaotou",
        label: "yaotou",
        duration: 3.0,
        voices: {"cn": {"subtitle": "很多人对我说，六十岁适合颐养天年，不必再为工作奔波。呵呵，他们哪里懂这里面的乐趣呢。", "sound": "sounds/vo_6026_daiji_02.wav"}, "en": {"subtitle": "很多人对我说，六十岁适合颐养天年，不必再为工作奔波。呵呵，他们哪里懂这里面的乐趣呢。", "sound": "sounds/en_vo_6026_daiji_02.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 602601012,
        audioId: 60260010,
        audioName: "vo_6026_xianliao_01",
        desc: "点击-闲聊1",
        group: "TapBody",
        index: 8,
        actionId: "yaotou",
        label: "yaotou",
        duration: 3.0,
        voices: {"cn": {"subtitle": "视浪费为格调，称歧视为教养，贵族间所谓的“优雅”，简直是在玷污这个词。", "sound": "sounds/vo_6026_xianliao_01.wav"}, "en": {"subtitle": "视浪费为格调，称歧视为教养，贵族间所谓的“优雅”，简直是在玷污这个词。", "sound": "sounds/en_vo_6026_xianliao_01.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 602601013,
        audioId: 60260011,
        audioName: "vo_6026_xianliao_02",
        desc: "点击-闲聊2",
        group: "Idle",
        index: 0,
        actionId: "idle",
        label: "默认",
        duration: 6.0,
        voices: {"cn": {"subtitle": "有几个家族成员自由惯了，随意一些也无妨。礼仪向来是约束自己，如果强加给别人，那就成了教条。", "sound": "sounds/vo_6026_xianliao_02.wav"}, "en": {"subtitle": "有几个家族成员自由惯了，随意一些也无妨。礼仪向来是约束自己，如果强加给别人，那就成了教条。", "sound": "sounds/en_vo_6026_xianliao_02.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 602601014,
        audioId: 60260012,
        audioName: "vo_6026_xianliao_03",
        desc: "点击-闲聊3",
        group: "TapBody",
        index: 5,
        actionId: "waitou",
        label: "waitou",
        duration: 3.433,
        voices: {"cn": {"subtitle": "哪怕再忙碌，也要给自己留下一杯茶的闲暇。连时间都会优雅地流淌，你又何必和它赛跑？", "sound": "sounds/vo_6026_xianliao_03.wav"}, "en": {"subtitle": "哪怕再忙碌，也要给自己留下一杯茶的闲暇。连时间都会优雅地流淌，你又何必和它赛跑？", "sound": "sounds/en_vo_6026_xianliao_03.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 602601015,
        audioId: 60260014,
        audioName: "vo_6026_zanyang",
        desc: "点击-赞扬1",
        group: "TapBody",
        index: 7,
        actionId: "xingli",
        label: "xingli",
        duration: 4.3,
        voices: {"cn": {"subtitle": "您继承了西西莉亚家族的精神，这比您手上的任何遗产都珍贵。", "sound": "sounds/vo_6026_zanyang.wav"}, "en": {"subtitle": "您继承了西西莉亚家族的精神，这比您手上的任何遗产都珍贵。", "sound": "sounds/en_vo_6026_zanyang.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 602601016,
        audioId: 60260006,
        audioName: "vo_6026_dianchu_tou",
        desc: "点击-头",
        group: "TapBody",
        index: 8,
        actionId: "yaotou",
        label: "yaotou",
        duration: 3.0,
        voices: {"cn": {"subtitle": "别被这头银发骗了，我的记性其实还不错。不过如果主人需要，我也可以适当忘记一些东西。", "sound": "sounds/vo_6026_dianchu_tou.wav"}, "en": {"subtitle": "别被这头银发骗了，我的记性其实还不错。不过如果主人需要，我也可以适当忘记一些东西。", "sound": "sounds/en_vo_6026_dianchu_tou.wav"}},
        hitAreaParam: "HitAreaHead",
        hitAreas: ["HitAreaHead"],
        sourceType2: 401,
        sourceWeight: 20,
        weight: 20
      },
      {
        showId: 602601017,
        audioId: 60260007,
        audioName: "vo_6026_dianchu_shou",
        desc: "点击-手",
        group: "Idle",
        index: 0,
        actionId: "idle",
        label: "默认",
        duration: 6.0,
        voices: {"cn": {"subtitle": "值得我摘下手套的工作不算多，每一件都有不少故事呢。", "sound": "sounds/vo_6026_dianchu_shou.wav"}, "en": {"subtitle": "值得我摘下手套的工作不算多，每一件都有不少故事呢。", "sound": "sounds/en_vo_6026_dianchu_shou.wav"}},
        hitAreaParam: "HitAreaHandL#HitAreaHandR1#HitAreaHandR2",
        hitAreas: ["HitAreaHandL", "HitAreaHandR1", "HitAreaHandR2"],
        sourceType2: 401,
        sourceWeight: 20,
        weight: 20
      },
      {
        showId: 602601018,
        audioId: 60260008,
        audioName: "vo_6026_dianchu_shen",
        desc: "点击-胸",
        group: "TapBody",
        index: 7,
        actionId: "xingli",
        label: "xingli",
        duration: 4.3,
        voices: {"cn": {"subtitle": "岁月能让身体老去，却不该让姿态屈服。这是我的小小坚持。", "sound": "sounds/vo_6026_dianchu_shen.wav"}, "en": {"subtitle": "岁月能让身体老去，却不该让姿态屈服。这是我的小小坚持。", "sound": "sounds/en_vo_6026_dianchu_shen.wav"}},
        hitAreaParam: "HitAreaBody",
        hitAreas: ["HitAreaBody"],
        sourceType2: 401,
        sourceWeight: 20,
        weight: 20
      }
    ]
  },
  {
    id: "104600_ls",
    title: "叻沙 角色立绘",
    assetKind: "character",
    categoryLabel: "角色",
    modelDir: "104600_ls",
    sourceModelDir: "104600_ls",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "localassets_win32",
    styleId: "",
    styleName: "叻沙",
    stage: "角色立绘",
    hitAreaNames: ["HitAreaHandR1", "HitAreaHandL", "HitAreaHandR2", "HitAreaHead", "HitAreaBody", "HitAreaMoren"],
    followConfigs: [{"id": 1009, "prefab": "104600_ls", "activeName": "", "expressionName": "", "damping": 0.0, "parameters": [{"parameterId": "ParamAngleX", "axis": "X", "factor": 50.0, "sourceToken": "ParamAngleX#50*X"}, {"parameterId": "ParamAngleY", "axis": "Y", "factor": 40.0, "sourceToken": "ParamAngleY#40*Y"}, {"parameterId": "ParamEyeBallX", "axis": "X", "factor": 80.0, "sourceToken": "ParamEyeBallX#80*X"}, {"parameterId": "ParamEyeBallY", "axis": "Y", "factor": 80.0, "sourceToken": "ParamEyeBallY#80*Y"}, {"parameterId": "ParamBodyAngleX", "axis": "X", "factor": 50.0, "sourceToken": "ParamBodyAngleX#50*X"}, {"parameterId": "ParamBodyAngleY", "axis": "Y", "factor": 50.0, "sourceToken": "ParamBodyAngleY#50*Y"}]}],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 6.0 }
        ]
      },
      {
        label: "TapBody",
        actions: [
          { group: "TapBody", index: 0, actionId: "diantou", label: "diantou", duration: 3.0 },
          { group: "TapBody", index: 1, actionId: "houyang", label: "houyang", duration: 4.5 },
          { group: "TapBody", index: 2, actionId: "lamaozi", label: "lamaozi", duration: 3.0 },
          { group: "TapBody", index: 3, actionId: "pingzi", label: "pingzi", duration: 6.267 },
          { group: "TapBody", index: 4, actionId: "qianqing", label: "qianqing", duration: 4.5 },
          { group: "TapBody", index: 5, actionId: "songjian", label: "songjian", duration: 3.0 },
          { group: "TapBody", index: 6, actionId: "songjian_1", label: "songjian_1", duration: 3.0 },
          { group: "TapBody", index: 7, actionId: "waitou", label: "waitou", duration: 4.5 },
          { group: "TapBody", index: 8, actionId: "waitou_1", label: "waitou_1", duration: 4.5 },
          { group: "TapBody", index: 9, actionId: "walk", label: "walk", duration: 2.0 },
          { group: "TapBody", index: 10, actionId: "yaotou", label: "yaotou", duration: 3.0 }
        ]
      }
    ],
    clickShowActions: [
      {
        showId: 602801010,
        audioId: 60280004,
        audioName: "vo_6028_daiji_01",
        desc: "点击-通用1",
        group: "TapBody",
        index: 6,
        actionId: "songjian_1",
        label: "songjian_1",
        duration: 3.0,
        voices: {"cn": {"subtitle": "今天客人塞钱给我，要买“让对方一见钟情”的香料……我遗憾地把钱袋推回去：香料不是仙丹好吧。", "sound": "sounds/vo_6028_daiji_01.wav"}, "en": {"subtitle": "今天客人塞钱给我，要买“让对方一见钟情”的香料……我遗憾地把钱袋推回去：香料不是仙丹好吧。", "sound": "sounds/en_vo_6028_daiji_01.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 602801011,
        audioId: 60280005,
        audioName: "vo_6028_daiji_02",
        desc: "点击-通用2",
        group: "TapBody",
        index: 3,
        actionId: "pingzi",
        label: "pingzi",
        duration: 6.267,
        voices: {"cn": {"subtitle": "香料价值几何？不好说。一袋香料换不来命，可命往往就是因为一袋香料没了。", "sound": "sounds/vo_6028_daiji_02.wav"}, "en": {"subtitle": "香料价值几何？不好说。一袋香料换不来命，可命往往就是因为一袋香料没了。", "sound": "sounds/en_vo_6028_daiji_02.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 602801012,
        audioId: 60280010,
        audioName: "vo_6028_xianliao_01",
        desc: "点击-闲聊1",
        group: "Idle",
        index: 0,
        actionId: "idle",
        label: "默认",
        duration: 6.0,
        voices: {"cn": {"subtitle": "我妈最爱叻沙叶的味道，我小时候偷偷种了一大片，风一吹，整个庄园都跟她厨房一样香。", "sound": "sounds/vo_6028_xianliao_01.wav"}, "en": {"subtitle": "我妈最爱叻沙叶的味道，我小时候偷偷种了一大片，风一吹，整个庄园都跟她厨房一样香。", "sound": "sounds/en_vo_6028_xianliao_01.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 602801013,
        audioId: 60280011,
        audioName: "vo_6028_xianliao_02",
        desc: "点击-闲聊2",
        group: "TapBody",
        index: 3,
        actionId: "pingzi",
        label: "pingzi",
        duration: 6.267,
        voices: {"cn": {"subtitle": "一些在我家乡常见的香草，到了这边却跟黄金一样贵。唉，真想回那个遍地是宝的地方多进点货。", "sound": "sounds/vo_6028_xianliao_02.wav"}, "en": {"subtitle": "一些在我家乡常见的香草，到了这边却跟黄金一样贵。唉，真想回那个遍地是宝的地方多进点货。", "sound": "sounds/en_vo_6028_xianliao_02.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 602801014,
        audioId: 60280012,
        audioName: "vo_6028_xianliao_03",
        desc: "点击-闲聊3",
        group: "TapBody",
        index: 3,
        actionId: "pingzi",
        label: "pingzi",
        duration: 6.267,
        voices: {"cn": {"subtitle": "我曾经把一包卖不出去的香料偷偷放进盗贼的饭里，天知道会有什么效果。总之……他们第二天就没力气蹲点我了。", "sound": "sounds/vo_6028_xianliao_03.wav"}, "en": {"subtitle": "我曾经把一包卖不出去的香料偷偷放进盗贼的饭里，天知道会有什么效果。总之……他们第二天就没力气蹲点我了。", "sound": "sounds/en_vo_6028_xianliao_03.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 602801015,
        audioId: 60280014,
        audioName: "vo_6028_zanyang",
        desc: "点击-赞扬1",
        group: "TapBody",
        index: 2,
        actionId: "lamaozi",
        label: "lamaozi",
        duration: 3.0,
        voices: {"cn": {"subtitle": "做生意最要紧的东西，是眼界和手段。这两样你都有了，如果你是个商人，我还真得提防你抢走我的生意。", "sound": "sounds/vo_6028_zanyang.wav"}, "en": {"subtitle": "做生意最要紧的东西，是眼界和手段。这两样你都有了，如果你是个商人，我还真得提防你抢走我的生意。", "sound": "sounds/en_vo_6028_zanyang.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 602801016,
        audioId: 60280006,
        audioName: "vo_6028_dianchu_tou",
        desc: "点击-头",
        group: "TapBody",
        index: 8,
        actionId: "waitou_1",
        label: "waitou_1",
        duration: 4.5,
        voices: {"cn": {"subtitle": "香味能牵着鼻子走，是因为它牵系着记忆。我不过是个把回忆装进袋子里卖的人罢了。", "sound": "sounds/vo_6028_dianchu_tou.wav"}, "en": {"subtitle": "香味能牵着鼻子走，是因为它牵系着记忆。我不过是个把回忆装进袋子里卖的人罢了。", "sound": "sounds/en_vo_6028_dianchu_tou.wav"}},
        hitAreaParam: "HitAreaHead",
        hitAreas: ["HitAreaHead"],
        sourceType2: 401,
        sourceWeight: 20,
        weight: 20
      },
      {
        showId: 602801017,
        audioId: 60280007,
        audioName: "vo_6028_dianchu_shou",
        desc: "点击-手",
        group: "TapBody",
        index: 6,
        actionId: "songjian_1",
        label: "songjian_1",
        duration: 3.0,
        voices: {"cn": {"subtitle": "这双手啊，本来是可以戴满戒指的，现在倒是习惯数零钱了。", "sound": "sounds/vo_6028_dianchu_shou.wav"}, "en": {"subtitle": "这双手啊，本来是可以戴满戒指的，现在倒是习惯数零钱了。", "sound": "sounds/en_vo_6028_dianchu_shou.wav"}},
        hitAreaParam: "HitAreaHandL#HitAreaHandR1#HitAreaHandR2",
        hitAreas: ["HitAreaHandL", "HitAreaHandR1", "HitAreaHandR2"],
        sourceType2: 401,
        sourceWeight: 20,
        weight: 20
      },
      {
        showId: 602801018,
        audioId: 60280008,
        audioName: "vo_6028_dianchu_xiong",
        desc: "点击-胸",
        group: "TapBody",
        index: 4,
        actionId: "qianqing",
        label: "qianqing",
        duration: 4.5,
        voices: {"cn": {"subtitle": "我整天待在香料堆里，时间长了，身上也沾染了味道。什么，是腌入味了？哎……就没有更浪漫一点的说法了嘛？", "sound": "sounds/vo_6028_dianchu_xiong.wav"}, "en": {"subtitle": "我整天待在香料堆里，时间长了，身上也沾染了味道。什么，是腌入味了？哎……就没有更浪漫一点的说法了嘛？", "sound": "sounds/en_vo_6028_dianchu_xiong.wav"}},
        hitAreaParam: "HitAreaBody",
        hitAreas: ["HitAreaBody"],
        sourceType2: 401,
        sourceWeight: 20,
        weight: 20
      }
    ]
  },
  {
    id: "104900_df",
    title: "预埋角色 104900_df 角色候选",
    assetKind: "character",
    categoryLabel: "角色",
    modelDir: "104900_df",
    sourceModelDir: "104900_df",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "localassets_win32",
    styleId: "",
    styleName: "预埋角色 104900_df",
    stage: "角色候选",
    hitAreaNames: ["HitAreaHead", "HitAreaHand", "HitAreaBody", "HitAreaMoren"],
    followConfigs: [{"id": 1011, "prefab": "104900_df", "activeName": "", "expressionName": "", "damping": 0.0, "parameters": [{"parameterId": "ParamEyeBallX", "axis": "X", "factor": 22.0, "sourceToken": "ParamEyeBallX#22*X"}, {"parameterId": "ParamEyeBallY", "axis": "Y", "factor": 50.0, "sourceToken": "ParamEyeBallY#50*Y"}, {"parameterId": "ParamAngleX", "axis": "X", "factor": 13.0, "sourceToken": "ParamAngleX#13*X"}, {"parameterId": "ParamAngleY", "axis": "Y", "factor": 70.0, "sourceToken": "ParamAngleY#70*Y"}, {"parameterId": "ParamBodyAngleX", "axis": "X", "factor": 8.0, "sourceToken": "ParamBodyAngleX#8*X"}, {"parameterId": "ParamBodyAngleY", "axis": "Y", "factor": 60.0, "sourceToken": "ParamBodyAngleY#60*Y"}]}, {"id": 30001, "prefab": "104900_df", "activeName": "HitAreaHand", "expressionName": "", "damping": 0.0, "parameters": [{"parameterId": "Param32", "axis": "Y", "factor": 100.0, "sourceToken": "Param32#100*Y"}]}],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 5.97 }
        ]
      },
      {
        label: "TapBody",
        actions: [
          { group: "TapBody", index: 0, actionId: "diantou", label: "diantou", duration: 2.571 },
          { group: "TapBody", index: 1, actionId: "jingti", label: "jingti", duration: 4.5 },
          { group: "TapBody", index: 2, actionId: "waitou", label: "waitou", duration: 2.812 },
          { group: "TapBody", index: 3, actionId: "walk", label: "walk", duration: 1.714 },
          { group: "TapBody", index: 4, actionId: "yaotou", label: "yaotou", duration: 2.571 }
        ]
      }
    ],
    clickShowActions: [

    ]
  },
  {
    id: "105400_ng",
    title: "NG 角色立绘",
    assetKind: "character",
    categoryLabel: "角色",
    modelDir: "105400_ng",
    sourceModelDir: "105400_ng",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "localassets_win32",
    styleId: "",
    styleName: "NG",
    stage: "角色立绘",
    hitAreaNames: ["HitAreaHandR", "HitAreaBody", "HitAreaHead", "HitAreaHandL", "HitAreaMoren"],
    followConfigs: [{"id": 1039, "prefab": "105400_ng", "activeName": "", "expressionName": "", "damping": 0.0, "parameters": [{"parameterId": "ParamAngleX", "axis": "X", "factor": 30.0, "sourceToken": "ParamAngleX#30*X"}, {"parameterId": "ParamAngleY", "axis": "Y", "factor": 30.0, "sourceToken": "ParamAngleY#30*Y"}, {"parameterId": "ParamEyeBallX", "axis": "X", "factor": 80.0, "sourceToken": "ParamEyeBallX#80*X"}, {"parameterId": "ParamEyeBallY", "axis": "Y", "factor": 80.0, "sourceToken": "ParamEyeBallY#80*Y"}, {"parameterId": "ParamBodyAngleX", "axis": "X", "factor": 50.0, "sourceToken": "ParamBodyAngleX#50*X"}, {"parameterId": "ParamBodyAngleY", "axis": "Y", "factor": 50.0, "sourceToken": "ParamBodyAngleY#50*Y"}]}],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 6.0 }
        ]
      },
      {
        label: "TapBody",
        actions: [
          { group: "TapBody", index: 0, actionId: "baidong", label: "baidong", duration: 3.133 },
          { group: "TapBody", index: 1, actionId: "baidong_1", label: "baidong_1", duration: 3.133 },
          { group: "TapBody", index: 2, actionId: "diantou", label: "diantou", duration: 3.0 },
          { group: "TapBody", index: 3, actionId: "qianqing", label: "qianqing", duration: 4.667 },
          { group: "TapBody", index: 4, actionId: "qianqing_1", label: "qianqing_1", duration: 4.667 },
          { group: "TapBody", index: 5, actionId: "sikao", label: "sikao", duration: 5.0 },
          { group: "TapBody", index: 6, actionId: "waitou", label: "waitou", duration: 3.333 },
          { group: "TapBody", index: 7, actionId: "waitou_1", label: "waitou_1", duration: 3.333 },
          { group: "TapBody", index: 8, actionId: "walk", label: "walk", duration: 2.0 },
          { group: "TapBody", index: 9, actionId: "yaotou", label: "yaotou", duration: 3.0 }
        ]
      }
    ],
    clickShowActions: [
      {
        showId: 603001010,
        audioId: 60300004,
        audioName: "vo_6030_daiji_01",
        desc: "点击-通用1",
        group: "TapBody",
        index: 9,
        actionId: "yaotou",
        label: "yaotou",
        duration: 3.0,
        voices: {"cn": {"subtitle": "离别时流泪，相爱时拥抱……这些无聊的剧本我都厌倦了，我更喜欢在厮杀中交换的谎言之吻，在缠绵中诞生的晦涩恨意……", "sound": "sounds/vo_6030_daiji_01.wav"}, "en": {"subtitle": "离别时流泪，相爱时拥抱……这些无聊的剧本我都厌倦了，我更喜欢在厮杀中交换的谎言之吻，在缠绵中诞生的晦涩恨意……", "sound": "sounds/en_vo_6030_daiji_01.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 603001011,
        audioId: 60300005,
        audioName: "vo_6030_daiji_02",
        desc: "点击-通用2",
        group: "TapBody",
        index: 4,
        actionId: "qianqing_1",
        label: "qianqing_1",
        duration: 4.667,
        voices: {"cn": {"subtitle": "你在注视着什么？为什么一直不说话……为什么不看屏幕中的我？", "sound": "sounds/vo_6030_daiji_02.wav"}, "en": {"subtitle": "你在注视着什么？为什么一直不说话……为什么不看屏幕中的我？", "sound": "sounds/en_vo_6030_daiji_02.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 603001012,
        audioId: 60300010,
        audioName: "vo_6030_xianliao_01",
        desc: "点击-闲聊1",
        group: "TapBody",
        index: 5,
        actionId: "sikao",
        label: "sikao",
        duration: 5.0,
        voices: {"cn": {"subtitle": "现在的我，只会对流血的艺术感兴趣，噱头、冲击力、感官刺激……但最初，我只是试着把一朵花涂在白纸上。", "sound": "sounds/vo_6030_xianliao_01.wav"}, "en": {"subtitle": "现在的我，只会对流血的艺术感兴趣，噱头、冲击力、感官刺激……但最初，我只是试着把一朵花涂在白纸上。", "sound": "sounds/en_vo_6030_xianliao_01.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 603001013,
        audioId: 60300011,
        audioName: "vo_6030_xianliao_02",
        desc: "点击-闲聊2",
        group: "TapBody",
        index: 5,
        actionId: "sikao",
        label: "sikao",
        duration: 5.0,
        voices: {"cn": {"subtitle": "作者死后，作品的价值才会开始攀升。如果我真的死掉，你会像珍视画作那样，分给我一点……永恒的注视吗？", "sound": "sounds/vo_6030_xianliao_02.wav"}, "en": {"subtitle": "作者死后，作品的价值才会开始攀升。如果我真的死掉，你会像珍视画作那样，分给我一点……永恒的注视吗？", "sound": "sounds/en_vo_6030_xianliao_02.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 603001014,
        audioId: 60300012,
        audioName: "vo_6030_xianliao_03",
        desc: "点击-闲聊3",
        group: "TapBody",
        index: 9,
        actionId: "yaotou",
        label: "yaotou",
        duration: 3.0,
        voices: {"cn": {"subtitle": "比起光鲜亮丽而平庸的东西，我更喜欢残缺品。每道裂痕都在诉说，为了到达这一步，它曾经历过怎样的挣扎。", "sound": "sounds/vo_6030_xianliao_03.wav"}, "en": {"subtitle": "比起光鲜亮丽而平庸的东西，我更喜欢残缺品。每道裂痕都在诉说，为了到达这一步，它曾经历过怎样的挣扎。", "sound": "sounds/en_vo_6030_xianliao_03.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 603001015,
        audioId: 60300014,
        audioName: "vo_6030_zanyang",
        desc: "点击-赞扬1",
        group: "Idle",
        index: 0,
        actionId: "idle",
        label: "默认",
        duration: 6.0,
        voices: {"cn": {"subtitle": "世界是无聊的，世界是荒诞的，一切都是剧本，一切都在重播，直到你推门进入，我才发现我一直被困在墙里……", "sound": "sounds/vo_6030_zanyang.wav"}, "en": {"subtitle": "世界是无聊的，世界是荒诞的，一切都是剧本，一切都在重播，直到你推门进入，我才发现我一直被困在墙里……", "sound": "sounds/en_vo_6030_zanyang.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 603001016,
        audioId: 60300006,
        audioName: "vo_6030_dianchu_tou",
        desc: "点击-头",
        group: "TapBody",
        index: 4,
        actionId: "qianqing_1",
        label: "qianqing_1",
        duration: 4.667,
        voices: {"cn": {"subtitle": "对，就这样，握住我的脖子，然后收紧……只有这样濒临窒息的快感，才能给这副躯壳带来一点活着的错觉。", "sound": "sounds/vo_6030_dianchu_tou.wav"}, "en": {"subtitle": "对，就这样，握住我的脖子，然后收紧……只有这样濒临窒息的快感，才能给这副躯壳带来一点活着的错觉。", "sound": "sounds/en_vo_6030_dianchu_tou.wav"}},
        hitAreaParam: "HitAreaHead",
        hitAreas: ["HitAreaHead"],
        sourceType2: 401,
        sourceWeight: 20,
        weight: 20
      },
      {
        showId: 603001017,
        audioId: 60300007,
        audioName: "vo_6030_dianchu_shou",
        desc: "点击-手",
        group: "Idle",
        index: 0,
        actionId: "idle",
        label: "默认",
        duration: 6.0,
        voices: {"cn": {"subtitle": "石头和白纸廉价而无趣，注定无人问津，只有被我亲手雕琢、污染后才会产生一点被人观看的价值，你不觉得吗？", "sound": "sounds/vo_6030_dianchu_shou.wav"}, "en": {"subtitle": "石头和白纸廉价而无趣，注定无人问津，只有被我亲手雕琢、污染后才会产生一点被人观看的价值，你不觉得吗？", "sound": "sounds/en_vo_6030_dianchu_shou.wav"}},
        hitAreaParam: "HitAreaHandL#HitAreaHandR",
        hitAreas: ["HitAreaHandL", "HitAreaHandR"],
        sourceType2: 401,
        sourceWeight: 20,
        weight: 20
      },
      {
        showId: 603001018,
        audioId: 60300008,
        audioName: "vo_6030_dianchu_shen",
        desc: "点击-胸",
        group: "TapBody",
        index: 4,
        actionId: "qianqing_1",
        label: "qianqing_1",
        duration: 4.667,
        voices: {"cn": {"subtitle": "想要留下痕迹吗？随你喜欢……反正这块伤痕累累的画板，本来就在等你的最后一笔。", "sound": "sounds/vo_6030_dianchu_shen.wav"}, "en": {"subtitle": "想要留下痕迹吗？随你喜欢……反正这块伤痕累累的画板，本来就在等你的最后一笔。", "sound": "sounds/en_vo_6030_dianchu_shen.wav"}},
        hitAreaParam: "HitAreaBody",
        hitAreas: ["HitAreaBody"],
        sourceType2: 401,
        sourceWeight: 20,
        weight: 20
      }
    ]
  },
  {
    id: "105400_ng_cg",
    title: "造梦制片人 一段",
    assetKind: "style",
    categoryLabel: "风格",
    modelDir: "105400_ng_cg",
    sourceModelDir: "105400_ng_cg",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "localassets_win32",
    styleId: "13001054",
    styleName: "造梦制片人",
    stage: "一段",
    hitAreaNames: ["HitAreagensui", "HitAreamoren"],
    followConfigs: [{"id": 21027, "prefab": "105400_ng_cg", "activeName": "HitAreagensui", "expressionName": "gensui01", "damping": 0.4, "parameters": [{"parameterId": "ParamAngleZ", "axis": "Y", "factor": 3.0, "sourceToken": "ParamAngleZ#3*Y"}, {"parameterId": "ParamBodyAngleZ", "axis": "Y", "factor": 1.0, "sourceToken": "ParamBodyAngleZ#1*Y"}, {"parameterId": "ParamLarm1", "axis": "Y", "factor": 1.0, "sourceToken": "ParamLarm1#1*Y"}, {"parameterId": "ParamLarm2", "axis": "Y", "factor": 1.0, "sourceToken": "ParamLarm2#1*Y"}, {"parameterId": "ParamLarm5", "axis": "Y", "factor": 3.0, "sourceToken": "ParamLarm5#3*Y"}, {"parameterId": "ParamLfg1s", "axis": "Y", "factor": 10.0, "sourceToken": "ParamLfg1s#10*Y"}, {"parameterId": "ParamLfg2s", "axis": "Y", "factor": 10.0, "sourceToken": "ParamLfg2s#10*Y"}, {"parameterId": "ParamLfg3s", "axis": "Y", "factor": 10.0, "sourceToken": "ParamLfg3s#10*Y"}, {"parameterId": "ParamLfg4s", "axis": "Y", "factor": 10.0, "sourceToken": "ParamLfg4s#10*Y"}, {"parameterId": "ParamLfg5s", "axis": "Y", "factor": 10.0, "sourceToken": "ParamLfg5s#10*Y"}, {"parameterId": "ParamNZx", "axis": "Y", "factor": 12.0, "sourceToken": "ParamNZx#12*Y"}, {"parameterId": "ParamNZx3", "axis": "Y", "factor": -10.0, "sourceToken": "ParamNZx3#-10*Y"}]}],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 16.0 },
          { group: "Idle", index: 1, actionId: "idle1", label: "注视1", duration: 16.0 },
          { group: "Idle", index: 2, actionId: "idle2", label: "注视2", duration: 20.0 }
        ]
      },
      {
        label: "TapBody",
        actions: [
          { group: "TapBody", index: 0, actionId: "loop", label: "loop", duration: 16.0 }
        ]
      },
      {
        label: "入场",
        actions: [
          { group: "Entry", index: 0, actionId: "ruchang", label: "入场", duration: 15.0 }
        ]
      }
    ],
    clickShowActions: [
      {
        showId: 61054006,
        audioId: 10540002,
        audioName: "vo_1054_yiduanchahua_01",
        desc: "点击1",
        group: "Idle",
        index: 1,
        actionId: "idle1",
        label: "注视1",
        duration: 16.0,
        voices: {"cn": {"subtitle": "一切布景都冰冷而虚假，但你……却似乎能从指尖点燃我，点燃我的身体和灵魂，将我燃烧殆尽。", "sound": "sounds/vo_1054_yiduanchahua_01.wav"}, "en": {"subtitle": "一切布景都冰冷而虚假，但你……却似乎能从指尖点燃我，点燃我的身体和灵魂，将我燃烧殆尽。", "sound": "sounds/en_vo_1054_yiduanchahua_01.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 20,
        weight: 20
      },
      {
        showId: 61054007,
        audioId: 10540003,
        audioName: "vo_1054_yiduanchahua_02",
        desc: "点击2",
        group: "Idle",
        index: 2,
        actionId: "idle2",
        label: "注视2",
        duration: 20.0,
        voices: {"cn": {"subtitle": "集中于屏幕里廉价的缠绵……我好像，错过了一个真实存在的吻。", "sound": "sounds/vo_1054_yiduanchahua_02.wav"}, "en": {"subtitle": "集中于屏幕里廉价的缠绵……我好像，错过了一个真实存在的吻。", "sound": "sounds/en_vo_1054_yiduanchahua_02.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 20,
        weight: 20
      },
      {
        showId: 61054008,
        audioId: 60300014,
        audioName: "vo_6030_zanyang",
        desc: "点击-赞扬1",
        group: "Idle",
        index: 1,
        actionId: "idle1",
        label: "注视1",
        duration: 16.0,
        voices: {"cn": {"subtitle": "世界是无聊的，世界是荒诞的，一切都是剧本，一切都在重播，直到你推门进入，我才发现我一直被困在墙里……", "sound": "sounds/vo_6030_zanyang.wav"}, "en": {"subtitle": "世界是无聊的，世界是荒诞的，一切都是剧本，一切都在重播，直到你推门进入，我才发现我一直被困在墙里……", "sound": "sounds/en_vo_6030_zanyang.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 10,
        weight: 10
      }
    ]
  },
  {
    id: "105401_ng_cg",
    title: "造梦制片人 二段",
    assetKind: "style",
    categoryLabel: "风格",
    modelDir: "105401_ng_cg",
    sourceModelDir: "105401_ng_cg",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "localassets_win32",
    styleId: "13001054",
    styleName: "造梦制片人",
    stage: "二段",
    hitAreaNames: ["HitAreagensui", "HitAreamoren"],
    followConfigs: [{"id": 21028, "prefab": "105401_ng_cg", "activeName": "HitAreagensui", "expressionName": "gensui01", "damping": 0.8, "parameters": [{"parameterId": "ParamEyeBallX", "axis": "X", "factor": 12.0, "sourceToken": "ParamEyeBallX#12*X"}, {"parameterId": "ParamAngleX", "axis": "X", "factor": 4.0, "sourceToken": "ParamAngleX#4*X"}, {"parameterId": "ParamBodyAngleX", "axis": "X", "factor": 2.0, "sourceToken": "ParamBodyAngleX#2*X"}, {"parameterId": "ParamNRarm2Z", "axis": "X", "factor": 5.0, "sourceToken": "ParamNRarm2Z#5*X"}, {"parameterId": "ParamidleS", "axis": "X", "factor": 10.0, "sourceToken": "ParamidleS#10*X"}, {"parameterId": "Paramanya", "axis": "X", "factor": 75.0, "sourceToken": "Paramanya#75*X"}]}],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [],
    storyTouchActions: [],
    unlockableMotions: [
      { group: "TapBody", index: 0, actionId: "dongzuo1", label: "亲近1", duration: 12.5 },
      { group: "TapBody", index: 1, actionId: "dongzuo2", label: "亲近2", duration: 15.0 },
      { group: "TapBody", index: 2, actionId: "dongzuo3", label: "亲近3", duration: 15.167 }
    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 12.0 },
          { group: "Idle", index: 1, actionId: "idle1", label: "注视1", duration: 12.0 },
          { group: "Idle", index: 2, actionId: "idle2", label: "注视2", duration: 12.0 }
        ]
      },
      {
        label: "TapBody",
        actions: [
          { group: "TapBody", index: 0, actionId: "dongzuo1", label: "亲近1", duration: 12.5 },
          { group: "TapBody", index: 1, actionId: "dongzuo2", label: "亲近2", duration: 15.0 },
          { group: "TapBody", index: 2, actionId: "dongzuo3", label: "亲近3", duration: 15.167 }
        ]
      },
      {
        label: "入场",
        actions: [
          { group: "Entry", index: 0, actionId: "ruchang", label: "入场", duration: 18.0 }
        ]
      }
    ],
    clickShowActions: [
      {
        showId: 61054055,
        audioId: 10540008,
        audioName: "vo_1054_erduanchahua_03",
        desc: "点击3",
        group: "TapBody",
        index: 0,
        actionId: "dongzuo1",
        label: "亲近1",
        duration: 12.5,
        voices: {"cn": {"subtitle": "继续吧，让我染上你的味道，让我变成你的……我是第一个，被你这么暴力涂抹的作品吗？", "sound": "sounds/vo_1054_erduanchahua_03.wav"}, "en": {"subtitle": "继续吧，让我染上你的味道，让我变成你的……我是第一个，被你这么暴力涂抹的作品吗？", "sound": "sounds/en_vo_1054_erduanchahua_03.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 20,
        weight: 20
      },
      {
        showId: 61054056,
        audioId: 10540009,
        audioName: "vo_1054_erduanchahua_04",
        desc: "点击4",
        group: "TapBody",
        index: 1,
        actionId: "dongzuo2",
        label: "亲近2",
        duration: 15.0,
        voices: {"cn": {"subtitle": "太浅了……如果这份痛不入骨，被你重塑的真实感，很快就会消失的……", "sound": "sounds/vo_1054_erduanchahua_04.wav"}, "en": {"subtitle": "太浅了……如果这份痛不入骨，被你重塑的真实感，很快就会消失的……", "sound": "sounds/en_vo_1054_erduanchahua_04.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 20,
        weight: 20
      },
      {
        showId: 61054057,
        audioId: 10540010,
        audioName: "vo_1054_erduanchahua_05",
        desc: "点击5",
        group: "TapBody",
        index: 2,
        actionId: "dongzuo3",
        label: "亲近3",
        duration: 15.167,
        voices: {"cn": {"subtitle": "继续看着我吧……如同我注视着你。我们就这样纠缠和塑造，在暧昧和杀意中把对方变得面目全非。", "sound": "sounds/vo_1054_erduanchahua_05.wav"}, "en": {"subtitle": "继续看着我吧……如同我注视着你。我们就这样纠缠和塑造，在暧昧和杀意中把对方变得面目全非。", "sound": "sounds/en_vo_1054_erduanchahua_05.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 20,
        weight: 20
      },
      {
        showId: 61054061,
        audioId: 10540006,
        audioName: "vo_1054_erduanchahua_01",
        desc: "点击1",
        group: "Idle",
        index: 1,
        actionId: "idle1",
        label: "注视1",
        duration: 12.0,
        voices: {"cn": {"subtitle": "哈……就是这样，鲜活的红色，你给我的颜色……别停下，我所有的感知，现在……全由你来定义。", "sound": "sounds/vo_1054_erduanchahua_01.wav"}, "en": {"subtitle": "哈……就是这样，鲜活的红色，你给我的颜色……别停下，我所有的感知，现在……全由你来定义。", "sound": "sounds/en_vo_1054_erduanchahua_01.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 10,
        weight: 10
      },
      {
        showId: 61054062,
        audioId: 10540007,
        audioName: "vo_1054_erduanchahua_02",
        desc: "点击2",
        group: "Idle",
        index: 2,
        actionId: "idle2",
        label: "注视2",
        duration: 12.0,
        voices: {"cn": {"subtitle": "别只是隔着躯壳试探……哈啊，为什么不划开这里，直接触碰我的心呢？那样我们才能真正融为一体……", "sound": "sounds/vo_1054_erduanchahua_02.wav"}, "en": {"subtitle": "别只是隔着躯壳试探……哈啊，为什么不划开这里，直接触碰我的心呢？那样我们才能真正融为一体……", "sound": "sounds/en_vo_1054_erduanchahua_02.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 10,
        weight: 10
      },
      {
        showId: 61054063,
        audioId: 60300010,
        audioName: "vo_6030_xianliao_01",
        desc: "点击-闲聊1",
        group: "Idle",
        index: 1,
        actionId: "idle1",
        label: "注视1",
        duration: 12.0,
        voices: {"cn": {"subtitle": "现在的我，只会对流血的艺术感兴趣，噱头、冲击力、感官刺激……但最初，我只是试着把一朵花涂在白纸上。", "sound": "sounds/vo_6030_xianliao_01.wav"}, "en": {"subtitle": "现在的我，只会对流血的艺术感兴趣，噱头、冲击力、感官刺激……但最初，我只是试着把一朵花涂在白纸上。", "sound": "sounds/en_vo_6030_xianliao_01.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 61054064,
        audioId: 60300011,
        audioName: "vo_6030_xianliao_02",
        desc: "点击-闲聊2",
        group: "Idle",
        index: 2,
        actionId: "idle2",
        label: "注视2",
        duration: 12.0,
        voices: {"cn": {"subtitle": "作者死后，作品的价值才会开始攀升。如果我真的死掉，你会像珍视画作那样，分给我一点……永恒的注视吗？", "sound": "sounds/vo_6030_xianliao_02.wav"}, "en": {"subtitle": "作者死后，作品的价值才会开始攀升。如果我真的死掉，你会像珍视画作那样，分给我一点……永恒的注视吗？", "sound": "sounds/en_vo_6030_xianliao_02.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 61054065,
        audioId: 60300014,
        audioName: "vo_6030_zanyang",
        desc: "点击-赞扬1",
        group: "Idle",
        index: 2,
        actionId: "idle2",
        label: "注视2",
        duration: 12.0,
        voices: {"cn": {"subtitle": "世界是无聊的，世界是荒诞的，一切都是剧本，一切都在重播，直到你推门进入，我才发现我一直被困在墙里……", "sound": "sounds/vo_6030_zanyang.wav"}, "en": {"subtitle": "世界是无聊的，世界是荒诞的，一切都是剧本，一切都在重播，直到你推门进入，我才发现我一直被困在墙里……", "sound": "sounds/en_vo_6030_zanyang.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      }
    ]
  },
  {
    id: "105500_tq",
    title: "预埋角色 105500_tq 角色候选",
    assetKind: "character",
    categoryLabel: "角色",
    modelDir: "105500_tq",
    sourceModelDir: "105500_tq",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "localassets_win32",
    styleId: "",
    styleName: "预埋角色 105500_tq",
    stage: "角色候选",
    hitAreaNames: ["HitAreaMoren", "HitAreaHead", "HitAreaBody", "HitAreaHandL", "HitAreaHandR"],
    followConfigs: [],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 5.967 }
        ]
      },
      {
        label: "TapBody",
        actions: [
          { group: "TapBody", index: 0, actionId: "diantou", label: "diantou", duration: 3.0 },
          { group: "TapBody", index: 1, actionId: "houyang", label: "houyang", duration: 3.0 },
          { group: "TapBody", index: 2, actionId: "paihui", label: "paihui", duration: 3.0 },
          { group: "TapBody", index: 3, actionId: "qianqing", label: "qianqing", duration: 4.0 },
          { group: "TapBody", index: 4, actionId: "waitou", label: "waitou", duration: 3.0 },
          { group: "TapBody", index: 5, actionId: "walk", label: "walk", duration: 3.0 },
          { group: "TapBody", index: 6, actionId: "yaotou", label: "yaotou", duration: 3.0 }
        ]
      }
    ],
    clickShowActions: [

    ]
  },
  {
    id: "105600_hs",
    title: "黑哨 角色立绘",
    assetKind: "character",
    categoryLabel: "角色",
    modelDir: "105600_hs",
    sourceModelDir: "105600_hs",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "localassets_win32",
    styleId: "",
    styleName: "黑哨",
    stage: "角色立绘",
    hitAreaNames: ["HitAreaHandL", "HitAreaMoren", "HitAreaHandR", "HitAreaBody", "HitAreaHead"],
    followConfigs: [{"id": 1038, "prefab": "105600_hs", "activeName": "", "expressionName": "", "damping": 0.0, "parameters": [{"parameterId": "ParamAngleX", "axis": "X", "factor": 30.0, "sourceToken": "ParamAngleX#30*X"}, {"parameterId": "ParamAngleY", "axis": "Y", "factor": 30.0, "sourceToken": "ParamAngleY#30*Y"}, {"parameterId": "ParamEyeBallX", "axis": "X", "factor": 70.0, "sourceToken": "ParamEyeBallX#70*X"}, {"parameterId": "ParamEyeBallY", "axis": "Y", "factor": 50.0, "sourceToken": "ParamEyeBallY#50*Y"}, {"parameterId": "ParamBodyAngleX", "axis": "X", "factor": 30.0, "sourceToken": "ParamBodyAngleX#30*X"}, {"parameterId": "ParamBodyMae", "axis": "Y", "factor": 10.0, "sourceToken": "ParamBodyMae#10*Y"}]}],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 6.0 }
        ]
      },
      {
        label: "TapBody",
        actions: [
          { group: "TapBody", index: 0, actionId: "diantou", label: "diantou", duration: 3.0 },
          { group: "TapBody", index: 1, actionId: "erji", label: "erji", duration: 6.333 },
          { group: "TapBody", index: 2, actionId: "houyang", label: "houyang", duration: 3.0 },
          { group: "TapBody", index: 3, actionId: "qianqing", label: "qianqing", duration: 3.5 },
          { group: "TapBody", index: 4, actionId: "songjian", label: "songjian", duration: 3.0 },
          { group: "TapBody", index: 5, actionId: "taiqiang", label: "taiqiang", duration: 3.0 },
          { group: "TapBody", index: 6, actionId: "waitou", label: "waitou", duration: 4.0 },
          { group: "TapBody", index: 7, actionId: "walk", label: "walk", duration: 2.0 },
          { group: "TapBody", index: 8, actionId: "yaotou", label: "yaotou", duration: 3.0 }
        ]
      }
    ],
    clickShowActions: [
      {
        showId: 603201010,
        audioId: 60320004,
        audioName: "vo_6032_daiji_01",
        desc: "点击-通用1",
        group: "TapBody",
        index: 1,
        actionId: "erji",
        label: "erji",
        duration: 6.333,
        voices: {"cn": {"subtitle": "听说过\"狼狈为奸\"这个词吗？我觉得挺适合我们俩的。", "sound": "sounds/vo_6032_daiji_01.wav"}, "en": {"subtitle": "听说过\"狼狈为奸\"这个词吗？我觉得挺适合我们俩的。", "sound": "sounds/en_vo_6032_daiji_01.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 603201011,
        audioId: 60320005,
        audioName: "vo_6032_daiji_02",
        desc: "点击-通用2",
        group: "TapBody",
        index: 3,
        actionId: "qianqing",
        label: "qianqing",
        duration: 3.5,
        voices: {"cn": {"subtitle": "你怎么不说话？在策划什么惊天动地的阴谋吗？算我一个。", "sound": "sounds/vo_6032_daiji_02.wav"}, "en": {"subtitle": "你怎么不说话？在策划什么惊天动地的阴谋吗？算我一个。", "sound": "sounds/en_vo_6032_daiji_02.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 603201012,
        audioId: 60320010,
        audioName: "vo_6032_xianliao_01",
        desc: "点击-闲聊1",
        group: "TapBody",
        index: 5,
        actionId: "taiqiang",
        label: "taiqiang",
        duration: 3.0,
        voices: {"cn": {"subtitle": "那些老家伙整天把“规矩”挂在嘴边，其实他们自己才是最想打破规矩的虚伪小人。", "sound": "sounds/vo_6032_xianliao_01.wav"}, "en": {"subtitle": "那些老家伙整天把“规矩”挂在嘴边，其实他们自己才是最想打破规矩的虚伪小人。", "sound": "sounds/en_vo_6032_xianliao_01.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 603201013,
        audioId: 60320011,
        audioName: "vo_6032_xianliao_02",
        desc: "点击-闲聊2",
        group: "TapBody",
        index: 1,
        actionId: "erji",
        label: "erji",
        duration: 6.333,
        voices: {"cn": {"subtitle": "人的心里藏着太多丑陋的欲望，贪婪、杀戮……那些声音交织在一起，吵得我头疼。", "sound": "sounds/vo_6032_xianliao_02.wav"}, "en": {"subtitle": "人的心里藏着太多丑陋的欲望，贪婪、杀戮……那些声音交织在一起，吵得我头疼。", "sound": "sounds/en_vo_6032_xianliao_02.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 603201014,
        audioId: 60320012,
        audioName: "vo_6032_xianliao_03",
        desc: "点击-闲聊3",
        group: "TapBody",
        index: 8,
        actionId: "yaotou",
        label: "yaotou",
        duration: 3.0,
        voices: {"cn": {"subtitle": "我最讨厌的事情排名：第一，写报告。第二，听废话。第三，写报告的时候听废话。", "sound": "sounds/vo_6032_xianliao_03.wav"}, "en": {"subtitle": "我最讨厌的事情排名：第一，写报告。第二，听废话。第三，写报告的时候听废话。", "sound": "sounds/en_vo_6032_xianliao_03.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 603201015,
        audioId: 60320014,
        audioName: "vo_6032_zanyang",
        desc: "点击-赞扬1",
        group: "Idle",
        index: 0,
        actionId: "idle",
        label: "默认",
        duration: 6.0,
        voices: {"cn": {"subtitle": "在这个无趣的世界里，大多数人都按部就班地行走，只有你是鲜活、无拘无束的。保持这样就好……别被那些无聊的道德规矩同化了。", "sound": "sounds/vo_6032_zanyang.wav"}, "en": {"subtitle": "在这个无趣的世界里，大多数人都按部就班地行走，只有你是鲜活、无拘无束的。保持这样就好……别被那些无聊的道德规矩同化了。", "sound": "sounds/en_vo_6032_zanyang.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 603201016,
        audioId: 60320006,
        audioName: "vo_6032_dianchu_tou",
        desc: "点击-头",
        group: "TapBody",
        index: 1,
        actionId: "erji",
        label: "erji",
        duration: 6.333,
        voices: {"cn": {"subtitle": "怎么，想看看我脑子里在想什么？别看了，全是坏主意。", "sound": "sounds/vo_6032_dianchu_tou.wav"}, "en": {"subtitle": "怎么，想看看我脑子里在想什么？别看了，全是坏主意。", "sound": "sounds/en_vo_6032_dianchu_tou.wav"}},
        hitAreaParam: "HitAreaHead",
        hitAreas: ["HitAreaHead"],
        sourceType2: 401,
        sourceWeight: 20,
        weight: 20
      },
      {
        showId: 603201017,
        audioId: 60320007,
        audioName: "vo_6032_dianchu_shou",
        desc: "点击-手",
        group: "TapBody",
        index: 6,
        actionId: "waitou",
        label: "waitou",
        duration: 4.0,
        voices: {"cn": {"subtitle": "想牵手就直说，偷偷摸摸的可不像你的作风啊，搭档。", "sound": "sounds/vo_6032_dianchu_shou.wav"}, "en": {"subtitle": "想牵手就直说，偷偷摸摸的可不像你的作风啊，搭档。", "sound": "sounds/en_vo_6032_dianchu_shou.wav"}},
        hitAreaParam: "HitAreaHandL#HitAreaHandR",
        hitAreas: ["HitAreaHandL", "HitAreaHandR"],
        sourceType2: 401,
        sourceWeight: 20,
        weight: 20
      },
      {
        showId: 603201018,
        audioId: 60320008,
        audioName: "vo_6032_dianchu_shen",
        desc: "点击-胸",
        group: "TapBody",
        index: 3,
        actionId: "qianqing",
        label: "qianqing",
        duration: 3.5,
        voices: {"cn": {"subtitle": "哇哦，搜身？怎么，觉得我衣服里藏了违禁品？还是说……你对我有什么非分之想？", "sound": "sounds/vo_6032_dianchu_shen.wav"}, "en": {"subtitle": "哇哦，搜身？怎么，觉得我衣服里藏了违禁品？还是说……你对我有什么非分之想？", "sound": "sounds/en_vo_6032_dianchu_shen.wav"}},
        hitAreaParam: "HitAreaBody",
        hitAreas: ["HitAreaBody"],
        sourceType2: 401,
        sourceWeight: 20,
        weight: 20
      }
    ]
  },
  {
    id: "105600_hs_cg",
    title: "无声裁决 一段",
    assetKind: "style",
    categoryLabel: "风格",
    modelDir: "105600_hs_cg",
    sourceModelDir: "105600_hs_cg",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "localassets_win32",
    styleId: "13001056",
    styleName: "无声裁决",
    stage: "一段",
    hitAreaNames: ["HitAreaquanbu"],
    followConfigs: [{"id": 21023, "prefab": "105600_hs_cg", "activeName": "", "expressionName": "", "damping": 0.0, "parameters": [{"parameterId": "ParamEyeBallX", "axis": "X", "factor": 14.0, "sourceToken": "ParamEyeBallX#14*X"}, {"parameterId": "ParamEyeBallY", "axis": "Y", "factor": 30.0, "sourceToken": "ParamEyeBallY#30*Y"}, {"parameterId": "ParamAngleX", "axis": "X", "factor": 19.0, "sourceToken": "ParamAngleX#19*X"}, {"parameterId": "ParamAngleY", "axis": "Y", "factor": 40.0, "sourceToken": "ParamAngleY#40*Y"}, {"parameterId": "ParamAngleZ", "axis": "X", "factor": 2.0, "sourceToken": "ParamAngleZ#2*X"}, {"parameterId": "ParamBodyAngleX", "axis": "X", "factor": 4.0, "sourceToken": "ParamBodyAngleX#4*X"}, {"parameterId": "ParamBodyAngleY", "axis": "Y", "factor": 2.0, "sourceToken": "ParamBodyAngleY#2*Y"}, {"parameterId": "Param87", "axis": "X", "factor": 4.0, "sourceToken": "Param87#4*X"}]}],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 6.633 },
          { group: "Idle", index: 1, actionId: "idle1", label: "注视1", duration: 13.3 },
          { group: "Idle", index: 2, actionId: "idle2", label: "注视2", duration: 9.833 }
        ]
      },
      {
        label: "入场",
        actions: [
          { group: "Entry", index: 0, actionId: "ruchang", label: "入场", duration: 14.3 }
        ]
      }
    ],
    clickShowActions: [
      {
        showId: 61056007,
        audioId: 10560002,
        audioName: "vo_1056_yiduanchahua_01",
        desc: "点击1",
        group: "Idle",
        index: 1,
        actionId: "idle1",
        label: "注视1",
        duration: 13.3,
        voices: {"cn": {"subtitle": "呼……过来让我靠着喘口气。一直紧绷着神经，可是会让人提前衰老的。", "sound": "sounds/vo_1056_yiduanchahua_01.wav"}, "en": {"subtitle": "呼……过来让我靠着喘口气。一直紧绷着神经，可是会让人提前衰老的。", "sound": "sounds/en_vo_1056_yiduanchahua_01.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 20,
        weight: 20
      },
      {
        showId: 61056008,
        audioId: 10560003,
        audioName: "vo_1056_yiduanchahua_02",
        desc: "点击2",
        group: "Idle",
        index: 2,
        actionId: "idle2",
        label: "注视2",
        duration: 9.833,
        voices: {"cn": {"subtitle": "你又救了我一次，虽然你什么都没做。也许恰恰因为你什么都没做。", "sound": "sounds/vo_1056_yiduanchahua_02.wav"}, "en": {"subtitle": "你又救了我一次，虽然你什么都没做。也许恰恰因为你什么都没做。", "sound": "sounds/en_vo_1056_yiduanchahua_02.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 20,
        weight: 20
      },
      {
        showId: 61056009,
        audioId: 60320011,
        audioName: "vo_6032_xianliao_02",
        desc: "点击-闲聊2",
        group: "Idle",
        index: 1,
        actionId: "idle1",
        label: "注视1",
        duration: 13.3,
        voices: {"cn": {"subtitle": "人的心里藏着太多丑陋的欲望，贪婪、杀戮……那些声音交织在一起，吵得我头疼。", "sound": "sounds/vo_6032_xianliao_02.wav"}, "en": {"subtitle": "人的心里藏着太多丑陋的欲望，贪婪、杀戮……那些声音交织在一起，吵得我头疼。", "sound": "sounds/en_vo_6032_xianliao_02.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 10,
        weight: 10
      },
      {
        showId: 61056010,
        audioId: 60320014,
        audioName: "vo_6032_zanyang",
        desc: "点击-赞扬1",
        group: "Idle",
        index: 2,
        actionId: "idle2",
        label: "注视2",
        duration: 9.833,
        voices: {"cn": {"subtitle": "在这个无趣的世界里，大多数人都按部就班地行走，只有你是鲜活、无拘无束的。保持这样就好……别被那些无聊的道德规矩同化了。", "sound": "sounds/vo_6032_zanyang.wav"}, "en": {"subtitle": "在这个无趣的世界里，大多数人都按部就班地行走，只有你是鲜活、无拘无束的。保持这样就好……别被那些无聊的道德规矩同化了。", "sound": "sounds/en_vo_6032_zanyang.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 10,
        weight: 10
      }
    ]
  },
  {
    id: "105601_hs_cg",
    title: "无声裁决 二段",
    assetKind: "style",
    categoryLabel: "风格",
    modelDir: "105601_hs_cg",
    sourceModelDir: "105601_hs_cg",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "localassets_win32",
    styleId: "13001056",
    styleName: "无声裁决",
    stage: "二段",
    hitAreaNames: ["HitAreamoren", "HitAreagensui"],
    followConfigs: [{"id": 21024, "prefab": "105601_hs_cg", "activeName": "HitAreagensui", "expressionName": "gensui01", "damping": 0.2, "parameters": [{"parameterId": "Param227", "axis": "X", "factor": 9.0, "sourceToken": "Param227#9*X"}, {"parameterId": "Param228", "axis": "Y", "factor": 15.0, "sourceToken": "Param228#15*Y"}, {"parameterId": "Param262", "axis": "X", "factor": 9.0, "sourceToken": "Param262#9*X"}, {"parameterId": "Param65", "axis": "Y", "factor": 20.0, "sourceToken": "Param65#20*Y"}, {"parameterId": "Param123", "axis": "X", "factor": -9.0, "sourceToken": "Param123#-9*X"}, {"parameterId": "Param269", "axis": "X", "factor": 4.0, "sourceToken": "Param269#4*X"}, {"parameterId": "Param270", "axis": "X", "factor": 4.0, "sourceToken": "Param270#4*X"}, {"parameterId": "Param267", "axis": "X", "factor": 4.0, "sourceToken": "Param267#4*X"}, {"parameterId": "Param268", "axis": "X", "factor": 4.0, "sourceToken": "Param268#4*X"}, {"parameterId": "Param263", "axis": "X", "factor": 4.0, "sourceToken": "Param263#4*X"}, {"parameterId": "Param266", "axis": "X", "factor": 4.0, "sourceToken": "Param266#4*X"}, {"parameterId": "Param264", "axis": "X", "factor": 4.0, "sourceToken": "Param264#4*X"}, {"parameterId": "Param265", "axis": "X", "factor": 4.0, "sourceToken": "Param265#4*X"}, {"parameterId": "ParamAngleY", "axis": "Y", "factor": 40.0, "sourceToken": "ParamAngleY#40*Y"}, {"parameterId": "ParamAngleZ", "axis": "X", "factor": 4.0, "sourceToken": "ParamAngleZ#4*X"}, {"parameterId": "ParamEyeBallX", "axis": "X", "factor": 4.0, "sourceToken": "ParamEyeBallX#4*X"}, {"parameterId": "ParamEyeBallY", "axis": "Y", "factor": 40.0, "sourceToken": "ParamEyeBallY#40*Y"}, {"parameterId": "ParamBodyAngleZ", "axis": "X", "factor": 1.0, "sourceToken": "ParamBodyAngleZ#1*X"}, {"parameterId": "Param330", "axis": "Y", "factor": 10.0, "sourceToken": "Param330#10*Y"}]}],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [],
    storyTouchActions: [],
    unlockableMotions: [
      { group: "TapBody", index: 0, actionId: "dongzuo1", label: "亲近1", duration: 11.633 },
      { group: "TapBody", index: 1, actionId: "dongzuo2", label: "亲近2", duration: 11.8 },
      { group: "TapBody", index: 2, actionId: "dongzuo3", label: "亲近3", duration: 13.233 }
    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 6.633 },
          { group: "Idle", index: 1, actionId: "idle1", label: "注视1", duration: 9.967 },
          { group: "Idle", index: 2, actionId: "idle2", label: "注视2", duration: 10.5 }
        ]
      },
      {
        label: "TapBody",
        actions: [
          { group: "TapBody", index: 0, actionId: "dongzuo1", label: "亲近1", duration: 11.633 },
          { group: "TapBody", index: 1, actionId: "dongzuo2", label: "亲近2", duration: 11.8 },
          { group: "TapBody", index: 2, actionId: "dongzuo3", label: "亲近3", duration: 13.233 },
          { group: "TapBody", index: 3, actionId: "loop", label: "loop", duration: 6.633 }
        ]
      },
      {
        label: "入场",
        actions: [
          { group: "Entry", index: 0, actionId: "ruchang", label: "入场", duration: 12.133 }
        ]
      }
    ],
    clickShowActions: [
      {
        showId: 61056055,
        audioId: 10560008,
        audioName: "vo_1056_erduanchahua_03",
        desc: "点击3",
        group: "TapBody",
        index: 0,
        actionId: "dongzuo1",
        label: "亲近1",
        duration: 11.633,
        voices: {"cn": {"subtitle": "心跳得快要炸开了……继续，别停。让你的节奏，彻底覆盖掉我这具身体里的警报。", "sound": "sounds/vo_1056_erduanchahua_03.wav"}, "en": {"subtitle": "心跳得快要炸开了……继续，别停。让你的节奏，彻底覆盖掉我这具身体里的警报。", "sound": "sounds/en_vo_1056_erduanchahua_03.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 20,
        weight: 20
      },
      {
        showId: 61056056,
        audioId: 10560009,
        audioName: "vo_1056_erduanchahua_04",
        desc: "点击4",
        group: "TapBody",
        index: 1,
        actionId: "dongzuo2",
        label: "亲近2",
        duration: 11.8,
        voices: {"cn": {"subtitle": "嗯哼…… 再往下，可就不是“安抚”了。你确定？", "sound": "sounds/vo_1056_erduanchahua_04.wav"}, "en": {"subtitle": "嗯哼…… 再往下，可就不是“安抚”了。你确定？", "sound": "sounds/en_vo_1056_erduanchahua_04.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 20,
        weight: 20
      },
      {
        showId: 61056057,
        audioId: 10560010,
        audioName: "vo_1056_erduanchahua_05",
        desc: "点击5",
        group: "TapBody",
        index: 2,
        actionId: "dongzuo3",
        label: "亲近3",
        duration: 13.233,
        voices: {"cn": {"subtitle": "我好虚弱，需要更多的安抚，西西莉亚的BOSS总不能连这点合作福利都舍不得给吧？", "sound": "sounds/vo_1056_erduanchahua_05.wav"}, "en": {"subtitle": "我好虚弱，需要更多的安抚，西西莉亚的BOSS总不能连这点合作福利都舍不得给吧？", "sound": "sounds/en_vo_1056_erduanchahua_05.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 20,
        weight: 20
      },
      {
        showId: 61056059,
        audioId: 10560006,
        audioName: "vo_1056_erduanchahua_01",
        desc: "点击1",
        group: "Idle",
        index: 1,
        actionId: "idle1",
        label: "注视1",
        duration: 9.967,
        voices: {"cn": {"subtitle": "能从欲望过载的幻境中将我拉回现实，你可真是我的特效药啊，搭档。", "sound": "sounds/vo_1056_erduanchahua_01.wav"}, "en": {"subtitle": "能从欲望过载的幻境中将我拉回现实，你可真是我的特效药啊，搭档。", "sound": "sounds/en_vo_1056_erduanchahua_01.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 10,
        weight: 10
      },
      {
        showId: 61056060,
        audioId: 10560007,
        audioName: "vo_1056_erduanchahua_02",
        desc: "点击2",
        group: "Idle",
        index: 2,
        actionId: "idle2",
        label: "注视2",
        duration: 10.5,
        voices: {"cn": {"subtitle": "我脑子里的声音还在开演唱会。要想让我彻底安静下来，只用花洒浇可不够，我需要你……更“深入”的安慰。", "sound": "sounds/vo_1056_erduanchahua_02.wav"}, "en": {"subtitle": "我脑子里的声音还在开演唱会。要想让我彻底安静下来，只用花洒浇可不够，我需要你……更“深入”的安慰。", "sound": "sounds/en_vo_1056_erduanchahua_02.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 10,
        weight: 10
      },
      {
        showId: 61056061,
        audioId: 60320014,
        audioName: "vo_6032_zanyang",
        desc: "点击-赞扬1",
        group: "Idle",
        index: 2,
        actionId: "idle2",
        label: "注视2",
        duration: 10.5,
        voices: {"cn": {"subtitle": "在这个无趣的世界里，大多数人都按部就班地行走，只有你是鲜活、无拘无束的。保持这样就好……别被那些无聊的道德规矩同化了。", "sound": "sounds/vo_6032_zanyang.wav"}, "en": {"subtitle": "在这个无趣的世界里，大多数人都按部就班地行走，只有你是鲜活、无拘无束的。保持这样就好……别被那些无聊的道德规矩同化了。", "sound": "sounds/en_vo_6032_zanyang.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      }
    ]
  },
  {
    id: "200000_l2d",
    title: "剧情CG 200000",
    assetKind: "storycg",
    categoryLabel: "剧情CG",
    modelDir: "200000_l2d",
    sourceModelDir: "200000_l2d",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "streamingassets",
    styleId: "",
    styleName: "剧情CG 200000",
    stage: "剧情CG",
    hitAreaNames: ["HitAreaBody"],
    followConfigs: [],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 8.0 }
        ]
      },
      {
        label: "入场",
        actions: [
          { group: "Entry", index: 0, actionId: "ruchang", label: "入场", duration: 4.0 }
        ]
      }
    ],
    clickShowActions: [

    ]
  },
  {
    id: "200001_l2d",
    title: "剧情CG 200001",
    assetKind: "storycg",
    categoryLabel: "剧情CG",
    modelDir: "200001_l2d",
    sourceModelDir: "200001_l2d",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "streamingassets",
    styleId: "",
    styleName: "剧情CG 200001",
    stage: "剧情CG",
    hitAreaNames: ["HitAreaBody"],
    followConfigs: [],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 7.0 }
        ]
      }
    ],
    clickShowActions: [

    ]
  },
  {
    id: "200003_l2d",
    title: "剧情CG 200003",
    assetKind: "storycg",
    categoryLabel: "剧情CG",
    modelDir: "200003_l2d",
    sourceModelDir: "200003_l2d",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "streamingassets",
    styleId: "",
    styleName: "剧情CG 200003",
    stage: "剧情CG",
    hitAreaNames: ["HitAreaBody"],
    followConfigs: [],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [{"id": "t_story_1100004:200003:1", "story": "t_story_1100004", "label": "剧情片段 1 · 17 句", "startStep": 118, "endStep": 154, "cues": [{"step": 121, "action": "dialog", "speaker": "愚者", "subtitle": "……我想得到你。", "voiceId": "15000130", "audioName": "vo_1100003_17_1010", "voices": {"cn": {"subtitle": "……我想得到你。", "sound": "sounds/vo_1100003_17_1010.wav"}, "en": {"subtitle": "……我想得到你。", "sound": "sounds/en_vo_1100003_17_1010.wav"}}, "motion": {"group": "Entry", "index": 0, "actionId": "ruchang", "label": "入场", "duration": 7.97}}, {"step": 123, "action": "dialog", "speaker": "愚者", "subtitle": "很荣幸获得你的认可，毕竟未来的我们将如誓词所述——", "voiceId": "15000131", "audioName": "vo_1100003_19_1010", "voices": {"cn": {"subtitle": "很荣幸获得你的认可，毕竟未来的我们将如誓词所述——", "sound": "sounds/vo_1100003_19_1010.wav"}, "en": {"subtitle": "很荣幸获得你的认可，毕竟未来的我们将如誓词所述——", "sound": "sounds/en_vo_1100003_19_1010.wav"}}, "motion": {"group": "Entry", "index": 0, "actionId": "ruchang", "label": "入场", "duration": 7.97}}, {"step": 124, "action": "dialog", "speaker": "愚者", "subtitle": "共度余生，直至一人永眠。", "voiceId": "15000132", "audioName": "vo_1100003_20_1010", "voices": {"cn": {"subtitle": "共度余生，直至一人永眠。", "sound": "sounds/vo_1100003_20_1010.wav"}, "en": {"subtitle": "共度余生，直至一人永眠。", "sound": "sounds/en_vo_1100003_20_1010.wav"}}, "motion": {"group": "Entry", "index": 0, "actionId": "ruchang", "label": "入场", "duration": 7.97}}, {"step": 125, "action": "dialog", "speaker": "愚者", "subtitle": "女士，我的<color=#f29c66>夜行能力</color>是“预知未来”。", "voiceId": "15000133", "audioName": "vo_1100003_21_1010", "voices": {"cn": {"subtitle": "女士，我的<color=#f29c66>夜行能力</color>是“预知未来”。", "sound": "sounds/vo_1100003_21_1010.wav"}, "en": {"subtitle": "女士，我的<color=#f29c66>夜行能力</color>是“预知未来”。", "sound": "sounds/en_vo_1100003_21_1010.wav"}}, "motion": {"group": "Entry", "index": 0, "actionId": "ruchang", "label": "入场", "duration": 7.97}}, {"step": 126, "action": "dialog", "speaker": "愚者", "subtitle": "我看见了我们的未来。", "voiceId": "15000134", "audioName": "vo_1100003_22_1010", "voices": {"cn": {"subtitle": "我看见了我们的未来。", "sound": "sounds/vo_1100003_22_1010.wav"}, "en": {"subtitle": "我看见了我们的未来。", "sound": "sounds/en_vo_1100003_22_1010.wav"}}, "motion": {"group": "Entry", "index": 0, "actionId": "ruchang", "label": "入场", "duration": 7.97}}, {"step": 128, "action": "dialog", "speaker": "愚者", "subtitle": "你成为了我的妻子。", "voiceId": "15000135", "audioName": "vo_1100003_23_1010", "voices": {"cn": {"subtitle": "你成为了我的妻子。", "sound": "sounds/vo_1100003_23_1010.wav"}, "en": {"subtitle": "你成为了我的妻子。", "sound": "sounds/en_vo_1100003_23_1010.wav"}}, "motion": {"group": "Entry", "index": 0, "actionId": "ruchang", "label": "入场", "duration": 7.97}}, {"step": 129, "action": "dialog", "speaker": "愚者", "subtitle": "谁不想亲眼看看自己未来的妻子是什么样子呢？", "voiceId": "15000136", "audioName": "vo_1100003_24_1010", "voices": {"cn": {"subtitle": "谁不想亲眼看看自己未来的妻子是什么样子呢？", "sound": "sounds/vo_1100003_24_1010.wav"}, "en": {"subtitle": "谁不想亲眼看看自己未来的妻子是什么样子呢？", "sound": "sounds/en_vo_1100003_24_1010.wav"}}, "motion": {"group": "Entry", "index": 0, "actionId": "ruchang", "label": "入场", "duration": 7.97}}, {"step": 134, "action": "dialog", "speaker": "愚者", "subtitle": "我承认我一生谎言无数，唯独这件事，我没有说谎。", "voiceId": "15000137", "audioName": "vo_1100003_26_1010", "voices": {"cn": {"subtitle": "我承认我一生谎言无数，唯独这件事，我没有说谎。", "sound": "sounds/vo_1100003_26_1010.wav"}, "en": {"subtitle": "我承认我一生谎言无数，唯独这件事，我没有说谎。", "sound": "sounds/en_vo_1100003_26_1010.wav"}}, "motion": {"group": "Entry", "index": 0, "actionId": "ruchang", "label": "入场", "duration": 7.97}}, {"step": 135, "action": "dialog", "speaker": "愚者", "subtitle": "预见的未来中，我们十分相爱，我成为了你的俘虏，被困在名为爱的高塔里，心甘情愿。", "voiceId": "15000138", "audioName": "vo_1100003_27_1010", "voices": {"cn": {"subtitle": "预见的未来中，我们十分相爱，我成为了你的俘虏，被困在名为爱的高塔里，心甘情愿。", "sound": "sounds/vo_1100003_27_1010.wav"}, "en": {"subtitle": "预见的未来中，我们十分相爱，我成为了你的俘虏，被困在名为爱的高塔里，心甘情愿。", "sound": "sounds/en_vo_1100003_27_1010.wav"}}, "motion": {"group": "Entry", "index": 0, "actionId": "ruchang", "label": "入场", "duration": 7.97}}, {"step": 136, "action": "dialog", "speaker": "愚者", "subtitle": "直至……", "voiceId": "15000139", "audioName": "vo_1100003_28_1010", "voices": {"cn": {"subtitle": "直至……", "sound": "sounds/vo_1100003_28_1010.wav"}, "en": {"subtitle": "直至……", "sound": "sounds/en_vo_1100003_28_1010.wav"}}, "motion": {"group": "Entry", "index": 0, "actionId": "ruchang", "label": "入场", "duration": 7.97}}, {"step": 138, "action": "l2dcg", "speaker": "愚者", "subtitle": "你杀了我。", "voiceId": "15000140", "audioName": "vo_1100003_29_1010", "voices": {"cn": {"subtitle": "你杀了我。", "sound": "sounds/vo_1100003_29_1010.wav"}, "en": {"subtitle": "你杀了我。", "sound": "sounds/en_vo_1100003_29_1010.wav"}}, "motion": {"group": "TapBody", "index": 1, "actionId": "chafen1_idle", "label": "chafen1_idle", "duration": 7.97}}, {"step": 141, "action": "dialog", "speaker": "愚者", "subtitle": "原本是这么打算的，但当真的见到你，我好像突然领悟了什么。", "voiceId": "15000141", "audioName": "vo_1100003_32_1010", "voices": {"cn": {"subtitle": "原本是这么打算的，但当真的见到你，我好像突然领悟了什么。", "sound": "sounds/vo_1100003_32_1010.wav"}, "en": {"subtitle": "原本是这么打算的，但当真的见到你，我好像突然领悟了什么。", "sound": "sounds/en_vo_1100003_32_1010.wav"}}, "motion": {"group": "TapBody", "index": 1, "actionId": "chafen1_idle", "label": "chafen1_idle", "duration": 7.97}}, {"step": 142, "action": "dialog", "speaker": "愚者", "subtitle": "或许，有趣的人生比漫长的寿命更有价值。", "voiceId": "15000142", "audioName": "vo_1100003_33_1010", "voices": {"cn": {"subtitle": "或许，有趣的人生比漫长的寿命更有价值。", "sound": "sounds/vo_1100003_33_1010.wav"}, "en": {"subtitle": "或许，有趣的人生比漫长的寿命更有价值。", "sound": "sounds/en_vo_1100003_33_1010.wav"}}, "motion": {"group": "TapBody", "index": 1, "actionId": "chafen1_idle", "label": "chafen1_idle", "duration": 7.97}}, {"step": 145, "action": "l2dcg", "speaker": "愚者", "subtitle": "噢，你的小男友们发现我了，我该走了。", "voiceId": "15000143", "audioName": "vo_1100003_34_1010", "voices": {"cn": {"subtitle": "噢，你的小男友们发现我了，我该走了。", "sound": "sounds/vo_1100003_34_1010.wav"}, "en": {"subtitle": "噢，你的小男友们发现我了，我该走了。", "sound": "sounds/en_vo_1100003_34_1010.wav"}}, "motion": {"group": "TapBody", "index": 3, "actionId": "chafen2_idle", "label": "chafen2_idle", "duration": 7.97}}, {"step": 147, "action": "dialog", "speaker": "愚者", "subtitle": "叫他们珍惜在你身边的时光，毕竟不用多久，你就会成为我的妻子。", "voiceId": "15000144", "audioName": "vo_1100003_35_1010", "voices": {"cn": {"subtitle": "叫他们珍惜在你身边的时光，毕竟不用多久，你就会成为我的妻子。", "sound": "sounds/vo_1100003_35_1010.wav"}, "en": {"subtitle": "叫他们珍惜在你身边的时光，毕竟不用多久，你就会成为我的妻子。", "sound": "sounds/en_vo_1100003_35_1010.wav"}}, "motion": {"group": "TapBody", "index": 3, "actionId": "chafen2_idle", "label": "chafen2_idle", "duration": 7.97}}, {"step": 148, "action": "dialog", "speaker": "愚者", "subtitle": "我的占有欲可是很强的。", "voiceId": "15000145", "audioName": "vo_1100003_36_1010", "voices": {"cn": {"subtitle": "我的占有欲可是很强的。", "sound": "sounds/vo_1100003_36_1010.wav"}, "en": {"subtitle": "我的占有欲可是很强的。", "sound": "sounds/en_vo_1100003_36_1010.wav"}}, "motion": {"group": "TapBody", "index": 3, "actionId": "chafen2_idle", "label": "chafen2_idle", "duration": 7.97}}, {"step": 149, "action": "dialog", "speaker": "愚者", "subtitle": "下次再会，La mia fidanzata。", "voiceId": "15000146", "audioName": "vo_1100003_37_1010", "voices": {"cn": {"subtitle": "下次再会，La mia fidanzata。", "sound": "sounds/vo_1100003_37_1010.wav"}, "en": {"subtitle": "下次再会，La mia fidanzata。", "sound": "sounds/en_vo_1100003_37_1010.wav"}}, "motion": {"group": "TapBody", "index": 3, "actionId": "chafen2_idle", "label": "chafen2_idle", "duration": 7.97}}]}],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 7.97 }
        ]
      },
      {
        label: "TapBody",
        actions: [
          { group: "TapBody", index: 0, actionId: "chafen1", label: "chafen1", duration: 8.3 },
          { group: "TapBody", index: 1, actionId: "chafen1_idle", label: "chafen1_idle", duration: 7.97 },
          { group: "TapBody", index: 2, actionId: "chafen2", label: "chafen2", duration: 8.4 },
          { group: "TapBody", index: 3, actionId: "chafen2_idle", label: "chafen2_idle", duration: 7.97 }
        ]
      },
      {
        label: "入场",
        actions: [
          { group: "Entry", index: 0, actionId: "ruchang", label: "入场", duration: 7.97 }
        ]
      }
    ],
    clickShowActions: [
      {
        showId: 118,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1100004 step 118",
        group: "Entry",
        index: 0,
        actionId: "ruchang",
        label: "入场",
        duration: 7.97,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 1
      },
      {
        showId: 138,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1100004 step 138",
        group: "TapBody",
        index: 0,
        actionId: "chafen1",
        label: "chafen1",
        duration: 8.3,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 1
      },
      {
        showId: 138,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1100004 step 138",
        group: "TapBody",
        index: 1,
        actionId: "chafen1_idle",
        label: "chafen1_idle",
        duration: 7.97,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 1
      },
      {
        showId: 145,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1100004 step 145",
        group: "TapBody",
        index: 2,
        actionId: "chafen2",
        label: "chafen2",
        duration: 8.4,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 1
      },
      {
        showId: 145,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1100004 step 145",
        group: "TapBody",
        index: 3,
        actionId: "chafen2_idle",
        label: "chafen2_idle",
        duration: 7.97,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 1
      }
    ]
  },
  {
    id: "200004_l2d",
    title: "剧情CG 200004",
    assetKind: "storycg",
    categoryLabel: "剧情CG",
    modelDir: "200004_l2d",
    sourceModelDir: "200004_l2d",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "streamingassets",
    styleId: "",
    styleName: "剧情CG 200004",
    stage: "剧情CG",
    hitAreaNames: ["HitAreaBody"],
    followConfigs: [],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [{"id": "t_story_1100002:200004:1", "story": "t_story_1100002", "label": "剧情片段 1 · 4 句", "startStep": 181, "endStep": 195, "cues": [{"step": 182, "action": "dialog", "speaker": "某某人", "subtitle": "唔……！", "voiceId": "15000079", "audioName": "vo_1100002_61_1007", "voices": {"cn": {"subtitle": "唔……！", "sound": "sounds/vo_1100002_61_1007.wav"}, "en": {"subtitle": "唔……！", "sound": "sounds/en_vo_1100002_61_1007.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle", "label": "默认", "duration": 7.97}}, {"step": 184, "action": "l2dcg", "speaker": "某某人", "subtitle": "这是<color=#f29c66>死亡之吻</color>？", "voiceId": "15000080", "audioName": "vo_1100002_62_1007", "voices": {"cn": {"subtitle": "这是<color=#f29c66>死亡之吻</color>？", "sound": "sounds/vo_1100002_62_1007.wav"}, "en": {"subtitle": "这是<color=#f29c66>死亡之吻</color>？", "sound": "sounds/en_vo_1100002_62_1007.wav"}}, "motion": {"group": "TapBody", "index": 1, "actionId": "chafen1_loop", "label": "chafen1_loop", "duration": 7.97}}, {"step": 185, "action": "dialog", "speaker": "某某人", "subtitle": "你要杀了我？", "voiceId": "15000180", "audioName": "vo_1100002_62a_1007", "voices": {"cn": {"subtitle": "你要杀了我？", "sound": "sounds/vo_1100002_62a_1007.wav"}, "en": {"subtitle": "你要杀了我？", "sound": "sounds/en_vo_1100002_62a_1007.wav"}}, "motion": {"group": "TapBody", "index": 1, "actionId": "chafen1_loop", "label": "chafen1_loop", "duration": 7.97}}, {"step": 192, "action": "l2dcg", "speaker": "某某人", "subtitle": "……好。", "voiceId": "15000081", "audioName": "vo_1100002_67_1007", "voices": {"cn": {"subtitle": "……好。", "sound": "sounds/vo_1100002_67_1007.wav"}, "en": {"subtitle": "……好。", "sound": "sounds/en_vo_1100002_67_1007.wav"}}, "motion": {"group": "TapBody", "index": 3, "actionId": "chafen2_loop", "label": "chafen2_loop", "duration": 7.97}}]}],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 7.97 }
        ]
      },
      {
        label: "TapBody",
        actions: [
          { group: "TapBody", index: 0, actionId: "chafen1", label: "chafen1", duration: 9.37 },
          { group: "TapBody", index: 1, actionId: "chafen1_loop", label: "chafen1_loop", duration: 7.97 },
          { group: "TapBody", index: 2, actionId: "chafen2", label: "chafen2", duration: 4.0 },
          { group: "TapBody", index: 3, actionId: "chafen2_loop", label: "chafen2_loop", duration: 7.97 }
        ]
      },
      {
        label: "入场",
        actions: [
          { group: "Entry", index: 0, actionId: "ruchang", label: "入场", duration: 7.0 }
        ]
      }
    ],
    clickShowActions: [
      {
        showId: 181,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1100002 step 181",
        group: "Entry",
        index: 0,
        actionId: "ruchang",
        label: "入场",
        duration: 7.0,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 1
      },
      {
        showId: 181,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1100002 step 181",
        group: "Idle",
        index: 0,
        actionId: "idle",
        label: "默认",
        duration: 7.97,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 1
      },
      {
        showId: 184,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1100002 step 184",
        group: "TapBody",
        index: 0,
        actionId: "chafen1",
        label: "chafen1",
        duration: 9.37,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 1
      },
      {
        showId: 184,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1100002 step 184",
        group: "TapBody",
        index: 1,
        actionId: "chafen1_loop",
        label: "chafen1_loop",
        duration: 7.97,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 1
      },
      {
        showId: 192,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1100002 step 192",
        group: "TapBody",
        index: 2,
        actionId: "chafen2",
        label: "chafen2",
        duration: 4.0,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 1
      },
      {
        showId: 192,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1100002 step 192",
        group: "TapBody",
        index: 3,
        actionId: "chafen2_loop",
        label: "chafen2_loop",
        duration: 7.97,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 1
      }
    ]
  },
  {
    id: "200007_l2d",
    title: "剧情CG 200007",
    assetKind: "storycg",
    categoryLabel: "剧情CG",
    modelDir: "200007_l2d",
    sourceModelDir: "200007_l2d",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "streamingassets",
    styleId: "",
    styleName: "剧情CG 200007",
    stage: "剧情CG",
    hitAreaNames: ["HitAreaBody"],
    followConfigs: [],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [{"id": "t_story_1100004:200007:1", "story": "t_story_1100004", "label": "剧情片段 1 · 4 句", "startStep": 104, "endStep": 117, "cues": [{"step": 106, "action": "dialog", "speaker": "愚者", "subtitle": "美丽的女士，<color=#f29c66>“愚者”</color>是我在夜行世界的名称。", "voiceId": "15000126", "audioName": "vo_1100003_08_1010", "voices": {"cn": {"subtitle": "美丽的女士，<color=#f29c66>“愚者”</color>是我在夜行世界的名称。", "sound": "sounds/vo_1100003_08_1010.wav"}, "en": {"subtitle": "美丽的女士，<color=#f29c66>“愚者”</color>是我在夜行世界的名称。", "sound": "sounds/en_vo_1100003_08_1010.wav"}}}, {"step": 108, "action": "dialog", "speaker": "愚者", "subtitle": "西西莉亚家族的小女儿，我确为见你一面而来。", "voiceId": "15000127", "audioName": "vo_1100003_10_1010", "voices": {"cn": {"subtitle": "西西莉亚家族的小女儿，我确为见你一面而来。", "sound": "sounds/vo_1100003_10_1010.wav"}, "en": {"subtitle": "西西莉亚家族的小女儿，我确为见你一面而来。", "sound": "sounds/en_vo_1100003_10_1010.wav"}}}, {"step": 112, "action": "dialog", "speaker": "愚者", "subtitle": "可以是，也可以不是。", "voiceId": "15000128", "audioName": "vo_1100003_14_1010", "voices": {"cn": {"subtitle": "可以是，也可以不是。", "sound": "sounds/vo_1100003_14_1010.wav"}, "en": {"subtitle": "可以是，也可以不是。", "sound": "sounds/en_vo_1100003_14_1010.wav"}}}, {"step": 115, "action": "dialog", "speaker": "愚者", "subtitle": "而我喜欢你。", "voiceId": "15000129", "audioName": "vo_1100003_16_1010", "voices": {"cn": {"subtitle": "而我喜欢你。", "sound": "sounds/vo_1100003_16_1010.wav"}, "en": {"subtitle": "而我喜欢你。", "sound": "sounds/en_vo_1100003_16_1010.wav"}}}]}],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 4.0 }
        ]
      }
    ],
    clickShowActions: [

    ]
  },
  {
    id: "200008_l2d",
    title: "剧情CG 200008",
    assetKind: "storycg",
    categoryLabel: "剧情CG",
    modelDir: "200008_l2d",
    sourceModelDir: "200008_l2d",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "streamingassets",
    styleId: "",
    styleName: "剧情CG 200008",
    stage: "剧情CG",
    hitAreaNames: ["HitAreaBody"],
    followConfigs: [],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [{"id": "t_story_1100004:200008:1", "story": "t_story_1100004", "label": "剧情片段 1 · 2 句", "startStep": 86, "endStep": 103, "cues": [{"step": 97, "action": "dialog", "speaker": "？？？", "subtitle": "毕竟我是一个害羞的男孩。", "voiceId": "15000124", "audioName": "vo_1100003_05_1010", "voices": {"cn": {"subtitle": "毕竟我是一个害羞的男孩。", "sound": "sounds/vo_1100003_05_1010.wav"}, "en": {"subtitle": "毕竟我是一个害羞的男孩。", "sound": "sounds/en_vo_1100003_05_1010.wav"}}}, {"step": 100, "action": "dialog", "speaker": "？？？", "subtitle": "你身边的拥护者那么多，我可不好意思靠近你。", "voiceId": "15000125", "audioName": "vo_1100003_06_1010", "voices": {"cn": {"subtitle": "你身边的拥护者那么多，我可不好意思靠近你。", "sound": "sounds/vo_1100003_06_1010.wav"}, "en": {"subtitle": "你身边的拥护者那么多，我可不好意思靠近你。", "sound": "sounds/en_vo_1100003_06_1010.wav"}}}]}],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 9.0 }
        ]
      }
    ],
    clickShowActions: [

    ]
  },
  {
    id: "200010_l2d",
    title: "剧情CG 200010",
    assetKind: "storycg",
    categoryLabel: "剧情CG",
    modelDir: "200010_l2d",
    sourceModelDir: "200010_l2d",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "streamingassets",
    styleId: "",
    styleName: "剧情CG 200010",
    stage: "剧情CG",
    hitAreaNames: ["HitAreaBody"],
    followConfigs: [],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [{"id": "t_story_1100001:200010:1", "story": "t_story_1100001", "label": "剧情片段 1 · 8 句", "startStep": 27, "endStep": 46, "cues": [{"step": 30, "action": "dialog", "speaker": "？？？", "subtitle": "达克利亚的拍卖行……我不去……", "voiceId": "15000024", "audioName": "vo_1100001_19_1008", "voices": {"cn": {"subtitle": "达克利亚的拍卖行……我不去……", "sound": "sounds/vo_1100001_19_1008.wav"}, "en": {"subtitle": "达克利亚的拍卖行……我不去……", "sound": "sounds/en_vo_1100001_19_1008.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle1", "label": "注视1", "duration": 4.0}}, {"step": 32, "action": "dialog", "speaker": "？？？", "subtitle": "杀了我……也不去！", "voiceId": "15000025", "audioName": "vo_1100001_20_1008", "voices": {"cn": {"subtitle": "杀了我……也不去！", "sound": "sounds/vo_1100001_20_1008.wav"}, "en": {"subtitle": "杀了我……也不去！", "sound": "sounds/en_vo_1100001_20_1008.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle1", "label": "注视1", "duration": 4.0}}, {"step": 35, "action": "dialog", "speaker": "打手B", "subtitle": "你现在没有选择权！我们的“世界”不是你这种普通人可以随便走进的。", "voiceId": "15000026", "audioName": "vo_1100001_21_dashoub", "voices": {"cn": {"subtitle": "你现在没有选择权！我们的“世界”不是你这种普通人可以随便走进的。", "sound": "sounds/vo_1100001_21_dashoub.wav"}, "en": {"subtitle": "你现在没有选择权！我们的“世界”不是你这种普通人可以随便走进的。", "sound": "sounds/en_vo_1100001_21_dashoub.wav"}}, "motion": {"group": "Idle", "index": 1, "actionId": "idle2", "label": "注视2", "duration": 3.0}}, {"step": 37, "action": "dialog", "speaker": "？？？", "subtitle": "<color=#f29c66>她</color>要来了……你们要倒霉了……", "voiceId": "15000027", "audioName": "vo_1100001_22_1008", "voices": {"cn": {"subtitle": "<color=#f29c66>她</color>要来了……你们要倒霉了……", "sound": "sounds/vo_1100001_22_1008.wav"}, "en": {"subtitle": "<color=#f29c66>她</color>要来了……你们要倒霉了……", "sound": "sounds/en_vo_1100001_22_1008.wav"}}, "motion": {"group": "Idle", "index": 1, "actionId": "idle2", "label": "注视2", "duration": 3.0}}, {"step": 38, "action": "dialog", "speaker": "打手B", "subtitle": "她？谁？", "voiceId": "15000028", "audioName": "vo_1100001_23_dashoub", "voices": {"cn": {"subtitle": "她？谁？", "sound": "sounds/vo_1100001_23_dashoub.wav"}, "en": {"subtitle": "她？谁？", "sound": "sounds/en_vo_1100001_23_dashoub.wav"}}, "motion": {"group": "Idle", "index": 1, "actionId": "idle2", "label": "注视2", "duration": 3.0}}, {"step": 39, "action": "dialog", "speaker": "打手A", "subtitle": "他会不会有靠山，不然普通人怎么敢大大咧咧闯进来。", "voiceId": "15000029", "audioName": "vo_1100001_24_dashoua", "voices": {"cn": {"subtitle": "他会不会有靠山，不然普通人怎么敢大大咧咧闯进来。", "sound": "sounds/vo_1100001_24_dashoua.wav"}, "en": {"subtitle": "他会不会有靠山，不然普通人怎么敢大大咧咧闯进来。", "sound": "sounds/en_vo_1100001_24_dashoua.wav"}}, "motion": {"group": "Idle", "index": 1, "actionId": "idle2", "label": "注视2", "duration": 3.0}}, {"step": 41, "action": "dialog", "speaker": "打手B", "subtitle": "管他什么靠山，我们可是“达克利亚”！", "voiceId": "15000030", "audioName": "vo_1100001_25_dashoub", "voices": {"cn": {"subtitle": "管他什么靠山，我们可是“达克利亚”！", "sound": "sounds/vo_1100001_25_dashoub.wav"}, "en": {"subtitle": "管他什么靠山，我们可是“达克利亚”！", "sound": "sounds/en_vo_1100001_25_dashoub.wav"}}, "motion": {"group": "Idle", "index": 1, "actionId": "idle2", "label": "注视2", "duration": 3.0}}, {"step": 43, "action": "dialog", "speaker": "打手B", "subtitle": "谁敢闯进来我就送她下地狱——", "voiceId": "15000031", "audioName": "vo_1100001_26_dashoub", "voices": {"cn": {"subtitle": "谁敢闯进来我就送她下地狱——", "sound": "sounds/vo_1100001_26_dashoub.wav"}, "en": {"subtitle": "谁敢闯进来我就送她下地狱——", "sound": "sounds/en_vo_1100001_26_dashoub.wav"}}, "motion": {"group": "Idle", "index": 1, "actionId": "idle2", "label": "注视2", "duration": 3.0}}]}],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle1", label: "注视1", duration: 4.0 },
          { group: "Idle", index: 1, actionId: "idle2", label: "注视2", duration: 3.0 }
        ]
      },
      {
        label: "TapBody",
        actions: [
          { group: "TapBody", index: 0, actionId: "beida", label: "beida", duration: 4.0 }
        ]
      }
    ],
    clickShowActions: [
      {
        showId: 27,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1100001 step 27",
        group: "Idle",
        index: 0,
        actionId: "idle1",
        label: "注视1",
        duration: 4.0,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 1
      },
      {
        showId: 34,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1100001 step 34",
        group: "TapBody",
        index: 0,
        actionId: "beida",
        label: "beida",
        duration: 4.0,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 1
      },
      {
        showId: 34,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1100001 step 34",
        group: "Idle",
        index: 1,
        actionId: "idle2",
        label: "注视2",
        duration: 3.0,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 1
      }
    ]
  },
  {
    id: "200011_l2d",
    title: "剧情CG 200011",
    assetKind: "storycg",
    categoryLabel: "剧情CG",
    modelDir: "200011_l2d",
    sourceModelDir: "200011_l2d",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "streamingassets",
    styleId: "",
    styleName: "剧情CG 200011",
    stage: "剧情CG",
    hitAreaNames: ["HitAreaBody"],
    followConfigs: [],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [{"id": "t_story_1100002:200011:1", "story": "t_story_1100002", "label": "剧情片段 1 · 6 句", "startStep": 9, "endStep": 26, "cues": [{"step": 10, "action": "dialog", "speaker": "？？？", "subtitle": "你是来救我的吗？", "voiceId": "15000038", "audioName": "vo_1100002_04_1008", "voices": {"cn": {"subtitle": "你是来救我的吗？", "sound": "sounds/vo_1100002_04_1008.wav"}, "en": {"subtitle": "你是来救我的吗？", "sound": "sounds/en_vo_1100002_04_1008.wav"}}, "motion": {"group": "TapBody", "index": 1, "actionId": "renying1-loop", "label": "renying1-loop", "duration": 4.0}}, {"step": 13, "action": "dialog", "speaker": "？？？", "subtitle": "我、我不是达克利亚！我是被他们抓起来的无辜人！", "voiceId": "15000039", "audioName": "vo_1100002_07_1008", "voices": {"cn": {"subtitle": "我、我不是达克利亚！我是被他们抓起来的无辜人！", "sound": "sounds/vo_1100002_07_1008.wav"}, "en": {"subtitle": "我、我不是达克利亚！我是被他们抓起来的无辜人！", "sound": "sounds/en_vo_1100002_07_1008.wav"}}, "motion": {"group": "TapBody", "index": 1, "actionId": "renying1-loop", "label": "renying1-loop", "duration": 4.0}}, {"step": 14, "action": "dialog", "speaker": "乔伊", "subtitle": "我的名字叫<color=#f29c66>“乔伊”</color>！", "voiceId": "15000040", "audioName": "vo_1100002_08_1008", "voices": {"cn": {"subtitle": "我的名字叫<color=#f29c66>“乔伊”</color>！", "sound": "sounds/vo_1100002_08_1008.wav"}, "en": {"subtitle": "我的名字叫<color=#f29c66>“乔伊”</color>！", "sound": "sounds/en_vo_1100002_08_1008.wav"}}, "motion": {"group": "TapBody", "index": 1, "actionId": "renying1-loop", "label": "renying1-loop", "duration": 4.0}}, {"step": 18, "action": "l2dcg", "speaker": "乔伊", "subtitle": "等、等等？！", "voiceId": "15000041", "audioName": "vo_1100002_11_1008", "voices": {"cn": {"subtitle": "等、等等？！", "sound": "sounds/vo_1100002_11_1008.wav"}, "en": {"subtitle": "等、等等？！", "sound": "sounds/en_vo_1100002_11_1008.wav"}}, "motion": {"group": "TapBody", "index": 3, "actionId": "renying2-loop", "label": "renying2-loop", "duration": 4.0}}, {"step": 21, "action": "dialog", "speaker": "乔伊", "subtitle": "我、我可以给你钱！你想要多少？", "voiceId": "15000042", "audioName": "vo_1100002_14_1008", "voices": {"cn": {"subtitle": "我、我可以给你钱！你想要多少？", "sound": "sounds/vo_1100002_14_1008.wav"}, "en": {"subtitle": "我、我可以给你钱！你想要多少？", "sound": "sounds/en_vo_1100002_14_1008.wav"}}, "motion": {"group": "TapBody", "index": 3, "actionId": "renying2-loop", "label": "renying2-loop", "duration": 4.0}}, {"step": 23, "action": "dialog", "speaker": "乔伊", "subtitle": "不、不，都给你，我都给你！我是这里……非常有名的侦探！", "voiceId": "15000043", "audioName": "vo_1100002_15_1008", "voices": {"cn": {"subtitle": "不、不，都给你，我都给你！我是这里……非常有名的侦探！", "sound": "sounds/vo_1100002_15_1008.wav"}, "en": {"subtitle": "不、不，都给你，我都给你！我是这里……非常有名的侦探！", "sound": "sounds/en_vo_1100002_15_1008.wav"}}, "motion": {"group": "TapBody", "index": 3, "actionId": "renying2-loop", "label": "renying2-loop", "duration": 4.0}}]}],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "TapBody",
        actions: [
          { group: "TapBody", index: 0, actionId: "renying1", label: "renying1", duration: 5.07 },
          { group: "TapBody", index: 1, actionId: "renying1-loop", label: "renying1-loop", duration: 4.0 },
          { group: "TapBody", index: 2, actionId: "renying2", label: "renying2", duration: 4.0 },
          { group: "TapBody", index: 3, actionId: "renying2-loop", label: "renying2-loop", duration: 4.0 }
        ]
      }
    ],
    clickShowActions: [
      {
        showId: 9,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1100002 step 9",
        group: "TapBody",
        index: 0,
        actionId: "renying1",
        label: "renying1",
        duration: 5.07,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 1
      },
      {
        showId: 9,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1100002 step 9",
        group: "TapBody",
        index: 1,
        actionId: "renying1-loop",
        label: "renying1-loop",
        duration: 4.0,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 1
      },
      {
        showId: 18,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1100002 step 18",
        group: "TapBody",
        index: 2,
        actionId: "renying2",
        label: "renying2",
        duration: 4.0,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 1
      },
      {
        showId: 18,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1100002 step 18",
        group: "TapBody",
        index: 3,
        actionId: "renying2-loop",
        label: "renying2-loop",
        duration: 4.0,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 1
      }
    ]
  },
  {
    id: "200014_l2d",
    title: "剧情CG 200014",
    assetKind: "storycg",
    categoryLabel: "剧情CG",
    modelDir: "200014_l2d",
    sourceModelDir: "200014_l2d",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "streamingassets",
    styleId: "",
    styleName: "剧情CG 200014",
    stage: "剧情CG",
    hitAreaNames: ["HitAreaBody"],
    followConfigs: [],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [{"id": "t_story_1100307:200014:1", "story": "t_story_1100307", "label": "剧情片段 1 · 10 句", "startStep": 132, "endStep": 165, "cues": [{"step": 134, "action": "cameraanim", "speaker": "红手套", "subtitle": "从进门开始，你的眼神就落在我身上。你找的是夜店舞王罗索，还是律师红手套？", "voiceId": "15030410", "audioName": "vo_1100307_38_6006", "voices": {"cn": {"subtitle": "从进门开始，你的眼神就落在我身上。你找的是夜店舞王罗索，还是律师红手套？", "sound": "sounds/vo_1100307_38_6006.wav"}, "en": {"subtitle": "从进门开始，你的眼神就落在我身上。你找的是夜店舞王罗索，还是律师红手套？", "sound": "sounds/en_vo_1100307_38_6006.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle", "label": "默认", "duration": 3.97}}, {"step": 138, "action": "dialog", "speaker": "红手套", "subtitle": "亲爱的，我不希望是后者，那太无趣了，现在可不是工作时间。", "voiceId": "15030411", "audioName": "vo_1100307_39_6006", "voices": {"cn": {"subtitle": "亲爱的，我不希望是后者，那太无趣了，现在可不是工作时间。", "sound": "sounds/vo_1100307_39_6006.wav"}, "en": {"subtitle": "亲爱的，我不希望是后者，那太无趣了，现在可不是工作时间。", "sound": "sounds/en_vo_1100307_39_6006.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle", "label": "默认", "duration": 3.97}}, {"step": 140, "action": "dialog", "speaker": "红手套", "subtitle": "哈哈哈哈，你说谎的样子与这个地方很相称呢，德弗兰公爵。", "voiceId": "15030412", "audioName": "vo_1100307_40_6006", "voices": {"cn": {"subtitle": "哈哈哈哈，你说谎的样子与这个地方很相称呢，德弗兰公爵。", "sound": "sounds/vo_1100307_40_6006.wav"}, "en": {"subtitle": "哈哈哈哈，你说谎的样子与这个地方很相称呢，德弗兰公爵。", "sound": "sounds/en_vo_1100307_40_6006.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle", "label": "默认", "duration": 3.97}}, {"step": 144, "action": "dialog", "speaker": "红手套", "subtitle": "噢，大家都听着呢，新晋公爵的承诺，很有诱惑力！", "voiceId": "15030413", "audioName": "vo_1100307_41_6006", "voices": {"cn": {"subtitle": "噢，大家都听着呢，新晋公爵的承诺，很有诱惑力！", "sound": "sounds/vo_1100307_41_6006.wav"}, "en": {"subtitle": "噢，大家都听着呢，新晋公爵的承诺，很有诱惑力！", "sound": "sounds/en_vo_1100307_41_6006.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle", "label": "默认", "duration": 3.97}}, {"step": 148, "action": "cameraanim", "speaker": "红手套", "subtitle": "可我什么也不缺，除了你以外。", "voiceId": "15030414", "audioName": "vo_1100307_42_6006", "voices": {"cn": {"subtitle": "可我什么也不缺，除了你以外。", "sound": "sounds/vo_1100307_42_6006.wav"}, "en": {"subtitle": "可我什么也不缺，除了你以外。", "sound": "sounds/en_vo_1100307_42_6006.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle", "label": "默认", "duration": 3.97}}, {"step": 150, "action": "dialog", "speaker": "红手套", "subtitle": "哎呀，我露馅了吗？", "voiceId": "15030415", "audioName": "vo_1100307_43_6006", "voices": {"cn": {"subtitle": "哎呀，我露馅了吗？", "sound": "sounds/vo_1100307_43_6006.wav"}, "en": {"subtitle": "哎呀，我露馅了吗？", "sound": "sounds/en_vo_1100307_43_6006.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle", "label": "默认", "duration": 3.97}}, {"step": 151, "action": "dialog", "speaker": "红手套", "subtitle": "好吧，我可以把今晚巡回舞会之后的行程空出来。", "voiceId": "15030416", "audioName": "vo_1100307_44_6006", "voices": {"cn": {"subtitle": "好吧，我可以把今晚巡回舞会之后的行程空出来。", "sound": "sounds/vo_1100307_44_6006.wav"}, "en": {"subtitle": "好吧，我可以把今晚巡回舞会之后的行程空出来。", "sound": "sounds/en_vo_1100307_44_6006.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle", "label": "默认", "duration": 3.97}}, {"step": 152, "action": "dialog", "speaker": "红手套", "subtitle": "在此期间，你想对我做什么都可以，如果是你的话。", "voiceId": "15031132", "audioName": "vo_1100307_44a_6006", "voices": {"cn": {"subtitle": "在此期间，你想对我做什么都可以，如果是你的话。", "sound": "sounds/vo_1100307_44a_6006.wav"}, "en": {"subtitle": "在此期间，你想对我做什么都可以，如果是你的话。", "sound": "sounds/en_vo_1100307_44a_6006.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle", "label": "默认", "duration": 3.97}}, {"step": 159, "action": "dialog", "speaker": "", "subtitle": "随即指尖迅速划过，在他的颈窝留下红痕，轻微湿润的血液浸染在我的指腹上。", "voiceId": "15030417", "audioName": "vo_1100307_45_6006", "voices": {"cn": {"subtitle": "随即指尖迅速划过，在他的颈窝留下红痕，轻微湿润的血液浸染在我的指腹上。", "sound": "sounds/vo_1100307_45_6006.wav"}, "en": {"subtitle": "随即指尖迅速划过，在他的颈窝留下红痕，轻微湿润的血液浸染在我的指腹上。", "sound": "sounds/en_vo_1100307_45_6006.wav"}}, "motion": {"group": "Idle", "index": 1, "actionId": "idle1", "label": "注视1", "duration": 3.97}}, {"step": 163, "action": "dialog", "speaker": "红手套", "subtitle": "……", "voiceId": "15030418", "audioName": "vo_1100307_46_6006", "voices": {"cn": {"subtitle": "……", "sound": "sounds/vo_1100307_46_6006.wav"}, "en": {"subtitle": "……", "sound": "sounds/en_vo_1100307_46_6006.wav"}}, "motion": {"group": "Idle", "index": 1, "actionId": "idle1", "label": "注视1", "duration": 3.97}}]}],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 3.97 },
          { group: "Idle", index: 1, actionId: "idle1", label: "注视1", duration: 3.97 }
        ]
      },
      {
        label: "TapBody",
        actions: [
          { group: "TapBody", index: 0, actionId: "touch1", label: "touch1", duration: 6.0 }
        ]
      }
    ],
    clickShowActions: [
      {
        showId: 132,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1100307 step 132",
        group: "Idle",
        index: 0,
        actionId: "idle",
        label: "默认",
        duration: 3.97,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 1
      },
      {
        showId: 158,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1100307 step 158",
        group: "TapBody",
        index: 0,
        actionId: "touch1",
        label: "touch1",
        duration: 6.0,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 1
      },
      {
        showId: 158,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1100307 step 158",
        group: "Idle",
        index: 1,
        actionId: "idle1",
        label: "注视1",
        duration: 3.97,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 1
      }
    ]
  },
  {
    id: "200015_l2d",
    title: "剧情CG 200015",
    assetKind: "storycg",
    categoryLabel: "剧情CG",
    modelDir: "200015_l2d",
    sourceModelDir: "200015_l2d",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "streamingassets",
    styleId: "",
    styleName: "剧情CG 200015",
    stage: "剧情CG",
    hitAreaNames: ["HitAreaBody"],
    followConfigs: [],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [{"id": "t_story_1100311:200015:1", "story": "t_story_1100311", "label": "剧情片段 1 · 6 句", "startStep": 43, "endStep": 58, "cues": [{"step": 44, "action": "dialog", "speaker": "罗索·法尔科内", "subtitle": "我的父亲死了，施舍给我的理由是在监狱中打架斗殴。", "voiceId": "15030521", "audioName": "vo_1100311_14_6006", "voices": {"cn": {"subtitle": "我的父亲死了，施舍给我的理由是在监狱中打架斗殴。", "sound": "sounds/vo_1100311_14_6006.wav"}, "en": {"subtitle": "我的父亲死了，施舍给我的理由是在监狱中打架斗殴。", "sound": "sounds/en_vo_1100311_14_6006.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle", "label": "默认", "duration": 6.133}}, {"step": 45, "action": "dialog", "speaker": "罗索·法尔科内", "subtitle": "校长，你教给我的都是错误的。", "voiceId": "15030522", "audioName": "vo_1100311_15_6006", "voices": {"cn": {"subtitle": "校长，你教给我的都是错误的。", "sound": "sounds/vo_1100311_15_6006.wav"}, "en": {"subtitle": "校长，你教给我的都是错误的。", "sound": "sounds/en_vo_1100311_15_6006.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle", "label": "默认", "duration": 6.133}}, {"step": 46, "action": "dialog", "speaker": "卢卡校长", "subtitle": "……", "voiceId": "15030523", "audioName": "vo_1100311_16_7008", "voices": {"cn": {"subtitle": "……", "sound": "sounds/vo_1100311_16_7008.wav"}, "en": {"subtitle": "……", "sound": "sounds/en_vo_1100311_16_7008.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle", "label": "默认", "duration": 6.133}}, {"step": 47, "action": "dialog", "speaker": "罗索·法尔科内", "subtitle": "如果不能站得更高，我说的话没人听得见。", "voiceId": "15030524", "audioName": "vo_1100311_17_6006", "voices": {"cn": {"subtitle": "如果不能站得更高，我说的话没人听得见。", "sound": "sounds/vo_1100311_17_6006.wav"}, "en": {"subtitle": "如果不能站得更高，我说的话没人听得见。", "sound": "sounds/en_vo_1100311_17_6006.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle", "label": "默认", "duration": 6.133}}, {"step": 55, "action": "shake", "speaker": "罗索·法尔科内", "subtitle": "你看不到。", "voiceId": "15030525", "audioName": "vo_1100311_18_6006", "voices": {"cn": {"subtitle": "你看不到。", "sound": "sounds/vo_1100311_18_6006.wav"}, "en": {"subtitle": "你看不到。", "sound": "sounds/en_vo_1100311_18_6006.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle", "label": "默认", "duration": 6.133}}, {"step": 58, "action": "shake", "speaker": "罗索·法尔科内", "subtitle": "你听不见。", "voiceId": "15030526", "audioName": "vo_1100311_19_6006", "voices": {"cn": {"subtitle": "你听不见。", "sound": "sounds/vo_1100311_19_6006.wav"}, "en": {"subtitle": "你听不见。", "sound": "sounds/en_vo_1100311_19_6006.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle", "label": "默认", "duration": 6.133}}]}],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 6.133 }
        ]
      }
    ],
    clickShowActions: [
      {
        showId: 43,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1100311 step 43",
        group: "Idle",
        index: 0,
        actionId: "idle",
        label: "默认",
        duration: 6.133,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 1
      }
    ]
  },
  {
    id: "200017_l2d",
    title: "剧情CG 200017",
    assetKind: "storycg",
    categoryLabel: "剧情CG",
    modelDir: "200017_l2d",
    sourceModelDir: "200017_l2d",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "streamingassets",
    styleId: "",
    styleName: "剧情CG 200017",
    stage: "剧情CG",
    hitAreaNames: ["HitAreaBody"],
    followConfigs: [],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [{"id": "t_story_1100311:200017:1", "story": "t_story_1100311", "label": "剧情片段 1 · 3 句", "startStep": 59, "endStep": 68, "cues": [{"step": 61, "action": "shake", "speaker": "罗索·法尔科内", "subtitle": "如果你不能审判正义，如果你不能裁决公平……", "voiceId": "15030527", "audioName": "vo_1100311_20_6006", "voices": {"cn": {"subtitle": "如果你不能审判正义，如果你不能裁决公平……", "sound": "sounds/vo_1100311_20_6006.wav"}, "en": {"subtitle": "如果你不能审判正义，如果你不能裁决公平……", "sound": "sounds/en_vo_1100311_20_6006.wav"}}}, {"step": 62, "action": "dialog", "speaker": "罗索·法尔科内", "subtitle": "那就由我……", "voiceId": "15030528", "audioName": "vo_1100311_21_6006", "voices": {"cn": {"subtitle": "那就由我……", "sound": "sounds/vo_1100311_21_6006.wav"}, "en": {"subtitle": "那就由我……", "sound": "sounds/en_vo_1100311_21_6006.wav"}}}, {"step": 65, "action": "dialog", "speaker": "红手套", "subtitle": "代行神职。", "voiceId": "15030529", "audioName": "vo_1100311_22_6006", "voices": {"cn": {"subtitle": "代行神职。", "sound": "sounds/vo_1100311_22_6006.wav"}, "en": {"subtitle": "代行神职。", "sound": "sounds/en_vo_1100311_22_6006.wav"}}, "motion": {"group": "TapBody", "index": 1, "actionId": "chafen1_loop", "label": "chafen1_loop", "duration": 5.3}}]}],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 7.97 }
        ]
      },
      {
        label: "TapBody",
        actions: [
          { group: "TapBody", index: 0, actionId: "chafen1", label: "chafen1", duration: 6.97 },
          { group: "TapBody", index: 1, actionId: "chafen1_loop", label: "chafen1_loop", duration: 5.3 }
        ]
      }
    ],
    clickShowActions: [
      {
        showId: 64,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1100311 step 64",
        group: "TapBody",
        index: 0,
        actionId: "chafen1",
        label: "chafen1",
        duration: 6.97,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 1
      },
      {
        showId: 64,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1100311 step 64",
        group: "TapBody",
        index: 1,
        actionId: "chafen1_loop",
        label: "chafen1_loop",
        duration: 5.3,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 1
      }
    ]
  },
  {
    id: "200018_l2d",
    title: "剧情CG 200018",
    assetKind: "storycg",
    categoryLabel: "剧情CG",
    modelDir: "200018_l2d",
    sourceModelDir: "200018_l2d",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "streamingassets",
    styleId: "",
    styleName: "剧情CG 200018",
    stage: "剧情CG",
    hitAreaNames: ["HitAreaBody"],
    followConfigs: [],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [{"id": "t_story_1100002:200018:1", "story": "t_story_1100002", "label": "剧情片段 1 · 5 句", "startStep": 124, "endStep": 146, "cues": [{"step": 133, "action": "dialog", "speaker": "黑衣人", "subtitle": "你……不认得我了？", "voiceId": "15000064", "audioName": "vo_1100002_46_1007_01", "voices": {"cn": {"subtitle": "你……不认得我了？", "sound": "sounds/vo_1100002_46_1007_01.wav"}, "en": {"subtitle": "你……不认得我了？", "sound": "sounds/en_vo_1100002_46_1007_01.wav"}}}, {"step": 134, "action": "dialog", "speaker": "某某人", "subtitle": "我是……某某人。", "voiceId": "15000065", "audioName": "vo_1100002_46_1007_02", "voices": {"cn": {"subtitle": "我是……某某人。", "sound": "sounds/vo_1100002_46_1007_02.wav"}, "en": {"subtitle": "我是……某某人。", "sound": "sounds/en_vo_1100002_46_1007_02.wav"}}}, {"step": 136, "action": "dialog", "speaker": "某某人", "subtitle": "……是。", "voiceId": "15000066", "audioName": "vo_1100002_47_1007_01", "voices": {"cn": {"subtitle": "……是。", "sound": "sounds/vo_1100002_47_1007_01.wav"}, "en": {"subtitle": "……是。", "sound": "sounds/en_vo_1100002_47_1007_01.wav"}}}, {"step": 139, "action": "dialog", "speaker": "某某人", "subtitle": "我……是个雇佣杀手，来这里找些活干。", "voiceId": "15000067", "audioName": "vo_1100002_47_1007_03", "voices": {"cn": {"subtitle": "我……是个雇佣杀手，来这里找些活干。", "sound": "sounds/vo_1100002_47_1007_03.wav"}, "en": {"subtitle": "我……是个雇佣杀手，来这里找些活干。", "sound": "sounds/en_vo_1100002_47_1007_03.wav"}}}, {"step": 140, "action": "dialog", "speaker": "某某人", "subtitle": "你要雇佣我吗？", "voiceId": "15000068", "audioName": "vo_1100002_47_1007_04", "voices": {"cn": {"subtitle": "你要雇佣我吗？", "sound": "sounds/vo_1100002_47_1007_04.wav"}, "en": {"subtitle": "你要雇佣我吗？", "sound": "sounds/en_vo_1100002_47_1007_04.wav"}}}]}],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 24.0 }
        ]
      }
    ],
    clickShowActions: [

    ]
  },
  {
    id: "200021_l2d",
    title: "剧情CG 200021",
    assetKind: "storycg",
    categoryLabel: "剧情CG",
    modelDir: "200021_l2d",
    sourceModelDir: "200021_l2d",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "streamingassets",
    styleId: "",
    styleName: "剧情CG 200021",
    stage: "剧情CG",
    hitAreaNames: ["HitAreaBody"],
    followConfigs: [],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [{"id": "t_story_1100002:200021:1", "story": "t_story_1100002", "label": "剧情片段 1 · 3 句", "startStep": 107, "endStep": 123, "cues": [{"step": 110, "action": "dialog", "speaker": "黑衣人", "subtitle": "你要干什么？", "voiceId": "15000061", "audioName": "vo_1100002_36_1007", "voices": {"cn": {"subtitle": "你要干什么？", "sound": "sounds/vo_1100002_36_1007.wav"}, "en": {"subtitle": "你要干什么？", "sound": "sounds/en_vo_1100002_36_1007.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle", "label": "默认", "duration": 9.0}}, {"step": 112, "action": "cameraanim", "speaker": "黑衣人", "subtitle": "你会死！", "voiceId": "15000062", "audioName": "vo_1100002_38_1007", "voices": {"cn": {"subtitle": "你会死！", "sound": "sounds/vo_1100002_38_1007.wav"}, "en": {"subtitle": "你会死！", "sound": "sounds/en_vo_1100002_38_1007.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle", "label": "默认", "duration": 9.0}}, {"step": 114, "action": "dialog", "speaker": "黑衣人", "subtitle": "你的生命很重要。", "voiceId": "15000063", "audioName": "vo_1100002_40_1007", "voices": {"cn": {"subtitle": "你的生命很重要。", "sound": "sounds/vo_1100002_40_1007.wav"}, "en": {"subtitle": "你的生命很重要。", "sound": "sounds/en_vo_1100002_40_1007.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle", "label": "默认", "duration": 9.0}}]}, {"id": "t_story_1100002:200021:2", "story": "t_story_1100002", "label": "剧情片段 2 · 2 句", "startStep": 147, "endStep": 158, "cues": [{"step": 153, "action": "cameraanim", "speaker": "某某人", "subtitle": "……我明白了。", "voiceId": "15000069", "audioName": "vo_1100002_48_1007", "voices": {"cn": {"subtitle": "……我明白了。", "sound": "sounds/vo_1100002_48_1007.wav"}, "en": {"subtitle": "……我明白了。", "sound": "sounds/en_vo_1100002_48_1007.wav"}}, "motion": {"group": "TapBody", "index": 1, "actionId": "chafen2", "label": "chafen2", "duration": 9.0}}, {"step": 154, "action": "dialog", "speaker": "某某人", "subtitle": "我守着你。", "voiceId": "15000070", "audioName": "vo_1100002_49_1007", "voices": {"cn": {"subtitle": "我守着你。", "sound": "sounds/vo_1100002_49_1007.wav"}, "en": {"subtitle": "我守着你。", "sound": "sounds/en_vo_1100002_49_1007.wav"}}, "motion": {"group": "TapBody", "index": 1, "actionId": "chafen2", "label": "chafen2", "duration": 9.0}}]}],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 9.0 }
        ]
      },
      {
        label: "TapBody",
        actions: [
          { group: "TapBody", index: 0, actionId: "chafen1", label: "chafen1", duration: 9.0 },
          { group: "TapBody", index: 1, actionId: "chafen2", label: "chafen2", duration: 9.0 }
        ]
      },
      {
        label: "入场",
        actions: [
          { group: "Entry", index: 0, actionId: "ruchang", label: "入场", duration: 6.8 }
        ]
      }
    ],
    clickShowActions: [
      {
        showId: 107,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1100002 step 107",
        group: "Entry",
        index: 0,
        actionId: "ruchang",
        label: "入场",
        duration: 6.8,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 1
      },
      {
        showId: 107,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1100002 step 107",
        group: "Idle",
        index: 0,
        actionId: "idle",
        label: "默认",
        duration: 9.0,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 1
      },
      {
        showId: 115,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1100002 step 115",
        group: "TapBody",
        index: 0,
        actionId: "chafen1",
        label: "chafen1 (2)",
        duration: 9.0,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 2
      },
      {
        showId: 152,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1100002 step 152",
        group: "TapBody",
        index: 1,
        actionId: "chafen2",
        label: "chafen2",
        duration: 9.0,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 1
      }
    ]
  },
  {
    id: "200025_l2d",
    title: "剧情CG 200025",
    assetKind: "storycg",
    categoryLabel: "剧情CG",
    modelDir: "200025_l2d",
    sourceModelDir: "200025_l2d",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "streamingassets",
    styleId: "",
    styleName: "剧情CG 200025",
    stage: "剧情CG",
    hitAreaNames: ["HitAreaBody"],
    followConfigs: [],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 6.0 }
        ]
      },
      {
        label: "入场",
        actions: [
          { group: "Entry", index: 0, actionId: "ruchang", label: "入场", duration: 5.0 }
        ]
      }
    ],
    clickShowActions: [

    ]
  },
  {
    id: "200028_l2d",
    title: "剧情CG 200028",
    assetKind: "storycg",
    categoryLabel: "剧情CG",
    modelDir: "200028_l2d",
    sourceModelDir: "200028_l2d",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "streamingassets",
    styleId: "",
    styleName: "剧情CG 200028",
    stage: "剧情CG",
    hitAreaNames: ["HitAreaBody"],
    followConfigs: [],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [{"id": "t_story_1100109:200028:1", "story": "t_story_1100109", "label": "剧情片段 1 · 6 句", "startStep": 130, "endStep": 169, "cues": [{"step": 133, "action": "dialog", "speaker": "某某人", "subtitle": "西西莉亚家族的故事没有结束，因为，你还在。", "voiceId": "15010359", "audioName": "vo_1100109_38_6002", "voices": {"cn": {"subtitle": "西西莉亚家族的故事没有结束，因为，你还在。", "sound": "sounds/vo_1100109_38_6002.wav"}, "en": {"subtitle": "西西莉亚家族的故事没有结束，因为，你还在。", "sound": "sounds/en_vo_1100109_38_6002.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle", "label": "默认", "duration": 9.967}}, {"step": 134, "action": "dialog", "speaker": "某某人", "subtitle": "我会支持你。", "voiceId": "15010360", "audioName": "vo_1100109_39_6002", "voices": {"cn": {"subtitle": "我会支持你。", "sound": "sounds/vo_1100109_39_6002.wav"}, "en": {"subtitle": "我会支持你。", "sound": "sounds/en_vo_1100109_39_6002.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle", "label": "默认", "duration": 9.967}}, {"step": 141, "action": "dialog", "speaker": "某某人", "subtitle": "不！不是的……", "voiceId": "15010361", "audioName": "vo_1100109_40_6002", "voices": {"cn": {"subtitle": "不！不是的……", "sound": "sounds/vo_1100109_40_6002.wav"}, "en": {"subtitle": "不！不是的……", "sound": "sounds/en_vo_1100109_40_6002.wav"}}, "motion": {"group": "TapBody", "index": 1, "actionId": "chafen1_loop", "label": "chafen1_loop", "duration": 9.967}}, {"step": 142, "action": "dialog", "speaker": "某某人", "subtitle": "我有自己的原因，抱歉……", "voiceId": "15010362", "audioName": "vo_1100109_41_6002", "voices": {"cn": {"subtitle": "我有自己的原因，抱歉……", "sound": "sounds/vo_1100109_41_6002.wav"}, "en": {"subtitle": "我有自己的原因，抱歉……", "sound": "sounds/en_vo_1100109_41_6002.wav"}}, "motion": {"group": "TapBody", "index": 1, "actionId": "chafen1_loop", "label": "chafen1_loop", "duration": 9.967}}, {"step": 153, "action": "dialog", "speaker": "某某人", "subtitle": "……", "voiceId": "15010363", "audioName": "vo_1100109_42_6002", "voices": {"cn": {"subtitle": "……", "sound": "sounds/vo_1100109_42_6002.wav"}, "en": {"subtitle": "……", "sound": "sounds/en_vo_1100109_42_6002.wav"}}, "motion": {"group": "TapBody", "index": 3, "actionId": "chafen2_loop", "label": "chafen2_loop", "duration": 9.967}}, {"step": 165, "action": "dialog", "speaker": "某某人", "subtitle": "……", "voiceId": "15010364", "audioName": "vo_1100109_43_6002", "voices": {"cn": {"subtitle": "……", "sound": "sounds/vo_1100109_43_6002.wav"}, "en": {"subtitle": "……", "sound": "sounds/en_vo_1100109_43_6002.wav"}}, "motion": {"group": "TapBody", "index": 5, "actionId": "chafen3_loop", "label": "chafen3_loop", "duration": 9.97}}]}],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 9.967 }
        ]
      },
      {
        label: "TapBody",
        actions: [
          { group: "TapBody", index: 0, actionId: "chafen1", label: "chafen1", duration: 4.967 },
          { group: "TapBody", index: 1, actionId: "chafen1_loop", label: "chafen1_loop", duration: 9.967 },
          { group: "TapBody", index: 2, actionId: "chafen2", label: "chafen2", duration: 4.967 },
          { group: "TapBody", index: 3, actionId: "chafen2_loop", label: "chafen2_loop", duration: 9.967 },
          { group: "TapBody", index: 4, actionId: "chafen3", label: "chafen3", duration: 4.967 },
          { group: "TapBody", index: 5, actionId: "chafen3_loop", label: "chafen3_loop", duration: 9.97 }
        ]
      },
      {
        label: "入场",
        actions: [
          { group: "Entry", index: 0, actionId: "ruchang", label: "入场", duration: 9.967 }
        ]
      }
    ],
    clickShowActions: [
      {
        showId: 130,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1100109 step 130",
        group: "Entry",
        index: 0,
        actionId: "ruchang",
        label: "入场",
        duration: 9.967,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 1
      },
      {
        showId: 130,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1100109 step 130",
        group: "Idle",
        index: 0,
        actionId: "idle",
        label: "默认",
        duration: 9.967,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 1
      },
      {
        showId: 137,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1100109 step 137",
        group: "TapBody",
        index: 0,
        actionId: "chafen1",
        label: "chafen1",
        duration: 4.967,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 1
      },
      {
        showId: 137,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1100109 step 137",
        group: "TapBody",
        index: 1,
        actionId: "chafen1_loop",
        label: "chafen1_loop",
        duration: 9.967,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 1
      },
      {
        showId: 148,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1100109 step 148",
        group: "TapBody",
        index: 2,
        actionId: "chafen2",
        label: "chafen2",
        duration: 4.967,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 1
      },
      {
        showId: 148,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1100109 step 148",
        group: "TapBody",
        index: 3,
        actionId: "chafen2_loop",
        label: "chafen2_loop",
        duration: 9.967,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 1
      },
      {
        showId: 159,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1100109 step 159",
        group: "TapBody",
        index: 4,
        actionId: "chafen3",
        label: "chafen3",
        duration: 4.967,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 1
      },
      {
        showId: 159,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1100109 step 159",
        group: "TapBody",
        index: 5,
        actionId: "chafen3_loop",
        label: "chafen3_loop",
        duration: 9.97,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 1
      }
    ]
  },
  {
    id: "200029_l2d",
    title: "剧情CG 200029",
    assetKind: "storycg",
    categoryLabel: "剧情CG",
    modelDir: "200029_l2d",
    sourceModelDir: "200029_l2d",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "streamingassets",
    styleId: "",
    styleName: "剧情CG 200029",
    stage: "剧情CG",
    hitAreaNames: ["HitAreaBody"],
    followConfigs: [],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [{"id": "t_story_1100116:200029:1", "story": "t_story_1100116", "label": "剧情片段 1 · 11 句", "startStep": 144, "endStep": 179, "cues": [{"step": 146, "action": "dialog", "speaker": "野狼", "subtitle": "……", "voiceId": "15011018", "audioName": "vo_1100116_41a_6001", "voices": {"cn": {"subtitle": "……", "sound": "sounds/vo_1100116_41a_6001.wav"}, "en": {"subtitle": "……", "sound": "sounds/en_vo_1100116_41a_6001.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle", "label": "默认", "duration": 8.0}}, {"step": 147, "action": "dialog", "speaker": "野狼", "subtitle": "小……小姐？", "voiceId": "15010736", "audioName": "vo_1100116_41_6001", "voices": {"cn": {"subtitle": "小……小姐？", "sound": "sounds/vo_1100116_41_6001.wav"}, "en": {"subtitle": "小……小姐？", "sound": "sounds/en_vo_1100116_41_6001.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle", "label": "默认", "duration": 8.0}}, {"step": 149, "action": "dialog", "speaker": "野狼", "subtitle": "我是在做梦吗？", "voiceId": "15010737", "audioName": "vo_1100116_42_6001", "voices": {"cn": {"subtitle": "我是在做梦吗？", "sound": "sounds/vo_1100116_42_6001.wav"}, "en": {"subtitle": "我是在做梦吗？", "sound": "sounds/en_vo_1100116_42_6001.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle", "label": "默认", "duration": 8.0}}, {"step": 156, "action": "l2dcg", "speaker": "野狼", "subtitle": "哈哈……哈哈哈哈……", "voiceId": "15010738", "audioName": "vo_1100116_43_6001", "voices": {"cn": {"subtitle": "哈哈……哈哈哈哈……", "sound": "sounds/vo_1100116_43_6001.wav"}, "en": {"subtitle": "哈哈……哈哈哈哈……", "sound": "sounds/en_vo_1100116_43_6001.wav"}}, "motion": {"group": "TapBody", "index": 2, "actionId": "chafen1-1loop", "label": "chafen1-1loop", "duration": 8.0}}, {"step": 157, "action": "dialog", "speaker": "野狼", "subtitle": "哈哈哈哈……呜呜呜呜……", "voiceId": "15010739", "audioName": "vo_1100116_44_6001", "voices": {"cn": {"subtitle": "哈哈哈哈……呜呜呜呜……", "sound": "sounds/vo_1100116_44_6001.wav"}, "en": {"subtitle": "哈哈哈哈……呜呜呜呜……", "sound": "sounds/en_vo_1100116_44_6001.wav"}}, "motion": {"group": "TapBody", "index": 2, "actionId": "chafen1-1loop", "label": "chafen1-1loop", "duration": 8.0}}, {"step": 169, "action": "dialog", "speaker": "野狼", "subtitle": "嗯……", "voiceId": "15010740", "audioName": "vo_1100116_45_6001", "voices": {"cn": {"subtitle": "嗯……", "sound": "sounds/vo_1100116_45_6001.wav"}, "en": {"subtitle": "嗯……", "sound": "sounds/en_vo_1100116_45_6001.wav"}}, "motion": {"group": "TapBody", "index": 7, "actionId": "chafen3_loop", "label": "chafen3_loop", "duration": 7.97}}, {"step": 170, "action": "dialog", "speaker": "野狼", "subtitle": "我再也不要离开你的身边……", "voiceId": "15010741", "audioName": "vo_1100116_46_6001", "voices": {"cn": {"subtitle": "我再也不要离开你的身边……", "sound": "sounds/vo_1100116_46_6001.wav"}, "en": {"subtitle": "我再也不要离开你的身边……", "sound": "sounds/en_vo_1100116_46_6001.wav"}}, "motion": {"group": "TapBody", "index": 7, "actionId": "chafen3_loop", "label": "chafen3_loop", "duration": 7.97}}, {"step": 171, "action": "dialog", "speaker": "野狼", "subtitle": "小姐，我好想你……", "voiceId": "15010742", "audioName": "vo_1100116_47_6001", "voices": {"cn": {"subtitle": "小姐，我好想你……", "sound": "sounds/vo_1100116_47_6001.wav"}, "en": {"subtitle": "小姐，我好想你……", "sound": "sounds/en_vo_1100116_47_6001.wav"}}, "motion": {"group": "TapBody", "index": 7, "actionId": "chafen3_loop", "label": "chafen3_loop", "duration": 7.97}}, {"step": 172, "action": "dialog", "speaker": "野狼", "subtitle": "我真的好想你……", "voiceId": "15010743", "audioName": "vo_1100116_48_6001", "voices": {"cn": {"subtitle": "我真的好想你……", "sound": "sounds/vo_1100116_48_6001.wav"}, "en": {"subtitle": "我真的好想你……", "sound": "sounds/en_vo_1100116_48_6001.wav"}}, "motion": {"group": "TapBody", "index": 7, "actionId": "chafen3_loop", "label": "chafen3_loop", "duration": 7.97}}, {"step": 175, "action": "dialog", "speaker": "野狼", "subtitle": "不行……我不能靠太近……万一达克利亚的人在盯着……", "voiceId": "15010744", "audioName": "vo_1100116_49_6001", "voices": {"cn": {"subtitle": "不行……我不能靠太近……万一达克利亚的人在盯着……", "sound": "sounds/vo_1100116_49_6001.wav"}, "en": {"subtitle": "不行……我不能靠太近……万一达克利亚的人在盯着……", "sound": "sounds/en_vo_1100116_49_6001.wav"}}, "motion": {"group": "TapBody", "index": 7, "actionId": "chafen3_loop", "label": "chafen3_loop", "duration": 7.97}}, {"step": 176, "action": "dialog", "speaker": "野狼", "subtitle": "小姐，你出现在这里不安全，你快走！我没事，真的没事……", "voiceId": "15010745", "audioName": "vo_1100116_50_6001", "voices": {"cn": {"subtitle": "小姐，你出现在这里不安全，你快走！我没事，真的没事……", "sound": "sounds/vo_1100116_50_6001.wav"}, "en": {"subtitle": "小姐，你出现在这里不安全，你快走！我没事，真的没事……", "sound": "sounds/en_vo_1100116_50_6001.wav"}}, "motion": {"group": "TapBody", "index": 7, "actionId": "chafen3_loop", "label": "chafen3_loop", "duration": 7.97}}]}],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 8.0 }
        ]
      },
      {
        label: "TapBody",
        actions: [
          { group: "TapBody", index: 0, actionId: "chafen1", label: "chafen1", duration: 4.0 },
          { group: "TapBody", index: 1, actionId: "chafen1-1", label: "chafen1-1", duration: 8.0 },
          { group: "TapBody", index: 2, actionId: "chafen1-1loop", label: "chafen1-1loop", duration: 8.0 },
          { group: "TapBody", index: 3, actionId: "chafen1_loop", label: "chafen1_loop", duration: 3.97 },
          { group: "TapBody", index: 4, actionId: "chafen2", label: "chafen2", duration: 4.0 },
          { group: "TapBody", index: 5, actionId: "chafen2_loop", label: "chafen2_loop", duration: 3.97 },
          { group: "TapBody", index: 6, actionId: "chafen3", label: "chafen3", duration: 8.0 },
          { group: "TapBody", index: 7, actionId: "chafen3_loop", label: "chafen3_loop", duration: 7.97 }
        ]
      },
      {
        label: "入场",
        actions: [
          { group: "Entry", index: 0, actionId: "ruchang", label: "入场", duration: 9.7 }
        ]
      }
    ],
    clickShowActions: [
      {
        showId: 144,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1100116 step 144",
        group: "Entry",
        index: 0,
        actionId: "ruchang",
        label: "入场",
        duration: 9.7,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 1
      },
      {
        showId: 144,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1100116 step 144",
        group: "Idle",
        index: 0,
        actionId: "idle",
        label: "默认",
        duration: 8.0,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 1
      },
      {
        showId: 151,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1100116 step 151",
        group: "TapBody",
        index: 0,
        actionId: "chafen1",
        label: "chafen1",
        duration: 4.0,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 1
      },
      {
        showId: 151,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1100116 step 151",
        group: "TapBody",
        index: 3,
        actionId: "chafen1_loop",
        label: "chafen1_loop",
        duration: 3.97,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 1
      },
      {
        showId: 156,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1100116 step 156",
        group: "TapBody",
        index: 1,
        actionId: "chafen1-1",
        label: "chafen1-1",
        duration: 8.0,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 1
      },
      {
        showId: 156,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1100116 step 156",
        group: "TapBody",
        index: 2,
        actionId: "chafen1-1loop",
        label: "chafen1-1loop",
        duration: 8.0,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 1
      },
      {
        showId: 158,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1100116 step 158",
        group: "TapBody",
        index: 4,
        actionId: "chafen2",
        label: "chafen2",
        duration: 4.0,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 1
      },
      {
        showId: 158,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1100116 step 158",
        group: "TapBody",
        index: 5,
        actionId: "chafen2_loop",
        label: "chafen2_loop",
        duration: 3.97,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 1
      },
      {
        showId: 165,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1100116 step 165",
        group: "TapBody",
        index: 6,
        actionId: "chafen3",
        label: "chafen3",
        duration: 8.0,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 1
      },
      {
        showId: 165,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1100116 step 165",
        group: "TapBody",
        index: 7,
        actionId: "chafen3_loop",
        label: "chafen3_loop",
        duration: 7.97,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 1
      }
    ]
  },
  {
    id: "200030_l2d",
    title: "剧情CG 200030",
    assetKind: "storycg",
    categoryLabel: "剧情CG",
    modelDir: "200030_l2d",
    sourceModelDir: "200030_l2d",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "streamingassets",
    styleId: "",
    styleName: "剧情CG 200030",
    stage: "剧情CG",
    hitAreaNames: ["HitAreaBody"],
    followConfigs: [],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [{"id": "t_story_1100112:200030:1", "story": "t_story_1100112", "label": "剧情片段 1 · 5 句", "startStep": 31, "endStep": 49, "cues": [{"step": 33, "action": "dialog", "speaker": "野狼", "subtitle": "野狼……自由的狼……呵呵……", "voiceId": "15010481", "audioName": "vo_1100112_17_6001", "voices": {"cn": {"subtitle": "野狼……自由的狼……呵呵……", "sound": "sounds/vo_1100112_17_6001.wav"}, "en": {"subtitle": "野狼……自由的狼……呵呵……", "sound": "sounds/en_vo_1100112_17_6001.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle", "label": "默认", "duration": 10.0}}, {"step": 36, "action": "dialog", "speaker": "野狼", "subtitle": "我不想要自由，我只想要她……", "voiceId": "15010482", "audioName": "vo_1100112_18_6001", "voices": {"cn": {"subtitle": "我不想要自由，我只想要她……", "sound": "sounds/vo_1100112_18_6001.wav"}, "en": {"subtitle": "我不想要自由，我只想要她……", "sound": "sounds/en_vo_1100112_18_6001.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle", "label": "默认", "duration": 10.0}}, {"step": 37, "action": "dialog", "speaker": "野狼", "subtitle": "哪怕只是再见一面也好……", "voiceId": "15010483", "audioName": "vo_1100112_19_6001", "voices": {"cn": {"subtitle": "哪怕只是再见一面也好……", "sound": "sounds/vo_1100112_19_6001.wav"}, "en": {"subtitle": "哪怕只是再见一面也好……", "sound": "sounds/en_vo_1100112_19_6001.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle", "label": "默认", "duration": 10.0}}, {"step": 38, "action": "dialog", "speaker": "格斗场经理", "subtitle": "我听不懂，什么意思？", "voiceId": "15010484", "audioName": "vo_1100112_20_7018", "voices": {"cn": {"subtitle": "我听不懂，什么意思？", "sound": "sounds/vo_1100112_20_7018.wav"}, "en": {"subtitle": "我听不懂，什么意思？", "sound": "sounds/en_vo_1100112_20_7018.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle", "label": "默认", "duration": 10.0}}, {"step": 46, "action": "dialog", "speaker": "野狼", "subtitle": "死契，我签……", "voiceId": "15010485", "audioName": "vo_1100112_21_6001", "voices": {"cn": {"subtitle": "死契，我签……", "sound": "sounds/vo_1100112_21_6001.wav"}, "en": {"subtitle": "死契，我签……", "sound": "sounds/en_vo_1100112_21_6001.wav"}}, "motion": {"group": "TapBody", "index": 3, "actionId": "chafen2_loop", "label": "chafen2_loop", "duration": 10.0}}]}],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 10.0 }
        ]
      },
      {
        label: "TapBody",
        actions: [
          { group: "TapBody", index: 0, actionId: "chafen1", label: "chafen1", duration: 6.0 },
          { group: "TapBody", index: 1, actionId: "chafen1_loop", label: "chafen1_loop", duration: 10.0 },
          { group: "TapBody", index: 2, actionId: "chafen2", label: "chafen2", duration: 6.0 },
          { group: "TapBody", index: 3, actionId: "chafen2_loop", label: "chafen2_loop", duration: 10.0 }
        ]
      }
    ],
    clickShowActions: [
      {
        showId: 31,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1100112 step 31",
        group: "Idle",
        index: 0,
        actionId: "idle",
        label: "默认",
        duration: 10.0,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 1
      },
      {
        showId: 44,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1100112 step 44",
        group: "TapBody",
        index: 2,
        actionId: "chafen2",
        label: "chafen2",
        duration: 6.0,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 1
      },
      {
        showId: 44,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1100112 step 44",
        group: "TapBody",
        index: 3,
        actionId: "chafen2_loop",
        label: "chafen2_loop",
        duration: 10.0,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 1
      }
    ]
  },
  {
    id: "200036_l2d",
    title: "剧情CG 200036_l2d",
    assetKind: "storycg",
    categoryLabel: "剧情CG",
    modelDir: "200036_l2d",
    sourceModelDir: "200036_l2d",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "streamingassets",
    styleId: "",
    styleName: "剧情CG 200036_l2d",
    stage: "剧情CG候选",
    hitAreaNames: ["HitAreaBody"],
    followConfigs: [],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 6.0 }
        ]
      },
      {
        label: "TapBody",
        actions: [
          { group: "TapBody", index: 0, actionId: "chafen1", label: "chafen1", duration: 9.0 }
        ]
      }
    ],
    clickShowActions: [

    ]
  },
  {
    id: "200037_l2d",
    title: "剧情CG 200037",
    assetKind: "storycg",
    categoryLabel: "剧情CG",
    modelDir: "200037_l2d",
    sourceModelDir: "200037_l2d",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "streamingassets",
    styleId: "",
    styleName: "剧情CG 200037",
    stage: "剧情CG",
    hitAreaNames: ["HitAreaBody"],
    followConfigs: [],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [{"id": "t_story_1100505:200037:1", "story": "t_story_1100505", "label": "剧情片段 1 · 7 句", "startStep": 127, "endStep": 161, "cues": [{"step": 134, "action": "dialog", "speaker": "少年", "subtitle": "对不起……我知道这样不好，可我……", "voiceId": "15050235", "audioName": "vo_1100505_26_6007", "voices": {"cn": {"subtitle": "对不起……我知道这样不好，可我……", "sound": "sounds/vo_1100505_26_6007.wav"}, "en": {"subtitle": "对不起……我知道这样不好，可我……", "sound": "sounds/en_vo_1100505_26_6007.wav"}}, "motion": {"group": "Entry", "index": 0, "actionId": "ruchang", "label": "入场", "duration": 6.0}}, {"step": 136, "action": "dialog", "speaker": "少年", "subtitle": "请您带我走吧！我不想留在伯爵府了，我会被他们打死的……", "voiceId": "15050236", "audioName": "vo_1100505_27_6007", "voices": {"cn": {"subtitle": "请您带我走吧！我不想留在伯爵府了，我会被他们打死的……", "sound": "sounds/vo_1100505_27_6007.wav"}, "en": {"subtitle": "请您带我走吧！我不想留在伯爵府了，我会被他们打死的……", "sound": "sounds/en_vo_1100505_27_6007.wav"}}, "motion": {"group": "Entry", "index": 0, "actionId": "ruchang", "label": "入场", "duration": 6.0}}, {"step": 137, "action": "dialog", "speaker": "少年", "subtitle": "我愿意用一切来报答您！我、我什么都可以做……", "voiceId": "15050237", "audioName": "vo_1100505_28_6007", "voices": {"cn": {"subtitle": "我愿意用一切来报答您！我、我什么都可以做……", "sound": "sounds/vo_1100505_28_6007.wav"}, "en": {"subtitle": "我愿意用一切来报答您！我、我什么都可以做……", "sound": "sounds/en_vo_1100505_28_6007.wav"}}, "motion": {"group": "Entry", "index": 0, "actionId": "ruchang", "label": "入场", "duration": 6.0}}, {"step": 144, "action": "dialog", "speaker": "少年", "subtitle": "大人……不喜欢我吗？", "voiceId": "15050238", "audioName": "vo_1100505_29_6007", "voices": {"cn": {"subtitle": "大人……不喜欢我吗？", "sound": "sounds/vo_1100505_29_6007.wav"}, "en": {"subtitle": "大人……不喜欢我吗？", "sound": "sounds/en_vo_1100505_29_6007.wav"}}, "motion": {"group": "TapBody", "index": 3, "actionId": "chafen2_loop", "label": "chafen2_loop", "duration": 6.0}}, {"step": 148, "action": "dialog", "speaker": "少年", "subtitle": "大人真是爱拿我开玩笑……", "voiceId": "15050239", "audioName": "vo_1100505_30_6007", "voices": {"cn": {"subtitle": "大人真是爱拿我开玩笑……", "sound": "sounds/vo_1100505_30_6007.wav"}, "en": {"subtitle": "大人真是爱拿我开玩笑……", "sound": "sounds/en_vo_1100505_30_6007.wav"}}, "motion": {"group": "TapBody", "index": 3, "actionId": "chafen2_loop", "label": "chafen2_loop", "duration": 6.0}}, {"step": 152, "action": "dialog", "speaker": "少年", "subtitle": "我是真心的……", "voiceId": "15050240", "audioName": "vo_1100505_31_6007", "voices": {"cn": {"subtitle": "我是真心的……", "sound": "sounds/vo_1100505_31_6007.wav"}, "en": {"subtitle": "我是真心的……", "sound": "sounds/en_vo_1100505_31_6007.wav"}}, "motion": {"group": "TapBody", "index": 3, "actionId": "chafen2_loop", "label": "chafen2_loop", "duration": 6.0}}, {"step": 159, "action": "l2dcg", "speaker": "少年", "subtitle": "……", "voiceId": "15050241", "audioName": "vo_1100505_32_6007", "voices": {"cn": {"subtitle": "……", "sound": "sounds/vo_1100505_32_6007.wav"}, "en": {"subtitle": "……", "sound": "sounds/en_vo_1100505_32_6007.wav"}}, "motion": {"group": "TapBody", "index": 5, "actionId": "chafen3_loop", "label": "chafen3_loop", "duration": 6.0}}]}],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 9.0 }
        ]
      },
      {
        label: "TapBody",
        actions: [
          { group: "TapBody", index: 0, actionId: "chafen1", label: "chafen1", duration: 6.0 },
          { group: "TapBody", index: 1, actionId: "chafen1_loop", label: "chafen1_loop", duration: 6.0 },
          { group: "TapBody", index: 2, actionId: "chafen2", label: "chafen2", duration: 6.0 },
          { group: "TapBody", index: 3, actionId: "chafen2_loop", label: "chafen2_loop", duration: 6.0 },
          { group: "TapBody", index: 4, actionId: "chafen3", label: "chafen3", duration: 5.0 },
          { group: "TapBody", index: 5, actionId: "chafen3_loop", label: "chafen3_loop", duration: 6.0 }
        ]
      },
      {
        label: "入场",
        actions: [
          { group: "Entry", index: 0, actionId: "ruchang", label: "入场", duration: 6.0 }
        ]
      }
    ],
    clickShowActions: [
      {
        showId: 127,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1100505 step 127",
        group: "Entry",
        index: 0,
        actionId: "ruchang",
        label: "入场",
        duration: 6.0,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 1
      },
      {
        showId: 139,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1100505 step 139",
        group: "TapBody",
        index: 0,
        actionId: "chafen1",
        label: "chafen1",
        duration: 6.0,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 1
      },
      {
        showId: 139,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1100505 step 139",
        group: "TapBody",
        index: 1,
        actionId: "chafen1_loop",
        label: "chafen1_loop",
        duration: 6.0,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 1
      },
      {
        showId: 143,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1100505 step 143",
        group: "TapBody",
        index: 2,
        actionId: "chafen2",
        label: "chafen2",
        duration: 6.0,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 1
      },
      {
        showId: 143,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1100505 step 143",
        group: "TapBody",
        index: 3,
        actionId: "chafen2_loop",
        label: "chafen2_loop",
        duration: 6.0,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 1
      },
      {
        showId: 159,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1100505 step 159",
        group: "TapBody",
        index: 4,
        actionId: "chafen3",
        label: "chafen3",
        duration: 5.0,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 1
      },
      {
        showId: 159,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1100505 step 159",
        group: "TapBody",
        index: 5,
        actionId: "chafen3_loop",
        label: "chafen3_loop",
        duration: 6.0,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 1
      }
    ]
  },
  {
    id: "200038_l2d",
    title: "剧情CG 200038",
    assetKind: "storycg",
    categoryLabel: "剧情CG",
    modelDir: "200038_l2d",
    sourceModelDir: "200038_l2d",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "streamingassets",
    styleId: "",
    styleName: "剧情CG 200038",
    stage: "剧情CG",
    hitAreaNames: ["HitAreaBody"],
    followConfigs: [],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [{"id": "t_story_1100120:200038:1", "story": "t_story_1100120", "label": "剧情片段 1 · 18 句", "startStep": 23, "endStep": 73, "cues": [{"step": 29, "action": "dialog", "speaker": "野狼", "subtitle": "……！？", "voiceId": "15010904", "audioName": "vo_1100120_03_6001", "voices": {"cn": {"subtitle": "……！？", "sound": "sounds/vo_1100120_03_6001.wav"}, "en": {"subtitle": "……！？", "sound": "sounds/en_vo_1100120_03_6001.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle", "label": "默认", "duration": 6.0}}, {"step": 39, "action": "dialog", "speaker": "野狼", "subtitle": "我没有易主……从来没有！", "voiceId": "15010905", "audioName": "vo_1100120_04_6001", "voices": {"cn": {"subtitle": "我没有易主……从来没有！", "sound": "sounds/vo_1100120_04_6001.wav"}, "en": {"subtitle": "我没有易主……从来没有！", "sound": "sounds/en_vo_1100120_04_6001.wav"}}, "motion": {"group": "TapBody", "index": 3, "actionId": "chafen2idle", "label": "chafen2idle", "duration": 6.0}}, {"step": 40, "action": "dialog", "speaker": "野狼", "subtitle": "这十年里，那些“你可能还活着”的消息，是我活下去唯一的希望。", "voiceId": "15010906", "audioName": "vo_1100120_05_6001", "voices": {"cn": {"subtitle": "这十年里，那些“你可能还活着”的消息，是我活下去唯一的希望。", "sound": "sounds/vo_1100120_05_6001.wav"}, "en": {"subtitle": "这十年里，那些“你可能还活着”的消息，是我活下去唯一的希望。", "sound": "sounds/en_vo_1100120_05_6001.wav"}}, "motion": {"group": "TapBody", "index": 3, "actionId": "chafen2idle", "label": "chafen2idle", "duration": 6.0}}, {"step": 41, "action": "dialog", "speaker": "野狼", "subtitle": "刚开始那几年，达克利亚的人一直在盯着我。", "voiceId": "15010907", "audioName": "vo_1100120_06_6001", "voices": {"cn": {"subtitle": "刚开始那几年，达克利亚的人一直在盯着我。", "sound": "sounds/vo_1100120_06_6001.wav"}, "en": {"subtitle": "刚开始那几年，达克利亚的人一直在盯着我。", "sound": "sounds/en_vo_1100120_06_6001.wav"}}, "motion": {"group": "TapBody", "index": 3, "actionId": "chafen2idle", "label": "chafen2idle", "duration": 6.0}}, {"step": 42, "action": "dialog", "speaker": "野狼", "subtitle": "我是不聪明，可我知道不能在那时候打听你的下落，我怕给你带来危险……", "voiceId": "15011041", "audioName": "vo_1100120_06a_6001", "voices": {"cn": {"subtitle": "我是不聪明，可我知道不能在那时候打听你的下落，我怕给你带来危险……", "sound": "sounds/vo_1100120_06a_6001.wav"}, "en": {"subtitle": "我是不聪明，可我知道不能在那时候打听你的下落，我怕给你带来危险……", "sound": "sounds/en_vo_1100120_06a_6001.wav"}}, "motion": {"group": "TapBody", "index": 3, "actionId": "chafen2idle", "label": "chafen2idle", "duration": 6.0}}, {"step": 43, "action": "dialog", "speaker": "野狼", "subtitle": "直到感觉不到他们的监视了，我才敢开始找和你有关的线索。", "voiceId": "15011054", "audioName": "vo_1100120_06b_6001", "voices": {"cn": {"subtitle": "直到感觉不到他们的监视了，我才敢开始找和你有关的线索。", "sound": "sounds/vo_1100120_06b_6001.wav"}, "en": {"subtitle": "直到感觉不到他们的监视了，我才敢开始找和你有关的线索。", "sound": "sounds/en_vo_1100120_06b_6001.wav"}}, "motion": {"group": "TapBody", "index": 3, "actionId": "chafen2idle", "label": "chafen2idle", "duration": 6.0}}, {"step": 44, "action": "dialog", "speaker": "野狼", "subtitle": "他们笑我傻，笑我是个把钱扔进大海里的疯子……", "voiceId": "15010908", "audioName": "vo_1100120_07_6001", "voices": {"cn": {"subtitle": "他们笑我傻，笑我是个把钱扔进大海里的疯子……", "sound": "sounds/vo_1100120_07_6001.wav"}, "en": {"subtitle": "他们笑我傻，笑我是个把钱扔进大海里的疯子……", "sound": "sounds/en_vo_1100120_07_6001.wav"}}, "motion": {"group": "TapBody", "index": 3, "actionId": "chafen2idle", "label": "chafen2idle", "duration": 6.0}}, {"step": 45, "action": "dialog", "speaker": "野狼", "subtitle": "我试过所有“聪明”的办法：打听、追踪、悬赏……每一条都是死路。", "voiceId": "15011042", "audioName": "vo_1100120_07a_6001", "voices": {"cn": {"subtitle": "我试过所有“聪明”的办法：打听、追踪、悬赏……每一条都是死路。", "sound": "sounds/vo_1100120_07a_6001.wav"}, "en": {"subtitle": "我试过所有“聪明”的办法：打听、追踪、悬赏……每一条都是死路。", "sound": "sounds/en_vo_1100120_07a_6001.wav"}}, "motion": {"group": "TapBody", "index": 3, "actionId": "chafen2idle", "label": "chafen2idle", "duration": 6.0}}, {"step": 46, "action": "dialog", "speaker": "野狼", "subtitle": "我想过去找你，但是万一你回来的时候我不在，我们又一次错开了呢？", "voiceId": "15010909", "audioName": "vo_1100120_08_6001", "voices": {"cn": {"subtitle": "我想过去找你，但是万一你回来的时候我不在，我们又一次错开了呢？", "sound": "sounds/vo_1100120_08_6001.wav"}, "en": {"subtitle": "我想过去找你，但是万一你回来的时候我不在，我们又一次错开了呢？", "sound": "sounds/en_vo_1100120_08_6001.wav"}}, "motion": {"group": "TapBody", "index": 3, "actionId": "chafen2idle", "label": "chafen2idle", "duration": 6.0}}, {"step": 47, "action": "dialog", "speaker": "野狼", "subtitle": "商队的船长在骗我，情报贩子在宰我，我知道，我全都知道！", "voiceId": "15010910", "audioName": "vo_1100120_09_6001", "voices": {"cn": {"subtitle": "商队的船长在骗我，情报贩子在宰我，我知道，我全都知道！", "sound": "sounds/vo_1100120_09_6001.wav"}, "en": {"subtitle": "商队的船长在骗我，情报贩子在宰我，我知道，我全都知道！", "sound": "sounds/en_vo_1100120_09_6001.wav"}}, "motion": {"group": "TapBody", "index": 3, "actionId": "chafen2idle", "label": "chafen2idle", "duration": 6.0}}, {"step": 48, "action": "dialog", "speaker": "野狼", "subtitle": "可如果他们是对的，如果你真的不在了，那我这十年……又算是什么？", "voiceId": "15011043", "audioName": "vo_1100120_09a_6001", "voices": {"cn": {"subtitle": "可如果他们是对的，如果你真的不在了，那我这十年……又算是什么？", "sound": "sounds/vo_1100120_09a_6001.wav"}, "en": {"subtitle": "可如果他们是对的，如果你真的不在了，那我这十年……又算是什么？", "sound": "sounds/en_vo_1100120_09a_6001.wav"}}, "motion": {"group": "TapBody", "index": 3, "actionId": "chafen2idle", "label": "chafen2idle", "duration": 6.0}}, {"step": 49, "action": "dialog", "speaker": "野狼", "subtitle": "所以我相信、也必须相信你还活着。", "voiceId": "15010911", "audioName": "vo_1100120_10_6001", "voices": {"cn": {"subtitle": "所以我相信、也必须相信你还活着。", "sound": "sounds/vo_1100120_10_6001.wav"}, "en": {"subtitle": "所以我相信、也必须相信你还活着。", "sound": "sounds/en_vo_1100120_10_6001.wav"}}, "motion": {"group": "TapBody", "index": 3, "actionId": "chafen2idle", "label": "chafen2idle", "duration": 6.0}}, {"step": 50, "action": "dialog", "speaker": "野狼", "subtitle": "这个念头能让我告诉自己：野狼没有失去家，他只是在等人回家。", "voiceId": "15011044", "audioName": "vo_1100120_10a_6001", "voices": {"cn": {"subtitle": "这个念头能让我告诉自己：野狼没有失去家，他只是在等人回家。", "sound": "sounds/vo_1100120_10a_6001.wav"}, "en": {"subtitle": "这个念头能让我告诉自己：野狼没有失去家，他只是在等人回家。", "sound": "sounds/en_vo_1100120_10a_6001.wav"}}, "motion": {"group": "TapBody", "index": 3, "actionId": "chafen2idle", "label": "chafen2idle", "duration": 6.0}}, {"step": 52, "action": "dialog", "speaker": "野狼", "subtitle": "我没有！我不想变，我想你回来的时候，我还是原来的那个我！", "voiceId": "15010912", "audioName": "vo_1100120_11_6001", "voices": {"cn": {"subtitle": "我没有！我不想变，我想你回来的时候，我还是原来的那个我！", "sound": "sounds/vo_1100120_11_6001.wav"}, "en": {"subtitle": "我没有！我不想变，我想你回来的时候，我还是原来的那个我！", "sound": "sounds/en_vo_1100120_11_6001.wav"}}, "motion": {"group": "TapBody", "index": 3, "actionId": "chafen2idle", "label": "chafen2idle", "duration": 6.0}}, {"step": 53, "action": "dialog", "speaker": "野狼", "subtitle": "小姐……", "voiceId": "15010913", "audioName": "vo_1100120_12_6001", "voices": {"cn": {"subtitle": "小姐……", "sound": "sounds/vo_1100120_12_6001.wav"}, "en": {"subtitle": "小姐……", "sound": "sounds/en_vo_1100120_12_6001.wav"}}, "motion": {"group": "TapBody", "index": 3, "actionId": "chafen2idle", "label": "chafen2idle", "duration": 6.0}}, {"step": 58, "action": "l2dcg", "speaker": "野狼", "subtitle": "小姐！我不会这么做的！我不——唔唔！", "voiceId": "15010914", "audioName": "vo_1100120_13_6001", "voices": {"cn": {"subtitle": "小姐！我不会这么做的！我不——唔唔！", "sound": "sounds/vo_1100120_13_6001.wav"}, "en": {"subtitle": "小姐！我不会这么做的！我不——唔唔！", "sound": "sounds/en_vo_1100120_13_6001.wav"}}, "motion": {"group": "TapBody", "index": 1, "actionId": "chafen1idle", "label": "chafen1idle", "duration": 8.0}}, {"step": 62, "action": "l2dcg", "speaker": "野狼", "subtitle": "……BOSS。", "voiceId": "15010915", "audioName": "vo_1100120_14_6001", "voices": {"cn": {"subtitle": "……BOSS。", "sound": "sounds/vo_1100120_14_6001.wav"}, "en": {"subtitle": "……BOSS。", "sound": "sounds/en_vo_1100120_14_6001.wav"}}, "motion": {"group": "TapBody", "index": 3, "actionId": "chafen2idle", "label": "chafen2idle", "duration": 6.0}}, {"step": 67, "action": "l2dcg", "speaker": "野狼", "subtitle": "……我愿意。", "voiceId": "15010916", "audioName": "vo_1100120_15_6001", "voices": {"cn": {"subtitle": "……我愿意。", "sound": "sounds/vo_1100120_15_6001.wav"}, "en": {"subtitle": "……我愿意。", "sound": "sounds/en_vo_1100120_15_6001.wav"}}, "motion": {"group": "TapBody", "index": 5, "actionId": "chafen3idle", "label": "chafen3idle", "duration": 6.0}}]}],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 6.0 }
        ]
      },
      {
        label: "TapBody",
        actions: [
          { group: "TapBody", index: 0, actionId: "chafen1", label: "chafen1", duration: 6.0 },
          { group: "TapBody", index: 1, actionId: "chafen1idle", label: "chafen1idle", duration: 8.0 },
          { group: "TapBody", index: 2, actionId: "chafen2", label: "chafen2", duration: 7.0 },
          { group: "TapBody", index: 3, actionId: "chafen2idle", label: "chafen2idle", duration: 6.0 },
          { group: "TapBody", index: 4, actionId: "chafen3", label: "chafen3", duration: 10.0 },
          { group: "TapBody", index: 5, actionId: "chafen3idle", label: "chafen3idle", duration: 6.0 }
        ]
      },
      {
        label: "入场",
        actions: [
          { group: "Entry", index: 0, actionId: "ruchang", label: "入场", duration: 12.0 }
        ]
      }
    ],
    clickShowActions: [
      {
        showId: 23,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1100120 step 23",
        group: "Entry",
        index: 0,
        actionId: "ruchang",
        label: "入场",
        duration: 12.0,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 1
      },
      {
        showId: 23,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1100120 step 23",
        group: "Idle",
        index: 0,
        actionId: "idle",
        label: "默认",
        duration: 6.0,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 1
      },
      {
        showId: 38,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1100120 step 38",
        group: "TapBody",
        index: 2,
        actionId: "chafen2",
        label: "chafen2 (2)",
        duration: 7.0,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 2
      },
      {
        showId: 38,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1100120 step 38",
        group: "TapBody",
        index: 3,
        actionId: "chafen2idle",
        label: "chafen2idle (2)",
        duration: 6.0,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 2
      },
      {
        showId: 58,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1100120 step 58",
        group: "TapBody",
        index: 0,
        actionId: "chafen1",
        label: "chafen1",
        duration: 6.0,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 1
      },
      {
        showId: 58,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1100120 step 58",
        group: "TapBody",
        index: 1,
        actionId: "chafen1idle",
        label: "chafen1idle",
        duration: 8.0,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 1
      },
      {
        showId: 67,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1100120 step 67",
        group: "TapBody",
        index: 4,
        actionId: "chafen3",
        label: "chafen3",
        duration: 10.0,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 1
      },
      {
        showId: 67,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1100120 step 67",
        group: "TapBody",
        index: 5,
        actionId: "chafen3idle",
        label: "chafen3idle",
        duration: 6.0,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 1
      }
    ]
  },
  {
    id: "200047_l2d",
    title: "剧情CG 200047_l2d",
    assetKind: "storycg",
    categoryLabel: "剧情CG",
    modelDir: "200047_l2d",
    sourceModelDir: "200047_l2d",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "streamingassets",
    styleId: "",
    styleName: "剧情CG 200047_l2d",
    stage: "剧情CG候选",
    hitAreaNames: ["HitAreaBody"],
    followConfigs: [],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 6.0 }
        ]
      },
      {
        label: "TapBody",
        actions: [
          { group: "TapBody", index: 0, actionId: "chafen1", label: "chafen1", duration: 6.0 },
          { group: "TapBody", index: 1, actionId: "chafen1_loop", label: "chafen1_loop", duration: 6.0 },
          { group: "TapBody", index: 2, actionId: "chafen2", label: "chafen2", duration: 6.0 },
          { group: "TapBody", index: 3, actionId: "chafen2_loop", label: "chafen2_loop", duration: 6.0 },
          { group: "TapBody", index: 4, actionId: "chafen3", label: "chafen3", duration: 5.143 },
          { group: "TapBody", index: 5, actionId: "chafen3_loop", label: "chafen3_loop", duration: 6.0 },
          { group: "TapBody", index: 6, actionId: "chafen4", label: "chafen4", duration: 6.0 },
          { group: "TapBody", index: 7, actionId: "chafen4_loop", label: "chafen4_loop", duration: 6.0 },
          { group: "TapBody", index: 8, actionId: "chafen5", label: "chafen5", duration: 6.0 },
          { group: "TapBody", index: 9, actionId: "chafen5_loop", label: "chafen5_loop", duration: 6.0 },
          { group: "TapBody", index: 10, actionId: "chafen6", label: "chafen6", duration: 6.0 },
          { group: "TapBody", index: 11, actionId: "chafen6_loop", label: "chafen6_loop", duration: 6.0 }
        ]
      },
      {
        label: "入场",
        actions: [
          { group: "Entry", index: 0, actionId: "ruchang", label: "入场", duration: 6.0 }
        ]
      }
    ],
    clickShowActions: [

    ]
  },
  {
    id: "200055_l2d",
    title: "剧情CG 200055_l2d",
    assetKind: "storycg",
    categoryLabel: "剧情CG",
    modelDir: "200055_l2d",
    sourceModelDir: "200055_l2d",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "streamingassets",
    styleId: "",
    styleName: "剧情CG 200055_l2d",
    stage: "剧情CG候选",
    hitAreaNames: ["HitAreaBody"],
    followConfigs: [],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 1.0 },
          { group: "Idle", index: 1, actionId: "idle2", label: "注视2", duration: 1.0 },
          { group: "Idle", index: 2, actionId: "idle3", label: "idle3", duration: 8.0 }
        ]
      },
      {
        label: "TapBody",
        actions: [
          { group: "TapBody", index: 0, actionId: "guanmen", label: "guanmen", duration: 4.5 },
          { group: "TapBody", index: 1, actionId: "guanmenidle", label: "guanmenidle", duration: 0.033 }
        ]
      },
      {
        label: "入场",
        actions: [
          { group: "Entry", index: 0, actionId: "ruchang1", label: "ruchang1", duration: 2.167 },
          { group: "Entry", index: 1, actionId: "ruchang2", label: "ruchang2", duration: 1.3 }
        ]
      }
    ],
    clickShowActions: [

    ]
  },
  {
    id: "200071_l2d",
    title: "剧情CG 200071",
    assetKind: "storycg",
    categoryLabel: "剧情CG",
    modelDir: "200071_l2d",
    sourceModelDir: "200071_l2d",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "streamingassets",
    styleId: "",
    styleName: "剧情CG 200071",
    stage: "剧情CG",
    hitAreaNames: ["HitAreaBody"],
    followConfigs: [],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [{"id": "t_story_1100523:200071:1", "story": "t_story_1100523", "label": "剧情片段 1 · 10 句", "startStep": 51, "endStep": 80, "cues": [{"step": 57, "action": "dialog", "speaker": "死士队长", "subtitle": "晚上好，沃斯先生。西尔维奥大人向您致以最诚挚的问候。", "voiceId": "15050851", "audioName": "vo_1100523_07_sishiduizhang", "voices": {"cn": {"subtitle": "晚上好，沃斯先生。西尔维奥大人向您致以最诚挚的问候。", "sound": "sounds/vo_1100523_07_sishiduizhang.wav"}, "en": {"subtitle": "晚上好，沃斯先生。西尔维奥大人向您致以最诚挚的问候。", "sound": "sounds/en_vo_1100523_07_sishiduizhang.wav"}}, "motion": {"group": "TapBody", "index": 1, "actionId": "chafen2", "label": "chafen2", "duration": 3.97}}, {"step": 62, "action": "dialog", "speaker": "点金手", "subtitle": "西尔维奥？他连亲自来见我一面的胆量都没有了吗？", "voiceId": "15050852", "audioName": "vo_1100523_08_6014", "voices": {"cn": {"subtitle": "西尔维奥？他连亲自来见我一面的胆量都没有了吗？", "sound": "sounds/vo_1100523_08_6014.wav"}, "en": {"subtitle": "西尔维奥？他连亲自来见我一面的胆量都没有了吗？", "sound": "sounds/en_vo_1100523_08_6014.wav"}}, "motion": {"group": "TapBody", "index": 5, "actionId": "chafen2-2_loop", "label": "chafen2-2_loop", "duration": 3.97}}, {"step": 63, "action": "dialog", "speaker": "点金手", "subtitle": "派你们这群躲在通风管里放毒气的耗子来，真是拉低了这场清算局的格调。", "voiceId": "15050853", "audioName": "vo_1100523_09_6014", "voices": {"cn": {"subtitle": "派你们这群躲在通风管里放毒气的耗子来，真是拉低了这场清算局的格调。", "sound": "sounds/vo_1100523_09_6014.wav"}, "en": {"subtitle": "派你们这群躲在通风管里放毒气的耗子来，真是拉低了这场清算局的格调。", "sound": "sounds/en_vo_1100523_09_6014.wav"}}, "motion": {"group": "TapBody", "index": 5, "actionId": "chafen2-2_loop", "label": "chafen2-2_loop", "duration": 3.97}}, {"step": 64, "action": "dialog", "speaker": "死士队长", "subtitle": "大人在筹备一场盛大的表演，实在抽不开身。", "voiceId": "15050854", "audioName": "vo_1100523_10_sishiduizhang", "voices": {"cn": {"subtitle": "大人在筹备一场盛大的表演，实在抽不开身。", "sound": "sounds/vo_1100523_10_sishiduizhang.wav"}, "en": {"subtitle": "大人在筹备一场盛大的表演，实在抽不开身。", "sound": "sounds/en_vo_1100523_10_sishiduizhang.wav"}}, "motion": {"group": "TapBody", "index": 5, "actionId": "chafen2-2_loop", "label": "chafen2-2_loop", "duration": 3.97}}, {"step": 67, "action": "dialog", "speaker": "死士队长", "subtitle": "他让我转告您：既然您这么喜欢达克利亚的钱，那就请您和这座带不走的金库一起，永远地长眠于此吧。", "voiceId": "15050855", "audioName": "vo_1100523_11_sishiduizhang", "voices": {"cn": {"subtitle": "他让我转告您：既然您这么喜欢达克利亚的钱，那就请您和这座带不走的金库一起，永远地长眠于此吧。", "sound": "sounds/vo_1100523_11_sishiduizhang.wav"}, "en": {"subtitle": "他让我转告您：既然您这么喜欢达克利亚的钱，那就请您和这座带不走的金库一起，永远地长眠于此吧。", "sound": "sounds/en_vo_1100523_11_sishiduizhang.wav"}}, "motion": {"group": "TapBody", "index": 7, "actionId": "chafen3_loop", "label": "chafen3_loop", "duration": 3.97}}, {"step": 69, "action": "dialog", "speaker": "死士队长", "subtitle": "别白费力气尝试调动您的夜行能力了。这里的屏蔽影具开到了最大功率，任何欲望力量都会被瞬间切断。", "voiceId": "15050856", "audioName": "vo_1100523_12_sishiduizhang", "voices": {"cn": {"subtitle": "别白费力气尝试调动您的夜行能力了。这里的屏蔽影具开到了最大功率，任何欲望力量都会被瞬间切断。", "sound": "sounds/vo_1100523_12_sishiduizhang.wav"}, "en": {"subtitle": "别白费力气尝试调动您的夜行能力了。这里的屏蔽影具开到了最大功率，任何欲望力量都会被瞬间切断。", "sound": "sounds/en_vo_1100523_12_sishiduizhang.wav"}}, "motion": {"group": "TapBody", "index": 7, "actionId": "chafen3_loop", "label": "chafen3_loop", "duration": 3.97}}, {"step": 70, "action": "dialog", "speaker": "死士队长", "subtitle": "在开枪前，您还有一分钟的时间可以向上天祈祷。", "voiceId": "15050857", "audioName": "vo_1100523_13_sishiduizhang", "voices": {"cn": {"subtitle": "在开枪前，您还有一分钟的时间可以向上天祈祷。", "sound": "sounds/vo_1100523_13_sishiduizhang.wav"}, "en": {"subtitle": "在开枪前，您还有一分钟的时间可以向上天祈祷。", "sound": "sounds/en_vo_1100523_13_sishiduizhang.wav"}}, "motion": {"group": "TapBody", "index": 7, "actionId": "chafen3_loop", "label": "chafen3_loop", "duration": 3.97}}, {"step": 74, "action": "dialog", "speaker": "点金手", "subtitle": "……屏蔽欲望力量？", "voiceId": "15050858", "audioName": "vo_1100523_14_6014", "voices": {"cn": {"subtitle": "……屏蔽欲望力量？", "sound": "sounds/vo_1100523_14_6014.wav"}, "en": {"subtitle": "……屏蔽欲望力量？", "sound": "sounds/en_vo_1100523_14_6014.wav"}}, "motion": {"group": "TapBody", "index": 11, "actionId": "chafen4_loop", "label": "chafen4_loop", "duration": 3.97}}, {"step": 76, "action": "dialog", "speaker": "点金手", "subtitle": "我是一名商人。我只相信最直接的“交易”。", "voiceId": "15050859", "audioName": "vo_1100523_15_6014", "voices": {"cn": {"subtitle": "我是一名商人。我只相信最直接的“交易”。", "sound": "sounds/vo_1100523_15_6014.wav"}, "en": {"subtitle": "我是一名商人。我只相信最直接的“交易”。", "sound": "sounds/en_vo_1100523_15_6014.wav"}}, "motion": {"group": "TapBody", "index": 11, "actionId": "chafen4_loop", "label": "chafen4_loop", "duration": 3.97}}, {"step": 77, "action": "dialog", "speaker": "点金手", "subtitle": "金子可以买到任何东西，包括跟你的同事买到解除屏蔽的装置。", "voiceId": "15050860", "audioName": "vo_1100523_16_6014", "voices": {"cn": {"subtitle": "金子可以买到任何东西，包括跟你的同事买到解除屏蔽的装置。", "sound": "sounds/vo_1100523_16_6014.wav"}, "en": {"subtitle": "金子可以买到任何东西，包括跟你的同事买到解除屏蔽的装置。", "sound": "sounds/en_vo_1100523_16_6014.wav"}}, "motion": {"group": "TapBody", "index": 11, "actionId": "chafen4_loop", "label": "chafen4_loop", "duration": 3.97}}]}],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 7.97 }
        ]
      },
      {
        label: "TapBody",
        actions: [
          { group: "TapBody", index: 0, actionId: "chafen1", label: "chafen1", duration: 2.57 },
          { group: "TapBody", index: 1, actionId: "chafen2", label: "chafen2", duration: 3.97 },
          { group: "TapBody", index: 2, actionId: "chafen2-1", label: "chafen2-1", duration: 3.5 },
          { group: "TapBody", index: 3, actionId: "chafen2-1_loop", label: "chafen2-1_loop", duration: 3.97 },
          { group: "TapBody", index: 4, actionId: "chafen2-2", label: "chafen2-2", duration: 3.0 },
          { group: "TapBody", index: 5, actionId: "chafen2-2_loop", label: "chafen2-2_loop", duration: 3.97 },
          { group: "TapBody", index: 6, actionId: "chafen3", label: "chafen3", duration: 5.4 },
          { group: "TapBody", index: 7, actionId: "chafen3_loop", label: "chafen3_loop", duration: 3.97 },
          { group: "TapBody", index: 8, actionId: "chafen4", label: "chafen4", duration: 1.0 },
          { group: "TapBody", index: 9, actionId: "chafen4_1", label: "chafen4_1", duration: 1.5 },
          { group: "TapBody", index: 10, actionId: "chafen4_1_loop", label: "chafen4_1_loop", duration: 3.97 },
          { group: "TapBody", index: 11, actionId: "chafen4_loop", label: "chafen4_loop", duration: 3.97 }
        ]
      },
      {
        label: "入场",
        actions: [
          { group: "Entry", index: 0, actionId: "ruchang", label: "入场", duration: 10.533 }
        ]
      }
    ],
    clickShowActions: [
      {
        showId: 51,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1100523 step 51",
        group: "Entry",
        index: 0,
        actionId: "ruchang",
        label: "入场",
        duration: 10.533,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 1
      },
      {
        showId: 51,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1100523 step 51",
        group: "Idle",
        index: 0,
        actionId: "idle",
        label: "默认",
        duration: 7.97,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 1
      },
      {
        showId: 56,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1100523 step 56",
        group: "TapBody",
        index: 0,
        actionId: "chafen1",
        label: "chafen1",
        duration: 2.57,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 1
      },
      {
        showId: 56,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1100523 step 56",
        group: "TapBody",
        index: 1,
        actionId: "chafen2",
        label: "chafen2",
        duration: 3.97,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 1
      },
      {
        showId: 58,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1100523 step 58",
        group: "TapBody",
        index: 2,
        actionId: "chafen2-1",
        label: "chafen2-1",
        duration: 3.5,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 1
      },
      {
        showId: 58,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1100523 step 58",
        group: "TapBody",
        index: 3,
        actionId: "chafen2-1_loop",
        label: "chafen2-1_loop",
        duration: 3.97,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 1
      },
      {
        showId: 61,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1100523 step 61",
        group: "TapBody",
        index: 4,
        actionId: "chafen2-2",
        label: "chafen2-2",
        duration: 3.0,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 1
      },
      {
        showId: 61,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1100523 step 61",
        group: "TapBody",
        index: 5,
        actionId: "chafen2-2_loop",
        label: "chafen2-2_loop",
        duration: 3.97,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 1
      },
      {
        showId: 65,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1100523 step 65",
        group: "TapBody",
        index: 6,
        actionId: "chafen3",
        label: "chafen3",
        duration: 5.4,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 1
      },
      {
        showId: 65,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1100523 step 65",
        group: "TapBody",
        index: 7,
        actionId: "chafen3_loop",
        label: "chafen3_loop",
        duration: 3.97,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 1
      },
      {
        showId: 71,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1100523 step 71",
        group: "TapBody",
        index: 8,
        actionId: "chafen4",
        label: "chafen4",
        duration: 1.0,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 1
      },
      {
        showId: 71,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1100523 step 71",
        group: "TapBody",
        index: 11,
        actionId: "chafen4_loop",
        label: "chafen4_loop (2)",
        duration: 3.97,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 2
      },
      {
        showId: 73,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1100523 step 73",
        group: "TapBody",
        index: 9,
        actionId: "chafen4_1",
        label: "chafen4_1",
        duration: 1.5,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 1
      }
    ]
  },
  {
    id: "200082_l2d",
    title: "剧情CG 200082",
    assetKind: "storycg",
    categoryLabel: "剧情CG",
    modelDir: "200082_l2d",
    sourceModelDir: "200082_l2d",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "streamingassets",
    styleId: "",
    styleName: "剧情CG 200082",
    stage: "剧情CG",
    hitAreaNames: ["HitAreaBody"],
    followConfigs: [],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [{"id": "t_story_1100318:200082:1", "story": "t_story_1100318", "label": "剧情片段 1 · 12 句", "startStep": 65, "endStep": 80, "cues": [{"step": 65, "action": "l2dcg", "speaker": "红手套", "subtitle": "德弗兰公爵对我这么上心，从舞厅跟到泰拉，从泰拉追到酒店。", "voiceId": "15031013", "audioName": "vo_1100318_12_6006", "voices": {"cn": {"subtitle": "德弗兰公爵对我这么上心，从舞厅跟到泰拉，从泰拉追到酒店。", "sound": "sounds/vo_1100318_12_6006.wav"}, "en": {"subtitle": "德弗兰公爵对我这么上心，从舞厅跟到泰拉，从泰拉追到酒店。", "sound": "sounds/en_vo_1100318_12_6006.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle1", "label": "注视1", "duration": 6.667}}, {"step": 66, "action": "dialog", "speaker": "红手套", "subtitle": "不知道的，还以为你是我的狂热粉丝呢。", "voiceId": "15031179", "audioName": "vo_1100318_12a_6006", "voices": {"cn": {"subtitle": "不知道的，还以为你是我的狂热粉丝呢。", "sound": "sounds/vo_1100318_12a_6006.wav"}, "en": {"subtitle": "不知道的，还以为你是我的狂热粉丝呢。", "sound": "sounds/en_vo_1100318_12a_6006.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle1", "label": "注视1", "duration": 6.667}}, {"step": 67, "action": "dialog", "speaker": "我", "subtitle": "我知道有人一直在附近盯着你，所以我们可以在脑海里，进行一场坦诚的私人交流。", "voiceId": "15031014", "audioName": "vo_1100318_12a_6000", "voices": {"cn": {"subtitle": "我知道有人一直在附近盯着你，所以我们可以在脑海里，进行一场坦诚的私人交流。", "sound": "sounds/vo_1100318_12a_6000.wav"}, "en": {"subtitle": "我知道有人一直在附近盯着你，所以我们可以在脑海里，进行一场坦诚的私人交流。", "sound": "sounds/en_vo_1100318_12a_6000.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle1", "label": "注视1", "duration": 6.667}}, {"step": 68, "action": "dialog", "speaker": "红手套", "subtitle": "真有趣，你是怎么办到的？", "voiceId": "15030551", "audioName": "vo_1100311_44_6006", "voices": {"cn": {"subtitle": "真有趣，你是怎么办到的？", "sound": "sounds/vo_1100311_44_6006.wav"}, "en": {"subtitle": "真有趣，你是怎么办到的？", "sound": "sounds/en_vo_1100311_44_6006.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle1", "label": "注视1", "duration": 6.667}}, {"step": 69, "action": "dialog", "speaker": "我", "subtitle": "这是我的夜行能力，还记得上次共舞的时候，你留在我指尖上的血吗？", "voiceId": "15031016", "audioName": "vo_1100318_13a_6000", "voices": {"cn": {"subtitle": "这是我的夜行能力，还记得上次共舞的时候，你留在我指尖上的血吗？", "sound": "sounds/vo_1100318_13a_6000.wav"}, "en": {"subtitle": "这是我的夜行能力，还记得上次共舞的时候，你留在我指尖上的血吗？", "sound": "sounds/en_vo_1100318_13a_6000.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle1", "label": "注视1", "duration": 6.667}}, {"step": 70, "action": "dialog", "speaker": "我", "subtitle": "这是我对你的标记。标记消失前，我可以像现在这样，向你发起心灵交流。", "voiceId": "15031017", "audioName": "vo_1100318_13b_6000", "voices": {"cn": {"subtitle": "这是我对你的标记。标记消失前，我可以像现在这样，向你发起心灵交流。", "sound": "sounds/vo_1100318_13b_6000.wav"}, "en": {"subtitle": "这是我对你的标记。标记消失前，我可以像现在这样，向你发起心灵交流。", "sound": "sounds/en_vo_1100318_13b_6000.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle1", "label": "注视1", "duration": 6.667}}, {"step": 71, "action": "cameraanim", "speaker": "红手套", "subtitle": "我不否认，你的确是一个有趣的人。", "voiceId": "15030552", "audioName": "vo_1100311_45_6006", "voices": {"cn": {"subtitle": "我不否认，你的确是一个有趣的人。", "sound": "sounds/vo_1100311_45_6006.wav"}, "en": {"subtitle": "我不否认，你的确是一个有趣的人。", "sound": "sounds/en_vo_1100311_45_6006.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle1", "label": "注视1", "duration": 6.667}}, {"step": 72, "action": "dialog", "speaker": "我", "subtitle": "我知道，你一早就在这里等着我来找你。", "voiceId": "15031019", "audioName": "vo_1100318_14a_6000", "voices": {"cn": {"subtitle": "我知道，你一早就在这里等着我来找你。", "sound": "sounds/vo_1100318_14a_6000.wav"}, "en": {"subtitle": "我知道，你一早就在这里等着我来找你。", "sound": "sounds/en_vo_1100318_14a_6000.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle1", "label": "注视1", "duration": 6.667}}, {"step": 73, "action": "dialog", "speaker": "我", "subtitle": "我说的不是今晚，而是更早之前。", "voiceId": "15031020", "audioName": "vo_1100318_14b_6000", "voices": {"cn": {"subtitle": "我说的不是今晚，而是更早之前。", "sound": "sounds/vo_1100318_14b_6000.wav"}, "en": {"subtitle": "我说的不是今晚，而是更早之前。", "sound": "sounds/en_vo_1100318_14b_6000.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle1", "label": "注视1", "duration": 6.667}}, {"step": 74, "action": "dialog", "speaker": "我", "subtitle": "早到我刚刚被宣布为德弗兰公爵第一继承人的时候。", "voiceId": "15031180", "audioName": "vo_1100318_14c_6000", "voices": {"cn": {"subtitle": "早到我刚刚被宣布为德弗兰公爵第一继承人的时候。", "sound": "sounds/vo_1100318_14c_6000.wav"}, "en": {"subtitle": "早到我刚刚被宣布为德弗兰公爵第一继承人的时候。", "sound": "sounds/en_vo_1100318_14c_6000.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle1", "label": "注视1", "duration": 6.667}}, {"step": 75, "action": "dialog", "speaker": "红手套", "subtitle": "亲爱的，你怎么会有这种想法？", "voiceId": "15030553", "audioName": "vo_1100311_46_6006", "voices": {"cn": {"subtitle": "亲爱的，你怎么会有这种想法？", "sound": "sounds/vo_1100311_46_6006.wav"}, "en": {"subtitle": "亲爱的，你怎么会有这种想法？", "sound": "sounds/en_vo_1100311_46_6006.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle1", "label": "注视1", "duration": 6.667}}, {"step": 77, "action": "dialog", "speaker": "我", "subtitle": "当我听完你的故事之后，我就知道，你不可能真心帮助达克利亚。毕竟……", "voiceId": "15031022", "audioName": "vo_1100318_15a_6000", "voices": {"cn": {"subtitle": "当我听完你的故事之后，我就知道，你不可能真心帮助达克利亚。毕竟……", "sound": "sounds/vo_1100318_15a_6000.wav"}, "en": {"subtitle": "当我听完你的故事之后，我就知道，你不可能真心帮助达克利亚。毕竟……", "sound": "sounds/en_vo_1100318_15a_6000.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle1", "label": "注视1", "duration": 6.667}}]}, {"id": "t_story_1100318:200082:2", "story": "t_story_1100318", "label": "剧情片段 2 · 6 句", "startStep": 86, "endStep": 94, "cues": [{"step": 88, "action": "dialog", "speaker": "我", "subtitle": "罗索，我们有共同的敌人。", "voiceId": "15031025", "audioName": "vo_1100318_15d_6000", "voices": {"cn": {"subtitle": "罗索，我们有共同的敌人。", "sound": "sounds/vo_1100318_15d_6000.wav"}, "en": {"subtitle": "罗索，我们有共同的敌人。", "sound": "sounds/en_vo_1100318_15d_6000.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle1", "label": "注视1", "duration": 6.667}}, {"step": 89, "action": "dialog", "speaker": "我", "subtitle": "从一开始，你就是我的人。", "voiceId": "15031026", "audioName": "vo_1100318_15e_6000", "voices": {"cn": {"subtitle": "从一开始，你就是我的人。", "sound": "sounds/vo_1100318_15e_6000.wav"}, "en": {"subtitle": "从一开始，你就是我的人。", "sound": "sounds/en_vo_1100318_15e_6000.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle1", "label": "注视1", "duration": 6.667}}, {"step": 90, "action": "dialog", "speaker": "红手套", "subtitle": "你想要什么？我的友谊？", "voiceId": "15030554", "audioName": "vo_1100311_47_6006", "voices": {"cn": {"subtitle": "你想要什么？我的友谊？", "sound": "sounds/vo_1100311_47_6006.wav"}, "en": {"subtitle": "你想要什么？我的友谊？", "sound": "sounds/en_vo_1100311_47_6006.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle1", "label": "注视1", "duration": 6.667}}, {"step": 91, "action": "dialog", "speaker": "我", "subtitle": "三年前你以合伙人的名义投靠达克利亚，我知道你手里有“主厨灭门案”的证据。", "voiceId": "15031028", "audioName": "vo_1100318_16a_6000", "voices": {"cn": {"subtitle": "三年前你以合伙人的名义投靠达克利亚，我知道你手里有“主厨灭门案”的证据。", "sound": "sounds/vo_1100318_16a_6000.wav"}, "en": {"subtitle": "三年前你以合伙人的名义投靠达克利亚，我知道你手里有“主厨灭门案”的证据。", "sound": "sounds/en_vo_1100318_16a_6000.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle1", "label": "注视1", "duration": 6.667}}, {"step": 92, "action": "dialog", "speaker": "我", "subtitle": "等我拿到“公爵毒杀案”的证据后，我要你两案合并，扳倒皮尔特 · 乔纳斯。", "voiceId": "15031029", "audioName": "vo_1100318_16b_6000", "voices": {"cn": {"subtitle": "等我拿到“公爵毒杀案”的证据后，我要你两案合并，扳倒皮尔特 · 乔纳斯。", "sound": "sounds/vo_1100318_16b_6000.wav"}, "en": {"subtitle": "等我拿到“公爵毒杀案”的证据后，我要你两案合并，扳倒皮尔特 · 乔纳斯。", "sound": "sounds/en_vo_1100318_16b_6000.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle1", "label": "注视1", "duration": 6.667}}, {"step": 93, "action": "dialog", "speaker": "红手套", "subtitle": "那我又能得到什么？", "voiceId": "15030555", "audioName": "vo_1100311_48_6006", "voices": {"cn": {"subtitle": "那我又能得到什么？", "sound": "sounds/vo_1100311_48_6006.wav"}, "en": {"subtitle": "那我又能得到什么？", "sound": "sounds/en_vo_1100311_48_6006.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle1", "label": "注视1", "duration": 6.667}}]}, {"id": "t_story_1100318:200082:3", "story": "t_story_1100318", "label": "剧情片段 3 · 1 句", "startStep": 103, "endStep": 106, "cues": [{"step": 105, "action": "dialog", "speaker": "红手套", "subtitle": "很遗憾，女士，你没能打动我。", "voiceId": "15030556", "audioName": "vo_1100311_49_6006", "voices": {"cn": {"subtitle": "很遗憾，女士，你没能打动我。", "sound": "sounds/vo_1100311_49_6006.wav"}, "en": {"subtitle": "很遗憾，女士，你没能打动我。", "sound": "sounds/en_vo_1100311_49_6006.wav"}}, "motion": {"group": "Idle", "index": 1, "actionId": "idle2", "label": "注视2", "duration": 6.667}}]}],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle1", label: "注视1", duration: 6.667 },
          { group: "Idle", index: 1, actionId: "idle2", label: "注视2", duration: 6.667 }
        ]
      },
      {
        label: "TapBody",
        actions: [
          { group: "TapBody", index: 0, actionId: "wenshou", label: "wenshou", duration: 6.667 }
        ]
      }
    ],
    clickShowActions: [
      {
        showId: 65,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1100318 step 65",
        group: "Idle",
        index: 0,
        actionId: "idle1",
        label: "注视1 (2)",
        duration: 6.667,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 2
      },
      {
        showId: 103,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1100318 step 103",
        group: "Idle",
        index: 1,
        actionId: "idle2",
        label: "注视2",
        duration: 6.667,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 1
      }
    ]
  },
  {
    id: "200083_l2d",
    title: "剧情CG 200083",
    assetKind: "storycg",
    categoryLabel: "剧情CG",
    modelDir: "200083_l2d",
    sourceModelDir: "200083_l2d",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "streamingassets",
    styleId: "",
    styleName: "剧情CG 200083",
    stage: "剧情CG",
    hitAreaNames: ["HitAreaBody"],
    followConfigs: [],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [{"id": "t_story_1100318:200083:1", "story": "t_story_1100318", "label": "剧情片段 1 · 2 句", "startStep": 81, "endStep": 85, "cues": [{"step": 83, "action": "dialog", "speaker": "我", "subtitle": "达克利亚是你的杀父仇人。", "voiceId": "15031023", "audioName": "vo_1100318_15b_6000", "voices": {"cn": {"subtitle": "达克利亚是你的杀父仇人。", "sound": "sounds/vo_1100318_15b_6000.wav"}, "en": {"subtitle": "达克利亚是你的杀父仇人。", "sound": "sounds/en_vo_1100318_15b_6000.wav"}}, "motion": {"group": "TapBody", "index": 1, "actionId": "weixiao-idle", "label": "weixiao-idle", "duration": 8.0}}, {"step": 84, "action": "dialog", "speaker": "我", "subtitle": "也是迫使你从罗索 · 法尔科内变成红手套的始作俑者。", "voiceId": "15031024", "audioName": "vo_1100318_15c_6000", "voices": {"cn": {"subtitle": "也是迫使你从罗索 · 法尔科内变成红手套的始作俑者。", "sound": "sounds/vo_1100318_15c_6000.wav"}, "en": {"subtitle": "也是迫使你从罗索 · 法尔科内变成红手套的始作俑者。", "sound": "sounds/en_vo_1100318_15c_6000.wav"}}, "motion": {"group": "TapBody", "index": 1, "actionId": "weixiao-idle", "label": "weixiao-idle", "duration": 8.0}}]}, {"id": "t_story_1100318:200083:2", "story": "t_story_1100318", "label": "剧情片段 2 · 2 句", "startStep": 107, "endStep": 112, "cues": [{"step": 109, "action": "dialog", "speaker": "红手套", "subtitle": "在我们很快就要到来的唇枪舌剑之前。", "voiceId": "15030557", "audioName": "vo_1100311_50_6006", "voices": {"cn": {"subtitle": "在我们很快就要到来的唇枪舌剑之前。", "sound": "sounds/vo_1100311_50_6006.wav"}, "en": {"subtitle": "在我们很快就要到来的唇枪舌剑之前。", "sound": "sounds/en_vo_1100311_50_6006.wav"}}, "motion": {"group": "TapBody", "index": 3, "actionId": "wenshou-idle", "label": "wenshou-idle", "duration": 7.97}}, {"step": 110, "action": "l2dcg", "speaker": "红手套", "subtitle": "请收好我的吻。", "voiceId": "15030558", "audioName": "vo_1100311_51_6006", "voices": {"cn": {"subtitle": "请收好我的吻。", "sound": "sounds/vo_1100311_51_6006.wav"}, "en": {"subtitle": "请收好我的吻。", "sound": "sounds/en_vo_1100311_51_6006.wav"}}, "motion": {"group": "TapBody", "index": 5, "actionId": "wenshou2-idle", "label": "wenshou2-idle", "duration": 8.0}}]}],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "TapBody",
        actions: [
          { group: "TapBody", index: 0, actionId: "weixiao", label: "weixiao", duration: 4.0 },
          { group: "TapBody", index: 1, actionId: "weixiao-idle", label: "weixiao-idle", duration: 8.0 },
          { group: "TapBody", index: 2, actionId: "wenshou", label: "wenshou", duration: 3.033 },
          { group: "TapBody", index: 3, actionId: "wenshou-idle", label: "wenshou-idle", duration: 7.97 },
          { group: "TapBody", index: 4, actionId: "wenshou2", label: "wenshou2", duration: 3.07 },
          { group: "TapBody", index: 5, actionId: "wenshou2-idle", label: "wenshou2-idle", duration: 8.0 }
        ]
      }
    ],
    clickShowActions: [
      {
        showId: 81,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1100318 step 81",
        group: "TapBody",
        index: 0,
        actionId: "weixiao",
        label: "weixiao",
        duration: 4.0,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 1
      },
      {
        showId: 81,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1100318 step 81",
        group: "TapBody",
        index: 1,
        actionId: "weixiao-idle",
        label: "weixiao-idle",
        duration: 8.0,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 1
      },
      {
        showId: 107,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1100318 step 107",
        group: "TapBody",
        index: 2,
        actionId: "wenshou",
        label: "wenshou",
        duration: 3.033,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 1
      },
      {
        showId: 107,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1100318 step 107",
        group: "TapBody",
        index: 3,
        actionId: "wenshou-idle",
        label: "wenshou-idle",
        duration: 7.97,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 1
      },
      {
        showId: 110,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1100318 step 110",
        group: "TapBody",
        index: 4,
        actionId: "wenshou2",
        label: "wenshou2",
        duration: 3.07,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 1
      },
      {
        showId: 110,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1100318 step 110",
        group: "TapBody",
        index: 5,
        actionId: "wenshou2-idle",
        label: "wenshou2-idle",
        duration: 8.0,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 1
      }
    ]
  },
  {
    id: "200084_l2d",
    title: "剧情CG 200084",
    assetKind: "storycg",
    categoryLabel: "剧情CG",
    modelDir: "200084_l2d",
    sourceModelDir: "200084_l2d",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "streamingassets",
    styleId: "",
    styleName: "剧情CG 200084",
    stage: "剧情CG",
    hitAreaNames: ["HitAreaBody"],
    followConfigs: [],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [{"id": "t_story_1100318:200084:1", "story": "t_story_1100318", "label": "剧情片段 1 · 5 句", "startStep": 95, "endStep": 102, "cues": [{"step": 97, "action": "dialog", "speaker": "我", "subtitle": "一个在法庭上复仇的机会。", "voiceId": "15031031", "audioName": "vo_1100318_17a_6000", "voices": {"cn": {"subtitle": "一个在法庭上复仇的机会。", "sound": "sounds/vo_1100318_17a_6000.wav"}, "en": {"subtitle": "一个在法庭上复仇的机会。", "sound": "sounds/en_vo_1100318_17a_6000.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle", "label": "默认", "duration": 6.0}}, {"step": 98, "action": "dialog", "speaker": "我", "subtitle": "我会让塞缪尔 · 达克利亚重返法庭为皮尔特辩护，当众自述老法尔科内当年的案情真相。", "voiceId": "15031032", "audioName": "vo_1100318_17b_6000", "voices": {"cn": {"subtitle": "我会让塞缪尔 · 达克利亚重返法庭为皮尔特辩护，当众自述老法尔科内当年的案情真相。", "sound": "sounds/vo_1100318_17b_6000.wav"}, "en": {"subtitle": "我会让塞缪尔 · 达克利亚重返法庭为皮尔特辩护，当众自述老法尔科内当年的案情真相。", "sound": "sounds/en_vo_1100318_17b_6000.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle", "label": "默认", "duration": 6.0}}, {"step": 99, "action": "dialog", "speaker": "我", "subtitle": "再由你亲手击败他。", "voiceId": "15031181", "audioName": "vo_1100318_17e_6000", "voices": {"cn": {"subtitle": "再由你亲手击败他。", "sound": "sounds/vo_1100318_17e_6000.wav"}, "en": {"subtitle": "再由你亲手击败他。", "sound": "sounds/en_vo_1100318_17e_6000.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle", "label": "默认", "duration": 6.0}}, {"step": 100, "action": "dialog", "speaker": "我", "subtitle": "如果你愿意的话。", "voiceId": "15031033", "audioName": "vo_1100318_17c_6000", "voices": {"cn": {"subtitle": "如果你愿意的话。", "sound": "sounds/vo_1100318_17c_6000.wav"}, "en": {"subtitle": "如果你愿意的话。", "sound": "sounds/en_vo_1100318_17c_6000.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle", "label": "默认", "duration": 6.0}}, {"step": 101, "action": "dialog", "speaker": "我", "subtitle": "请以一个忠诚的吻作为定金。", "voiceId": "15031034", "audioName": "vo_1100318_17d_6000", "voices": {"cn": {"subtitle": "请以一个忠诚的吻作为定金。", "sound": "sounds/vo_1100318_17d_6000.wav"}, "en": {"subtitle": "请以一个忠诚的吻作为定金。", "sound": "sounds/en_vo_1100318_17d_6000.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle", "label": "默认", "duration": 6.0}}]}],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 6.0 }
        ]
      }
    ],
    clickShowActions: [
      {
        showId: 95,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1100318 step 95",
        group: "Idle",
        index: 0,
        actionId: "idle",
        label: "默认",
        duration: 6.0,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 1
      }
    ]
  },
  {
    id: "200085_l2d",
    title: "剧情CG 200085",
    assetKind: "storycg",
    categoryLabel: "剧情CG",
    modelDir: "200085_l2d",
    sourceModelDir: "200085_l2d",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "streamingassets",
    styleId: "",
    styleName: "剧情CG 200085",
    stage: "剧情CG",
    hitAreaNames: ["HitAreaBody"],
    followConfigs: [],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 6.0 }
        ]
      },
      {
        label: "TapBody",
        actions: [
          { group: "TapBody", index: 0, actionId: "chafen1", label: "chafen1", duration: 6.0 },
          { group: "TapBody", index: 1, actionId: "chafen2", label: "chafen2", duration: 6.0 },
          { group: "TapBody", index: 2, actionId: "chafen2_loop", label: "chafen2_loop", duration: 6.0 },
          { group: "TapBody", index: 3, actionId: "chafen3", label: "chafen3", duration: 6.0 },
          { group: "TapBody", index: 4, actionId: "chafen3_loop", label: "chafen3_loop", duration: 6.0 }
        ]
      }
    ],
    clickShowActions: [
      {
        showId: 78,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1100418 step 78",
        group: "Idle",
        index: 0,
        actionId: "idle",
        label: "默认",
        duration: 6.0,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 1
      },
      {
        showId: 88,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1100418 step 88",
        group: "TapBody",
        index: 3,
        actionId: "chafen3",
        label: "chafen3",
        duration: 6.0,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 1
      },
      {
        showId: 88,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1100418 step 88",
        group: "TapBody",
        index: 4,
        actionId: "chafen3_loop",
        label: "chafen3_loop",
        duration: 6.0,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 1
      }
    ]
  },
  {
    id: "200091_01_l2d",
    title: "活动CG 200091_01_l2d 活动主界面",
    assetKind: "activity",
    categoryLabel: "活动CG",
    modelDir: "200091_01_l2d",
    sourceModelDir: "200091_01_l2d",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "localassets_win32",
    styleId: "",
    styleName: "活动CG 200091_01_l2d",
    stage: "活动主界面",
    hitAreaNames: ["HitAreaquanbu"],
    followConfigs: [],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 9.967 }
        ]
      },
      {
        label: "TapBody",
        actions: [
          { group: "TapBody", index: 0, actionId: "dianji1", label: "dianji1", duration: 3.2 },
          { group: "TapBody", index: 1, actionId: "loop", label: "loop", duration: 19.97 }
        ]
      },
      {
        label: "入场",
        actions: [
          { group: "Entry", index: 0, actionId: "ruchang", label: "入场", duration: 3.3 }
        ]
      }
    ],
    clickShowActions: [

    ]
  },
  {
    id: "200091_02_l2d",
    title: "活动CG 200091_02_l2d 活动主界面",
    assetKind: "activity",
    categoryLabel: "活动CG",
    modelDir: "200091_02_l2d",
    sourceModelDir: "200091_02_l2d",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "localassets_win32",
    styleId: "",
    styleName: "活动CG 200091_02_l2d",
    stage: "活动主界面",
    hitAreaNames: ["HitAreaquanbu"],
    followConfigs: [],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 9.967 }
        ]
      },
      {
        label: "TapBody",
        actions: [
          { group: "TapBody", index: 0, actionId: "dianji1", label: "dianji1", duration: 3.2 },
          { group: "TapBody", index: 1, actionId: "loop", label: "loop", duration: 19.97 }
        ]
      },
      {
        label: "入场",
        actions: [
          { group: "Entry", index: 0, actionId: "ruchang", label: "入场", duration: 3.3 }
        ]
      }
    ],
    clickShowActions: [

    ]
  },
  {
    id: "200092_l2d",
    title: "剧情CG 200092",
    assetKind: "storycg",
    categoryLabel: "剧情CG",
    modelDir: "200092_l2d",
    sourceModelDir: "200092_l2d",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "localassets_win32",
    styleId: "",
    styleName: "剧情CG 200092",
    stage: "剧情CG",
    hitAreaNames: ["HitAreaBody"],
    followConfigs: [],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [{"id": "t_story_1600107:200092:1", "story": "t_story_1600107", "label": "剧情片段 1 · 53 句", "startStep": 35, "endStep": 143, "cues": [{"step": 36, "action": "dialog", "speaker": "面试官", "subtitle": "我是你的面试官。", "voiceId": "16010292", "audioName": "vo_1600107_01_6030", "voices": {"cn": {"subtitle": "我是你的面试官。", "sound": "sounds/vo_1600107_01_6030.wav"}, "en": {"subtitle": "我是你的面试官。", "sound": "sounds/en_vo_1600107_01_6030.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle", "label": "默认", "duration": 6.0}}, {"step": 39, "action": "dialog", "speaker": "面试者01", "subtitle": "你好，我是来面试……", "voiceId": "16010293", "audioName": "vo_1600107_02_mianshizhe01", "voices": {"cn": {"subtitle": "你好，我是来面试……", "sound": "sounds/vo_1600107_02_mianshizhe01.wav"}, "en": {"subtitle": "你好，我是来面试……", "sound": "sounds/en_vo_1600107_02_mianshizhe01.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle", "label": "默认", "duration": 6.0}}, {"step": 40, "action": "dialog", "speaker": "面试官", "subtitle": "基本的资料我都看过了，自我介绍就跳过吧，那太无聊了。", "voiceId": "16010294", "audioName": "vo_1600107_03_6030", "voices": {"cn": {"subtitle": "基本的资料我都看过了，自我介绍就跳过吧，那太无聊了。", "sound": "sounds/vo_1600107_03_6030.wav"}, "en": {"subtitle": "基本的资料我都看过了，自我介绍就跳过吧，那太无聊了。", "sound": "sounds/en_vo_1600107_03_6030.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle", "label": "默认", "duration": 6.0}}, {"step": 41, "action": "dialog", "speaker": "面试者01", "subtitle": "好的，先生。", "voiceId": "16010295", "audioName": "vo_1600107_04_mianshizhe01", "voices": {"cn": {"subtitle": "好的，先生。", "sound": "sounds/vo_1600107_04_mianshizhe01.wav"}, "en": {"subtitle": "好的，先生。", "sound": "sounds/en_vo_1600107_04_mianshizhe01.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle", "label": "默认", "duration": 6.0}}, {"step": 42, "action": "dialog", "speaker": "面试官", "subtitle": "你来到这里，是想得到什么呢？", "voiceId": "16010296", "audioName": "vo_1600107_05_6030", "voices": {"cn": {"subtitle": "你来到这里，是想得到什么呢？", "sound": "sounds/vo_1600107_05_6030.wav"}, "en": {"subtitle": "你来到这里，是想得到什么呢？", "sound": "sounds/en_vo_1600107_05_6030.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle", "label": "默认", "duration": 6.0}}, {"step": 43, "action": "dialog", "speaker": "面试官", "subtitle": "金钱、快乐、梦想还是爱？", "voiceId": "16010297", "audioName": "vo_1600107_06_6030", "voices": {"cn": {"subtitle": "金钱、快乐、梦想还是爱？", "sound": "sounds/vo_1600107_06_6030.wav"}, "en": {"subtitle": "金钱、快乐、梦想还是爱？", "sound": "sounds/en_vo_1600107_06_6030.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle", "label": "默认", "duration": 6.0}}, {"step": 44, "action": "dialog", "speaker": "面试者01", "subtitle": "我的梦想就是进入失乐园，成为能为大家带来笑容的演艺者！", "voiceId": "16010298", "audioName": "vo_1600107_07_mianshizhe01", "voices": {"cn": {"subtitle": "我的梦想就是进入失乐园，成为能为大家带来笑容的演艺者！", "sound": "sounds/vo_1600107_07_mianshizhe01.wav"}, "en": {"subtitle": "我的梦想就是进入失乐园，成为能为大家带来笑容的演艺者！", "sound": "sounds/en_vo_1600107_07_mianshizhe01.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle", "label": "默认", "duration": 6.0}}, {"step": 48, "action": "dialog", "speaker": "面试官", "subtitle": "啊、啊……又是这样。", "voiceId": "16010299", "audioName": "vo_1600107_08_6030", "voices": {"cn": {"subtitle": "啊、啊……又是这样。", "sound": "sounds/vo_1600107_08_6030.wav"}, "en": {"subtitle": "啊、啊……又是这样。", "sound": "sounds/en_vo_1600107_08_6030.wav"}}, "motion": {"group": "Idle", "index": 1, "actionId": "idle2", "label": "注视2", "duration": 6.0}}, {"step": 49, "action": "dialog", "speaker": "面试官", "subtitle": "好老套，太老套了，你们都一模一样，长得一模一样，天真得一模一样。", "voiceId": "16010300", "audioName": "vo_1600107_09_6030", "voices": {"cn": {"subtitle": "好老套，太老套了，你们都一模一样，长得一模一样，天真得一模一样。", "sound": "sounds/vo_1600107_09_6030.wav"}, "en": {"subtitle": "好老套，太老套了，你们都一模一样，长得一模一样，天真得一模一样。", "sound": "sounds/en_vo_1600107_09_6030.wav"}}, "motion": {"group": "Idle", "index": 1, "actionId": "idle2", "label": "注视2", "duration": 6.0}}, {"step": 50, "action": "dialog", "speaker": "面试官", "subtitle": "人格和灵魂也像是流水线生产的垃圾电影。", "voiceId": "16010301", "audioName": "vo_1600107_10_6030", "voices": {"cn": {"subtitle": "人格和灵魂也像是流水线生产的垃圾电影。", "sound": "sounds/vo_1600107_10_6030.wav"}, "en": {"subtitle": "人格和灵魂也像是流水线生产的垃圾电影。", "sound": "sounds/en_vo_1600107_10_6030.wav"}}, "motion": {"group": "Idle", "index": 1, "actionId": "idle2", "label": "注视2", "duration": 6.0}}, {"step": 54, "action": "dialog", "speaker": "面试者01", "subtitle": "不，先生，我可以重新回答的！", "voiceId": "16010302", "audioName": "vo_1600107_11_mianshizhe01", "voices": {"cn": {"subtitle": "不，先生，我可以重新回答的！", "sound": "sounds/vo_1600107_11_mianshizhe01.wav"}, "en": {"subtitle": "不，先生，我可以重新回答的！", "sound": "sounds/en_vo_1600107_11_mianshizhe01.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle", "label": "默认", "duration": 6.0}}, {"step": 55, "action": "dialog", "speaker": "面试官", "subtitle": "啊……我不喜欢NG，所以你已经被淘汰了。", "voiceId": "16010303", "audioName": "vo_1600107_12_6030", "voices": {"cn": {"subtitle": "啊……我不喜欢NG，所以你已经被淘汰了。", "sound": "sounds/vo_1600107_12_6030.wav"}, "en": {"subtitle": "啊……我不喜欢NG，所以你已经被淘汰了。", "sound": "sounds/en_vo_1600107_12_6030.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle", "label": "默认", "duration": 6.0}}, {"step": 56, "action": "dialog", "speaker": "面试者01", "subtitle": "什……为什么？！", "voiceId": "16010304", "audioName": "vo_1600107_13_mianshizhe01", "voices": {"cn": {"subtitle": "什……为什么？！", "sound": "sounds/vo_1600107_13_mianshizhe01.wav"}, "en": {"subtitle": "什……为什么？！", "sound": "sounds/en_vo_1600107_13_mianshizhe01.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle", "label": "默认", "duration": 6.0}}, {"step": 57, "action": "dialog", "speaker": "面试官", "subtitle": "因为你没有欲望。", "voiceId": "16010305", "audioName": "vo_1600107_14_6030", "voices": {"cn": {"subtitle": "因为你没有欲望。", "sound": "sounds/vo_1600107_14_6030.wav"}, "en": {"subtitle": "因为你没有欲望。", "sound": "sounds/en_vo_1600107_14_6030.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle", "label": "默认", "duration": 6.0}}, {"step": 58, "action": "dialog", "speaker": "面试者01", "subtitle": "欲望……？", "voiceId": "16010306", "audioName": "vo_1600107_15_mianshizhe01", "voices": {"cn": {"subtitle": "欲望……？", "sound": "sounds/vo_1600107_15_mianshizhe01.wav"}, "en": {"subtitle": "欲望……？", "sound": "sounds/en_vo_1600107_15_mianshizhe01.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle", "label": "默认", "duration": 6.0}}, {"step": 59, "action": "dialog", "speaker": "面试官", "subtitle": "赚钱的欲望、成名的欲望、让所有人爱上你、为你疯狂、为你去死的欲望。", "voiceId": "16010307", "audioName": "vo_1600107_16_6030", "voices": {"cn": {"subtitle": "赚钱的欲望、成名的欲望、让所有人爱上你、为你疯狂、为你去死的欲望。", "sound": "sounds/vo_1600107_16_6030.wav"}, "en": {"subtitle": "赚钱的欲望、成名的欲望、让所有人爱上你、为你疯狂、为你去死的欲望。", "sound": "sounds/en_vo_1600107_16_6030.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle", "label": "默认", "duration": 6.0}}, {"step": 60, "action": "dialog", "speaker": "面试官", "subtitle": "在失乐园……不。", "voiceId": "16010308", "audioName": "vo_1600107_17_6030", "voices": {"cn": {"subtitle": "在失乐园……不。", "sound": "sounds/vo_1600107_17_6030.wav"}, "en": {"subtitle": "在失乐园……不。", "sound": "sounds/en_vo_1600107_17_6030.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle", "label": "默认", "duration": 6.0}}, {"step": 61, "action": "dialog", "speaker": "面试官", "subtitle": "在整个绿洲共和国，所有人都用欲望填满自己空虚的皮囊，没有欲望的人是活不下去的。", "voiceId": "16012090", "audioName": "vo_1600107_17a_6030", "voices": {"cn": {"subtitle": "在整个绿洲共和国，所有人都用欲望填满自己空虚的皮囊，没有欲望的人是活不下去的。", "sound": "sounds/vo_1600107_17a_6030.wav"}, "en": {"subtitle": "在整个绿洲共和国，所有人都用欲望填满自己空虚的皮囊，没有欲望的人是活不下去的。", "sound": "sounds/en_vo_1600107_17a_6030.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle", "label": "默认", "duration": 6.0}}, {"step": 62, "action": "dialog", "speaker": "面试官", "subtitle": "你想死吗？", "voiceId": "16010309", "audioName": "vo_1600107_18_6030", "voices": {"cn": {"subtitle": "你想死吗？", "sound": "sounds/vo_1600107_18_6030.wav"}, "en": {"subtitle": "你想死吗？", "sound": "sounds/en_vo_1600107_18_6030.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle", "label": "默认", "duration": 6.0}}, {"step": 71, "action": "dialog", "speaker": "面试官", "subtitle": "啊……看，你连追逐死亡的欲望都丧失了。", "voiceId": "16010310", "audioName": "vo_1600107_19_6030", "voices": {"cn": {"subtitle": "啊……看，你连追逐死亡的欲望都丧失了。", "sound": "sounds/vo_1600107_19_6030.wav"}, "en": {"subtitle": "啊……看，你连追逐死亡的欲望都丧失了。", "sound": "sounds/en_vo_1600107_19_6030.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle", "label": "默认", "duration": 6.0}}, {"step": 72, "action": "dialog", "speaker": "面试官", "subtitle": "浑浑噩噩地活着、平庸地活着、没用地活着……你为什么要活着？", "voiceId": "16010311", "audioName": "vo_1600107_20_6030", "voices": {"cn": {"subtitle": "浑浑噩噩地活着、平庸地活着、没用地活着……你为什么要活着？", "sound": "sounds/vo_1600107_20_6030.wav"}, "en": {"subtitle": "浑浑噩噩地活着、平庸地活着、没用地活着……你为什么要活着？", "sound": "sounds/en_vo_1600107_20_6030.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle", "label": "默认", "duration": 6.0}}, {"step": 74, "action": "dialog", "speaker": "面试官", "subtitle": "我最讨厌沉默，无论是演员的忘词还是无聊的默片。", "voiceId": "16010312", "audioName": "vo_1600107_21_6030", "voices": {"cn": {"subtitle": "我最讨厌沉默，无论是演员的忘词还是无聊的默片。", "sound": "sounds/vo_1600107_21_6030.wav"}, "en": {"subtitle": "我最讨厌沉默，无论是演员的忘词还是无聊的默片。", "sound": "sounds/en_vo_1600107_21_6030.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle", "label": "默认", "duration": 6.0}}, {"step": 75, "action": "dialog", "speaker": "面试官", "subtitle": "并不那么遗憾地通知你，你可以走了。", "voiceId": "16012091", "audioName": "vo_1600107_21a_6030", "voices": {"cn": {"subtitle": "并不那么遗憾地通知你，你可以走了。", "sound": "sounds/vo_1600107_21a_6030.wav"}, "en": {"subtitle": "并不那么遗憾地通知你，你可以走了。", "sound": "sounds/en_vo_1600107_21a_6030.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle", "label": "默认", "duration": 6.0}}, {"step": 76, "action": "dialog", "speaker": "面试者01", "subtitle": "请您……再给我一个机会。", "voiceId": "16010313", "audioName": "vo_1600107_22_mianshizhe01", "voices": {"cn": {"subtitle": "请您……再给我一个机会。", "sound": "sounds/vo_1600107_22_mianshizhe01.wav"}, "en": {"subtitle": "请您……再给我一个机会。", "sound": "sounds/en_vo_1600107_22_mianshizhe01.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle", "label": "默认", "duration": 6.0}}, {"step": 78, "action": "dialog", "speaker": "面试官", "subtitle": "你现在的表情倒是很不错，可惜太迟了，不是所有观众都有耐心等待你的渐入佳境。", "voiceId": "16010314", "audioName": "vo_1600107_23_6030", "voices": {"cn": {"subtitle": "你现在的表情倒是很不错，可惜太迟了，不是所有观众都有耐心等待你的渐入佳境。", "sound": "sounds/vo_1600107_23_6030.wav"}, "en": {"subtitle": "你现在的表情倒是很不错，可惜太迟了，不是所有观众都有耐心等待你的渐入佳境。", "sound": "sounds/en_vo_1600107_23_6030.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle", "label": "默认", "duration": 6.0}}, {"step": 79, "action": "dialog", "speaker": "面试者01", "subtitle": "……我明白了。", "voiceId": "16010315", "audioName": "vo_1600107_24_mianshizhe01", "voices": {"cn": {"subtitle": "……我明白了。", "sound": "sounds/vo_1600107_24_mianshizhe01.wav"}, "en": {"subtitle": "……我明白了。", "sound": "sounds/en_vo_1600107_24_mianshizhe01.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle", "label": "默认", "duration": 6.0}}, {"step": 92, "action": "dialog", "speaker": "面试者02 迪恩", "subtitle": "您好。", "voiceId": "16010316", "audioName": "vo_1600107_25_7082", "voices": {"cn": {"subtitle": "您好。", "sound": "sounds/vo_1600107_25_7082.wav"}, "en": {"subtitle": "您好。", "sound": "sounds/en_vo_1600107_25_7082.wav"}}, "motion": {"group": "Idle", "index": 3, "actionId": "idle4", "label": "idle4", "duration": 6.0}}, {"step": 93, "action": "dialog", "speaker": "面试官", "subtitle": "坐吧，我有些累了，我们速战速决。", "voiceId": "16010317", "audioName": "vo_1600107_26_6030", "voices": {"cn": {"subtitle": "坐吧，我有些累了，我们速战速决。", "sound": "sounds/vo_1600107_26_6030.wav"}, "en": {"subtitle": "坐吧，我有些累了，我们速战速决。", "sound": "sounds/en_vo_1600107_26_6030.wav"}}, "motion": {"group": "Idle", "index": 3, "actionId": "idle4", "label": "idle4", "duration": 6.0}}, {"step": 96, "action": "dialog", "speaker": "面试者02 迪恩", "subtitle": "您看起来不太舒服，身体还好吗？", "voiceId": "16010318", "audioName": "vo_1600107_27_7082", "voices": {"cn": {"subtitle": "您看起来不太舒服，身体还好吗？", "sound": "sounds/vo_1600107_27_7082.wav"}, "en": {"subtitle": "您看起来不太舒服，身体还好吗？", "sound": "sounds/en_vo_1600107_27_7082.wav"}}, "motion": {"group": "Idle", "index": 3, "actionId": "idle4", "label": "idle4", "duration": 6.0}}, {"step": 97, "action": "dialog", "speaker": "面试官", "subtitle": "哦，我刚刚在画画呢，不用在意。", "voiceId": "16010319", "audioName": "vo_1600107_28_6030", "voices": {"cn": {"subtitle": "哦，我刚刚在画画呢，不用在意。", "sound": "sounds/vo_1600107_28_6030.wav"}, "en": {"subtitle": "哦，我刚刚在画画呢，不用在意。", "sound": "sounds/en_vo_1600107_28_6030.wav"}}, "motion": {"group": "Idle", "index": 3, "actionId": "idle4", "label": "idle4", "duration": 6.0}}, {"step": 102, "action": "dialog", "speaker": "面试者02 迪恩", "subtitle": "！！！", "voiceId": "16010320", "audioName": "vo_1600107_29_7082", "voices": {"cn": {"subtitle": "！！！", "sound": "sounds/vo_1600107_29_7082.wav"}, "en": {"subtitle": "！！！", "sound": "sounds/en_vo_1600107_29_7082.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle", "label": "默认", "duration": 6.0}}, {"step": 106, "action": "dialog", "speaker": "面试者02 迪恩", "subtitle": "这、这样吗？", "voiceId": "16010321", "audioName": "vo_1600107_30_7082", "voices": {"cn": {"subtitle": "这、这样吗？", "sound": "sounds/vo_1600107_30_7082.wav"}, "en": {"subtitle": "这、这样吗？", "sound": "sounds/en_vo_1600107_30_7082.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle", "label": "默认", "duration": 6.0}}, {"step": 113, "action": "dialog", "speaker": "面试官", "subtitle": "迪恩，恭喜你，你被录取了。", "voiceId": "16010322", "audioName": "vo_1600107_31_6030", "voices": {"cn": {"subtitle": "迪恩，恭喜你，你被录取了。", "sound": "sounds/vo_1600107_31_6030.wav"}, "en": {"subtitle": "迪恩，恭喜你，你被录取了。", "sound": "sounds/en_vo_1600107_31_6030.wav"}}, "motion": {"group": "Idle", "index": 1, "actionId": "idle2", "label": "注视2", "duration": 6.0}}, {"step": 114, "action": "dialog", "speaker": "面试者02 迪恩", "subtitle": "感谢您的赏识！", "voiceId": "16010323", "audioName": "vo_1600107_32_7082", "voices": {"cn": {"subtitle": "感谢您的赏识！", "sound": "sounds/vo_1600107_32_7082.wav"}, "en": {"subtitle": "感谢您的赏识！", "sound": "sounds/en_vo_1600107_32_7082.wav"}}, "motion": {"group": "Idle", "index": 1, "actionId": "idle2", "label": "注视2", "duration": 6.0}}, {"step": 115, "action": "dialog", "speaker": "面试官", "subtitle": "好了，明天来上班。", "voiceId": "16010324", "audioName": "vo_1600107_33_6030", "voices": {"cn": {"subtitle": "好了，明天来上班。", "sound": "sounds/vo_1600107_33_6030.wav"}, "en": {"subtitle": "好了，明天来上班。", "sound": "sounds/en_vo_1600107_33_6030.wav"}}, "motion": {"group": "Idle", "index": 1, "actionId": "idle2", "label": "注视2", "duration": 6.0}}, {"step": 116, "action": "dialog", "speaker": "面试者02 迪恩", "subtitle": "等、等等，我能问一下为什么选择我吗？", "voiceId": "16010325", "audioName": "vo_1600107_34_7082", "voices": {"cn": {"subtitle": "等、等等，我能问一下为什么选择我吗？", "sound": "sounds/vo_1600107_34_7082.wav"}, "en": {"subtitle": "等、等等，我能问一下为什么选择我吗？", "sound": "sounds/en_vo_1600107_34_7082.wav"}}, "motion": {"group": "Idle", "index": 1, "actionId": "idle2", "label": "注视2", "duration": 6.0}}, {"step": 119, "action": "dialog", "speaker": "面试官", "subtitle": "你有着一张不错的脸，还有与之相匹配的恶毒和野心。", "voiceId": "16010326", "audioName": "vo_1600107_35_6030", "voices": {"cn": {"subtitle": "你有着一张不错的脸，还有与之相匹配的恶毒和野心。", "sound": "sounds/vo_1600107_35_6030.wav"}, "en": {"subtitle": "你有着一张不错的脸，还有与之相匹配的恶毒和野心。", "sound": "sounds/en_vo_1600107_35_6030.wav"}}, "motion": {"group": "Idle", "index": 1, "actionId": "idle2", "label": "注视2", "duration": 6.0}}, {"step": 120, "action": "dialog", "speaker": "面试者02 迪恩", "subtitle": "……什么？我想我一定是听错了。", "voiceId": "16010327", "audioName": "vo_1600107_36_7082", "voices": {"cn": {"subtitle": "……什么？我想我一定是听错了。", "sound": "sounds/vo_1600107_36_7082.wav"}, "en": {"subtitle": "……什么？我想我一定是听错了。", "sound": "sounds/en_vo_1600107_36_7082.wav"}}, "motion": {"group": "Idle", "index": 1, "actionId": "idle2", "label": "注视2", "duration": 6.0}}, {"step": 122, "action": "dialog", "speaker": "面试官", "subtitle": "好了，我们别玩自欺欺人的游戏了，我已经很困了。", "voiceId": "16010328", "audioName": "vo_1600107_37_6030", "voices": {"cn": {"subtitle": "好了，我们别玩自欺欺人的游戏了，我已经很困了。", "sound": "sounds/vo_1600107_37_6030.wav"}, "en": {"subtitle": "好了，我们别玩自欺欺人的游戏了，我已经很困了。", "sound": "sounds/en_vo_1600107_37_6030.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle", "label": "默认", "duration": 6.0}}, {"step": 123, "action": "dialog", "speaker": "面试官", "subtitle": "你不是在面试者01的衣领上别了摄像头、偷窥他的现场了吗？", "voiceId": "16012092", "audioName": "vo_1600107_37a_6030", "voices": {"cn": {"subtitle": "你不是在面试者01的衣领上别了摄像头、偷窥他的现场了吗？", "sound": "sounds/vo_1600107_37a_6030.wav"}, "en": {"subtitle": "你不是在面试者01的衣领上别了摄像头、偷窥他的现场了吗？", "sound": "sounds/en_vo_1600107_37a_6030.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle", "label": "默认", "duration": 6.0}}, {"step": 124, "action": "dialog", "speaker": "面试官", "subtitle": "你知道一天有多少个想将自己献给失乐园的面试者吗？", "voiceId": "16010329", "audioName": "vo_1600107_38_6030", "voices": {"cn": {"subtitle": "你知道一天有多少个想将自己献给失乐园的面试者吗？", "sound": "sounds/vo_1600107_38_6030.wav"}, "en": {"subtitle": "你知道一天有多少个想将自己献给失乐园的面试者吗？", "sound": "sounds/en_vo_1600107_38_6030.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle", "label": "默认", "duration": 6.0}}, {"step": 125, "action": "dialog", "speaker": "面试官", "subtitle": "你并不是面试者02，而是面试者00002。", "voiceId": "16010330", "audioName": "vo_1600107_39_6030", "voices": {"cn": {"subtitle": "你并不是面试者02，而是面试者00002。", "sound": "sounds/vo_1600107_39_6030.wav"}, "en": {"subtitle": "你并不是面试者02，而是面试者00002。", "sound": "sounds/en_vo_1600107_39_6030.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle", "label": "默认", "duration": 6.0}}, {"step": 126, "action": "dialog", "speaker": "面试官", "subtitle": "你平庸又自大，我之所以录取你，就是因为你不择手段追逐欲望的野心。", "voiceId": "16010331", "audioName": "vo_1600107_40_6030", "voices": {"cn": {"subtitle": "你平庸又自大，我之所以录取你，就是因为你不择手段追逐欲望的野心。", "sound": "sounds/vo_1600107_40_6030.wav"}, "en": {"subtitle": "你平庸又自大，我之所以录取你，就是因为你不择手段追逐欲望的野心。", "sound": "sounds/en_vo_1600107_40_6030.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle", "label": "默认", "duration": 6.0}}, {"step": 127, "action": "dialog", "speaker": "面试官", "subtitle": "你的梦想在这里，你曾经发誓要死在这里。", "voiceId": "16010332", "audioName": "vo_1600107_41_6030", "voices": {"cn": {"subtitle": "你的梦想在这里，你曾经发誓要死在这里。", "sound": "sounds/vo_1600107_41_6030.wav"}, "en": {"subtitle": "你的梦想在这里，你曾经发誓要死在这里。", "sound": "sounds/en_vo_1600107_41_6030.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle", "label": "默认", "duration": 6.0}}, {"step": 128, "action": "dialog", "speaker": "面试官", "subtitle": "为此，你甚至不惜撕毁了朋友的面试资料，他现在正因为重新打印而迟到被拦在场外。", "voiceId": "16010333", "audioName": "vo_1600107_42_6030", "voices": {"cn": {"subtitle": "为此，你甚至不惜撕毁了朋友的面试资料，他现在正因为重新打印而迟到被拦在场外。", "sound": "sounds/vo_1600107_42_6030.wav"}, "en": {"subtitle": "为此，你甚至不惜撕毁了朋友的面试资料，他现在正因为重新打印而迟到被拦在场外。", "sound": "sounds/en_vo_1600107_42_6030.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle", "label": "默认", "duration": 6.0}}, {"step": 129, "action": "dialog", "speaker": "面试官", "subtitle": "多么愚蠢又勇敢的行为啊……", "voiceId": "16010334", "audioName": "vo_1600107_43_6030", "voices": {"cn": {"subtitle": "多么愚蠢又勇敢的行为啊……", "sound": "sounds/vo_1600107_43_6030.wav"}, "en": {"subtitle": "多么愚蠢又勇敢的行为啊……", "sound": "sounds/en_vo_1600107_43_6030.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle", "label": "默认", "duration": 6.0}}, {"step": 131, "action": "dialog", "speaker": "面试者02 迪恩", "subtitle": "我没有，是他自己……", "voiceId": "16010335", "audioName": "vo_1600107_44_7082", "voices": {"cn": {"subtitle": "我没有，是他自己……", "sound": "sounds/vo_1600107_44_7082.wav"}, "en": {"subtitle": "我没有，是他自己……", "sound": "sounds/en_vo_1600107_44_7082.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle", "label": "默认", "duration": 6.0}}, {"step": 133, "action": "dialog", "speaker": "面试官", "subtitle": "值得称赞。", "voiceId": "16010336", "audioName": "vo_1600107_45_6030", "voices": {"cn": {"subtitle": "值得称赞。", "sound": "sounds/vo_1600107_45_6030.wav"}, "en": {"subtitle": "值得称赞。", "sound": "sounds/en_vo_1600107_45_6030.wav"}}, "motion": {"group": "Idle", "index": 2, "actionId": "idle3", "label": "idle3", "duration": 6.0}}, {"step": 135, "action": "dialog", "speaker": "面试者02 迪恩", "subtitle": "……", "voiceId": "16010337", "audioName": "vo_1600107_46_7082", "voices": {"cn": {"subtitle": "……", "sound": "sounds/vo_1600107_46_7082.wav"}, "en": {"subtitle": "……", "sound": "sounds/en_vo_1600107_46_7082.wav"}}, "motion": {"group": "Idle", "index": 2, "actionId": "idle3", "label": "idle3", "duration": 6.0}}, {"step": 136, "action": "dialog", "speaker": "面试官", "subtitle": "唔……你现在的表情简直是为镜头而生，扭曲又恶毒、困惑又自满……", "voiceId": "16010338", "audioName": "vo_1600107_47_6030", "voices": {"cn": {"subtitle": "唔……你现在的表情简直是为镜头而生，扭曲又恶毒、困惑又自满……", "sound": "sounds/vo_1600107_47_6030.wav"}, "en": {"subtitle": "唔……你现在的表情简直是为镜头而生，扭曲又恶毒、困惑又自满……", "sound": "sounds/en_vo_1600107_47_6030.wav"}}, "motion": {"group": "Idle", "index": 2, "actionId": "idle3", "label": "idle3", "duration": 6.0}}, {"step": 137, "action": "dialog", "speaker": "面试官", "subtitle": "你一定可以成为失乐园那颗……最完美的苹果。", "voiceId": "16010339", "audioName": "vo_1600107_48_6030", "voices": {"cn": {"subtitle": "你一定可以成为失乐园那颗……最完美的苹果。", "sound": "sounds/vo_1600107_48_6030.wav"}, "en": {"subtitle": "你一定可以成为失乐园那颗……最完美的苹果。", "sound": "sounds/en_vo_1600107_48_6030.wav"}}, "motion": {"group": "Idle", "index": 2, "actionId": "idle3", "label": "idle3", "duration": 6.0}}, {"step": 139, "action": "dialog", "speaker": "面试者02 迪恩", "subtitle": "我会的、我会的！", "voiceId": "16010340", "audioName": "vo_1600107_49_7082", "voices": {"cn": {"subtitle": "我会的、我会的！", "sound": "sounds/vo_1600107_49_7082.wav"}, "en": {"subtitle": "我会的、我会的！", "sound": "sounds/en_vo_1600107_49_7082.wav"}}, "motion": {"group": "Idle", "index": 2, "actionId": "idle3", "label": "idle3", "duration": 6.0}}, {"step": 140, "action": "dialog", "speaker": "面试者02 迪恩", "subtitle": "我愿意死在这里！", "voiceId": "16010341", "audioName": "vo_1600107_50_7082", "voices": {"cn": {"subtitle": "我愿意死在这里！", "sound": "sounds/vo_1600107_50_7082.wav"}, "en": {"subtitle": "我愿意死在这里！", "sound": "sounds/en_vo_1600107_50_7082.wav"}}, "motion": {"group": "Idle", "index": 2, "actionId": "idle3", "label": "idle3", "duration": 6.0}}]}, {"id": "t_story_1600201:200092:2", "story": "t_story_1600201", "label": "剧情片段 2 · 46 句", "startStep": 53, "endStep": 166, "cues": [{"step": 55, "action": "dialog", "speaker": "面试官", "subtitle": "我是失乐园的面试官，不用紧张，我只是来为你做一个简单的采访……", "voiceId": "16010870", "audioName": "vo_1600201_08_6030", "voices": {"cn": {"subtitle": "我是失乐园的面试官，不用紧张，我只是来为你做一个简单的采访……", "sound": "sounds/vo_1600201_08_6030.wav"}, "en": {"subtitle": "我是失乐园的面试官，不用紧张，我只是来为你做一个简单的采访……", "sound": "sounds/en_vo_1600201_08_6030.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle", "label": "默认", "duration": 6.0}}, {"step": 56, "action": "l2dcg", "speaker": "面试官", "subtitle": "我即将为你播放一段混剪，内容是失乐园过往选手的精彩游戏片段。", "voiceId": "16010871", "audioName": "vo_1600201_09_6030", "voices": {"cn": {"subtitle": "我即将为你播放一段混剪，内容是失乐园过往选手的精彩游戏片段。", "sound": "sounds/vo_1600201_09_6030.wav"}, "en": {"subtitle": "我即将为你播放一段混剪，内容是失乐园过往选手的精彩游戏片段。", "sound": "sounds/en_vo_1600201_09_6030.wav"}}, "motion": {"group": "Idle", "index": 1, "actionId": "idle2", "label": "注视2", "duration": 6.0}}, {"step": 57, "action": "dialog", "speaker": "面试官", "subtitle": "当灯光熄灭，你对于这些画面的感受更接近于以下哪种感觉？", "voiceId": "16013017", "audioName": "vo_1600201_09a_6030", "voices": {"cn": {"subtitle": "当灯光熄灭，你对于这些画面的感受更接近于以下哪种感觉？", "sound": "sounds/vo_1600201_09a_6030.wav"}, "en": {"subtitle": "当灯光熄灭，你对于这些画面的感受更接近于以下哪种感觉？", "sound": "sounds/en_vo_1600201_09a_6030.wav"}}, "motion": {"group": "Idle", "index": 1, "actionId": "idle2", "label": "注视2", "duration": 6.0}}, {"step": 61, "action": "l2dcg", "speaker": "面试官", "subtitle": "嗯嗯……有趣……", "voiceId": "16010872", "audioName": "vo_1600201_10_6030", "voices": {"cn": {"subtitle": "嗯嗯……有趣……", "sound": "sounds/vo_1600201_10_6030.wav"}, "en": {"subtitle": "嗯嗯……有趣……", "sound": "sounds/en_vo_1600201_10_6030.wav"}}, "motion": {"group": "Idle", "index": 2, "actionId": "idle3", "label": "idle3", "duration": 6.0}}, {"step": 64, "action": "l2dcg", "speaker": "面试官", "subtitle": "嗯嗯……有趣……", "voiceId": "16010872", "audioName": "vo_1600201_10_6030", "voices": {"cn": {"subtitle": "嗯嗯……有趣……", "sound": "sounds/vo_1600201_10_6030.wav"}, "en": {"subtitle": "嗯嗯……有趣……", "sound": "sounds/en_vo_1600201_10_6030.wav"}}, "motion": {"group": "Idle", "index": 2, "actionId": "idle3", "label": "idle3", "duration": 6.0}}, {"step": 67, "action": "l2dcg", "speaker": "面试官", "subtitle": "嗯嗯……有趣……", "voiceId": "16010872", "audioName": "vo_1600201_10_6030", "voices": {"cn": {"subtitle": "嗯嗯……有趣……", "sound": "sounds/vo_1600201_10_6030.wav"}, "en": {"subtitle": "嗯嗯……有趣……", "sound": "sounds/en_vo_1600201_10_6030.wav"}}, "motion": {"group": "Idle", "index": 2, "actionId": "idle3", "label": "idle3", "duration": 6.0}}, {"step": 70, "action": "l2dcg", "speaker": "面试官", "subtitle": "嗯嗯……有趣……", "voiceId": "16010872", "audioName": "vo_1600201_10_6030", "voices": {"cn": {"subtitle": "嗯嗯……有趣……", "sound": "sounds/vo_1600201_10_6030.wav"}, "en": {"subtitle": "嗯嗯……有趣……", "sound": "sounds/en_vo_1600201_10_6030.wav"}}, "motion": {"group": "Idle", "index": 2, "actionId": "idle3", "label": "idle3", "duration": 6.0}}, {"step": 72, "action": "l2dcg", "speaker": "面试官", "subtitle": "现在我会给你展示其他选手的资产评估。", "voiceId": "16010873", "audioName": "vo_1600201_11_6030", "voices": {"cn": {"subtitle": "现在我会给你展示其他选手的资产评估。", "sound": "sounds/vo_1600201_11_6030.wav"}, "en": {"subtitle": "现在我会给你展示其他选手的资产评估。", "sound": "sounds/en_vo_1600201_11_6030.wav"}}, "motion": {"group": "Idle", "index": 1, "actionId": "idle2", "label": "注视2", "duration": 6.0}}, {"step": 73, "action": "dialog", "speaker": "面试官", "subtitle": "你会看到一个资质平平者因运气一夜暴富，另一个则因贩卖了灵魂获得巨额筹码。", "voiceId": "16013018", "audioName": "vo_1600201_11a_6030", "voices": {"cn": {"subtitle": "你会看到一个资质平平者因运气一夜暴富，另一个则因贩卖了灵魂获得巨额筹码。", "sound": "sounds/vo_1600201_11a_6030.wav"}, "en": {"subtitle": "你会看到一个资质平平者因运气一夜暴富，另一个则因贩卖了灵魂获得巨额筹码。", "sound": "sounds/en_vo_1600201_11a_6030.wav"}}, "motion": {"group": "Idle", "index": 1, "actionId": "idle2", "label": "注视2", "duration": 6.0}}, {"step": 74, "action": "l2dcg", "speaker": "面试官", "subtitle": "这些数据在你心中首先激起的涟漪是？", "voiceId": "16010874", "audioName": "vo_1600201_12_6030", "voices": {"cn": {"subtitle": "这些数据在你心中首先激起的涟漪是？", "sound": "sounds/vo_1600201_12_6030.wav"}, "en": {"subtitle": "这些数据在你心中首先激起的涟漪是？", "sound": "sounds/en_vo_1600201_12_6030.wav"}}, "motion": {"group": "Idle", "index": 2, "actionId": "idle3", "label": "idle3", "duration": 6.0}}, {"step": 77, "action": "dialog", "speaker": "面试官", "subtitle": "居然选了这个吗……", "voiceId": "16010875", "audioName": "vo_1600201_13_6030", "voices": {"cn": {"subtitle": "居然选了这个吗……", "sound": "sounds/vo_1600201_13_6030.wav"}, "en": {"subtitle": "居然选了这个吗……", "sound": "sounds/en_vo_1600201_13_6030.wav"}}, "motion": {"group": "Idle", "index": 2, "actionId": "idle3", "label": "idle3", "duration": 6.0}}, {"step": 80, "action": "dialog", "speaker": "面试官", "subtitle": "居然选了这个吗……", "voiceId": "16010875", "audioName": "vo_1600201_13_6030", "voices": {"cn": {"subtitle": "居然选了这个吗……", "sound": "sounds/vo_1600201_13_6030.wav"}, "en": {"subtitle": "居然选了这个吗……", "sound": "sounds/en_vo_1600201_13_6030.wav"}}, "motion": {"group": "Idle", "index": 2, "actionId": "idle3", "label": "idle3", "duration": 6.0}}, {"step": 83, "action": "dialog", "speaker": "面试官", "subtitle": "居然选了这个吗……", "voiceId": "16010875", "audioName": "vo_1600201_13_6030", "voices": {"cn": {"subtitle": "居然选了这个吗……", "sound": "sounds/vo_1600201_13_6030.wav"}, "en": {"subtitle": "居然选了这个吗……", "sound": "sounds/en_vo_1600201_13_6030.wav"}}, "motion": {"group": "Idle", "index": 2, "actionId": "idle3", "label": "idle3", "duration": 6.0}}, {"step": 86, "action": "dialog", "speaker": "面试官", "subtitle": "居然选了这个吗……", "voiceId": "16010875", "audioName": "vo_1600201_13_6030", "voices": {"cn": {"subtitle": "居然选了这个吗……", "sound": "sounds/vo_1600201_13_6030.wav"}, "en": {"subtitle": "居然选了这个吗……", "sound": "sounds/en_vo_1600201_13_6030.wav"}}, "motion": {"group": "Idle", "index": 2, "actionId": "idle3", "label": "idle3", "duration": 6.0}}, {"step": 88, "action": "l2dcg", "speaker": "面试官", "subtitle": "下一个问题，在团体游戏中，一个无能的同伴因自私导致你满盘皆输。", "voiceId": "16010876", "audioName": "vo_1600201_14_6030", "voices": {"cn": {"subtitle": "下一个问题，在团体游戏中，一个无能的同伴因自私导致你满盘皆输。", "sound": "sounds/vo_1600201_14_6030.wav"}, "en": {"subtitle": "下一个问题，在团体游戏中，一个无能的同伴因自私导致你满盘皆输。", "sound": "sounds/en_vo_1600201_14_6030.wav"}}, "motion": {"group": "Idle", "index": 1, "actionId": "idle2", "label": "注视2", "duration": 6.0}}, {"step": 89, "action": "dialog", "speaker": "面试官", "subtitle": "现在，你可以选择惩罚他的方法。", "voiceId": "16013019", "audioName": "vo_1600201_14a_6030", "voices": {"cn": {"subtitle": "现在，你可以选择惩罚他的方法。", "sound": "sounds/vo_1600201_14a_6030.wav"}, "en": {"subtitle": "现在，你可以选择惩罚他的方法。", "sound": "sounds/en_vo_1600201_14a_6030.wav"}}, "motion": {"group": "Idle", "index": 1, "actionId": "idle2", "label": "注视2", "duration": 6.0}}, {"step": 92, "action": "l2dcg", "speaker": "面试官", "subtitle": "唔……这样真的好吗？", "voiceId": "16010877", "audioName": "vo_1600201_15_6030", "voices": {"cn": {"subtitle": "唔……这样真的好吗？", "sound": "sounds/vo_1600201_15_6030.wav"}, "en": {"subtitle": "唔……这样真的好吗？", "sound": "sounds/en_vo_1600201_15_6030.wav"}}, "motion": {"group": "Idle", "index": 2, "actionId": "idle3", "label": "idle3", "duration": 6.0}}, {"step": 95, "action": "l2dcg", "speaker": "面试官", "subtitle": "唔……这样真的好吗？", "voiceId": "16010877", "audioName": "vo_1600201_15_6030", "voices": {"cn": {"subtitle": "唔……这样真的好吗？", "sound": "sounds/vo_1600201_15_6030.wav"}, "en": {"subtitle": "唔……这样真的好吗？", "sound": "sounds/en_vo_1600201_15_6030.wav"}}, "motion": {"group": "Idle", "index": 2, "actionId": "idle3", "label": "idle3", "duration": 6.0}}, {"step": 98, "action": "l2dcg", "speaker": "面试官", "subtitle": "唔……这样真的好吗？", "voiceId": "16010877", "audioName": "vo_1600201_15_6030", "voices": {"cn": {"subtitle": "唔……这样真的好吗？", "sound": "sounds/vo_1600201_15_6030.wav"}, "en": {"subtitle": "唔……这样真的好吗？", "sound": "sounds/en_vo_1600201_15_6030.wav"}}, "motion": {"group": "Idle", "index": 2, "actionId": "idle3", "label": "idle3", "duration": 6.0}}, {"step": 101, "action": "l2dcg", "speaker": "面试官", "subtitle": "唔……这样真的好吗？", "voiceId": "16010877", "audioName": "vo_1600201_15_6030", "voices": {"cn": {"subtitle": "唔……这样真的好吗？", "sound": "sounds/vo_1600201_15_6030.wav"}, "en": {"subtitle": "唔……这样真的好吗？", "sound": "sounds/en_vo_1600201_15_6030.wav"}}, "motion": {"group": "Idle", "index": 2, "actionId": "idle3", "label": "idle3", "duration": 6.0}}, {"step": 103, "action": "l2dcg", "speaker": "面试官", "subtitle": "如果我能保证你安全晋级前两轮游戏，且享受最好的贵宾待遇，代价是无人会在意你，你永远也不可能受到瞩目，成为明星选手。", "voiceId": "16010878", "audioName": "vo_1600201_16_6030", "voices": {"cn": {"subtitle": "如果我能保证你安全晋级前两轮游戏，且享受最好的贵宾待遇，代价是无人会在意你，你永远也不可能受到瞩目，成为明星选手。", "sound": "sounds/vo_1600201_16_6030.wav"}, "en": {"subtitle": "如果我能保证你安全晋级前两轮游戏，且享受最好的贵宾待遇，代价是无人会在意你，你永远也不可能受到瞩目，成为明星选手。", "sound": "sounds/en_vo_1600201_16_6030.wav"}}, "motion": {"group": "Idle", "index": 1, "actionId": "idle2", "label": "注视2", "duration": 6.0}}, {"step": 104, "action": "dialog", "speaker": "面试官", "subtitle": "你会怎么选择？", "voiceId": "16010879", "audioName": "vo_1600201_17_6030", "voices": {"cn": {"subtitle": "你会怎么选择？", "sound": "sounds/vo_1600201_17_6030.wav"}, "en": {"subtitle": "你会怎么选择？", "sound": "sounds/en_vo_1600201_17_6030.wav"}}, "motion": {"group": "Idle", "index": 1, "actionId": "idle2", "label": "注视2", "duration": 6.0}}, {"step": 107, "action": "dialog", "speaker": "面试官", "subtitle": "原来你是这么想的吗……", "voiceId": "16010880", "audioName": "vo_1600201_18_6030", "voices": {"cn": {"subtitle": "原来你是这么想的吗……", "sound": "sounds/vo_1600201_18_6030.wav"}, "en": {"subtitle": "原来你是这么想的吗……", "sound": "sounds/en_vo_1600201_18_6030.wav"}}, "motion": {"group": "Idle", "index": 1, "actionId": "idle2", "label": "注视2", "duration": 6.0}}, {"step": 110, "action": "dialog", "speaker": "面试官", "subtitle": "原来你是这么想的吗……", "voiceId": "16010880", "audioName": "vo_1600201_18_6030", "voices": {"cn": {"subtitle": "原来你是这么想的吗……", "sound": "sounds/vo_1600201_18_6030.wav"}, "en": {"subtitle": "原来你是这么想的吗……", "sound": "sounds/en_vo_1600201_18_6030.wav"}}, "motion": {"group": "Idle", "index": 1, "actionId": "idle2", "label": "注视2", "duration": 6.0}}, {"step": 113, "action": "dialog", "speaker": "面试官", "subtitle": "原来你是这么想的吗……", "voiceId": "16010880", "audioName": "vo_1600201_18_6030", "voices": {"cn": {"subtitle": "原来你是这么想的吗……", "sound": "sounds/vo_1600201_18_6030.wav"}, "en": {"subtitle": "原来你是这么想的吗……", "sound": "sounds/en_vo_1600201_18_6030.wav"}}, "motion": {"group": "Idle", "index": 1, "actionId": "idle2", "label": "注视2", "duration": 6.0}}, {"step": 116, "action": "dialog", "speaker": "面试官", "subtitle": "原来你是这么想的吗……", "voiceId": "16010880", "audioName": "vo_1600201_18_6030", "voices": {"cn": {"subtitle": "原来你是这么想的吗……", "sound": "sounds/vo_1600201_18_6030.wav"}, "en": {"subtitle": "原来你是这么想的吗……", "sound": "sounds/en_vo_1600201_18_6030.wav"}}, "motion": {"group": "Idle", "index": 1, "actionId": "idle2", "label": "注视2", "duration": 6.0}}, {"step": 118, "action": "l2dcg", "speaker": "面试官", "subtitle": "现在你面前有一个按钮，按下去你将立刻获得足以改变游戏局面的巨额筹码，但是会随机导致另一名选手直接出局。", "voiceId": "16010881", "audioName": "vo_1600201_19_6030", "voices": {"cn": {"subtitle": "现在你面前有一个按钮，按下去你将立刻获得足以改变游戏局面的巨额筹码，但是会随机导致另一名选手直接出局。", "sound": "sounds/vo_1600201_19_6030.wav"}, "en": {"subtitle": "现在你面前有一个按钮，按下去你将立刻获得足以改变游戏局面的巨额筹码，但是会随机导致另一名选手直接出局。", "sound": "sounds/en_vo_1600201_19_6030.wav"}}, "motion": {"group": "Idle", "index": 1, "actionId": "idle2", "label": "注视2", "duration": 6.0}}, {"step": 119, "action": "dialog", "speaker": "面试官", "subtitle": "你会按下它吗？", "voiceId": "16010882", "audioName": "vo_1600201_20_6030", "voices": {"cn": {"subtitle": "你会按下它吗？", "sound": "sounds/vo_1600201_20_6030.wav"}, "en": {"subtitle": "你会按下它吗？", "sound": "sounds/en_vo_1600201_20_6030.wav"}}, "motion": {"group": "Idle", "index": 1, "actionId": "idle2", "label": "注视2", "duration": 6.0}}, {"step": 122, "action": "l2dcg", "speaker": "面试官", "subtitle": "很符合我对你的心理侧写……", "voiceId": "16010883", "audioName": "vo_1600201_21_6030", "voices": {"cn": {"subtitle": "很符合我对你的心理侧写……", "sound": "sounds/vo_1600201_21_6030.wav"}, "en": {"subtitle": "很符合我对你的心理侧写……", "sound": "sounds/en_vo_1600201_21_6030.wav"}}, "motion": {"group": "Idle", "index": 2, "actionId": "idle3", "label": "idle3", "duration": 6.0}}, {"step": 125, "action": "l2dcg", "speaker": "面试官", "subtitle": "很符合我对你的心理侧写……", "voiceId": "16010883", "audioName": "vo_1600201_21_6030", "voices": {"cn": {"subtitle": "很符合我对你的心理侧写……", "sound": "sounds/vo_1600201_21_6030.wav"}, "en": {"subtitle": "很符合我对你的心理侧写……", "sound": "sounds/en_vo_1600201_21_6030.wav"}}, "motion": {"group": "Idle", "index": 2, "actionId": "idle3", "label": "idle3", "duration": 6.0}}, {"step": 128, "action": "l2dcg", "speaker": "面试官", "subtitle": "很符合我对你的心理侧写……", "voiceId": "16010883", "audioName": "vo_1600201_21_6030", "voices": {"cn": {"subtitle": "很符合我对你的心理侧写……", "sound": "sounds/vo_1600201_21_6030.wav"}, "en": {"subtitle": "很符合我对你的心理侧写……", "sound": "sounds/en_vo_1600201_21_6030.wav"}}, "motion": {"group": "Idle", "index": 2, "actionId": "idle3", "label": "idle3", "duration": 6.0}}, {"step": 131, "action": "l2dcg", "speaker": "面试官", "subtitle": "很符合我对你的心理侧写……", "voiceId": "16010883", "audioName": "vo_1600201_21_6030", "voices": {"cn": {"subtitle": "很符合我对你的心理侧写……", "sound": "sounds/vo_1600201_21_6030.wav"}, "en": {"subtitle": "很符合我对你的心理侧写……", "sound": "sounds/en_vo_1600201_21_6030.wav"}}, "motion": {"group": "Idle", "index": 2, "actionId": "idle3", "label": "idle3", "duration": 6.0}}, {"step": 133, "action": "l2dcg", "speaker": "面试官", "subtitle": "失乐园会为你提供无上限的美食，你想要的任何特色食物我们都可以为你找来。", "voiceId": "16010884", "audioName": "vo_1600201_22_6030", "voices": {"cn": {"subtitle": "失乐园会为你提供无上限的美食，你想要的任何特色食物我们都可以为你找来。", "sound": "sounds/vo_1600201_22_6030.wav"}, "en": {"subtitle": "失乐园会为你提供无上限的美食，你想要的任何特色食物我们都可以为你找来。", "sound": "sounds/en_vo_1600201_22_6030.wav"}}, "motion": {"group": "Idle", "index": 1, "actionId": "idle2", "label": "注视2", "duration": 6.0}}, {"step": 134, "action": "dialog", "speaker": "面试官", "subtitle": "但代价是只要你吃下第一口，就再也离不开这里。", "voiceId": "16013020", "audioName": "vo_1600201_22a_6030", "voices": {"cn": {"subtitle": "但代价是只要你吃下第一口，就再也离不开这里。", "sound": "sounds/vo_1600201_22a_6030.wav"}, "en": {"subtitle": "但代价是只要你吃下第一口，就再也离不开这里。", "sound": "sounds/en_vo_1600201_22a_6030.wav"}}, "motion": {"group": "Idle", "index": 1, "actionId": "idle2", "label": "注视2", "duration": 6.0}}, {"step": 135, "action": "dialog", "speaker": "面试官", "subtitle": "你会选择品尝吗？", "voiceId": "16010885", "audioName": "vo_1600201_23_6030", "voices": {"cn": {"subtitle": "你会选择品尝吗？", "sound": "sounds/vo_1600201_23_6030.wav"}, "en": {"subtitle": "你会选择品尝吗？", "sound": "sounds/en_vo_1600201_23_6030.wav"}}, "motion": {"group": "Idle", "index": 1, "actionId": "idle2", "label": "注视2", "duration": 6.0}}, {"step": 138, "action": "dialog", "speaker": "面试官", "subtitle": "好的，我已经记录下来了……", "voiceId": "16010886", "audioName": "vo_1600201_24_6030", "voices": {"cn": {"subtitle": "好的，我已经记录下来了……", "sound": "sounds/vo_1600201_24_6030.wav"}, "en": {"subtitle": "好的，我已经记录下来了……", "sound": "sounds/en_vo_1600201_24_6030.wav"}}, "motion": {"group": "Idle", "index": 1, "actionId": "idle2", "label": "注视2", "duration": 6.0}}, {"step": 141, "action": "dialog", "speaker": "面试官", "subtitle": "好的，我已经记录下来了……", "voiceId": "16010886", "audioName": "vo_1600201_24_6030", "voices": {"cn": {"subtitle": "好的，我已经记录下来了……", "sound": "sounds/vo_1600201_24_6030.wav"}, "en": {"subtitle": "好的，我已经记录下来了……", "sound": "sounds/en_vo_1600201_24_6030.wav"}}, "motion": {"group": "Idle", "index": 1, "actionId": "idle2", "label": "注视2", "duration": 6.0}}, {"step": 144, "action": "dialog", "speaker": "面试官", "subtitle": "好的，我已经记录下来了……", "voiceId": "16010886", "audioName": "vo_1600201_24_6030", "voices": {"cn": {"subtitle": "好的，我已经记录下来了……", "sound": "sounds/vo_1600201_24_6030.wav"}, "en": {"subtitle": "好的，我已经记录下来了……", "sound": "sounds/en_vo_1600201_24_6030.wav"}}, "motion": {"group": "Idle", "index": 1, "actionId": "idle2", "label": "注视2", "duration": 6.0}}, {"step": 147, "action": "dialog", "speaker": "面试官", "subtitle": "好的，我已经记录下来了……", "voiceId": "16010886", "audioName": "vo_1600201_24_6030", "voices": {"cn": {"subtitle": "好的，我已经记录下来了……", "sound": "sounds/vo_1600201_24_6030.wav"}, "en": {"subtitle": "好的，我已经记录下来了……", "sound": "sounds/en_vo_1600201_24_6030.wav"}}, "motion": {"group": "Idle", "index": 1, "actionId": "idle2", "label": "注视2", "duration": 6.0}}, {"step": 149, "action": "l2dcg", "speaker": "面试官", "subtitle": "第七个问题，也是最后一个问题——", "voiceId": "16010887", "audioName": "vo_1600201_25_6030", "voices": {"cn": {"subtitle": "第七个问题，也是最后一个问题——", "sound": "sounds/vo_1600201_25_6030.wav"}, "en": {"subtitle": "第七个问题，也是最后一个问题——", "sound": "sounds/en_vo_1600201_25_6030.wav"}}, "motion": {"group": "Idle", "index": 2, "actionId": "idle3", "label": "idle3", "duration": 6.0}}, {"step": 150, "action": "dialog", "speaker": "面试官", "subtitle": "失乐园中最具魅力的明星选手向你释放了暧昧信号，这能为你带来巨大关注度，但也意味着，你将踏入复杂的情感博弈场。", "voiceId": "16010888", "audioName": "vo_1600201_26_6030", "voices": {"cn": {"subtitle": "失乐园中最具魅力的明星选手向你释放了暧昧信号，这能为你带来巨大关注度，但也意味着，你将踏入复杂的情感博弈场。", "sound": "sounds/vo_1600201_26_6030.wav"}, "en": {"subtitle": "失乐园中最具魅力的明星选手向你释放了暧昧信号，这能为你带来巨大关注度，但也意味着，你将踏入复杂的情感博弈场。", "sound": "sounds/en_vo_1600201_26_6030.wav"}}, "motion": {"group": "Idle", "index": 2, "actionId": "idle3", "label": "idle3", "duration": 6.0}}, {"step": 151, "action": "dialog", "speaker": "面试官", "subtitle": "你会接受这个邀约吗？", "voiceId": "16010889", "audioName": "vo_1600201_27_6030", "voices": {"cn": {"subtitle": "你会接受这个邀约吗？", "sound": "sounds/vo_1600201_27_6030.wav"}, "en": {"subtitle": "你会接受这个邀约吗？", "sound": "sounds/en_vo_1600201_27_6030.wav"}}, "motion": {"group": "Idle", "index": 2, "actionId": "idle3", "label": "idle3", "duration": 6.0}}, {"step": 154, "action": "l2dcg", "speaker": "面试官", "subtitle": "所有答案记录完毕……让我看看……", "voiceId": "16010890", "audioName": "vo_1600201_28_6030", "voices": {"cn": {"subtitle": "所有答案记录完毕……让我看看……", "sound": "sounds/vo_1600201_28_6030.wav"}, "en": {"subtitle": "所有答案记录完毕……让我看看……", "sound": "sounds/en_vo_1600201_28_6030.wav"}}, "motion": {"group": "Idle", "index": 1, "actionId": "idle2", "label": "注视2", "duration": 6.0}}, {"step": 157, "action": "l2dcg", "speaker": "面试官", "subtitle": "所有答案记录完毕……让我看看……", "voiceId": "16010890", "audioName": "vo_1600201_28_6030", "voices": {"cn": {"subtitle": "所有答案记录完毕……让我看看……", "sound": "sounds/vo_1600201_28_6030.wav"}, "en": {"subtitle": "所有答案记录完毕……让我看看……", "sound": "sounds/en_vo_1600201_28_6030.wav"}}, "motion": {"group": "Idle", "index": 1, "actionId": "idle2", "label": "注视2", "duration": 6.0}}, {"step": 160, "action": "l2dcg", "speaker": "面试官", "subtitle": "所有答案记录完毕……让我看看……", "voiceId": "16010890", "audioName": "vo_1600201_28_6030", "voices": {"cn": {"subtitle": "所有答案记录完毕……让我看看……", "sound": "sounds/vo_1600201_28_6030.wav"}, "en": {"subtitle": "所有答案记录完毕……让我看看……", "sound": "sounds/en_vo_1600201_28_6030.wav"}}, "motion": {"group": "Idle", "index": 1, "actionId": "idle2", "label": "注视2", "duration": 6.0}}, {"step": 163, "action": "l2dcg", "speaker": "面试官", "subtitle": "所有答案记录完毕……让我看看……", "voiceId": "16010890", "audioName": "vo_1600201_28_6030", "voices": {"cn": {"subtitle": "所有答案记录完毕……让我看看……", "sound": "sounds/vo_1600201_28_6030.wav"}, "en": {"subtitle": "所有答案记录完毕……让我看看……", "sound": "sounds/en_vo_1600201_28_6030.wav"}}, "motion": {"group": "Idle", "index": 1, "actionId": "idle2", "label": "注视2", "duration": 6.0}}]}],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 6.0 },
          { group: "Idle", index: 1, actionId: "idle2", label: "注视2", duration: 6.0 },
          { group: "Idle", index: 2, actionId: "idle3", label: "idle3", duration: 6.0 },
          { group: "Idle", index: 3, actionId: "idle4", label: "idle4", duration: 6.0 }
        ]
      },
      {
        label: "TapBody",
        actions: [
          { group: "TapBody", index: 0, actionId: "fangjianli", label: "fangjianli", duration: 3.0 },
          { group: "TapBody", index: 1, actionId: "kanjianli", label: "kanjianli", duration: 6.533 }
        ]
      }
    ],
    clickShowActions: [
      {
        showId: 35,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1600107 step 35",
        group: "Idle",
        index: 0,
        actionId: "idle",
        label: "默认 (5)",
        duration: 6.0,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 5
      },
      {
        showId: 47,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1600107 step 47",
        group: "TapBody",
        index: 1,
        actionId: "kanjianli",
        label: "kanjianli (11)",
        duration: 6.533,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 11
      },
      {
        showId: 47,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1600107 step 47",
        group: "Idle",
        index: 1,
        actionId: "idle2",
        label: "注视2 (11)",
        duration: 6.0,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 11
      },
      {
        showId: 52,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1600107 step 52",
        group: "TapBody",
        index: 0,
        actionId: "fangjianli",
        label: "fangjianli (16)",
        duration: 3.0,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 16
      },
      {
        showId: 84,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1600107 step 84",
        group: "Idle",
        index: 3,
        actionId: "idle4",
        label: "idle4",
        duration: 6.0,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 1
      },
      {
        showId: 132,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1600107 step 132",
        group: "Idle",
        index: 2,
        actionId: "idle3",
        label: "idle3 (15)",
        duration: 6.0,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 15
      }
    ]
  },
  {
    id: "200093_l2d",
    title: "剧情CG 200093",
    assetKind: "storycg",
    categoryLabel: "剧情CG",
    modelDir: "200093_l2d",
    sourceModelDir: "200093_l2d",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "localassets_win32",
    styleId: "",
    styleName: "剧情CG 200093",
    stage: "剧情CG",
    hitAreaNames: ["HitAreaBody"],
    followConfigs: [],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [{"id": "t_story_1600116:200093:1", "story": "t_story_1600116", "label": "剧情片段 1 · 5 句", "startStep": 18, "endStep": 38, "cues": [{"step": 23, "action": "dialog", "speaker": "愚者", "subtitle": "有必要吗？", "voiceId": "16010814", "audioName": "vo_1600116_02_6004", "voices": {"cn": {"subtitle": "有必要吗？", "sound": "sounds/vo_1600116_02_6004.wav"}, "en": {"subtitle": "有必要吗？", "sound": "sounds/en_vo_1600116_02_6004.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle", "label": "默认", "duration": 3.967}}, {"step": 26, "action": "dialog", "speaker": "愚者", "subtitle": "不，还没到时候。", "voiceId": "16010815", "audioName": "vo_1600116_03_6004", "voices": {"cn": {"subtitle": "不，还没到时候。", "sound": "sounds/vo_1600116_03_6004.wav"}, "en": {"subtitle": "不，还没到时候。", "sound": "sounds/en_vo_1600116_03_6004.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle", "label": "默认", "duration": 3.967}}, {"step": 27, "action": "dialog", "speaker": "愚者", "subtitle": "在我们还没有步入教堂前，我们不会走到那一步的。", "voiceId": "16010816", "audioName": "vo_1600116_04_6004", "voices": {"cn": {"subtitle": "在我们还没有步入教堂前，我们不会走到那一步的。", "sound": "sounds/vo_1600116_04_6004.wav"}, "en": {"subtitle": "在我们还没有步入教堂前，我们不会走到那一步的。", "sound": "sounds/en_vo_1600116_04_6004.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle", "label": "默认", "duration": 3.967}}, {"step": 28, "action": "dialog", "speaker": "愚者", "subtitle": "即使你真的扣下扳机，命运的子弹也不会命中我的心脏。", "voiceId": "16010817", "audioName": "vo_1600116_05_6004", "voices": {"cn": {"subtitle": "即使你真的扣下扳机，命运的子弹也不会命中我的心脏。", "sound": "sounds/vo_1600116_05_6004.wav"}, "en": {"subtitle": "即使你真的扣下扳机，命运的子弹也不会命中我的心脏。", "sound": "sounds/en_vo_1600116_05_6004.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle", "label": "默认", "duration": 3.967}}, {"step": 30, "action": "dialog", "speaker": "愚者", "subtitle": "很多人都对我这么说过，但只有你的话让我格外心痛。", "voiceId": "16010818", "audioName": "vo_1600116_06_6004", "voices": {"cn": {"subtitle": "很多人都对我这么说过，但只有你的话让我格外心痛。", "sound": "sounds/vo_1600116_06_6004.wav"}, "en": {"subtitle": "很多人都对我这么说过，但只有你的话让我格外心痛。", "sound": "sounds/en_vo_1600116_06_6004.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle", "label": "默认", "duration": 3.967}}]}],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 3.967 }
        ]
      },
      {
        label: "TapBody",
        actions: [
          { group: "TapBody", index: 0, actionId: "kaiqiang", label: "kaiqiang", duration: 4.5 },
          { group: "TapBody", index: 1, actionId: "kaiqiang2", label: "kaiqiang2", duration: 0.97 },
          { group: "TapBody", index: 2, actionId: "kaiqiang_loop", label: "kaiqiang_loop", duration: 3.97 },
          { group: "TapBody", index: 3, actionId: "loop", label: "loop", duration: 15.97 },
          { group: "TapBody", index: 4, actionId: "weixiao", label: "weixiao", duration: 3.97 },
          { group: "TapBody", index: 5, actionId: "weixiao_loop", label: "weixiao_loop", duration: 3.97 }
        ]
      }
    ],
    clickShowActions: [
      {
        showId: 18,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1600116 step 18",
        group: "Idle",
        index: 0,
        actionId: "idle",
        label: "默认",
        duration: 3.967,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 1
      },
      {
        showId: 37,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1600116 step 37",
        group: "TapBody",
        index: 1,
        actionId: "kaiqiang2",
        label: "kaiqiang2",
        duration: 0.97,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 1
      }
    ]
  },
  {
    id: "200095_l2d",
    title: "剧情CG 200095",
    assetKind: "storycg",
    categoryLabel: "剧情CG",
    modelDir: "200095_l2d",
    sourceModelDir: "200095_l2d",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "localassets_win32",
    styleId: "",
    styleName: "剧情CG 200095",
    stage: "剧情CG",
    hitAreaNames: ["HitAreaBody"],
    followConfigs: [],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "TapBody",
        actions: [
          { group: "TapBody", index: 0, actionId: "fangsong_loop", label: "fangsong_loop", duration: 3.967 },
          { group: "TapBody", index: 1, actionId: "kaiqiang", label: "kaiqiang", duration: 0.7 },
          { group: "TapBody", index: 2, actionId: "kaiqiang_loop", label: "kaiqiang_loop", duration: 3.967 },
          { group: "TapBody", index: 3, actionId: "miaozhun", label: "miaozhun", duration: 0.367 }
        ]
      }
    ],
    clickShowActions: [

    ]
  },
  {
    id: "200096_l2d",
    title: "剧情CG 200096",
    assetKind: "storycg",
    categoryLabel: "剧情CG",
    modelDir: "200096_l2d",
    sourceModelDir: "200096_l2d",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "localassets_win32",
    styleId: "",
    styleName: "剧情CG 200096",
    stage: "剧情CG",
    hitAreaNames: ["HitAreaBody"],
    followConfigs: [],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 10.0 }
        ]
      },
      {
        label: "TapBody",
        actions: [
          { group: "TapBody", index: 0, actionId: "weixiao", label: "weixiao", duration: 10.0 }
        ]
      },
      {
        label: "入场",
        actions: [
          { group: "Entry", index: 0, actionId: "ruchang", label: "入场", duration: 13.4 }
        ]
      }
    ],
    clickShowActions: [

    ]
  },
  {
    id: "200099_l2d",
    title: "剧情CG 200099",
    assetKind: "storycg",
    categoryLabel: "剧情CG",
    modelDir: "200099_l2d",
    sourceModelDir: "200099_l2d",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "localassets_win32",
    styleId: "",
    styleName: "剧情CG 200099",
    stage: "剧情CG",
    hitAreaNames: ["HitAreaBody"],
    followConfigs: [],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "TapBody",
        actions: [
          { group: "TapBody", index: 0, actionId: "shenshou", label: "shenshou", duration: 2.367 },
          { group: "TapBody", index: 1, actionId: "shoushou", label: "shoushou", duration: 2.133 },
          { group: "TapBody", index: 2, actionId: "tuijin", label: "tuijin", duration: 3.033 }
        ]
      }
    ],
    clickShowActions: [
      {
        showId: 94,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1600103 step 94",
        group: "TapBody",
        index: 2,
        actionId: "tuijin",
        label: "tuijin",
        duration: 3.033,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 1
      },
      {
        showId: 105,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1600103 step 105",
        group: "TapBody",
        index: 0,
        actionId: "shenshou",
        label: "shenshou",
        duration: 2.367,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 1
      }
    ]
  },
  {
    id: "200103_l2d",
    title: "剧情CG 200103_l2d",
    assetKind: "storycg",
    categoryLabel: "剧情CG",
    modelDir: "200103_l2d",
    sourceModelDir: "200103_l2d",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "localassets_win32",
    styleId: "",
    styleName: "剧情CG 200103_l2d",
    stage: "剧情CG候选",
    hitAreaNames: ["HitAreaBody"],
    followConfigs: [],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 6.0 }
        ]
      }
    ],
    clickShowActions: [

    ]
  },
  {
    id: "200110_l2d",
    title: "剧情CG 200110",
    assetKind: "storycg",
    categoryLabel: "剧情CG",
    modelDir: "200110_l2d",
    sourceModelDir: "200110_l2d",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "localassets_win32",
    styleId: "",
    styleName: "剧情CG 200110",
    stage: "剧情CG",
    hitAreaNames: ["HitAreaBody"],
    followConfigs: [],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [{"id": "t_story_1100216:200110:1", "story": "t_story_1100216", "label": "剧情片段 1 · 1 句", "startStep": 133, "endStep": 140, "cues": [{"step": 139, "action": "dialog", "speaker": "青年暴君", "subtitle": "我能。", "voiceId": "15020587", "audioName": "vo_1100216_35_6013", "voices": {"cn": {"subtitle": "我能。", "sound": "sounds/vo_1100216_35_6013.wav"}, "en": {"subtitle": "我能。", "sound": "sounds/en_vo_1100216_35_6013.wav"}}, "motion": {"group": "TapBody", "index": 2, "actionId": "chanfen2_loop", "label": "chanfen2_loop", "duration": 3.967}}]}],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "TapBody",
        actions: [
          { group: "TapBody", index: 0, actionId: "chanfen1", label: "chanfen1", duration: 3.967 },
          { group: "TapBody", index: 1, actionId: "chanfen2", label: "chanfen2", duration: 10.3 },
          { group: "TapBody", index: 2, actionId: "chanfen2_loop", label: "chanfen2_loop", duration: 3.967 },
          { group: "TapBody", index: 3, actionId: "loop", label: "loop", duration: 3.3 }
        ]
      }
    ],
    clickShowActions: [
      {
        showId: 133,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1100216 step 133",
        group: "TapBody",
        index: 0,
        actionId: "chanfen1",
        label: "chanfen1",
        duration: 3.967,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 1
      },
      {
        showId: 133,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1100216 step 133",
        group: "TapBody",
        index: 3,
        actionId: "loop",
        label: "loop",
        duration: 3.3,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 1
      },
      {
        showId: 138,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1100216 step 138",
        group: "TapBody",
        index: 1,
        actionId: "chanfen2",
        label: "chanfen2",
        duration: 10.3,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 1
      },
      {
        showId: 138,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1100216 step 138",
        group: "TapBody",
        index: 2,
        actionId: "chanfen2_loop",
        label: "chanfen2_loop",
        duration: 3.967,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 1
      }
    ]
  },
  {
    id: "200112_l2d",
    title: "剧情CG 200112",
    assetKind: "storycg",
    categoryLabel: "剧情CG",
    modelDir: "200112_l2d",
    sourceModelDir: "200112_l2d",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "localassets_win32",
    styleId: "",
    styleName: "剧情CG 200112",
    stage: "剧情CG",
    hitAreaNames: ["HitAreaBody"],
    followConfigs: [],
    hideGroups: [],
    ambientMotion: { group: "TapBody", index: 6, actionId: "loop", label: "loop", duration: 4.0 },
    storySegments: [{"id": "t_story_1600205:200112:1", "story": "t_story_1600205", "label": "剧情片段 1 · 6 句", "startStep": 220, "endStep": 246, "cues": [{"step": 226, "action": "dialog", "speaker": "诺亚", "subtitle": "我真的很失败吗？", "voiceId": "16011155", "audioName": "vo_1600205_60_6030", "voices": {"cn": {"subtitle": "我真的很失败吗？", "sound": "sounds/vo_1600205_60_6030.wav"}, "en": {"subtitle": "我真的很失败吗？", "sound": "sounds/en_vo_1600205_60_6030.wav"}}, "motion": {"group": "TapBody", "index": 1, "actionId": "chafen1_loop", "label": "chafen1_loop", "duration": 4.0}}, {"step": 232, "action": "dialog", "speaker": "诺亚", "subtitle": "……从来没人对我说过这些。", "voiceId": "16011156", "audioName": "vo_1600205_61_6030", "voices": {"cn": {"subtitle": "……从来没人对我说过这些。", "sound": "sounds/vo_1600205_61_6030.wav"}, "en": {"subtitle": "……从来没人对我说过这些。", "sound": "sounds/en_vo_1600205_61_6030.wav"}}, "motion": {"group": "TapBody", "index": 3, "actionId": "chafen2_loop", "label": "chafen2_loop", "duration": 4.0}}, {"step": 233, "action": "dialog", "speaker": "诺亚", "subtitle": "如果、如果那时候……你真的存在就好了。", "voiceId": "16011157", "audioName": "vo_1600205_62_6030", "voices": {"cn": {"subtitle": "如果、如果那时候……你真的存在就好了。", "sound": "sounds/vo_1600205_62_6030.wav"}, "en": {"subtitle": "如果、如果那时候……你真的存在就好了。", "sound": "sounds/en_vo_1600205_62_6030.wav"}}, "motion": {"group": "TapBody", "index": 3, "actionId": "chafen2_loop", "label": "chafen2_loop", "duration": 4.0}}, {"step": 237, "action": "dialog", "speaker": "诺亚", "subtitle": "夜晚来临了，太阳要落山了。", "voiceId": "16011158", "audioName": "vo_1600205_63_6030", "voices": {"cn": {"subtitle": "夜晚来临了，太阳要落山了。", "sound": "sounds/vo_1600205_63_6030.wav"}, "en": {"subtitle": "夜晚来临了，太阳要落山了。", "sound": "sounds/en_vo_1600205_63_6030.wav"}}, "motion": {"group": "TapBody", "index": 3, "actionId": "chafen2_loop", "label": "chafen2_loop", "duration": 4.0}}, {"step": 239, "action": "dialog", "speaker": "诺亚", "subtitle": "那等到明天，我应该去哪里找你？", "voiceId": "16011159", "audioName": "vo_1600205_64_6030", "voices": {"cn": {"subtitle": "那等到明天，我应该去哪里找你？", "sound": "sounds/vo_1600205_64_6030.wav"}, "en": {"subtitle": "那等到明天，我应该去哪里找你？", "sound": "sounds/en_vo_1600205_64_6030.wav"}}, "motion": {"group": "TapBody", "index": 3, "actionId": "chafen2_loop", "label": "chafen2_loop", "duration": 4.0}}, {"step": 240, "action": "dialog", "speaker": "诺亚", "subtitle": "下一次，你会在什么时候出现？", "voiceId": "16011160", "audioName": "vo_1600205_65_6030", "voices": {"cn": {"subtitle": "下一次，你会在什么时候出现？", "sound": "sounds/vo_1600205_65_6030.wav"}, "en": {"subtitle": "下一次，你会在什么时候出现？", "sound": "sounds/en_vo_1600205_65_6030.wav"}}, "motion": {"group": "TapBody", "index": 3, "actionId": "chafen2_loop", "label": "chafen2_loop", "duration": 4.0}}]}],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 4.0 }
        ]
      },
      {
        label: "TapBody",
        actions: [
          { group: "TapBody", index: 0, actionId: "chafen1", label: "chafen1", duration: 4.0 },
          { group: "TapBody", index: 1, actionId: "chafen1_loop", label: "chafen1_loop", duration: 4.0 },
          { group: "TapBody", index: 2, actionId: "chafen2", label: "chafen2", duration: 4.0 },
          { group: "TapBody", index: 3, actionId: "chafen2_loop", label: "chafen2_loop", duration: 4.0 },
          { group: "TapBody", index: 4, actionId: "chafen3", label: "chafen3", duration: 4.0 },
          { group: "TapBody", index: 5, actionId: "chafen3_loop", label: "chafen3_loop", duration: 4.0 },
          { group: "TapBody", index: 6, actionId: "loop", label: "loop", duration: 4.0 }
        ]
      },
      {
        label: "入场",
        actions: [
          { group: "Entry", index: 0, actionId: "ruchang", label: "入场", duration: 3.0 }
        ]
      }
    ],
    clickShowActions: [
      {
        showId: 220,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1600205 step 220",
        group: "Entry",
        index: 0,
        actionId: "ruchang",
        label: "入场",
        duration: 3.0,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 1
      },
      {
        showId: 220,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1600205 step 220",
        group: "Idle",
        index: 0,
        actionId: "idle",
        label: "默认",
        duration: 4.0,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 1
      },
      {
        showId: 225,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1600205 step 225",
        group: "TapBody",
        index: 0,
        actionId: "chafen1",
        label: "chafen1",
        duration: 4.0,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 1
      },
      {
        showId: 225,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1600205 step 225",
        group: "TapBody",
        index: 1,
        actionId: "chafen1_loop",
        label: "chafen1_loop",
        duration: 4.0,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 1
      },
      {
        showId: 231,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1600205 step 231",
        group: "TapBody",
        index: 2,
        actionId: "chafen2",
        label: "chafen2",
        duration: 4.0,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 1
      },
      {
        showId: 231,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1600205 step 231",
        group: "TapBody",
        index: 3,
        actionId: "chafen2_loop",
        label: "chafen2_loop",
        duration: 4.0,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 1
      },
      {
        showId: 242,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1600205 step 242",
        group: "TapBody",
        index: 4,
        actionId: "chafen3",
        label: "chafen3",
        duration: 4.0,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 1
      },
      {
        showId: 242,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1600205 step 242",
        group: "TapBody",
        index: 5,
        actionId: "chafen3_loop",
        label: "chafen3_loop",
        duration: 4.0,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 1
      }
    ]
  },
  {
    id: "200113_l2d",
    title: "剧情CG 200113",
    assetKind: "storycg",
    categoryLabel: "剧情CG",
    modelDir: "200113_l2d",
    sourceModelDir: "200113_l2d",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "localassets_win32",
    styleId: "",
    styleName: "剧情CG 200113",
    stage: "剧情CG",
    hitAreaNames: ["HitAreaBody"],
    followConfigs: [],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [{"id": "t_story_1600215:200113:1", "story": "t_story_1600215", "label": "剧情片段 1 · 28 句", "startStep": 8, "endStep": 64, "cues": [{"step": 10, "action": "dialog", "speaker": "NG", "subtitle": "好看吗？", "voiceId": "16011557", "audioName": "vo_1600215_01_6030", "voices": {"cn": {"subtitle": "好看吗？", "sound": "sounds/vo_1600215_01_6030.wav"}, "en": {"subtitle": "好看吗？", "sound": "sounds/en_vo_1600215_01_6030.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle", "label": "默认", "duration": 10.0}}, {"step": 13, "action": "dialog", "speaker": "NG", "subtitle": "这是我的代表作，哦，不是电影，是纪录片。", "voiceId": "16011558", "audioName": "vo_1600215_02_6030", "voices": {"cn": {"subtitle": "这是我的代表作，哦，不是电影，是纪录片。", "sound": "sounds/vo_1600215_02_6030.wav"}, "en": {"subtitle": "这是我的代表作，哦，不是电影，是纪录片。", "sound": "sounds/en_vo_1600215_02_6030.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle", "label": "默认", "duration": 10.0}}, {"step": 14, "action": "dialog", "speaker": "NG", "subtitle": "从某种意义上来说，它非常能代表这个国家……", "voiceId": "16011559", "audioName": "vo_1600215_03_6030", "voices": {"cn": {"subtitle": "从某种意义上来说，它非常能代表这个国家……", "sound": "sounds/vo_1600215_03_6030.wav"}, "en": {"subtitle": "从某种意义上来说，它非常能代表这个国家……", "sound": "sounds/en_vo_1600215_03_6030.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle", "label": "默认", "duration": 10.0}}, {"step": 15, "action": "dialog", "speaker": "NG", "subtitle": "就如同我的存在是娱乐至死的象征。", "voiceId": "16013053", "audioName": "vo_1600215_03a_6030", "voices": {"cn": {"subtitle": "就如同我的存在是娱乐至死的象征。", "sound": "sounds/vo_1600215_03a_6030.wav"}, "en": {"subtitle": "就如同我的存在是娱乐至死的象征。", "sound": "sounds/en_vo_1600215_03a_6030.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle", "label": "默认", "duration": 10.0}}, {"step": 16, "action": "dialog", "speaker": "NG", "subtitle": "我苟延残喘的生命是这个罪恶国度滋生的腐烂种子，长出了绝望的花。", "voiceId": "16011560", "audioName": "vo_1600215_04_6030", "voices": {"cn": {"subtitle": "我苟延残喘的生命是这个罪恶国度滋生的腐烂种子，长出了绝望的花。", "sound": "sounds/vo_1600215_04_6030.wav"}, "en": {"subtitle": "我苟延残喘的生命是这个罪恶国度滋生的腐烂种子，长出了绝望的花。", "sound": "sounds/en_vo_1600215_04_6030.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle", "label": "默认", "duration": 10.0}}, {"step": 17, "action": "dialog", "speaker": "NG", "subtitle": "不那么美，但很值得一看，对吧？", "voiceId": "16011561", "audioName": "vo_1600215_05_6030", "voices": {"cn": {"subtitle": "不那么美，但很值得一看，对吧？", "sound": "sounds/vo_1600215_05_6030.wav"}, "en": {"subtitle": "不那么美，但很值得一看，对吧？", "sound": "sounds/en_vo_1600215_05_6030.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle", "label": "默认", "duration": 10.0}}, {"step": 21, "action": "dialog", "speaker": "NG", "subtitle": "所以……多看看我吧……", "voiceId": "16011562", "audioName": "vo_1600215_06_6030", "voices": {"cn": {"subtitle": "所以……多看看我吧……", "sound": "sounds/vo_1600215_06_6030.wav"}, "en": {"subtitle": "所以……多看看我吧……", "sound": "sounds/en_vo_1600215_06_6030.wav"}}, "motion": {"group": "TapBody", "index": 1, "actionId": "chafen1_loop", "label": "chafen1_loop", "duration": 10.0}}, {"step": 24, "action": "dialog", "speaker": "NG", "subtitle": "我为什么要生气？", "voiceId": "16011563", "audioName": "vo_1600215_07_6030", "voices": {"cn": {"subtitle": "我为什么要生气？", "sound": "sounds/vo_1600215_07_6030.wav"}, "en": {"subtitle": "我为什么要生气？", "sound": "sounds/en_vo_1600215_07_6030.wav"}}, "motion": {"group": "TapBody", "index": 1, "actionId": "chafen1_loop", "label": "chafen1_loop", "duration": 10.0}}, {"step": 25, "action": "dialog", "speaker": "NG", "subtitle": "计划被破坏只能说明那是一个失败的脚本。没有应急预案，不值得排播。", "voiceId": "16011564", "audioName": "vo_1600215_08_6030", "voices": {"cn": {"subtitle": "计划被破坏只能说明那是一个失败的脚本。没有应急预案，不值得排播。", "sound": "sounds/vo_1600215_08_6030.wav"}, "en": {"subtitle": "计划被破坏只能说明那是一个失败的脚本。没有应急预案，不值得排播。", "sound": "sounds/en_vo_1600215_08_6030.wav"}}, "motion": {"group": "TapBody", "index": 1, "actionId": "chafen1_loop", "label": "chafen1_loop", "duration": 10.0}}, {"step": 26, "action": "dialog", "speaker": "NG", "subtitle": "它的可看性哪里比得上你关门的那瞬间呢？", "voiceId": "16011565", "audioName": "vo_1600215_09_6030", "voices": {"cn": {"subtitle": "它的可看性哪里比得上你关门的那瞬间呢？", "sound": "sounds/vo_1600215_09_6030.wav"}, "en": {"subtitle": "它的可看性哪里比得上你关门的那瞬间呢？", "sound": "sounds/en_vo_1600215_09_6030.wav"}}, "motion": {"group": "TapBody", "index": 1, "actionId": "chafen1_loop", "label": "chafen1_loop", "duration": 10.0}}, {"step": 28, "action": "dialog", "speaker": "NG", "subtitle": "我一直都疯着。", "voiceId": "16011566", "audioName": "vo_1600215_10_6030", "voices": {"cn": {"subtitle": "我一直都疯着。", "sound": "sounds/vo_1600215_10_6030.wav"}, "en": {"subtitle": "我一直都疯着。", "sound": "sounds/en_vo_1600215_10_6030.wav"}}, "motion": {"group": "TapBody", "index": 1, "actionId": "chafen1_loop", "label": "chafen1_loop", "duration": 10.0}}, {"step": 29, "action": "dialog", "speaker": "NG", "subtitle": "在世界这个舞台里扮演早就被写好结局的角色，我早就忍受够了！", "voiceId": "16011567", "audioName": "vo_1600215_11_6030", "voices": {"cn": {"subtitle": "在世界这个舞台里扮演早就被写好结局的角色，我早就忍受够了！", "sound": "sounds/vo_1600215_11_6030.wav"}, "en": {"subtitle": "在世界这个舞台里扮演早就被写好结局的角色，我早就忍受够了！", "sound": "sounds/en_vo_1600215_11_6030.wav"}}, "motion": {"group": "TapBody", "index": 1, "actionId": "chafen1_loop", "label": "chafen1_loop", "duration": 10.0}}, {"step": 30, "action": "dialog", "speaker": "NG", "subtitle": "我曾经以为没人能打破它，但你做到了！", "voiceId": "16011568", "audioName": "vo_1600215_12_6030", "voices": {"cn": {"subtitle": "我曾经以为没人能打破它，但你做到了！", "sound": "sounds/vo_1600215_12_6030.wav"}, "en": {"subtitle": "我曾经以为没人能打破它，但你做到了！", "sound": "sounds/en_vo_1600215_12_6030.wav"}}, "motion": {"group": "TapBody", "index": 1, "actionId": "chafen1_loop", "label": "chafen1_loop", "duration": 10.0}}, {"step": 31, "action": "dialog", "speaker": "NG", "subtitle": "你是那个唯一可以打破剧本的人……", "voiceId": "16011569", "audioName": "vo_1600215_13_6030", "voices": {"cn": {"subtitle": "你是那个唯一可以打破剧本的人……", "sound": "sounds/vo_1600215_13_6030.wav"}, "en": {"subtitle": "你是那个唯一可以打破剧本的人……", "sound": "sounds/en_vo_1600215_13_6030.wav"}}, "motion": {"group": "TapBody", "index": 1, "actionId": "chafen1_loop", "label": "chafen1_loop", "duration": 10.0}}, {"step": 32, "action": "dialog", "speaker": "NG", "subtitle": "你是可以赢得世界这场真人秀的人！", "voiceId": "16011570", "audioName": "vo_1600215_14_6030", "voices": {"cn": {"subtitle": "你是可以赢得世界这场真人秀的人！", "sound": "sounds/vo_1600215_14_6030.wav"}, "en": {"subtitle": "你是可以赢得世界这场真人秀的人！", "sound": "sounds/en_vo_1600215_14_6030.wav"}}, "motion": {"group": "TapBody", "index": 1, "actionId": "chafen1_loop", "label": "chafen1_loop", "duration": 10.0}}, {"step": 36, "action": "dialog", "speaker": "NG", "subtitle": "那就由你来赐我死亡吧……", "voiceId": "16011571", "audioName": "vo_1600215_15_6030", "voices": {"cn": {"subtitle": "那就由你来赐我死亡吧……", "sound": "sounds/vo_1600215_15_6030.wav"}, "en": {"subtitle": "那就由你来赐我死亡吧……", "sound": "sounds/en_vo_1600215_15_6030.wav"}}, "motion": {"group": "Idle", "index": 1, "actionId": "idle1", "label": "注视1", "duration": 10.0}}, {"step": 37, "action": "dialog", "speaker": "NG", "subtitle": "富有戏剧性的、刻骨铭心的、永恒的死亡！", "voiceId": "16013054", "audioName": "vo_1600215_15a_6030", "voices": {"cn": {"subtitle": "富有戏剧性的、刻骨铭心的、永恒的死亡！", "sound": "sounds/vo_1600215_15a_6030.wav"}, "en": {"subtitle": "富有戏剧性的、刻骨铭心的、永恒的死亡！", "sound": "sounds/en_vo_1600215_15a_6030.wav"}}, "motion": {"group": "Idle", "index": 1, "actionId": "idle1", "label": "注视1", "duration": 10.0}}, {"step": 38, "action": "dialog", "speaker": "NG", "subtitle": "这样我就属于你啦……", "voiceId": "16013055", "audioName": "vo_1600215_15b_6030", "voices": {"cn": {"subtitle": "这样我就属于你啦……", "sound": "sounds/vo_1600215_15b_6030.wav"}, "en": {"subtitle": "这样我就属于你啦……", "sound": "sounds/en_vo_1600215_15b_6030.wav"}}, "motion": {"group": "Idle", "index": 1, "actionId": "idle1", "label": "注视1", "duration": 10.0}}, {"step": 41, "action": "dialog", "speaker": "NG", "subtitle": "用你的手握住我的脖子，慢慢收紧，让我失去声音和氧气……", "voiceId": "16011572", "audioName": "vo_1600215_16_6030", "voices": {"cn": {"subtitle": "用你的手握住我的脖子，慢慢收紧，让我失去声音和氧气……", "sound": "sounds/vo_1600215_16_6030.wav"}, "en": {"subtitle": "用你的手握住我的脖子，慢慢收紧，让我失去声音和氧气……", "sound": "sounds/en_vo_1600215_16_6030.wav"}}, "motion": {"group": "Idle", "index": 1, "actionId": "idle1", "label": "注视1", "duration": 10.0}}, {"step": 42, "action": "dialog", "speaker": "NG", "subtitle": "剖开我的肚子，把你的手伸入我的躯壳，掏出我的心……", "voiceId": "16011573", "audioName": "vo_1600215_17_6030", "voices": {"cn": {"subtitle": "剖开我的肚子，把你的手伸入我的躯壳，掏出我的心……", "sound": "sounds/vo_1600215_17_6030.wav"}, "en": {"subtitle": "剖开我的肚子，把你的手伸入我的躯壳，掏出我的心……", "sound": "sounds/en_vo_1600215_17_6030.wav"}}, "motion": {"group": "Idle", "index": 1, "actionId": "idle1", "label": "注视1", "duration": 10.0}}, {"step": 43, "action": "dialog", "speaker": "NG", "subtitle": "它会是怎样的？鲜红的、黑色的、还是万紫千红的？", "voiceId": "16011574", "audioName": "vo_1600215_18_6030", "voices": {"cn": {"subtitle": "它会是怎样的？鲜红的、黑色的、还是万紫千红的？", "sound": "sounds/vo_1600215_18_6030.wav"}, "en": {"subtitle": "它会是怎样的？鲜红的、黑色的、还是万紫千红的？", "sound": "sounds/en_vo_1600215_18_6030.wav"}}, "motion": {"group": "Idle", "index": 1, "actionId": "idle1", "label": "注视1", "duration": 10.0}}, {"step": 44, "action": "dialog", "speaker": "NG", "subtitle": "它会是一颗真心吗？它会是一颗烂苹果吗？还是说它会是一个交错纵横的宇宙？", "voiceId": "16011575", "audioName": "vo_1600215_19_6030", "voices": {"cn": {"subtitle": "它会是一颗真心吗？它会是一颗烂苹果吗？还是说它会是一个交错纵横的宇宙？", "sound": "sounds/vo_1600215_19_6030.wav"}, "en": {"subtitle": "它会是一颗真心吗？它会是一颗烂苹果吗？还是说它会是一个交错纵横的宇宙？", "sound": "sounds/en_vo_1600215_19_6030.wav"}}, "motion": {"group": "Idle", "index": 1, "actionId": "idle1", "label": "注视1", "duration": 10.0}}, {"step": 45, "action": "cameraanim", "speaker": "NG", "subtitle": "你不想看吗……你不想看吗？你不想看吗？！", "voiceId": "16011576", "audioName": "vo_1600215_20_6030", "voices": {"cn": {"subtitle": "你不想看吗……你不想看吗？你不想看吗？！", "sound": "sounds/vo_1600215_20_6030.wav"}, "en": {"subtitle": "你不想看吗……你不想看吗？你不想看吗？！", "sound": "sounds/en_vo_1600215_20_6030.wav"}}, "motion": {"group": "Idle", "index": 1, "actionId": "idle1", "label": "注视1", "duration": 10.0}}, {"step": 46, "action": "cameraanim", "speaker": "NG", "subtitle": "求求你，看看我吧，看着我吧！", "voiceId": "16011577", "audioName": "vo_1600215_21_6030", "voices": {"cn": {"subtitle": "求求你，看看我吧，看着我吧！", "sound": "sounds/vo_1600215_21_6030.wav"}, "en": {"subtitle": "求求你，看看我吧，看着我吧！", "sound": "sounds/en_vo_1600215_21_6030.wav"}}, "motion": {"group": "Idle", "index": 1, "actionId": "idle1", "label": "注视1", "duration": 10.0}}, {"step": 47, "action": "cameraanim", "speaker": "NG", "subtitle": "看着我站在这里、看着我一无是处地存在、看着我死去！", "voiceId": "16013056", "audioName": "vo_1600215_21a_6030", "voices": {"cn": {"subtitle": "看着我站在这里、看着我一无是处地存在、看着我死去！", "sound": "sounds/vo_1600215_21a_6030.wav"}, "en": {"subtitle": "看着我站在这里、看着我一无是处地存在、看着我死去！", "sound": "sounds/en_vo_1600215_21a_6030.wav"}}, "motion": {"group": "Idle", "index": 1, "actionId": "idle1", "label": "注视1", "duration": 10.0}}, {"step": 52, "action": "dialog", "speaker": "NG", "subtitle": "那什么才是？", "voiceId": "16011578", "audioName": "vo_1600215_22_6030", "voices": {"cn": {"subtitle": "那什么才是？", "sound": "sounds/vo_1600215_22_6030.wav"}, "en": {"subtitle": "那什么才是？", "sound": "sounds/en_vo_1600215_22_6030.wav"}}, "motion": {"group": "Idle", "index": 1, "actionId": "idle1", "label": "注视1", "duration": 10.0}}, {"step": 61, "action": "dialog", "speaker": "NG", "subtitle": "我会试着去做，哪怕一切都毫无用处……", "voiceId": "16011579", "audioName": "vo_1600215_23_6030", "voices": {"cn": {"subtitle": "我会试着去做，哪怕一切都毫无用处……", "sound": "sounds/vo_1600215_23_6030.wav"}, "en": {"subtitle": "我会试着去做，哪怕一切都毫无用处……", "sound": "sounds/en_vo_1600215_23_6030.wav"}}, "motion": {"group": "Idle", "index": 1, "actionId": "idle1", "label": "注视1", "duration": 10.0}}, {"step": 62, "action": "dialog", "speaker": "NG", "subtitle": "我的主角，我的缪斯……", "voiceId": "16013057", "audioName": "vo_1600215_23a_6030", "voices": {"cn": {"subtitle": "我的主角，我的缪斯……", "sound": "sounds/vo_1600215_23a_6030.wav"}, "en": {"subtitle": "我的主角，我的缪斯……", "sound": "sounds/en_vo_1600215_23a_6030.wav"}}, "motion": {"group": "Idle", "index": 1, "actionId": "idle1", "label": "注视1", "duration": 10.0}}]}],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 10.0 },
          { group: "Idle", index: 1, actionId: "idle1", label: "注视1", duration: 10.0 }
        ]
      },
      {
        label: "TapBody",
        actions: [
          { group: "TapBody", index: 0, actionId: "chafen1", label: "chafen1", duration: 10.0 },
          { group: "TapBody", index: 1, actionId: "chafen1_loop", label: "chafen1_loop", duration: 10.0 }
        ]
      }
    ],
    clickShowActions: [
      {
        showId: 8,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1600215 step 8",
        group: "Idle",
        index: 0,
        actionId: "idle",
        label: "默认",
        duration: 10.0,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 1
      },
      {
        showId: 19,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1600215 step 19",
        group: "TapBody",
        index: 0,
        actionId: "chafen1",
        label: "chafen1",
        duration: 10.0,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 1
      },
      {
        showId: 19,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1600215 step 19",
        group: "TapBody",
        index: 1,
        actionId: "chafen1_loop",
        label: "chafen1_loop",
        duration: 10.0,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 1
      },
      {
        showId: 35,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1600215 step 35",
        group: "Idle",
        index: 1,
        actionId: "idle1",
        label: "注视1",
        duration: 10.0,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 1
      }
    ]
  },
  {
    id: "200118_l2d",
    title: "剧情CG 200118",
    assetKind: "storycg",
    categoryLabel: "剧情CG",
    modelDir: "200118_l2d",
    sourceModelDir: "200118_l2d",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "streamingassets",
    styleId: "",
    styleName: "剧情CG 200118",
    stage: "剧情CG",
    hitAreaNames: ["HitAreaBody"],
    followConfigs: [],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [{"id": "t_story_1100429:200118:1", "story": "t_story_1100429", "label": "剧情片段 1 · 16 句", "startStep": 65, "endStep": 86, "cues": [{"step": 69, "action": "dialog", "speaker": "将军", "subtitle": "那是……铁马大陆的雪。", "voiceId": "15040970", "audioName": "vo_1100427_11_6008", "voices": {"cn": {"subtitle": "那是……铁马大陆的雪。", "sound": "sounds/vo_1100427_11_6008.wav"}, "en": {"subtitle": "那是……铁马大陆的雪。", "sound": "sounds/en_vo_1100427_11_6008.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle", "label": "默认", "duration": 6.467}}, {"step": 70, "action": "dialog", "speaker": "将军", "subtitle": "十八岁那年，我以为只要手里的刀够快，就能斩断所有的不公。", "voiceId": "15040971", "audioName": "vo_1100427_12_6008", "voices": {"cn": {"subtitle": "十八岁那年，我以为只要手里的刀够快，就能斩断所有的不公。", "sound": "sounds/vo_1100427_12_6008.wav"}, "en": {"subtitle": "十八岁那年，我以为只要手里的刀够快，就能斩断所有的不公。", "sound": "sounds/en_vo_1100427_12_6008.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle", "label": "默认", "duration": 6.467}}, {"step": 71, "action": "dialog", "speaker": "将军", "subtitle": "百姓在欢呼，他们叫我英雄。我以为我在保家卫国……", "voiceId": "15040972", "audioName": "vo_1100427_13_6008", "voices": {"cn": {"subtitle": "百姓在欢呼，他们叫我英雄。我以为我在保家卫国……", "sound": "sounds/vo_1100427_13_6008.wav"}, "en": {"subtitle": "百姓在欢呼，他们叫我英雄。我以为我在保家卫国……", "sound": "sounds/en_vo_1100427_13_6008.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle", "label": "默认", "duration": 6.467}}, {"step": 72, "action": "dialog", "speaker": "将军", "subtitle": "但是我错了……", "voiceId": "15040973", "audioName": "vo_1100427_14_6008", "voices": {"cn": {"subtitle": "但是我错了……", "sound": "sounds/vo_1100427_14_6008.wav"}, "en": {"subtitle": "但是我错了……", "sound": "sounds/en_vo_1100427_14_6008.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle", "label": "默认", "duration": 6.467}}, {"step": 73, "action": "dialog", "speaker": "将军", "subtitle": "只有我……只有我一个人活下来了！", "voiceId": "15041096", "audioName": "vo_1100427_14a_6008", "voices": {"cn": {"subtitle": "只有我……只有我一个人活下来了！", "sound": "sounds/vo_1100427_14a_6008.wav"}, "en": {"subtitle": "只有我……只有我一个人活下来了！", "sound": "sounds/en_vo_1100427_14a_6008.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle", "label": "默认", "duration": 6.467}}, {"step": 74, "action": "dialog", "speaker": "将军", "subtitle": "不是因为敌人太强，是因为背后的冷箭！", "voiceId": "15040974", "audioName": "vo_1100427_15_6008", "voices": {"cn": {"subtitle": "不是因为敌人太强，是因为背后的冷箭！", "sound": "sounds/vo_1100427_15_6008.wav"}, "en": {"subtitle": "不是因为敌人太强，是因为背后的冷箭！", "sound": "sounds/en_vo_1100427_15_6008.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle", "label": "默认", "duration": 6.467}}, {"step": 75, "action": "dialog", "speaker": "将军", "subtitle": "那些坐在暖房里喝酒的政客……他们忌惮我的声望，忌惮军团的力量。", "voiceId": "15040975", "audioName": "vo_1100427_16_6008", "voices": {"cn": {"subtitle": "那些坐在暖房里喝酒的政客……他们忌惮我的声望，忌惮军团的力量。", "sound": "sounds/vo_1100427_16_6008.wav"}, "en": {"subtitle": "那些坐在暖房里喝酒的政客……他们忌惮我的声望，忌惮军团的力量。", "sound": "sounds/en_vo_1100427_16_6008.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle", "label": "默认", "duration": 6.467}}, {"step": 76, "action": "dialog", "speaker": "将军", "subtitle": "一封密信，一次调度，整个部队的战士，全变成了死人！", "voiceId": "15041097", "audioName": "vo_1100427_16a_6008", "voices": {"cn": {"subtitle": "一封密信，一次调度，整个部队的战士，全变成了死人！", "sound": "sounds/vo_1100427_16a_6008.wav"}, "en": {"subtitle": "一封密信，一次调度，整个部队的战士，全变成了死人！", "sound": "sounds/en_vo_1100427_16a_6008.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle", "label": "默认", "duration": 6.467}}, {"step": 77, "action": "dialog", "speaker": "将军", "subtitle": "我带着悲痛回到故乡，等着我的是“叛军”的帽子。", "voiceId": "15040976", "audioName": "vo_1100427_17_6008", "voices": {"cn": {"subtitle": "我带着悲痛回到故乡，等着我的是“叛军”的帽子。", "sound": "sounds/vo_1100427_17_6008.wav"}, "en": {"subtitle": "我带着悲痛回到故乡，等着我的是“叛军”的帽子。", "sound": "sounds/en_vo_1100427_17_6008.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle", "label": "默认", "duration": 6.467}}, {"step": 78, "action": "dialog", "speaker": "将军", "subtitle": "那些为了保护他们而死去的战士，名字被刻在耻辱柱上，任人唾骂。", "voiceId": "15041098", "audioName": "vo_1100427_17a_6008", "voices": {"cn": {"subtitle": "那些为了保护他们而死去的战士，名字被刻在耻辱柱上，任人唾骂。", "sound": "sounds/vo_1100427_17a_6008.wav"}, "en": {"subtitle": "那些为了保护他们而死去的战士，名字被刻在耻辱柱上，任人唾骂。", "sound": "sounds/en_vo_1100427_17a_6008.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle", "label": "默认", "duration": 6.467}}, {"step": 79, "action": "dialog", "speaker": "将军", "subtitle": "所有的荣光都成了笑话，所有牺牲都变成了罪行。", "voiceId": "15040977", "audioName": "vo_1100427_18_6008", "voices": {"cn": {"subtitle": "所有的荣光都成了笑话，所有牺牲都变成了罪行。", "sound": "sounds/vo_1100427_18_6008.wav"}, "en": {"subtitle": "所有的荣光都成了笑话，所有牺牲都变成了罪行。", "sound": "sounds/en_vo_1100427_18_6008.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle", "label": "默认", "duration": 6.467}}, {"step": 80, "action": "dialog", "speaker": "将军", "subtitle": "在一个雷暴之夜，我看着幕后主使在我面前咽气。我自己也成了怪物，一个拥有了力量却失去了一切的怪物。", "voiceId": "15040978", "audioName": "vo_1100427_19_6008", "voices": {"cn": {"subtitle": "在一个雷暴之夜，我看着幕后主使在我面前咽气。我自己也成了怪物，一个拥有了力量却失去了一切的怪物。", "sound": "sounds/vo_1100427_19_6008.wav"}, "en": {"subtitle": "在一个雷暴之夜，我看着幕后主使在我面前咽气。我自己也成了怪物，一个拥有了力量却失去了一切的怪物。", "sound": "sounds/en_vo_1100427_19_6008.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle", "label": "默认", "duration": 6.467}}, {"step": 81, "action": "dialog", "speaker": "将军", "subtitle": "我逃到了米兰王国，遇到了费代丽卡女士。西西莉亚收留了我这条丧家之犬。", "voiceId": "15040979", "audioName": "vo_1100427_20_6008", "voices": {"cn": {"subtitle": "我逃到了米兰王国，遇到了费代丽卡女士。西西莉亚收留了我这条丧家之犬。", "sound": "sounds/vo_1100427_20_6008.wav"}, "en": {"subtitle": "我逃到了米兰王国，遇到了费代丽卡女士。西西莉亚收留了我这条丧家之犬。", "sound": "sounds/en_vo_1100427_20_6008.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle", "label": "默认", "duration": 6.467}}, {"step": 82, "action": "dialog", "speaker": "将军", "subtitle": "这次……我发誓会用命守住这里。", "voiceId": "15040980", "audioName": "vo_1100427_21_6008", "voices": {"cn": {"subtitle": "这次……我发誓会用命守住这里。", "sound": "sounds/vo_1100427_21_6008.wav"}, "en": {"subtitle": "这次……我发誓会用命守住这里。", "sound": "sounds/en_vo_1100427_21_6008.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle", "label": "默认", "duration": 6.467}}, {"step": 83, "action": "dialog", "speaker": "将军", "subtitle": "可是十年前……我又食言了。", "voiceId": "15041099", "audioName": "vo_1100427_21a_6008", "voices": {"cn": {"subtitle": "可是十年前……我又食言了。", "sound": "sounds/vo_1100427_21a_6008.wav"}, "en": {"subtitle": "可是十年前……我又食言了。", "sound": "sounds/en_vo_1100427_21a_6008.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle", "label": "默认", "duration": 6.467}}, {"step": 84, "action": "dialog", "speaker": "将军", "subtitle": "我又一次……成了幸存者。", "voiceId": "15040981", "audioName": "vo_1100427_22_6008", "voices": {"cn": {"subtitle": "我又一次……成了幸存者。", "sound": "sounds/vo_1100427_22_6008.wav"}, "en": {"subtitle": "我又一次……成了幸存者。", "sound": "sounds/en_vo_1100427_22_6008.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle", "label": "默认", "duration": 6.467}}]}],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 6.467 }
        ]
      }
    ],
    clickShowActions: [
      {
        showId: 65,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1100429 step 65",
        group: "Idle",
        index: 0,
        actionId: "idle",
        label: "默认",
        duration: 6.467,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 1
      }
    ]
  },
  {
    id: "200124_l2d",
    title: "剧情CG 200124",
    assetKind: "storycg",
    categoryLabel: "剧情CG",
    modelDir: "200124_l2d",
    sourceModelDir: "200124_l2d",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "localassets_win32",
    styleId: "",
    styleName: "剧情CG 200124",
    stage: "剧情CG",
    hitAreaNames: ["HitAreaBody"],
    followConfigs: [],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [{"id": "t_story_1100512:200124:1", "story": "t_story_1100512", "label": "剧情片段 1 · 3 句", "startStep": 170, "endStep": 177, "cues": [{"step": 172, "action": "dialog", "speaker": "爱德华多", "subtitle": "我和另外六个孩子一起杀死了富商。", "voiceId": "15050575", "audioName": "vo_1100512_72_6007", "voices": {"cn": {"subtitle": "我和另外六个孩子一起杀死了富商。", "sound": "sounds/vo_1100512_72_6007.wav"}, "en": {"subtitle": "我和另外六个孩子一起杀死了富商。", "sound": "sounds/en_vo_1100512_72_6007.wav"}}}, {"step": 173, "action": "dialog", "speaker": "爱德华多", "subtitle": "杀死一个成年人原来没有想象中那么难。", "voiceId": "15050576", "audioName": "vo_1100512_73_6007", "voices": {"cn": {"subtitle": "杀死一个成年人原来没有想象中那么难。", "sound": "sounds/vo_1100512_73_6007.wav"}, "en": {"subtitle": "杀死一个成年人原来没有想象中那么难。", "sound": "sounds/en_vo_1100512_73_6007.wav"}}}, {"step": 174, "action": "dialog", "speaker": "爱德华多", "subtitle": "他臃肿、近视、行动迟缓，浑身都是弱点。", "voiceId": "15050577", "audioName": "vo_1100512_74_6007", "voices": {"cn": {"subtitle": "他臃肿、近视、行动迟缓，浑身都是弱点。", "sound": "sounds/vo_1100512_74_6007.wav"}, "en": {"subtitle": "他臃肿、近视、行动迟缓，浑身都是弱点。", "sound": "sounds/en_vo_1100512_74_6007.wav"}}}]}, {"id": "t_story_1100512:200124:2", "story": "t_story_1100512", "label": "剧情片段 2 · 4 句", "startStep": 212, "endStep": 222, "cues": [{"step": 213, "action": "dialog", "speaker": "爱德华多", "subtitle": "你们记住，孤儿院的孩子们已经“死了”，我们以后不能再用过去的身份活着。", "voiceId": "15050590", "audioName": "vo_1100512_87_6007", "voices": {"cn": {"subtitle": "你们记住，孤儿院的孩子们已经“死了”，我们以后不能再用过去的身份活着。", "sound": "sounds/vo_1100512_87_6007.wav"}, "en": {"subtitle": "你们记住，孤儿院的孩子们已经“死了”，我们以后不能再用过去的身份活着。", "sound": "sounds/en_vo_1100512_87_6007.wav"}}}, {"step": 214, "action": "dialog", "speaker": "爱德华多", "subtitle": "从今天开始，没有爱德华多。", "voiceId": "15050591", "audioName": "vo_1100512_88_6007", "voices": {"cn": {"subtitle": "从今天开始，没有爱德华多。", "sound": "sounds/vo_1100512_88_6007.wav"}, "en": {"subtitle": "从今天开始，没有爱德华多。", "sound": "sounds/en_vo_1100512_88_6007.wav"}}}, {"step": 215, "action": "dialog", "speaker": "埃利亚", "subtitle": "那我们应该叫你什么？", "voiceId": "15050592", "audioName": "vo_1100512_89_7069", "voices": {"cn": {"subtitle": "那我们应该叫你什么？", "sound": "sounds/vo_1100512_89_7069.wav"}, "en": {"subtitle": "那我们应该叫你什么？", "sound": "sounds/en_vo_1100512_89_7069.wav"}}}, {"step": 220, "action": "cameraanim", "speaker": "幽灵", "subtitle": "……幽灵，叫我幽灵。", "voiceId": "15050593", "audioName": "vo_1100512_90_6007", "voices": {"cn": {"subtitle": "……幽灵，叫我幽灵。", "sound": "sounds/vo_1100512_90_6007.wav"}, "en": {"subtitle": "……幽灵，叫我幽灵。", "sound": "sounds/en_vo_1100512_90_6007.wav"}}, "motion": {"group": "Idle", "index": 1, "actionId": "idle2", "label": "注视2", "duration": 1.0}}]}],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 3.167 },
          { group: "Idle", index: 1, actionId: "idle2", label: "注视2", duration: 1.0 }
        ]
      },
      {
        label: "TapBody",
        actions: [
          { group: "TapBody", index: 0, actionId: "chafen1", label: "chafen1", duration: 1.0 }
        ]
      }
    ],
    clickShowActions: [
      {
        showId: 219,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1100512 step 219",
        group: "TapBody",
        index: 0,
        actionId: "chafen1",
        label: "chafen1",
        duration: 1.0,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 1
      },
      {
        showId: 219,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1100512 step 219",
        group: "Idle",
        index: 1,
        actionId: "idle2",
        label: "注视2",
        duration: 1.0,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 1
      }
    ]
  },
  {
    id: "200134_l2d",
    title: "剧情CG 200134_l2d",
    assetKind: "storycg",
    categoryLabel: "剧情CG",
    modelDir: "200134_l2d",
    sourceModelDir: "200134_l2d",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "localassets_win32",
    styleId: "",
    styleName: "剧情CG 200134_l2d",
    stage: "剧情CG候选",
    hitAreaNames: ["HitAreaBody"],
    followConfigs: [],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 20.0 }
        ]
      }
    ],
    clickShowActions: [

    ]
  },
  {
    id: "200141_l2d",
    title: "剧情CG 200141_l2d",
    assetKind: "storycg",
    categoryLabel: "剧情CG",
    modelDir: "200141_l2d",
    sourceModelDir: "200141_l2d",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "localassets_win32",
    styleId: "",
    styleName: "剧情CG 200141_l2d",
    stage: "剧情CG候选",
    hitAreaNames: ["HitAreaBody"],
    followConfigs: [],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 6.0 }
        ]
      }
    ],
    clickShowActions: [

    ]
  },
  {
    id: "200146_l2d",
    title: "剧情CG 200146",
    assetKind: "storycg",
    categoryLabel: "剧情CG",
    modelDir: "200146_l2d",
    sourceModelDir: "200146_l2d",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "localassets_win32",
    styleId: "",
    styleName: "剧情CG 200146",
    stage: "剧情CG",
    hitAreaNames: ["HitAreaRudingR", "HitAreaHead", "HitAreaHandR", "HitAreaXiong", "HitAreaHandL", "HitAreaMoren", "HitAreaKua", "HitAreaRudingL", "HitAreaBody"],
    followConfigs: [],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [{"id": "t_story_1600311:200146:1", "story": "t_story_1600311", "label": "剧情片段 1 · 17 句", "startStep": 94, "endStep": 163, "cues": [{"step": 107, "action": "dialog", "speaker": "黑哨", "subtitle": "痛？", "voiceId": "16020374", "audioName": "vo_1600308_19_6032", "voices": {"cn": {"subtitle": "痛？", "sound": "sounds/vo_1600308_19_6032.wav"}, "en": {"subtitle": "痛？", "sound": "sounds/en_vo_1600308_19_6032.wav"}}, "motion": {"group": "TapBody", "index": 0, "actionId": "dongzuo1", "label": "亲近1", "duration": 15.0}}, {"step": 109, "action": "dialog", "speaker": "黑哨", "subtitle": "那种吵闹的神经信号？我把它们“关”掉了。", "voiceId": "16020375", "audioName": "vo_1600308_20_6032", "voices": {"cn": {"subtitle": "那种吵闹的神经信号？我把它们“关”掉了。", "sound": "sounds/vo_1600308_20_6032.wav"}, "en": {"subtitle": "那种吵闹的神经信号？我把它们“关”掉了。", "sound": "sounds/en_vo_1600308_20_6032.wav"}}, "motion": {"group": "TapBody", "index": 0, "actionId": "dongzuo1", "label": "亲近1", "duration": 15.0}}, {"step": 111, "action": "dialog", "speaker": "黑哨", "subtitle": "听觉、触觉、嗅觉……只要我不想要，它们就是噪音。既然是噪音，就可以被“缄默”。", "voiceId": "16020376", "audioName": "vo_1600308_21_6032", "voices": {"cn": {"subtitle": "听觉、触觉、嗅觉……只要我不想要，它们就是噪音。既然是噪音，就可以被“缄默”。", "sound": "sounds/vo_1600308_21_6032.wav"}, "en": {"subtitle": "听觉、触觉、嗅觉……只要我不想要，它们就是噪音。既然是噪音，就可以被“缄默”。", "sound": "sounds/en_vo_1600308_21_6032.wav"}}, "motion": {"group": "TapBody", "index": 0, "actionId": "dongzuo1", "label": "亲近1", "duration": 15.0}}, {"step": 112, "action": "dialog", "speaker": "黑哨", "subtitle": "在这个疯狂的世界里，让自己变成一块石头，才能活得更久。", "voiceId": "16020377", "audioName": "vo_1600308_21a_6032", "voices": {"cn": {"subtitle": "在这个疯狂的世界里，让自己变成一块石头，才能活得更久。", "sound": "sounds/vo_1600308_21a_6032.wav"}, "en": {"subtitle": "在这个疯狂的世界里，让自己变成一块石头，才能活得更久。", "sound": "sounds/en_vo_1600308_21a_6032.wav"}}, "motion": {"group": "TapBody", "index": 0, "actionId": "dongzuo1", "label": "亲近1", "duration": 15.0}}, {"step": 117, "action": "dialog", "speaker": "黑哨", "subtitle": "别吧，搭档。这个世界太吵了……我想安静一会儿。", "voiceId": "16020378", "audioName": "vo_1600308_22_6032", "voices": {"cn": {"subtitle": "别吧，搭档。这个世界太吵了……我想安静一会儿。", "sound": "sounds/vo_1600308_22_6032.wav"}, "en": {"subtitle": "别吧，搭档。这个世界太吵了……我想安静一会儿。", "sound": "sounds/en_vo_1600308_22_6032.wav"}}, "motion": {"group": "TapBody", "index": 0, "actionId": "dongzuo1", "label": "亲近1", "duration": 15.0}}, {"step": 120, "action": "cameraanim", "speaker": "", "subtitle": "我俯身一把攥住他，将他拉向我。", "voiceId": "16020379", "audioName": "vo_1600308_22a_6032", "voices": {"cn": {"subtitle": "我俯身一把攥住他，将他拉向我。", "sound": "sounds/vo_1600308_22a_6032.wav"}, "en": {"subtitle": "我俯身一把攥住他，将他拉向我。", "sound": "sounds/en_vo_1600308_22a_6032.wav"}}, "motion": {"group": "TapBody", "index": 0, "actionId": "dongzuo1", "label": "亲近1", "duration": 15.0}}, {"step": 126, "action": "dialog", "speaker": "黑哨", "subtitle": "更麻烦的方式……比如？我很好奇你的想象力，搭档。", "voiceId": "16020380", "audioName": "vo_1600308_23_6032", "voices": {"cn": {"subtitle": "更麻烦的方式……比如？我很好奇你的想象力，搭档。", "sound": "sounds/vo_1600308_23_6032.wav"}, "en": {"subtitle": "更麻烦的方式……比如？我很好奇你的想象力，搭档。", "sound": "sounds/en_vo_1600308_23_6032.wav"}}, "motion": {"group": "TapBody", "index": 0, "actionId": "dongzuo1", "label": "亲近1", "duration": 15.0}}, {"step": 130, "action": "dialog", "speaker": "黑哨", "subtitle": "激将法？真老套。不过既然你为我这么费心……", "voiceId": "16020381", "audioName": "vo_1600308_24_6032", "voices": {"cn": {"subtitle": "激将法？真老套。不过既然你为我这么费心……", "sound": "sounds/vo_1600308_24_6032.wav"}, "en": {"subtitle": "激将法？真老套。不过既然你为我这么费心……", "sound": "sounds/en_vo_1600308_24_6032.wav"}}, "motion": {"group": "TapBody", "index": 0, "actionId": "dongzuo1", "label": "亲近1", "duration": 15.0}}, {"step": 133, "action": "dialog", "speaker": "", "subtitle": "他叹了口气，像是对这种执着感到无奈，又像是某种妥协。", "voiceId": "16020382", "audioName": "vo_1600308_25a_6032", "voices": {"cn": {"subtitle": "他叹了口气，像是对这种执着感到无奈，又像是某种妥协。", "sound": "sounds/vo_1600308_25a_6032.wav"}, "en": {"subtitle": "他叹了口气，像是对这种执着感到无奈，又像是某种妥协。", "sound": "sounds/en_vo_1600308_25a_6032.wav"}}, "motion": {"group": "TapBody", "index": 0, "actionId": "dongzuo1", "label": "亲近1", "duration": 15.0}}, {"step": 134, "action": "dialog", "speaker": "黑哨", "subtitle": "这么在意活着的感觉？你的生命力让我感到有些刺眼了。", "voiceId": "16020383", "audioName": "vo_1600308_25_6032", "voices": {"cn": {"subtitle": "这么在意活着的感觉？你的生命力让我感到有些刺眼了。", "sound": "sounds/vo_1600308_25_6032.wav"}, "en": {"subtitle": "这么在意活着的感觉？你的生命力让我感到有些刺眼了。", "sound": "sounds/en_vo_1600308_25_6032.wav"}}, "motion": {"group": "TapBody", "index": 0, "actionId": "dongzuo1", "label": "亲近1", "duration": 15.0}}, {"step": 135, "action": "dialog", "speaker": "黑哨", "subtitle": "行行行……真是个霸道的女人。", "voiceId": "16020384", "audioName": "vo_1600308_26_6032", "voices": {"cn": {"subtitle": "行行行……真是个霸道的女人。", "sound": "sounds/vo_1600308_26_6032.wav"}, "en": {"subtitle": "行行行……真是个霸道的女人。", "sound": "sounds/en_vo_1600308_26_6032.wav"}}, "motion": {"group": "TapBody", "index": 0, "actionId": "dongzuo1", "label": "亲近1", "duration": 15.0}}, {"step": 137, "action": "dialog", "speaker": "", "subtitle": "我看到他的眉头猛地一皱，额角瞬间渗出一层细密的冷汗。苍白的皮肤因为疼痛而泛起病态的潮红，他的呼吸变得急促而沉重。", "voiceId": "16020385", "audioName": "vo_1600308_26a_6032", "voices": {"cn": {"subtitle": "我看到他的眉头猛地一皱，额角瞬间渗出一层细密的冷汗。苍白的皮肤因为疼痛而泛起病态的潮红，他的呼吸变得急促而沉重。", "sound": "sounds/vo_1600308_26a_6032.wav"}, "en": {"subtitle": "我看到他的眉头猛地一皱，额角瞬间渗出一层细密的冷汗。苍白的皮肤因为疼痛而泛起病态的潮红，他的呼吸变得急促而沉重。", "sound": "sounds/en_vo_1600308_26a_6032.wav"}}, "motion": {"group": "TapBody", "index": 1, "actionId": "dongzuo2", "label": "亲近2", "duration": 10.4}}, {"step": 139, "action": "dialog", "speaker": "", "subtitle": "他倒吸一口冷气，睁开眼，那双原本空洞深邃的眼睛里，此刻因为骤然刺激而泛红，渗出一点生理性的泪水，看起来竟然有一种令人心惊的鲜活感。", "voiceId": "16020386", "audioName": "vo_1600308_27a_6032", "voices": {"cn": {"subtitle": "他倒吸一口冷气，睁开眼，那双原本空洞深邃的眼睛里，此刻因为骤然刺激而泛红，渗出一点生理性的泪水，看起来竟然有一种令人心惊的鲜活感。", "sound": "sounds/vo_1600308_27a_6032.wav"}, "en": {"subtitle": "他倒吸一口冷气，睁开眼，那双原本空洞深邃的眼睛里，此刻因为骤然刺激而泛红，渗出一点生理性的泪水，看起来竟然有一种令人心惊的鲜活感。", "sound": "sounds/en_vo_1600308_27a_6032.wav"}}, "motion": {"group": "TapBody", "index": 1, "actionId": "dongzuo2", "label": "亲近2", "duration": 10.4}}, {"step": 140, "action": "dialog", "speaker": "黑哨", "subtitle": "这下你满意了？如果你是想谋杀我……恭喜你，差点就成功了。", "voiceId": "16020387", "audioName": "vo_1600308_27_6032", "voices": {"cn": {"subtitle": "这下你满意了？如果你是想谋杀我……恭喜你，差点就成功了。", "sound": "sounds/vo_1600308_27_6032.wav"}, "en": {"subtitle": "这下你满意了？如果你是想谋杀我……恭喜你，差点就成功了。", "sound": "sounds/en_vo_1600308_27_6032.wav"}}, "motion": {"group": "TapBody", "index": 1, "actionId": "dongzuo2", "label": "亲近2", "duration": 10.4}}, {"step": 148, "action": "dialog", "speaker": "黑哨", "subtitle": "啧。你下手可真狠啊，搭档。", "voiceId": "16020388", "audioName": "vo_1600308_28_6032", "voices": {"cn": {"subtitle": "啧。你下手可真狠啊，搭档。", "sound": "sounds/vo_1600308_28_6032.wav"}, "en": {"subtitle": "啧。你下手可真狠啊，搭档。", "sound": "sounds/en_vo_1600308_28_6032.wav"}}, "motion": {"group": "Idle", "index": 2, "actionId": "idle2", "label": "注视2", "duration": 10.0}}, {"step": 149, "action": "dialog", "speaker": "黑哨", "subtitle": "记住这种感觉？不用你说……我的每根神经都在骂脏话。", "voiceId": "16020389", "audioName": "vo_1600308_28a_6032", "voices": {"cn": {"subtitle": "记住这种感觉？不用你说……我的每根神经都在骂脏话。", "sound": "sounds/vo_1600308_28a_6032.wav"}, "en": {"subtitle": "记住这种感觉？不用你说……我的每根神经都在骂脏话。", "sound": "sounds/en_vo_1600308_28a_6032.wav"}}, "motion": {"group": "Idle", "index": 2, "actionId": "idle2", "label": "注视2", "duration": 10.0}}, {"step": 150, "action": "dialog", "speaker": "黑哨", "subtitle": "但你最好小心点。我被火烧疼了，可是会撕开对方的脖子的……", "voiceId": "16020390", "audioName": "vo_1600308_29_6032", "voices": {"cn": {"subtitle": "但你最好小心点。我被火烧疼了，可是会撕开对方的脖子的……", "sound": "sounds/vo_1600308_29_6032.wav"}, "en": {"subtitle": "但你最好小心点。我被火烧疼了，可是会撕开对方的脖子的……", "sound": "sounds/en_vo_1600308_29_6032.wav"}}, "motion": {"group": "Idle", "index": 2, "actionId": "idle2", "label": "注视2", "duration": 10.0}}]}],
    storyTouchActions: [{"storyGameId": "1101", "story": "t_story_1600311", "storyStep": 97, "hitArea": "HitAreaKua", "sourceHitAreas": ["HitAreaKua"], "subtitles": ["这里是禁区，搭档。", "呵，你故意的？"], "audioId": "130416", "audioName": "vo_mocashangyao_wuzhijue_yao", "eventSource": "t_uiAudio.audioName", "defaultSet": true, "voices": {"cn": {"sound": "sounds/vo_mocashangyao_wuzhijue_yao.wav", "sounds": ["sounds/vo_mocashangyao_wuzhijue_yao.wav", "sounds/vo_mocashangyao_wuzhijue_yao__02.wav", "sounds/vo_mocashangyao_wuzhijue_yao__03.wav", "sounds/vo_mocashangyao_wuzhijue_yao__04.wav"]}, "en": {"sound": "sounds/en_vo_mocashangyao_wuzhijue_yao.wav", "sounds": ["sounds/en_vo_mocashangyao_wuzhijue_yao.wav", "sounds/en_vo_mocashangyao_wuzhijue_yao__02.wav", "sounds/en_vo_mocashangyao_wuzhijue_yao__03.wav", "sounds/en_vo_mocashangyao_wuzhijue_yao__04.wav"]}}, "motion": {"group": "TapBody", "index": 0, "actionId": "dongzuo1", "label": "亲近1", "duration": 15.0}}, {"storyGameId": "1101", "story": "t_story_1600311", "storyStep": 97, "hitArea": "HitAreaBody", "sourceHitAreas": ["HitAreaBody"], "subtitles": ["疼倒不疼，这里很痒。", "看来不把我每块腹肌都检查一遍，你是不会停手了。"], "audioId": "130416", "audioName": "vo_mocashangyao_wuzhijue_yao", "eventSource": "t_uiAudio.audioName", "defaultSet": true, "voices": {"cn": {"sound": "sounds/vo_mocashangyao_wuzhijue_yao.wav", "sounds": ["sounds/vo_mocashangyao_wuzhijue_yao.wav", "sounds/vo_mocashangyao_wuzhijue_yao__02.wav", "sounds/vo_mocashangyao_wuzhijue_yao__03.wav", "sounds/vo_mocashangyao_wuzhijue_yao__04.wav"]}, "en": {"sound": "sounds/en_vo_mocashangyao_wuzhijue_yao.wav", "sounds": ["sounds/en_vo_mocashangyao_wuzhijue_yao.wav", "sounds/en_vo_mocashangyao_wuzhijue_yao__02.wav", "sounds/en_vo_mocashangyao_wuzhijue_yao__03.wav", "sounds/en_vo_mocashangyao_wuzhijue_yao__04.wav"]}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle", "label": "默认", "duration": 10.0}}, {"storyGameId": "1101", "story": "t_story_1600311", "storyStep": 97, "hitArea": "HitAreaXiong", "sourceHitAreas": ["HitAreaXiong"], "subtitles": ["心跳正常，要验证一下吗？", "这算小伤，放心，你搭档命大得很。"], "audioId": "130415", "audioName": "vo_mocashangyao_wuzhijue_xiong", "eventSource": "t_uiAudio.audioName", "defaultSet": true, "voices": {"cn": {"sound": "sounds/vo_mocashangyao_wuzhijue_xiong.wav", "sounds": ["sounds/vo_mocashangyao_wuzhijue_xiong.wav", "sounds/vo_mocashangyao_wuzhijue_xiong__02.wav", "sounds/vo_mocashangyao_wuzhijue_xiong__03.wav", "sounds/vo_mocashangyao_wuzhijue_xiong__04.wav"]}, "en": {"sound": "sounds/en_vo_mocashangyao_wuzhijue_xiong.wav", "sounds": ["sounds/en_vo_mocashangyao_wuzhijue_xiong.wav", "sounds/en_vo_mocashangyao_wuzhijue_xiong__02.wav", "sounds/en_vo_mocashangyao_wuzhijue_xiong__03.wav", "sounds/en_vo_mocashangyao_wuzhijue_xiong__04.wav"]}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle", "label": "默认", "duration": 10.0}}, {"storyGameId": "1101", "story": "t_story_1600311", "storyStep": 97, "hitArea": "HitAreaRudingR", "sourceHitAreas": ["HitAreaRudingR"], "subtitles": ["嘶……你的手是不是带电了？", "是痛还是痒？你猜呢。"], "audioId": "130415", "audioName": "vo_mocashangyao_wuzhijue_xiong", "eventSource": "t_uiAudio.audioName", "defaultSet": true, "voices": {"cn": {"sound": "sounds/vo_mocashangyao_wuzhijue_xiong.wav", "sounds": ["sounds/vo_mocashangyao_wuzhijue_xiong.wav", "sounds/vo_mocashangyao_wuzhijue_xiong__02.wav", "sounds/vo_mocashangyao_wuzhijue_xiong__03.wav", "sounds/vo_mocashangyao_wuzhijue_xiong__04.wav"]}, "en": {"sound": "sounds/en_vo_mocashangyao_wuzhijue_xiong.wav", "sounds": ["sounds/en_vo_mocashangyao_wuzhijue_xiong.wav", "sounds/en_vo_mocashangyao_wuzhijue_xiong__02.wav", "sounds/en_vo_mocashangyao_wuzhijue_xiong__03.wav", "sounds/en_vo_mocashangyao_wuzhijue_xiong__04.wav"]}}, "motion": {"group": "TapBody", "index": 0, "actionId": "dongzuo1", "label": "亲近1", "duration": 15.0}}, {"storyGameId": "1101", "story": "t_story_1600311", "storyStep": 97, "hitArea": "HitAreaRudingL", "sourceHitAreas": ["HitAreaRudingL"], "subtitles": ["嘶……你的手是不是带电了？", "是痛还是痒？你猜呢。"], "audioId": "130415", "audioName": "vo_mocashangyao_wuzhijue_xiong", "eventSource": "t_uiAudio.audioName", "defaultSet": true, "voices": {"cn": {"sound": "sounds/vo_mocashangyao_wuzhijue_xiong.wav", "sounds": ["sounds/vo_mocashangyao_wuzhijue_xiong.wav", "sounds/vo_mocashangyao_wuzhijue_xiong__02.wav", "sounds/vo_mocashangyao_wuzhijue_xiong__03.wav", "sounds/vo_mocashangyao_wuzhijue_xiong__04.wav"]}, "en": {"sound": "sounds/en_vo_mocashangyao_wuzhijue_xiong.wav", "sounds": ["sounds/en_vo_mocashangyao_wuzhijue_xiong.wav", "sounds/en_vo_mocashangyao_wuzhijue_xiong__02.wav", "sounds/en_vo_mocashangyao_wuzhijue_xiong__03.wav", "sounds/en_vo_mocashangyao_wuzhijue_xiong__04.wav"]}}, "motion": {"group": "TapBody", "index": 0, "actionId": "dongzuo1", "label": "亲近1", "duration": 15.0}}, {"storyGameId": "1101", "story": "t_story_1600311", "storyStep": 97, "hitArea": "HitAreaHead", "sourceHitAreas": ["HitAreaHead"], "subtitles": ["好好好，从头到脚，任你摆布。", "盯着我的脸看这么久，找到伤口了吗？"], "audioId": "130414", "audioName": "vo_mocashangyao_wuzhijue_tou", "eventSource": "t_uiAudio.audioName", "defaultSet": true, "voices": {"cn": {"sound": "sounds/vo_mocashangyao_wuzhijue_tou.wav", "sounds": ["sounds/vo_mocashangyao_wuzhijue_tou.wav", "sounds/vo_mocashangyao_wuzhijue_tou__02.wav", "sounds/vo_mocashangyao_wuzhijue_tou__03.wav", "sounds/vo_mocashangyao_wuzhijue_tou__04.wav"]}, "en": {"sound": "sounds/en_vo_mocashangyao_wuzhijue_tou.wav", "sounds": ["sounds/en_vo_mocashangyao_wuzhijue_tou.wav", "sounds/en_vo_mocashangyao_wuzhijue_tou__02.wav", "sounds/en_vo_mocashangyao_wuzhijue_tou__03.wav", "sounds/en_vo_mocashangyao_wuzhijue_tou__04.wav"]}}}, {"storyGameId": "1101", "story": "t_story_1600311", "storyStep": 97, "hitArea": "HitAreaHandR", "sourceHitAreas": ["HitAreaHandR"], "subtitles": ["不是每次受伤都有好心的搭档替我上药。", "手臂还好，没怎么伤到。"], "audioId": "130413", "audioName": "vo_mocashangyao_wuzhijue_shou", "eventSource": "t_uiAudio.audioName", "defaultSet": true, "voices": {"cn": {"sound": "sounds/vo_mocashangyao_wuzhijue_shou.wav", "sounds": ["sounds/vo_mocashangyao_wuzhijue_shou.wav", "sounds/vo_mocashangyao_wuzhijue_shou__02.wav", "sounds/vo_mocashangyao_wuzhijue_shou__03.wav", "sounds/vo_mocashangyao_wuzhijue_shou__04.wav"]}, "en": {"sound": "sounds/en_vo_mocashangyao_wuzhijue_shou.wav", "sounds": ["sounds/en_vo_mocashangyao_wuzhijue_shou.wav", "sounds/en_vo_mocashangyao_wuzhijue_shou__02.wav", "sounds/en_vo_mocashangyao_wuzhijue_shou__03.wav", "sounds/en_vo_mocashangyao_wuzhijue_shou__04.wav"]}}}, {"storyGameId": "1101", "story": "t_story_1600311", "storyStep": 97, "hitArea": "HitAreaHandL", "sourceHitAreas": ["HitAreaHandL"], "subtitles": ["不是每次受伤都有好心的搭档替我上药。", "手臂还好，没怎么伤到。"], "audioId": "130413", "audioName": "vo_mocashangyao_wuzhijue_shou", "eventSource": "t_uiAudio.audioName", "defaultSet": true, "voices": {"cn": {"sound": "sounds/vo_mocashangyao_wuzhijue_shou.wav", "sounds": ["sounds/vo_mocashangyao_wuzhijue_shou.wav", "sounds/vo_mocashangyao_wuzhijue_shou__02.wav", "sounds/vo_mocashangyao_wuzhijue_shou__03.wav", "sounds/vo_mocashangyao_wuzhijue_shou__04.wav"]}, "en": {"sound": "sounds/en_vo_mocashangyao_wuzhijue_shou.wav", "sounds": ["sounds/en_vo_mocashangyao_wuzhijue_shou.wav", "sounds/en_vo_mocashangyao_wuzhijue_shou__02.wav", "sounds/en_vo_mocashangyao_wuzhijue_shou__03.wav", "sounds/en_vo_mocashangyao_wuzhijue_shou__04.wav"]}}}, {"storyGameId": "1102", "story": "t_story_1600311", "storyStep": 155, "hitArea": "HitAreaKua", "sourceHitAreas": ["HitAreaKua"], "subtitles": ["你还真是急不可耐。", "你的手再往下一点，我可要误会了。"], "audioId": "130416", "audioName": "vo_mocashangyao_wuzhijue_yao", "eventSource": "t_uiAudio.audioName", "defaultSet": false, "voices": {"cn": {"sound": "sounds/vo_mocashangyao_wuzhijue_yao.wav", "sounds": ["sounds/vo_mocashangyao_wuzhijue_yao.wav", "sounds/vo_mocashangyao_wuzhijue_yao__02.wav", "sounds/vo_mocashangyao_wuzhijue_yao__03.wav", "sounds/vo_mocashangyao_wuzhijue_yao__04.wav"]}, "en": {"sound": "sounds/en_vo_mocashangyao_wuzhijue_yao.wav", "sounds": ["sounds/en_vo_mocashangyao_wuzhijue_yao.wav", "sounds/en_vo_mocashangyao_wuzhijue_yao__02.wav", "sounds/en_vo_mocashangyao_wuzhijue_yao__03.wav", "sounds/en_vo_mocashangyao_wuzhijue_yao__04.wav"]}}, "motion": {"group": "TapBody", "index": 2, "actionId": "dongzuo3", "label": "亲近3", "duration": 2.933}}, {"storyGameId": "1102", "story": "t_story_1600311", "storyStep": 155, "hitArea": "HitAreaBody", "sourceHitAreas": ["HitAreaBody"], "subtitles": ["忍痛我在行，忍别的不太行。", "喂喂，再多碰几下就收费了。"], "audioId": "130389", "audioName": "vo_mocashangyao_rentong", "eventSource": "t_uiAudio.audioName", "defaultSet": false, "voices": {"cn": {"sound": "sounds/vo_mocashangyao_rentong.wav", "sounds": ["sounds/vo_mocashangyao_rentong.wav", "sounds/vo_mocashangyao_rentong__02.wav", "sounds/vo_mocashangyao_rentong__03.wav", "sounds/vo_mocashangyao_rentong__04.wav"]}, "en": {"sound": "sounds/en_vo_mocashangyao_rentong.wav", "sounds": ["sounds/en_vo_mocashangyao_rentong.wav", "sounds/en_vo_mocashangyao_rentong__02.wav", "sounds/en_vo_mocashangyao_rentong__03.wav", "sounds/en_vo_mocashangyao_rentong__04.wav"]}}, "motion": {"group": "TapBody", "index": 0, "actionId": "dongzuo1", "label": "亲近1", "duration": 15.0}}, {"storyGameId": "1102", "story": "t_story_1600311", "storyStep": 155, "hitArea": "HitAreaXiong", "sourceHitAreas": ["HitAreaXiong"], "subtitles": ["被公爵大人照顾的感觉，好像不错。", "我的心跳好像变快了，或许是因为疼吧，谁知道呢？"], "audioId": "130389", "audioName": "vo_mocashangyao_rentong", "eventSource": "t_uiAudio.audioName", "defaultSet": false, "voices": {"cn": {"sound": "sounds/vo_mocashangyao_rentong.wav", "sounds": ["sounds/vo_mocashangyao_rentong.wav", "sounds/vo_mocashangyao_rentong__02.wav", "sounds/vo_mocashangyao_rentong__03.wav", "sounds/vo_mocashangyao_rentong__04.wav"]}, "en": {"sound": "sounds/en_vo_mocashangyao_rentong.wav", "sounds": ["sounds/en_vo_mocashangyao_rentong.wav", "sounds/en_vo_mocashangyao_rentong__02.wav", "sounds/en_vo_mocashangyao_rentong__03.wav", "sounds/en_vo_mocashangyao_rentong__04.wav"]}}, "motion": {"group": "TapBody", "index": 3, "actionId": "dongzuo4", "label": "dongzuo4", "duration": 3.333}}, {"storyGameId": "1102", "story": "t_story_1600311", "storyStep": 155, "hitArea": "HitAreaRudingR", "sourceHitAreas": ["HitAreaRudingR"], "subtitles": ["只是一个小装饰，别蹭了。", "你……这里就不劳你大驾了，公爵大人。"], "audioId": "130389", "audioName": "vo_mocashangyao_rentong", "eventSource": "t_uiAudio.audioName", "defaultSet": false, "voices": {"cn": {"sound": "sounds/vo_mocashangyao_rentong.wav", "sounds": ["sounds/vo_mocashangyao_rentong.wav", "sounds/vo_mocashangyao_rentong__02.wav", "sounds/vo_mocashangyao_rentong__03.wav", "sounds/vo_mocashangyao_rentong__04.wav"]}, "en": {"sound": "sounds/en_vo_mocashangyao_rentong.wav", "sounds": ["sounds/en_vo_mocashangyao_rentong.wav", "sounds/en_vo_mocashangyao_rentong__02.wav", "sounds/en_vo_mocashangyao_rentong__03.wav", "sounds/en_vo_mocashangyao_rentong__04.wav"]}}, "motion": {"group": "TapBody", "index": 2, "actionId": "dongzuo3", "label": "亲近3", "duration": 2.933}}, {"storyGameId": "1102", "story": "t_story_1600311", "storyStep": 155, "hitArea": "HitAreaRudingL", "sourceHitAreas": ["HitAreaRudingL"], "subtitles": ["只是一个小装饰，别蹭了。", "你……这里就不劳你大驾了，公爵大人。"], "audioId": "130389", "audioName": "vo_mocashangyao_rentong", "eventSource": "t_uiAudio.audioName", "defaultSet": false, "voices": {"cn": {"sound": "sounds/vo_mocashangyao_rentong.wav", "sounds": ["sounds/vo_mocashangyao_rentong.wav", "sounds/vo_mocashangyao_rentong__02.wav", "sounds/vo_mocashangyao_rentong__03.wav", "sounds/vo_mocashangyao_rentong__04.wav"]}, "en": {"sound": "sounds/en_vo_mocashangyao_rentong.wav", "sounds": ["sounds/en_vo_mocashangyao_rentong.wav", "sounds/en_vo_mocashangyao_rentong__02.wav", "sounds/en_vo_mocashangyao_rentong__03.wav", "sounds/en_vo_mocashangyao_rentong__04.wav"]}}, "motion": {"group": "TapBody", "index": 2, "actionId": "dongzuo3", "label": "亲近3", "duration": 2.933}}, {"storyGameId": "1102", "story": "t_story_1600311", "storyStep": 155, "hitArea": "HitAreaHead", "sourceHitAreas": ["HitAreaHead"], "subtitles": ["我保证，头上一根头发丝都没掉。", "这么温柔，心疼我这张脸啊？"], "audioId": "130414", "audioName": "vo_mocashangyao_wuzhijue_tou", "eventSource": "t_uiAudio.audioName", "defaultSet": false, "voices": {"cn": {"sound": "sounds/vo_mocashangyao_wuzhijue_tou.wav", "sounds": ["sounds/vo_mocashangyao_wuzhijue_tou.wav", "sounds/vo_mocashangyao_wuzhijue_tou__02.wav", "sounds/vo_mocashangyao_wuzhijue_tou__03.wav", "sounds/vo_mocashangyao_wuzhijue_tou__04.wav"]}, "en": {"sound": "sounds/en_vo_mocashangyao_wuzhijue_tou.wav", "sounds": ["sounds/en_vo_mocashangyao_wuzhijue_tou.wav", "sounds/en_vo_mocashangyao_wuzhijue_tou__02.wav", "sounds/en_vo_mocashangyao_wuzhijue_tou__03.wav", "sounds/en_vo_mocashangyao_wuzhijue_tou__04.wav"]}}}, {"storyGameId": "1102", "story": "t_story_1600311", "storyStep": 155, "hitArea": "HitAreaHandR", "sourceHitAreas": ["HitAreaHandR"], "subtitles": ["我的手臂不会一碰就碎，尽管来吧。", "手臂上这点小伤，你擦慢点它都愈合了。"], "audioId": "130423", "audioName": "vo_mocashangyao_qingzhong", "eventSource": "t_uiAudio.audioName", "defaultSet": false, "voices": {"cn": {"sound": "sounds/vo_mocashangyao_qingzhong.wav", "sounds": ["sounds/vo_mocashangyao_qingzhong.wav", "sounds/vo_mocashangyao_qingzhong__02.wav", "sounds/vo_mocashangyao_qingzhong__03.wav"]}, "en": {"sound": "sounds/en_vo_mocashangyao_qingzhong.wav", "sounds": ["sounds/en_vo_mocashangyao_qingzhong.wav", "sounds/en_vo_mocashangyao_qingzhong__02.wav", "sounds/en_vo_mocashangyao_qingzhong__03.wav"]}}}, {"storyGameId": "1102", "story": "t_story_1600311", "storyStep": 155, "hitArea": "HitAreaHandL", "sourceHitAreas": ["HitAreaHandL"], "subtitles": ["我的手臂不会一碰就碎，尽管来吧。", "手臂上这点小伤，你擦慢点它都愈合了。"], "audioId": "130423", "audioName": "vo_mocashangyao_qingzhong", "eventSource": "t_uiAudio.audioName", "defaultSet": false, "voices": {"cn": {"sound": "sounds/vo_mocashangyao_qingzhong.wav", "sounds": ["sounds/vo_mocashangyao_qingzhong.wav", "sounds/vo_mocashangyao_qingzhong__02.wav", "sounds/vo_mocashangyao_qingzhong__03.wav"]}, "en": {"sound": "sounds/en_vo_mocashangyao_qingzhong.wav", "sounds": ["sounds/en_vo_mocashangyao_qingzhong.wav", "sounds/en_vo_mocashangyao_qingzhong__02.wav", "sounds/en_vo_mocashangyao_qingzhong__03.wav"]}}}, {"storyGameId": "1103", "story": "t_story_1600311", "storyStep": 160, "hitArea": "HitAreaKua", "sourceHitAreas": ["HitAreaKua"], "subtitles": ["唔……现在是擦药环节，还是逼供环节？", "还乱动？后果自负……"], "audioId": "130416", "audioName": "vo_mocashangyao_wuzhijue_yao", "eventSource": "t_uiAudio.audioName", "defaultSet": false, "voices": {"cn": {"sound": "sounds/vo_mocashangyao_wuzhijue_yao.wav", "sounds": ["sounds/vo_mocashangyao_wuzhijue_yao.wav", "sounds/vo_mocashangyao_wuzhijue_yao__02.wav", "sounds/vo_mocashangyao_wuzhijue_yao__03.wav", "sounds/vo_mocashangyao_wuzhijue_yao__04.wav"]}, "en": {"sound": "sounds/en_vo_mocashangyao_wuzhijue_yao.wav", "sounds": ["sounds/en_vo_mocashangyao_wuzhijue_yao.wav", "sounds/en_vo_mocashangyao_wuzhijue_yao__02.wav", "sounds/en_vo_mocashangyao_wuzhijue_yao__03.wav", "sounds/en_vo_mocashangyao_wuzhijue_yao__04.wav"]}}, "motion": {"group": "TapBody", "index": 1, "actionId": "dongzuo2", "label": "亲近2", "duration": 10.4}}, {"storyGameId": "1103", "story": "t_story_1600311", "storyStep": 160, "hitArea": "HitAreaBody", "sourceHitAreas": ["HitAreaBody"], "subtitles": ["再疼都不许躲……？遵命，搭档。", "看我变成这样，你满意了？"], "audioId": "130388", "audioName": "vo_mocashangyao_citong", "eventSource": "t_uiAudio.audioName", "defaultSet": false, "voices": {"cn": {"sound": "sounds/vo_mocashangyao_citong.wav", "sounds": ["sounds/vo_mocashangyao_citong.wav", "sounds/vo_mocashangyao_citong__02.wav", "sounds/vo_mocashangyao_citong__03.wav", "sounds/vo_mocashangyao_citong__04.wav"]}, "en": {"sound": "sounds/en_vo_mocashangyao_citong.wav", "sounds": ["sounds/en_vo_mocashangyao_citong.wav", "sounds/en_vo_mocashangyao_citong__02.wav", "sounds/en_vo_mocashangyao_citong__03.wav", "sounds/en_vo_mocashangyao_citong__04.wav"]}}, "motion": {"group": "TapBody", "index": 0, "actionId": "dongzuo1", "label": "亲近1", "duration": 15.0}}, {"storyGameId": "1103", "story": "t_story_1600311", "storyStep": 160, "hitArea": "HitAreaXiong", "sourceHitAreas": ["HitAreaXiong"], "subtitles": ["我都已经“坦诚相待”了，你不考虑对我仁慈一点？", "你的手……比流弹更能折磨我。"], "audioId": "130388", "audioName": "vo_mocashangyao_citong", "eventSource": "t_uiAudio.audioName", "defaultSet": false, "voices": {"cn": {"sound": "sounds/vo_mocashangyao_citong.wav", "sounds": ["sounds/vo_mocashangyao_citong.wav", "sounds/vo_mocashangyao_citong__02.wav", "sounds/vo_mocashangyao_citong__03.wav", "sounds/vo_mocashangyao_citong__04.wav"]}, "en": {"sound": "sounds/en_vo_mocashangyao_citong.wav", "sounds": ["sounds/en_vo_mocashangyao_citong.wav", "sounds/en_vo_mocashangyao_citong__02.wav", "sounds/en_vo_mocashangyao_citong__03.wav", "sounds/en_vo_mocashangyao_citong__04.wav"]}}, "motion": {"group": "TapBody", "index": 2, "actionId": "dongzuo3", "label": "亲近3", "duration": 2.933}}, {"storyGameId": "1103", "story": "t_story_1600311", "storyStep": 160, "hitArea": "HitAreaRudingR", "sourceHitAreas": ["HitAreaRudingR"], "subtitles": ["呃啊……这里不行，把手拿开。", "别用你把玩弹头的力度刺激它们……"], "audioId": "130388", "audioName": "vo_mocashangyao_citong", "eventSource": "t_uiAudio.audioName", "defaultSet": false, "voices": {"cn": {"sound": "sounds/vo_mocashangyao_citong.wav", "sounds": ["sounds/vo_mocashangyao_citong.wav", "sounds/vo_mocashangyao_citong__02.wav", "sounds/vo_mocashangyao_citong__03.wav", "sounds/vo_mocashangyao_citong__04.wav"]}, "en": {"sound": "sounds/en_vo_mocashangyao_citong.wav", "sounds": ["sounds/en_vo_mocashangyao_citong.wav", "sounds/en_vo_mocashangyao_citong__02.wav", "sounds/en_vo_mocashangyao_citong__03.wav", "sounds/en_vo_mocashangyao_citong__04.wav"]}}, "motion": {"group": "TapBody", "index": 3, "actionId": "dongzuo4", "label": "dongzuo4", "duration": 3.333}}, {"storyGameId": "1103", "story": "t_story_1600311", "storyStep": 160, "hitArea": "HitAreaRudingL", "sourceHitAreas": ["HitAreaRudingL"], "subtitles": ["呃啊……这里不行，把手拿开。", "别用你把玩弹头的力度刺激它们……"], "audioId": "130388", "audioName": "vo_mocashangyao_citong", "eventSource": "t_uiAudio.audioName", "defaultSet": false, "voices": {"cn": {"sound": "sounds/vo_mocashangyao_citong.wav", "sounds": ["sounds/vo_mocashangyao_citong.wav", "sounds/vo_mocashangyao_citong__02.wav", "sounds/vo_mocashangyao_citong__03.wav", "sounds/vo_mocashangyao_citong__04.wav"]}, "en": {"sound": "sounds/en_vo_mocashangyao_citong.wav", "sounds": ["sounds/en_vo_mocashangyao_citong.wav", "sounds/en_vo_mocashangyao_citong__02.wav", "sounds/en_vo_mocashangyao_citong__03.wav", "sounds/en_vo_mocashangyao_citong__04.wav"]}}, "motion": {"group": "TapBody", "index": 3, "actionId": "dongzuo4", "label": "dongzuo4", "duration": 3.333}}, {"storyGameId": "1103", "story": "t_story_1600311", "storyStep": 160, "hitArea": "HitAreaHead", "sourceHitAreas": ["HitAreaHead"], "subtitles": ["厚脸皮的确是优点，不然怎么受得了你这么用力。", "你是不是对我这张帅脸有意见……"], "audioId": "130414", "audioName": "vo_mocashangyao_wuzhijue_tou", "eventSource": "t_uiAudio.audioName", "defaultSet": false, "voices": {"cn": {"sound": "sounds/vo_mocashangyao_wuzhijue_tou.wav", "sounds": ["sounds/vo_mocashangyao_wuzhijue_tou.wav", "sounds/vo_mocashangyao_wuzhijue_tou__02.wav", "sounds/vo_mocashangyao_wuzhijue_tou__03.wav", "sounds/vo_mocashangyao_wuzhijue_tou__04.wav"]}, "en": {"sound": "sounds/en_vo_mocashangyao_wuzhijue_tou.wav", "sounds": ["sounds/en_vo_mocashangyao_wuzhijue_tou.wav", "sounds/en_vo_mocashangyao_wuzhijue_tou__02.wav", "sounds/en_vo_mocashangyao_wuzhijue_tou__03.wav", "sounds/en_vo_mocashangyao_wuzhijue_tou__04.wav"]}}}, {"storyGameId": "1103", "story": "t_story_1600311", "storyStep": 160, "hitArea": "HitAreaHandR", "sourceHitAreas": ["HitAreaHandR"], "subtitles": ["我还活着，你再这么使劲就不一定了。", "这只手今天帮了你大忙，轻点。"], "audioId": "130423", "audioName": "vo_mocashangyao_qingzhong", "eventSource": "t_uiAudio.audioName", "defaultSet": false, "voices": {"cn": {"sound": "sounds/vo_mocashangyao_qingzhong.wav", "sounds": ["sounds/vo_mocashangyao_qingzhong.wav", "sounds/vo_mocashangyao_qingzhong__02.wav", "sounds/vo_mocashangyao_qingzhong__03.wav"]}, "en": {"sound": "sounds/en_vo_mocashangyao_qingzhong.wav", "sounds": ["sounds/en_vo_mocashangyao_qingzhong.wav", "sounds/en_vo_mocashangyao_qingzhong__02.wav", "sounds/en_vo_mocashangyao_qingzhong__03.wav"]}}}, {"storyGameId": "1103", "story": "t_story_1600311", "storyStep": 160, "hitArea": "HitAreaHandL", "sourceHitAreas": ["HitAreaHandL"], "subtitles": ["我还活着，你再这么使劲就不一定了。", "这只手今天帮了你大忙，轻点。"], "audioId": "130423", "audioName": "vo_mocashangyao_qingzhong", "eventSource": "t_uiAudio.audioName", "defaultSet": false, "voices": {"cn": {"sound": "sounds/vo_mocashangyao_qingzhong.wav", "sounds": ["sounds/vo_mocashangyao_qingzhong.wav", "sounds/vo_mocashangyao_qingzhong__02.wav", "sounds/vo_mocashangyao_qingzhong__03.wav"]}, "en": {"sound": "sounds/en_vo_mocashangyao_qingzhong.wav", "sounds": ["sounds/en_vo_mocashangyao_qingzhong.wav", "sounds/en_vo_mocashangyao_qingzhong__02.wav", "sounds/en_vo_mocashangyao_qingzhong__03.wav"]}}}],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 10.0 },
          { group: "Idle", index: 1, actionId: "idle1", label: "注视1", duration: 10.0 },
          { group: "Idle", index: 2, actionId: "idle2", label: "注视2", duration: 10.0 }
        ]
      },
      {
        label: "TapBody",
        actions: [
          { group: "TapBody", index: 0, actionId: "dongzuo1", label: "亲近1", duration: 15.0 },
          { group: "TapBody", index: 1, actionId: "dongzuo2", label: "亲近2", duration: 10.4 },
          { group: "TapBody", index: 2, actionId: "dongzuo3", label: "亲近3", duration: 2.933 },
          { group: "TapBody", index: 3, actionId: "dongzuo4", label: "dongzuo4", duration: 3.333 },
          { group: "TapBody", index: 4, actionId: "loop", label: "loop", duration: 10.0 }
        ]
      },
      {
        label: "入场",
        actions: [
          { group: "Entry", index: 0, actionId: "ruchang", label: "入场", duration: 10.0 }
        ]
      }
    ],
    clickShowActions: [
      {
        showId: 94,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1600311 step 94",
        group: "Idle",
        index: 1,
        actionId: "idle1",
        label: "注视1",
        duration: 10.0,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 1
      },
      {
        showId: 99,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1600311 step 99",
        group: "TapBody",
        index: 0,
        actionId: "dongzuo1",
        label: "亲近1",
        duration: 15.0,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 1
      },
      {
        showId: 136,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1600311 step 136",
        group: "TapBody",
        index: 1,
        actionId: "dongzuo2",
        label: "亲近2",
        duration: 10.4,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 1
      },
      {
        showId: 142,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1600311 step 142",
        group: "TapBody",
        index: 3,
        actionId: "dongzuo4",
        label: "dongzuo4",
        duration: 3.333,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 1
      },
      {
        showId: 142,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1600311 step 142",
        group: "Idle",
        index: 2,
        actionId: "idle2",
        label: "注视2 (2)",
        duration: 10.0,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 2
      },
      {
        showId: 145,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1600311 step 145",
        group: "TapBody",
        index: 2,
        actionId: "dongzuo3",
        label: "亲近3",
        duration: 2.933,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 1
      }
    ]
  },
  {
    id: "200147_l2d",
    title: "剧情CG 200147",
    assetKind: "storycg",
    categoryLabel: "剧情CG",
    modelDir: "200147_l2d",
    sourceModelDir: "200147_l2d",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "localassets_win32",
    styleId: "",
    styleName: "剧情CG 200147",
    stage: "剧情CG",
    hitAreaNames: ["HitAreaBody"],
    followConfigs: [],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [{"id": "t_story_1600410:200147:1", "story": "t_story_1600410", "label": "剧情片段 1 · 26 句", "startStep": 52, "endStep": 100, "cues": [{"step": 54, "action": "dialog", "speaker": "雨仙", "subtitle": "别担心，我看得见，甚至看得比大多数人更清楚。", "voiceId": "16022320", "audioName": "vo_1600409_14_6016", "voices": {"cn": {"subtitle": "别担心，我看得见，甚至看得比大多数人更清楚。", "sound": "sounds/vo_1600409_14_6016.wav"}, "en": {"subtitle": "别担心，我看得见，甚至看得比大多数人更清楚。", "sound": "sounds/en_vo_1600409_14_6016.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle1", "label": "注视1", "duration": 8.0}}, {"step": 55, "action": "dialog", "speaker": "雨仙", "subtitle": "比如说，你刚到疗养院，我就注意到了你。", "voiceId": "16022321", "audioName": "vo_1600409_15_6016", "voices": {"cn": {"subtitle": "比如说，你刚到疗养院，我就注意到了你。", "sound": "sounds/vo_1600409_15_6016.wav"}, "en": {"subtitle": "比如说，你刚到疗养院，我就注意到了你。", "sound": "sounds/en_vo_1600409_15_6016.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle1", "label": "注视1", "duration": 8.0}}, {"step": 56, "action": "dialog", "speaker": "雨仙", "subtitle": "普通夜行者几乎不可能拥有这么庞大纯净的爱欲……你是爱欲钥匙持有者。", "voiceId": "16022626", "audioName": "vo_1600409_15a_6016", "voices": {"cn": {"subtitle": "普通夜行者几乎不可能拥有这么庞大纯净的爱欲……你是爱欲钥匙持有者。"}, "en": {"subtitle": "普通夜行者几乎不可能拥有这么庞大纯净的爱欲……你是爱欲钥匙持有者。"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle1", "label": "注视1", "duration": 8.0}}, {"step": 57, "action": "dialog", "speaker": "雨仙", "subtitle": "也许，你以为这件事隐藏得很好。", "voiceId": "16022322", "audioName": "vo_1600409_16_6016", "voices": {"cn": {"subtitle": "也许，你以为这件事隐藏得很好。", "sound": "sounds/vo_1600409_16_6016.wav"}, "en": {"subtitle": "也许，你以为这件事隐藏得很好。", "sound": "sounds/en_vo_1600409_16_6016.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle1", "label": "注视1", "duration": 8.0}}, {"step": 58, "action": "dialog", "speaker": "雨仙", "subtitle": "但在我眼里，你就像黑暗中的灯光、雨中的火焰一样明显。", "voiceId": "16022627", "audioName": "vo_1600409_16a_6016", "voices": {"cn": {"subtitle": "但在我眼里，你就像黑暗中的灯光、雨中的火焰一样明显。"}, "en": {"subtitle": "但在我眼里，你就像黑暗中的灯光、雨中的火焰一样明显。"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle1", "label": "注视1", "duration": 8.0}}, {"step": 67, "action": "dialog", "speaker": "雨仙", "subtitle": "呵……谁知道呢。也许我内心深处，希望有人能“看见”我。", "voiceId": "16022323", "audioName": "vo_1600409_17_6016", "voices": {"cn": {"subtitle": "呵……谁知道呢。也许我内心深处，希望有人能“看见”我。", "sound": "sounds/vo_1600409_17_6016.wav"}, "en": {"subtitle": "呵……谁知道呢。也许我内心深处，希望有人能“看见”我。", "sound": "sounds/en_vo_1600409_17_6016.wav"}}, "motion": {"group": "TapBody", "index": 1, "actionId": "chafen12_loop", "label": "chafen12_loop", "duration": 8.0}}, {"step": 68, "action": "dialog", "speaker": "雨仙", "subtitle": "不是作为圣子，不是作为雨仙，只是……看见。", "voiceId": "16022324", "audioName": "vo_1600409_17a_6016", "voices": {"cn": {"subtitle": "不是作为圣子，不是作为雨仙，只是……看见。", "sound": "sounds/vo_1600409_17a_6016.wav"}, "en": {"subtitle": "不是作为圣子，不是作为雨仙，只是……看见。", "sound": "sounds/en_vo_1600409_17a_6016.wav"}}, "motion": {"group": "TapBody", "index": 1, "actionId": "chafen12_loop", "label": "chafen12_loop", "duration": 8.0}}, {"step": 69, "action": "dialog", "speaker": "雨仙", "subtitle": "我在外院第一次见你，想的是又多了一件工具。", "voiceId": "16022325", "audioName": "vo_1600409_18_6016", "voices": {"cn": {"subtitle": "我在外院第一次见你，想的是又多了一件工具。", "sound": "sounds/vo_1600409_18_6016.wav"}, "en": {"subtitle": "我在外院第一次见你，想的是又多了一件工具。", "sound": "sounds/en_vo_1600409_18_6016.wav"}}, "motion": {"group": "TapBody", "index": 1, "actionId": "chafen12_loop", "label": "chafen12_loop", "duration": 8.0}}, {"step": 70, "action": "dialog", "speaker": "雨仙", "subtitle": "和那些长老、执事、信徒一样，可以被我利用、被我引导。", "voiceId": "16022628", "audioName": "vo_1600409_18a_6016", "voices": {"cn": {"subtitle": "和那些长老、执事、信徒一样，可以被我利用、被我引导。"}, "en": {"subtitle": "和那些长老、执事、信徒一样，可以被我利用、被我引导。"}}, "motion": {"group": "TapBody", "index": 1, "actionId": "chafen12_loop", "label": "chafen12_loop", "duration": 8.0}}, {"step": 71, "action": "dialog", "speaker": "雨仙", "subtitle": "但你在新人告解中破除了我的控制，在赌桌上没有被贪婪迷失本性。", "voiceId": "16022326", "audioName": "vo_1600409_19_6016", "voices": {"cn": {"subtitle": "但你在新人告解中破除了我的控制，在赌桌上没有被贪婪迷失本性。", "sound": "sounds/vo_1600409_19_6016.wav"}, "en": {"subtitle": "但你在新人告解中破除了我的控制，在赌桌上没有被贪婪迷失本性。", "sound": "sounds/en_vo_1600409_19_6016.wav"}}, "motion": {"group": "TapBody", "index": 1, "actionId": "chafen12_loop", "label": "chafen12_loop", "duration": 8.0}}, {"step": 72, "action": "dialog", "speaker": "雨仙", "subtitle": "在赦罪中反过来牵制了玛丽长老的试探。", "voiceId": "16022629", "audioName": "vo_1600409_19a_6016", "voices": {"cn": {"subtitle": "在赦罪中反过来牵制了玛丽长老的试探。"}, "en": {"subtitle": "在赦罪中反过来牵制了玛丽长老的试探。"}}, "motion": {"group": "TapBody", "index": 1, "actionId": "chafen12_loop", "label": "chafen12_loop", "duration": 8.0}}, {"step": 73, "action": "dialog", "speaker": "雨仙", "subtitle": "即便你戴上了圣子银戒，也没有成为长老的傀儡。依旧凭着自己的意志行动。", "voiceId": "16022327", "audioName": "vo_1600409_20_6016", "voices": {"cn": {"subtitle": "即便你戴上了圣子银戒，也没有成为长老的傀儡。依旧凭着自己的意志行动。", "sound": "sounds/vo_1600409_20_6016.wav"}, "en": {"subtitle": "即便你戴上了圣子银戒，也没有成为长老的傀儡。依旧凭着自己的意志行动。", "sound": "sounds/en_vo_1600409_20_6016.wav"}}, "motion": {"group": "TapBody", "index": 1, "actionId": "chafen12_loop", "label": "chafen12_loop", "duration": 8.0}}, {"step": 74, "action": "dialog", "speaker": "雨仙", "subtitle": "你坚韧的灵魂从不曲折，令我心生敬佩。", "voiceId": "16022328", "audioName": "vo_1600409_21_6016", "voices": {"cn": {"subtitle": "你坚韧的灵魂从不曲折，令我心生敬佩。", "sound": "sounds/vo_1600409_21_6016.wav"}, "en": {"subtitle": "你坚韧的灵魂从不曲折，令我心生敬佩。", "sound": "sounds/en_vo_1600409_21_6016.wav"}}, "motion": {"group": "TapBody", "index": 1, "actionId": "chafen12_loop", "label": "chafen12_loop", "duration": 8.0}}, {"step": 75, "action": "dialog", "speaker": "雨仙", "subtitle": "我开始不确定了。你到底是工具……还是别的什么。", "voiceId": "16022329", "audioName": "vo_1600409_22_6016", "voices": {"cn": {"subtitle": "我开始不确定了。你到底是工具……还是别的什么。", "sound": "sounds/vo_1600409_22_6016.wav"}, "en": {"subtitle": "我开始不确定了。你到底是工具……还是别的什么。", "sound": "sounds/en_vo_1600409_22_6016.wav"}}, "motion": {"group": "TapBody", "index": 1, "actionId": "chafen12_loop", "label": "chafen12_loop", "duration": 8.0}}, {"step": 82, "action": "dialog", "speaker": "雨仙", "subtitle": "很久没有人问过这个问题了。", "voiceId": "16022330", "audioName": "vo_1600409_23_6016", "voices": {"cn": {"subtitle": "很久没有人问过这个问题了。", "sound": "sounds/vo_1600409_23_6016.wav"}, "en": {"subtitle": "很久没有人问过这个问题了。", "sound": "sounds/en_vo_1600409_23_6016.wav"}}, "motion": {"group": "TapBody", "index": 1, "actionId": "chafen12_loop", "label": "chafen12_loop", "duration": 8.0}}, {"step": 83, "action": "dialog", "speaker": "雨仙", "subtitle": "当人们逐渐用圣子的标准要求我，疼痛就是恩赐、是试炼，不是值得倾诉的烦恼。", "voiceId": "16022331", "audioName": "vo_1600409_23a_6016", "voices": {"cn": {"subtitle": "当人们逐渐用圣子的标准要求我，疼痛就是恩赐、是试炼，不是值得倾诉的烦恼。", "sound": "sounds/vo_1600409_23a_6016.wav"}, "en": {"subtitle": "当人们逐渐用圣子的标准要求我，疼痛就是恩赐、是试炼，不是值得倾诉的烦恼。", "sound": "sounds/en_vo_1600409_23a_6016.wav"}}, "motion": {"group": "TapBody", "index": 1, "actionId": "chafen12_loop", "label": "chafen12_loop", "duration": 8.0}}, {"step": 84, "action": "dialog", "speaker": "雨仙", "subtitle": "我本来打算威胁你。", "voiceId": "16022332", "audioName": "vo_1600409_24_6016", "voices": {"cn": {"subtitle": "我本来打算威胁你。", "sound": "sounds/vo_1600409_24_6016.wav"}, "en": {"subtitle": "我本来打算威胁你。", "sound": "sounds/en_vo_1600409_24_6016.wav"}}, "motion": {"group": "TapBody", "index": 1, "actionId": "chafen12_loop", "label": "chafen12_loop", "duration": 8.0}}, {"step": 85, "action": "dialog", "speaker": "雨仙", "subtitle": "带你来水牢，是为了让你知道服从净雨之庭的下场。", "voiceId": "16022333", "audioName": "vo_1600409_25_6016", "voices": {"cn": {"subtitle": "带你来水牢，是为了让你知道服从净雨之庭的下场。", "sound": "sounds/vo_1600409_25_6016.wav"}, "en": {"subtitle": "带你来水牢，是为了让你知道服从净雨之庭的下场。", "sound": "sounds/en_vo_1600409_25_6016.wav"}}, "motion": {"group": "TapBody", "index": 1, "actionId": "chafen12_loop", "label": "chafen12_loop", "duration": 8.0}}, {"step": 86, "action": "dialog", "speaker": "雨仙", "subtitle": "摘下眼纱，是为了让你知道我能做到什么地步。", "voiceId": "16022630", "audioName": "vo_1600409_25a_6016", "voices": {"cn": {"subtitle": "摘下眼纱，是为了让你知道我能做到什么地步。"}, "en": {"subtitle": "摘下眼纱，是为了让你知道我能做到什么地步。"}}, "motion": {"group": "TapBody", "index": 1, "actionId": "chafen12_loop", "label": "chafen12_loop", "duration": 8.0}}, {"step": 87, "action": "dialog", "speaker": "雨仙", "subtitle": "然后，用威胁和引导让你听话，乖乖做我的工具。", "voiceId": "16022334", "audioName": "vo_1600409_26_6016", "voices": {"cn": {"subtitle": "然后，用威胁和引导让你听话，乖乖做我的工具。", "sound": "sounds/vo_1600409_26_6016.wav"}, "en": {"subtitle": "然后，用威胁和引导让你听话，乖乖做我的工具。", "sound": "sounds/en_vo_1600409_26_6016.wav"}}, "motion": {"group": "TapBody", "index": 1, "actionId": "chafen12_loop", "label": "chafen12_loop", "duration": 8.0}}, {"step": 89, "action": "dialog", "speaker": "雨仙", "subtitle": "但你让我出乎意料。", "voiceId": "16022335", "audioName": "vo_1600409_27_6016", "voices": {"cn": {"subtitle": "但你让我出乎意料。", "sound": "sounds/vo_1600409_27_6016.wav"}, "en": {"subtitle": "但你让我出乎意料。", "sound": "sounds/en_vo_1600409_27_6016.wav"}}, "motion": {"group": "TapBody", "index": 1, "actionId": "chafen12_loop", "label": "chafen12_loop", "duration": 8.0}}, {"step": 93, "action": "dialog", "speaker": "雨仙", "subtitle": "我在高处一个人待得太久了。只有你看见了我，所以，别走。", "voiceId": "16022336", "audioName": "vo_1600409_28_6016", "voices": {"cn": {"subtitle": "我在高处一个人待得太久了。只有你看见了我，所以，别走。", "sound": "sounds/vo_1600409_28_6016.wav"}, "en": {"subtitle": "我在高处一个人待得太久了。只有你看见了我，所以，别走。", "sound": "sounds/en_vo_1600409_28_6016.wav"}}, "motion": {"group": "TapBody", "index": 4, "actionId": "chafen3_loop", "label": "chafen3_loop", "duration": 6.5}}, {"step": 95, "action": "dialog", "speaker": "雨仙", "subtitle": "呵……你是第一个。因为你是第一个来找我，第一个凭自己的意志走到我面前的。", "voiceId": "16022337", "audioName": "vo_1600409_29_6016", "voices": {"cn": {"subtitle": "呵……你是第一个。因为你是第一个来找我，第一个凭自己的意志走到我面前的。", "sound": "sounds/vo_1600409_29_6016.wav"}, "en": {"subtitle": "呵……你是第一个。因为你是第一个来找我，第一个凭自己的意志走到我面前的。", "sound": "sounds/en_vo_1600409_29_6016.wav"}}, "motion": {"group": "TapBody", "index": 4, "actionId": "chafen3_loop", "label": "chafen3_loop", "duration": 6.5}}, {"step": 96, "action": "dialog", "speaker": "雨仙", "subtitle": "你既然戴上了戒指，成了我的半身……你就必须看着我。", "voiceId": "16022338", "audioName": "vo_1600409_30_6016", "voices": {"cn": {"subtitle": "你既然戴上了戒指，成了我的半身……你就必须看着我。", "sound": "sounds/vo_1600409_30_6016.wav"}, "en": {"subtitle": "你既然戴上了戒指，成了我的半身……你就必须看着我。", "sound": "sounds/en_vo_1600409_30_6016.wav"}}, "motion": {"group": "TapBody", "index": 4, "actionId": "chafen3_loop", "label": "chafen3_loop", "duration": 6.5}}, {"step": 97, "action": "dialog", "speaker": "雨仙", "subtitle": "哪怕这副躯壳已然腐烂，丑恶无比，你也不能移开双眼。明白吗？", "voiceId": "16022339", "audioName": "vo_1600409_31_6016", "voices": {"cn": {"subtitle": "哪怕这副躯壳已然腐烂，丑恶无比，你也不能移开双眼。明白吗？", "sound": "sounds/vo_1600409_31_6016.wav"}, "en": {"subtitle": "哪怕这副躯壳已然腐烂，丑恶无比，你也不能移开双眼。明白吗？", "sound": "sounds/en_vo_1600409_31_6016.wav"}}, "motion": {"group": "TapBody", "index": 4, "actionId": "chafen3_loop", "label": "chafen3_loop", "duration": 6.5}}, {"step": 98, "action": "dialog", "speaker": "雨仙", "subtitle": "和我一起，见证这里的终结。", "voiceId": "16022340", "audioName": "vo_1600409_32_6016", "voices": {"cn": {"subtitle": "和我一起，见证这里的终结。", "sound": "sounds/vo_1600409_32_6016.wav"}, "en": {"subtitle": "和我一起，见证这里的终结。", "sound": "sounds/en_vo_1600409_32_6016.wav"}}, "motion": {"group": "TapBody", "index": 4, "actionId": "chafen3_loop", "label": "chafen3_loop", "duration": 6.5}}]}],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle1", label: "注视1", duration: 8.0 }
        ]
      },
      {
        label: "TapBody",
        actions: [
          { group: "TapBody", index: 0, actionId: "chafen1", label: "chafen1", duration: 5.167 },
          { group: "TapBody", index: 1, actionId: "chafen12_loop", label: "chafen12_loop", duration: 8.0 },
          { group: "TapBody", index: 2, actionId: "chafen2", label: "chafen2", duration: 5.167 },
          { group: "TapBody", index: 3, actionId: "chafen3", label: "chafen3", duration: 4.0 },
          { group: "TapBody", index: 4, actionId: "chafen3_loop", label: "chafen3_loop", duration: 6.5 },
          { group: "TapBody", index: 5, actionId: "loop", label: "loop", duration: 5.6 }
        ]
      }
    ],
    clickShowActions: [
      {
        showId: 52,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1600410 step 52",
        group: "Idle",
        index: 0,
        actionId: "idle1",
        label: "注视1",
        duration: 8.0,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 1
      },
      {
        showId: 64,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1600410 step 64",
        group: "TapBody",
        index: 0,
        actionId: "chafen1",
        label: "chafen1",
        duration: 5.167,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 1
      },
      {
        showId: 64,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1600410 step 64",
        group: "TapBody",
        index: 1,
        actionId: "chafen12_loop",
        label: "chafen12_loop (2)",
        duration: 8.0,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 2
      },
      {
        showId: 79,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1600410 step 79",
        group: "TapBody",
        index: 2,
        actionId: "chafen2",
        label: "chafen2",
        duration: 5.167,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 1
      },
      {
        showId: 92,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1600410 step 92",
        group: "TapBody",
        index: 3,
        actionId: "chafen3",
        label: "chafen3",
        duration: 4.0,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 1
      },
      {
        showId: 92,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1600410 step 92",
        group: "TapBody",
        index: 4,
        actionId: "chafen3_loop",
        label: "chafen3_loop",
        duration: 6.5,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 1
      }
    ]
  },
  {
    id: "200149_l2d",
    title: "剧情CG 200149",
    assetKind: "storycg",
    categoryLabel: "剧情CG",
    modelDir: "200149_l2d",
    sourceModelDir: "200149_l2d",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "localassets_win32",
    styleId: "",
    styleName: "剧情CG 200149",
    stage: "剧情CG",
    hitAreaNames: ["HitAreaBody"],
    followConfigs: [],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [{"id": "t_story_1600414:200149:1", "story": "t_story_1600414", "label": "剧情片段 1 · 35 句", "startStep": 8, "endStep": 69, "cues": [{"step": 13, "action": "dialog", "speaker": "雨仙", "subtitle": "那是吉安长老发起的计划。", "voiceId": "16022439", "audioName": "vo_1600412_01_6016", "voices": {"cn": {"subtitle": "那是吉安长老发起的计划。", "sound": "sounds/vo_1600412_01_6016.wav"}, "en": {"subtitle": "那是吉安长老发起的计划。", "sound": "sounds/en_vo_1600412_01_6016.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle", "label": "默认", "duration": 3.967}}, {"step": 15, "action": "dialog", "speaker": "雨仙", "subtitle": "吉安长老曾是大学教授，是研究“欲望与文明”的哲学家。", "voiceId": "16022440", "audioName": "vo_1600412_02_6016", "voices": {"cn": {"subtitle": "吉安长老曾是大学教授，是研究“欲望与文明”的哲学家。", "sound": "sounds/vo_1600412_02_6016.wav"}, "en": {"subtitle": "吉安长老曾是大学教授，是研究“欲望与文明”的哲学家。", "sound": "sounds/en_vo_1600412_02_6016.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle", "label": "默认", "duration": 3.967}}, {"step": 16, "action": "dialog", "speaker": "雨仙", "subtitle": "他的妻子，因严重的战后创伤自杀。", "voiceId": "16022634", "audioName": "vo_1600412_02a_6016", "voices": {"cn": {"subtitle": "他的妻子，因严重的战后创伤自杀。", "sound": "sounds/vo_1600412_02a_6016.wav"}, "en": {"subtitle": "他的妻子，因严重的战后创伤自杀。", "sound": "sounds/en_vo_1600412_02a_6016.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle", "label": "默认", "duration": 3.967}}, {"step": 17, "action": "dialog", "speaker": "雨仙", "subtitle": "他试过所有的办法，药物、温泉疗养、咨询、甚至催眠……", "voiceId": "16022441", "audioName": "vo_1600412_03_6016", "voices": {"cn": {"subtitle": "他试过所有的办法，药物、温泉疗养、咨询、甚至催眠……", "sound": "sounds/vo_1600412_03_6016.wav"}, "en": {"subtitle": "他试过所有的办法，药物、温泉疗养、咨询、甚至催眠……", "sound": "sounds/en_vo_1600412_03_6016.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle", "label": "默认", "duration": 3.967}}, {"step": 18, "action": "dialog", "speaker": "雨仙", "subtitle": "对妻子被痛苦压垮的心并无帮助。", "voiceId": "16022635", "audioName": "vo_1600412_03a_6016", "voices": {"cn": {"subtitle": "对妻子被痛苦压垮的心并无帮助。", "sound": "sounds/vo_1600412_03a_6016.wav"}, "en": {"subtitle": "对妻子被痛苦压垮的心并无帮助。", "sound": "sounds/en_vo_1600412_03a_6016.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle", "label": "默认", "duration": 3.967}}, {"step": 19, "action": "dialog", "speaker": "雨仙", "subtitle": "他认定那是文明在压抑人类本能后，降下的诅咒。", "voiceId": "16022442", "audioName": "vo_1600412_04_6016", "voices": {"cn": {"subtitle": "他认定那是文明在压抑人类本能后，降下的诅咒。", "sound": "sounds/vo_1600412_04_6016.wav"}, "en": {"subtitle": "他认定那是文明在压抑人类本能后，降下的诅咒。", "sound": "sounds/en_vo_1600412_04_6016.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle", "label": "默认", "duration": 3.967}}, {"step": 20, "action": "dialog", "speaker": "雨仙", "subtitle": "因为无法原谅那个不让人发泄悲伤的世界，他来到了净雨之庭。", "voiceId": "16022443", "audioName": "vo_1600412_05_6016", "voices": {"cn": {"subtitle": "因为无法原谅那个不让人发泄悲伤的世界，他来到了净雨之庭。", "sound": "sounds/vo_1600412_05_6016.wav"}, "en": {"subtitle": "因为无法原谅那个不让人发泄悲伤的世界，他来到了净雨之庭。", "sound": "sounds/en_vo_1600412_05_6016.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle", "label": "默认", "duration": 3.967}}, {"step": 21, "action": "dialog", "speaker": "雨仙", "subtitle": "他告诉我，他要为我，也为了全人类，建立一个不需要压抑欲望、永远没有眼泪的乌托邦。", "voiceId": "16022444", "audioName": "vo_1600412_06_6016", "voices": {"cn": {"subtitle": "他告诉我，他要为我，也为了全人类，建立一个不需要压抑欲望、永远没有眼泪的乌托邦。", "sound": "sounds/vo_1600412_06_6016.wav"}, "en": {"subtitle": "他告诉我，他要为我，也为了全人类，建立一个不需要压抑欲望、永远没有眼泪的乌托邦。", "sound": "sounds/en_vo_1600412_06_6016.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle", "label": "默认", "duration": 3.967}}, {"step": 22, "action": "dialog", "speaker": "雨仙", "subtitle": "为了这个伟大的理想，一些牺牲，只是微不足道的代价。", "voiceId": "16022445", "audioName": "vo_1600412_07_6016", "voices": {"cn": {"subtitle": "为了这个伟大的理想，一些牺牲，只是微不足道的代价。", "sound": "sounds/vo_1600412_07_6016.wav"}, "en": {"subtitle": "为了这个伟大的理想，一些牺牲，只是微不足道的代价。", "sound": "sounds/en_vo_1600412_07_6016.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle", "label": "默认", "duration": 3.967}}, {"step": 23, "action": "dialog", "speaker": "雨仙", "subtitle": "可能是学校方面的关系，他接触了“赞助人”。", "voiceId": "16022446", "audioName": "vo_1600412_08_6016", "voices": {"cn": {"subtitle": "可能是学校方面的关系，他接触了“赞助人”。", "sound": "sounds/vo_1600412_08_6016.wav"}, "en": {"subtitle": "可能是学校方面的关系，他接触了“赞助人”。", "sound": "sounds/en_vo_1600412_08_6016.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle", "label": "默认", "duration": 3.967}}, {"step": 24, "action": "dialog", "speaker": "雨仙", "subtitle": "然后慢慢地把净雨之庭改造成疗养院，开始了爱欲实验。", "voiceId": "16022636", "audioName": "vo_1600412_08a_6016", "voices": {"cn": {"subtitle": "然后慢慢地把净雨之庭改造成疗养院，开始了爱欲实验。", "sound": "sounds/vo_1600412_08a_6016.wav"}, "en": {"subtitle": "然后慢慢地把净雨之庭改造成疗养院，开始了爱欲实验。", "sound": "sounds/en_vo_1600412_08a_6016.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle", "label": "默认", "duration": 3.967}}, {"step": 25, "action": "dialog", "speaker": "雨仙", "subtitle": "但他始终没说赞助人是谁，我们只知道那是一些学者。", "voiceId": "16022447", "audioName": "vo_1600412_09_6016", "voices": {"cn": {"subtitle": "但他始终没说赞助人是谁，我们只知道那是一些学者。", "sound": "sounds/vo_1600412_09_6016.wav"}, "en": {"subtitle": "但他始终没说赞助人是谁，我们只知道那是一些学者。", "sound": "sounds/en_vo_1600412_09_6016.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle", "label": "默认", "duration": 3.967}}, {"step": 26, "action": "dialog", "speaker": "雨仙", "subtitle": "不过，罗曼帝国的学者，可以说比星星还多。", "voiceId": "16022637", "audioName": "vo_1600412_09a_6016", "voices": {"cn": {"subtitle": "不过，罗曼帝国的学者，可以说比星星还多。", "sound": "sounds/vo_1600412_09a_6016.wav"}, "en": {"subtitle": "不过，罗曼帝国的学者，可以说比星星还多。", "sound": "sounds/en_vo_1600412_09a_6016.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle", "label": "默认", "duration": 3.967}}, {"step": 28, "action": "dialog", "speaker": "雨仙", "subtitle": "……是吗。", "voiceId": "16022448", "audioName": "vo_1600412_10_6016", "voices": {"cn": {"subtitle": "……是吗。", "sound": "sounds/vo_1600412_10_6016.wav"}, "en": {"subtitle": "……是吗。", "sound": "sounds/en_vo_1600412_10_6016.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle", "label": "默认", "duration": 3.967}}, {"step": 31, "action": "dialog", "speaker": "雨仙", "subtitle": "呵……你以为阿刻斯商会的走私链曝光是意外？", "voiceId": "16022449", "audioName": "vo_1600412_11_6016", "voices": {"cn": {"subtitle": "呵……你以为阿刻斯商会的走私链曝光是意外？", "sound": "sounds/vo_1600412_11_6016.wav"}, "en": {"subtitle": "呵……你以为阿刻斯商会的走私链曝光是意外？", "sound": "sounds/en_vo_1600412_11_6016.wav"}}, "motion": {"group": "Idle", "index": 1, "actionId": "idle2", "label": "注视2", "duration": 3.967}}, {"step": 32, "action": "cameraanim", "speaker": "雨仙", "subtitle": "你以为夜行公会收到的那些匿名举报信，是正义之士的呐喊？", "voiceId": "16022638", "audioName": "vo_1600412_11a_6016", "voices": {"cn": {"subtitle": "你以为夜行公会收到的那些匿名举报信，是正义之士的呐喊？", "sound": "sounds/vo_1600412_11a_6016.wav"}, "en": {"subtitle": "你以为夜行公会收到的那些匿名举报信，是正义之士的呐喊？", "sound": "sounds/en_vo_1600412_11a_6016.wav"}}, "motion": {"group": "Idle", "index": 1, "actionId": "idle2", "label": "注视2", "duration": 3.967}}, {"step": 33, "action": "dialog", "speaker": "雨仙", "subtitle": "放纵阿刻斯商会的贪婪，煽动一些疗养院的人员。", "voiceId": "16022450", "audioName": "vo_1600412_12_6016", "voices": {"cn": {"subtitle": "放纵阿刻斯商会的贪婪，煽动一些疗养院的人员。", "sound": "sounds/vo_1600412_12_6016.wav"}, "en": {"subtitle": "放纵阿刻斯商会的贪婪，煽动一些疗养院的人员。", "sound": "sounds/en_vo_1600412_12_6016.wav"}}, "motion": {"group": "Idle", "index": 1, "actionId": "idle2", "label": "注视2", "duration": 3.967}}, {"step": 34, "action": "dialog", "speaker": "雨仙", "subtitle": "或者用适量的圣水加上言语疏导让人配合，很容易就能达到这个结果。", "voiceId": "16022639", "audioName": "vo_1600412_12a_6016", "voices": {"cn": {"subtitle": "或者用适量的圣水加上言语疏导让人配合，很容易就能达到这个结果。", "sound": "sounds/vo_1600412_12a_6016.wav"}, "en": {"subtitle": "或者用适量的圣水加上言语疏导让人配合，很容易就能达到这个结果。", "sound": "sounds/en_vo_1600412_12a_6016.wav"}}, "motion": {"group": "Idle", "index": 1, "actionId": "idle2", "label": "注视2", "duration": 3.967}}, {"step": 35, "action": "dialog", "speaker": "雨仙", "subtitle": "在我设置的条件下，接公会任务的人需要能调查城市灰色产业的罪恶链条，能和各家族周旋并承担报复的风险，还不会被精神控制问题吓退。", "voiceId": "16022451", "audioName": "vo_1600412_13_6016", "voices": {"cn": {"subtitle": "在我设置的条件下，接公会任务的人需要能调查城市灰色产业的罪恶链条，能和各家族周旋并承担报复的风险，还不会被精神控制问题吓退。", "sound": "sounds/vo_1600412_13_6016.wav"}, "en": {"subtitle": "在我设置的条件下，接公会任务的人需要能调查城市灰色产业的罪恶链条，能和各家族周旋并承担报复的风险，还不会被精神控制问题吓退。", "sound": "sounds/en_vo_1600412_13_6016.wav"}}, "motion": {"group": "Idle", "index": 1, "actionId": "idle2", "label": "注视2", "duration": 3.967}}, {"step": 36, "action": "dialog", "speaker": "雨仙", "subtitle": "最后来的，一定是有胆量和野心、有一定实力、信念强大的人。", "voiceId": "16022452", "audioName": "vo_1600412_14_6016", "voices": {"cn": {"subtitle": "最后来的，一定是有胆量和野心、有一定实力、信念强大的人。", "sound": "sounds/vo_1600412_14_6016.wav"}, "en": {"subtitle": "最后来的，一定是有胆量和野心、有一定实力、信念强大的人。", "sound": "sounds/en_vo_1600412_14_6016.wav"}}, "motion": {"group": "Idle", "index": 1, "actionId": "idle2", "label": "注视2", "duration": 3.967}}, {"step": 37, "action": "dialog", "speaker": "雨仙", "subtitle": "我有把握和这种人谈合作。", "voiceId": "16022640", "audioName": "vo_1600412_14a_6016", "voices": {"cn": {"subtitle": "我有把握和这种人谈合作。", "sound": "sounds/vo_1600412_14a_6016.wav"}, "en": {"subtitle": "我有把握和这种人谈合作。", "sound": "sounds/en_vo_1600412_14a_6016.wav"}}, "motion": {"group": "Idle", "index": 1, "actionId": "idle2", "label": "注视2", "duration": 3.967}}, {"step": 38, "action": "dialog", "speaker": "雨仙", "subtitle": "所以……", "voiceId": "16022453", "audioName": "vo_1600412_15_6016", "voices": {"cn": {"subtitle": "所以……", "sound": "sounds/vo_1600412_15_6016.wav"}, "en": {"subtitle": "所以……", "sound": "sounds/en_vo_1600412_15_6016.wav"}}, "motion": {"group": "Idle", "index": 1, "actionId": "idle2", "label": "注视2", "duration": 3.967}}, {"step": 42, "action": "dialog", "speaker": "雨仙", "subtitle": "你是我一手挑选、一手制造的同谋。", "voiceId": "16022455", "audioName": "vo_1600412_16_6016", "voices": {"cn": {"subtitle": "你是我一手挑选、一手制造的同谋。", "sound": "sounds/vo_1600412_16_6016.wav"}, "en": {"subtitle": "你是我一手挑选、一手制造的同谋。", "sound": "sounds/en_vo_1600412_16_6016.wav"}}, "motion": {"group": "TapBody", "index": 1, "actionId": "chafen1_loop", "label": "chafen1_loop", "duration": 3.967}}, {"step": 43, "action": "dialog", "speaker": "雨仙", "subtitle": "但我没想到……雨神送给我的，比我预想的更好。", "voiceId": "16022456", "audioName": "vo_1600412_17_6016", "voices": {"cn": {"subtitle": "但我没想到……雨神送给我的，比我预想的更好。", "sound": "sounds/vo_1600412_17_6016.wav"}, "en": {"subtitle": "但我没想到……雨神送给我的，比我预想的更好。", "sound": "sounds/en_vo_1600412_17_6016.wav"}}, "motion": {"group": "TapBody", "index": 1, "actionId": "chafen1_loop", "label": "chafen1_loop", "duration": 3.967}}, {"step": 44, "action": "dialog", "speaker": "雨仙", "subtitle": "你有爱欲钥匙，简直是为了摧毁这里量身定做的完美武器。", "voiceId": "16022641", "audioName": "vo_1600412_17a_6016", "voices": {"cn": {"subtitle": "你有爱欲钥匙，简直是为了摧毁这里量身定做的完美武器。", "sound": "sounds/vo_1600412_17a_6016.wav"}, "en": {"subtitle": "你有爱欲钥匙，简直是为了摧毁这里量身定做的完美武器。", "sound": "sounds/en_vo_1600412_17a_6016.wav"}}, "motion": {"group": "TapBody", "index": 1, "actionId": "chafen1_loop", "label": "chafen1_loop", "duration": 3.967}}, {"step": 45, "action": "dialog", "speaker": "雨仙", "subtitle": "我不后悔利用你，但我确实愧对你。这就是我的忏悔。", "voiceId": "16022457", "audioName": "vo_1600412_18_6016", "voices": {"cn": {"subtitle": "我不后悔利用你，但我确实愧对你。这就是我的忏悔。", "sound": "sounds/vo_1600412_18_6016.wav"}, "en": {"subtitle": "我不后悔利用你，但我确实愧对你。这就是我的忏悔。", "sound": "sounds/en_vo_1600412_18_6016.wav"}}, "motion": {"group": "TapBody", "index": 1, "actionId": "chafen1_loop", "label": "chafen1_loop", "duration": 3.967}}, {"step": 56, "action": "dialog", "speaker": "雨仙", "subtitle": "呵呵……哈哈哈哈……", "voiceId": "16022458", "audioName": "vo_1600412_19_6016", "voices": {"cn": {"subtitle": "呵呵……哈哈哈哈……", "sound": "sounds/vo_1600412_19_6016.wav"}, "en": {"subtitle": "呵呵……哈哈哈哈……", "sound": "sounds/en_vo_1600412_19_6016.wav"}}, "motion": {"group": "TapBody", "index": 3, "actionId": "chafen2_loop", "label": "chafen2_loop", "duration": 3.967}}, {"step": 57, "action": "dialog", "speaker": "雨仙", "subtitle": "我从未见过你这样的灵魂，不祈求神明的宽恕，不畏惧罪孽的重量。", "voiceId": "16022459", "audioName": "vo_1600412_20_6016", "voices": {"cn": {"subtitle": "我从未见过你这样的灵魂，不祈求神明的宽恕，不畏惧罪孽的重量。", "sound": "sounds/vo_1600412_20_6016.wav"}, "en": {"subtitle": "我从未见过你这样的灵魂，不祈求神明的宽恕，不畏惧罪孽的重量。", "sound": "sounds/en_vo_1600412_20_6016.wav"}}, "motion": {"group": "TapBody", "index": 3, "actionId": "chafen2_loop", "label": "chafen2_loop", "duration": 3.967}}, {"step": 58, "action": "dialog", "speaker": "雨仙", "subtitle": "我以为我选择了你，到最后，我才是你选择的人。", "voiceId": "16022460", "audioName": "vo_1600412_20a_6016", "voices": {"cn": {"subtitle": "我以为我选择了你，到最后，我才是你选择的人。", "sound": "sounds/vo_1600412_20a_6016.wav"}, "en": {"subtitle": "我以为我选择了你，到最后，我才是你选择的人。", "sound": "sounds/en_vo_1600412_20a_6016.wav"}}, "motion": {"group": "TapBody", "index": 3, "actionId": "chafen2_loop", "label": "chafen2_loop", "duration": 3.967}}, {"step": 59, "action": "dialog", "speaker": "雨仙", "subtitle": "原来如此，今夜我才洞见了自身的傲慢。", "voiceId": "16022461", "audioName": "vo_1600412_21_6016", "voices": {"cn": {"subtitle": "原来如此，今夜我才洞见了自身的傲慢。", "sound": "sounds/vo_1600412_21_6016.wav"}, "en": {"subtitle": "原来如此，今夜我才洞见了自身的傲慢。", "sound": "sounds/en_vo_1600412_21_6016.wav"}}, "motion": {"group": "TapBody", "index": 3, "actionId": "chafen2_loop", "label": "chafen2_loop", "duration": 3.967}}, {"step": 60, "action": "dialog", "speaker": "雨仙", "subtitle": "我开始感到可惜，为何上天不能让你早点出现在我面前……", "voiceId": "16022642", "audioName": "vo_1600412_21a_6016", "voices": {"cn": {"subtitle": "我开始感到可惜，为何上天不能让你早点出现在我面前……", "sound": "sounds/vo_1600412_21a_6016.wav"}, "en": {"subtitle": "我开始感到可惜，为何上天不能让你早点出现在我面前……", "sound": "sounds/en_vo_1600412_21a_6016.wav"}}, "motion": {"group": "TapBody", "index": 3, "actionId": "chafen2_loop", "label": "chafen2_loop", "duration": 3.967}}, {"step": 61, "action": "dialog", "speaker": "雨仙", "subtitle": "我曾经跪在这里，向我敬爱又憎恨的神明祈祷，祈祷这虚伪的一切早日毁灭。", "voiceId": "16022462", "audioName": "vo_1600412_22_6016", "voices": {"cn": {"subtitle": "我曾经跪在这里，向我敬爱又憎恨的神明祈祷，祈祷这虚伪的一切早日毁灭。", "sound": "sounds/vo_1600412_22_6016.wav"}, "en": {"subtitle": "我曾经跪在这里，向我敬爱又憎恨的神明祈祷，祈祷这虚伪的一切早日毁灭。", "sound": "sounds/en_vo_1600412_22_6016.wav"}}, "motion": {"group": "TapBody", "index": 3, "actionId": "chafen2_loop", "label": "chafen2_loop", "duration": 3.967}}, {"step": 62, "action": "dialog", "speaker": "雨仙", "subtitle": "但今晚……我向我心中的神祷告，为何我心中的神，却变成了你的模样？", "voiceId": "16022463", "audioName": "vo_1600412_23_6016", "voices": {"cn": {"subtitle": "但今晚……我向我心中的神祷告，为何我心中的神，却变成了你的模样？", "sound": "sounds/vo_1600412_23_6016.wav"}, "en": {"subtitle": "但今晚……我向我心中的神祷告，为何我心中的神，却变成了你的模样？", "sound": "sounds/en_vo_1600412_23_6016.wav"}}, "motion": {"group": "TapBody", "index": 3, "actionId": "chafen2_loop", "label": "chafen2_loop", "duration": 3.967}}, {"step": 63, "action": "dialog", "speaker": "雨仙", "subtitle": "明天，当我在他们面前亲手砸碎神国之路，当我成为最大的罪人……", "voiceId": "16022464", "audioName": "vo_1600412_24_6016", "voices": {"cn": {"subtitle": "明天，当我在他们面前亲手砸碎神国之路，当我成为最大的罪人……", "sound": "sounds/vo_1600412_24_6016.wav"}, "en": {"subtitle": "明天，当我在他们面前亲手砸碎神国之路，当我成为最大的罪人……", "sound": "sounds/en_vo_1600412_24_6016.wav"}}, "motion": {"group": "TapBody", "index": 3, "actionId": "chafen2_loop", "label": "chafen2_loop", "duration": 3.967}}, {"step": 64, "action": "dialog", "speaker": "雨仙", "subtitle": "到那时，请你继续看着我。", "voiceId": "16022465", "audioName": "vo_1600412_25_6016", "voices": {"cn": {"subtitle": "到那时，请你继续看着我。", "sound": "sounds/vo_1600412_25_6016.wav"}, "en": {"subtitle": "到那时，请你继续看着我。", "sound": "sounds/en_vo_1600412_25_6016.wav"}}, "motion": {"group": "TapBody", "index": 3, "actionId": "chafen2_loop", "label": "chafen2_loop", "duration": 3.967}}]}],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 3.967 },
          { group: "Idle", index: 1, actionId: "idle2", label: "注视2", duration: 3.967 },
          { group: "Idle", index: 2, actionId: "idle3", label: "idle3", duration: 7.967 }
        ]
      },
      {
        label: "TapBody",
        actions: [
          { group: "TapBody", index: 0, actionId: "chafen1", label: "chafen1", duration: 3.967 },
          { group: "TapBody", index: 1, actionId: "chafen1_loop", label: "chafen1_loop", duration: 3.967 },
          { group: "TapBody", index: 2, actionId: "chafen2", label: "chafen2", duration: 4.833 },
          { group: "TapBody", index: 3, actionId: "chafen2_loop", label: "chafen2_loop", duration: 3.967 },
          { group: "TapBody", index: 4, actionId: "chafen3", label: "chafen3", duration: 3.967 }
        ]
      }
    ],
    clickShowActions: [
      {
        showId: 8,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1600414 step 8",
        group: "Idle",
        index: 0,
        actionId: "idle",
        label: "默认",
        duration: 3.967,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 1
      },
      {
        showId: 30,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1600414 step 30",
        group: "Idle",
        index: 1,
        actionId: "idle2",
        label: "注视2",
        duration: 3.967,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 1
      },
      {
        showId: 40,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1600414 step 40",
        group: "TapBody",
        index: 0,
        actionId: "chafen1",
        label: "chafen1",
        duration: 3.967,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 1
      },
      {
        showId: 40,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1600414 step 40",
        group: "TapBody",
        index: 1,
        actionId: "chafen1_loop",
        label: "chafen1_loop",
        duration: 3.967,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 1
      },
      {
        showId: 55,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1600414 step 55",
        group: "TapBody",
        index: 2,
        actionId: "chafen2",
        label: "chafen2",
        duration: 4.833,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 1
      },
      {
        showId: 55,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1600414 step 55",
        group: "TapBody",
        index: 3,
        actionId: "chafen2_loop",
        label: "chafen2_loop",
        duration: 3.967,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 1
      },
      {
        showId: 65,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1600414 step 65",
        group: "TapBody",
        index: 4,
        actionId: "chafen3",
        label: "chafen3",
        duration: 3.967,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 1
      },
      {
        showId: 65,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1600414 step 65",
        group: "Idle",
        index: 2,
        actionId: "idle3",
        label: "idle3",
        duration: 7.967,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 1
      }
    ]
  },
  {
    id: "200151_l2d",
    title: "剧情CG 200151",
    assetKind: "storycg",
    categoryLabel: "剧情CG",
    modelDir: "200151_l2d",
    sourceModelDir: "200151_l2d",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "localassets_win32",
    styleId: "",
    styleName: "剧情CG 200151",
    stage: "剧情CG",
    hitAreaNames: ["HitAreaBody"],
    followConfigs: [],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [{"id": "t_story_1600409:200151:1", "story": "t_story_1600409", "label": "剧情片段 1 · 6 句", "startStep": 59, "endStep": 80, "cues": [{"step": 64, "action": "dialog", "speaker": "卡塔西斯", "subtitle": "这怎么能叫绑？这是一场……在神明见证下的神圣缔结。", "voiceId": "16022283", "audioName": "vo_1600408_13_6016", "voices": {"cn": {"subtitle": "这怎么能叫绑？这是一场……在神明见证下的神圣缔结。", "sound": "sounds/vo_1600408_13_6016.wav"}, "en": {"subtitle": "这怎么能叫绑？这是一场……在神明见证下的神圣缔结。", "sound": "sounds/en_vo_1600408_13_6016.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle", "label": "默认", "duration": 5.0}}, {"step": 65, "action": "dialog", "speaker": "卡塔西斯", "subtitle": "因为我选择了你，雨神选择了你。", "voiceId": "16022284", "audioName": "vo_1600408_13a_6016", "voices": {"cn": {"subtitle": "因为我选择了你，雨神选择了你。", "sound": "sounds/vo_1600408_13a_6016.wav"}, "en": {"subtitle": "因为我选择了你，雨神选择了你。", "sound": "sounds/en_vo_1600408_13a_6016.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle", "label": "默认", "duration": 5.0}}, {"step": 67, "action": "dialog", "speaker": "卡塔西斯", "subtitle": "风景绝佳，只要你不恐高。还有……别松开我的手。", "voiceId": "16022285", "audioName": "vo_1600408_14_6016", "voices": {"cn": {"subtitle": "风景绝佳，只要你不恐高。还有……别松开我的手。", "sound": "sounds/vo_1600408_14_6016.wav"}, "en": {"subtitle": "风景绝佳，只要你不恐高。还有……别松开我的手。", "sound": "sounds/en_vo_1600408_14_6016.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle", "label": "默认", "duration": 5.0}}, {"step": 75, "action": "dialog", "speaker": "卡塔西斯", "subtitle": "从现在起，你在净雨之庭拥有和我一样的地位。你可以分享我的荣光、我的权力。", "voiceId": "16022286", "audioName": "vo_1600408_15_6016", "voices": {"cn": {"subtitle": "从现在起，你在净雨之庭拥有和我一样的地位。你可以分享我的荣光、我的权力。", "sound": "sounds/vo_1600408_15_6016.wav"}, "en": {"subtitle": "从现在起，你在净雨之庭拥有和我一样的地位。你可以分享我的荣光、我的权力。", "sound": "sounds/en_vo_1600408_15_6016.wav"}}, "motion": {"group": "TapBody", "index": 2, "actionId": "chafen2", "label": "chafen2", "duration": 5.333}}, {"step": 76, "action": "dialog", "speaker": "卡塔西斯", "subtitle": "但记住……跌落神坛的代价，是粉身碎骨。无论天堂还是地狱，你都必须和我同在。", "voiceId": "16022287", "audioName": "vo_1600408_16_6016", "voices": {"cn": {"subtitle": "但记住……跌落神坛的代价，是粉身碎骨。无论天堂还是地狱，你都必须和我同在。", "sound": "sounds/vo_1600408_16_6016.wav"}, "en": {"subtitle": "但记住……跌落神坛的代价，是粉身碎骨。无论天堂还是地狱，你都必须和我同在。", "sound": "sounds/en_vo_1600408_16_6016.wav"}}, "motion": {"group": "TapBody", "index": 2, "actionId": "chafen2", "label": "chafen2", "duration": 5.333}}, {"step": 78, "action": "dialog", "speaker": "", "subtitle": "卡塔西斯愉快地轻笑，我们交握的手也被连带着轻轻晃动。", "voiceId": "16022288", "audioName": "vo_1600408_17_6016", "voices": {"cn": {"subtitle": "卡塔西斯愉快地轻笑，我们交握的手也被连带着轻轻晃动。", "sound": "sounds/vo_1600408_17_6016.wav"}, "en": {"subtitle": "卡塔西斯愉快地轻笑，我们交握的手也被连带着轻轻晃动。", "sound": "sounds/en_vo_1600408_17_6016.wav"}}, "motion": {"group": "TapBody", "index": 2, "actionId": "chafen2", "label": "chafen2", "duration": 5.333}}]}],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 5.0 }
        ]
      },
      {
        label: "TapBody",
        actions: [
          { group: "TapBody", index: 0, actionId: "chafen1", label: "chafen1", duration: 7.0 },
          { group: "TapBody", index: 1, actionId: "chafen1_loop", label: "chafen1_loop", duration: 5.0 },
          { group: "TapBody", index: 2, actionId: "chafen2", label: "chafen2", duration: 5.333 }
        ]
      }
    ],
    clickShowActions: [
      {
        showId: 59,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1600409 step 59",
        group: "Idle",
        index: 0,
        actionId: "idle",
        label: "默认",
        duration: 5.0,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 1
      },
      {
        showId: 68,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1600409 step 68",
        group: "TapBody",
        index: 0,
        actionId: "chafen1",
        label: "chafen1",
        duration: 7.0,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 1
      },
      {
        showId: 68,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1600409 step 68",
        group: "TapBody",
        index: 1,
        actionId: "chafen1_loop",
        label: "chafen1_loop",
        duration: 5.0,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 1
      },
      {
        showId: 71,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1600409 step 71",
        group: "TapBody",
        index: 2,
        actionId: "chafen2",
        label: "chafen2",
        duration: 5.333,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 1
      }
    ]
  },
  {
    id: "200162_l2d",
    title: "剧情CG 200162",
    assetKind: "storycg",
    categoryLabel: "剧情CG",
    modelDir: "200162_l2d",
    sourceModelDir: "200162_l2d",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "localassets_win32",
    styleId: "",
    styleName: "剧情CG 200162",
    stage: "剧情CG",
    hitAreaNames: ["HitAreaBody"],
    followConfigs: [],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [{"id": "t_story_1600419:200162:1", "story": "t_story_1600419", "label": "剧情片段 1 · 7 句", "startStep": 159, "endStep": 175, "cues": [{"step": 165, "action": "dialog", "speaker": "雨仙", "subtitle": "世人总想从天上寻找答案。", "voiceId": "16022612", "audioName": "vo_1600416_25_6016", "voices": {"cn": {"subtitle": "世人总想从天上寻找答案。", "sound": "sounds/vo_1600416_25_6016.wav"}, "en": {"subtitle": "世人总想从天上寻找答案。", "sound": "sounds/en_vo_1600416_25_6016.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle", "label": "默认", "duration": 3.667}}, {"step": 166, "action": "dialog", "speaker": "雨仙", "subtitle": "他们以为雨水能洗净罪孽，以为神明能代为受过。", "voiceId": "16022613", "audioName": "vo_1600416_26_6016", "voices": {"cn": {"subtitle": "他们以为雨水能洗净罪孽，以为神明能代为受过。", "sound": "sounds/vo_1600416_26_6016.wav"}, "en": {"subtitle": "他们以为雨水能洗净罪孽，以为神明能代为受过。", "sound": "sounds/en_vo_1600416_26_6016.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle", "label": "默认", "duration": 3.667}}, {"step": 167, "action": "dialog", "speaker": "雨仙", "subtitle": "但欲望从未消失，痛苦也从未远离。", "voiceId": "16022614", "audioName": "vo_1600416_27_6016", "voices": {"cn": {"subtitle": "但欲望从未消失，痛苦也从未远离。", "sound": "sounds/vo_1600416_27_6016.wav"}, "en": {"subtitle": "但欲望从未消失，痛苦也从未远离。", "sound": "sounds/en_vo_1600416_27_6016.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle", "label": "默认", "duration": 3.667}}, {"step": 168, "action": "cameraanim", "speaker": "雨仙", "subtitle": "我们只能在泥泞中跋涉，带着伤疤，清醒地活下去。", "voiceId": "16022615", "audioName": "vo_1600416_28_6016", "voices": {"cn": {"subtitle": "我们只能在泥泞中跋涉，带着伤疤，清醒地活下去。", "sound": "sounds/vo_1600416_28_6016.wav"}, "en": {"subtitle": "我们只能在泥泞中跋涉，带着伤疤，清醒地活下去。", "sound": "sounds/en_vo_1600416_28_6016.wav"}}, "motion": {"group": "Idle", "index": 0, "actionId": "idle", "label": "默认", "duration": 3.667}}, {"step": 171, "action": "dialog", "speaker": "雨仙", "subtitle": "雨只是回到了它原本的样子。", "voiceId": "16022616", "audioName": "vo_1600416_29_6016", "voices": {"cn": {"subtitle": "雨只是回到了它原本的样子。", "sound": "sounds/vo_1600416_29_6016.wav"}, "en": {"subtitle": "雨只是回到了它原本的样子。", "sound": "sounds/en_vo_1600416_29_6016.wav"}}, "motion": {"group": "Idle", "index": 1, "actionId": "idle1", "label": "注视1", "duration": 3.667}}, {"step": 172, "action": "dialog", "speaker": "雨仙", "subtitle": "从天空坠落，落在泥土里。", "voiceId": "16022617", "audioName": "vo_1600416_30_6016", "voices": {"cn": {"subtitle": "从天空坠落，落在泥土里。", "sound": "sounds/vo_1600416_30_6016.wav"}, "en": {"subtitle": "从天空坠落，落在泥土里。", "sound": "sounds/en_vo_1600416_30_6016.wav"}}, "motion": {"group": "Idle", "index": 1, "actionId": "idle1", "label": "注视1", "duration": 3.667}}, {"step": 173, "action": "dialog", "speaker": "雨仙", "subtitle": "落在罪人与善人的肩膀上。", "voiceId": "16022618", "audioName": "vo_1600416_31_6016", "voices": {"cn": {"subtitle": "落在罪人与善人的肩膀上。", "sound": "sounds/vo_1600416_31_6016.wav"}, "en": {"subtitle": "落在罪人与善人的肩膀上。", "sound": "sounds/en_vo_1600416_31_6016.wav"}}, "motion": {"group": "Idle", "index": 1, "actionId": "idle1", "label": "注视1", "duration": 3.667}}]}],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 3.667 },
          { group: "Idle", index: 1, actionId: "idle1", label: "注视1", duration: 3.667 }
        ]
      },
      {
        label: "TapBody",
        actions: [
          { group: "TapBody", index: 0, actionId: "bonong", label: "bonong", duration: 4.6 },
          { group: "TapBody", index: 1, actionId: "loop", label: "loop", duration: 7.267 }
        ]
      }
    ],
    clickShowActions: [
      {
        showId: 159,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1600419 step 159",
        group: "Idle",
        index: 0,
        actionId: "idle",
        label: "默认",
        duration: 3.667,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 1
      },
      {
        showId: 170,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1600419 step 170",
        group: "TapBody",
        index: 0,
        actionId: "bonong",
        label: "bonong",
        duration: 4.6,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 1
      },
      {
        showId: 170,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1600419 step 170",
        group: "Idle",
        index: 1,
        actionId: "idle1",
        label: "注视1",
        duration: 3.667,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 1
      }
    ]
  },
  {
    id: "200202_l2d",
    title: "剧情CG 200202",
    assetKind: "storycg",
    categoryLabel: "剧情CG",
    modelDir: "200202_l2d",
    sourceModelDir: "200202_l2d",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "localassets_win32",
    styleId: "",
    styleName: "剧情CG 200202",
    stage: "剧情CG",
    hitAreaNames: ["HitAreaBody"],
    followConfigs: [],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [{"id": "t_story_1600112:200202:1", "story": "t_story_1600112", "label": "剧情片段 1 · 21 句", "startStep": 116, "endStep": 156, "cues": [{"step": 127, "action": "dialog", "speaker": "观众A", "subtitle": "命运之轮！", "voiceId": "16010688", "audioName": "vo_1600112_70_guanzhongA", "voices": {"cn": {"subtitle": "命运之轮！", "sound": "sounds/vo_1600112_70_guanzhongA.wav"}, "en": {"subtitle": "命运之轮！", "sound": "sounds/en_vo_1600112_70_guanzhongA.wav"}}}, {"step": 128, "action": "dialog", "speaker": "观众B", "subtitle": "这意味着又有人闯到了最后一关，有资格与愚者大人进行最终博弈！", "voiceId": "16010689", "audioName": "vo_1600112_71_guanzhongB", "voices": {"cn": {"subtitle": "这意味着又有人闯到了最后一关，有资格与愚者大人进行最终博弈！", "sound": "sounds/vo_1600112_71_guanzhongB.wav"}, "en": {"subtitle": "这意味着又有人闯到了最后一关，有资格与愚者大人进行最终博弈！", "sound": "sounds/en_vo_1600112_71_guanzhongB.wav"}}}, {"step": 129, "action": "dialog", "speaker": "观众B", "subtitle": "而我们也得以又一次看见最刺激最精彩的对决！", "voiceId": "16010690", "audioName": "vo_1600112_72_guanzhongB", "voices": {"cn": {"subtitle": "而我们也得以又一次看见最刺激最精彩的对决！", "sound": "sounds/vo_1600112_72_guanzhongB.wav"}, "en": {"subtitle": "而我们也得以又一次看见最刺激最精彩的对决！", "sound": "sounds/en_vo_1600112_72_guanzhongB.wav"}}}, {"step": 130, "action": "dialog", "speaker": "观众B", "subtitle": "你死我亡的那种！", "voiceId": "16010691", "audioName": "vo_1600112_73_guanzhongB", "voices": {"cn": {"subtitle": "你死我亡的那种！", "sound": "sounds/vo_1600112_73_guanzhongB.wav"}, "en": {"subtitle": "你死我亡的那种！", "sound": "sounds/en_vo_1600112_73_guanzhongB.wav"}}}, {"step": 131, "action": "dialog", "speaker": "观众A", "subtitle": "愚者大人，愚者大人！", "voiceId": "16010692", "audioName": "vo_1600112_74_guanzhongA", "voices": {"cn": {"subtitle": "愚者大人，愚者大人！", "sound": "sounds/vo_1600112_74_guanzhongA.wav"}, "en": {"subtitle": "愚者大人，愚者大人！", "sound": "sounds/en_vo_1600112_74_guanzhongA.wav"}}}, {"step": 132, "action": "dialog", "speaker": "观众B", "subtitle": "终于又可以看到愚者大人是如何玩弄对手的了！", "voiceId": "16010693", "audioName": "vo_1600112_75_guanzhongB", "voices": {"cn": {"subtitle": "终于又可以看到愚者大人是如何玩弄对手的了！", "sound": "sounds/vo_1600112_75_guanzhongB.wav"}, "en": {"subtitle": "终于又可以看到愚者大人是如何玩弄对手的了！", "sound": "sounds/en_vo_1600112_75_guanzhongB.wav"}}}, {"step": 133, "action": "dialog", "speaker": "观众A", "subtitle": "这次你要投多少？", "voiceId": "16010694", "audioName": "vo_1600112_76_guanzhongA", "voices": {"cn": {"subtitle": "这次你要投多少？", "sound": "sounds/vo_1600112_76_guanzhongA.wav"}, "en": {"subtitle": "这次你要投多少？", "sound": "sounds/en_vo_1600112_76_guanzhongA.wav"}}}, {"step": 134, "action": "dialog", "speaker": "观众A", "subtitle": "不投吧，这个赔率没有赚头……等等！", "voiceId": "16010695", "audioName": "vo_1600112_77_guanzhongB", "voices": {"cn": {"subtitle": "不投吧，这个赔率没有赚头……等等！", "sound": "sounds/vo_1600112_77_guanzhongB.wav"}, "en": {"subtitle": "不投吧，这个赔率没有赚头……等等！", "sound": "sounds/en_vo_1600112_77_guanzhongB.wav"}}}, {"step": 136, "action": "dialog", "speaker": "观众A", "subtitle": "怎么会这样……愚者大人这次的对手是谁？", "voiceId": "16010696", "audioName": "vo_1600112_78_guanzhongA", "voices": {"cn": {"subtitle": "怎么会这样……愚者大人这次的对手是谁？", "sound": "sounds/vo_1600112_78_guanzhongA.wav"}, "en": {"subtitle": "怎么会这样……愚者大人这次的对手是谁？", "sound": "sounds/en_vo_1600112_78_guanzhongA.wav"}}}, {"step": 138, "action": "dialog", "speaker": "观众B", "subtitle": "咦？那是……", "voiceId": "16010697", "audioName": "vo_1600112_79_guanzhongB", "voices": {"cn": {"subtitle": "咦？那是……", "sound": "sounds/vo_1600112_79_guanzhongB.wav"}, "en": {"subtitle": "咦？那是……", "sound": "sounds/en_vo_1600112_79_guanzhongB.wav"}}}, {"step": 139, "action": "dialog", "speaker": "梅花J", "subtitle": "是那个新来的女人。", "voiceId": "16010698", "audioName": "vo_1600112_80_7096", "voices": {"cn": {"subtitle": "是那个新来的女人。", "sound": "sounds/vo_1600112_80_7096.wav"}, "en": {"subtitle": "是那个新来的女人。", "sound": "sounds/en_vo_1600112_80_7096.wav"}}}, {"step": 141, "action": "dialog", "speaker": "观众B", "subtitle": "我记得你，你是第一个输给她的人。", "voiceId": "16010699", "audioName": "vo_1600112_81_guanzhongB", "voices": {"cn": {"subtitle": "我记得你，你是第一个输给她的人。", "sound": "sounds/vo_1600112_81_guanzhongB.wav"}, "en": {"subtitle": "我记得你，你是第一个输给她的人。", "sound": "sounds/en_vo_1600112_81_guanzhongB.wav"}}}, {"step": 142, "action": "dialog", "speaker": "观众A", "subtitle": "你……你不会投了她？", "voiceId": "16010700", "audioName": "vo_1600112_82_guanzhongA", "voices": {"cn": {"subtitle": "你……你不会投了她？", "sound": "sounds/vo_1600112_82_guanzhongA.wav"}, "en": {"subtitle": "你……你不会投了她？", "sound": "sounds/en_vo_1600112_82_guanzhongA.wav"}}}, {"step": 143, "action": "dialog", "speaker": "梅花J", "subtitle": "……", "voiceId": "16010701", "audioName": "vo_1600112_83_7096", "voices": {"cn": {"subtitle": "……", "sound": "sounds/vo_1600112_83_7096.wav"}, "en": {"subtitle": "……", "sound": "sounds/en_vo_1600112_83_7096.wav"}}}, {"step": 144, "action": "dialog", "speaker": "观众A", "subtitle": "你就是投了她！", "voiceId": "16010702", "audioName": "vo_1600112_84_guanzhongA", "voices": {"cn": {"subtitle": "你就是投了她！", "sound": "sounds/vo_1600112_84_guanzhongA.wav"}, "en": {"subtitle": "你就是投了她！", "sound": "sounds/en_vo_1600112_84_guanzhongA.wav"}}}, {"step": 145, "action": "dialog", "speaker": "观众B", "subtitle": "为什么？", "voiceId": "16010703", "audioName": "vo_1600112_85_guanzhongB", "voices": {"cn": {"subtitle": "为什么？", "sound": "sounds/vo_1600112_85_guanzhongB.wav"}, "en": {"subtitle": "为什么？", "sound": "sounds/en_vo_1600112_85_guanzhongB.wav"}}}, {"step": 146, "action": "dialog", "speaker": "梅花J", "subtitle": "如果你和她对决过，你会明白的。", "voiceId": "16010704", "audioName": "vo_1600112_86_7096", "voices": {"cn": {"subtitle": "如果你和她对决过，你会明白的。", "sound": "sounds/vo_1600112_86_7096.wav"}, "en": {"subtitle": "如果你和她对决过，你会明白的。", "sound": "sounds/en_vo_1600112_86_7096.wav"}}}, {"step": 147, "action": "dialog", "speaker": "梅花J", "subtitle": "你看，这才多久，她就踏上了“命运之轮”。", "voiceId": "16010705", "audioName": "vo_1600112_87_7096", "voices": {"cn": {"subtitle": "你看，这才多久，她就踏上了“命运之轮”。", "sound": "sounds/vo_1600112_87_7096.wav"}, "en": {"subtitle": "你看，这才多久，她就踏上了“命运之轮”。", "sound": "sounds/en_vo_1600112_87_7096.wav"}}}, {"step": 148, "action": "dialog", "speaker": "梅花J", "subtitle": "这难道不是奇迹吗？", "voiceId": "16010706", "audioName": "vo_1600112_88_7096", "voices": {"cn": {"subtitle": "这难道不是奇迹吗？", "sound": "sounds/vo_1600112_88_7096.wav"}, "en": {"subtitle": "这难道不是奇迹吗？", "sound": "sounds/en_vo_1600112_88_7096.wav"}}}, {"step": 149, "action": "dialog", "speaker": "梅花J", "subtitle": "我为什么不能期待第二个奇迹？", "voiceId": "16010707", "audioName": "vo_1600112_89_7096", "voices": {"cn": {"subtitle": "我为什么不能期待第二个奇迹？", "sound": "sounds/vo_1600112_89_7096.wav"}, "en": {"subtitle": "我为什么不能期待第二个奇迹？", "sound": "sounds/en_vo_1600112_89_7096.wav"}}}, {"step": 150, "action": "dialog", "speaker": "梅花J", "subtitle": "何况，如果总是愚者赢……会有人觉得无聊的。", "voiceId": "16010708", "audioName": "vo_1600112_90_7096", "voices": {"cn": {"subtitle": "何况，如果总是愚者赢……会有人觉得无聊的。", "sound": "sounds/vo_1600112_90_7096.wav"}, "en": {"subtitle": "何况，如果总是愚者赢……会有人觉得无聊的。", "sound": "sounds/en_vo_1600112_90_7096.wav"}}}]}, {"id": "t_story_1600113:200202:2", "story": "t_story_1600113", "label": "剧情片段 2 · 15 句", "startStep": 10, "endStep": 105, "cues": [{"step": 26, "action": "dialog", "speaker": "愚者", "subtitle": "每一个轮次都需要抽签，抽到死亡签的人需要对自己开至少一枪。", "voiceId": "16010711", "audioName": "vo_1600113_03_6004", "voices": {"cn": {"subtitle": "每一个轮次都需要抽签，抽到死亡签的人需要对自己开至少一枪。", "sound": "sounds/vo_1600113_03_6004.wav"}, "en": {"subtitle": "每一个轮次都需要抽签，抽到死亡签的人需要对自己开至少一枪。", "sound": "sounds/en_vo_1600113_03_6004.wav"}}, "motion": {"group": "TapBody", "index": 2, "actionId": "kaiqiang_loop", "label": "kaiqiang_loop", "duration": 3.97}}, {"step": 27, "action": "dialog", "speaker": "愚者", "subtitle": "六个膛室，一颗实弹。", "voiceId": "16010712", "audioName": "vo_1600113_04_6004", "voices": {"cn": {"subtitle": "六个膛室，一颗实弹。", "sound": "sounds/vo_1600113_04_6004.wav"}, "en": {"subtitle": "六个膛室，一颗实弹。", "sound": "sounds/en_vo_1600113_04_6004.wav"}}, "motion": {"group": "TapBody", "index": 2, "actionId": "kaiqiang_loop", "label": "kaiqiang_loop", "duration": 3.97}}, {"step": 28, "action": "dialog", "speaker": "愚者", "subtitle": "幸好我的幸运彩票还没有过期。", "voiceId": "16010713", "audioName": "vo_1600113_05_6004", "voices": {"cn": {"subtitle": "幸好我的幸运彩票还没有过期。", "sound": "sounds/vo_1600113_05_6004.wav"}, "en": {"subtitle": "幸好我的幸运彩票还没有过期。", "sound": "sounds/en_vo_1600113_05_6004.wav"}}, "motion": {"group": "TapBody", "index": 2, "actionId": "kaiqiang_loop", "label": "kaiqiang_loop", "duration": 3.97}}, {"step": 29, "action": "dialog", "speaker": "愚者", "subtitle": "“恋人”，该你了。", "voiceId": "16010714", "audioName": "vo_1600113_06_6004", "voices": {"cn": {"subtitle": "“恋人”，该你了。", "sound": "sounds/vo_1600113_06_6004.wav"}, "en": {"subtitle": "“恋人”，该你了。", "sound": "sounds/en_vo_1600113_06_6004.wav"}}, "motion": {"group": "TapBody", "index": 2, "actionId": "kaiqiang_loop", "label": "kaiqiang_loop", "duration": 3.97}}, {"step": 31, "action": "dialog", "speaker": "观众A", "subtitle": "这是第一个抽到“恋人”牌的人……", "voiceId": "16010715", "audioName": "vo_1600113_07_guanzhongA", "voices": {"cn": {"subtitle": "这是第一个抽到“恋人”牌的人……", "sound": "sounds/vo_1600113_07_guanzhongA.wav"}, "en": {"subtitle": "这是第一个抽到“恋人”牌的人……", "sound": "sounds/en_vo_1600113_07_guanzhongA.wav"}}, "motion": {"group": "TapBody", "index": 2, "actionId": "kaiqiang_loop", "label": "kaiqiang_loop", "duration": 3.97}}, {"step": 32, "action": "dialog", "speaker": "观众B", "subtitle": "真期待，“恋人”的死法……", "voiceId": "16010716", "audioName": "vo_1600113_08_guanzhongB", "voices": {"cn": {"subtitle": "真期待，“恋人”的死法……", "sound": "sounds/vo_1600113_08_guanzhongB.wav"}, "en": {"subtitle": "真期待，“恋人”的死法……", "sound": "sounds/en_vo_1600113_08_guanzhongB.wav"}}, "motion": {"group": "TapBody", "index": 2, "actionId": "kaiqiang_loop", "label": "kaiqiang_loop", "duration": 3.97}}, {"step": 34, "action": "dialog", "speaker": "愚者", "subtitle": "第二局开始了。", "voiceId": "16010717", "audioName": "vo_1600113_09_6004", "voices": {"cn": {"subtitle": "第二局开始了。", "sound": "sounds/vo_1600113_09_6004.wav"}, "en": {"subtitle": "第二局开始了。", "sound": "sounds/en_vo_1600113_09_6004.wav"}}, "motion": {"group": "TapBody", "index": 2, "actionId": "kaiqiang_loop", "label": "kaiqiang_loop", "duration": 3.97}}, {"step": 47, "action": "dialog", "speaker": "观众A", "subtitle": "好可恶的女人，愚者大人，赶紧让她死！！！", "voiceId": "16010718", "audioName": "vo_1600113_10_guanzhongA", "voices": {"cn": {"subtitle": "好可恶的女人，愚者大人，赶紧让她死！！！", "sound": "sounds/vo_1600113_10_guanzhongA.wav"}, "en": {"subtitle": "好可恶的女人，愚者大人，赶紧让她死！！！", "sound": "sounds/en_vo_1600113_10_guanzhongA.wav"}}, "motion": {"group": "TapBody", "index": 2, "actionId": "kaiqiang_loop", "label": "kaiqiang_loop", "duration": 3.97}}, {"step": 48, "action": "dialog", "speaker": "观众B", "subtitle": "好帅……", "voiceId": "16010719", "audioName": "vo_1600113_11_guanzhongB", "voices": {"cn": {"subtitle": "好帅……", "sound": "sounds/vo_1600113_11_guanzhongB.wav"}, "en": {"subtitle": "好帅……", "sound": "sounds/en_vo_1600113_11_guanzhongB.wav"}}, "motion": {"group": "TapBody", "index": 2, "actionId": "kaiqiang_loop", "label": "kaiqiang_loop", "duration": 3.97}}, {"step": 49, "action": "dialog", "speaker": "观众B", "subtitle": "我觉得我已经爱上她了，我要买她赢……", "voiceId": "16010721", "audioName": "vo_1600113_13_guanzhongB", "voices": {"cn": {"subtitle": "我觉得我已经爱上她了，我要买她赢……", "sound": "sounds/vo_1600113_13_guanzhongB.wav"}, "en": {"subtitle": "我觉得我已经爱上她了，我要买她赢……", "sound": "sounds/en_vo_1600113_13_guanzhongB.wav"}}, "motion": {"group": "TapBody", "index": 2, "actionId": "kaiqiang_loop", "label": "kaiqiang_loop", "duration": 3.97}}, {"step": 50, "action": "dialog", "speaker": "观众A", "subtitle": "你是不是有病？！", "voiceId": "16010722", "audioName": "vo_1600113_14_guanzhongA", "voices": {"cn": {"subtitle": "你是不是有病？！", "sound": "sounds/vo_1600113_14_guanzhongA.wav"}, "en": {"subtitle": "你是不是有病？！", "sound": "sounds/en_vo_1600113_14_guanzhongA.wav"}}, "motion": {"group": "TapBody", "index": 2, "actionId": "kaiqiang_loop", "label": "kaiqiang_loop", "duration": 3.97}}, {"step": 69, "action": "dialog", "speaker": "愚者", "subtitle": "你的信息素很好闻。", "voiceId": "16010723", "audioName": "vo_1600113_15_6004", "voices": {"cn": {"subtitle": "你的信息素很好闻。", "sound": "sounds/vo_1600113_15_6004.wav"}, "en": {"subtitle": "你的信息素很好闻。", "sound": "sounds/en_vo_1600113_15_6004.wav"}}, "motion": {"group": "TapBody", "index": 2, "actionId": "kaiqiang_loop", "label": "kaiqiang_loop", "duration": 3.97}}, {"step": 72, "action": "dialog", "speaker": "愚者", "subtitle": "来吧，我的脑子全都是你。", "voiceId": "16010724", "audioName": "vo_1600113_16_6004", "voices": {"cn": {"subtitle": "来吧，我的脑子全都是你。", "sound": "sounds/vo_1600113_16_6004.wav"}, "en": {"subtitle": "来吧，我的脑子全都是你。", "sound": "sounds/en_vo_1600113_16_6004.wav"}}, "motion": {"group": "TapBody", "index": 2, "actionId": "kaiqiang_loop", "label": "kaiqiang_loop", "duration": 3.97}}, {"step": 88, "action": "dialog", "speaker": "愚者", "subtitle": "真不幸，看来留给我的是死亡签。", "voiceId": "16010725", "audioName": "vo_1600113_17_6004", "voices": {"cn": {"subtitle": "真不幸，看来留给我的是死亡签。", "sound": "sounds/vo_1600113_17_6004.wav"}, "en": {"subtitle": "真不幸，看来留给我的是死亡签。", "sound": "sounds/en_vo_1600113_17_6004.wav"}}, "motion": {"group": "TapBody", "index": 2, "actionId": "kaiqiang_loop", "label": "kaiqiang_loop", "duration": 3.97}}, {"step": 103, "action": "dialog", "speaker": "愚者", "subtitle": "规则是至少一枪，我为自己附赠了一枪。可惜还是没中。", "voiceId": "16010726", "audioName": "vo_1600113_18_6004", "voices": {"cn": {"subtitle": "规则是至少一枪，我为自己附赠了一枪。可惜还是没中。", "sound": "sounds/vo_1600113_18_6004.wav"}, "en": {"subtitle": "规则是至少一枪，我为自己附赠了一枪。可惜还是没中。", "sound": "sounds/en_vo_1600113_18_6004.wav"}}, "motion": {"group": "TapBody", "index": 2, "actionId": "kaiqiang_loop", "label": "kaiqiang_loop", "duration": 3.97}}]}, {"id": "t_story_1600113:200202:3", "story": "t_story_1600113", "label": "剧情片段 3 · 10 句", "startStep": 116, "endStep": 138, "cues": [{"step": 118, "action": "dialog", "speaker": "愚者", "subtitle": "现在，我的“恋人”，该你了。", "voiceId": "16010727", "audioName": "vo_1600113_19_6004", "voices": {"cn": {"subtitle": "现在，我的“恋人”，该你了。", "sound": "sounds/vo_1600113_19_6004.wav"}, "en": {"subtitle": "现在，我的“恋人”，该你了。", "sound": "sounds/en_vo_1600113_19_6004.wav"}}}, {"step": 120, "action": "dialog", "speaker": "愚者", "subtitle": "顺便一提，这一次抽中死亡签的……一定是你。", "voiceId": "16010728", "audioName": "vo_1600113_20_6004", "voices": {"cn": {"subtitle": "顺便一提，这一次抽中死亡签的……一定是你。", "sound": "sounds/vo_1600113_20_6004.wav"}, "en": {"subtitle": "顺便一提，这一次抽中死亡签的……一定是你。", "sound": "sounds/en_vo_1600113_20_6004.wav"}}}, {"step": 122, "action": "dialog", "speaker": "愚者", "subtitle": "是的。", "voiceId": "16010729", "audioName": "vo_1600113_21_6004", "voices": {"cn": {"subtitle": "是的。", "sound": "sounds/vo_1600113_21_6004.wav"}, "en": {"subtitle": "是的。", "sound": "sounds/en_vo_1600113_21_6004.wav"}}}, {"step": 124, "action": "dialog", "speaker": "愚者", "subtitle": "现在我说任何理由都像是借口。", "voiceId": "16010730", "audioName": "vo_1600113_22_6004", "voices": {"cn": {"subtitle": "现在我说任何理由都像是借口。", "sound": "sounds/vo_1600113_22_6004.wav"}, "en": {"subtitle": "现在我说任何理由都像是借口。", "sound": "sounds/en_vo_1600113_22_6004.wav"}}}, {"step": 125, "action": "dialog", "speaker": "愚者", "subtitle": "再说背叛本来就是不需要任何理由。", "voiceId": "16010731", "audioName": "vo_1600113_23_6004", "voices": {"cn": {"subtitle": "再说背叛本来就是不需要任何理由。", "sound": "sounds/vo_1600113_23_6004.wav"}, "en": {"subtitle": "再说背叛本来就是不需要任何理由。", "sound": "sounds/en_vo_1600113_23_6004.wav"}}}, {"step": 126, "action": "dialog", "speaker": "愚者", "subtitle": "你忘记了吗？我拿到的第一张牌可不是“愚者”，而是“倒吊人”。", "voiceId": "16010732", "audioName": "vo_1600113_24_6004", "voices": {"cn": {"subtitle": "你忘记了吗？我拿到的第一张牌可不是“愚者”，而是“倒吊人”。", "sound": "sounds/vo_1600113_24_6004.wav"}, "en": {"subtitle": "你忘记了吗？我拿到的第一张牌可不是“愚者”，而是“倒吊人”。", "sound": "sounds/en_vo_1600113_24_6004.wav"}}}, {"step": 127, "action": "dialog", "speaker": "愚者", "subtitle": "背叛不是一种选择，而是一种能力。", "voiceId": "16010733", "audioName": "vo_1600113_25_6004", "voices": {"cn": {"subtitle": "背叛不是一种选择，而是一种能力。", "sound": "sounds/vo_1600113_25_6004.wav"}, "en": {"subtitle": "背叛不是一种选择，而是一种能力。", "sound": "sounds/en_vo_1600113_25_6004.wav"}}}, {"step": 128, "action": "dialog", "speaker": "愚者", "subtitle": "我很欣赏你改变命运的努力。", "voiceId": "16010734", "audioName": "vo_1600113_26_6004", "voices": {"cn": {"subtitle": "我很欣赏你改变命运的努力。", "sound": "sounds/vo_1600113_26_6004.wav"}, "en": {"subtitle": "我很欣赏你改变命运的努力。", "sound": "sounds/en_vo_1600113_26_6004.wav"}}}, {"step": 134, "action": "dialog", "speaker": "愚者", "subtitle": "但命运是无法改变的。", "voiceId": "16010735", "audioName": "vo_1600113_27_6004", "voices": {"cn": {"subtitle": "但命运是无法改变的。", "sound": "sounds/vo_1600113_27_6004.wav"}, "en": {"subtitle": "但命运是无法改变的。", "sound": "sounds/en_vo_1600113_27_6004.wav"}}}, {"step": 135, "action": "dialog", "speaker": "愚者", "subtitle": "在结束之前，让我为你讲一个流传在失乐园里的寓言故事。", "voiceId": "16010736", "audioName": "vo_1600113_28_6004", "voices": {"cn": {"subtitle": "在结束之前，让我为你讲一个流传在失乐园里的寓言故事。", "sound": "sounds/vo_1600113_28_6004.wav"}, "en": {"subtitle": "在结束之前，让我为你讲一个流传在失乐园里的寓言故事。", "sound": "sounds/en_vo_1600113_28_6004.wav"}}}]}],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 3.967 }
        ]
      },
      {
        label: "TapBody",
        actions: [
          { group: "TapBody", index: 0, actionId: "kaiqiang", label: "kaiqiang", duration: 4.5 },
          { group: "TapBody", index: 1, actionId: "kaiqiang2", label: "kaiqiang2", duration: 0.97 },
          { group: "TapBody", index: 2, actionId: "kaiqiang_loop", label: "kaiqiang_loop", duration: 3.97 },
          { group: "TapBody", index: 3, actionId: "loop", label: "loop", duration: 15.97 },
          { group: "TapBody", index: 4, actionId: "weixiao", label: "weixiao", duration: 3.97 },
          { group: "TapBody", index: 5, actionId: "weixiao_loop", label: "weixiao_loop", duration: 3.97 }
        ]
      }
    ],
    clickShowActions: [
      {
        showId: 21,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1600113 step 21",
        group: "TapBody",
        index: 0,
        actionId: "kaiqiang",
        label: "kaiqiang (4)",
        duration: 4.5,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 4
      },
      {
        showId: 21,
        audioId: 0,
        audioName: "",
        desc: "剧情脚本 t_story_1600113 step 21",
        group: "TapBody",
        index: 2,
        actionId: "kaiqiang_loop",
        label: "kaiqiang_loop (4)",
        duration: 3.97,
        voices: {},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 0,
        weight: 4
      }
    ]
  },
  {
    id: "25100102_yl",
    title: "野狼 · 荣光未褪 时装",
    assetKind: "skin",
    categoryLabel: "角色",
    modelDir: "25100102_yl",
    sourceModelDir: "25100102_yl",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "localassets_win32",
    styleId: "",
    styleName: "野狼 · 荣光未褪",
    stage: "时装",
    hitAreaNames: ["HitAreaBody", "HitAreaHandL", "HitAreaHead", "HitAreaChange_ParamDiy", "HitAreaMoren", "HitAreadianji2", "HitAreaChangjing", "HitAreadianji1", "HitAreatuozhuai"],
    followConfigs: [{"id": 1046, "prefab": "25100102_yl", "activeName": "", "expressionName": "", "damping": 0.0, "parameters": [{"parameterId": "Param17", "axis": "X", "factor": 2.0, "sourceToken": "Param17#2*X"}, {"parameterId": "ParamEyeBallX", "axis": "X", "factor": 19.0, "sourceToken": "ParamEyeBallX#19*X"}, {"parameterId": "ParamEyeBallY", "axis": "Y", "factor": 40.0, "sourceToken": "ParamEyeBallY#40*Y"}, {"parameterId": "ParamAngleX", "axis": "X", "factor": 19.0, "sourceToken": "ParamAngleX#19*X"}, {"parameterId": "ParamAngleY", "axis": "Y", "factor": 40.0, "sourceToken": "ParamAngleY#40*Y"}, {"parameterId": "ParamAngleZ", "axis": "X", "factor": 4.0, "sourceToken": "ParamAngleZ#4*X"}, {"parameterId": "ParamBodyAngleX", "axis": "X", "factor": 4.0, "sourceToken": "ParamBodyAngleX#4*X"}, {"parameterId": "Param197", "axis": "Y", "factor": 8.0, "sourceToken": "Param197#8*Y"}, {"parameterId": "Param10", "axis": "X", "factor": -1.0, "sourceToken": "Param10#-1*X"}]}, {"id": 30004, "prefab": "25100102_yl", "activeName": "HitAreatuozhuai", "expressionName": "", "damping": 0.0, "parameters": [{"parameterId": "Paramtuozhuai", "axis": "Y", "factor": 100.0, "sourceToken": "Paramtuozhuai#100*Y"}]}],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 6.633 }
        ]
      },
      {
        label: "TapBody",
        actions: [
          { group: "TapBody", index: 0, actionId: "bianhua", label: "bianhua", duration: 11.467 },
          { group: "TapBody", index: 1, actionId: "dianji1", label: "dianji1", duration: 8.8 },
          { group: "TapBody", index: 2, actionId: "dianji2", label: "dianji2", duration: 9.733 },
          { group: "TapBody", index: 3, actionId: "diantou", label: "diantou", duration: 3.3 },
          { group: "TapBody", index: 4, actionId: "loop", label: "loop", duration: 6.633 },
          { group: "TapBody", index: 5, actionId: "qianqing", label: "qianqing", duration: 3.3 },
          { group: "TapBody", index: 6, actionId: "taishou", label: "taishou", duration: 3.967 },
          { group: "TapBody", index: 7, actionId: "tuozhuai", label: "tuozhuai", duration: 7.6 },
          { group: "TapBody", index: 8, actionId: "waitou", label: "waitou", duration: 3.3 },
          { group: "TapBody", index: 9, actionId: "yaotou", label: "yaotou", duration: 3.3 }
        ]
      },
      {
        label: "入场",
        actions: [
          { group: "Entry", index: 0, actionId: "ruchang", label: "入场", duration: 10.667 }
        ]
      }
    ],
    clickShowActions: [
      {
        showId: 600102010,
        audioId: 60010004,
        audioName: "vo_6001_daiji_01",
        desc: "点击-通用1",
        group: "TapBody",
        index: 2,
        actionId: "dianji2",
        label: "dianji2",
        duration: 9.733,
        voices: {"cn": {"subtitle": "吵着要保护你的人是我，可是你不在，我连打架都不安心。也许，是你在保护我……", "sound": "sounds/vo_6001_daiji_01.wav"}, "en": {"subtitle": "吵着要保护你的人是我，可是你不在，我连打架都不安心。也许，是你在保护我……", "sound": "sounds/en_vo_6001_daiji_01.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 600102011,
        audioId: 60010005,
        audioName: "vo_6001_daiji_02",
        desc: "点击-通用2",
        group: "TapBody",
        index: 8,
        actionId: "waitou",
        label: "waitou",
        duration: 3.3,
        voices: {"cn": {"subtitle": "有人说我像BOSS的狗？哼，我乐意，狗可比有些人更懂得忠诚。", "sound": "sounds/vo_6001_daiji_02.wav"}, "en": {"subtitle": "有人说我像BOSS的狗？哼，我乐意，狗可比有些人更懂得忠诚。", "sound": "sounds/en_vo_6001_daiji_02.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 600102012,
        audioId: 60010212,
        audioName: "vo_600102_haogan_01",
        desc: "点击-闲聊1",
        group: "TapBody",
        index: 7,
        actionId: "tuozhuai",
        label: "tuozhuai",
        duration: 7.6,
        voices: {"cn": {"subtitle": "当英雄太累了，要管那么多人的死活。我脑子笨，我只管你一个人的死活就行。", "sound": "sounds/vo_600102_haogan_01.wav"}, "en": {"subtitle": "当英雄太累了，要管那么多人的死活。我脑子笨，我只管你一个人的死活就行。", "sound": "sounds/en_vo_600102_haogan_01.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 10,
        weight: 10
      },
      {
        showId: 600102013,
        audioId: 60010213,
        audioName: "vo_600102_haogan_02",
        desc: "点击-闲聊2",
        group: "TapBody",
        index: 2,
        actionId: "dianji2",
        label: "dianji2",
        duration: 9.733,
        voices: {"cn": {"subtitle": "赢了比赛的战士可以获得奖品……那我要你的气味，留在我身上再久一点。", "sound": "sounds/vo_600102_haogan_02.wav"}, "en": {"subtitle": "赢了比赛的战士可以获得奖品……那我要你的气味，留在我身上再久一点。", "sound": "sounds/en_vo_600102_haogan_02.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 10,
        weight: 10
      },
      {
        showId: 600102014,
        audioId: 60010214,
        audioName: "vo_600102_haogan_03",
        desc: "点击-闲聊3",
        group: "TapBody",
        index: 5,
        actionId: "qianqing",
        label: "qianqing",
        duration: 3.3,
        voices: {"cn": {"subtitle": "你看别的战士干嘛？他没我力气大，一拳就被我撂倒了，你只看我一个好不好？", "sound": "sounds/vo_600102_haogan_03.wav"}, "en": {"subtitle": "你看别的战士干嘛？他没我力气大，一拳就被我撂倒了，你只看我一个好不好？", "sound": "sounds/en_vo_600102_haogan_03.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 10,
        weight: 10
      },
      {
        showId: 600102015,
        audioId: 60010216,
        audioName: "vo_600102_haogan_05",
        desc: "点击-赞扬1",
        group: "TapBody",
        index: 0,
        actionId: "bianhua",
        label: "bianhua",
        duration: 11.467,
        voices: {"cn": {"subtitle": "你在我身边的时候，我就是这世上最强大的战士。", "sound": "sounds/vo_600102_haogan_05.wav"}, "en": {"subtitle": "你在我身边的时候，我就是这世上最强大的战士。", "sound": "sounds/en_vo_600102_haogan_05.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 10,
        weight: 10
      },
      {
        showId: 600102016,
        audioId: 60010201,
        audioName: "vo_600102_dianchu_tou",
        desc: "点击-头",
        group: "TapBody",
        index: 1,
        actionId: "dianji1",
        label: "dianji1",
        duration: 8.8,
        voices: {"cn": {"subtitle": "战士的头脑里从没有输这个字眼，只要你一个眼神的肯定，我就能为你横扫一切敌人。", "sound": "sounds/vo_600102_dianchu_tou.wav"}, "en": {"subtitle": "战士的头脑里从没有输这个字眼，只要你一个眼神的肯定，我就能为你横扫一切敌人。", "sound": "sounds/en_vo_600102_dianchu_tou.wav"}},
        hitAreaParam: "HitAreaHead",
        hitAreas: ["HitAreaHead"],
        sourceType2: 401,
        sourceWeight: 10,
        weight: 10
      },
      {
        showId: 600102017,
        audioId: 60010202,
        audioName: "vo_600102_dianchu_shou",
        desc: "点击-手",
        group: "TapBody",
        index: 2,
        actionId: "dianji2",
        label: "dianji2",
        duration: 9.733,
        voices: {"cn": {"subtitle": "缎带的一头系着我，另一头系着你。只有你，才能拴住一头嗜战的野兽。", "sound": "sounds/vo_600102_dianchu_shou.wav"}, "en": {"subtitle": "缎带的一头系着我，另一头系着你。只有你，才能拴住一头嗜战的野兽。", "sound": "sounds/en_vo_600102_dianchu_shou.wav"}},
        hitAreaParam: "HitAreaHandL",
        hitAreas: ["HitAreaHandL"],
        sourceType2: 401,
        sourceWeight: 10,
        weight: 10
      },
      {
        showId: 600102018,
        audioId: 60010203,
        audioName: "vo_600102_dianchu_shen",
        desc: "点击-胸",
        group: "TapBody",
        index: 7,
        actionId: "tuozhuai",
        label: "tuozhuai",
        duration: 7.6,
        voices: {"cn": {"subtitle": "你的触碰是唯一能让野兽恢复冷静的号角，别告诉别人，这太不像个战士了。", "sound": "sounds/vo_600102_dianchu_shen.wav"}, "en": {"subtitle": "你的触碰是唯一能让野兽恢复冷静的号角，别告诉别人，这太不像个战士了。", "sound": "sounds/en_vo_600102_dianchu_shen.wav"}},
        hitAreaParam: "HitAreaBody",
        hitAreas: ["HitAreaBody"],
        sourceType2: 401,
        sourceWeight: 10,
        weight: 10
      },
      {
        showId: 600102082,
        audioId: 60010206,
        audioName: "vo_600102_changjingbianhua",
        desc: "特殊2-点击1",
        group: "TapBody",
        index: 1,
        actionId: "dianji1",
        label: "dianji1",
        duration: 8.8,
        voices: {"cn": {"subtitle": "不管面对怎样的敌人，只要你想赢，我就会替你杀出一条血路。", "sound": "sounds/vo_600102_changjingbianhua.wav"}, "en": {"subtitle": "不管面对怎样的敌人，只要你想赢，我就会替你杀出一条血路。", "sound": "sounds/en_vo_600102_changjingbianhua.wav"}},
        hitAreaParam: "HitAreadianji1",
        hitAreas: ["HitAreadianji1"],
        sourceType2: 401,
        sourceWeight: 10,
        weight: 10
      },
      {
        showId: 600102083,
        audioId: 60010207,
        audioName: "vo_600102_dianjijiaohu_02",
        desc: "特殊3-点击2",
        group: "TapBody",
        index: 2,
        actionId: "dianji2",
        label: "dianji2",
        duration: 9.733,
        voices: {"cn": {"subtitle": "别人说战士不该有弱点，可是你就是我最大的弱点，也是我最硬的那块铠甲。", "sound": "sounds/vo_600102_dianjijiaohu_02.wav"}, "en": {"subtitle": "别人说战士不该有弱点，可是你就是我最大的弱点，也是我最硬的那块铠甲。", "sound": "sounds/en_vo_600102_dianjijiaohu_02.wav"}},
        hitAreaParam: "HitAreadianji2",
        hitAreas: ["HitAreadianji2"],
        sourceType2: 401,
        sourceWeight: 10,
        weight: 10
      },
      {
        showId: 600102084,
        audioId: 60010208,
        audioName: "vo_600102_teshudongzuo",
        desc: "特殊4-变化",
        group: "TapBody",
        index: 0,
        actionId: "bianhua",
        label: "bianhua",
        duration: 11.467,
        voices: {"cn": {"subtitle": "狼本无法在深海里厮杀，可我的命早就归你了，你去哪，我就去哪。", "sound": "sounds/vo_600102_teshudongzuo.wav"}, "en": {"subtitle": "狼本无法在深海里厮杀，可我的命早就归你了，你去哪，我就去哪。", "sound": "sounds/en_vo_600102_teshudongzuo.wav"}},
        hitAreaParam: "HitAreaChangjing",
        hitAreas: ["HitAreaChangjing"],
        sourceType2: 401,
        sourceWeight: 10,
        weight: 10
      }
    ]
  },
  {
    id: "25100302_dd",
    title: "嘀嗒 · 盛宴的间隙 时装",
    assetKind: "skin",
    categoryLabel: "角色",
    modelDir: "25100302_dd",
    sourceModelDir: "25100302_dd",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "localassets_win32",
    styleId: "",
    styleName: "嘀嗒 · 盛宴的间隙",
    stage: "时装",
    hitAreaNames: ["HitAreaHandR2", "HitAreaquanbu", "HitAreaHandR1", "HitAreadianji", "HitAreaBody", "HitAreaHandL", "HitAreaHead"],
    followConfigs: [{"id": 1045, "prefab": "25100302_dd", "activeName": "", "expressionName": "", "damping": 0.0, "parameters": [{"parameterId": "ParamAngleX", "axis": "X", "factor": 30.0, "sourceToken": "ParamAngleX#30*X"}, {"parameterId": "ParamAngleY", "axis": "Y", "factor": 30.0, "sourceToken": "ParamAngleY#30*Y"}, {"parameterId": "ParamEyeBallX", "axis": "X", "factor": 80.0, "sourceToken": "ParamEyeBallX#80*X"}, {"parameterId": "ParamEyeBallY", "axis": "Y", "factor": 50.0, "sourceToken": "ParamEyeBallY#50*Y"}, {"parameterId": "ParamBodyAngleX", "axis": "X", "factor": 20.0, "sourceToken": "ParamBodyAngleX#20*X"}, {"parameterId": "ParamBodyMae", "axis": "Y", "factor": -10.0, "sourceToken": "ParamBodyMae#-10*Y"}]}],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 6.0 }
        ]
      },
      {
        label: "TapBody",
        actions: [
          { group: "TapBody", index: 0, actionId: "cheyifu", label: "cheyifu", duration: 6.0 },
          { group: "TapBody", index: 1, actionId: "diantou", label: "diantou", duration: 2.667 },
          { group: "TapBody", index: 2, actionId: "huaibiao", label: "huaibiao", duration: 9.0 },
          { group: "TapBody", index: 3, actionId: "loop", label: "loop", duration: 30.0 },
          { group: "TapBody", index: 4, actionId: "qianqing", label: "qianqing", duration: 3.433 },
          { group: "TapBody", index: 5, actionId: "qingsangzi", label: "qingsangzi", duration: 6.0 },
          { group: "TapBody", index: 6, actionId: "waitou", label: "waitou", duration: 4.0 },
          { group: "TapBody", index: 7, actionId: "yaoqing", label: "yaoqing", duration: 12.0 },
          { group: "TapBody", index: 8, actionId: "yaotou", label: "yaotou", duration: 3.0 },
          { group: "TapBody", index: 9, actionId: "zhengli", label: "zhengli", duration: 12.0 }
        ]
      }
    ],
    clickShowActions: [
      {
        showId: 600302008,
        audioId: 60030004,
        audioName: "vo_6003_daiji_01",
        desc: "点击-通用1",
        group: "TapBody",
        index: 7,
        actionId: "yaoqing",
        label: "yaoqing",
        duration: 12.0,
        voices: {"cn": {"subtitle": "我总觉得自己该有个酷炫的出场方式，这样更能镇得住场子。比如甩一下外套，或者同时看三块怀表……？", "sound": "sounds/vo_6003_daiji_01.wav"}, "en": {"subtitle": "我总觉得自己该有个酷炫的出场方式，这样更能镇得住场子。比如甩一下外套，或者同时看三块怀表……？", "sound": "sounds/en_vo_6003_daiji_01.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 600302009,
        audioId: 60030010,
        audioName: "vo_6003_xianliao_01",
        desc: "点击-闲聊1",
        group: "TapBody",
        index: 6,
        actionId: "waitou",
        label: "waitou",
        duration: 4.0,
        voices: {"cn": {"subtitle": "是不是我的问题太多了？总感觉……每当我拿着笔记本出现，周围的人都一下子消失了。", "sound": "sounds/vo_6003_xianliao_01.wav"}, "en": {"subtitle": "是不是我的问题太多了？总感觉……每当我拿着笔记本出现，周围的人都一下子消失了。", "sound": "sounds/en_vo_6003_xianliao_01.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 600302010,
        audioId: 60030011,
        audioName: "vo_6003_xianliao_02",
        desc: "点击-闲聊2",
        group: "TapBody",
        index: 2,
        actionId: "huaibiao",
        label: "huaibiao",
        duration: 9.0,
        voices: {"cn": {"subtitle": "时光倒流，人们回到过去弥补遗憾——啊，这是我刚读到的小说情节，要是它能成真就好了。", "sound": "sounds/vo_6003_xianliao_02.wav"}, "en": {"subtitle": "时光倒流，人们回到过去弥补遗憾——啊，这是我刚读到的小说情节，要是它能成真就好了。", "sound": "sounds/en_vo_6003_xianliao_02.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 600302011,
        audioId: 60030014,
        audioName: "vo_6003_zanyang",
        desc: "点击-赞扬1",
        group: "TapBody",
        index: 9,
        actionId: "zhengli",
        label: "zhengli",
        duration: 12.0,
        voices: {"cn": {"subtitle": "在夜行者这行里，你可是了不起的大前辈！真希望我能跟得上你的脚步。", "sound": "sounds/vo_6003_zanyang.wav"}, "en": {"subtitle": "在夜行者这行里，你可是了不起的大前辈！真希望我能跟得上你的脚步。", "sound": "sounds/en_vo_6003_zanyang.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 600302012,
        audioId: 60030201,
        audioName: "vo_600302_dianchu_tou",
        desc: "点击-头",
        group: "TapBody",
        index: 9,
        actionId: "zhengli",
        label: "zhengli",
        duration: 12.0,
        voices: {"cn": {"subtitle": "嘿嘿，这个造型很不错吧？我对着杂志练习了很久，怎么把头发梳成大人模样。", "sound": "sounds/vo_600302_dianchu_tou.wav"}, "en": {"subtitle": "嘿嘿，这个造型很不错吧？我对着杂志练习了很久，怎么把头发梳成大人模样。", "sound": "sounds/en_vo_600302_dianchu_tou.wav"}},
        hitAreaParam: "HitAreaHead",
        hitAreas: ["HitAreaHead"],
        sourceType2: 401,
        sourceWeight: 30,
        weight: 30
      },
      {
        showId: 600302013,
        audioId: 60030202,
        audioName: "vo_600302_dianchu_shou",
        desc: "点击-手",
        group: "TapBody",
        index: 7,
        actionId: "yaoqing",
        label: "yaoqing",
        duration: 12.0,
        voices: {"cn": {"subtitle": "邀、邀请我一起跳舞？咳咳，我当然会，为了这一天，我可是练习了很久。", "sound": "sounds/vo_600302_dianchu_shou.wav"}, "en": {"subtitle": "邀、邀请我一起跳舞？咳咳，我当然会，为了这一天，我可是练习了很久。", "sound": "sounds/en_vo_600302_dianchu_shou.wav"}},
        hitAreaParam: "HitAreaHandL#HitAreaHandR1#HitAreaHandR2",
        hitAreas: ["HitAreaHandL", "HitAreaHandR1", "HitAreaHandR2"],
        sourceType2: 401,
        sourceWeight: 30,
        weight: 30
      },
      {
        showId: 600302014,
        audioId: 60030203,
        audioName: "vo_600302_dianchu_shen",
        desc: "点击-胸",
        group: "TapBody",
        index: 7,
        actionId: "yaoqing",
        label: "yaoqing",
        duration: 12.0,
        voices: {"cn": {"subtitle": "午夜的钟声就要响起了，等宴席散去，脱下这身华服，我有好多好多话想跟你说。我果然还是更喜欢和你在一起，普普通通地生活。", "sound": "sounds/vo_600302_dianchu_shen.wav"}, "en": {"subtitle": "午夜的钟声就要响起了，等宴席散去，脱下这身华服，我有好多好多话想跟你说。我果然还是更喜欢和你在一起，普普通通地生活。", "sound": "sounds/en_vo_600302_dianchu_shen.wav"}},
        hitAreaParam: "HitAreaBody",
        hitAreas: ["HitAreaBody"],
        sourceType2: 401,
        sourceWeight: 30,
        weight: 30
      },
      {
        showId: 600302081,
        audioId: 60030204,
        audioName: "vo_600302_teshudongzuo",
        desc: "点击-特殊动作",
        group: "TapBody",
        index: 9,
        actionId: "zhengli",
        label: "zhengli",
        duration: 12.0,
        voices: {"cn": {"subtitle": "宾客里暂时没有发现可疑人物，但不能掉以轻心，这场宴会随时可能出事——侦探小说里都是这样写的。", "sound": "sounds/vo_600302_teshudongzuo.wav"}, "en": {"subtitle": "宾客里暂时没有发现可疑人物，但不能掉以轻心，这场宴会随时可能出事——侦探小说里都是这样写的。", "sound": "sounds/en_vo_600302_teshudongzuo.wav"}},
        hitAreaParam: "HitAreadianji",
        hitAreas: ["HitAreadianji"],
        sourceType2: 401,
        sourceWeight: 0,
        weight: 100
      }
    ]
  },
  {
    id: "25100702_yl",
    title: "幽灵 · 深海献礼 时装",
    assetKind: "skin",
    categoryLabel: "角色",
    modelDir: "25100702_yl",
    sourceModelDir: "25100702_yl",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "localassets_win32",
    styleId: "",
    styleName: "幽灵 · 深海献礼",
    stage: "时装",
    hitAreaNames: ["HitAreaHandR", "HitAreaBody", "HitAreadianji2", "HitAreaMoren", "HitAreaHandL", "HitAreaHead", "HitAreaChangjing", "HitAreatuozhuai", "HitAreadianji1"],
    followConfigs: [{"id": 1035, "prefab": "25100702_yl", "activeName": "", "expressionName": "", "damping": 0.0, "parameters": [{"parameterId": "Param121", "axis": "X", "factor": -2.0, "sourceToken": "Param121#-2*X"}, {"parameterId": "ParamEyeBallX", "axis": "X", "factor": 33.0, "sourceToken": "ParamEyeBallX#33*X"}, {"parameterId": "ParamEyeBallY", "axis": "Y", "factor": 65.0, "sourceToken": "ParamEyeBallY#65*Y"}, {"parameterId": "ParamAngleX", "axis": "X", "factor": 25.0, "sourceToken": "ParamAngleX#25*X"}, {"parameterId": "ParamAngleY", "axis": "Y", "factor": 60.0, "sourceToken": "ParamAngleY#60*Y"}, {"parameterId": "ParamAngleZ", "axis": "X", "factor": 4.0, "sourceToken": "ParamAngleZ#4*X"}, {"parameterId": "Param92", "axis": "X", "factor": 4.0, "sourceToken": "Param92#4*X"}, {"parameterId": "ParamBodyAngleY", "axis": "Y", "factor": 6.0, "sourceToken": "ParamBodyAngleY#6*Y"}, {"parameterId": "ParamBodyAngleZ", "axis": "X", "factor": 4.0, "sourceToken": "ParamBodyAngleZ#4*X"}, {"parameterId": "ParamArmL4", "axis": "X", "factor": 4.0, "sourceToken": "ParamArmL4#4*X"}, {"parameterId": "Param90", "axis": "X", "factor": -4.0, "sourceToken": "Param90#-4*X"}]}, {"id": 30002, "prefab": "25100702_yl", "activeName": "HitAreatuozhuai", "expressionName": "", "damping": 0.0, "parameters": [{"parameterId": "Paramtuozhuai", "axis": "X", "factor": 100.0, "sourceToken": "Paramtuozhuai#100*X"}]}],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 2.967 }
        ]
      },
      {
        label: "TapBody",
        actions: [
          { group: "TapBody", index: 0, actionId: "bianhua", label: "bianhua", duration: 6.467 },
          { group: "TapBody", index: 1, actionId: "dianji1", label: "dianji1", duration: 9.567 },
          { group: "TapBody", index: 2, actionId: "dianji2", label: "dianji2", duration: 11.233 },
          { group: "TapBody", index: 3, actionId: "diantou", label: "diantou", duration: 2.967 },
          { group: "TapBody", index: 4, actionId: "loop", label: "loop", duration: 9.967 },
          { group: "TapBody", index: 5, actionId: "qianqing", label: "qianqing", duration: 2.967 },
          { group: "TapBody", index: 6, actionId: "taishou", label: "taishou", duration: 2.967 },
          { group: "TapBody", index: 7, actionId: "tuozhuai", label: "tuozhuai", duration: 9.3 },
          { group: "TapBody", index: 8, actionId: "waitou", label: "waitou", duration: 3.967 },
          { group: "TapBody", index: 9, actionId: "yaotou", label: "yaotou", duration: 2.967 }
        ]
      },
      {
        label: "入场",
        actions: [
          { group: "Entry", index: 0, actionId: "ruchang", label: "入场", duration: 13.633 }
        ]
      }
    ],
    clickShowActions: [
      {
        showId: 600702009,
        audioId: 60070004,
        audioName: "vo_6007_daiji_01",
        desc: "点击-通用1",
        group: "TapBody",
        index: 8,
        actionId: "waitou",
        label: "waitou",
        duration: 3.967,
        voices: {"cn": {"subtitle": "我会恰到好处地示弱，您负责心软；这正是我们的默契，不是吗？", "sound": "sounds/vo_6007_daiji_01.wav"}, "en": {"subtitle": "我会恰到好处地示弱，您负责心软；这正是我们的默契，不是吗？", "sound": "sounds/en_vo_6007_daiji_01.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 600702010,
        audioId: 60070212,
        audioName: "vo_600702_haogan_01",
        desc: "点击-闲聊1",
        group: "TapBody",
        index: 1,
        actionId: "dianji1",
        label: "dianji1",
        duration: 9.567,
        voices: {"cn": {"subtitle": "您给予了一条人鱼栖身之处，所以我也会展现出您期望的顺从……目前的交易，您还满意吗？", "sound": "sounds/vo_600702_haogan_01.wav"}, "en": {"subtitle": "您给予了一条人鱼栖身之处，所以我也会展现出您期望的顺从……目前的交易，您还满意吗？", "sound": "sounds/en_vo_600702_haogan_01.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 10,
        weight: 10
      },
      {
        showId: 600702011,
        audioId: 60070213,
        audioName: "vo_600702_haogan_02",
        desc: "点击-闲聊2",
        group: "TapBody",
        index: 2,
        actionId: "dianji2",
        label: "dianji2",
        duration: 11.233,
        voices: {"cn": {"subtitle": "拆穿一条人鱼的把戏，然后呢？您打算将我放回海里，还是……将我留在您身边？", "sound": "sounds/vo_600702_haogan_02.wav"}, "en": {"subtitle": "拆穿一条人鱼的把戏，然后呢？您打算将我放回海里，还是……将我留在您身边？", "sound": "sounds/en_vo_600702_haogan_02.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 10,
        weight: 10
      },
      {
        showId: 600702012,
        audioId: 60070214,
        audioName: "vo_600702_haogan_03",
        desc: "点击-闲聊3",
        group: "TapBody",
        index: 8,
        actionId: "waitou",
        label: "waitou",
        duration: 3.967,
        voices: {"cn": {"subtitle": "如果我是故事里的那条人鱼……我该用什么来换取留在您身边？声音？记忆？还是……全部的自己。", "sound": "sounds/vo_600702_haogan_03.wav"}, "en": {"subtitle": "如果我是故事里的那条人鱼……我该用什么来换取留在您身边？声音？记忆？还是……全部的自己。", "sound": "sounds/en_vo_600702_haogan_03.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 10,
        weight: 10
      },
      {
        showId: 600702013,
        audioId: 60070216,
        audioName: "vo_600702_haogan_05",
        desc: "点击-赞扬1",
        group: "TapBody",
        index: 6,
        actionId: "taishou",
        label: "taishou",
        duration: 2.967,
        voices: {"cn": {"subtitle": "我的心房就像蚌壳一样紧闭，可您总有办法不费吹灰之力地撬开它，看到里面那些污秽泥泞，却仍然选择接纳。", "sound": "sounds/vo_600702_haogan_05.wav"}, "en": {"subtitle": "我的心房就像蚌壳一样紧闭，可您总有办法不费吹灰之力地撬开它，看到里面那些污秽泥泞，却仍然选择接纳。", "sound": "sounds/en_vo_600702_haogan_05.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 10,
        weight: 10
      },
      {
        showId: 600702014,
        audioId: 60070201,
        audioName: "vo_600702_dianchu_tou",
        desc: "点击-头",
        group: "TapBody",
        index: 8,
        actionId: "waitou",
        label: "waitou",
        duration: 3.967,
        voices: {"cn": {"subtitle": "既然您觉得美丽……为什么不再靠近一点呢？此刻……我想用人鱼的秘密，交换一个您的怜惜。", "sound": "sounds/vo_600702_dianchu_tou.wav"}, "en": {"subtitle": "既然您觉得美丽……为什么不再靠近一点呢？此刻……我想用人鱼的秘密，交换一个您的怜惜。", "sound": "sounds/en_vo_600702_dianchu_tou.wav"}},
        hitAreaParam: "HitAreaHead",
        hitAreas: ["HitAreaHead"],
        sourceType2: 401,
        sourceWeight: 10,
        weight: 10
      },
      {
        showId: 600702015,
        audioId: 60070202,
        audioName: "vo_600702_dianchu_shou",
        desc: "点击-手",
        group: "TapBody",
        index: 2,
        actionId: "dianji2",
        label: "dianji2",
        duration: 11.233,
        voices: {"cn": {"subtitle": "我喜欢这样柔软的白纱，贴着我的触感这样轻柔，只略逊于您的手心。", "sound": "sounds/vo_600702_dianchu_shou.wav"}, "en": {"subtitle": "我喜欢这样柔软的白纱，贴着我的触感这样轻柔，只略逊于您的手心。", "sound": "sounds/en_vo_600702_dianchu_shou.wav"}},
        hitAreaParam: "HitAreaHandL#HitAreaHandR",
        hitAreas: ["HitAreaHandL", "HitAreaHandR"],
        sourceType2: 401,
        sourceWeight: 10,
        weight: 10
      },
      {
        showId: 600702016,
        audioId: 60070203,
        audioName: "vo_600702_dianchu_shen",
        desc: "点击-胸",
        group: "TapBody",
        index: 7,
        actionId: "tuozhuai",
        label: "tuozhuai",
        duration: 9.3,
        voices: {"cn": {"subtitle": "如果您想，或许我可以解开这些繁复的珠链……让您看到，我的身上没有锋利的刀子。只有……您亲手留下的印记。", "sound": "sounds/vo_600702_dianchu_shen.wav"}, "en": {"subtitle": "如果您想，或许我可以解开这些繁复的珠链……让您看到，我的身上没有锋利的刀子。只有……您亲手留下的印记。", "sound": "sounds/en_vo_600702_dianchu_shen.wav"}},
        hitAreaParam: "HitAreaBody",
        hitAreas: ["HitAreaBody"],
        sourceType2: 401,
        sourceWeight: 10,
        weight: 10
      },
      {
        showId: 600702082,
        audioId: 60070206,
        audioName: "vo_600702_dianjijiaohu_01",
        desc: "特殊2-点击1",
        group: "TapBody",
        index: 1,
        actionId: "dianji1",
        label: "dianji1",
        duration: 9.567,
        voices: {"cn": {"subtitle": "为我准备了这样漂亮的新衣服，又给予我一个温暖的拥抱……您的包容和爱，简直要让我贪心不足了。", "sound": "sounds/vo_600702_dianjijiaohu_01.wav"}, "en": {"subtitle": "为我准备了这样漂亮的新衣服，又给予我一个温暖的拥抱……您的包容和爱，简直要让我贪心不足了。", "sound": "sounds/en_vo_600702_dianjijiaohu_01.wav"}},
        hitAreaParam: "HitAreadianji1",
        hitAreas: ["HitAreadianji1"],
        sourceType2: 401,
        sourceWeight: 10,
        weight: 10
      },
      {
        showId: 600702083,
        audioId: 60070207,
        audioName: "vo_600702_changjingbianhua",
        desc: "特殊3-点击2",
        group: "TapBody",
        index: 2,
        actionId: "dianji2",
        label: "dianji2",
        duration: 11.233,
        voices: {"cn": {"subtitle": "我可以为您唱出迷惑人心的歌声，也可以帮您处理掉那些碍眼的敌人，只要您一直注视着我。", "sound": "sounds/vo_600702_changjingbianhua.wav"}, "en": {"subtitle": "我可以为您唱出迷惑人心的歌声，也可以帮您处理掉那些碍眼的敌人，只要您一直注视着我。", "sound": "sounds/en_vo_600702_changjingbianhua.wav"}},
        hitAreaParam: "HitAreadianji2",
        hitAreas: ["HitAreadianji2"],
        sourceType2: 401,
        sourceWeight: 10,
        weight: 10
      },
      {
        showId: 600702084,
        audioId: 60070208,
        audioName: "vo_600702_dianjijiaohu_02",
        desc: "特殊4-变化",
        group: "TapBody",
        index: 0,
        actionId: "bianhua",
        label: "bianhua",
        duration: 6.467,
        voices: {"cn": {"subtitle": "褪去这层华丽的珠纱，底下只有伤痕累累的躯壳……您还会愿意接纳一条如此丑陋的人鱼吗？", "sound": "sounds/vo_600702_dianjijiaohu_02.wav"}, "en": {"subtitle": "褪去这层华丽的珠纱，底下只有伤痕累累的躯壳……您还会愿意接纳一条如此丑陋的人鱼吗？", "sound": "sounds/en_vo_600702_dianjijiaohu_02.wav"}},
        hitAreaParam: "HitAreaChangjing",
        hitAreas: ["HitAreaChangjing"],
        sourceType2: 401,
        sourceWeight: 10,
        weight: 10
      }
    ]
  },
  {
    id: "25100802_jj",
    title: "将军 · 亮剑之时 时装",
    assetKind: "skin",
    categoryLabel: "角色",
    modelDir: "25100802_jj",
    sourceModelDir: "25100802_jj",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "localassets_win32",
    styleId: "",
    styleName: "将军 · 亮剑之时",
    stage: "时装",
    hitAreaNames: ["HitAreaHead", "HitAreadianji1", "HitAreaBody", "HitAreaquanbu", "HitAreaHandR", "HitAreaHandL"],
    followConfigs: [{"id": 1040, "prefab": "25100802_jj", "activeName": "", "expressionName": "", "damping": 0.0, "parameters": [{"parameterId": "ParamAngleX", "axis": "X", "factor": 30.0, "sourceToken": "ParamAngleX#30*X"}, {"parameterId": "ParamAngleY", "axis": "Y", "factor": 30.0, "sourceToken": "ParamAngleY#30*Y"}, {"parameterId": "ParamEyeBallX", "axis": "X", "factor": 50.0, "sourceToken": "ParamEyeBallX#50*X"}, {"parameterId": "ParamEyeBallY", "axis": "Y", "factor": 50.0, "sourceToken": "ParamEyeBallY#50*Y"}]}],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 6.5 }
        ]
      },
      {
        label: "TapBody",
        actions: [
          { group: "TapBody", index: 0, actionId: "dianji", label: "dianji", duration: 9.933 },
          { group: "TapBody", index: 1, actionId: "dianji2", label: "dianji2", duration: 8.4 },
          { group: "TapBody", index: 2, actionId: "diantou", label: "diantou", duration: 3.0 },
          { group: "TapBody", index: 3, actionId: "fujian", label: "fujian", duration: 8.233 },
          { group: "TapBody", index: 4, actionId: "jianding", label: "jianding", duration: 6.533 },
          { group: "TapBody", index: 5, actionId: "qianqing", label: "qianqing", duration: 3.367 },
          { group: "TapBody", index: 6, actionId: "waitou", label: "waitou", duration: 3.167 },
          { group: "TapBody", index: 7, actionId: "yaotou", label: "yaotou", duration: 3.0 }
        ]
      }
    ],
    clickShowActions: [
      {
        showId: 600802009,
        audioId: 60080005,
        audioName: "vo_6008_daiji_02",
        desc: "点击-通用2",
        group: "TapBody",
        index: 7,
        actionId: "yaotou",
        label: "yaotou",
        duration: 3.0,
        voices: {"cn": {"subtitle": "别一声不响地离开，我不怕你出事，你一定能应付。但我怕自己没法第一时间赶过去。", "sound": "sounds/vo_6008_daiji_02.wav"}, "en": {"subtitle": "别一声不响地离开，我不怕你出事，你一定能应付。但我怕自己没法第一时间赶过去。", "sound": "sounds/en_vo_6008_daiji_02.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 600802010,
        audioId: 60080010,
        audioName: "vo_6008_xianliao_01",
        desc: "点击-闲聊1",
        group: "TapBody",
        index: 7,
        actionId: "yaotou",
        label: "yaotou",
        duration: 3.0,
        voices: {"cn": {"subtitle": "要求士兵着装整洁不是为了好看。在战场上，一条松脱的皮带，也会变成拖死骑兵的绞索。", "sound": "sounds/vo_6008_xianliao_01.wav"}, "en": {"subtitle": "要求士兵着装整洁不是为了好看。在战场上，一条松脱的皮带，也会变成拖死骑兵的绞索。", "sound": "sounds/en_vo_6008_xianliao_01.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 600802011,
        audioId: 60080011,
        audioName: "vo_6008_xianliao_02",
        desc: "点击-闲聊2",
        group: "Idle",
        index: 0,
        actionId: "idle",
        label: "默认",
        duration: 6.5,
        voices: {"cn": {"subtitle": "这里的气候比我故乡舒适。过多的雨水除外，它会让电极装置生锈。", "sound": "sounds/vo_6008_xianliao_02.wav"}, "en": {"subtitle": "这里的气候比我故乡舒适。过多的雨水除外，它会让电极装置生锈。", "sound": "sounds/en_vo_6008_xianliao_02.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 600802012,
        audioId: 60080012,
        audioName: "vo_6008_xianliao_03",
        desc: "点击-闲聊3",
        group: "TapBody",
        index: 0,
        actionId: "dianji",
        label: "dianji",
        duration: 9.933,
        voices: {"cn": {"subtitle": "只讲美德会遭人掠夺，而运用头脑和枪炮讲美德，你反而能收获鲜花和金子，甚至赢得一个国家。", "sound": "sounds/vo_6008_xianliao_03.wav"}, "en": {"subtitle": "只讲美德会遭人掠夺，而运用头脑和枪炮讲美德，你反而能收获鲜花和金子，甚至赢得一个国家。", "sound": "sounds/en_vo_6008_xianliao_03.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 600802013,
        audioId: 60080014,
        audioName: "vo_6008_zanyang",
        desc: "点击-赞扬1",
        group: "Idle",
        index: 0,
        actionId: "idle",
        label: "默认",
        duration: 6.5,
        voices: {"cn": {"subtitle": "你的成长，比任何胜利都让我感到欣慰。", "sound": "sounds/vo_6008_zanyang.wav"}, "en": {"subtitle": "你的成长，比任何胜利都让我感到欣慰。", "sound": "sounds/en_vo_6008_zanyang.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 600802014,
        audioId: 60080201,
        audioName: "vo_600802_dianchu_tou",
        desc: "点击-头",
        group: "TapBody",
        index: 2,
        actionId: "diantou",
        label: "diantou",
        duration: 3.0,
        voices: {"cn": {"subtitle": "当年的教训告诉我，只看眼前的牌局，就会满盘皆输。", "sound": "sounds/vo_600802_dianchu_tou.wav"}, "en": {"subtitle": "当年的教训告诉我，只看眼前的牌局，就会满盘皆输。", "sound": "sounds/en_vo_600802_dianchu_tou.wav"}},
        hitAreaParam: "HitAreaHead",
        hitAreas: ["HitAreaHead"],
        sourceType2: 401,
        sourceWeight: 20,
        weight: 20
      },
      {
        showId: 600802015,
        audioId: 60080202,
        audioName: "vo_600802_dianchu_shou",
        desc: "点击-手",
        group: "TapBody",
        index: 1,
        actionId: "dianji2",
        label: "dianji2",
        duration: 8.4,
        voices: {"cn": {"subtitle": "你的动作，已经暴露了你的心思，牌局如战局，一步错，步步错，想好了再出牌。", "sound": "sounds/vo_600802_dianchu_shou.wav"}, "en": {"subtitle": "你的动作，已经暴露了你的心思，牌局如战局，一步错，步步错，想好了再出牌。", "sound": "sounds/en_vo_600802_dianchu_shou.wav"}},
        hitAreaParam: "HitAreaHandL",
        hitAreas: ["HitAreaHandL"],
        sourceType2: 401,
        sourceWeight: 20,
        weight: 20
      },
      {
        showId: 600802016,
        audioId: 60080203,
        audioName: "vo_600802_dianchu_shen",
        desc: "点击-胸",
        group: "Idle",
        index: 0,
        actionId: "idle",
        label: "默认",
        duration: 6.5,
        voices: {"cn": {"subtitle": "我的弱点？如果你找到了，记得好好利用它，赢下这局。", "sound": "sounds/vo_600802_dianchu_shen.wav"}, "en": {"subtitle": "我的弱点？如果你找到了，记得好好利用它，赢下这局。", "sound": "sounds/en_vo_600802_dianchu_shen.wav"}},
        hitAreaParam: "HitAreaBody",
        hitAreas: ["HitAreaBody"],
        sourceType2: 401,
        sourceWeight: 20,
        weight: 20
      },
      {
        showId: 600802081,
        audioId: 60080204,
        audioName: "vo_600802_teshudongzuo",
        desc: "特殊1",
        group: "TapBody",
        index: 0,
        actionId: "dianji",
        label: "dianji",
        duration: 9.933,
        voices: {"cn": {"subtitle": "你的所在，即剑锋所向。这一次，我不会再缺席任何一场战斗。", "sound": "sounds/vo_600802_teshudongzuo.wav"}, "en": {"subtitle": "你的所在，即剑锋所向。这一次，我不会再缺席任何一场战斗。", "sound": "sounds/en_vo_600802_teshudongzuo.wav"}},
        hitAreaParam: "HitAreadianji1",
        hitAreas: ["HitAreadianji1"],
        sourceType2: 401,
        sourceWeight: 0,
        weight: 100
      }
    ]
  },
  {
    id: "25101102_yd",
    title: "园丁 · 仲夏夜之梦 时装",
    assetKind: "skin",
    categoryLabel: "角色",
    modelDir: "25101102_yd",
    sourceModelDir: "25101102_yd",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "localassets_win32",
    styleId: "",
    styleName: "园丁 · 仲夏夜之梦",
    stage: "时装",
    hitAreaNames: ["HitAreaMoren", "HitAreaHandR", "HitAreaHead", "HitAreaHandL", "HitAreaBody"],
    followConfigs: [{"id": 1034, "prefab": "25101102_yd", "activeName": "", "expressionName": "", "damping": 0.0, "parameters": [{"parameterId": "ParamAngleX", "axis": "X", "factor": 30.0, "sourceToken": "ParamAngleX#30*X"}, {"parameterId": "ParamAngleY", "axis": "Y", "factor": 30.0, "sourceToken": "ParamAngleY#30*Y"}, {"parameterId": "ParamBodyAngleX", "axis": "X", "factor": 30.0, "sourceToken": "ParamBodyAngleX#30*X"}, {"parameterId": "ParamBodyMae", "axis": "Y", "factor": 20.0, "sourceToken": "ParamBodyMae#20*Y"}, {"parameterId": "ParamEyeBallX", "axis": "X", "factor": 50.0, "sourceToken": "ParamEyeBallX#50*X"}, {"parameterId": "ParamEyeBallY", "axis": "Y", "factor": 50.0, "sourceToken": "ParamEyeBallY#50*Y"}]}],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 6.0 }
        ]
      },
      {
        label: "TapBody",
        actions: [
          { group: "TapBody", index: 0, actionId: "bonong", label: "bonong", duration: 4.5 },
          { group: "TapBody", index: 1, actionId: "diantou", label: "diantou", duration: 3.0 },
          { group: "TapBody", index: 2, actionId: "qianqing", label: "qianqing", duration: 4.5 },
          { group: "TapBody", index: 3, actionId: "qianqing_1", label: "qianqing_1", duration: 4.5 },
          { group: "TapBody", index: 4, actionId: "waitou", label: "waitou", duration: 3.667 },
          { group: "TapBody", index: 5, actionId: "waitou_1", label: "waitou_1", duration: 3.667 },
          { group: "TapBody", index: 6, actionId: "yaotou", label: "yaotou", duration: 3.0 }
        ]
      }
    ],
    clickShowActions: [
      {
        showId: 601102010,
        audioId: 60110004,
        audioName: "vo_6011_daiji_01",
        desc: "点击-通用1",
        group: "TapBody",
        index: 3,
        actionId: "qianqing_1",
        label: "qianqing_1",
        duration: 4.5,
        voices: {"cn": {"subtitle": "摘下来的……小花，你要吗？放在口袋里……一直带着，心情会变好。", "sound": "sounds/vo_6011_daiji_01.wav"}, "en": {"subtitle": "摘下来的……小花，你要吗？放在口袋里……一直带着，心情会变好。", "sound": "sounds/en_vo_6011_daiji_01.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 601102011,
        audioId: 60110005,
        audioName: "vo_6011_daiji_02",
        desc: "点击-通用2",
        group: "Idle",
        index: 0,
        actionId: "idle",
        label: "默认",
        duration: 6.0,
        voices: {"cn": {"subtitle": "被打……不是很痛。倒地睡一觉，醒来……就好了。", "sound": "sounds/vo_6011_daiji_02.wav"}, "en": {"subtitle": "被打……不是很痛。倒地睡一觉，醒来……就好了。", "sound": "sounds/en_vo_6011_daiji_02.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 601102012,
        audioId: 60110010,
        audioName: "vo_6011_xianliao_01",
        desc: "点击-闲聊1",
        group: "TapBody",
        index: 6,
        actionId: "yaotou",
        label: "yaotou",
        duration: 3.0,
        voices: {"cn": {"subtitle": "你很干净，我都是土，不要碰。", "sound": "sounds/vo_6011_xianliao_01.wav"}, "en": {"subtitle": "你很干净，我都是土，不要碰。", "sound": "sounds/en_vo_6011_xianliao_01.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 601102013,
        audioId: 60110011,
        audioName: "vo_6011_xianliao_02",
        desc: "点击-闲聊2",
        group: "TapBody",
        index: 5,
        actionId: "waitou_1",
        label: "waitou_1",
        duration: 3.667,
        voices: {"cn": {"subtitle": "天气热的话……铁桶很烫。我只好……往头上浇水。", "sound": "sounds/vo_6011_xianliao_02.wav"}, "en": {"subtitle": "天气热的话……铁桶很烫。我只好……往头上浇水。", "sound": "sounds/en_vo_6011_xianliao_02.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 601102016,
        audioId: 60110006,
        audioName: "vo_6011_dianchu_tou",
        desc: "点击-头",
        group: "TapBody",
        index: 5,
        actionId: "waitou_1",
        label: "waitou_1",
        duration: 3.667,
        voices: {"cn": {"subtitle": "铁桶里，能听到……回声。你想听？唔，我去拿别的桶……", "sound": "sounds/vo_6011_dianchu_tou.wav"}, "en": {"subtitle": "铁桶里，能听到……回声。你想听？唔，我去拿别的桶……", "sound": "sounds/en_vo_6011_dianchu_tou.wav"}},
        hitAreaParam: "HitAreaHead",
        hitAreas: ["HitAreaHead"],
        sourceType2: 401,
        sourceWeight: 30,
        weight: 30
      },
      {
        showId: 601102017,
        audioId: 60110007,
        audioName: "vo_6011_dianchu_shou",
        desc: "点击-手",
        group: "TapBody",
        index: 0,
        actionId: "bonong",
        label: "bonong",
        duration: 4.5,
        voices: {"cn": {"subtitle": "你对我笑的时候……我，嗯……不知道手要放哪。", "sound": "sounds/vo_6011_dianchu_shou.wav"}, "en": {"subtitle": "你对我笑的时候……我，嗯……不知道手要放哪。", "sound": "sounds/en_vo_6011_dianchu_shou.wav"}},
        hitAreaParam: "HitAreaHandL#HitAreaHandR",
        hitAreas: ["HitAreaHandL", "HitAreaHandR"],
        sourceType2: 401,
        sourceWeight: 30,
        weight: 30
      },
      {
        showId: 601102018,
        audioId: 60110008,
        audioName: "vo_6011_dianchu_shen",
        desc: "点击-胸",
        group: "Idle",
        index: 0,
        actionId: "idle",
        label: "默认",
        duration: 6.0,
        voices: {"cn": {"subtitle": "衣服……我不挑，反正……总是会脏。", "sound": "sounds/vo_6011_dianchu_shen.wav"}, "en": {"subtitle": "衣服……我不挑，反正……总是会脏。", "sound": "sounds/en_vo_6011_dianchu_shen.wav"}},
        hitAreaParam: "HitAreaBody",
        hitAreas: ["HitAreaBody"],
        sourceType2: 401,
        sourceWeight: 30,
        weight: 30
      }
    ]
  },
  {
    id: "25101302_bj",
    title: "暴君 · 胜者为王 时装",
    assetKind: "skin",
    categoryLabel: "角色",
    modelDir: "25101302_bj",
    sourceModelDir: "25101302_bj",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "localassets_win32",
    styleId: "",
    styleName: "暴君 · 胜者为王",
    stage: "时装",
    hitAreaNames: ["HitAreaBody", "HitAreadianji2", "HitAreachangjing1", "HitAreaHandL", "HitAreatuozhuai", "HitAreaHead", "HitAreadianji1", "HitAreachangjing2", "HitAreaMoren"],
    followConfigs: [{"id": 1043, "prefab": "25101302_bj", "activeName": "", "expressionName": "", "damping": 0.0, "parameters": [{"parameterId": "ParamAngleX", "axis": "X", "factor": 15.0, "sourceToken": "ParamAngleX#15*X"}, {"parameterId": "ParamAngleY", "axis": "Y", "factor": 25.0, "sourceToken": "ParamAngleY#25*Y"}, {"parameterId": "ParamEyeBallX", "axis": "X", "factor": 25.0, "sourceToken": "ParamEyeBallX#25*X"}, {"parameterId": "ParamEyeBallY", "axis": "Y", "factor": 30.0, "sourceToken": "ParamEyeBallY#30*Y"}, {"parameterId": "ParamBodyAngleX", "axis": "X", "factor": 5.0, "sourceToken": "ParamBodyAngleX#5*X"}, {"parameterId": "ParamBodyAngleY", "axis": "Y", "factor": 5.0, "sourceToken": "ParamBodyAngleY#5*Y"}]}, {"id": 30003, "prefab": "25101302_bj", "activeName": "HitAreatuozhuai", "expressionName": "", "damping": 0.0, "parameters": [{"parameterId": "Paramtuozhuai", "axis": "X", "factor": 100.0, "sourceToken": "Paramtuozhuai#100*X"}]}],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 12.0 }
        ]
      },
      {
        label: "TapBody",
        actions: [
          { group: "TapBody", index: 0, actionId: "bianhua", label: "bianhua", duration: 12.0 },
          { group: "TapBody", index: 1, actionId: "dianji1", label: "dianji1", duration: 11.0 },
          { group: "TapBody", index: 2, actionId: "dianji2", label: "dianji2", duration: 8.0 },
          { group: "TapBody", index: 3, actionId: "diantou", label: "diantou", duration: 4.0 },
          { group: "TapBody", index: 4, actionId: "fupai", label: "fupai", duration: 8.0 },
          { group: "TapBody", index: 5, actionId: "loop", label: "loop", duration: 12.0 },
          { group: "TapBody", index: 6, actionId: "qianqing", label: "qianqing", duration: 4.5 },
          { group: "TapBody", index: 7, actionId: "tuozhuai", label: "tuozhuai", duration: 10.0 },
          { group: "TapBody", index: 8, actionId: "yaotou", label: "yaotou", duration: 4.0 }
        ]
      },
      {
        label: "入场",
        actions: [
          { group: "Entry", index: 0, actionId: "ruchang", label: "入场", duration: 12.0 }
        ]
      }
    ],
    clickShowActions: [
      {
        showId: 601302010,
        audioId: 60130004,
        audioName: "vo_6013_daiji_01",
        desc: "点击-通用1",
        group: "Idle",
        index: 0,
        actionId: "idle",
        label: "默认",
        duration: 12.0,
        voices: {"cn": {"subtitle": "我心情好是因为灭了一个敌方据点？原来在你印象中我是这种人。", "sound": "sounds/vo_6013_daiji_01.wav"}, "en": {"subtitle": "我心情好是因为灭了一个敌方据点？原来在你印象中我是这种人。", "sound": "sounds/en_vo_6013_daiji_01.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 601302011,
        audioId: 60130005,
        audioName: "vo_6013_daiji_02",
        desc: "点击-通用2",
        group: "Idle",
        index: 0,
        actionId: "idle",
        label: "默认",
        duration: 12.0,
        voices: {"cn": {"subtitle": "今天风向变了，有些不安分的势力可能又想闹事。我等着他们犯错。", "sound": "sounds/vo_6013_daiji_02.wav"}, "en": {"subtitle": "今天风向变了，有些不安分的势力可能又想闹事。我等着他们犯错。", "sound": "sounds/en_vo_6013_daiji_02.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 601302012,
        audioId: 60130212,
        audioName: "vo_601302_haogan_01",
        desc: "点击-闲聊1",
        group: "TapBody",
        index: 1,
        actionId: "dianji1",
        label: "dianji1",
        duration: 11.0,
        voices: {"cn": {"subtitle": "好牌谁都想要，你有什么筹码值得我跟注？", "sound": "sounds/vo_601302_haogan_01.wav"}, "en": {"subtitle": "好牌谁都想要，你有什么筹码值得我跟注？", "sound": "sounds/en_vo_601302_haogan_01.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 10,
        weight: 10
      },
      {
        showId: 601302013,
        audioId: 60130213,
        audioName: "vo_601302_haogan_02",
        desc: "点击-闲聊2",
        group: "TapBody",
        index: 2,
        actionId: "dianji2",
        label: "dianji2",
        duration: 8.0,
        voices: {"cn": {"subtitle": "再来一局？我可以让你先手，毕竟旗鼓相当的对手才有意思。", "sound": "sounds/vo_601302_haogan_02.wav"}, "en": {"subtitle": "再来一局？我可以让你先手，毕竟旗鼓相当的对手才有意思。", "sound": "sounds/en_vo_601302_haogan_02.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 10,
        weight: 10
      },
      {
        showId: 601302014,
        audioId: 60130214,
        audioName: "vo_601302_haogan_03",
        desc: "点击-闲聊3",
        group: "Idle",
        index: 0,
        actionId: "idle",
        label: "默认",
        duration: 12.0,
        voices: {"cn": {"subtitle": "如果有一天在牌桌上你需要用我的性命来换取胜利，记得下手狠一点，别让我失望。", "sound": "sounds/vo_601302_haogan_03.wav"}, "en": {"subtitle": "如果有一天在牌桌上你需要用我的性命来换取胜利，记得下手狠一点，别让我失望。", "sound": "sounds/en_vo_601302_haogan_03.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 10,
        weight: 10
      },
      {
        showId: 601302015,
        audioId: 60130216,
        audioName: "vo_601302_haogan_05",
        desc: "点击-赞扬1",
        group: "TapBody",
        index: 4,
        actionId: "fupai",
        label: "fupai",
        duration: 8.0,
        voices: {"cn": {"subtitle": "我习惯掌控一切筹码，但你是个例外——这让我很不习惯，却又……有些期待。", "sound": "sounds/vo_601302_haogan_05.wav"}, "en": {"subtitle": "我习惯掌控一切筹码，但你是个例外——这让我很不习惯，却又……有些期待。", "sound": "sounds/en_vo_601302_haogan_05.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 10,
        weight: 10
      },
      {
        showId: 601302016,
        audioId: 60130201,
        audioName: "vo_601302_dianchu_tou",
        desc: "点击-头",
        group: "TapBody",
        index: 2,
        actionId: "dianji2",
        label: "dianji2",
        duration: 8.0,
        voices: {"cn": {"subtitle": "为我加冕，与我并肩，这场牌局唯有你我，才是最终赢家。", "sound": "sounds/vo_601302_dianchu_tou.wav"}, "en": {"subtitle": "为我加冕，与我并肩，这场牌局唯有你我，才是最终赢家。", "sound": "sounds/en_vo_601302_dianchu_tou.wav"}},
        hitAreaParam: "HitAreaHead",
        hitAreas: ["HitAreaHead"],
        sourceType2: 401,
        sourceWeight: 10,
        weight: 10
      },
      {
        showId: 601302017,
        audioId: 60130202,
        audioName: "vo_601302_dianchu_shou",
        desc: "点击-手",
        group: "TapBody",
        index: 1,
        actionId: "dianji1",
        label: "dianji1",
        duration: 11.0,
        voices: {"cn": {"subtitle": "出千？呵，不用那种手段，我也能赢。所有规则，都可以由枪炮改写。", "sound": "sounds/vo_601302_dianchu_shou.wav"}, "en": {"subtitle": "出千？呵，不用那种手段，我也能赢。所有规则，都可以由枪炮改写。", "sound": "sounds/en_vo_601302_dianchu_shou.wav"}},
        hitAreaParam: "HitAreaHandL",
        hitAreas: ["HitAreaHandL"],
        sourceType2: 401,
        sourceWeight: 10,
        weight: 10
      },
      {
        showId: 601302018,
        audioId: 60130203,
        audioName: "vo_601302_dianchu_shen",
        desc: "点击-胸",
        group: "TapBody",
        index: 8,
        actionId: "yaotou",
        label: "yaotou",
        duration: 4.0,
        voices: {"cn": {"subtitle": "我沾红的绶带，早就洗不净了，无所谓，败者的鲜血是国王最好的勋章。", "sound": "sounds/vo_601302_dianchu_shen.wav"}, "en": {"subtitle": "我沾红的绶带，早就洗不净了，无所谓，败者的鲜血是国王最好的勋章。", "sound": "sounds/en_vo_601302_dianchu_shen.wav"}},
        hitAreaParam: "HitAreaBody",
        hitAreas: ["HitAreaBody"],
        sourceType2: 401,
        sourceWeight: 10,
        weight: 10
      },
      {
        showId: 601302082,
        audioId: 60130206,
        audioName: "vo_601302_dianjijiaohu_01",
        desc: "特殊2-点击2",
        group: "TapBody",
        index: 2,
        actionId: "dianji2",
        label: "dianji2",
        duration: 8.0,
        voices: {"cn": {"subtitle": "赢了？这不是理所当然的事吗？", "sound": "sounds/vo_601302_dianjijiaohu_01.wav"}, "en": {"subtitle": "赢了？这不是理所当然的事吗？", "sound": "sounds/en_vo_601302_dianjijiaohu_01.wav"}},
        hitAreaParam: "HitAreadianji2",
        hitAreas: ["HitAreadianji2"],
        sourceType2: 401,
        sourceWeight: 10,
        weight: 10
      },
      {
        showId: 601302083,
        audioId: 60130207,
        audioName: "vo_601302_dianjijiaohu_02",
        desc: "特殊3-点击1",
        group: "TapBody",
        index: 1,
        actionId: "dianji1",
        label: "dianji1",
        duration: 11.0,
        voices: {"cn": {"subtitle": "如果牌桌上分不出胜负，我不介意用枪口来跟你讲讲道理。", "sound": "sounds/vo_601302_dianjijiaohu_02.wav"}, "en": {"subtitle": "如果牌桌上分不出胜负，我不介意用枪口来跟你讲讲道理。", "sound": "sounds/en_vo_601302_dianjijiaohu_02.wav"}},
        hitAreaParam: "HitAreadianji1",
        hitAreas: ["HitAreadianji1"],
        sourceType2: 401,
        sourceWeight: 10,
        weight: 10
      },
      {
        showId: 601302084,
        audioId: 60130208,
        audioName: "vo_601302_changjingbianhua",
        desc: "特殊4-变化",
        group: "TapBody",
        index: 0,
        actionId: "bianhua",
        label: "bianhua",
        duration: 12.0,
        voices: {"cn": {"subtitle": "在泰拉，没有天生的国王，只有踩着别人骸骨活下来的赢家。", "sound": "sounds/vo_601302_changjingbianhua.wav"}, "en": {"subtitle": "在泰拉，没有天生的国王，只有踩着别人骸骨活下来的赢家。", "sound": "sounds/en_vo_601302_changjingbianhua.wav"}},
        hitAreaParam: "HitAreachangjing1",
        hitAreas: ["HitAreachangjing1"],
        sourceType2: 401,
        sourceWeight: 10,
        weight: 10
      }
    ]
  },
  {
    id: "25101501_sz01",
    title: "预埋角色 25101501_sz01 角色候选",
    assetKind: "character",
    categoryLabel: "角色",
    modelDir: "25101501_sz01",
    sourceModelDir: "25101501_sz01",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "streamingassets",
    styleId: "",
    styleName: "预埋角色 25101501_sz01",
    stage: "角色候选",
    hitAreaNames: ["HitAreadianji", "HitAreaHandL", "HitAreaquanbu", "HitAreaBody", "HitAreaHandR"],
    followConfigs: [],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 6.633 }
        ]
      },
      {
        label: "TapBody",
        actions: [
          { group: "TapBody", index: 0, actionId: "dianji", label: "dianji", duration: 9.733 },
          { group: "TapBody", index: 1, actionId: "diantou", label: "diantou", duration: 3.0 },
          { group: "TapBody", index: 2, actionId: "ditou", label: "ditou", duration: 4.0 },
          { group: "TapBody", index: 3, actionId: "houyang", label: "houyang", duration: 4.0 },
          { group: "TapBody", index: 4, actionId: "taidao", label: "taidao", duration: 3.0 },
          { group: "TapBody", index: 5, actionId: "waitou", label: "waitou", duration: 4.0 },
          { group: "TapBody", index: 6, actionId: "yaotou", label: "yaotou", duration: 3.0 }
        ]
      }
    ],
    clickShowActions: [

    ]
  },
  {
    id: "25101502_zc",
    title: "主厨 · 永不复焉 时装",
    assetKind: "skin",
    categoryLabel: "角色",
    modelDir: "25101502_zc",
    sourceModelDir: "25101502_zc",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "localassets_win32",
    styleId: "",
    styleName: "主厨 · 永不复焉",
    stage: "时装",
    hitAreaNames: ["HitAreadianji", "HitAreaBody", "HitAreaquanbu", "HitAreaHead", "HitAreaHandR", "HitAreaHandL"],
    followConfigs: [{"id": 1032, "prefab": "25101502_zc", "activeName": "", "expressionName": "", "damping": 0.0, "parameters": [{"parameterId": "ParamAngleX", "axis": "X", "factor": 23.0, "sourceToken": "ParamAngleX#23*X"}, {"parameterId": "ParamAngleY", "axis": "Y", "factor": 50.0, "sourceToken": "ParamAngleY#50*Y"}, {"parameterId": "ParamAngleZ", "axis": "X", "factor": 4.0, "sourceToken": "ParamAngleZ#4*X"}, {"parameterId": "ParamEyeBallX", "axis": "X", "factor": 23.0, "sourceToken": "ParamEyeBallX#23*X"}, {"parameterId": "ParamEyeBallY", "axis": "Y", "factor": 50.0, "sourceToken": "ParamEyeBallY#50*Y"}, {"parameterId": "ParamBodyAngleZ", "axis": "X", "factor": 3.0, "sourceToken": "ParamBodyAngleZ#3*X"}]}],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 6.633 }
        ]
      },
      {
        label: "TapBody",
        actions: [
          { group: "TapBody", index: 0, actionId: "dianji", label: "dianji", duration: 9.7 },
          { group: "TapBody", index: 1, actionId: "diantou", label: "diantou", duration: 2.967 },
          { group: "TapBody", index: 2, actionId: "ditou", label: "ditou", duration: 3.967 },
          { group: "TapBody", index: 3, actionId: "houyang", label: "houyang", duration: 3.967 },
          { group: "TapBody", index: 4, actionId: "loop", label: "loop", duration: 6.633 },
          { group: "TapBody", index: 5, actionId: "taidao", label: "taidao", duration: 2.967 },
          { group: "TapBody", index: 6, actionId: "waitou", label: "waitou", duration: 3.967 },
          { group: "TapBody", index: 7, actionId: "yaotou", label: "yaotou", duration: 2.967 }
        ]
      }
    ],
    clickShowActions: [
      {
        showId: 601502010,
        audioId: 60150004,
        audioName: "vo_6015_daiji_01",
        desc: "点击-通用1",
        group: "TapBody",
        index: 5,
        actionId: "taidao",
        label: "taidao",
        duration: 2.967,
        voices: {"cn": {"subtitle": "有些仇人不需要我动刀，我只需请他吃顿我亲手做的饭。", "sound": "sounds/vo_6015_daiji_01.wav"}, "en": {"subtitle": "有些仇人不需要我动刀，我只需请他吃顿我亲手做的饭。", "sound": "sounds/en_vo_6015_daiji_01.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 601502011,
        audioId: 60150005,
        audioName: "vo_6015_daiji_02",
        desc: "点击-通用2",
        group: "TapBody",
        index: 2,
        actionId: "ditou",
        label: "ditou",
        duration: 3.967,
        voices: {"cn": {"subtitle": "刚才看你随便吃两口就来办公室了，这是加餐，至少别饿倒在我面前。", "sound": "sounds/vo_6015_daiji_02.wav"}, "en": {"subtitle": "刚才看你随便吃两口就来办公室了，这是加餐，至少别饿倒在我面前。", "sound": "sounds/en_vo_6015_daiji_02.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 601502012,
        audioId: 60150010,
        audioName: "vo_6015_xianliao_01",
        desc: "点击-闲聊1",
        group: "Idle",
        index: 0,
        actionId: "idle",
        label: "默认",
        duration: 6.633,
        voices: {"cn": {"subtitle": "每个米兰王国的人都应该知道怎么做一份完美的披萨——上面绝对没有水果。", "sound": "sounds/vo_6015_xianliao_01.wav"}, "en": {"subtitle": "每个米兰王国的人都应该知道怎么做一份完美的披萨——上面绝对没有水果。", "sound": "sounds/en_vo_6015_xianliao_01.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 601502013,
        audioId: 60150011,
        audioName: "vo_6015_xianliao_02",
        desc: "点击-闲聊2",
        group: "TapBody",
        index: 6,
        actionId: "waitou",
        label: "waitou",
        duration: 3.967,
        voices: {"cn": {"subtitle": "别怪我没有提醒你，挑食会让你的身体营养不均衡，别以为夜行者就可以对自己的身体为所欲为。", "sound": "sounds/vo_6015_xianliao_02.wav"}, "en": {"subtitle": "别怪我没有提醒你，挑食会让你的身体营养不均衡，别以为夜行者就可以对自己的身体为所欲为。", "sound": "sounds/en_vo_6015_xianliao_02.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 601502014,
        audioId: 60150012,
        audioName: "vo_6015_xianliao_03",
        desc: "点击-闲聊3",
        group: "TapBody",
        index: 1,
        actionId: "diantou",
        label: "diantou",
        duration: 2.967,
        voices: {"cn": {"subtitle": "每个家庭餐馆都有自己传承的秘方，那都是带着回忆的、独一无二的味道。", "sound": "sounds/vo_6015_xianliao_03.wav"}, "en": {"subtitle": "每个家庭餐馆都有自己传承的秘方，那都是带着回忆的、独一无二的味道。", "sound": "sounds/en_vo_6015_xianliao_03.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 601502015,
        audioId: 60150014,
        audioName: "vo_6015_zanyang",
        desc: "点击-赞扬1",
        group: "TapBody",
        index: 1,
        actionId: "diantou",
        label: "diantou",
        duration: 2.967,
        voices: {"cn": {"subtitle": "看到你今天也有按时吃饱饭，我就放心了。", "sound": "sounds/vo_6015_zanyang.wav"}, "en": {"subtitle": "看到你今天也有按时吃饱饭，我就放心了。", "sound": "sounds/en_vo_6015_zanyang.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 601502016,
        audioId: 60150101,
        audioName: "vo_6015_shizhuang01_dianchu_tou",
        desc: "点击-头",
        group: "TapBody",
        index: 7,
        actionId: "yaotou",
        label: "yaotou",
        duration: 2.967,
        voices: {"cn": {"subtitle": "即使让我为了融入宴会涂抹金箔，也只会弄得像刀痕或是泪痕。", "sound": "sounds/vo_6015_shizhuang01_dianchu_tou.wav"}, "en": {"subtitle": "即使让我为了融入宴会涂抹金箔，也只会弄得像刀痕或是泪痕。", "sound": "sounds/en_vo_6015_shizhuang01_dianchu_tou.wav"}},
        hitAreaParam: "HitAreaHead",
        hitAreas: ["HitAreaHead"],
        sourceType2: 401,
        sourceWeight: 30,
        weight: 30
      },
      {
        showId: 601502017,
        audioId: 60150102,
        audioName: "vo_6015_shizhuang01_dianchu_shou",
        desc: "点击-手",
        group: "TapBody",
        index: 6,
        actionId: "waitou",
        label: "waitou",
        duration: 3.967,
        voices: {"cn": {"subtitle": "邀请一位厨子跳舞吗……？你确定？", "sound": "sounds/vo_6015_shizhuang01_dianchu_shou.wav"}, "en": {"subtitle": "邀请一位厨子跳舞吗……？你确定？", "sound": "sounds/en_vo_6015_shizhuang01_dianchu_shou.wav"}},
        hitAreaParam: "HitAreaHandL#HitAreaHandR",
        hitAreas: ["HitAreaHandL", "HitAreaHandR"],
        sourceType2: 401,
        sourceWeight: 30,
        weight: 30
      },
      {
        showId: 601502018,
        audioId: 60150103,
        audioName: "vo_6015_shizhuang01_dianchu_shen",
        desc: "点击-胸",
        group: "TapBody",
        index: 5,
        actionId: "taidao",
        label: "taidao",
        duration: 2.967,
        voices: {"cn": {"subtitle": "刀上的血用领巾擦了。那些宾客没人发现，还以为是什么时髦的新样式。", "sound": "sounds/vo_6015_shizhuang01_dianchu_shen.wav"}, "en": {"subtitle": "刀上的血用领巾擦了。那些宾客没人发现，还以为是什么时髦的新样式。", "sound": "sounds/en_vo_6015_shizhuang01_dianchu_shen.wav"}},
        hitAreaParam: "HitAreaBody",
        hitAreas: ["HitAreaBody"],
        sourceType2: 401,
        sourceWeight: 30,
        weight: 30
      },
      {
        showId: 601502081,
        audioId: 60150104,
        audioName: "vo_6015_shizhuang01_teshudongzuo",
        desc: "点击-刀",
        group: "TapBody",
        index: 0,
        actionId: "dianji",
        label: "dianji",
        duration: 9.7,
        voices: {"cn": {"subtitle": "我早已习惯带着仇恨生存，你却让我……打开囚笼，任那只乌鸦飞去。", "sound": "sounds/vo_6015_shizhuang01_teshudongzuo.wav"}, "en": {"subtitle": "我早已习惯带着仇恨生存，你却让我……打开囚笼，任那只乌鸦飞去。", "sound": "sounds/en_vo_6015_shizhuang01_teshudongzuo.wav"}},
        hitAreaParam: "HitAreadianji",
        hitAreas: ["HitAreadianji"],
        sourceType2: 401,
        sourceWeight: 0,
        weight: 100
      }
    ]
  },
  {
    id: "25102403_xs",
    title: "星闪 · 掠夺明日 时装",
    assetKind: "skin",
    categoryLabel: "角色",
    modelDir: "25102403_xs",
    sourceModelDir: "25102403_xs",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "localassets_win32",
    styleId: "",
    styleName: "星闪 · 掠夺明日",
    stage: "时装",
    hitAreaNames: ["HitAreaHead", "HitAreaHandR", "HitAreaquanbu", "HitAreaBody", "HitAreaHandL", "HitAreaChange_ParamDiy", "HitAreadianji1"],
    followConfigs: [{"id": 1044, "prefab": "25102403_xs", "activeName": "", "expressionName": "", "damping": 0.0, "parameters": [{"parameterId": "ParamAngleX", "axis": "X", "factor": 30.0, "sourceToken": "ParamAngleX#30*X"}, {"parameterId": "ParamAngleY", "axis": "Y", "factor": 30.0, "sourceToken": "ParamAngleY#30*Y"}, {"parameterId": "ParamEyeBallX", "axis": "X", "factor": 50.0, "sourceToken": "ParamEyeBallX#50*X"}, {"parameterId": "ParamEyeBallY", "axis": "Y", "factor": 50.0, "sourceToken": "ParamEyeBallY#50*Y"}, {"parameterId": "ParamBodyAngleX", "axis": "X", "factor": 50.0, "sourceToken": "ParamBodyAngleX#50*X"}]}],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 10.0 }
        ]
      },
      {
        label: "TapBody",
        actions: [
          { group: "TapBody", index: 0, actionId: "dianliang", label: "dianliang", duration: 5.0 },
          { group: "TapBody", index: 1, actionId: "diantou", label: "diantou", duration: 3.0 },
          { group: "TapBody", index: 2, actionId: "loop", label: "loop", duration: 10.0 },
          { group: "TapBody", index: 3, actionId: "qianqing", label: "qianqing", duration: 4.367 },
          { group: "TapBody", index: 4, actionId: "sanchaji", label: "sanchaji", duration: 10.0 },
          { group: "TapBody", index: 5, actionId: "shenshou", label: "shenshou", duration: 5.0 },
          { group: "TapBody", index: 6, actionId: "waitou", label: "waitou", duration: 4.367 },
          { group: "TapBody", index: 7, actionId: "xingxing", label: "xingxing", duration: 10.0 },
          { group: "TapBody", index: 8, actionId: "yaotou", label: "yaotou", duration: 4.367 }
        ]
      }
    ],
    clickShowActions: [
      {
        showId: 602403008,
        audioId: 60240010,
        audioName: "vo_6024_xianliao_01",
        desc: "点击-闲聊1",
        group: "TapBody",
        index: 7,
        actionId: "xingxing",
        label: "xingxing",
        duration: 10.0,
        voices: {"cn": {"subtitle": "我的故事？没什么特别，就是海盗，宝藏，风暴，和一艘不肯停泊的船。", "sound": "sounds/vo_6024_xianliao_01.wav"}, "en": {"subtitle": "我的故事？没什么特别，就是海盗，宝藏，风暴，和一艘不肯停泊的船。", "sound": "sounds/en_vo_6024_xianliao_01.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 602403009,
        audioId: 60240011,
        audioName: "vo_6024_xianliao_02",
        desc: "点击-闲聊2",
        group: "TapBody",
        index: 4,
        actionId: "sanchaji",
        label: "sanchaji",
        duration: 10.0,
        voices: {"cn": {"subtitle": "光靠海上寻宝是要喝西北风的，只有扩展更多业务，比如打捞，捕鱼，再时不时请“贵客”上船喝杯酒……日子才过得下去～", "sound": "sounds/vo_6024_xianliao_02.wav"}, "en": {"subtitle": "光靠海上寻宝是要喝西北风的，只有扩展更多业务，比如打捞，捕鱼，再时不时请“贵客”上船喝杯酒……日子才过得下去～", "sound": "sounds/en_vo_6024_xianliao_02.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 602403010,
        audioId: 60240012,
        audioName: "vo_6024_xianliao_03",
        desc: "点击-闲聊3",
        group: "TapBody",
        index: 7,
        actionId: "xingxing",
        label: "xingxing",
        duration: 10.0,
        voices: {"cn": {"subtitle": "海盗是不会有乡愁的，我们在哪儿都能活下去……五湖四海，整个世界，都等着我们去抢夺。", "sound": "sounds/vo_6024_xianliao_03.wav"}, "en": {"subtitle": "海盗是不会有乡愁的，我们在哪儿都能活下去……五湖四海，整个世界，都等着我们去抢夺。", "sound": "sounds/en_vo_6024_xianliao_03.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 602403011,
        audioId: 60240014,
        audioName: "vo_6024_zanyang",
        desc: "点击-赞扬1",
        group: "TapBody",
        index: 4,
        actionId: "sanchaji",
        label: "sanchaji",
        duration: 10.0,
        voices: {"cn": {"subtitle": "你身上那股狠劲比海盗更像海盗，去厮杀、去掠夺，别浪费你的野心和本事。", "sound": "sounds/vo_6024_zanyang.wav"}, "en": {"subtitle": "你身上那股狠劲比海盗更像海盗，去厮杀、去掠夺，别浪费你的野心和本事。", "sound": "sounds/en_vo_6024_zanyang.wav"}},
        hitAreaParam: "",
        hitAreas: [],
        sourceType2: 0,
        sourceWeight: 5,
        weight: 5
      },
      {
        showId: 602403012,
        audioId: 60240301,
        audioName: "vo_602403_dianchu_tou",
        desc: "点击-头",
        group: "TapBody",
        index: 5,
        actionId: "shenshou",
        label: "shenshou",
        duration: 5.0,
        voices: {"cn": {"subtitle": "在这场狂欢里，阴谋和争斗从不是一个好故事，比起那些，我更想掠夺你此刻的目光。", "sound": "sounds/vo_602403_dianchu_tou.wav"}, "en": {"subtitle": "在这场狂欢里，阴谋和争斗从不是一个好故事，比起那些，我更想掠夺你此刻的目光。", "sound": "sounds/en_vo_602403_dianchu_tou.wav"}},
        hitAreaParam: "HitAreaHead",
        hitAreas: ["HitAreaHead"],
        sourceType2: 401,
        sourceWeight: 20,
        weight: 20
      },
      {
        showId: 602403013,
        audioId: 60240302,
        audioName: "vo_602403_dianchu_shou",
        desc: "点击-手",
        group: "TapBody",
        index: 4,
        actionId: "sanchaji",
        label: "sanchaji",
        duration: 10.0,
        voices: {"cn": {"subtitle": "海神的三叉戟，传说中无往不胜的神器，如今也不过是我的战利品之一。", "sound": "sounds/vo_602403_dianchu_shou.wav"}, "en": {"subtitle": "海神的三叉戟，传说中无往不胜的神器，如今也不过是我的战利品之一。", "sound": "sounds/en_vo_602403_dianchu_shou.wav"}},
        hitAreaParam: "HitAreaHandL#HitAreaHandR",
        hitAreas: ["HitAreaHandL", "HitAreaHandR"],
        sourceType2: 401,
        sourceWeight: 20,
        weight: 20
      },
      {
        showId: 602403014,
        audioId: 60240303,
        audioName: "vo_602403_dianchu_shen",
        desc: "点击-胸",
        group: "TapBody",
        index: 8,
        actionId: "yaotou",
        label: "yaotou",
        duration: 4.367,
        voices: {"cn": {"subtitle": "唔……我身上可没有藏宝图。不过，这场狂欢游戏的规则变了，现在你才是被海盗盯上的宝藏。", "sound": "sounds/vo_602403_dianchu_shen.wav"}, "en": {"subtitle": "唔……我身上可没有藏宝图。不过，这场狂欢游戏的规则变了，现在你才是被海盗盯上的宝藏。", "sound": "sounds/en_vo_602403_dianchu_shen.wav"}},
        hitAreaParam: "HitAreaBody",
        hitAreas: ["HitAreaBody"],
        sourceType2: 401,
        sourceWeight: 20,
        weight: 20
      },
      {
        showId: 602403081,
        audioId: 60240304,
        audioName: "vo_602403_teshudongzuo",
        desc: "特殊1",
        group: "TapBody",
        index: 7,
        actionId: "xingxing",
        label: "xingxing",
        duration: 10.0,
        voices: {"cn": {"subtitle": "满帆向前，只要海洋和风依然在，我们的狂欢游戏就不会落幕。", "sound": "sounds/vo_602403_teshudongzuo.wav"}, "en": {"subtitle": "满帆向前，只要海洋和风依然在，我们的狂欢游戏就不会落幕。", "sound": "sounds/en_vo_602403_teshudongzuo.wav"}},
        hitAreaParam: "HitAreadianji1",
        hitAreas: ["HitAreadianji1"],
        sourceType2: 401,
        sourceWeight: 0,
        weight: 100
      }
    ]
  },
  {
    id: "600000_nz",
    title: "主角 角色立绘",
    assetKind: "character",
    categoryLabel: "角色",
    modelDir: "600000_nz",
    sourceModelDir: "600000_nz",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "streamingassets",
    styleId: "",
    styleName: "主角",
    stage: "角色立绘",
    hitAreaNames: ["HitAreaBody"],
    followConfigs: [],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 4.0 }
        ]
      },
      {
        label: "TapBody",
        actions: [
          { group: "TapBody", index: 0, actionId: "diantou", label: "diantou", duration: 3.0 },
          { group: "TapBody", index: 1, actionId: "waitou", label: "waitou", duration: 4.0 },
          { group: "TapBody", index: 2, actionId: "yaotou", label: "yaotou", duration: 3.5 }
        ]
      }
    ],
    clickShowActions: [

    ]
  },
  {
    id: "7000_petdfl",
    title: "预埋角色 7000_petdfl 角色候选",
    assetKind: "character",
    categoryLabel: "角色",
    modelDir: "7000_petdfl",
    sourceModelDir: "7000_petdfl",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "localassets_win32",
    styleId: "",
    styleName: "预埋角色 7000_petdfl",
    stage: "角色候选",
    hitAreaNames: ["HitAreaBody"],
    followConfigs: [],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 6.0 }
        ]
      },
      {
        label: "TapBody",
        actions: [
          { group: "TapBody", index: 0, actionId: "diantou", label: "diantou", duration: 3.333 },
          { group: "TapBody", index: 1, actionId: "houyang", label: "houyang", duration: 3.333 },
          { group: "TapBody", index: 2, actionId: "jiaku", label: "jiaku", duration: 6.167 },
          { group: "TapBody", index: 3, actionId: "qianqing", label: "qianqing", duration: 3.667 },
          { group: "TapBody", index: 4, actionId: "yaotou", label: "yaotou", duration: 3.333 }
        ]
      }
    ],
    clickShowActions: [

    ]
  },
  {
    id: "7001_smedkly",
    title: "预埋角色 7001_smedkly 角色候选",
    assetKind: "character",
    categoryLabel: "角色",
    modelDir: "7001_smedkly",
    sourceModelDir: "7001_smedkly",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "streamingassets",
    styleId: "",
    styleName: "预埋角色 7001_smedkly",
    stage: "角色候选",
    hitAreaNames: ["HitAreaBody"],
    followConfigs: [],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 6.0 }
        ]
      },
      {
        label: "TapBody",
        actions: [
          { group: "TapBody", index: 0, actionId: "chayao", label: "chayao", duration: 6.233 },
          { group: "TapBody", index: 1, actionId: "diantou", label: "diantou", duration: 2.9 },
          { group: "TapBody", index: 2, actionId: "houyang", label: "houyang", duration: 3.3 },
          { group: "TapBody", index: 3, actionId: "yaotou", label: "yaotou", duration: 2.9 }
        ]
      }
    ],
    clickShowActions: [

    ]
  },
  {
    id: "7002_nqhst",
    title: "预埋角色 7002_nqhst 角色候选",
    assetKind: "character",
    categoryLabel: "角色",
    modelDir: "7002_nqhst",
    sourceModelDir: "7002_nqhst",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "streamingassets",
    styleId: "",
    styleName: "预埋角色 7002_nqhst",
    stage: "角色候选",
    hitAreaNames: ["HitAreaBody"],
    followConfigs: [],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 6.0 }
        ]
      }
    ],
    clickShowActions: [

    ]
  },
  {
    id: "7003_nqhst",
    title: "预埋角色 7003_nqhst 角色候选",
    assetKind: "character",
    categoryLabel: "角色",
    modelDir: "7003_nqhst",
    sourceModelDir: "7003_nqhst",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "streamingassets",
    styleId: "",
    styleName: "预埋角色 7003_nqhst",
    stage: "角色候选",
    hitAreaNames: ["HitAreaBody"],
    followConfigs: [],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 6.0 }
        ]
      }
    ],
    clickShowActions: [

    ]
  },
  {
    id: "7005_fsdf",
    title: "预埋角色 7005_fsdf 角色候选",
    assetKind: "character",
    categoryLabel: "角色",
    modelDir: "7005_fsdf",
    sourceModelDir: "7005_fsdf",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "streamingassets",
    styleId: "",
    styleName: "预埋角色 7005_fsdf",
    stage: "角色候选",
    hitAreaNames: ["HitAreaBody"],
    followConfigs: [],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 6.0 }
        ]
      }
    ],
    clickShowActions: [

    ]
  },
  {
    id: "7006_npls",
    title: "预埋角色 7006_npls 角色候选",
    assetKind: "character",
    categoryLabel: "角色",
    modelDir: "7006_npls",
    sourceModelDir: "7006_npls",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "streamingassets",
    styleId: "",
    styleName: "预埋角色 7006_npls",
    stage: "角色候选",
    hitAreaNames: ["HitAreaBody"],
    followConfigs: [],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 6.0 }
        ]
      }
    ],
    clickShowActions: [

    ]
  },
  {
    id: "7013_nksbhjl",
    title: "预埋角色 7013_nksbhjl 角色候选",
    assetKind: "character",
    categoryLabel: "角色",
    modelDir: "7013_nksbhjl",
    sourceModelDir: "7013_nksbhjl",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "streamingassets",
    styleId: "",
    styleName: "预埋角色 7013_nksbhjl",
    stage: "角色候选",
    hitAreaNames: ["HitAreaBody"],
    followConfigs: [],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 5.97 }
        ]
      }
    ],
    clickShowActions: [

    ]
  },
  {
    id: "7016_stlss",
    title: "预埋角色 7016_stlss 角色候选",
    assetKind: "character",
    categoryLabel: "角色",
    modelDir: "7016_stlss",
    sourceModelDir: "7016_stlss",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "streamingassets",
    styleId: "",
    styleName: "预埋角色 7016_stlss",
    stage: "角色候选",
    hitAreaNames: ["HitAreaBody"],
    followConfigs: [],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 6.0 }
        ]
      }
    ],
    clickShowActions: [

    ]
  },
  {
    id: "7023_ynyl",
    title: "预埋角色 7023_ynyl 角色候选",
    assetKind: "character",
    categoryLabel: "角色",
    modelDir: "7023_ynyl",
    sourceModelDir: "7023_ynyl",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "streamingassets",
    styleId: "",
    styleName: "预埋角色 7023_ynyl",
    stage: "角色候选",
    hitAreaNames: ["HitAreaBody"],
    followConfigs: [],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 6.0 }
        ]
      }
    ],
    clickShowActions: [

    ]
  },
  {
    id: "7031_dfp",
    title: "预埋角色 7031_dfp 角色候选",
    assetKind: "character",
    categoryLabel: "角色",
    modelDir: "7031_dfp",
    sourceModelDir: "7031_dfp",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "streamingassets",
    styleId: "",
    styleName: "预埋角色 7031_dfp",
    stage: "角色候选",
    hitAreaNames: ["HitAreaMoren"],
    followConfigs: [],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 5.97 }
        ]
      },
      {
        label: "TapBody",
        actions: [
          { group: "TapBody", index: 0, actionId: "daku", label: "daku", duration: 8.6 },
          { group: "TapBody", index: 1, actionId: "diantou", label: "diantou", duration: 3.0 },
          { group: "TapBody", index: 2, actionId: "shengqi", label: "shengqi", duration: 7.333 },
          { group: "TapBody", index: 3, actionId: "walk", label: "walk", duration: 1.97 },
          { group: "TapBody", index: 4, actionId: "yaotou", label: "yaotou", duration: 3.0 }
        ]
      }
    ],
    clickShowActions: [

    ]
  },
  {
    id: "7032_nzfq",
    title: "预埋角色 7032_nzfq 角色候选",
    assetKind: "character",
    categoryLabel: "角色",
    modelDir: "7032_nzfq",
    sourceModelDir: "7032_nzfq",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "streamingassets",
    styleId: "",
    styleName: "预埋角色 7032_nzfq",
    stage: "角色候选",
    hitAreaNames: ["HitAreaMoren"],
    followConfigs: [],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 5.97 }
        ]
      }
    ],
    clickShowActions: [

    ]
  },
  {
    id: "7033_nzmq",
    title: "预埋角色 7033_nzmq 角色候选",
    assetKind: "character",
    categoryLabel: "角色",
    modelDir: "7033_nzmq",
    sourceModelDir: "7033_nzmq",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "localassets_win32",
    styleId: "",
    styleName: "预埋角色 7033_nzmq",
    stage: "角色候选",
    hitAreaNames: ["HitAreaMoren"],
    followConfigs: [],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 5.967 }
        ]
      },
      {
        label: "TapBody",
        actions: [
          { group: "TapBody", index: 0, actionId: "fuyanjing", label: "fuyanjing", duration: 5.967 }
        ]
      }
    ],
    clickShowActions: [

    ]
  },
  {
    id: "7034_nzdg",
    title: "预埋角色 7034_nzdg 角色候选",
    assetKind: "character",
    categoryLabel: "角色",
    modelDir: "7034_nzdg",
    sourceModelDir: "7034_nzdg",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "streamingassets",
    styleId: "",
    styleName: "预埋角色 7034_nzdg",
    stage: "角色候选",
    hitAreaNames: ["HitAreaMoren"],
    followConfigs: [],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 12.0 }
        ]
      }
    ],
    clickShowActions: [

    ]
  },
  {
    id: "7035_nveg",
    title: "预埋角色 7035_nveg 角色候选",
    assetKind: "character",
    categoryLabel: "角色",
    modelDir: "7035_nveg",
    sourceModelDir: "7035_nveg",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "streamingassets",
    styleId: "",
    styleName: "预埋角色 7035_nveg",
    stage: "角色候选",
    hitAreaNames: ["HitAreaMoren"],
    followConfigs: [],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 18.0 }
        ]
      }
    ],
    clickShowActions: [

    ]
  },
  {
    id: "7037_nzsj",
    title: "预埋角色 7037_nzsj 角色候选",
    assetKind: "character",
    categoryLabel: "角色",
    modelDir: "7037_nzsj",
    sourceModelDir: "7037_nzsj",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "streamingassets",
    styleId: "",
    styleName: "预埋角色 7037_nzsj",
    stage: "角色候选",
    hitAreaNames: ["HitAreaMoren"],
    followConfigs: [],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 11.97 }
        ]
      }
    ],
    clickShowActions: [

    ]
  },
  {
    id: "7038_dklygg",
    title: "预埋角色 7038_dklygg 角色候选",
    assetKind: "character",
    categoryLabel: "角色",
    modelDir: "7038_dklygg",
    sourceModelDir: "7038_dklygg",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "localassets_win32",
    styleId: "",
    styleName: "预埋角色 7038_dklygg",
    stage: "角色候选",
    hitAreaNames: ["HitAreaBody"],
    followConfigs: [],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 6.0 }
        ]
      },
      {
        label: "TapBody",
        actions: [
          { group: "TapBody", index: 0, actionId: "dakai", label: "dakai", duration: 3.0 },
          { group: "TapBody", index: 1, actionId: "dakai_1", label: "dakai_1", duration: 4.1 },
          { group: "TapBody", index: 2, actionId: "diantou", label: "diantou", duration: 2.967 },
          { group: "TapBody", index: 3, actionId: "songjian", label: "songjian", duration: 2.967 },
          { group: "TapBody", index: 4, actionId: "yaotou", label: "yaotou", duration: 3.3 }
        ]
      }
    ],
    clickShowActions: [

    ]
  },
  {
    id: "7039_dklydd",
    title: "预埋角色 7039_dklydd 角色候选",
    assetKind: "character",
    categoryLabel: "角色",
    modelDir: "7039_dklydd",
    sourceModelDir: "7039_dklydd",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "localassets_win32",
    styleId: "",
    styleName: "预埋角色 7039_dklydd",
    stage: "角色候选",
    hitAreaNames: ["HitAreaBody"],
    followConfigs: [],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 6.0 }
        ]
      },
      {
        label: "TapBody",
        actions: [
          { group: "TapBody", index: 0, actionId: "diantou", label: "diantou", duration: 3.0 },
          { group: "TapBody", index: 1, actionId: "houyang", label: "houyang", duration: 3.3 },
          { group: "TapBody", index: 2, actionId: "qianqing", label: "qianqing", duration: 3.3 },
          { group: "TapBody", index: 3, actionId: "waitou", label: "waitou", duration: 3.833 },
          { group: "TapBody", index: 4, actionId: "yaotou", label: "yaotou", duration: 3.0 }
        ]
      }
    ],
    clickShowActions: [

    ]
  },
  {
    id: "7040_nvmq",
    title: "预埋角色 7040_nvmq 角色候选",
    assetKind: "character",
    categoryLabel: "角色",
    modelDir: "7040_nvmq",
    sourceModelDir: "7040_nvmq",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "streamingassets",
    styleId: "",
    styleName: "预埋角色 7040_nvmq",
    stage: "角色候选",
    hitAreaNames: ["HitAreaBody"],
    followConfigs: [],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 6.0 }
        ]
      }
    ],
    clickShowActions: [

    ]
  },
  {
    id: "7041_mhnh",
    title: "预埋角色 7041_mhnh 角色候选",
    assetKind: "character",
    categoryLabel: "角色",
    modelDir: "7041_mhnh",
    sourceModelDir: "7041_mhnh",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "streamingassets",
    styleId: "",
    styleName: "预埋角色 7041_mhnh",
    stage: "角色候选",
    hitAreaNames: ["HitAreaBody"],
    followConfigs: [],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 6.0 }
        ]
      }
    ],
    clickShowActions: [

    ]
  },
  {
    id: "7042_stqjg",
    title: "预埋角色 7042_stqjg 角色候选",
    assetKind: "character",
    categoryLabel: "角色",
    modelDir: "7042_stqjg",
    sourceModelDir: "7042_stqjg",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "streamingassets",
    styleId: "",
    styleName: "预埋角色 7042_stqjg",
    stage: "角色候选",
    hitAreaNames: ["HitAreaBody"],
    followConfigs: [],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 6.0 }
        ]
      }
    ],
    clickShowActions: [

    ]
  },
  {
    id: "7062_qsl",
    title: "预埋角色 7062_qsl 角色候选",
    assetKind: "character",
    categoryLabel: "角色",
    modelDir: "7062_qsl",
    sourceModelDir: "7062_qsl",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "localassets_win32",
    styleId: "",
    styleName: "预埋角色 7062_qsl",
    stage: "角色候选",
    hitAreaNames: ["HitAreaBody"],
    followConfigs: [],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 6.0 }
        ]
      },
      {
        label: "TapBody",
        actions: [
          { group: "TapBody", index: 0, actionId: "daxiao", label: "daxiao", duration: 3.8 },
          { group: "TapBody", index: 1, actionId: "songjian", label: "songjian", duration: 2.067 },
          { group: "TapBody", index: 2, actionId: "toubulashen", label: "toubulashen", duration: 2.733 }
        ]
      }
    ],
    clickShowActions: [

    ]
  },
  {
    id: "7064_xewa",
    title: "预埋角色 7064_xewa 角色候选",
    assetKind: "character",
    categoryLabel: "角色",
    modelDir: "7064_xewa",
    sourceModelDir: "7064_xewa",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "streamingassets",
    styleId: "",
    styleName: "预埋角色 7064_xewa",
    stage: "角色候选",
    hitAreaNames: ["HitAreaBody"],
    followConfigs: [],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 6.0 }
        ]
      }
    ],
    clickShowActions: [

    ]
  },
  {
    id: "7065_mds",
    title: "预埋角色 7065_mds 角色候选",
    assetKind: "character",
    categoryLabel: "角色",
    modelDir: "7065_mds",
    sourceModelDir: "7065_mds",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "localassets_win32",
    styleId: "",
    styleName: "预埋角色 7065_mds",
    stage: "角色候选",
    hitAreaNames: ["HitAreaBody"],
    followConfigs: [],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 6.0 }
        ]
      }
    ],
    clickShowActions: [

    ]
  },
  {
    id: "7066_alk",
    title: "预埋角色 7066_alk 角色候选",
    assetKind: "character",
    categoryLabel: "角色",
    modelDir: "7066_alk",
    sourceModelDir: "7066_alk",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "streamingassets",
    styleId: "",
    styleName: "预埋角色 7066_alk",
    stage: "角色候选",
    hitAreaNames: ["HitAreaBody"],
    followConfigs: [],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 6.0 }
        ]
      }
    ],
    clickShowActions: [

    ]
  },
  {
    id: "7075_wl",
    title: "预埋角色 7075_wl 角色候选",
    assetKind: "character",
    categoryLabel: "角色",
    modelDir: "7075_wl",
    sourceModelDir: "7075_wl",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "localassets_win32",
    styleId: "",
    styleName: "预埋角色 7075_wl",
    stage: "角色候选",
    hitAreaNames: ["HitAreaBody"],
    followConfigs: [],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 6.0 }
        ]
      }
    ],
    clickShowActions: [

    ]
  },
  {
    id: "7076_jjlt",
    title: "预埋角色 7076_jjlt 角色候选",
    assetKind: "character",
    categoryLabel: "角色",
    modelDir: "7076_jjlt",
    sourceModelDir: "7076_jjlt",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "localassets_win32",
    styleId: "",
    styleName: "预埋角色 7076_jjlt",
    stage: "角色候选",
    hitAreaNames: ["HitAreaBody"],
    followConfigs: [],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 6.0 }
        ]
      },
      {
        label: "TapBody",
        actions: [
          { group: "TapBody", index: 0, actionId: "yaotou", label: "yaotou", duration: 3.0 }
        ]
      }
    ],
    clickShowActions: [

    ]
  },
  {
    id: "7082_ttzde",
    title: "预埋角色 7082_ttzde 角色候选",
    assetKind: "character",
    categoryLabel: "角色",
    modelDir: "7082_ttzde",
    sourceModelDir: "7082_ttzde",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "localassets_win32",
    styleId: "",
    styleName: "预埋角色 7082_ttzde",
    stage: "角色候选",
    hitAreaNames: ["HitAreaBody"],
    followConfigs: [],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 6.0 }
        ]
      },
      {
        label: "TapBody",
        actions: [
          { group: "TapBody", index: 0, actionId: "diantou", label: "diantou", duration: 3.333 },
          { group: "TapBody", index: 1, actionId: "houyang", label: "houyang", duration: 3.333 },
          { group: "TapBody", index: 2, actionId: "loop", label: "loop", duration: 6.0 },
          { group: "TapBody", index: 3, actionId: "qianqing", label: "qianqing", duration: 3.667 },
          { group: "TapBody", index: 4, actionId: "yaotou", label: "yaotou", duration: 3.333 }
        ]
      }
    ],
    clickShowActions: [

    ]
  },
  {
    id: "7083_joker2",
    title: "预埋角色 7083_joker2 角色候选",
    assetKind: "character",
    categoryLabel: "角色",
    modelDir: "7083_joker2",
    sourceModelDir: "7083_joker2",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "localassets_win32",
    styleId: "",
    styleName: "预埋角色 7083_joker2",
    stage: "角色候选",
    hitAreaNames: ["HitAreaBody"],
    followConfigs: [],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 3.967 }
        ]
      }
    ],
    clickShowActions: [

    ]
  },
  {
    id: "7084_joker1",
    title: "预埋角色 7084_joker1 角色候选",
    assetKind: "character",
    categoryLabel: "角色",
    modelDir: "7084_joker1",
    sourceModelDir: "7084_joker1",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "localassets_win32",
    styleId: "",
    styleName: "预埋角色 7084_joker1",
    stage: "角色候选",
    hitAreaNames: ["HitAreaBody"],
    followConfigs: [],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 5.967 }
        ]
      }
    ],
    clickShowActions: [

    ]
  },
  {
    id: "7086_njs",
    title: "预埋角色 7086_njs 角色候选",
    assetKind: "character",
    categoryLabel: "角色",
    modelDir: "7086_njs",
    sourceModelDir: "7086_njs",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "localassets_win32",
    styleId: "",
    styleName: "预埋角色 7086_njs",
    stage: "角色候选",
    hitAreaNames: ["HitAreaBody"],
    followConfigs: [],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 6.0 }
        ]
      }
    ],
    clickShowActions: [

    ]
  },
  {
    id: "7102_dlb",
    title: "预埋角色 7102_dlb 角色候选",
    assetKind: "character",
    categoryLabel: "角色",
    modelDir: "7102_dlb",
    sourceModelDir: "7102_dlb",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "localassets_win32",
    styleId: "",
    styleName: "预埋角色 7102_dlb",
    stage: "角色候选",
    hitAreaNames: ["HitAreaBody"],
    followConfigs: [],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 6.133 }
        ]
      },
      {
        label: "TapBody",
        actions: [
          { group: "TapBody", index: 0, actionId: "songjian", label: "songjian", duration: 2.983 }
        ]
      }
    ],
    clickShowActions: [

    ]
  },
  {
    id: "7103_fz",
    title: "预埋角色 7103_fz 角色候选",
    assetKind: "character",
    categoryLabel: "角色",
    modelDir: "7103_fz",
    sourceModelDir: "7103_fz",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "localassets_win32",
    styleId: "",
    styleName: "预埋角色 7103_fz",
    stage: "角色候选",
    hitAreaNames: ["HitAreaBody"],
    followConfigs: [],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 6.0 }
        ]
      },
      {
        label: "TapBody",
        actions: [
          { group: "TapBody", index: 0, actionId: "diantou", label: "diantou", duration: 3.5 },
          { group: "TapBody", index: 1, actionId: "huangdao", label: "huangdao", duration: 4.0 },
          { group: "TapBody", index: 2, actionId: "qianqing", label: "qianqing", duration: 3.667 },
          { group: "TapBody", index: 3, actionId: "songjian", label: "songjian", duration: 4.0 },
          { group: "TapBody", index: 4, actionId: "waitou", label: "waitou", duration: 3.5 },
          { group: "TapBody", index: 5, actionId: "xibizi", label: "xibizi", duration: 2.067 },
          { group: "TapBody", index: 6, actionId: "xu", label: "xu", duration: 4.0 },
          { group: "TapBody", index: 7, actionId: "yaotou", label: "yaotou", duration: 3.5 }
        ]
      }
    ],
    clickShowActions: [

    ]
  },
  {
    id: "7104_tj",
    title: "预埋角色 7104_tj 角色候选",
    assetKind: "character",
    categoryLabel: "角色",
    modelDir: "7104_tj",
    sourceModelDir: "7104_tj",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "localassets_win32",
    styleId: "",
    styleName: "预埋角色 7104_tj",
    stage: "角色候选",
    hitAreaNames: ["HitAreaBody"],
    followConfigs: [],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 5.967 }
        ]
      }
    ],
    clickShowActions: [

    ]
  },
  {
    id: "7105_lkdkly",
    title: "预埋角色 7105_lkdkly 角色候选",
    assetKind: "character",
    categoryLabel: "角色",
    modelDir: "7105_lkdkly",
    sourceModelDir: "7105_lkdkly",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "localassets_win32",
    styleId: "",
    styleName: "预埋角色 7105_lkdkly",
    stage: "角色候选",
    hitAreaNames: ["HitAreaBody"],
    followConfigs: [],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 6.0 }
        ]
      }
    ],
    clickShowActions: [

    ]
  },
  {
    id: "7106_adl",
    title: "预埋角色 7106_adl 角色候选",
    assetKind: "character",
    categoryLabel: "角色",
    modelDir: "7106_adl",
    sourceModelDir: "7106_adl",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "localassets_win32",
    styleId: "",
    styleName: "预埋角色 7106_adl",
    stage: "角色候选",
    hitAreaNames: ["HitAreaBody"],
    followConfigs: [],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 6.0 }
        ]
      }
    ],
    clickShowActions: [

    ]
  },
  {
    id: "7112_bpr",
    title: "预埋角色 7112_bpr 角色候选",
    assetKind: "character",
    categoryLabel: "角色",
    modelDir: "7112_bpr",
    sourceModelDir: "7112_bpr",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "localassets_win32",
    styleId: "",
    styleName: "预埋角色 7112_bpr",
    stage: "角色候选",
    hitAreaNames: ["HitAreaBody"],
    followConfigs: [],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 6.0 }
        ]
      }
    ],
    clickShowActions: [

    ]
  },
  {
    id: "7113_llshz",
    title: "预埋角色 7113_llshz 角色候选",
    assetKind: "character",
    categoryLabel: "角色",
    modelDir: "7113_llshz",
    sourceModelDir: "7113_llshz",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "localassets_win32",
    styleId: "",
    styleName: "预埋角色 7113_llshz",
    stage: "角色候选",
    hitAreaNames: ["HitAreaBody"],
    followConfigs: [],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 6.133 }
        ]
      },
      {
        label: "TapBody",
        actions: [
          { group: "TapBody", index: 0, actionId: "diantou", label: "diantou", duration: 3.0 },
          { group: "TapBody", index: 1, actionId: "waitou", label: "waitou", duration: 3.7 },
          { group: "TapBody", index: 2, actionId: "yaotou", label: "yaotou", duration: 3.0 }
        ]
      }
    ],
    clickShowActions: [

    ]
  },
  {
    id: "7116_cfja",
    title: "预埋角色 7116_cfja 角色候选",
    assetKind: "character",
    categoryLabel: "角色",
    modelDir: "7116_cfja",
    sourceModelDir: "7116_cfja",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "localassets_win32",
    styleId: "",
    styleName: "预埋角色 7116_cfja",
    stage: "角色候选",
    hitAreaNames: ["HitAreaBody"],
    followConfigs: [],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 6.0 }
        ]
      },
      {
        label: "TapBody",
        actions: [
          { group: "TapBody", index: 0, actionId: "diantou", label: "diantou", duration: 4.5 },
          { group: "TapBody", index: 1, actionId: "yaotou", label: "yaotou", duration: 4.5 }
        ]
      }
    ],
    clickShowActions: [

    ]
  },
  {
    id: "7117_al",
    title: "预埋角色 7117_al 角色候选",
    assetKind: "character",
    categoryLabel: "角色",
    modelDir: "7117_al",
    sourceModelDir: "7117_al",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "localassets_win32",
    styleId: "",
    styleName: "预埋角色 7117_al",
    stage: "角色候选",
    hitAreaNames: ["HitAreaBody"],
    followConfigs: [],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 5.0 }
        ]
      },
      {
        label: "TapBody",
        actions: [
          { group: "TapBody", index: 0, actionId: "diantou", label: "diantou", duration: 3.5 },
          { group: "TapBody", index: 1, actionId: "yaotou", label: "yaotou", duration: 3.57 }
        ]
      }
    ],
    clickShowActions: [

    ]
  },
  {
    id: "7135_bpr",
    title: "预埋角色 7135_bpr 角色候选",
    assetKind: "character",
    categoryLabel: "角色",
    modelDir: "7135_bpr",
    sourceModelDir: "7135_bpr",
    variantKey: "current",
    variantLabel: "当前版",
    variantSourceLayer: "localassets_win32",
    styleId: "",
    styleName: "预埋角色 7135_bpr",
    stage: "角色候选",
    hitAreaNames: ["HitAreaMoren"],
    followConfigs: [],
    hideGroups: [],
    ambientMotion: undefined,
    storySegments: [],
    storyTouchActions: [],
    unlockableMotions: [

    ],
    motionGroups: [
      {
        label: "动作预览",
        actions: [
          { group: "Idle", index: 0, actionId: "idle", label: "默认", duration: 5.967 }
        ]
      }
    ],
    clickShowActions: [

    ]
  }
];
